{
  "source": "https://raw.githubusercontent.com/nvkelso/natural-earth-vector/ca96624a56bd078437bca8184e78163e5039ad19/geojson/ne_10m_admin_0_boundary_lines_land.geojson",
  "sha256": "74d9c16229c095fde65943a9919e337682f044bcebccb120764f38edf3b70f4a",
  "scale": "10m",
  "features": [
    {
      "left": "BOL",
      "right": "CHL",
      "kind": "International boundary (verify)",
      "lines": [
        "dgziBvdggLziNqWtaFew@x`EkdCplLgyN~mFc|E~`Hg|Cp~Eeh@zjM{C`cFiw@txCq_BrAklA",
        "brslBxvveLbmC_}Bve@gk@bO}j@za@qrCbnBg|Dri@cdBt^mhB",
        "|`vlBte|eL{w@ulA}Te`B",
        "zd_mBjpudLjaBc|@rDoBjlGxm@`nDndFbuDlwDjbH_xAlaE{}D`eBm_AhpCiTf`ASzu@yEzgGa{Apv@yIjsIdO`eBkXdoJw`Fp_Cul@bmCdB`jHdi@jaIjFbqHew@|zFasCvoAuh@rsAyMhrAzK~rA`m@nCXdDYnCmAhyT{yIp_A_SrhC`ArrBjq@ppF`yDv{@u`BrqAwkAheE}rBxgIsqCnwA}dArt@wtAz_BigH`dCwfEhiNokQdtCmmCjiJszE|hBmkDboA{}E|jM}zSrrBy_Cr{BylBdwBem@hh@|s@fjBrzFtqApuAxuD|gCR?tlKzuGjbN|qI~qBdmB~yErcG||BvoAhqBzLdmA}j@f{EkkH|eEucE|iAekBfkAe_E~h@u{@rsAon@zj@cEvwDcE|tAw[ld@eXve@mGxxA`RhbH|}BbyBlFluErs@|~@`]h~@dw@bFfv@",
        "ls`mBfa_eL{D_bCae@eaBsAujA",
        "lilyBj{taLkRdaAgMxxA",
        "xgkyBjwyaLbQb_Ep|Er}V|hBpiBbwBoRhqBg}Dri@ykEt}@uQ|qDh^dsFlF~nEkfAr_LavFduB|`JtgBxkC`cD|eAx~DsUd~D{zAdjDmbCtfCgiClbBshCv_Hy}RprD}dHh~@abDvmCyuDjqBdCb}IpkLz~B`|A~pCbo@jhXeDtbGihB`uAgrC~lAkdC~G{wA",
        "lxx~B`|x`L|_@sgCj{AoaBhk~@ywg@xrGguAfpn@j\\vvEap@buS{cKbbN{`Cbb_@_fAjyAeYhiAcy@z~B{tCzrGgnHlnAi|BlcCylBnuC}iArfCuTzw@tTrgBbnAvy@rSdbAgUxjFknDxtCew@nxBmFbeKxkBt{B}@||Bih@nzKsnFtdCsu@tuHgt@v}Iq}DbyB}Ada\\xjEnaN\\n`DmZ~{AebAfl@}nF",
        "`dy~B|baaLsJ{eG",
        "zbwjCxku{Kw\\krL_i@geFglKix|@",
        "r}kjCns_}K`dE_gCzj@co@t}@{gErt@ue]",
        "dbljCdr`}KqCu]"
      ]
    },
    {
      "left": "CHL",
      "right": "PER",
      "kind": "International boundary (verify)",
      "lines": [
        "dgziBvdggL?HtiVl`XjzDz{Gdl@byGkf@hcHpL~fGxiEreEbiGho@hyEufA`xEqiBdgG{v@f}CcKhhBs`@~bFqiCnvBor@|sBoNzuB~RhuX`yJhcE~fCzuBdpBllE|tFlqIbhHhtA`lBhs@ziCpAlvDxn@dtC~mFhzL|j@tzC|_@vbIu}@z{S~Tz`IjpAd}C"
      ]
    },
    {
      "left": "CHL",
      "right": "ARG",
      "kind": "International boundary (verify)",
      "lines": ["jbnpCpptyKqvRwoEu_AkTcoh@}uLaoh@}uLmnh@suL}lIwmBcbE{a@qza@pcb@"]
    },
    {
      "left": "CYP",
      "right": "ESB",
      "kind": "International boundary (verify)",
      "lines": [
        "i}otE_gdmE{WpW_I`p@",
        "e`qtEk}amE?b\\~HdMjRwe@`IqWdWuH",
        "ihntE{_emE?aR{CkRyCu\\?uHa\\~RgM`\\",
        "i}otEs|emE?pW?`\\",
        "q`otEcxcmEzCa\\pQ_D",
        "q`otEa{bmE?a\\"
      ]
    },
    {
      "left": "ESB",
      "right": "CYP",
      "kind": "International boundary (verify)",
      "lines": ["a|utEm`~lE`D}c@~}@?`Ip`@fHjW", "udstEmk}lEmGhRwOzDg]gHuUuEgHg]"]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "Disputed (please verify)",
      "lines": [
        "iuswEekzyM|hCs|AlcCguBd`BwmCpa@waD",
        "qmswEur~zMzN}kJdqFafAjuIxlBn{HjoD|iNfu@tqMg{EpbZghQ~bFox@xxMqv@luEyvAjlG}zFdlBqv@t~c@iaKxtEwmCf|DmtFdaByrGfhEkok@h|BydJrwIcyOt~Ia~HfpBoiFpdAibHbsAwaFpoCotDpx@_c@l_EiwBpmCox@dpCkRdpCvQbmCby@~oJ~fMrzEf~QdpGvyMnqOdw@vyVmrHnnK}hBfrKsi@nid@lnA|lJcyBjnE}pCviMa|PvG{I",
        "ecgwEqpjzM_}@wwDw_GiyGsjAanD"
      ]
    },
    {
      "left": "PSX",
      "right": "ISR",
      "kind": "Disputed (please verify)",
      "lines": ["q~n}Dec`pEsnAicBokEu`IciE}yE}iBcQwuEtr@iiB}@gzEkeCacQuaU}u@i}A?g@y_DojEazBqlDsrBj_FazChrF"]
    },
    {
      "left": "PSX",
      "right": "ISR",
      "kind": "Disputed (please verify)",
      "lines": [
        "octdE_o`xEsmBbxNm_@rqCaCftCyg@baDs|Cfa@o`EsA}qCpv@u`B`yDqQ~xDhOjhKga@tpBu{BhqDid@nrAyCxIxDvnBjw@dvAzyC~{CrfBv`ErjAhzDpcBvcDjtDvyBncIziAniBpWp_Cfl@zMfV~XhrAnM|VhnAxXtcE|TzpAjRxScmAzm@ij@z`A}IlnA|TjlAzl@d}DzqFp}A|RdpA{ZtqCwxAnaD{|@`vE~O`mL{nCl{@j`AnjByKn}AdEdgAtdA??"
      ]
    },
    {
      "left": "LBN",
      "right": "ISR",
      "kind": "Indefinite (please verify)",
      "lines": [
        "ilcjEip`xEbd@ec@ztC_pBbp@mnA",
        "kdwhEgjvvEelAu_JakBajHqL{~Dc~A_^anDgsB}gBst@g~Cs`@csHyM{hCmo@ctA{w@mtAyc@gz@_i@}E_hA",
        "k`|iEsugxEXg@~Xec@",
        "e`|iE}tgxEEU",
        "ma`iE}ijvElKg_@|Lec@ln@wdAn~@_}@biAij@v~@cy@zHuqA",
        "ia~hEmv`vEc_AgfF?gkA",
        "oy~hE{k{uEfAod@dRowAvAqk@",
        "{u|hE}bwuEuHcZal@cdA{Kug@",
        "ku}hEwnguEn^esN"
      ]
    },
    {
      "left": "SDS",
      "right": "ETH",
      "kind": "Disputed (please verify)",
      "lines": [
        "ots_@yqqvEau@~qBogB~{A}bIllEux@nWkkAaFibAqk@c`Aiu@ueAmd@oiAbZ",
        "sqw_@qwgxEeh@xvCexEjlGkrAbmC{[vnB_PlaC",
        "guc`@arnwE?xbCbUjoBpzAphCfuGp}F`aBxkCvUbvC",
        "yee[exfzEih[~rYubG`xC}nHhs@wyg@mYqoAu^ylH_nFi|B_r@w_Cf@_uCpv@wkF~zBmxBjRopC}h@itFghDuv@~]ccCjuIw{FxyKsi@f}C",
        "c`{_@oosxEbZrrBzr@vnBn^psC"
      ]
    },
    {
      "left": "SOM",
      "right": "ETH",
      "kind": "Indefinite (please verify)",
      "lines": [
        "qyxo@y|ycH|cHrnH|cHzoH|cH|nHrcHfnHfdH|nHrcHfnH|cHrnH|cHfoHrcHpnHbw@`y@dlFptF|cHpnH|cHrnH|cHrnHfdHpnH|cHfoHrcHfoH|cHrnHrcHpnHfdHfoH|cHrnHfdH|mHrcHrnH|cHpnHfdHfoHncH|nH`dHfnH|cHrnH~cHpnHpyBf~BxlGjwGtlG~vGzyBf~Bf~BxbCtbG~kGneKb|JxeKn{JreKv|JreKv|JteKv|JreKb|JxeKl|JreKb{Jj{Un}Sh{Un}S~{Un}SblS|tQfnApgAj{Un}Sr{Ud}St{Uz}Sj{Un}StcKfbJ?r@vtOlmNpjAzsD",
        "e|{\\u~bqGuRxqIwQ|bI}QrbIuQhcImQrbIwQfcIY`NwPpsHuQfcIsQ|bI{QhbIqQfcIaRrbIwQhcIkQrbIaRfcIqQrbIwQfcI}T|vJ",
        "gqf]cujkGvu@jdFx_En_P|i@hzDxlC|gR~kBvyMb`Dd{TrkEdoLjkIb}TlqIxhUfoIpdU~lLzjOp_K|sMd|@bp@~aAhh@fqE~rA~sLbnBfhEh}AxlE|vDvGzFxwCdhFlgBrdGvjAl{Ld_Dxj\\lbD~|\\z{Bv~UxCnvMnDt{Odr@xiEjkBvvErxGj`JnmGdxLz`B`nBpxBri@p~DcD~lA|_@`dAztA`zB~rA"
      ]
    },
    { "left": "SDS", "right": "KEN", "kind": "Disputed (please verify)", "lines": ["ahq[gjcyElP_sFblJkP?A"] },
    {
      "left": "TZA",
      "right": "MWI",
      "kind": "Disputed (please verify)",
      "lines": [
        "bazx@sbrnEbmA_xEl}B}`EjDgGvdAmz@xn@quAn}F{rEbZcn@zsB{jB`qA{sDrzR{~QdbAuyDtqAkf@vnBoNduB_^vp@ec@bmC{iCnNm[zjBapBxXaFx{V_oRp_CafAzeG_{DxtE}gAxbAmGvfA|K`yBpv@~|@zKdtEwn@dlMknE`kImz@fgCis@plAqLnaA|@biTr}B~eCyZheEcwBhsBoYjz@pLdkCby@boA|Kl`@eCfp@cEpuAa\\~pAkh@`fAkq@pW}s@",
        "f`iz@cl~mEomBweBsi@?a{@k{A}~@sr@kpA_UkqBoCq{D}j@elBsJavGfsB}{C_|AywBgrC}tAgkAwxAmdB",
        "duq_AwfhrE|DsSjE_U|gAmPdwBdDxc@yO|{CkeC~|Bkz@fgCeDxbCtqAnx@mf@vZ}Ipb@oY`\\ug@pk@od@voAcOdw@fkA|s@`e@lbD{VxeKvoAbtG?p_ApLd~F~qB~gArx@r|Cn{Bp|C~]|~BcZl_GirA`xCcQxlBcn@p{FyhHj|@}_@|u@kRjf@u\\xZapBda@wp@no@we@dw@oNvmC_SlxBqv@tzAkpApv@{aBve@?tSzc@jh@pt@jRnd@n}FgiCxn@ag@",
        "lxq_AmpfrEgBiu@",
        "~`ddAakjsEnE_r@vxA_mGdmAevC~fB{sBp_Cen@bn@oYr~A{sBdhDst@|`Ayy@tp@wy@zl@oYnd@eMdw@w\\rhA_^`zAeMrbI?hu@kI",
        "dzfdAwcesEqCih@mcAmnAeOqm@"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "Disputed (please verify)",
      "lines": [
        "_q}oDqpvjQksGo`MdeG_xPnqA`g@xcAyD|j@wp@`GazAzvAylBftB_r@dpGg`A|bCwoAh|IwiIp{HmbBxjH}`@fjC`}QtlGkGtuOnfQjnNndMnoJhwEdiGufLckBy}LyaDcqI{l@ejBorBcrHfPekG|p@a~Tn~Najb@~oBm`Fle@}eEih@udEu{Be}EepBg{Grt@{fFhaI{bLlU{`A_@mz@tTmo@jyC}~@zu@qv@jrFqzItpB_nF",
        "i~~hDcdgnP|PubIn|G{uHyTo{QhlGcyD|vEkt@}J}pGfk@}nGceCmaBooCsaC~n@{yMgwC_aGoeDy|BogI_cUnOa{@fyA{w@dcF}hBfsBqsAhj@i}AolB_sAyuDiiAjIea@daBi_@jpA}~@aGwnBakByn@kdCga@ysAshAvLkgAnzCwoAro@}~@gLufAupCm`Fpk@_lGcs@ebJk~BaoB{hDgoGg}A_fHitFkhDiaFc_DytF~yEumA?q`ApjAqV~yEw`@r~AqyAhIqrEylBeiDqsCujCyuDydF{cKgVyw@~]gVxn@qNlZi]nDi}AwFczAuY_|Ass@{_B{qAi}Ai~DcvCwuAexA{v@upBigAsnFsjAazAuzBw}LctCmhOczAofNeqI__AmhFreE_~CmjEcpFmzFcxCkmDobFebB{aHqxAy_CcnF{iHkvPck@qrSdi@eyI_@_rBgp@wnBo}@keCiI{|Fw\\}hB|cBkqJiwCk{NfiCmsK}eHcoEumFc_C_rEegAgjG~Eis@mxBwdAg_BauB{gI_{Aq|IiiEcnFmQg}M}rGq`GieHo|Iw{EbnFcnFbnFqwHogB|JuaFmU}iAaz@{`AccDmdBscAs_AibAgrCiTcaD}@ygIsZipCoc@kfBs~@quA__MypIwtA{jBqPq}DfoAulF|gCo~ErqIgeIdgBkeArsFve@`q@i}Ar@{iCeN_gBaFspFjz@ogFvg@cbRhqAgmJ|gD_`Inb@wnBleAkqMbOar@`\\_r@ho@_^|u@wFnq@gMfb@st@xh@}`J`dBswOu}@aeKkkC_hJogKisC}d@i~@ypCwFgbFdbAgiAiTaRuxEyn@sJm~@lGwu@mRah@oaAiI_t@i@{u@{LqaAjdCwrI|}@mwLayIw{Dk`LdO__@udE{l@ayBrsD}bLe{EiuPm^oxJo^oxJbDmdL|xAew@d}Hi}AlgB}~@lwDcuDjaBuyDgBojEwxBwaFguAovBk\\quAda@aoAhiBaeBjpA{BvpE`xCx{D`|Art@`dA`bDtwSfv@veBdqAh~@h|Anv@zzPgGn{MaxBmY}kIwuHuoH"
      ]
    },
    {
      "left": "SYR",
      "right": "ISR",
      "kind": "Line of control (please verify)",
      "lines": [
        "_w{jE{hsyEl`@kGpe@da@`eBtHja@jRjrAzMb~@teB`k@no@~s@|gC|gC_nFtwFfpEvo@}j@veB_nDbcHeXhhA{kCjsD_SfyBncAn{AlcAz{A?tqAyhFzqAjR`rQuqA~lA{a@|kEsqChlCxvAtHpk@~zCfjBdyD~gAxlA{Vd_Dvn@nwHtwH~pEheD"
      ]
    },
    {
      "left": "SOL",
      "right": "SOM",
      "kind": "Disputed (please verify)",
      "lines": [
        "qyxo@y|ycHgwPsuJ}wPuuJcwPsuJcwP_wJyvPsuJgwPivJ}wP}vJivPsuJ{wPuuJiwP}uJsvP_wJ}wPiuJsvP_vJ}vPsvJiwPstJgwP_vJuwT?sD?o}T?s}T?{|T?}|T?o}T?i}T?_}T?y}T?i}T?m}T?u|T?s}T?e}T?i}T?m}T?"
      ]
    },
    {
      "left": "SUR",
      "right": "FRA",
      "kind": "Disputed (please verify)",
      "lines": [
        "iyaRzb{iIy{Ho`CokC{uAwtGkcFg{Fy_DqtCipEqAqB",
        "ctgMvo}kI}KkyBqu@meA_iLggDec@_~@oc@{aAs@{hCqLi}Aa]}iAajHajHmvCcdBqgRyrFw|LizEgfRafM}~Ayo@uaHyaBur@_i@ug@}iAobAjqAii@`f@_i@tIq`AeCufAsUg}BguAyc@aRg~Del@{tAzAkIh`@elAvcAyvAr`@_i@agAwe@wZewArIouCle@yOpL_i@ny@cDfLga@qL_Tc[qMm[oNeNacCoMolCzMayAbcA",
        "qobRzqviIfU~oC",
        "atiMtadlI|~@}pE",
        "ejeMp`jlIayBmcByNmyA"
      ]
    },
    {
      "left": "GUY",
      "right": "SUR",
      "kind": "Disputed (please verify)",
      "lines": [
        "}ybRrpo|IiIr}@uq@ldAah@sJup@kg@sjAmPkoCdbAwcAfMqkAeDq_Cs`@giAaGsiAhUkr@`f@_s@zLcmAur@cf@_H_xEqMuvAjRm~HjzC",
        "eavSp`x|ItyCrdEl[~eD",
        "ajpSdmc}Ikr@~eDmtAhdE",
        "{rtSnyn}IfpBwEvu@pj@nl@toD~SnNni@fk@lYxm@",
        "mckSpyx}IwZtTi_@nMqQbd@aHbp@gAjq@cZzb@in@vnAyNloA",
        "swpSljd~IvyB`|@tGlx@",
        "etlS|`h~IeRdcAckB`aEWh@",
        "ismQvtd|IqXiScn@lEcnAt\\co@xE{iCly@ebBzjB_qBzw@cvDi~AiJhTgBfCmDf@wQrJ",
        "eyeRtqj|I`f@hi@dc@ru@~R~|@",
        "{wmQhlg|IpCqvA",
        "mqePj|}{IyY|iAmy@vZyy@`SoY`q@q_AnXibI~qA_}@cy@olAq`B{vAccAu{A~\\}TtnE{l@vnAmpA_r@mx@}_@cp@zBqu@`QqjA~I_U_S",
        "uf|Opqv{I{tBhh@c`F{jB_h@rj@",
        "ufhPrzu{IpL|hAly@j|BfLly@",
        "_}aO`ee{Iyc@vp@cuFld@uqB`}@oiDl`DupAr_@a}@oWcnA_j@ybAeMk\\j{@",
        "eu}O`go{Ih_@xtEdMtS",
        "kfhNdtzzIcy@jg@sqE}_@ol@hJyvD||Cow@j]giBdCwpAw\\shAwOwnAhi@",
        "ifdOfca{IhhAx`C",
        "afzJjrvwIqgAnSq{@be@ek@zu@ei@bbCs^ts@yi@jk@it@za@uyBrjFaItcRgeAdjD_sYtxQiyDpl@igCnn@orGn|@mxBhnAw\\tv@yYdoCa\\~x@{v@xYa`FkBqjCvdAabEt~EkpBrn@yxAgg@{_AcJw{@d]}~AnfB{u@p\\}tAdSu{@{KcdAu]ecAmGyx@~r@",
        "mblNl|szIt|Ar~Bj]bwA"
      ]
    },
    {
      "left": "PRK",
      "right": "KOR",
      "kind": "Line of control (please verify)",
      "lines": [
        "gnwhFmnalWoYuhLcwB}kLyiEenK}pGukImaDuoCmlDywBy_EkpAw|EcZytE~s@_lBnLwoAkf@whBoiDunCm`J",
        "ol|hFy{vjWlZkr@vyAwnA`|@{kAfP}tA",
        "mtvhFsz_iWqLi{DovAenJ_rAutd@",
        "wa{hF}imhWhlCuoQ",
        "wlyhFigugW_t@saW",
        "k}yhFk`ogWrO}eE",
        "yf{eFsvbdWoxOjj@{sC}_@mj@gjAaIsrBmo@e`Ds{CuwF{bS{tOovAclBirC}oFy|AafBivF{}BsdD_tAilAclAuc@qc@e}EuuIgcEemKodC}aLga@arK",
        "ilxhFy~lkW`]snS",
        "_hvhFwa`kWicAa|K"
      ]
    },
    {
      "left": "SAH",
      "right": "MAR",
      "kind": "Line of control (please verify)",
      "lines": [
        "esygDlayt@@@zKxGx~Gqa@teOcvDpvL}~@zqGjzAtzIrtAphIuc@bgJikCjsJg_CdyF?f|Dl_GxfBxkQhtA``U?xbO",
        "__jdDpbmv@a|@bfW",
        "a|kdDtiew@fKdaN?ddL`|@hvJ~lF`oMlsJxbOlsN|eSdvHpbKdbArbO?rbO",
        "ud}bDh`q}@iyF|eSgsJdfWa|DxbMa|@tbSayB|eS",
        "mg|cDz|s`A~{@zbM?tbQdyFdfWbvD|eSf|D|bUtiDxdXtpPkbEdpHwtGpyJ?b|HlbCjvHpbKvkKnyLdvHb_GlpLnbGhyFh_EzwKtkIp_OzfHn|HtzAfmJzuBxlB~cFp`BjrWf_ChsN`yBnsLvvE|aD??pa@dYpvLh|B~uH?hyF~{BpmRdyDrvPbyF|mVf|DjmRfyDfh^byFpd\\hyF|mZhvHnpPhyFdvHb|DpyJnsLdsFhvJh|HhsLdvHrsNjsJnmTn|HvsPvmCrdF??lgDrmGfpLnsLzsRnvJfsNbyF~jXnsLlvLdvH~rFb|DhyFrsNf|DnpPbyFppRnyFnsN|xFrmThyFjsLlsJpyHjvL~xFtsRhvHljThyFpvL~{Bn|m@lvJtgZd|BtpP~{BppTjyDbe`@|{BxgZ?lsNh|BjyJ~~@lpLhvHdvHhyFlvLdsLhyFlvJhyF~{B~uHnvJrsNhvJjvHhvHfyFa|@lvLa_AlvLf|DpsN~xDlmRrsNhvHnpP`|@vmX?bbb@",
        "oa{bD~ml{@iyFpvNa_CrbI",
        "{{fcDdif|@bKntE~oD`~I`yB~}K?pbK",
        "eo|aCpoj}AayBxg\\g_CzjZ_|@~d`@",
        "offbCfjd`B?zmV`yBtg\\?lekAdbA~g\\hyFd_j@b|@llK",
        "crzaCt}m{Aa|@vjZ",
        "eo|aClii|A?be`@"
      ]
    },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": [
        "mkbbAttzaOp\\iz@~m@oMb~@f@jlA{Kdl@mZ`fBerA|j@mPz{@aaA|lBkaHlk@kaAd|@{v@`{@evBrxA_kBztCgVvk@tuAlPzXfo@vZfb@sJrYoXrTeM~kBshCni@}_@"
      ]
    },
    {
      "left": "COD",
      "right": "COG",
      "kind": "International boundary (verify)",
      "lines": [
        "mafT}}tpBxkD_r@tnWcp@hh[leAnjCby@hiApLtfBhh@rsAdaBjnBh{EpvAd`CtoBjpA|gRtmEjyCdaBr~@|VfhCdXr_AvZx`D`pBx|HnuChrAtSfhD|ThhL~{ClgX~|Mhs@tQhT~~@fnIneJ`eB~pAxcBbp@nnJbdA`zBjf@ztBfu@tpBxdAjxEdvAh}A|~@~^piB|~@dXprDpuC~gAnm@|pSdqFt{A?z|Dyc@p~DoN~tQv\\z~Gqb@dbBh@zjB~RtmEh~@vjB|Kp~v@en@laCfMjhXnpJfyBza@zcF`\\j{T|yEddKrUtzBpk@jrL`bGvxCnjC`kFbwBvnCjh@`qLkgAlnN|@n{W_yDdjDRnaNt|AjoD{BlwCce@jkHovB~q@wzAldB{`AvwBkf@fjB}Kp}Qtg@bcBza@fnVxwOr|h@pjNd_FhqBrkc@n}F~{CxOf}CcOroRcxCxra@{u@~|@bn@jzBfvAvsJdnKzj@fa@no@lYtzAhKzXtHpUrSrt@thAj{A`oAf_BnaCvfLz~Ipr^|fYnuCvaD`zCz~Bjf@xn@jpA|fDh_@lPjpCvyB`e@r_Aj{AxeIpk@zzH|_@lxBdjDh`LrsA~kH|_@|eEdObe@dl@z`AnNbe@be@lPdjDhrCvvEdsFjbFtbEvjFhbHhtAvmCtg@tg@dl@l[lmDxbAjaGvoCpeFf_BtqChfBbnMpgFtkG`mE`aH`oCxaCpsAz}DlzBteBxl@jfBt^`fAjGnsE{BvwDxc@f}CjpA~kSbnNbSdNziAr`@htA~R`Qve@hrAdlBtg@z_BdOv\\~q@xw@vyBr~Ar`K~hKrfEzgG|lIx{IbwB~oD|iC~yCpfEbxCxbCdkAxkCfl@toCwFlo@aH`g@R~wGlpAjdBzKf_BiTpuAox@h_@yMvy@sJtlH{Bp{m@_oEvx[vbCj}L|rCdvAvOxxAbFliJmj@v_F}YtuHzVj~Iq`@zpIxX~fBoYptBcy@jnCi@roGbe@vbC}_@hgAshAlq@_hAdbAq`@|pCrJrrBh]r{DlpAptObsH|lIn_C~nGpjClxMzcKdaOx|FxkCpm@nwAlwAdhHhhBbrIlaElo@|j@h~@dc@nnJtpBhoCtuCb]l^r}BfqFtqAlsGri@jwGtg@nqGx}Gle[~q@`nBrhAr~AptBxmA~eRn_Efu@p`@hpCfiC~h@pWhTfu@voA~yCnwAzqFb}IvvTlnA`yBrhAdjDnwAlwCjzBz`A~rAr`@~iInhFjrMvhI||BhgCrgDhlIlcA~q@lpA`g@byMnaNfvYf_OteBxn@~{A|~@voAdaBr}B|dHjaG`}Kr_A`wDfV~mF",
        "bjy\\ks{vA{|DnYwdNycBs_A|Vew@r^mz@dXshAzByy@oNylByn@kz@}Ik{CdXmbBbdAevA~{AguB|}AkmFtr@{iCbn@ap@cDmyAar@yxAyaBeaBmkFekA}iAq`BwdA}sBsgBs{B{vA}sB_S_i@tg@{iCjwEwmCbyB_zC`eBmyA|h@s`@|@q`@iTyxAcZaoA}IqaAUwp@nNa\\dc@",
        "zjbYc~xvAlGrrB|pCjlGncAd{GnwAf~BjlEzhFnmBniFnlArnFnaAtdP`|AdhF`wFbwD`Q~IpLpLtfAlbBr}BhhBve@f`ApA~|@",
        "zglZyeusAyMnx@c{@lcAacDzvAekAnx@czAdkC{Kz~B",
        "td_ZmjdsAdiCrkKlf@hgAtfApWhzQebAxwBrUp{Fd`B|gC~TvkGurAfu@jh@",
        "nrmZcr`tAks@buD{@nE",
        "f|kZouzsArJtnD",
        "hdy\\awvpAqoG`dCuxEfl@qjAp`@ox@vy@kq@j{AufCpyJgiAtpBe~FzdHqiBteD_}@t{@wkEplAyaDvnBu|Ajq@{}CrfC",
        "x||Zg_`oAbOlwCfiCveBpqEqL",
        "rzs[s|srAeDxm@{Mtr@",
        "pfs[czprAnY`r@ncAxX|qBmP|j@|_@xDzu@",
        "fj{[{flrAag@xmC{Bt{@",
        "h~y[k{erArsAnaChzFrfCtUbgA~P`x@",
        "|ve\\apyqAga@rjA{~BjzBqb@lnA",
        "fq_\\sypqAjItfAduBxiEfu@i~@rt@eXbn@bQzc@jeAjkFt`IhpEnkD|s@z`A",
        "dns\\_kuwAeXxZ{bA~q@{B~qB",
        "fmp\\eiowAh_@`yBlf@hiAfgCp_Cxe@dkAtQnvBjRdlB",
        "tv|\\qhixA{XxdAeuB`bEoYbmAwOl[aqA`r@a\\t\\qCtr@",
        "tgs\\upywAnEtdC"
      ]
    },
    {
      "left": "BTN",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "i~~hDcdgnPmxC{u@y{BuhAcyBoWunC~{AscAjdBot@xbC{`@phCa\\b`Ga{A|xFy@tcFmKlyA{Qf}@m`@fmB}~ExbNo`D|eEyyElxB|rBz~BtGhrCiTp~CxYbaDzpAptBbnGzeGdwBnwARh@H?`oC|fDpv@z|F{WjlGw~ApqE_nA`zAalFb~HafAfmJsTzcK_o@zoEyg@jpDq}CvkGkSteBxSteBtvAduDzM`xCv\\fiCur@rvK}@blB|KpkB"
      ]
    },
    {
      "left": "BLR",
      "right": "UKR",
      "kind": "International boundary (verify)",
      "lines": [
        "cgb}Hylb_ExaCgea@",
        "{ur|Hclr}Dgf@sqCsgBueB_|Bg_BqdB_}B_|BqjNy@q|P",
        "id~|Hasd`EgVcjU",
        "qxz|H_ox|DjQsoFlt@mwCdvCq|Gtb@ouC",
        "uxi|H_cu{DqFwaDcpAqv@crA`{@oNxuDk^_T{\\{Ls]cQk^_^shBxc@{`Ao`B_^uzCy]ewY",
        "{fk|Hour{DdI{a@~b@si@",
        "_iw{H{rzzDyOgu@ge@qv@ygAssAoi@?_Yr`@we@xOmUgBii@_pDaa@cxAgf@olAem@cdA}t@}~@eS}@c_@zBme@uJse@ap@{W_r@iI{c@",
        "}la|HsruxCtoDe}_@vKmde@zGoqY",
        "sgt{Hmn{uC{nDuzu@}uD_qPox@qzG_D}yG",
        "eh}{Hoxg|Cn{Cqsh@",
        "sf{{Hwhw{Cq`AwnO",
        "ctx{He__~C~Xq{Dx~EwrKzq@izDbe@wkl@lV}iApk@i@xw@vQv{@gMzaAykAz[{vAhY{~i@fdIm|c@ri@y{K",
        "ukx{Hamq}CmGcqL",
        "ssw{HyxtzDrIayD",
        "yuayHob{yDym@?yOz`AyZr_Acn@hs@cjAt]yq@{b@km@bZuh@r_Aub@dkAa\\st@k\\_^sdAmn@i^rfBmd@~nEcz@jgAwe@?{Mi_@qK_TuIcYqGcp@we@?kSrt@a`AlxBim@?{eBqrDyTynAw{@rVaW`QcOq`@cn@ar@eYsi@guAld@}bC}gAmsAnb@{MemA{Bw`E{RwdAkz@{a@klAaHehAaRem@mdAsm@?qBjq@}e@t{Bgu@{kA_x@qjCgfAanB_`BxDsz@zl@{V|@qQcZal@ag@omBigCsTmP{Qga@kh@u\\ch@ag@ii@q_Cet@wOmy@{Bqf@}VsIkq@",
        "ydv{HqmkuCrx@a~JpBy`C",
        "_ryyHe`cqCoX_yFujO_e\\smHscUgyCkoDwvKqsCmxBg_B}pEkbFevAsfCu]mcCwjAcso@",
        "kg}zH}s|cDfLggPjb@c`Gn{@ifDv`Bkf@ddCxO~eDpAvyBwp@|t@azA~Gi|B",
        "y}xzHc~hcDqhCytR",
        "{~gzHqzheDf[wwDjkBvQjeCj{AvhBnb@fp@}rA",
        "srgzHwbdeDgKyvC",
        "yggzHwwdkDdDg~Bv`Aa{Ar}@qVbt@fBjw@eEveAss@xm@siApeA{rDht@olAp`Aug@nkDebAzp@qb@dSkpA",
        "eztyHsqijDsZywBwsAouCmqF{iE{sBayBsjAudCii@ekC",
        "k{ezH}_yoClAsqCnqAexL`Hi{Cd}@mvF`dCanDbgBspD",
        "}clyHokcoCmPgu@w~Am[m{@zMokHzhD}p@dc@aq@mEeqAsjAsh@}~@uY{kAyaBy~Q",
        "cfczH_lopDre@izFvy@ouC`lAylAzaFmbCddEuoEpeB_hApbDoW~`Dvy@zeA_i@ho@_gBr|A{~BxwBmeAlgC}s@voBolAzq@mnC",
        "{hvxHyajnDsnAkoBe{Ak]emFpLihBmPikDwyBkdCanD{`BegEoaAieEuWyuDmAs`Kwe@ccD}oAovBsdE{rC}jAu{BsZwyB{B{~B",
        "}vazH}sufDjB_zEDW~hDecTxEk~Iza@{aBnaCcmAf|C`p@ryHjnErOyKp`@}Xby@_sA|p@wdBzVywA",
        "ai{yHmhdfDcEy_C_i@ihCevBwlDqe@srB",
        "yb`zHwg_iDpl@udCl_G{xJ|e@}sBpQ_rBb@kaR",
        "eobyHc}chD_HcbBcf@g`A{uFicH}f@s_@crAw[icAnDkbAxNmnAfBc}Bkf@chBmpAccA{sBaNmnC",
        "_p|yHsuxeD|e@yqJ",
        "{tzyHstleDeHigC}p@uwF",
        "ctwyHic{lDliAuoP~g@o`DbtA{u@f~BoNr|IeaBnvAag@jaAw{@j^ifB",
        "eonyH_o_lDiYwnAaaBy`DwbCkvHqa@y`DgAqhD",
        "w~lyH_raoCxYox@",
        "cghyH_c`tDbK_hCxm@{jBvoBifBb~A}u@lcAymArz@cvP",
        "sbsxH_gvrD_@i{BgdBczAmwCuzAyhAa}@cZqsAsJyaDid@uoC{dAu|AgqAowA}gAe`Cy_@kzBaM_oC",
        "upfyH}k_wDx]grDfpAknDpgEyhFny@ewAp_BqzH~m@coAri@md@nh@wPjp@yEx_ATfp@|IlaChs@hElPjaAom@jyCe~Dnn@irAlVs~A",
        "}gayHqhquDwAemA_|BezJiYknCuMsiZ",
        "}ubyHedluDtBg_Ahi@ccB",
        "g|{xHa|`uDmQkoBmj@i~@ywBihB_b@cnA",
        "u_byHeoxyDzHirA",
        "yzuwHqwkyDeIcdAub@}W}DcCatCcGsKaPazBwnBqzAyOuuA{}DoqBcmDooDzc@_TaqAs_@lE_d@|j@q`@t^{nDh|@ih@xZoc@zjAmAf`A_Nbo@ciAfW_nAsKak@cn@qMmeA",
        "kp~xHuvbnD~CaoAhlAsk@lsBqk@v_A{`A",
        "mu|xHej}mDqXyxAk`@uqA",
        "{huxHavmrDfeA}oG",
        "yioxHup}qDi[{_Coj@inAoyAcdDw[aoC",
        "yjaxHocsxDjMczAju@uzA|bCejCfR{`B",
        "_jaxHoimxDY_yD",
        "ouzwHs~byD`M}rA|_@mnApo@ceAbz@mn@",
        "{nzwHkg`yDsEgvA"
      ]
    },
    {
      "left": "ZAF",
      "right": "NAM",
      "kind": "International boundary (verify)",
      "lines": [
        "`cjkDkeghBs`@fgEipClcCscHh]mlCwOykCi@qkBzw@gj@|{Ccp@lxBupB`qA{~BtfA_|AdvA{XleAi@h~@",
        "p~`jDoffgBdZjzBf_@jeArhCroE",
        "rcgjDctyfBce@teD",
        "n}ejDmmtfBlPhgArsAdxAxX|iA",
        "j}ijD_amfBiIr}@ybAt}@sJ`p@",
        "rcgjDsrgfBbZbe@zjBpiBxO~T`oNnm@t}@zl@",
        "zr|jDelzeBaQnYuHdX",
        "bw{jDoxxeBbZbe@nd@fK|_@wOr{BylBfl@sA~Rr~A",
        "dj}jDqo_fBgBbZsUf_@",
        "hp|jDet}eBpA~fB",
        "pvdkDugxeBS`dC",
        "|udkDsbteBfVfa@xy@dXzj@wQh~@cn@hiAec@xmAfKjf@xy@",
        "vifnDylmiB}_@dhF}zDrJubGemAmtFkf@shCncA}iArcFghBlo@cmCdc@abEfhDapB`r@yxAqWirAkpAu}@qkB{VghBi~@obBgrCis@yjD{MwdC|KkeAh_@qtBlbB__Ahj@ykAnW__AnE}~@`Q{kAzw@a{@zVmnA`HcdAdXu\\jeA",
        "~ggkDosxhBvFn`DhrArkK",
        "tspkDefseBkRh~@ug@~|@sUfu@",
        "~`nkDsrmeBlo@bnBvnBbZ|~BeXf_Bqk@prDcdChqB{j@`r@naAfu@vzAt{Bh_@vmCvFfhBlPriBlcA`dCloBh}Ar{B",
        "tfnlDit}xBfj@laExDp_A",
        "vwolDiquxBgVdiE",
        "n`olDcgoxBvFvdA`qAvcDb_FtvGnm@xuDvQrlH|j@bmCpuAjzBtp@zjB~h@frRnNzu@nd@f`Afj@`g@jq@xc@v{@pv@~q@p`@~qB~s@|Tjf@hT`{@hu@be@ftNfsDlyAf`AbmAnkBtr@z~B~qB`zNza@lyA",
        "fs|lD{u`eBuH~fBey@zXmnA`QafAvZi]pv@",
        "pztlDsnydB|Tr_Aj~KnxMxbA~mFxmAlkDdaBlbDbn@lqB",
        "zqrnDalxjBar@phE}s@~eCs}Bl[wxCeDkcCp`@yy@h}A",
        "hr`nDkdijBtS|hB`p@zuBxZf~BbZ`bGvy@lsG",
        "dxknDyc`uBiIpaAgjBdtC",
        "rbhnDalytBlElyAv{@nnAtqA~eAzsDpkBlaCrUhgCkh@raJehFpjAfB`g@rhAzMllEfV`e@nbBncAxl@~q@`eD|bJpjAjaGrJ|oF",
        "x}koDuw~mB}@fsBcaDdlOylBrnFavGxzJyuBfrE_sAvaFckEdr_@",
        "|}mnDsaikBnNphExZxbAziA~zBfXb{@nC`oA",
        "`cwoDk{msBcyB|hByX`\\uSbdAoW~yEsL|j@cbAz`A_zEr|CquA~fBifDlxg@",
        "hx_oDkglqB`zCfmd@xlBvaFld@jeC",
        "rfioD_p{oBgKj[u}@fkAeMvZ",
        "nmfoDskwoBxD|a@~]fu@tHfa@lP`yBvQlcAvZno@fl@lxB",
        "dikoDwghoBgV`xC}tAzeGaHpjC",
        "|rgoDg|vnBleAtdPlcAz}E"
      ]
    },
    {
      "left": "ISR",
      "right": "LBN",
      "kind": "Indefinite (please verify)",
      "lines": ["_w{jE{hsyE`_Bf_BbpEt{Bh~A`eBpf@fiAb_@puA~SbxAvEtqA"]
    },
    { "left": "SYR", "right": "LBN", "kind": "International boundary (verify)", "lines": ["gp`kEa{|yEbmA`{CbjAbuC"] },
    {
      "left": "SYR",
      "right": "LBN",
      "kind": "Indefinite (please verify)",
      "lines": [
        "e|urEyqr|Ejq@_|A|{EgrCh|A_}B~h@{rC",
        "yqirEup}{EmPgxJgV_}@ar@ox@ox@gVkyBqAyn@uS}iA{`C",
        "_snrEozrzErK}u@vPyl@hhAelBr_@sfCfBymC",
        "qpnrE{jpzEmAsnA",
        "sukrEiay{EhJs^nl@shA~Ice@",
        "iajrEcut{EcFcZmd@}iAwFce@",
        "yzjrEehg{EfHuzCfOgpG",
        "mgjrE{bb{EkRidD",
        "opjrEcfl}E~cEnW`\\pk@",
        "qeirE}sb}EqAazCkg@cvC",
        "mncrEaaj}Eqk@paA}Tj{A",
        "}perEcbe}Eln@j{A|iA|K`{AwFdaBj[lnAbyBpkAdjD`{ArgB~_Bi}@rZyPjCwOb@mP",
        "{hqqEa{b}EhJejD~W}tA\\?ngB_g@voAa}@by@}rAbe@}hB~{AmyAvWgl@",
        "c~oqEqhx|Ec@mPkCyOi]mxB}EyuD",
        "sadqEsuy}Efz@obBvu@ga@fdAdDpeB|Tbj@xOp\\rUl_@~Rjr@dD`q@yOlo@_^h|C_fCd{@qaAdOqk@",
        "ktcqEygx}EgLyl@",
        "a~kpEkse~EbGwg@po@g_@fpAzK|cAb{@voAbn@ptBu\\|xAwg@j{BcvC|{@k`@fEmBn`DhoDthEtoCxeEvvGj_C`yBhwAdc@nhAfKxx@fa@li@`eBpB|tA",
        "c{kpEqed~E}Ayl@",
        "ksxnEcem}Euh@heCcDtfA",
        "ebznEcwf}Etv@xbCxzE~nEntDtwFvcBdaBvnBztAv`FvdCrU_Jvz@ag@be@kf@nvBcwDza@mtFjv@{jBj_CgKtqApjAdObwB",
        "mulmEgix|E{m@xjFqbC~_ImPpkB",
        "iyrmE{oc|Ez\\|}A`z@dvApq@vcBpAnaC",
        "gknmEorv{EsYjq@orAnnA_Shh@",
        "kmrmEigq{ErqBb_F|e@pkBjXfsBta@bcBtbA~|@ddC~rAlrCtmEfjB|tAffA`e@tvAjqBtv@nm@hs@`HjpBcQ`{@xOfWt\\xXlpAhTdXpdCzVbj@uqArTgiChcA}pCtSexA|n@}qB|_AugBpeA{u@|rB~Rx}Af_B`fAp_Ctl@zuB",
        "ertkEskrzEs@rqC",
        "ystkE_ymzEzf@frCzqA`fA|}BssAlfEnbB`hCv`Ejx@~qB"
      ]
    },
    { "left": "SXM", "right": "MAF", "kind": "International boundary (verify)", "lines": ["ucamBxbs_K_|C~iLoU|bC"] },
    {
      "left": "OMN",
      "right": "ARE",
      "kind": "International boundary (verify)",
      "lines": [
        "{`{xCqpfvIkg@ueBmwBwwD{v@efA}m@opCiqAumD{jDs\\sl@lwFybDvsBcUzzD",
        "gnryC}kkvI|rBvgDndBwKv}@aSrr@qd@t`A~{@tjAdfDxyCbM~{@mHza@alAnXyaB"
      ]
    },
    {
      "left": "MOZ",
      "right": "MWI",
      "kind": "International boundary (verify)",
      "lines": [
        "nyfhAkewrEvFkeCbp@mlCnaAobB~|B_r@f}CjR~yCbdAhsBdaBrhAlaCfVnlC",
        "ha_iAaevrE_i@r{Bq_CboAcbC|@sqCug@inGsrBew@uqA"
      ]
    },
    { "left": "MOZ", "right": "MWI", "kind": "International boundary (verify)", "lines": ["fqbhAgi}qE{ByD"] },
    {
      "left": "UZB",
      "right": "KGZ",
      "kind": "International boundary (verify)",
      "lines": ["ybprFga{tLqM{_BelAk|@enKolC}_AnY", "unasForcuLnd@tzClbC~bF`h@zjBlE~{C~{AjdBbyAk|@riAieCfk@ywBld@e_D"]
    },
    {
      "left": "KAZ",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "atzjH_|urOrj@o|GxvAqpFtqCu`W",
        "qjsjHqkzqOohFmoZ",
        "sdvjH{diqOdlAcqJzKqsD",
        "w{|fHk~onO{bEyrUc~@qsBemA_~@muE_rBybB}iAqpAe`BgaEkjHcpL{vMiiA{m@{tATyhG`fA_iAjGcy@ij@k{A}rB_dE_zCcxBnaBg}B|eEgrEzsCmxCjg@ejBpLeaBwZq~BgtAqkBccBolAkfBgiC{qFkdB{jBg|EqhCufAadCkHcmD",
        "_x}fHma}mOf[}{Q",
        "}tofHekamOqvButIciEmvFurAwbCul@kdD",
        "u{qfHo`}kOveAuic@",
        "}xd~Go}yhOmjAqk@msBoManB}u@kvAmoAitAov@q~Agb@qtBwPogBu{@a`Ae`C}_@{uCuTo|G}t@elAk{Au\\o_C{WkmEgaA{aB?sqB|u@giBtQaqBsi@ayBi]e_Cft@{kNhuL{xDz`B_@?u~Dt[qbLyaBinEfAizx@hsNiwCeNghCccA{cD_rBmjFwzAerTuxC{ni@yyXmbEsrDilBuaFghColj@",
        "cre_HihezNfLqiDvd@{tC|aEiaIxs@i|BdvAe_Q`pActFveNkl`@beQkkiA",
        "mlttGsqnuN_xFx_FodCib@{oDwm@{eIkcEyiRaaFkyPsuMmiH}oDiqDaqAizPggDI?s_ZoaDiuK_dD{mJmvFoyMs~KkcEk|AmrI}iAekB_h@ypJmvFmum@}zP{_h@_s[mdBkf@mhBuHukBh^ayBvPwyBa\\cjFs~AubAcDmxBri@w~@vFmdAkRadCybAihAwQizFhIweAup@uu@}}CaWkyCmFyjD",
        "_ae~Gy}lhO`Gu~K",
        "gkb~Ge{sgOwtAsaX",
        "sjc~GmshgOj^wfJ",
        "iov|GquedOsS{jDsbCugMkfAcyMm`Ay`CuyDclCmdAkeBob@mzAql@_xGyb@koAilC{sDkxEgmLe|AudCg|DyuCg`A}sAap@q`CyP}}B",
        "yuz}GodiaOpk@m~V",
        "svs}Gezb`OwQcwC{~CenKS}@IqBUgA}i@gzS",
        "_qy}GyodbObFmbBpnBepI`a@}yG",
        "giy}G}cabO]oCyEkfB",
        "g_x}G_qmcOdNehH`tAy}EnkC{iE`yDs{B`}EpKzdBxcAhbBnwAh}Apv@vuAoYxg@_{B",
        "gxt}Gk_{bO_fBspQ",
        "otu}G}au_Oz|@gwL",
        "gru}Gmwb_OgAoiQ",
        "ctjrG{pkvNwp@qnKikIe{Gi_MmvDmvPowBcvFyN{eFlZmyBvdBq|Dv`Sq_Bzj\\sjA~xEI^",
        "mlttGqrnuN?\\",
        "{_xsGufmqNtq@avFhJwvEp|Dy`Dx_GwdBluEyc@~oCcFhsAg_@fj@gtAxn@khLzl@{`BdaBovBrsA_yF",
        "aslrGesilNqCmcDawEozVqBy}GeaAy|FyiEi}N}hPsulAm_GovNgtAoiG",
        "yiasGcp~tNpUasHtpCgfHveLcvOteCimH",
        "_hprGg{dsNow@qyHglLujd@a{@smI",
        "ufprGssykNrrBq~N",
        "uxgrGczpjNciG{h^{BsnH",
        "iyhrGiicjNr_@yoL",
        "_o|qGqhoiNcOi{CybAaeB{|E}sBsjAq}B{K{iC",
        "_b}qGyv`iN~QwpM",
        "wcyqGywrhNg}B_~L",
        "kxzqGmydhNrs@k}L",
        "sckpGcuogNuRvhHe{Ij`WyuCd_D}{D_~AycAs{B}hBuaHs_KojRK?o_DalFuqAicGeMmsG",
        "ydafGc{vkNmQ}gCqv@s{Bm}AmyA{dC}a@mtB~_@ceEjnCutB|_@sxBdDcxBrSslBzl@wtAlpA_yAvuF_m@liFk`Bp`BckLa`IqaEmbBkmEeOqak@hbVoak@hbVgqFtaFuoCtgBwbCf`AU?q}B|@uqBxMgiBve@kfBvfA{sCljEguAvzA}qBve@{hFqk@qaM{hDctFf@yv[ryF{}EpNc_Gqm@ywMseDkfCg_BufA{VcmAtg@{jB~oBox@`\\mdAkG_rB{~B_gAuxE{bAiuKkq@yaBuqAga@kpAf_@om@xcBuwGfq^otDj_Iih@trBgLhdD",
        "apppGisrhNlkDd}a@",
        "etgfGmx`kN`HubGdnDc|HbV{`C",
        "qlidG{zeiNeHgjBsxAmiHogAqtBoaCywMa[{zH_~@}gC{~Byc@ymBhgA{u@bbCg]d}GqwCrjLa_CzrEw}CzsBgmDkpAi}B{eG}jDybPemGufN{{AciG",
        "}~jdGsv{hNxDihBpk@}yE",
        "oco`GqaqhNa_BgqFogA_fAgeCwp@{`MduBmzAdvAgyAt}@obBri@ypNxkCehA`H{yBkgA}nAec@qjAvHulBd`AgqDvcDw_B`fAusFpv@k`Bjq@_bBp`@ggCgVq`Bgu@q`G_cFmwDweBiuJgiCs|Cy`Cum@_gB"
      ]
    },
    {
      "left": "TJK",
      "right": "UZB",
      "kind": "International boundary (verify)",
      "lines": ["{czxFuzdnL{iBhI{uCvoA{iBpuAcbB~oCgw@dkD", "{kjyF{kumLvRvcBx_C_hAdDmEvoA_gB~yDyuDpkAihB|T_{B"]
    },
    {
      "left": "LTU",
      "right": "BLR",
      "kind": "International boundary (verify)",
      "lines": [
        "kgqpIs`_aDgB|hBwnAvsJwe@daBg`Aj[isBu{@}|CgtCaz@gj@{gFuqAcdAst@{~Bq|EugA_SyaCptBouCyZ_qBayBmcBaxCelBoxB}hCa{@ucDoNsfD|VgsCby@",
        "}iloIiefaDeMqhCczAg_BotDwdAmlDag@oaAel@emA{aBwdBqrDs_@g_Bcd@qqFqWo_Dq`AouCwcBcdAihBdx@}}@jnC_gB`l_@",
        "oaspI{yjaDby@fxJ",
        "osqoIwqq`DphDqrS",
        "uenoIweg`DS}s@iJk|@qWwe@yc@yc@u]_t@yDcxA",
        "amqoIgqq_DjfBosT",
        "y~inIamq}CoxA_vVsiAm`Fwz@u|Ae{AkgBw_BmlBk_H}dFit@w\\gjAsJazCxD_fAwO_qDkcEm[sxG",
        "m`knIccc}C|@iqBj]kbFh@gsB",
        "uamjI_~_{Cu]rfCwoAhtAg|CmG_fCqtBeiEy}GufCwnBmwBgVeaCpCwbDcZq}BocAgjAs~AccCk}JkfAovBg`BevAi{Bi_@ywBnb@{|E`zCuzB~h@ymAcF_}@cZox@}_@eaAqWs_AuHc~HhTsrAkR{v@qaAweAggCaQk|@Ssi@_Ku^ss@wZur@zBu{Brt@{v@~GqtBg`AqiA_{B}_AipCywAoaC}~@ag@qw@_Jym@qUoc@shAyx@ejF",
        "cwhjIma_|CqBdX}U|VanBnaAa|@vQkr@dc@a\\ftA",
        "enqjIsaw{CpMt|AhrBruJrIhnG",
        "egljI_pkzC~ImnAzVih@db@a]t_JqwLrV~s@",
        "swajIk~iyCwOq`Oyx@yvCwwEsyFgk@s|C",
        "sfniIw_`|CoEiiAs~@aoCeaBwp@y|GyDw[kRcy@shAyZ{Mae@dOgLj]mFda@uSdXcdAjh@ew@`p@{l@pv@af@`{@{Bl[",
        "_eijIcia|CzLtfA",
        "}jdjIwq}xChrAskK",
        "czjiIqbwwCcZkwGufBqoGggDy~FoaCkfBgeH{~B_qAmnA_JwnB",
        "yh~iIkj|zCcF~pC",
        "}o~iIkxwzC|i@z~B`}@zMln@ouCrt@{a@nm@dl@dc@hqD|j@nm@vnBen@vnAamCvo@sgD|t@qhP",
        "acoiIgv~vCdWo~GvoBykN",
        "mvjhIk{{uCaf@_tKeb@mmBgiBmnAUUSSIS{iDiK{uBpv@{iB~rA_fCfiAi~A`\\}S}IiAmf@ih@qv@ij@{sB{VgBuh@vFmn@Smf@gXc`AyvDaJg^aRk`H",
        "kyniIiux{CvQmiF",
        "a}jiImdm{CqA}gCsUg`AapA{aBaQybA",
        "gwphIanquCpBgVvGqUvxBwoA|t@k{AxCkqB",
        "ww{gIuhxsCybAaaFezJkkU{jBgzHem@enKybAgtCsAgV",
        "izihIcsorCjg@_dEr|BanDprD{jBb{@oaAzLywB",
        "_hdhIezjqC}AooKk]uwDazBiaK}TmlE",
        "qtghIyy~pC|Vq`B`eAawDpMweB",
        "qbbhIumkpC{Cmo@maDk|MuIi}A",
        "q_fhIe`jnCf`@wvEzgEipPrUgjB",
        "oxchIa}dpCbDgj@bf@moBtH}s@",
        "y~}gIoteoC{C{_BcmAcsH}_@yeKen@okBqUg_B",
        "g||gIsaksCdb@geEh@y_F",
        "wv|gIkndsCoDgrE"
      ]
    },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": ["jlxwDrr_~IeMh{CapBtcEyeIbxBqsAtbB"]
    },
    {
      "left": "CHN",
      "right": "MNG",
      "kind": "International boundary (verify)",
      "lines": [
        "mbboHw{dgUp|z@~gh@|rC|}Avx{@f_h@vx{@f_h@bnBnYvwEyvA`oBsAzhE`{Bxhm@tnk@hfBlx@daC`\\~{B?b{e@amCrdEby@~pBbuDhsM`xl@nlBziCrz@}@|eXwbEttJccBrqCquApjCcvCnob@_kp@jfCiaK",
        "uerhHmmpwOg_CxzK{v@z_C{kA|}Aew@fVo`CjIcz@vZsi@rt@w[dbAce@phCqjAhhBokBpLirBmp@}}A_rAq~ColNgiCsdFm`FfA_gAr~Aa]nvB_s@lbBsgCdd@wcC__@owAst@a{Ayc@uoCjRg{DxxA_iA~I",
        "skggH{_hxOc@~gAkmA|pE{mC`bEyvCdw@miBckEyn@owAwcA_r@ubA{a@im@ii@_|BkwGox@ev@g~CvZmbCd_D}fDhkJ__@`oC",
        "}srhHweywOfMhwG",
        "uf~fHyifyOcEnlBgb@nmBajBljE{z@xjDonAveBoXby@}@z`A",
        "}ahgHyslxOhU|rC",
        "u{jfHyjxzOmAlnCazA~nEgzGt_I{|AfiDcvCvoLiJbnB",
        "wt~fHq`myO`MvuE",
        "yl_eHqob|Og\\vyBmgCjvFmxAr_BymBnl@wxB`\\evBnn@{zBnNugFywAmmB`p@wtHdeKon@frC",
        "}clfHqa`{OrK~{BrZvxB",
        "eprdHs{d}O_DxaDgzA|zDi}Gl|Kuh@hqD",
        "mx_eHcmg|OrJp|C",
        "es|cHuun~OyhSrbUew@z_Ba^dkD",
        "gtsdH_ep}O`c@jhJ",
        "gfbdH}{x`PgHldB}|A~xF{Bh|A",
        "iqedHe_k`P~f@~{BhfDrnHzlAziBtoAvxCjS||C",
        "spzbHcz~bPkc@nhE}hAbdAwqDzw@yrAlo@_cAvcBo^f{E{b@tgB{oA`fAchBlo@yxAzu@eb@fvAwQfhBcz@hrAovAnn@ihBqBikDbZ_aA~zD",
        "{`ddHgsoaPlEjmF|j@~oDfG|vH",
        "iocdHooipUt]qsCv~BkkHp\\{_Dfu@usd@~oCaqLjaIwhKpsVibTbiFeqIl|Joag@jfCs~OliAetCn|AisAztBol@b_M{kAviB{a@jfAuhAt|@{rCpyCigQlt@}xFxr@evBjvAyn@t|@h_@joCpsChxAfj@|o@eqFjbR{i]fjAwzAloBuqAdfByw@biAsjAxlAedKdjC{eGn`J{wL~_E{sDxtEs{C~zB_h@npJmFxgAkSvb@oM|^yPvzAowAhqC_nEvnAcxArt@i_@lp@wPxm@}Vnm@{u@tIqaAlDwdBnOqtAfj@}Tr_Ald@zl@fa@jq@|TzkAh@|^sJzWgVpQa]rKi_@jXae@r^xCbe@`S|i@xDpjCgCzfExnAriBlPpu@oXvnBcdBpq@}Ury@vPnl@xe@~i@vn@reCnmBxsA~pBlu@~{B",
        "{q}cH{p`oUaLmwCmyB}`Lqp@slJkCsuJ",
        "c}~cHywanUfj@ax]",
        "}xyaHe`ikUoxEcsFewGucFcfDkbFyuDwrIkid@k{h@e`Bs|C_hAulH",
        "aoycH_pp_P}j@haIs@x`Q}t@|rDSR",
        "es|cHiwn~O?r@",
        "q_x}GwyaiPqa@vuFwmCf|D{mx@fpn@km@zM{k@qLii@_i@mzAs_AwhBwZeeBlPsoA|iA{oAfhDudD~f@qhEsJc|DzMmsAdvAepBbkEwtAlpA_wHtwDmyArsAs}BbdAevAs}@obAqjAybAt\\agA`dCcs@tdCwjBn`QcxAj`Hy|BrnGgaD|fF}tAdkA{yBhiAmcChh@{pB{VsfCis@upB`[ocAh~A{BdfGsr@xtF",
        "aghcHy|adPda@~eB`lAxn@brAvG`rA~R`kAvpApo@xhEjc@prS",
        "{yecHyx_hUbYabElvEkjVtpBwpMby@ojCpn]mio@~RgpG",
        "sx}bHq_seUsFoyLakFyep@qL}vL",
        "afccHi{ndUllDgcc@",
        "mg`bHupnbUc|C}kJwbRiwTsiG{~QcrAodK",
        "kkxrGi~yiPg@phEqsDn`BufBwOccA}a@ycAoCqiBfkAyy@zjBaoAx|FwfAza@soEfBmkDnlAmcD|_BmvDby@y`Cp~AgsEdyKclBlcCqgm@e{GqiCowAuse@}ug@ygFm|Iec@cdAqrDmdBa`HuQe|Glz@sfDx`CmlDvcDscU~tHg~BvQm~Ak|@aeD_yDgeMcuF}sBocAuwFq~AipBmnAi_FkeCshCw{@w~AqLmsAt|Aw`@lcCey@f_Be_DqLwiGitAcgD}NorA}FugFdbAwqEjxDkyCn~EixAzvAa_Cp`@wp@mPg~A_hAon@}Kw_AfVsc@hj@w\\~q@qj@dn@kqBj|@ilBhh@ofBrt@q`Br~AmoAf~Byw@`dCm[llC",
        "ybx}GumfiPfB|rC",
        "w|a|Gi`wtUyXjfBguAbcA_gBxZyxAlo@uk@xaC",
        "i{l|GwektUtl@f|Dp~BduChbH|nFbyA|qE",
        "_zn{GyagwU}rH|up@so@|}CazA`nCw`GduDobBlmB",
        "{~g|GgxbuUtSh}BhfC~zCbe@r|A",
        "oh}{G_fbrUga@bjFqmCznKer@x}EyO`xE",
        "i}d|Gcs`qU|J|eEdn@z~DlyAnhEbkCffFpWrsAjHrmI`]`pB`aGrhNfUvkEjr@dqHln@toCbeApjCpcBxuBjiF~dDv~AdaB`l@lxB`q@txR",
        "sp{{GmorsU_i@p|EcxApgFkq@tlF",
        "cfa|Gs{|rUbPxwAbrAnjDzWnaBNxmN",
        "mov{GcdlzUeCdjBal@dbC",
        "u`x{GwudzU~RxvAljAfkAxvBn`BrdAnwAz`Az_C|o@rgChSlmB",
        "yhp{GgtyxUgv@jqM",
        "a`r{G{akxUfB|lHfyAjoPpGv`H",
        "u|j{Gw_nyUm[ldC}|Bp{E_T`dC",
        "alp{Gux~xUfBlcD",
        "ql{zGipjmUsVvmCuyB`lHa|AlmB_bGp~CegApuA",
        "cgm{G}oqlUbKfiAnoCv_HrFtr@",
        "{bh{GgqdlUoJt}@{a@duB",
        "gqi{Gk|~kUdrAbmNhdEaeBx}AyMjuA|j@nzEtaFniD~gAtmLxZziCn`Brk@n~E",
        "kw{yGun}jUwdBbdbAu{BtsWgApiB",
        "a|bzGij~gUzVt}@fiBjzBpgFvgK|ZtzA~b@fcKdx@hcGteA~eCrk@ftAhdEh|B`pBhu@byAlyAttVrx_@vpe@xb[piDbe@laEquAvmCkcC|rCmz@fpE`dCdzJzxJlyAbaD`pBxqHtRxcBHf_B",
        "kqwuGyrkcUs_@~_I",
        "_rxuGyqacUvQj|@nbBxwBjhXxai@j}JhsMvzAh{C~|@vwDhdEhe_@`pBboYr@jeh@d`Cvrc@",
        "aa}sG{~o|T{W|pEofHtx_@gLpsE",
        "ungtGu~a{TbZnsEdhFnnYr_@~|@ly@bZ|zGlo@djCxy@drGxuDvgJlqIveZnmg@phC~kH~}@dxAbcAh~@daDptBtcElaEjcCnsE~qA~mFvp@nqGfWxqJzk@`xCf{F~aI|cIp|RliHtiK|gCxhF~g@f|D",
        "ygjrG{cplPybBv`RyuC~sKw{@bzA}rCphCoaAlnAcoArqE}i@juGwGf{G",
        "my~rGwsnjPpX`aFnsDjrL",
        "k}arGkvtmPwf@fkA}uJxyKgu@xlB",
        "irprGoabmPzA~eC|u@fjBbnAvcBh}@piBfB`{B",
        "cfarGq_gkTs|BvwQ",
        "wcerGyftjT`AxfDXpeAnNh}Ari@p_Aru@xy@jq@rhAhi@z~B`p@jlGhi@`{Bn`EfbJlwBn`DvnCfiC|it@xpc@~zCp_AbcBxDbtEcZhhBzBlnBza@boAlq@duCjcC|yFr|CldAz`ApKzMzkBztC`mDbmCjdE`nBxtDby@x}FzBf_CowAdiDmfKldBokBtpBcn@zpF}a@fgFeaB|eEmwCnvPouPvxCqqEpwIm~T~gC{~Dj~CejDpdVq|P`rE}tAvvDsUzmElPdiDthAzgAjnCxMfjB`aBngH",
        "au_rGo|mnPcmBxiR",
        "eccrGuqzmPhJ~gA~Tdw@nCby@",
        "g`vqGcozqPmZr|C}oG|sO{aAvkEcd@bkEwG|pE",
        "k}brGwqqpPxPluEvo@b}I",
        "yz`rGe}_pP}i@nr`@",
        "webrGui~nPrIpjCvz@l_GhId`C",
        "cfapG{lktT{a@dcMoYr~AsgBhoDyZdaB{rCd}fA_fDtdP_@fpGcrGh{j@ioGbfYs|AhoDs|BjeCosHz|FmpJbcOitAfqDk\\jnE",
        "c{arGuc|lT~Sbct@",
        "k~tqGgdnvPaFryDsu@fsDspC|wIwF~rA",
        "mu{qGmhuuPr_@roEnCr~A",
        "ipzqGexkuPa]t_H",
        "kn{qGowbuPzjCxhUbOj~Kf`Bz|Q",
        "wpuqGarsrPi@`eB_hAp|G",
        "a{wqGmngrP?blBxy@dqH",
        "cqsqGmplsP}AvcBirAhyGsJnkB",
        "_svqG{d}rPfa@xqH",
        "sdpqG_rgxPaH~yCabDhiN{L~dD",
        "s~uqGufnwPd\\`jKxIzqC",
        "svtqGwh}vPcYxwBkIbwB",
        "c{uqGywuvPxDlxB|UbyB",
        "o}ooGcya}Pgu@|hOapAxhHaaGtiIgi^dj^_fBx_DgwJty^}VjmSea@d`CmnB|oFkg@f~BoEpsC",
        "yhqqGu_qxPdc@tlH",
        "}fsnGw|}~Pyo@jmDmbBjfB_nGjdDupBjoBusKlbOug@`qAi^jfBmG`eB",
        "_asoGins}Pf`B|yGfAfyG",
        "qpbmGa{`cQyZtkGuxEjePubGrbc@co@llC_qAbxAgjB`fA_}Af_BofHboLqdJl}WwdAr{D",
        "}gsnGikj_Q^pmK",
        "mzvcGkagkQyMvoA{Hpt@qeBpk@yoW~rAepCtg@g~B|iA_pClwC_}u@jjjAmjEbtE_iFlxBceGlz@w~GdXkbFrt@ghj@flZmtm@fdSefPfpIaeCh{Cym@z{EqKfeIwoBzqQg`Art@qrCh@ofJmz@sxHri@k|@wF}}@wZewB_sAejDgj@qhBgkA{sDwwDkzB}s@kh@hqB",
        "oyhmGmxceQ|gEj|aA",
        "guoiGi{siT{MhhM",
        "cdpiG_reiTbe@ptBxhZrq]haCvwDxhAbkEli@twSts@niDhhFvgK~}Lljn@b~Hv}V|lD`wFxbZpuYjyPpyUr}BxxA`uHjyCnlGllEdtE~aGxzIhfQxlBztCpdItxC~fB`pBlxOzbs@tbBxtE`v@bmAvo@pv@zg@xy@f_@tzA`NdlB",
        "gixbGorc~QewFfinAewFhinAewFfinAgwFfinAsgEfc_AugEfc_A",
        "k{cdG}`fpQf@dOrjDp|dApjDp|dAngAfsQ",
        "mrqbG}gxhRspHrfmAqpHrfmAspHpfmA",
        "ggncGcqmaRl@|zGxkNhhcAvnEjx[",
        "uifcG_vs~SgBfyI",
        "}lfcGw{h~Sxn@jqM~qNn|n@h}Nlb\\bOvp@",
        "g{h_GkqhtR_cAb`EevJftbAevJftbAevJftbAopCruJiuLlcPswb@jo\\grI`bRshC`_Uim@xhU",
        "mptbGcx}iR~|Adod@",
        "u{dbGuvk{Sc@fa@",
        "y|dbGmtj{S~Hj]vq@ve@nWfVlK~]`v@rq]`kArlHzM~fD",
        "mr~aGsectSolBhrOoYxeJ",
        "mzbbGokgsS|}A~|Wt|HnmrAv|HpmrAt|HnmrA`s[`yvA`s[`yvAb|\\fblA`sDl{Ln_DjuGp\\ftArZhsBvcCt`Izj@j~I`^nkBxw[`jc@l}@b_G",
        "ci}aGypyySmrClqq@",
        "q|abGk~fxSlKhnEvpFfgR`v@ntEnI~dE",
        "y|waGik`wSsdFlzq@",
        "mb_bG{omuS~Nfii@",
        "ikz}Fe_axR{UvwDk{Ufhx@k{Udhx@IfA",
        "g{h_GwqhtR?J",
        "mhy|Fmuu_SuaF~nFobB|fCeg@jdCeCjzw@mdA~xQux@hj@c_g@mP",
        "gzp~F{hy|RnfJxckAlfJzckA"
      ]
    },
    {
      "left": "RUS",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "wtxjHsqcuO]keAesFkid@sj@soR",
        "o|xjH{_buOvFwp@",
        "ydojHukmtO}UalFwoAqgFeXwe@g`@s`@cf@wZwbB}s@uIod@",
        "}}qjHwl~sOr~@soFnXimF"
      ]
    },
    {
      "left": "DEU",
      "right": "CZE",
      "kind": "International boundary (verify)",
      "lines": [
        "awovH_wkvA|n@qgFbZen@va@}_@`a@ug@fVybA\\cdA",
        "gppuH}`qvAoaBmvDuzCmd@a|@reD}i@reFybBp~Cq`AyDgV_t@sKuH}^t{BmPfrEk]|gAs~@wdA}rDyvAe_B{tC{R}eE",
        "oeovHkpkwA~s@ec@rd@qLld@iTdr@yy@fa@olAxYsgDbe@ykAxx@sjAlp@yn@~{@kR~|ArJfjAno@xxAziAdkAfa@zb@ufA",
        "ywkvHasgwAgVafAmuAgu@",
        "{_lvHkp`wA`GuaF",
        "_ojvHia{vA{o@anD",
        "mnxuH_|exA\\sjAveAq`@~qAdc@h|C|hBvnB|Txm@k]ve@_xEh^exA~qB_nF|_@{fFfBsfC",
        "usuuHmb{wAwyAqxI",
        "yhquHsvavApWiiN",
        "_fauHemptAeDewBgzGam]el@gkAelBiqBii@ybAu\\y_F",
        "szbuHetayAmPycBgk@u{@kgAmz@sfDyaB",
        "wxauHqhitAvQscF",
        "gv|tH}|{sAmFymAk]}~@olAq~Ak]ebAyOcyB",
        "{a}tHe`zsArJw{@",
        "moqtHmpisAqMmoBufAysDSce@aGec@we@si@_`@gB{j@zM_t@vFu{@oY}k@ox@g@}s@",
        "ycrtHsq`sAjSy}G",
        "_totHmdqrAeNowB{v@ulFwG_fC",
        "}uotHcs_rA|@ipP",
        "quxsHk|}pAkQgsBk|@}hBguAqkBiU_}@k\\md@yd@yDaq@bc@aq@_gBmcAirAisAqW}~AjgAeaBy~F{`@qzG",
        "aj_tH{arpAvPekAfWs`@||AyvA|_@kh@rj@ojC",
        "_wssHatapAsi@cbCq}BoaAwf@{a@}hBoiFyXod@sU{BwFmP",
        "uhvsHemwoAbFmxBdl@mdBj\\_gB",
        "kuesHuiioAihAuxCufByxAiaJ_oE",
        "uafsHg`_oAhKmhI",
        "imdsHizunA}Ayy@_Iyw@?SUi@we@koD",
        "gyesHceonA`Fur@fVmo@jI}u@fBcy@",
        "_qsrHqx`nAu^kq@{tAigC{aAowA_qBug@y}Fug@}Uur@aGis@",
        "{c{rHukfmA~His@b`FwaQvFytE",
        "smyrH{t`mAuHwe@cd@{vAmFew@",
        "swyrHce}lA~HwnB",
        "woqrHmiklAyDkpA}i@ydA_hCeiCuq@coAqVaeB{BccB",
        "ovrrHo{`lAve@}lI",
        "acgrHkcakAwGgX}UqLqWzB_TlG{Kf@c[wOs^}K_^}T{Xom@}}AclDon@}zFgUurM",
        "kdgrHek_kAh@ew@",
        "c`dqHslajAug@evAqv@?yaAdc@olAvQcnBmRyy@q`@kdBkzBebByOwo@_r@i^wdAyn@afAw`Fy`Esi@ebA}`AmvDsi@iiAkGqU",
        "ydbrH{ruhAlFo|CdM{jHpu@cwBxx@yc@fjB|@vo@qWlf@wdA`QazA|AqrDxNsk@rUsSt[dBfb@xZ\\tH|@jGpBlGnCvF~JvOpKxDzLmEpMcOveAelBpVcZtg@{Xnc@}Ih_@oEbkD}iAh~@g~@tGsiB",
        "wecpHuotjAgeItp\\uf@~R{w@h@}~@|Ku|@pv@kq@lyAcd@`cB_s@nwAu}Ahu@s|AzBcmC}j@_}A`QgiAxn@ydAleA{jB`xCuzBvsHgiAr_AsjAemAcZq_Aa\\_i@aoAsJexAfVov@jq@g_B`oC",
        "g{boHw~dkAs_B{l@ckDaoCs~Akq@mxBkRel@ve@iUbxA{_Bx~FybAcFisAgj@kzAbOs_AhhBoN|dFu{@r~A",
        "wecpHcvtjA?lE",
        "ctcoHmaakAzWi|B",
        "}memHg||kA}LleAem@xbAym@`p@{v@lf@}iA`g@ihAdXqiC`\\ybA|j@cn@z`Ait@dtCkq@|~@eNoCcp@u\\yNvp@kGbOqkA_t@_rApCeaAtr@m\\puAq_A|nEii@r~Ass@xxAowBd`CaoAp_A}`A~]}|AshAafAkaGg`AobBweB_ScbCgBcwAae@",
        "yf`lHcanmAeb@doJm\\~zByaAzaBmjHvkE}sA||BowAb_HeaA`yBmyA`fAmdB~]alE`QihBlGqWnm@",
        "ctemHc~~kAdEz`A",
        "ecuiHcghqAem@~pCk|AtdEwmBprD}~AvxAknDzB{kBxdAspDlhG_fD||Dgj@fkAs^h|BuJzxJybA~oD}gBlbBazB`qA}gOfhQw[nlAUh@I?kzCpfEcy@l[k{@jGar@za@k\\pkBwxBtnDyn@lyAcd@|hB}i@~mF",
        "isclHepsmAvPztAloAwZhI|sB",
        "cpviHmk}qAwe@riB{v@|hBgk@xlBkM`fBsDhg@",
        "_o{iHuynqAbYpuAxcAlz@zkBp_A",
        "eushHikisAsrAbyBilKrlHotCjpCi_@xvAgWzgFyc@fuBaeApiBq`Bp`BupBnaAeuBnN",
        "oxviHc}`rAjGtpB"
      ]
    },
    {
      "left": "LVA",
      "right": "EST",
      "kind": "International boundary (verify)",
      "lines": [
        "yieaJo~ryCkQzw@uc@jf@epBhiA}i@ri@yo@vnByItpB",
        "sxmaJ{geyCnh@`oAdkBbFfhDanDxbBsi@dvA~zB`v@fgE?daB",
        "sg|`J}c|xCeh@vzAseCfkAayClx@q_C|tA_y@baD",
        "allaJmjmxCjCrcH`VfrCjm@hgCtn@jvApkEbvJvy@p~Cnd@|~Mxr@dvCd_AtaCp_@haA",
        "irm`Jw{k{C}JfrCkl@fiCk{AvbCsp@r`@oh@dDoEx@ea@xHym@pt@sUv{@_Y|{EcsAjuFosFpyJigAryF",
        "e|eaJgmwyC|@h~@rJtg@xCve@",
        "eqz`Ja`nvCoMvaDwv@xaDyY`bE",
        "gr}`Jmw}uCv_AvzAxkD|qBhh@p`BrUxzJ",
        "wdt`JkkhuCsTruL",
        "kzt`JwtztCtMh|B~_DbgIbeA`wFlo@dmApsCteBb~@vdA|j@~pC~CfqD",
        "{p`~Ieuv`DweArrBc`DhpE}u@~fBIn@grB|nNmQjnA_cB~aGofCpsEcgOtnQo`C~nE}tHnqT_lAfu@{_CvQix@wQed@ob@md@}Tqz@rSq]nm@uRthAo}@d`h@{oA~{C{{B`oAw}Bdy@evAf}As@r~A",
        "edp`Jwm}{CzK~dAz|@tnIbFh{C",
        "ooc`JkxrsCuz@znG",
        "_ss~IsdgcDuHz_Bkk@xdAy^zkA",
        "{hv~Iaq_cDz[rrBhnAn`Bt{A|~@puA|iAt|@p_CvPlmB",
        "yr`~Iy|veDa~Dlc]aP|tN}e@zsC}nAf}Bk}DhdF_~@hrCwf@vvEg@nkB",
        "e`t~ImrjcDdLxlB",
        "_zj~IabmbDeMbdN",
        "ehk~I}|}aDxc@hpEf`AbkEdwAvwDjg@~f@~l@~Tfe@t\\zN|~@",
        "m}`~IckfaD_Jb{@gl@rrBkGjz@",
        "a~b~I_`_aDxYrsAhh@htA`Hz_B",
        "ozb~I{j}eDtfA`mE"
      ]
    },
    {
      "left": "RUS",
      "right": "LVA",
      "kind": "International boundary (verify)",
      "lines": [
        "_`c~Iar_gDzbFp`@vrCwP`_CnbAhlB~TzzA_{CxeDklS|jE}mIpr@ssArtEkwRfw@isBlxAomAxpCmc@r}I~]~~Ddl@zdC`{@~`Bf|DvxCtdQh}AftB~pBquAtm@maDn}@iqCd_D}_@bcA~]~eCldBbdAve@h~@bOt{BzLveAhThgN`~KnzEf~BzMacBrNahB",
        "ozb~I{j}eDoDefa@",
        "ktbzI_`rhDrj@wtGh}@udCvxCotFvz@qhCbxAs`@vmCptBrrCztCrgBpaApjBgjBloF}eRliBs_AdxGcDfcC}_@tdBssApbAomBxeC}rNjm@elBrhAce@dv@rj@|tAlaDxhAnd@f{@aSnv@kq@heF{cItr@oo@rbAqUnuEpUjnCaQl}Bql@tiLe{FnaAqN`{AhKbp@xc@jg@jq@naAjr@|qCpu@rrCdc@piClz@xwBf}B",
        "ml|yImqygDq~C_eOkg@qgG"
      ]
    },
    {
      "left": "LVA",
      "right": "LTU",
      "kind": "International boundary (verify)",
      "lines": [
        "g}nwIqrxvCdWadCxgBwnBveGmbD~yJm`DxrBcdAb_Au}@t_C_oEt{@u{@fhEcnBr{DeuD`{Am`F~oCizm@|~@wsS",
        "ukgwIqbrvCcE_r@qu@mf@cdAwFqaAgVel@quA",
        "y_jwI_gzeCrIsxGba@{uBf_B}fF|ZuyB",
        "wtfuIw~n_Cc`@elFw@qnJgf@izFouBs|AikDgl@ghEqiBqhCs|CyfCe}E_lBqgFmv@y~DwFszGgQo`BiuJugZeaA}fF{L}gP{jMczu@e\\qnBstDetT",
        "u~hwIgm|jCf~@{iE`sDmwChsH{{E`zB{{G",
        "yt|vIu_jiCsFi}AmjEisZywAedFafAqvD}Ue}E",
        "ajhwIixmvCj]giC",
        "gkkvIczetC_s@etEmtBmgJmcAeuBu~JwzNekBwuFaw@qbFkjCutPs@s}@",
        "wyewIiykhCnr@ooKnCaNlp@ydDlaDctG`X{jB",
        "{vdwIczqfC{a@e~x@",
        "qjawIuocmCjN{iCvbBedLhxCgfS~Gw_F",
        "_|svIijwkC_i@gzHi{DgxH{_Afu@ah@_rBi}AcsU",
        "gv}vI{euoCrIis@hj@}s@hm@wFff@`FtSkGvPmaE",
        "cf}vIi{ooCcOqiD",
        "kr}vIshboCfKuqL",
        "cuxvIwgpnCs{B}vJs_@}gE",
        "e|yvIoilpCfBumEnMgpA|yBwoTp`GoiQp`AipEhSg|D",
        "idxvIsz~oC{v@{mL",
        "cyrvI}ulsC|j@ohEvaDglKd^mlE",
        "axjvIgsirC]kH}O_dDc{EcrVaRe`E",
        "qawuIg|wzCrsAixH|JgjB",
        "ivuuIqsjzCgj@ugL",
        "yqtuIoup{CvQgkAzu@yl@rqEisBd`A{u@xi@gkA~jCcfJvrBwuD|jHqxMnqEkqPzbCi_JbtFgaKlnHckRjiC}{Cv}DwoCpnIaiIbgDmfKtlF{aZ|u@u_JxNqcJ",
        "_atuIy`e{CyOusJ"
      ]
    },
    {
      "left": "SWE",
      "right": "NOR",
      "kind": "International boundary (verify)",
      "lines": [
        "gtjdLy}z|Blk@xzq@lk@xzq@n{Twsm@|hByn@fhPmo@fuBbZf}BhrA~wSx}RpeIjqOdyKt_d@zmKelv@fdUx_m@xmAbsFvEhzF",
        "q`aaLwkcqBgb@b{IozJjx^giAz{G",
        "qipaLkyooBj|Ehfo@tN`lBxb@p_AjgA~_@x_QjxBf~DbFdne@uiIpzF|gCnxZ|ac@r{ClaE~pB`yD`Sd_D",
        "wsd`LywsxBolM|vvA_}NlsuA",
        "g_caLmkesBt}@t~`A",
        "iiz}KaeflB}fLn`w@{fLn`w@",
        "cyt~KabvhBdm@heCjhJhrN`hXlnoAhtA~{C~zBbbCr{k@h|\\tdCheCjhLxjSzsCvrIdlA~_KtrAlu_@fiAptBfkMfnIfmj@ku{@rmByc@~jXhoDrgBnbB~gAhzDvxAnpJdwMrbc@rcHr}Oxgw@rcgAhcT|nn@vkDsU|eTu_HhwAod@~hEcp@`_CsJ`qA~|@|vVburA~uAraq@|uAraq@zdv@ehSf|FwZjcCrhAbrK|`Lx`Blz@~cm@pyH|hHmEhgIij@jaHdXvvD|gEtnEf}Nx}Ar}BfxCbxAjcQzjD`p@db@xEzCjyDtdCvaQ~}Y^f@~wf@bvr@~wf@bvr@lbQcay@fj@egGno@}iNteAm`FnuCgsBv`m@y}GtpBxD`qBlnAje\\di_@h}@`pB?~yC",
        "qzteKopatAe}Fd{cAe}Fb{cA",
        "}vdfKexwoAfgE|cp@ndLxjk@|yEriM|t[`}e@bx\\j~c@xnJ~~VtyRmrHnjC}@vyB~{Axj_@`oh@xlOgdLpuf@}x^jgNrbVlbBbdAnaCgVjz\\cqJzoCpLvlDf_BfoHd}E`lDlpAd|BcFbhn@ywc@|u@wi@bsHmmDvxAoDxjFoMdvp@veNfvp@teNdrAquApxJmrUjpBuaHx{HqjN|u@_pDfZwjFzLsjLjc@{iExvA{|Dlka@}lr@fz@i|@fiAwFllQfpE~oD~{AvhC~|BhmI`gMhw@bn@jrAve@tgLlxB|XxOpbA|j@tc@`dC",
        "a}psJu`llAm_Aj`U",
        "o}rsJi_vkAnHvhJ`sEjal@hsAblDj~BmPl~GgqFbpE}qB`gMigCd}Eu|AhtFqgDx{QorS|xZ}yTxpDexAlaEeXjaFzl@zuC~gAnvBdaBbcBxwBbuEnoIhrAlpAjeBvZzrEis@lqKcaDn_FkRdpGztAtdFblDf{D`cFn`Q~n]|wJ|t[vZl_G",
        "i`qlJ{xzhAkq@bj^",
        "urrlJwm{gAxx@hcI~o@~`BfmAn{CnsEhh@dwAgiAhuBosDvW{d@vdB{kAr}A_HllFjf@toB?jr@za@niExsFftApuCxhFrhY~}AptB~dDpWjeCag@dwe@}xS|aLwmCvlCk]vcC?|DpBjxA|t@vdB`nBn`Bzw@neKfhDjjH~RjeDbdAnqGf}CnkCfu@d_Dtg@~lInvDfgD`iIrs@`rK",
        "q|kfJghneAqL`rKcx@f~DyqKwFo~Dh}AsBzBA@"
      ]
    },
    {
      "left": "NOR",
      "right": "FIN",
      "kind": "International boundary (verify)",
      "lines": [
        "uqujLewaiDz[{|DzkBuyD|oGqoIjoUukc@xr@}gCpyDond@prE~Gr|B_zCnbAkmFxb@_nFn{Ieo~@n{Ico~@h_AobB~eNc}I~vVsrZbbPpoUph^|dfAtpAxmAdjCjq@bpMfjBlcB{Bp`AgjAjjImjU",
        "ikrjLcdshDkeBarM",
        "wetjLsizgDly@oyW",
        "}tsiLc`ldDilDshh@cwB{|FwKzl@_i@`zA{Lzl@{v@afAuOazA{AebBuNwbB_tDypKg~B_aVekBon@icCicG{e@cgI",
        "_xziLu~}bDjVmaEtwAgyI",
        "m{xiLi{kbDq{@kbQ",
        "ceziLse_bDth@utK",
        "yqjcLing{CqKg}Coy@etC{uAczAs}AekAupAweBihB_dE_~@cdAirA}_@emAwdAi|AgeGcoAqv@{j@rUk^~q@el@nvB}_@vp@c[vFeXcFcYzBebB`|Akf@bDwz@mo@ij@sJ_nE_HeXiK_UqWk\\qUco@wF}j@`QykBjpAeb@r`@mbDxaB_gDkRyvNehFevAqjAwiJevPsr@v\\}pF`bE_pCmwCyd@_hA_r@ox@qtCxDshAag@ocAcxAol@~]qb@xbAwd@pWydAssA_gBivJsgBcaD_gCanB{rCcFolCztCox@rgBu|@xOoaAqk@_hAemAmyAqsC{l@}fDazAae\\eYihBom@mnAow@}iAwcD}yG}cFqnHq}F}{Rq~BcuDupBziA_n@s}@gmBszEguBwyBgj@inEk|@_y`@",
        "o{wiLuvtcDdDkdD|xBqkMlFovB",
        "}gwiLk{ncDqRizD",
        "mn|eLwxaaCh|Byo~@~q@ouCnqe@aiv@nnIc`Nn|Im{YnlAgtAr{CcxAr~@kgAx}He`NjyCmpNh~@azAlvPg}CfuBemAvPayB",
        "evjdL}or_Cqk@yjD{pGoeJ}gQj~V{qEawD}}A_gBoy@}sBqcI{_i@",
        "g}wdLosr}B|jK}gw@bZorF",
        "gtjdLy}z|BceK}fQ{a@wlD",
        "ismcLswozCn`BuuV",
        "ahxaL_dswCihBooKqM}fDoWkzBk}@_|Ag~BshAqt@pjAce@{Bgb@od@wn@cZubH}IqhCw\\u{B_qAknD}oF}aKcic@cy@}bHeWqeH",
        "gw_cL}uqpC|Ak|MfyFonf@ldCmjEf_AwoCn_Fcm[lxBea\\joCeqb@hoDcvPppGqvMz~DubEpt@kqB",
        "w}xaL{wqlCmeLcnv@my@}f^}~BseQe|FknE{pGcwBshB{wK",
        "qenbLifwhCpLucDxpH{yp@",
        "}|jbLsr{gCybBwhUyC}hD",
        "}jfbLs}nkCnc@eeIbbAkdD~mHybNpU{iC",
        "efdbL{enjCwcAwv_@",
        "ikxaLycnwCfBe_D",
        "wrlaLgfzvCeLcaD_sA}gCwnBcdA}gBgtAu}@cwD"
      ]
    },
    {
      "left": "KHM",
      "right": "VNM",
      "kind": "International boundary (verify)",
      "lines": [
        "qe_wAyetnSk\\ywBy~@ymAw}Aew@wbD}iActAgVkk@yDysAcZm}BwxAmeAi_@_bBmFyxDfW}_BaH_|HkpC}{Cg_@oeDfjA",
        "q}awAuaqnS~Yoc@rh@gVjRkg@",
        "wsltAi_jnSge@hiB{pBjfA}}BgAu`C_TuyBdLwjBndAqz@`z@ohAnYeuCa]eoQorEa{Ek^yy@]y}@vPswB|u@aw@zLq~BsJoqBgl@wzEq~B_x@wPqw@uHyr@kR}k@wp@uWwoA",
        "icxiAiennSwFwmC}wGgrEaeByuCg`Ae`DwoBa{AcmCup@kxCk^u|NwvDiqCSSRI?apA|j@ybAgLobAwe@ynAga@g|D}TejErJepTh{CuyDnM}fDmDwbDvOcmD|sAkbEjnDyhAhj@y|AdXm|DfVs|CjeAgdAfMybA_Jq|@cd@{Wi_@w`@eNug@|@ul@nNgeAp`BixAbOo}m@owRsdEerAwzMggEk~DiUodRve@kcFdm@gw]lcOcxCxlBuxClnCyZpKm}Alz@gjCzuBy|Ar^k`AgAkeCkg@{v@wFm|DxbAygBwZ{eAga@{fAcPalAzKi^fDmvDdwAix@xDqz@wFa|@zB}z@`f@sc@p_B",
        "ojmtAmiqnSvUbiF",
        "s`gjAg~_nSbwAqrCp|GkzDrfBcwB",
        "a_shAszikScYgfFowA{fFcdByvCqbL}iL}nFkdEirBseDccA}iAewA_i@o_EwwDgrDarJo]sbBq{AemH{VerG",
        "{bthAq}zjSxb@a|M",
        "s|_hAc`cjS{b@wbC{~CayBcjE_hAsqCweBisAamC{HgsBqEqlA",
        "gfbhAc}qhSfKwoA`g@ew@pu@qXri@q`@dDuqA",
        "audfAawnhS}@kpA}}Aox@gFvAyhCbt@m}GdiD{aBxE{tAs`@_rAkr@exAgj@}t@kGeuB{Bih@cFsrCk{AyNcOayCdb@wsI`xDgnCpq@_XzGyd@sqCcE_hA",
        "abbhAmhyiSldAuvH",
        "ad_hAezziS_}Avp@",
        "spahAkt`iSpBkjH~gAmyO",
        "qk}gA{szhSadCo_E",
        "s|yfAkcafSnn@e}GxaB{cIzCabGjdCcnL|_AmyBft@cn@|hCyxAzk@ew@zLuqA",
        "{~`fA_gqeSywAqjAyaC{w@grDwlD{kAqb@gsAyNquAcDevCupC",
        "kfjfAmichS~Hu|@j\\}uAr~AqhChi@mnA",
        "eegfA{fvgSmyAa_JwEoaA",
        "wsdfA}jbeSzjBmhH~GsqD",
        "amnbAm`ofSk`Ch~@{dB|rAivDjyEyfBr|AsjFlwCyrAj{A{oArmIm~Ap_CykDf`A_@?seCvOwp@tqAkX`eB_}@xnAywAbEcuMkfBisEcdAo|AmPc~AjIciIz_BwaDqLerAlEgeAv[qq@bdA_]heDkg@fkAcgBn~@i[fPi{BwQemBufAyvAaqAqNqQggBe{BiTqiB",
        "cs}aAgmagSyd@{j@i{B`eAeeJ`eBqjBhgAmsAvnByOpkB",
        "gltbAkhtfSjw@f_BxeCtfA",
        "y_gbAkshdSfPgfDtvB_hBp}DwmBj`HqsEx}Aqk@nxEufAhxAym@rcBisAfeAmmB",
        "u{waAqjwbS{_A}uHeyBghQoRm|Aq_AcmCyiA{tB]s@kuAipC{q@gsD",
        "sy}aA}f{fSjC_dCbAi`A",
        "{{u`Agw`gSwwQx_Ds~G`yCmdB~^{L_Iy_DwFqMpLw~@qb@iUiSsKomB",
        "we|aAs~jbSdMk[lo@_pDrdAekCxDkq@",
        "y}caAy{xaS}y@a{@atJayDibH{|Fss@ymA",
        "cayaA}_j`SvYoc@zpAoMx}AufAz\\ywA~nBw_Rxq@}rGt|@g_BdxDmuEh_@_|A",
        "ywd_Aosn~RsJ_xGiwAq}EayCyuCwbKm`GinAsgAicAapAmrHkdRqoCwvC_jEdBqvKn~EyiFz`BkwEhToaBkg@syAaeAat@gz@sVkY{w@kpAofAgiC",
        "geoaA{upeSffDioEjbAey@fbCgsBpoBg}CfvAwlDdw@udDja@_aJtg@wbDloBejC",
        "mzaaAwlfeS}@g`Co}@cy@qzB}hA}gCmy@{dBkH",
        "ohh_Aqtq}R`x@ktM`QwsCpd@ysH",
        "qiq~@yes|RgMowAq{@{`AqwJucGuaB_s@}yAu{@{{@coAsTeaBmJukG",
        "{ar~@}so|RhW{pB"
      ]
    },
    { "left": "BOL", "right": "PER", "kind": "International boundary (verify)", "lines": ["~_ziB`eggLdFI"] },
    {
      "left": "LUX",
      "right": "DEU",
      "kind": "International boundary (verify)",
      "lines": [
        "i_qpHgsfd@oC~IunDkf@}tAk]myAij@",
        "okyoHaord@su@vp@unD|}A}hBzjBuq@bZmdAmPoaCve@kr@tg@eXzbA_hAcy@iSiVi@fM",
        "qaqpHuxgd@fAld@",
        "ohdoHqpoe@{Ajq@_TlEo_Ald@kj@fXga@t\\ce@`zAa|@zrE}~@p`Bw~HllEaoBdjB",
        "ma|oHgrtd@|tAdbA",
        "is~nHwycf@kRblBsj@|hBwmBrrDij@|hB]zu@",
        "imeoHgnre@xc@t|A",
        "}u|nHc`uf@qVp`@_@pWyc@n_E",
        "is~nHoemf@?vjH",
        "gw|nHe~tf@h@}@",
        "illnHantf@we@rk@}k@t\\_r@dM{v@oCqa@w{@gWqAwZxOgk@S_gCw\\eCaHss@SwGqL",
        "ezlnHwwrf@zLiu@",
        "}fzlHeive@am@Mg|DjRyhEyg@c{@cK_eE?ycAqb@g_Bi}AmaCwaDssAi~@gl@en@a[wOkh@xDeW`e@wP`g@uS~IewA{_Bc`EijMqLhK__@ri@k]iTiHa\\"
      ]
    },
    {
      "left": "OMN",
      "right": "ARE",
      "kind": "International boundary (verify)",
      "lines": [
        "mvc~Cy`vuIvFafA|oFeaBz~Bu^jqBrLtxDhh@toPxXxxA~h@jxCxwBj|Aj]piByZjoDipCxlAa\\tpApk@pw@voAf`AdbAdjBbDjvGu\\|iAqb@pDoIzKkWzVsqCth@ew@||B_}@xm@}j@pWeaB",
        "q`a~CwrguIiJ}oCqiAc|H",
        "oui{CmwcvIcPccB}bAqbG"
      ]
    },
    {
      "left": "BEL",
      "right": "FRA",
      "kind": "International boundary (verify)",
      "lines": [
        "c`yvHgpkNhnCe~AxrGu}@rwB_}@t{Co~Er|AeaBj{B_Sld@xc@`zA~nCdx@dc@dqGkzBvg@bFldAlo@t[lEjT_SnWqjAjSm[bnAst@nb@}_@|K{l@fKuzAh@ar@",
        "{qcuHsihOdCmz@lZaqAdc@s^hi@kRxm@kh@blCogFjh@qb@f}B}rAle@}_@t|@srBnpC_sNfGm[fLo`B",
        "qgcuHkudOiIgsB",
        "qw}tHsb}Qj^eaDr~@}hBluByfB@AzaBsuAxuB{kAxc@wp@vF{vAlP}rAxx@wp@|sCafAhgBdvAzsDkq@t~IkdDhfEuH`fAi_@joAeaBjh@_qAvyAgpGtRelB",
        "aultH_zrPkg@uqA_nE_{D{lAupBcx@aoCe`AmfI}aBwoN",
        "cdjsHacfTlPyxAr_@ug@jq@tHldAv{@xc@qlAr@urK`RolCpj@}gC|jA_{BztBmdBppF}s@tbHSl~F}u@xbCszE",
        "ehdsHumoSsJwvCs~@}pGsh@qsAwf@a}@yY}~@oCcxA",
        "ythrHs|dVhSubG~h@e`Cbo@gjBfa@wnB",
        "_a`rHilrUsKm[uQwO_s@cZmyBmoByc@kq@_SssAgLqoG",
        "kygrHs{lWbd@mxBhrCknEjp@adC~hAe`CljFejDpa@}qB",
        "cddrHo|wV_@mlCejBglKaHmcC",
        "yf`rH}arUxDkI",
        "{z~qHk`qUkg@qWqB_H",
        "}|yqHi`lXzKgw@|`@}rArj@olAtg@ce@f`AxMdl@j|@|hAhrC`|@naA`r@l[tpBr`@ryFbwB~oBzMv[owA",
        "qwuqHyhhXa\\{l@_j@vF_g@gBiTcmA",
        "icdqHepk\\~{Am[`RkeA",
        "qkwoHmfaZ_TkxDwuGkfZyYicGw[{bAkfAox@cbB{j@sfEyn@}i@lEi^fVod@zMu|@yOap@ec@aqLsySwp@qgD",
        "mmaqHwvt\\xo@ox@llBlGf`Cp`@llBdM",
        "gs`qH_sn\\eYwbE",
        "ob~pHmqmXhS_}@tlGihBxy@md@vp@ij@~g@|@bo@ztCnaAtoCxcAjqBzb@dl@xm@r^rhAzXbGw\\p~Aea@vzAwF",
        "gw|pHqqgXoc@u{BwEebA",
        "o`upHaxt\\cn@dbA",
        "sovpH{tr\\xDbe@heDptBpw@bF~r@uHxaAxD~`KfoFvbBbZpvAirAnmAyfH|qBq`BlpA_J|t@dOhs@r^nkAr`@r_@rS~h@pv@be@rJh^}Kp`Ai|@bd@oNzhFf@ln@ew@dNmbD",
        "ws_pHsogXuAhl@GjC",
        "uv_pH}}eXvxBa}IpN_sA",
        "_z|oH_nbYdeDyh\\fGsm@",
        "km{oH_psXuGu{A}b@i`K",
        "u~|nHu{i]vg@apBzsCqgFzl@s{Brh@{}Edm@iiA~xFciGly@_|A|u@upBlZaoC",
        "}mznHc}x\\oMckC_}@inGuBwqBQkO",
        "{ihnHgeb_@~rAoaCf_BywBt|Agj@pUj[~Slq@nwAjRnx@{MpWk]fL_gB",
        "qtfnH_du^_r@gyGiA_fC",
        "ip{mHc~p_@dCwe@xZafAdm@y`E~Zao@xf@ecAhaJ_lHbx@{Xf`Ah@xy@`Szv@lEpv@we@fV_fC",
        "qtxmH{~l_@aHqk@s^}_@ga@oYyOgV",
        "}rlmHuiab@lEebA|u@}gCrJ_hA",
        "i`imHghza@}TolAmdAwoAgVebA",
        "wokmHanma@~SykCfj@keCdN_fC",
        "ukemHyhba@aGk{AeXuS}k@eMeaAiiAur@uzC",
        "opgmHooz`@lz@wbEjHqt@",
        "c`bmHyzl`@u|@caDmoA_|Cga@qtB"
      ]
    },
    {
      "left": "LUX",
      "right": "BEL",
      "kind": "International boundary (verify)",
      "lines": [
        "qraqHmlzc@oEleAqGlZgPfv@{l@`e@wz@tSc[`g@",
        "sxfqHoprc@lp@f_B`H`dCxx@|s@ptAzXxxAvp@h}@~{AhhApgFv{@hfBtf@rUldBfKri@nNpb@be@~q@`zAve@nd@jgAcFvy@?lp@nN~]fl@dc@p}Bf`@xe@fuA`Fza@}j@pa@eXztAncAj^tr@zLj{A`Rzj@~h@bp@r_@fVr^zMvf@dXpqFjwEjz@dX|UshAdcAgiCxw@cy@",
        "{c|pHiyid@yY`|Akp@dMcz@cFox@bZaq@voA",
        "wvcqHiicd@dClo@xZ`g@rTfu@pMbmC",
        "w|hoHiscb@_J`cD",
        "wgioHgo~a@dc@SvQ`HnMrJrU|Idc@a{@h_@hiAvz@vZpiAaHnmAae@`fA}`A`Sg~@jFebAt^onAtf@ih@r{DgrCl\\uHdvAqLnMpA~Sag@bPevApLod@dC{a@",
        "qylnHejtb@|@ug@bd@cc@dMoAr`@}DxXfVhUj]pa@tHtg@fB~RtQhU`Hzl@}T~Ssi@jHi|BxWgl@zwA{a@fu@za@ld@~|@be@vp@`oCboAr}@vp@hj@jeAvd@}hBp`Blz@xbBjnCdm@psC",
        "{plnHcbsb@uGag@"
      ]
    },
    {
      "left": "GEO",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "kbphGs~hvFgUtwF}aLzdo@MdmL",
        "_|}hG{qctFnqAleLjgAftCbbBftAndXjgLhkBd`@",
        "mtugGqboyF}a@z~DktNfvY}tAnhEy`Dx_SamDxxH{]tv@ccAbuD",
        "quvhGoybwFnRjbFvxCjsK|d@bbE",
        "oongGeg}zFwcAtxEcsBn_EmiAdiEi_@btE",
        "cswgGumczFt}@bjS",
        "k`wfGiw~|FgMtcFscApgDmpEvtGqfAvcDwiAdeIqq@lyA}~@by@_qCzvAy|@xw@st@||D",
        "}npgGefk{Fl~@~}L",
        "cehfGahbcGaRxwBo{Cb|J_fBdsD}wBvcDqnDfbJwe@|wJeD`q@",
        "cp{fG}joaGz`Al``@zb@p~C~Lja@lhE~lNj\\pfE",
        "wvtfG_`g~FqMjcEktA|uKsQjbF",
        "imxfGiam}F|k@~hM",
        "qupfG_rr_GaGfgEoi@tdEkfAjcEsc@zsDyElvD",
        "}zufGkst~Fdc@jrL",
        "i~ubGi~dkGcj@fuByk@`nAyoAnmC}o@f{FmPdpHwv@rxGgbDhqDqwDkRs}BunDcrBkyEevCaoCmuDxdAei@~oB_}@`eDogB~dQqu@rrBkaFjaGubArgBezCdmLwj@lkFkxBzfQgxF|md@eo@nvBop@vyBaqMx}Sy|CxsHk`Axw@}cBmPkfByn@crATopCzsO{uAntDsyBvnDcrAjmDkm@hoFyCtwF",
        "}~ofGa||cGt`AhbHlBvbE`e@nkBxrB|fDxYnwA",
        "{apcGom}qG}PhqByg@lmBchJdiTeg@poG",
        "}m~cG_rxpGz}Cn_DxcBbf@z_HxsDhwIbdBvj@fv@",
        "ieacGeygpG{z@nlAokJjyCisAhiA{oC`wDaz@p`Bq`BffFmDzUaw@bkF{WxiG",
        "{e}cGix}nGpPpxHnd@psDh_EleN`|@n}FpGdiPj~B~pCdoDrrBrwAntBv`AhvAfOjgA~o@ryE~SluQt|AhoGlcAfsAr}C`zCzz@j{AvLzsB",
        "wtobGyqysGo~@~nEogAh~@gpBtcAupAnp@gsAncAygPpfRcrBfsDkw@niE",
        "ghscGoalrGxIdvBbx@dmDlQjw@~NfuB",
        "{ln_GyxpwGiDptB}a@|rAqdApaAqeI~oDm~@fuAcsA~rL{dJhmTevAfzFmyAr{DupCt}@cqj@}mUmoCkRcDUw`Fx~FmmCtfNscAzjOcExfJ",
        "s`tbGmtqtGfoBnwNrZbiG",
        "}km_Gar|wGkShs@icArgBoNjg@",
        "ctp_GwlvwGtHts@no@tqA`Lpk@",
        "abg_GwvpxGqBz~Dss@bvCogC~h@i^j|@",
        "abn_GkxbxGhOftAxD`pB",
        "gvt~FapkzGwxCbwCy~@`xCqVlrJa{@|pDisF|oGoaBlbDsK`|@uBrs@",
        "qji_Gms_yGtB|s@xI~s@X|@R|@pw@zmJ"
      ]
    },
    {
      "left": "ALB",
      "right": "MKD",
      "kind": "International boundary (verify)",
      "lines": [
        "exh{Fgcb|Bih@yxAqlAkpAgtAmz@igB{j@ssAi@cM~Ew}@b^mnAfiAqVdn@sK~fBm[pk@{`@fKaeB|Kco@rSmPbK{_BjbAod@xn@{VvdA_|A|j@sgDcQywAfVaq@{oHw[myAce@_sAug@}s@}_Aq`@yKB}h@N{`HlcCkdCr^ecMvp@{`AaQcrAmq@w{@k|@{iBipCwu@ug@{g@zCiwArIy|Cvp@}`@}@mgByDogA}}C",
        "omi{Fmi_|BhTyxA",
        "_|vyFicz|ByEhtAkPbp@gl@x~B}sA|j@ymB{BclCt^apCxaBavFffFq}CxmAepI|hBi{Dp`@mKgAqyBgU",
        "y`rxFc{v}BoYr|Coh@l_Awt@lrAkoClyAofJxwBgwKxwBwcB|~@mf@xbAgEnv@y@dO",
        "}~vyFcr||B|AxmA",
        "ukixF{w}~BaeDpAqtB`r@{kArgBaeAtuHec@`iI",
        "m~wxF{xd~B`@nDzUlyBlcC~nEf`@xlB"
      ]
    },
    {
      "left": "ARM",
      "right": "AZE",
      "kind": "International boundary (verify)",
      "lines": ["wyvyFs`pqGpk@muF|qDmdA`oCdxA", "ejkyFicwqGyy@taFekAdmAi}A`f@quAiSur@}_B"]
    },
    {
      "left": "ALB",
      "right": "KOS",
      "kind": "International boundary (verify)",
      "lines": [
        "upjbGm__zBobBfhBm~B~vHsgBd`C",
        "ijhaGi_rzBeGhiAoi@~q@keBfu@mk@`HmsA_Jio@zM}d@dc@_}@p`Baf@`\\ag@wFihAs_Aur@}@co@~]g{@~rAkb@fa@kyHtnDE?c@RS?",
        "upjbGw`_zB?h@",
        "kjq~Fu_p|B{l@{BalAt^kl@f@kjAu\\ma@ce@iXel@cp@ar@iqB{`AinA?eqA~]o{B`\\e_KjcEwsBbe@agEh@omBbOoeDdbA{|JjkFyxBpvBag@~p@srAjgBcdLpcWcKf_B",
        "{qhaGgj_{BpF|iL"
      ]
    },
    {
      "left": "GEO",
      "right": "TUR",
      "kind": "International boundary (verify)",
      "lines": [
        "suy|FefkcGnw@siZ|i@{uBny@lo@|}@tS~|@|Kpv@xXpl@jq@nmAjzB~|@hs@tfAe_DdaByuB`\\qtB",
        "{}z{Fqs_bGeBkqA}AgjAq_A{`C{sEizD{jBsfCwcBu}@o}Fwy@_hB}~@ugAk|BeAyGsEsYq]yyB_SezH",
        "}fk|Fwol|FtqEsxShJmnA",
        "{pi|Fw}__Gd_Cu~L",
        "iey{Fcre~FeYa{@e`DuyF{qEubEwp@}tAqjAgzF",
        "soh|F_bf`GfA}}A`g@cxArhA_gBjH{tC",
        "ieg|Fs}_`Gii@kcE",
        "ioh|FatsdGtg@qk@zlA{a@jeAur@hTyn@zm@awDxYce@j[eXpWk]nOqv@rh@mo@pgGuyDziAmyAlkF{jMrfEulHbdAy_E`QyuDh_@kGlyAfsA`{@lzAxaCbqItg@{hD",
        "ebc|FifldGadCwxCag@_sA",
        "snh|Fslz_G|IyvAj]exA",
        "upe|Fm}m_Gss@{{E__@myAiH{vA",
        "{if|Fmpn}FJyn@nWkGzm@`F~q@h@jf@oYhU_hAbPyuDtSuqA`mDuwFfWekA",
        "}hd|Fyxc}F_JuyD}t@}{C",
        "q_e|Fkk}`Gt`Iega@",
        "ird|F}ws`GgLmrH",
        "}nvzFaekfGhJazBnkBi}BvtGytClp@cyA",
        "icvzFo{ffGsJqhC",
        "aslzFmcrgG`g@_dEfjAqiDnuB}gDrrCywAlaD`fA",
        "}ohzFknzfGmxB}}PuHcuD"
      ]
    },
    { "left": "FRA", "right": "DEU", "kind": "International boundary (verify)", "lines": ["gczlHs~we@uBlt@"] },
    {
      "left": "FRA",
      "right": "LUX",
      "kind": "International boundary (verify)",
      "lines": [
        "gowlHkekc@}qD|tAelAptBu|@pkKco@~{CqaAdlBeiDhcE",
        "}fzlHeive@qGz{Bmz@~dDepCxhHiD|Isk@djDgKtpD",
        "izbmHutxd@xXbfJnx@ug@tIhoDrJpk@be@~_@~f@Ur`@fMvQpjA`{@t{@fUvzA~S|sOrVnkB"
      ]
    },
    {
      "left": "MAR",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": ["amxyEnbr_@weBriCwnBz_Bg~BveAikCbx@"]
    },
    {
      "left": "CHN",
      "right": "LAO",
      "kind": "International boundary (verify)",
      "lines": [
        "gwhhCkd`lRdBwZtpCkyDxzKwlEtnC_zCb[g}C",
        "_{|fC}k`kReb@uqAap@u]_cG{tAobBoOyYmF_gBykBuGeOa{BqKwxBtHg}ByD_hCcz@adBewAufB{~BcnAeuCa[}qD?gv@",
        "kg_hCu{omRlGmyBftAk~JtSa{@ld@k|@tr@w[xw@eCjr@ai@",
        "wzqgCoawlRkpAoy@}}BmYolBi~@we@ymBcE}nGur@kdCgMy`C",
        "uougC}yenR?ueA",
        "{|}fCct{jR|UgjA|IqkA",
        "mel`Cg`ilRuHox@s^kq@ag@md@{^wLcRgGs_AyDaoA~T{bAtp@{v@ldAqk@xmA_pBfdIsiApvAshBdm@qiB}AqgFi}@{hR{XkdCazAeuB{WkxFhsA_fBaH}u@a{AwP}fCyb@oaCymBymAu{BpMuq@lxAa]|sBi|@~{Aq`ArUoaCuSa|@dDur@nb@srA`eBce@nYs}ApBmnB}Uc|Ik{Ba|@|AacCtzCgk@t]s|ClmAotDvmCit@lPco@|Bwo@rJsu@fj@kz@d}EynAhgCevAlz@kxF`g@y_Chr@waGfiDcaClz@}hCpAmmBsi@owB__@ifD|`@ykBbmAwwEn_EejBnNwoBwbBkq@{v@s_@s_ASmnA",
        "iopbC{rlhRlE}_B`eBgjAbwDmFj{NxxB`cCwRr_@co@vzAesDxmAsrB",
        "qdmaCoszhRHqMjq@iIrqDriAr}Bd_Bje@{Kru@qv@|UgKduA`G|eF|}@~hA_fAnjDcyArrAwz@trAg_Bp`@g`B",
        "a_maCkxyhRoDcZ",
        "w~s`CqgnjRh@okCpVieCzaAgrEpBii@~RyYbdAoYxw@tHlz@pb@vz@fVlz@m[dMa{A",
        "eqf`CsiciRgKykBiu@mcCaaEimHuh@cwBg~BgeU",
        "eam`CwsdlRvZokC",
        "my~_C}wykRkRkyBqb@srBem@ebAg|@uIm}@}IywAhh@weA~TkfAisA",
        "cqi`CuwikRr@yvBzjA_}AbbEipBdbAybBzBitA",
        "ulf`CgabkRmcBmuF"
      ]
    },
    {
      "left": "KGZ",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "cfn_G}okhNmnAcsHidEucDkvBlEyvAzw@kmAzkAkzAz`A{dBt\\ijEtSo}Ave@",
        "otn_G{nzfNjMa`p@",
        "kuq~Fq~meNa]kuGk}Co~EymBey@kgFkeAcmBew@kzAgvA}z@wcBafAucF_~@_`I",
        "_{q~FkwdeNrDefH",
        "mt}}FcmlcN}@sqCyc@_}Be}F{kNsqB_tKuzDa_Jir@uvG",
        "es`~Fya`cNv}AijK",
        "somyFkpl{Mi_@cnBm{KuvRqkAmyAybBgvAssF_gD_lDyuB}oDi{CsiAkdBaoBkxF_hAkoBsiB}~@_pBlPsoFxlBkoB{X}_BueByw@cnBquAixFepIacQkgA}jMqjAg{Eu|@_}@uzCur@ybAyn@qu@uqAod@quA_yF{kY{iHirPcj@}qB}t@gxJuzJm~TmhAysF_s@kbHcj@udCehA_fC_oE{fHew@clBiXigC",
        "kisyF{igzMbxAmqXrtA{qF~Ie`C",
        "u~eyFsmyxMmGsrByXq~A}lI}wXur@gpEyE{}E",
        "imoyFiq_uMdWqiDx`CsmIlp@g|Dnd@ahW",
        "ypfuFm~wpMu\\_gB{sC}eEsoGq_P{_CejD}pDekC}vLohEy~Ds|CkcEkjIywAafAmdBiTkxRih@w_FsiBe~DucDqiCwmEihBkvFomAq`Bs|Bis@i{BnNmyBnm@yvB~TguByy@ylAejBe`CseFeaB{vAazBwaDomAysFgrBm_T",
        "azjyFcb_wMdw@{{IjoBu_JtgAkxDbE}qD",
        "k|gyFypmvMitAkiJkG}eE",
        "ujfyFonoxM~Jc~H",
        "ubcyF_l`xM_gBoaN",
        "kd_wFuv}kM|@m`FxaCylDxhGkoBh`Ji_@fuBqk@bnAcdAf}BioDxbAw{@xnByM~qAt{@ztAtqAdwBjq@ntBsJnsGwcBnkBst@pvA}hB",
        "ytyuFyh}iMuTgsBsr@yn@cz@}Vmp@}_@gV{kA}JshAeY_}@cdYeui@evBgeG",
        "mvgvFwk{gMvq@cmCb}Gg~O|iAwaFve@idF",
        "o~auFglvgMaf@abEckEtr@uqAfkAgpEzdH_~Afl@_|Bgl@mbColAsqBkq@iUyDg_AeXowAqkA_UaRuHwbC",
        "ib~uF_lriMzb@srBr}@}sB~i@gsB",
        "{syuFea_iMcPg}C}hB{oHkRuzC",
        "otyuF_mjpMfk@yuDfhB_}@~_KccBdlAowA",
        "ykkuF}hxoMmcBqqEeiE}|DayCqrD",
        "u`puFurioMt[ovBzaBehFhTqtB",
        "md}tF{kcnMsUwdC}~@uyB{iBkfBihBmeAcxA_qAmlEolP}IaxC",
        "sleuFetagMlEqhCtfBomO",
        "{ausFahodM}Uc`EqjAm`Fi_LgzSwpM{iPcwB_oE{aBqrFwz@sgBkwFa`Iaf@euB",
        "ma`uFifnmMvFsfCnmA_tKvE}gC",
        "cn|tFkr|lMaHmlC}}Ac_HiJkeC",
        "q}xsFux{cMbd@axE~}@avEpVg~D",
        "cwwoF_kl`Ma{Bsvc@ym@ylB{vAw{@uvEwdA{kCmeAayAymAs_AkdBeaAqjCebAg_@}mIxkCwkG`\\waC`e@olBnwAyx@lxBaShhBih@rsAkzBv{@ywBvFuyByZwoBew@yxAqjAgtBgsD_r@mo@_gAu\\_cGoo@kzBwxAs_BkzBsgBsgBqrCqb@czA{MiqAcc@_iA_t@q_Aq_AqjBqiDsj@qxKcdAgeE_fBudEcdAaxEsTe}E"
      ]
    },
    {
      "left": "GEO",
      "right": "ARM",
      "kind": "International boundary (verify)",
      "lines": [
        "a}yzFw{cqGyDalFmf@ekAq_BolCmd@olA",
        "me|zFm`qpGjgAizQ",
        "{aozFqeqpGyOacDg`Aa}@_YhWkl@fi@gtAniFewArr@u{AmxB",
        "wvszFs`vlG|s@qhDp}CimHh`@srB",
        "w_izFw~dlGcQybCaq@uyB}hAeaBa|@__@}s@eCom@eOwf@giASqaA",
        "okrzFkmhoG|Ks}BnmAidGdMgs[",
        "kkizF_n|nG_}@a{AebBgkAapAwoA{l@ieC",
        "ympzFwbtmGxEelAvwCilIxd@sgClFokC",
        "}alzFclhmGmQ}qCu\\yx@cf@{k@oa@ar@cQ}hA",
        "weozF_tunGbn@}_@~~@sUln@ga@xZe_C",
        "_ajzFkrinGi`@yvCgiB}|BqVug@s@ebA",
        "}wjzF}u|kGdw@ygG",
        "ys{yFu}{iGuHywCaf@kyBy`EibHisAckGkHwaQiX}gCOuAoYinCqtAgzF_Iu{B",
        "i`_zFkb|hGnkBiz^",
        "gf{yF_jghGiIk|@_gBopIwFohG",
        "es{yFumchG|Js}@^u|@"
      ]
    },
    {
      "left": "KGZ",
      "right": "KAZ",
      "kind": "International boundary (verify)",
      "lines": [
        "meodG_l_jM}ZxaD}fDzxJauAdtC{kAtnDguAxzJ_~@hqDyqB~oDs`EnvOswAbhUu|@txEikJl`SakAbxAcfEh{CgoApuAcp@fuBkr@l_GmlBp|EaSpfGco@h|BycErbIkaAprDwa@tmEmt@~oDusEl}HmiAzsD",
        "sp`gGg`wcMlkDoiDljB}`AfxAxOxi@jfB`vAlw]",
        "s}pfGa|{bMyZ|qBq}Cn`Fw_@f|B",
        "wxwfGkjmbMnjBh|DvlLroEz{AxhF",
        "sbdfGsryaMsF`bG",
        "gjdfGqoqaMdOzjBteIrn`@b}BngHv_AdaBjzAjeA`zNblFrfDn_C~xA`r@`jB|TbhBoNxoE{kAtpBmPv~A~T~lGreDtePjjIp|EvdAljFxOhpEen@tbEe_BpdSwaM|BwAloBpAdWjoD",
        "wlydGyc~vMqkArfRYzmBYzgBqRteB{u@t|AayD|qDuk@`dAyx@dtE{vAfdUkf@byB",
        "eekeGosutMnN`yBxfA`wFrAlsGxMt{Bb_AxwBbrBjcCjTno@fAnb@",
        "qqaeGa_ssMiPtpB",
        "{bbeGkmosM`Gnm@|UdMh[xF`VxXb~ArnFxSnvB",
        "gj}dGmqznMyExkCaiB|iNuXbsF",
        "ytaeGqe_nM~QlcIrBz|@|Ph}A|n@tfAnoKdiEpoAnaAtpBrsCn}AfqD|x@duD~Cx_D",
        "e`~dGmvzoMaqAhhM",
        "gr`eGcmloM|@vaD`eB|wK",
        "{u|dG_gxwM}j@vlDeDf_B",
        "_g~dG_yowMnNp~Ab~AzgGrj@vkE",
        "mfzdGag}pMwxBlxO",
        "e`~dGsmlpM?dvP",
        "o{xdGk_mrMiT`cDwdBfcIoNvcD",
        "af}dGirxqMhd@fsBzdCtyDnXloB",
        "apwdGcgnxMw@~fB{q@xwBqaAdlBsn@lxB",
        "{v|dGu_`xM^twF",
        "q|{dG}gasM_DvtG",
        "qa|dGerxrM~mAhoF`VnaC",
        "kawdG}rkqMkV`{@ccBvdAa]p_A",
        "}z{dGqpeqM|A|iA|h@`{BrFnaA",
        "qhtdGgg|yM{e@rhAqa@vg@uh@xX_d@jf@wiAddL}Jv{K",
        "kw{dGwq|xMjQnaC|sBbgI",
        "u`qdGkjg{Mqa@vtGazChbJgf@njCaKtoC",
        "sqxdGcujzM~MnlC|Pdw@tq@~fBlt@d_D",
        "}x}cG}ujaNcE`lFqeArpFoPj|KgwChtNkw@brV_h@djBgdCvvE}mBb`Gq}CrdRu^~~K",
        "ecvdGwgu}MdNdrGtb@naCvjBtaFz\\fjB",
        "ufpdGcd~|MyDvbCocAn_GiOvwB",
        "iasdGcgn|Mj]v_H",
        "}brdGkfe|MmJn|G",
        "knrdG{h|{Mtl@n}S",
        "q`kdGylxkMmgCx_k@",
        "_iodG_lljMpB~~K",
        "st|cGo~awLyi@zgEigHnrUofA~_Kc`@hfBco@p`Bi^z_B",
        "y_mdGkwouLnN`eB|x@`xEnOfvL`p@jlE`eIhnT~MzjB",
        "clgdGurplMo{B`rKiJt{B",
        "}skdG}b`lMjRbuF",
        "cdcdG_kgsLgjAtlH",
        "koedGi}}rLjCnvCxhAlmBd{ApaAxwArqAleA|_Bhc@`nB",
        "q|abGoktdNwZzsQw`Bd|HyiDniDguNpzGozCheEokDxmNyeDn~EyqBnwAgtBr_Aa~Bbc@koCxDsoFob@c~@nm@m`@~{C",
        "srddGusabNdb@vuFnuD~eN",
        "w_~cGmxxsL}UdmA_zCvuFkWh~@",
        "ajddGetlsLjCz`Ap`@hfB",
        "umncGsmqyLi^~yEwnJpbV{yBx{KeXr`X",
        "yp_dGspmwLjRp~Ar~@fsDdHh}A",
        "mazcGerjrLgRbdCyr@psCi_@ziC",
        "yh}cGsm}qLfg@piBluD~eCnnAnlAzp@ldBby@ljFn}@ht@vbCbOruFiIz{Af`@piAnaB~}@tzOfiBdiFhiFmz@|z@s}@vmCuxER?TU",
        "gyrbGupe|LyDnsE{j@frEehAfrEkkBp~CigHjwEqzB|rCcnAlaEw}CnvZ",
        "grncG{o_zLpCfaM",
        "eaxaGq}m_MkoBlrJugAjyPqoArhA_fClE{}D_SorA|}Aqf@`oCqV~}LoUbnBgk@`eB_fAh|BugAbjFyEvtG",
        "q|ubGir~|LhbBr`X",
        "wnjbGsnupLjeAus@xhAfLd}@bz@za@ptA",
        "wnjbGkmupL?g@",
        "o}bbGkerpLgFvdBmmCnhH",
        "esgbGcvepLnaA|}AbhBvxA|yBvfAvwBve@nbAsJ~h@{a@lj@qNtgArk@bwDdiE~q@~fAliBduCt_BzjAz|Aea@`wDawFnr@eaCr_@cuD",
        "oco`GqaqhN_wBfpGm{D~zDmvEhdDuiEvmEkpGrtKgeGjmFgjApuAyaCpfGg|Efgj@qFpqG",
        "qddbGicdeN~fAxvN"
      ]
    },
    {
      "left": "BRA",
      "right": "GUY",
      "kind": "International boundary (verify)",
      "lines": [
        "u|{^lfhnJ}nA~xA}qCly@sV`qA",
        "ewc_@|lonJjbAbdGxw@vrBv{Fb{FdqAxuBvB|gC",
        "oinZ`s{mJg@tv@uNriA{q@nbBk{A`eAcrBj]uuBuSepD}eD_Hyt@gAm|BaSuw@_w@sy@yy@iTm~@yEgeAyNyiAo^ebGsqDqdBst@ykBsd@kuByMonGvZauGyvAuuJuNgwDmj@epBkm@srBcT}oFyDkyJcnBgqD~HawAlmDs{CrrGiaBz_CazA`pAyPzNakMreEegAju@",
        "gb__@fn_nJpdBdwG",
        "kht^n|qpJiIhyAc_@ldAwf@l_Aq`@jjAuMthAqXfrJ",
        "kdy^~diqJxEziCd|@dvG",
        "ihu^takoJs}AtqG",
        "}fx^jtsoJvEjaCjg@rn@bxBbhAvk@p|@",
        "}qq^`m}oJ}Adm@g`@hi@yi@`j@s^tm@aXn{B",
        "syu^x{fpJfp@t_J",
        "mglZprpmJcPnaAypBb`@km@f`@{a@bcA{AtbA",
        "o~rZf_ymJ`q@x_@dfAtMvZhc@",
        "u{hZ|`ulJk]r`@_vBxxAkb@hw@iKj|@{BdgA",
        "sdoZfz~lJlPt|@zr@bZhh@jb@",
        "_vkZlvbmJgKtlAuq@fsC",
        "}tmZjximJjQvxBbZl_B",
        "cffZf`klJgGlZaf@jXinAwPqVnXIpoA",
        "s|jZjmolJbz@rxBxD|x@",
        "}veWntujJqWff@y_DsDyc@bZq]rd@{~C~vAucEtrEa`Bvz@sqCuRyfBmdA_xAsPkfBlcCuuApkGcjApeBkcDhhA_cAfKgu@RmmBcOoc@eNciAuv@wf@gLoh@|KefAf~@c[dJ{sBuaAg|EutEqsC{e@yj@w@u{@iAoSfVmFzfAgVdgAes@dv@k|@hn@eq@fq@_kEnkJslBnrA",
        "}egZdq`lJtv@jq@|Llt@",
        "i`eZ~xclJgb@tdCeBp\\",
        "wffZf|hlJR~bA",
        "w_|SnwflJcmBsPqaGkjBq}Cdr@k`C~oB}gCf_BmvD]ikDs|CgsDe`OgzE}kFq|@clCwk@gv@ufAce@au@oBav@pFyiA{B}{Ces@inAgnAeqBe~Fc~A_zBiwAaSufB~Y}kClPi}Bse@upC}yAuuBmsB_n@asBuGu|@a]ga@sn@{H_}@bKor@fl@oYbiAm_@beE",
        "oyeWlxsjJpA`{@",
        "mnhJlnrkJgB`kAubAtw@u~B`]}hCxHibBuBgfA}UwwBemAgaAk[_x@iEwbDxNct@iJofByb@er@kCscAtSiaC`dAqqAjHu`AoRimBmeA{|@{Rw~@|AeyD~w@ehFxCspFqa@muEfHevCteCyMhw@gBlyBsJly@kg@tlAacDj~Dq_CzwF}sAbvBovBl_Ayw@cIkgBm_AmdA|@eaAzLifClEecAtI}uKttDovBzUylAw@en@jHghBxr@qXtXu\\poAgW`^_SqC{kAy]q`@y@k~JjcEowBrUg{^wf@s_Ou`CacC}NqdJfUs{Cu\\qsCq|@goG}eDyYc`@eNih@aS{c@kg@iSqj@vEgaAzm@ae@pGcP{RiKcnAeWuN_h@zLyy@bt@ug@fQkpAc@co@g_@wf@kl@ex@kh@gyGctAu}@mZqjGy`DgqE{`AiD_SsAmf@iI}i@a\\o^cj@{CoqAbe@_i@vGulHyZ",
        "_g}SfkclJff@fkB",
        "e}tJhhwzIs@jeBgVboBkuAjcD_aBrrB{_C|hA_qDbf@wvCd}D",
        "ayiK`fp{IhwBrmHjnIpuO",
        "kq{Jfkj|IaVf}BilCbaFkMvxC",
        "cdaKjez|Ixr@zhCxsAvzAt`BxmAfyAnaBhcAlbCx^dvApv@j}@n~K~yC`pBp`AbmOt~KblCtyDbiA|bHxDz~D",
        "afzJjrvwI|lBxbHnkB`}DlFrbB",
        "edsJzwhxI_n@h~AogAlxAi}@xaBkMxwB",
        "khyJfluxIni@hhBv~@xqAlo@hxA",
        "q|lJpisyII|tAmjAt{Lm[vpAopAvcB}z@jh@}_@|s@_@~eC",
        "ctuJ~wpzI|UhoE",
        "umtJta~xIoC||BuSj|B",
        "{fuJ~|eyItRfsA`sEvkGpa@pjA",
        "eifJtmbkJwQdmA{zA~iF_CxgA",
        "y{iJtonkJjl@v}B",
        "qunI~b}jJmQzfAw_@n~@gk@bx@upCxgCir@dIkeC_cBu|FgbCwkAbEuGrO",
        "osfJ~eakJhItf@",
        "o}gHbijiJmQ|jAk[`VoaBlk@ec@|UeOx^wFhlAqKp\\uaApw@ezEtyBk_Axx@wyCfbEyeCbhB}zGlmD_lBt`Coh@vcC",
        "wipInhrjJ`MpnBt]nkBlFl}B",
        "chjI`px~Iu_BjoOiJd~E",
        "ctmIr_p_Jft@rfE`~EnwNh`CzrE|d@fhB",
        "qx_Iz|o`JcD~gBakAf{D{LdbB",
        "swbIhe|`Jnl@ld@zaBwFn}Doc@`kB`RtqBjh@xhExlBxwBlcB`p@|dG",
        "k|nH|_jbJ_CduBsUhhCaf@~dCyt@pjBmn@pk@ycBj|@oMbZ",
        "svwH`v}bJ|o@jfAnqAri@zzApa@`kApk@dd@pv@l~@vmCjg@pk@~|@`H|bCec@rz@|AnpBfhDzL`pAtlAxcMnU|Pb|AliAj`Cuh@rtFeuBbaCwf@dvC{BxkBtg@nrHvbEpAjr@",
        "iveHbslaJuHnfHgt@fhE{r@fj@ggCzl@g{@lo@}u@~fB",
        "qdqHlucbJtIp`Abd@nx@jWlnA",
        "krfFn_bfJaQvoBit@r|Bq_Cx_Do`Crt@sfC|_@{tCnaBk{ArrBwdAf_CoLna@k~AfsFwwDzq_@e`CbpKg{@bnBmgBbmAwjHvdCybAhs@aaAjpBujBlZgtBzLo}AtgAuG~w@",
        "u`iH`jfiJdb@`~B",
        "ylvFtafdJk\\jp@wP`q@iK}@oXzWeYza@eM`\\",
        "cjzF~{kdJ~IxZ`|@vnAlOvf@",
        "sqwFhopdJu{@z|R",
        "inyFdmdeJtGr}Azu@tfAtxFblDnkBnbBrtAnvB`z@duCl[~{B`HtoB"
      ]
    },
    {
      "left": "DNK",
      "right": "DEU",
      "kind": "International boundary (verify)",
      "lines": [
        "{xbnIqnzt@vp@irNfsB}iNzsDolh@rt@sgB|}@m[fvAuQfiA{l@zXomB\\_gM",
        "qo_nI{rht@k{AuhL}K_qC",
        "{|`nIcqzs@nf@czExDseF",
        "e|qmIo_hx@vcA}|BbF}hB",
        "cmnmImvzw@_Iu|Aoc@u{@eMexAqb@mcAyMapB",
        "ipomIkgox@aQk{Au@sB"
      ]
    },
    { "left": "BRA", "right": "PER", "kind": "International boundary (verify)", "lines": ["|`zaAn_xgL|@isB"] },
    {
      "left": "TUN",
      "right": "LBY",
      "kind": "International boundary (verify)",
      "lines": [
        "kr`bEgse`Ai_@cyB_pCipEovBuaFamDwkEmoN}zFuzCqiDooW_k{@ewSsbr@}uFssLs|@ekAseBs}BabEcnBafG|Ts_FjpCo{IpaLwpFz~BcwIpC_rSczAwfSfl@sfLwnBw|IgBa_BoNyqQ}qDiwGzD",
        "g}cbE_{z_ApLqtBpu@koBve@iqB",
        "ggq`Eqts~@srBiuIceAaeBmnAwzA_}A}iAawEghBgqEqfGunEmpAssNis@e_CykC",
        "_oq`Ekv}}@vFe}T",
        "uaowDeiby@c_Souj@ii@awDcYmfMmoAo~CafZchW{v[orSunPcxP{qTs`Kg{FyaBgpEqA_uL|{Cq|ExZ}nF{a@isBjGodJrdE{qSp}Dal`@jqMokBrJsvKoaAuoCeaBm|JenK}{RydL{{Eu`I"
      ]
    },
    {
      "left": "AZE",
      "right": "ARM",
      "kind": "International boundary (verify)",
      "lines": [
        "ip_{F_ptqGlqJgfFvbC~}@plAqa@za@gjBHgwKbY{iBx`EefIxwAapAnbBaGnuBluE",
        "sz{yFastrGuRdiR",
        "in|yF{harGzgEnaAjgBkoA`dAkfCjHwwB",
        "qjvyFcokrG|h@ifBz_DckE`{@}~BbnA{_Bf`AueBdYqeHftA{pGlPmmC",
        "snpyF{virGgiAce@upBcQ",
        "kejyFo|etGzrCce@diE|u@h~@{kArPewAlKi}@~eBkdD~cGmjGpkAyaB~]g~B`GirCpj@okBfiCiJl`GftBlmCtcDnpDncNn{Ap{FvwCnsFfqEh|C~tCHdsBH~oCcxAbyAewBzjAg}BtfB{kBt|@oWfiCgMbbAw[lp@yx@f`Ao`CtgAss@vgIeiEpgGcqJvuR_ol@bC{Cd_FyhGdDi|B",
        "mreyF}pusGcmBgbHsUyz@eMokD",
        "qnwtF{shwGxc@azAxaAyxAnaDo_Dbc@sJzc@eCbd@dCvpKjpBbxCdkAvyBdvB~{ApiCnn@fVl~GrhAnaAti@fu@|rA~_@tsL",
        "wjvtFyg`wGoHii@{RywAmE}gC",
        "_kdsFkaqvGyaC`b_@",
        "ymhsFi~puG~cErjK||@eGhuAoJxcAieErr@wjS|_A{iDhrBifCnyLwvGpjAwn@jwEsxGns@edCfpA}lEtzAkiKp_C{iDfxJ}oFlxBkcE|s@alFzm@qjBptAayAvuEsqCzbAwzAf`@{iC",
        "ikypFkysyG|JytEzv@owA`yCirChs@s|AnOkzB",
        "o_spFku_yG{a@axE}gD}iL",
        "ueqpFu~tzGbPycBhs@sfBvoAqkA~eBwQnnAdw@pj@bzAtr@|gAjfB|@z`A}i@ly@fAzl@ri@l[rjAHfAnaArhM~}AheEx_D`qAjcE}tA`zBwkEtzCq`M|~@ybBvyAem@nbB}_@`{Aw{@tzBcvCnpCyiGj\\ih@nd@_i@bO_Gvj@uT~Szu@zBlbCn_Dv`HvGzkA",
        "shppF_thzGa\\uiK",
        "uednFkx{zG{tCxzJ}T~yE",
        "oqinFqaizGrgB~nCd_EcEtzB{~CzzA_oEx}AcvCjlEymAjpD{a@~mD`QneE`qAtRnC|P`HzjA|TjlAtI`kAeE~gAmYndJaxE"
      ]
    },
    {
      "left": "ARM",
      "right": "AZE",
      "kind": "International boundary (verify)",
      "lines": [
        "}svqFmrzqGjqAosEdm@ym@zwKc}KhgBg_ArrBcZ~pChIb`Fj|@`zAoWt{@myB",
        "_olqFqd_qGmf@etEkeA{aD{Nwc@ghCqeF_}@oiF",
        "grlqFisvpGfBgpG",
        "omiqF_`hpGa{@ipDug@_aH",
        "ciupFwyfsGji@}e@bhDmzCz`C_iAleA_~@j[azAhTyfHfk@elB|zCmdEV[h]ebAlGkeA",
        "usnpFoztrGgi@ieFs~BspDqj@ifD",
        "cnopFsddvGhr@mkDxmAolCxmAew@|hBi@|}CjSH?H?n|Gqw@naBxZlkGfqE~{Bvf@r_A{b@t\\mOteAuaJjpAo_CbcB{uBxxAetCta@ezAnfCocJr}Aq~Bbp@_h@bn@gM`l@|Kdi@hi@jyCxuC`~Cbe@fcDyw@dhDccCftDmaD|dEs}B~bUqdIl}OikJ",
        "}k_pFaektG_JafAmZydA_UoaAuvFquNst@ifD}nCk}VqE}a@}@_pC"
      ]
    },
    {
      "left": "HUN",
      "right": "ROU",
      "kind": "International boundary (verify)",
      "lines": [
        "sqnbHuyuhCgVanFkaA_cFujByuD}gCkyCqg@ekAkf@i~BkH_fCyOmd@geA_t@ul@hKkg@r^mt@rAmsAebAen@ccBs}@syFi~@aeBacE_|CwoAueB",
        "entbHyr`hCtcDenMzVuvE",
        "ynibHwxogCiDwxA}UuqAem@wfAwuFaeBe]y~D",
        "eljbH_xfgCj\\w_H",
        "idp{GgumaCkp@_fC}tBy`CipAai@sVeKihAebAuSqiDwo@i|BssBupBkzBiTgnArgD_KtQuMdOqPpLsd@yDoc@gMm`@iTw\\wZa{FudCwdBcoA}rAoaCei@_cFqe@s_AynAis@sbA|@uaAhTgkAxDshAuHyOwFcFwZo_Do|Gql@_t@wsH{uBcE{VmEzB_hAdw@gWhj@aG`{@wPrt@k`@xMmS`HggEesFgyAojCekCcsHatAs}Bcv@_i@gmB_^uw@wZwz@mz@}xAgiCgq@is@_lAce@ux@|@ow@zMogA}@idAyXu{AkgAyw@}_@{~EufA}gAce@onFqpFavAupBym@moB{v@kuGilDi|BmoEjGmwE|u@qaEbO}wC{uB}gCwwDudEecKos@eqH{Peb@eXmp@en@}_@uEq@yg@mHem@oCih@wQqtC_zC}t@kRsqBiTom@gVwe@{l@_s@}hBs_@yn@{jC}gCmp@afAmj@srBcZcnBcDmnA",
        "qpp{GgofaCfK_eF",
        "wwmyG}{~_Cs_@a{@}}AufAywBst@auGyXufCi~@gtAihBa]ayB{FygGkkAwoCihClf@woFxuDu_CoNebB{vAc}A{jBoqBolAonFqWauBob@mnAs~AqVudC",
        "wxmyGcey_C^yuD",
        "{pdyGgbk_Cu\\koBszFmiHqMag@",
        "cmlyGwia~BzBi|BtScy@naAkoBbPar@",
        "yy{xGacq}B{a@kq@aq@S{iCby@yy@fB{a@cZclCysFwSmv@mYqeAoXcbC",
        "uqjyG_ir~BlOwnBbeAehF",
        "}`iyGsdl~B{B_}@ob@wzAkHsi@",
        "oohyGwkd_CbPcp@dc@gj@hhAcyB",
        "c{gyG}a}~BgBkzBcPyw@?st@",
        "on|xGomm}BdMcy@nEmz@",
        "itpxGg|w|Bsr@u_Jij@ayBshAs~Au|@q`@wLc@wjA_Eom@_^}Jen@",
        "ikyxGmw|{Bjg@c~F~fAmvFfsBcuDl\\_}@~RsjA\\om@",
        "qnlxGutpzBe~Eq{FkRwl^eiDmwC"
      ]
    },
    {
      "left": "UZB",
      "right": "KGZ",
      "kind": "International boundary (verify)",
      "lines": [
        "miq_Gmt}oL_m@u`GwjNarZwnBccOqxBqgFghFs|AeDxS{p@bgEorMpkZe|@|eE",
        "o}baGacspLjSheElvCvtGv~AhgC",
        "ssq_G}`toLdIorH",
        "czu{FuadmLk@hg@wBzlBgaAr}AkwExwCcxAjzAwfArgBqiBdhF]h@Kh@SR}hA`pZczAreFohEhqBy`DmbCq|L{r^k|EusJciAckEy}As{DwcDirCueHyuDmoFqoGyjK{hRwtAe_Emt@umRw|@uwE}gBmdAyeJmQ{cFykB{q@w`G",
        "yky{F_hotLmOjz@}jAdDa~I_rBeaCTmxB|_@irAlnAyN|gC",
        "_fr|Fm`itL~h@fiCbdApjArnF`{BH?HUh@?~fBs}@diDunDtqBiVt{BdZppEbxAdrI~nEfgClkDt^dtE",
        "wkuzFgj}nLgtAnlAelB~Iu~Jk{AwbCrJs~Blz@_gMv}IgiBhhBqv@duB",
        "a{b|FyhinLdWnsEjjIn|Vj|@btE",
        "y|jzFkoyuLwz@xaDgfG|_@miGoNamEdc@axD`cBerSpiQqa@vp@cOhs@",
        "gw_|FgbztLlY`g@xbCnCf`@jq@",
        "wwy{FicwtLkSxy@mcBp`@_TdbA",
        "qe~{FwcrtLpa@`\\dcAzX~q@xc@",
        "aw`{F}npsLewA~lG{sE~kHcOrtA",
        "gtj{Fi~{rLlnAve@vu`@qv@`xEp`@jzAdkC",
        "oelzFmi}oL_It{BwpA~pBwxAfuAonAteBu|@joBwd@dwB",
        "}mwzFguhoLhIxkC|j@lxB|JvcB",
        "_ufyFcwmwL{sCgtAwnBsi@myB?oeInx@iqD~IeiDt\\ewBtfAkfAp~C",
        "svmzFqmgwLbQlwC~fAjpCvzA~eC|sAtyD",
        "{|{yFyjmqLkq@daBehEf}Ck|@bcB}VdhFco@tpB{kAp_Cmo@njC_h@dhH",
        "edmzFcvepLt]tkG",
        "ykezFabtvLij@zjB_fBp~A}}AdvC",
        "a}lzFm_ivLf_A`oN",
        "e||yF}b`rLs_AxnAovAvz@mjFzkAsjA`fAiHpsC",
        "utkzF{nrqLft@d`CpuAxO`oBk]bbC}KxwBj|@",
        "sy|yFkawrLuuGrjL",
        "ipezFwuirLvvCh{CzvBdbAnChrA",
        "gblxFumvzLqWvkGwoAfqF{_Dv`Ey{H`kGob@xwBcG~yCek@`pBmnCi@yd@iI}^fB{XlPuQh_@qWrkImf@~oD_}@naCosE|qD}i@hrA",
        "g`uyFglnxLvdAhqBdl@|_@lcDvfAv[bn@nW|dFzqAjfJvj@t|D",
        "shcxFmnw{L_gByOcvDbZwp@|oF",
        "oymxFeso{Lfv@ndX",
        "_zfxFwg{|LccAr}BwzApuAur@bcB",
        "qmmxFmnq|LlaDnmMlxCj`H`HboA",
        "kyqvFa~yzL__AeuDs_L}gAkmDgtCkfA_zEqvAeaMc_GewO_dDoiQ}~BogHe_Ee~D}|B|_@AN{Gpr@iW`lC",
        "wkgxF}wf}LvPdoJ",
        "}`{vFw_xxLdjC_oExvDumEbcAesDpW}oFreFqwL",
        "iynuFszuxLqVgrCadCg~B}|CebA_qCmEi@RwfA|d@sr@hZGNstCxmGow@zu@S?wdAh@wdB_i@wnBSg@\\qjD`eCYE{eBcTs~@mxD",
        "cjtvFmfozLRupBboA}dF",
        "szfvFc|_zL_JawFmy@g_B{kAa{@ywAa\\k{AkG_gBoo@",
        "mi}uFqq{wL~HkqBjb@kx@Xk@h~@dX|UlyAlFpiBbOjgA|w@p\\n@XvRonA",
        "azqtFemnvLcP{vAybAug@ap@za@{Sbh@aVll@s_AzsDe`AptBu|Apk@A?mwA{a@gqEu{Os|BkdDwmDmyAssBmd@q_Aox@knD__L_TihBkJc|G{@on@",
        "iivuFcdbxLdYwzAjdDopJlo@ghD",
        "g_vuFgiywLaI{yG",
        "qzbuFkw{qLve@i~@p`Aqv@by@}_Av[ouAbFafB",
        "{pvtFsgkqLeNudEshBewAeiCev@aqBq`BsScxA",
        "cd}tFypmrLxEg}BblCkcEpaAawG|iAa{@j{Aup@hrAwpBf_AadChi@wmCzk@{dH",
        "gt|tFwlgrL{NacE",
        "}`ytFqqtpL`oAauU",
        "y`rtFodbpLkoDaaFwn@_jJ",
        "aavtF_|dtLrhAmmBnlCowA|}B}j@l_G|@f~Awe@hi@s}B",
        "q{itFudysLsJkyC_gAgu@ekB{MovBce@emAupB",
        "inttF_utuLxl@auFzNwuF",
        "_a_tFirqtLuRquA{sCwgI_iAycB}sAybAseE}sBetCw`E_IacF",
        "sfstFkngvLlGap@pV}iApKyaB",
        "sprtFyadvLyPkgAeCec@"
      ]
    },
    {
      "left": "POL",
      "right": "SVK",
      "kind": "International boundary (verify)",
      "lines": [
        "czvmHeptuBdHka@`Mys@xwBihBr_@en@h~@sqCr|BqjAdzHupB~eEwcBpk@i_@|t@gjB|UmaCr@_yFjf@`\\|`@tHx`B{BphAfLz@J|nAefJtHigC",
        "wsgmH}m{tBwEq_AgVowAoYen@qcK}|O_^{ViIec@",
        "_ugmHmmutBf@o_E",
        "ktmlHuutsBkS_|Ckq@m_Eaq@gl@ylAcOwxB}j@sAaQg@{kAqLyZuh@yMu\\fKwQ~RcF~IyiEccBywAgtAqw@azAs_@aeBwOewB",
        "c~dmHoj}qBbd@yiR`gA{sDfhB|u@bxAoErsAi]t{AeOllEzXleA{a@xMcyB",
        "_bylHkmw`CpLquAvxBc}IloBc`R",
        "gbolHugf`CoMkeCq`AejBs{DcbEar@_pB",
        "qrtlHm~ybCtR}sBvZi~@~hAgsBv[i~@dCen@",
        "mzqlHenebCc]}pBaXu}A}_@s~L",
        "sftlH_}y_CxD{_Btq@apB|_AcxA|i@s~A",
        "q_zkHovt~Bqa@sqCokA_fCmbEckEupAq_CqLeaB_@wbCeNsrBcx@ar@i}AfkAex@`oCyw@dkAk{As}Bw\\q~Aq`@{|F",
        "elrlHmrbbCvPwzA",
        "gjqlHecxaCUkfBg`@{fF",
        "isplHocksBzKox@bz@_{B~Rc{@|Aq_A",
        "qzllHkkzrBaGg}CuzAqpF_TigC",
        "mfplHivicC~J_}@jeAihBfrE}pE~q@g_B",
        "exolHmufcCgM{_B",
        "w|olHsuv{B`oDmoO|T}gC",
        "qzklHmri{BaG}aIqjBf@qMo`B",
        "m{olH}zd}BhJq`BbpL{iPbn@yaBfMekC",
        "qbolHon}|B{WmkF",
        "yoolHogy|BfL_fC",
        "wvilH_ok|Bqa@{rC}j@wfAkoAmbBsV}~@qAox@",
        "k~nlHmkrwBxZew@Rg@duBey@~fBs^hmHyc@nXtHzm@xn@~XxBL@~S_Ujh@gtAHSdM_IhAs@r_@on@p@gAbZsJfb@zMzLbc@lF`g@xMxZr{FjkFzpA`XLB~gAuoAxd@s|CdMc_H",
        "a_mlHo{gwBkGs}B}u@ipE",
        "qymlHsra{B~}@y~F",
        "c_}kHeq`zBod@k|@giBigC{a@}}AwZoaNyZa^quAqk@cxAg_@ox@}Kwe@gVi^}~@_@iiA",
        "y~jlHksddCti@iqBzhCidFxlBqoIziCm`F||DqrDp{EymA~eEih@|sA_pDdv@oyL|tAojE~SigApAu}@",
        "ymelHyoxcCk[e`AycAowAs_A{jBeN_}B",
        "{e`lH}`d~BtHeaBzw@}sBldAaeBbo@kdBdM_rB",
        "sa`lHkv`~BgCqiB",
        "os}kHcx{yBtHoNtIqhC",
        "ucckHqbkyBu|@ayBi{Cs_AiyEob@k|@olAmdAij@iiAob@knDovB_^qb@",
        "}gmkHccuxBbz@wlDreEiaInaAknE",
        "yrekH_m`xBq`@{iCqz@}vAqqA_yB}u@apBoMggE",
        "kbckHo|lfClEur@`q@ocA|j@Sjg@lPjf@eMdYqm@xy@gdH",
        "mvbkHufhfC}JytC",
        "}a{jHm_fgCpa@adC|oEq{Hdm@idF|L}gN`eAmwE",
        "eyzjH{e{fCwGqxI"
      ]
    },
    {
      "left": "GBR",
      "right": "IRL",
      "kind": "International boundary (verify)",
      "lines": [
        "ivboIjmfk@~XfxBlf@|u@zj@bo@r_@~q@pb@dnKp`@riAth@t}@f}CroDpu@yXtIlOvEh`@fk@dXp~Cqb@~r@vFdi@hk@dGtGv\\~zBle@tr@|hAfV|}CoYd`A?`eCr_AxmBnaBdeIldMhsAvf@rzCfKzm@sShTs`@fLHrSvpA",
        "}gbmI`knm@qa@luE",
        "ojcmInaum@be@lnBj{BjxEjfAluE~GzrE",
        "yabmI|xbm@}@p`Awd@ftB",
        "oicmIvohm@p`@hzD",
        "sw{lIrtln@i~@vmEkyApqDsA|tA",
        "}s`mIzk{n@~{BxtEnxAvtHjq@weBfKce@~|Abo@p_Air@bf@kfBvPekBtRss@bnA_~@~]ap@h@ks@",
        "swnlIvjun@`\\guA~gBggE|Tq`B",
        "gdmlIvzyn@}i@{_BmGcn@",
        "ubllIn`cn@`IoaAzxBiOHAlBM`q@taGfxIjmRzu@jnF",
        "s{ilItjin@u\\}gBkh@g`B",
        "yxykIrmco@yDltF{_ArxM",
        "o_|kIt|yo@ztAxbCdlBv}BvzAzkAlY~^bf@tfA|s@vxCnx@~jI|c@jqBzIp`@fj@cnAbo@aRjq@cL~r@o{@|_BqtC|yEohGnxAsqC`p@c|CTeuD~bEgcCxxAkpAveAqjBnKqu@jJwp@rTssF`h@}zAvbBih@dsG{Wp_BuqAfk@wxBbZ_vI",
        "iqbkIntyi@~}@}qE||D{bKhi@sj@phByw@xPmq@pBqiAdXcf@l`Bq{@tsBogAvyA}I~}@`q@da@llBnbA{|Edd@{v@rs@k[t{@uTt}@cc@bcBufBhrAcyBpaAkdC~q@sfCzBsiA",
        "}hsjIj_wj@_@ar@azAklE_xGinH}gByuDkIicE",
        "{tsjIdmzj@|JylB",
        "c|mjInw{j@yx@mo@{BfAuHlOu^|Vce@nNu\\kHaEsQyF_W",
        "c}mjIp_|j@^aG",
        "scmjIxa}j@oXga@",
        "slmjIrp~j@~Gym@",
        "suiiIdqok@{X}tAae@cy@su@gl@s~@mOi}@b[oc@myB}_@vFa\\by@{W`]i}@eb@ah@ag@u]kr@s_@afAgt@kuIar@udCueB`g@kfAquAmmBn}E{uAmd@a|@rpEebAdNoCa]",
        "qkyiIficn@hKmnB|eEqaMvf@qj@dv@kIhs@iSt^uhAj{A}yS",
        "_}xiI~|nn@qMwrJ",
        "gvxiIzz|g@xDiiArU{aAz`AyaCn~@azAjb@uq@vnBec@hqBxy@piBnkCvfAqaA~eA`G~qCp_Bnl@g~AxwBueDl[owA",
        "ivuiIf_bh@s^kq@ug@en@sVyaA",
        "_criIb|ok@nNiTfl@bQnv@tG`gASxw@lEfWgU",
        "_ahiIn`vk@gCm`AoAqe@knDvmCuh@?i_@{k@{`Ag}D",
        "iqniIr`ll@vF_{Cpu@ldAjH_U",
        "_ijiIjhxl@yNueCowBa`G",
        "woliIlufl@vGur@zu@{l@bZgKpCwZ",
        "siliI`thl@cEs}@",
        "u}iiIxo_l@t{@inH",
        "mpiiIzkbl@gLa{A",
        "qngiItdxe@xCar@hj@co@r^}hA",
        "ut|hIxrgf@Sqk@ga@y_DyM_rC_Uuf@_s@oY_s@nCco@tIwe@wFirA_rA",
        "ulfiI`nje@rl@g{A",
        "y~diIpwre@iJirAcZ{wAmFi|A",
        "uf_iI`}jf@|IeCnY{WxZcd@vOag@",
        "}l{hI``ag@gtBeuOoCykD",
        "kh|hIvpeg@zVq~ApBcp@",
        "}cyhIzgkg@iKea@w_@ac@}Zy]sTs_@yDmp@"
      ]
    },
    {
      "left": "CZE",
      "right": "POL",
      "kind": "International boundary (verify)",
      "lines": [
        "kfdvHuwe{AoZzvAyl@rhAu|@~s@}j@n{H_dAzuB",
        "i~kvHymqzApr@lPv[`\\rh@lyAzCnb@rIpb@nOr^hTl[?RveAoYtq@kdBnvA_~AptDaFr^jR|j@j|@hTlPza@xDzV{BxPcF~wEwF|t@|K",
        "yo{tHc_y|AcAnIuN~lAsr@`g@mz@eDu}@mPu{@|@gtB|iAwp@~}As^~oBi~@t{BybApaAkfBrhAcmBby@ywAvQ_rB}j@q`Agu@k{@oEmeBbcBis@teDqB|bJuzAvy@}}A`\\gV~gA",
        "gejvHu{l{Axb@voAvpAdw@R?r~@tS`HjeA",
        "elluH{dmzAg`@vhU",
        "mmmuHc{vyA`g@baF",
        "keluH_yoyA}A`dC",
        "mnstHejv~AgL|`Ak[zl@moArqAa]`fAwtGpaf@",
        "i|`uHc~f}AzLjcGzl@by@paAlz@dm@`dA",
        "sehtHarw_BaH`g@ktIzzHce@~Rsi@pLkH`zC",
        "e~utHoqf_BvnAhfO",
        "uozsHonp`BwQ|KuRnC_SeDkSgKom@yxAiiAeMeuAfa@ssAfu@eaBjpAur@~rAkHhfB",
        "kaktHiqh`BnwAbqJfBblD",
        "{ljsHkz_cByc@Rco@kGs^wHec@cZmPmPuS?cn@|Vkr@kcEevBxw@yeJhsOcdAx~Dg`@bkE}AvaF",
        "quetHaiabB~IvoAr}@zl@xnAdl@~{@fkAnNfhB",
        "so~sHwgvaBk[~}Ag_BrdEcPpfG",
        "k}btHq{daBtmFpbK~]nhG",
        "wkdsHuoubBeNejBss@yy@apAq_Cyn@st@",
        "mpjsH{k`cBpBnP",
        "goesHmgobBnb@ggE",
        "a_zrHgq~aBaRrJmdAj]gAae@gVox@wGga@ir@g_Buh@ylBkr@u|AwoAmo@iSeaB",
        "cqzrHqtzaB`Qu{B",
        "sxkrHsggbBkh@`oAcc@v\\e`DvoA}UxiEwnBxy@cbBcp@",
        "grurHmgofBmb@j{AqbAjoDsJvmC",
        "{dyrH}kbfBz`AzhDdvAS|{DggEhqBafAbdCom@`xBk|@dlA}sBdx@mwCboAupB`oB{`AxvCaHbdAkpAhqAiKht@`g@",
        "oenrH_vsgBSztAcZboAemAhpCyYncA_rB`aS",
        "g}urHcxsfB~ItoC",
        "_ubrHw_lhBmZpsCcxAf{Esi@j|@iu@nd@uoAve@{bAhTmPqLeM~gA",
        "u~nrHqtygBdXp}D",
        "kxvpH{_udBovAheGq~B`vEk{AxlBemAxy@ctE`fAguBxbAs}Bf|D_{AlnAymAlyAkxD|}CcpAvxAi}@ziCg`AluGs}AbnBqu@bO{w@eDcy@pCcy@zj@}Jlz@",
        "cgmrH}gubB?z{GdN~gAzWpk@lEzl@",
        "{avqH_t|hBkg@hrAi_Afj@cnAhKkpAwFyNj[cQzX_T|TqVlPu\\}qBgb@d`C",
        "ozbrH_euhBnDfdH",
        "goxpHg}ujBm[p`BavFpnHql@|K}}@{l@iUmcAmFulH_i@seDkeBeiGkeAq}Bs}Ayy@urBp`B}h@z`A_~@dMex@gK{sBybAwRgMuQoCyOfBeMnNobB~qB_Tza@eX|hB",
        "edbrH_h~jBxOtg@ri@bO~q@za@lcDjxDdw@fjBdWtoC",
        "smsqHwekiByCp`@qLt^isBby@ueAhgC",
        "_{yqHabciBvEdiCjqBzbA",
        "}`wqH_wmjBg~@vmP",
        "e`yqHgh|iBlPxhHvmClvDzLh_@nC|_@",
        "gsmqHo}xfBmQpjA}~@paAwd@`\\oOld@]vzA",
        "y|qqHcqofB`PlPrjAg@|UlNpAfw@",
        "sfnqHgylfBoYrrB",
        "caoqHseifBh@zu@f`@|iAt{A~fBr`@xy@lJ~dAlK|jA",
        "khiqHao{eBoDh|B",
        "{miqHwqweBrJ`{BdlAdkCdlBjoBrsAxbAldAfkAp_AziC|gDn_E|Jx|F",
        "go~oHijblB_^hbFubG`tKu}@jeAqiAbp@elAza@cdAri@it@bdAyd@vy@yb@jRga@_S__@cy@oCsAyCg@yDf@eErA}JxvAgu@|hDeM~pA",
        "ktypHat{jB~HpaAtR|s@lFh~@",
        "yrroHyvsnBq`A~zBii@za@{_Bfj@ga@nYob@hiAwRrqCiTrhAmlB~cE}`@~}Awo@dnKw{@jpAirBug@wxC|kJgMrwAwOzfB",
        "iwmpHib{lBnlCwZ`H}_@",
        "yjipHwp~lB^st@fj@}j@j}@}IlZr^`f@njEzCryF`RtpB|hB`wDpk@lbF",
        "w`ipH__}lBaIwp@",
        "ampoHgvxoBudDloMov@rpF",
        "gjwoHetboB~R|zF",
        "gvvoHye{nBpB_J`FkGtIcFnaB`nDrJlyA",
        "gvvoHgxznB?qL",
        "u}cnH}vhqBu]xmA}|AtyBij@lpAmPbxA_Jn_Ewd@hrA{m@jf@ytDt}@kcEfrC}|DpkBsfDpAy_CyjDyx@~dDqkAbZ}~AoNkpBve@ec@j{A",
        "cssoHu}dpBvdBbuFHhpC",
        "c~dmHoj}qBigBmYe`C`QoiGxxAow@vZelBrhAa{@`\\avE~h@yo@zXel@r|A",
        "}henHcuqqB|Ip`BnZn`BxCbzA"
      ]
    },
    {
      "left": "KGZ",
      "right": "TJK",
      "kind": "International boundary (verify)",
      "lines": [
        "y`rtFodbpLxvCo_ClwC~fBdvB|pE`q@b_E",
        "{e}sFczgkLg`@hfCs_MbzZwP|yE",
        "oyltFw|`jL~aT`~kArJ~fB",
        "igctF}jvoLox@tlI",
        "y`etFg}koLrUhrA`\\fj@bm@tpB",
        "__btF_mdoLiHdCoN~SiJ~]",
        "ccctFytboLpB|a@xMhT`g@ve@f~CdsF~f@ftAjfBdnKdwBtdDd_Dj\\n_EwFjwErt@jpB~rAduAnkBv{@~{Bnd@teCvEnhGv[|gApv@~h@zhCjr@fu@pu@",
        "ycprFuadmLyc@~eCiqAnn@{kBwP{sBoy@qvAapAss@q~Aah@kfB}t@obB{iCuzAwmBh~@{kA|pCyd@tzCox@jpNaoAjmFsTf{Eql@loBsrAbcB{uAxlAgkAnxA_t@fhCuGtnC",
        "ku}sF{pqkLnNvuH",
        "{jwsFuupgLkGxaBa]`g@s~Az`A}Jjq@",
        "{|{sFqvhgLlZl[zjBnYvg@`Q~oCz_CbmClcBz~Ctg@heEkq@bd@qWle@qL~g@eD|i@dDziEuoCtqAcFtcDjxQ",
        "weorFovrfL}jKjkH}|CbwDqLpuA",
        "e}`sFm{`fLdL|Ule@r@t}@lZjlEbwBrzSz|G~nFvdA`vFhSrqB{j@~qA_}AtgAylBhsAowA~eBom@fuBsUvgV~]nuCowA",
        "{dypFcankL`|@a{@fsBk[riBi@l_FnaAzvAiIh^{jB",
        "wrkpFwv`kLoYkfBa{@is@kaHamDex@s_B",
        "uvwpFe}csLdbBgpEfeA{fBhD{Ft|AmyAlcBod@h|Ar`@zsDz}Cf`B~s@txEy`CtzAabGhJ}mH",
        "{sdpF}zzqLcf@obA_pDifEir@evAwyAwwEm[ol@weA}tAqWgj@wOa|@{WspDemAwvEaHkqB",
        "orupFuadmLbZ{tA|~AykCxc@ymAjGelB",
        "}topF}|qlLuRce@ga@_^}_@ce@yOa{@mOkfBcz@eiEiI{jB",
        "ekqpFuexmL~IylBbxAyvClbCquA~iHsyB|CaA^IH?hi@ebAbo@gqC|j@c{@ftAob@duAzMjrAvZnlAfBp_C_~AdkAidDzX}|D",
        "gjppFk`qmL}_@idF",
        "e`qpF{hfhLfVy~F|~@wuFhrB_dGdx@{qF",
        "axgpFax`gLqLqtBi^iqBkq@siBokCgpE}`@qkBmYo_P",
        "kzppF{{ilLxDg_At]eaC\\s}@",
        "iqepFqnrkLuScnBy{HmlPqVwoA",
        "afppFgwnjL^}gC|U{~Br}AspEv[adB",
        "gqhpFgvbjLg_@is@{jBo`BihA}hBk^g`C",
        "odlpFgejfLjQ{a@lxBmvCfa@q`C",
        "u{dpFef~eLylAcuFql@we@wo@oNkg@sUiSa{@",
        "aikpFmztiLhTo~FnaAi{D",
        "o|hpFiweiLqkAcbN",
        "kxgpFmn|fLHshC",
        "mvfpFcatfL}`@ilG",
        "{ifpF{imqLht@{bJTelA",
        "eimoFcvepLmnA}gEokDiqBckEa{AmlD{_CsgBamE}u@ubGsJyhG",
        "in{oFozt_Mvo@o~PleA_pD",
        "efeoFekk}L}J}eE{hDkyR_s@qcJ}~@gj@{vAqL{_Byn@aqAcxCcbCwiTmO}{E",
        "g|yoFwtwtLbdAyaBvmCew@n`DeOr|BfVr|AvfAfaA|rAxlA|~@p_C|Kh{Bom@xbBazAxbAkqBl\\cwB",
        "uqvoFm|_tL_gBg{RqAa{B",
        "ikroF}hwoLlp@igCdkAayCnc@yiD",
        "ulnoFctooL{Mkq@ccAqkAsj@{tB",
        "ysnoFq|moLbFqv@",
        "ayjoFih}nLkSyjDuqAg}DwPgjA}@}}A",
        "sfmoF{gizLpCsgBxiF_bc@",
        "sjfoFo}}yL}a@keAgsBovBgj@}~@qXqkB",
        "aqioF{zryL~Sg}AxnAi}Cr@aeB",
        "ukcoFqlgyLsKaeBo`DwbEgVocA",
        "arhoFqu~|LbQ{kAth@ylB`o@}yE",
        "}bdoFsuo|L{Cs|Ag}ByqH_KonA",
        "kfhoFefwvLz_AgjBrgCwdAp}Cod@bcCiI~|Aew@fj@{`Cpa@ilGfW_t@vy@s~Aht@maCve@kRho@Uzz@wOpeByy@dfAc~@r@m@",
        "sytnFet`uLuSucFekA_cFqpIqhRsi@ghBmd@ehFu{A_zEqLiqB",
        "kggoFm`|{LjFe`Cr`AeeKlZylB",
        "gweoFosp{LgB}}A{k@_mG",
        "}xdoF{u}xL`h@mlEdCghB",
        "wcenFsezwLeCafAisLc`GqoIwmCi~AqjAi^cnBeMggCa{AehFgBelB"
      ]
    },
    {
      "left": "ALB",
      "right": "GRC",
      "kind": "International boundary (verify)",
      "lines": [
        "eg}uFqjs~BapAuzC}_Aa{@_^uScc@aQqlAnCov@md@gb@qaAwOwoA__Asi@ob@ox@eXox@qb@si@}}@}_@yo@uH_s@qA_gA_JkxEqaAsqB}TwyBjGelBtg@yvA~~@wxC~dDq_CfqDym@dZkq@fKen@fVce@j|@{_B{jBwcCce@cgH~I",
        "iu_vFipj~B~r@wmCbYojC",
        "ygpsFqfm|BsJszC}tAyiFyw@kzCqW{l@sj@mYcjEu|Am[aH}rBv\\s^|@cdArSme@eBga@a\\sTk{A_Tga@gtCwdAe_Ci@_|B|KmmCm[w{@ap@mc@{bAeZmcAq`@cp@qa@cQawDy_B{`BocAur@wZelAiTg`AdBeiDbZyy@iI}j@qv@qVy`C{Vqv@__A_r@wz@qWss@s`@si@irAqAifD",
        "smqsFe{b|Bxd@kjI",
        "akosFig|{Bsj@caB}UwpB",
        "y}osF}wu{BvQknE",
        "yjyqFoyi{BquAqkBu{Bkq@okBdXqnJb_HkpBpsCmd@h_@ozJr|Awo@t^mQsjAmF_wHyOifBaoBoYanBis@{aBafAqiAirAkh@{uB",
        "kv}qFqqyzBlF_}@hAyF`dAchFjr@mmBjHqiB",
        "ctaqFuhqzB}gCwQmeAi}A_s@gsBapA}tAybAuQ}_@tQyZr`@qu@zVwQ~Igk@zl@uSnNiRcF}iAkf@i_@uHcp@rSmYxc@qXnNym@{j@oOks@",
        "wdiqFmkdyBfu@ipE~|@uwFfsBy}Gj{BgqDpl@g~B",
        "ksgqFmfayBkp@_dB",
        "g{bqFo{mzBfLiu@zX{u@",
        "ir|pFweezBaR{aB}_@}Tql@pAco@aF_i@cp@gLkq@?}s@"
      ]
    },
    {
      "left": "UZB",
      "right": "KGZ",
      "kind": "International boundary (verify)",
      "lines": [
        "ouksFyvlqLeDdn@iJpWeMhTwoBj}IqtArhDkfBziByiDfuAmwCrgB{bAnlC",
        "_ibtFozkpLjqAjcEvaExjBbmBnc@tfBxEvcBga@tcGkyCbmAafAr`@_qAlZueDfk@_gAbuDm[hbIbjG|}CkIt]ymA",
        "m~jrFmk`qL_|@{fHqB}pE{WquA}jAoaAm_EiKwbFdrGm`DpMqkAwdBkzCk`H{`B_i@cy@xn@iJxmA",
        "uxnsFk{uqL~_@n~CnM|_@|i@bdAvG~]",
        "ywprF_bvpLnC{uBrt@a]xcAeN~r@_hAlEi{A",
        "cflrF{mnpL_i@owAg`A{tAme@wdA"
      ]
    },
    {
      "left": "ZMB",
      "right": "MWI",
      "kind": "International boundary (verify)",
      "lines": [
        "ta|x@kb`hEwp@t{@ssAv\\}kJpL",
        "~kxy@{ilhEcZtqA}hDfkA{aMmmBoiDpA{Xpv@irAlyAeX|h@",
        "dszx@{zdhEfBtgAh]th@|Kbe@",
        "v}}`AqaakEyc@aqAwnBupBmP}}AolA{~BokBycAizFwdBepIgoHgu@irAob@coAanDysFevA{_ByvCueB{WdA_V`Ai|@lDupBfk@acD\\_UfiDylBp_BiwG`yBst@xn@wxCjmD_hA~s@s`K`cDytCrUo|Imf@_dEpMmdBlxA{tA`{BevCfsBew@baDk{A`pBmmB`eBomBbbCc_Fh}NiqB|rAo`D{Bs|C}_@efHqtB{{GkxDwbCqk@mmD`g@wuFdaBmo@tg@_sAffF_g@dkA}`A|iAqjArt@{hDlyA_hAncAs~Ar{CowAbz@k{AvOwy@iSkq@i_@ebAmP}}AjHkrAvZ}{CbyAevA~{BmPdpIcdAtoC",
        "zvoy@oo_iEbaDdc@vwDrShqB|u@",
        "`d~y@w_|hEwp@fiCkz@|_@sjAdMoaAdXu^xcA",
        "biuy@khshEtShsAbn@bdA`^`dA",
        "pp|`AsrwjE`g@_nEbD}~A",
        "|diaAwuajEqv@a{AunDgtBg`AekAm[ssAk]s|Cea@{uA{MguA",
        "pqhaAih}iElPe`A|@gkA",
        "lopaAob{iEga@jp@yxAoDylBev@_Soy@",
        "davdAkb`jEgtAus@aoAg@woAfK{vAiIq`@m[wg@s~Aa\\{a@ae@kGmeArTug@kH_ySsuLanD{tAuyDgu@eyIfgEshCdjC}{CrrBclDbyA_{Dt{@wvDxQ}{DhR_dEbn@gkAlyA",
        "bcpaAsf`jEhK|tA?dmA",
        "~_rdAec{iEd`Ce~C",
        "dhteAg_}iES~fBce@rgBmo@tSmaEwzA}sBug@ykAaFisO`\\owAyy@",
        "bdijAylwjEqjArzEkxDxwBkrLlmBckEdmA}tAhgAkdDvnDkdBbn@sqE`HinEsUazPytFa~Hmy@obB{b@q`B}ScxAnW}gCleAccBRwjFuqAucFiTmv^`fAwcBxc@_~ArsAmP`eB",
        "rzseAam`jEpLxlB",
        "dogjAqmmkE_sAdsF",
        "d{djAkyekE|gCpkM",
        "dwokAwlljE_^giCowAwmCs}Bg_C_oCy`B__AafA{iAs|DiiAev@wxCeDom@m[yO}}AifBel@g`BkbDyNqYwcBew@g~BtHoYtfA",
        "|kgjAevpkEfBrgB",
        "fcmkAy{djExDemAt\\u{@h_@is@bOwp@",
        "r|_lA{cliEsA}~@_^w\\si@sSyc@od@uSs^qUyZsUae@aS_~@kz@qvAouE}fBaoAwfAiTkq@cZ_eD",
        "juxkAsqwhEtHij@da@q`@bp@oYtg@}j@",
        "|lzqA}usfEiKymAykCqgDis@urAs`@geFov@mpAolCwZupBzBeaBqLybAis@mP_rB_|AspDunFwnB{lIorAk`JiwAqrFaqBc`EizCst@_{DevAq`@kgAjRunCbcB}hBlo@ugBdYokBjFyrTo`Bw|JejDwlDa\\yvCht@{iCjxC_gBrgDybAtg@uiMxc@clB_U{hD}rAmhIm`F_uJ{~DssA{`A{kAowAiT_r@",
        "hwxkAwweiEbOwz@fj@sj@fiCgiAt^oY",
        "`{|kA}d|hEeXgu@en@yw@k[wp@{X{aBcDcn@",
        "v}xqA{gmfEjGyxAxe@gsB",
        "|g`tAumahE_i@tr@eaBbe@_|ApL_~AzW_uJ~uHcmA`{AcdAn~Dgl@reFymAfsDqgDnb@wdAebAsiBsdFybAit@}iAza@yeI`lFwfAjdD}@hdF{j@tdEieErhA{`CcZmo@a{@",
        "taptA}{siEi|BriB{dJlaEigAbxA",
        "dv~sAwugiEza@r}@f}C`{@fu@pw@~|@twEfl@fvA~{ArsA`uHjbEnYrqB",
        "jfwtA}glhEmvD~pC_~Ah_@ezH}Tqb@sJ}_@pA}s@nb@eXjq@",
        "bb`tAw~dhExD`pB"
      ]
    },
    {
      "left": "SVK",
      "right": "UKR",
      "kind": "International boundary (verify)",
      "lines": [
        "_amfHgyafCgaMyDudBcdAeaB}Tg|F~gAs}B}KudBu|AezEgwKol@we@sbBg`A}j@cn@{a@{kAgb@ueDs_@qjAyvAccBssBekAwcCag@_eCvFurAkR_h@yn@u]wy@ur@iu@ufAgj@ii@eM{rEpL_r@fKyo@oCekAkh@gJ{J}k@qn@urAytC{v@yy@ae@gKwoARu]wFcnBolAgeGufC{w@ylBgVgoFgu@}_BshBrA_oCa\\ymCgl@_fByn@"
      ]
    },
    {
      "left": "MOZ",
      "right": "MWI",
      "kind": "International boundary (verify)",
      "lines": [
        "x~`hAgodrEtgBotDd~D{tAjwEjz@h|Bp_C",
        "jmbhAao}qEqm@e_F",
        "j|thAu~frE{Bh}AkpAdmAwnB`oAkxDteDsgBdMccB_{B"
      ]
    },
    {
      "left": "GIN",
      "right": "SLE",
      "kind": "International boundary (verify)",
      "lines": [
        "aj_|@duxcAhOs}Ct}@qrEpFouAvz@cdAziCql@~zK}sAbhAem@dbHmoM~rFm_GltGuxEbxGqsCjsEihArz@ce@rT{a@bd@wdBb_@ug@xo@cZvbD_i@d|@em@|lBe_Dz|@w{@nr@}TzjD__@|x@qk@j]}_Ajg@mn@xwAvEnzC|`@xmBoYx|AccAzdB_|Ax}@{`Bfb@iK~l@zaAvu@`{@nXolAzCmmB",
        "_ug{@ljbiAoi@cdEi|Fgvc@_y@si@m|Jk]qMs`rAgFgmh@",
        "}hr{@rx|iAjDuoCxgAmoBfdBypBryAmsC|i@qtBlU_fBnCgiB",
        "mxkz@vkmkA_NkR_^pA}dArVwQzBynMitAu`ATii@zFwe@eCuw@md@oaC_`FeeBkzG{dEaj\\",
        "g}kz@`lnkAxCi_@",
        "q_ry@zy~kA{Bgq@au@iXugGsFuRqQcqDaeBox@ix@gtBcaEuBkSwVaGkkAb@k]gKI_^",
        "_gry@vv`lAlF{{@",
        "qkix@j}slAgf@kWwd@eOmVySec@gj@gf@w[}dT_tEi^i@g[fKyX_C}U_o@uIob@sIaSsOkLi[oO}kEqu@ys@k\\iTyx@",
        "ukjx@tvvlAnCyYdTy^lEu]",
        "sesw@nbnmAuTqbCkuAkgBstFetCwu@kkB{VauA_o@uBow@~Wqp@l@w`Aeq@_^qb@}y@ghB",
        "guhx@dm{`A`Gk|@",
        "omhx@pu|`AwFkg@",
        "{mhx@fmw`AfLcy@hmB}iAv`AqiAjv@krAj]g`AleFmiG~lAaGfdAzVhdAdc@hmAv[rt@S|hBeXxx@`GxgAvp@zg@daA~]`eAxi@`|@`bElnBxlGbcA|aFqk@rbAm_F",
        "emhx@xoy`AUqaA",
        "g{tw@hw}mAl|BwxB",
        "e|dv@`tcoAoNs}AwhCq|D}rBcpFofAkpBygBatAacEqqAazAor@ctAg{@aQob@kH_aBcFyUor@rEogBvtAy}@rZqrDw[y_E_bBqzAsaC",
        "answ@tzqmAlGewB",
        "y}pw@p}ymAyfAygCmGayB",
        "mxkv@`rroAfVoaB|rCalF`p@mmC",
        "i|dv@zzdpA}iBgsCcsAmpGa\\cbD",
        "ejkv@xxb`AnXkwFdh@_qCj{@iiAng@gEfd@wDfOoAbqJ|~AzwEt\\ffM_Jn}@iIroD{w@rZq@faAvEvUgBxXiT`\\{k@tNmPxpIc_G~bAi}A`{@ga@vcJakGzdCvo@vxBhtAfpAptBhJ`oCzWp}BrbBdwBlcCbbBbuDxbBryAf_BtjApj@zqApMbiASlp@lPpGnbAb{ObyAhvC~zAbdCtpBtqEvnCnjEf_ArmBs|B",
        "eakv@d{j`A_HkaG",
        "e~zr@zjc~@fB_i@dr@{iD`[aq@lPgt@",
        "u~tq@b~o_Akl@kqBknCgzEoeJepJw_BqkA{pHcvCatAw{@ubA_hAqq@ymAob@}|AyYg}D",
        "gzwr@tny}@sHufA",
        "}qzq@r~``A~IumE`f@u{AtqB}qDnMeaA",
        "_dnq@zxk`AspEql@yaCkzBox@ipD"
      ]
    },
    {
      "left": "SLE",
      "right": "LBR",
      "kind": "International boundary (verify)",
      "lines": [
        "kmfi@dm`eAyyAceEu[mo@i}CfL}hBeYe`BejDueBwz@quBwe@i|A{L_}BrUsh@aSeNggCyOqm@}`@g`@qu@qKomArS_oCnwAg`AnOqVkR_gBapBorIuxE}TgiBgfFoaOuq@}t@weOquKwmCynBqyUs~[wmCm~Fqu@wlFqb@_rAgu@mdAcoAcaAer^_aYsgEklFe~C{eHoNql@_UknC{en@nNihAaHmy@oXam@ew@_vAi}Cy}@oaA}jG_pC{pBa{AegA}qC{Q_|BqAewNwPe_Cce@wyBsdAcxBqsCwxCwrBmPk{Bbp@koDnl@ykCqK{lFcmBg}Ve_E}aIeC"
      ]
    },
    {
      "left": "SDN",
      "right": "CAF",
      "kind": "International boundary (verify)",
      "lines": [
        "ussaAs`pjCxiDqLf`g@oxZ~bMehShca@gob@j}r@_o_@j}r@_o_@jvGy`Cpv`@yuDnnF~]vwDrsAj_JffFtsDnlAhcA{BzyCu{@dqA}KpaElGbz@mP~mAen@",
        "ezqx@qegoCdMyc@pq@ga@nh@gB`eNh{C|mBlGz~D}~@fzAaHpiApv@r~@tqA`lHppFvhC|gCjk@jgAlPvcB",
        "gxqx@aweoC}@om@",
        "_a_w@gbqnCkGdiE",
        "ki_w@axjnCrd@|}A|hBnfAhn@z^dzWphClwCcOf~BaqAl~AseD",
        "_h|u@adunCdDylBbfC{l@pxEtHlbJzkAbkD|hBp_Hv`GxaD~pAduCfBffDur@rgC}}Axx@}~B",
        "extu@_qhnCqLejDgaF{fF",
        "m{ht@st_oC~J}hBnh@eaBf`Au|Ab_@kpA",
        "iobt@yzqnCsSk{A}nBgrCso@evA}U_rB",
        "ipft@obhpCrxAijK",
        "orbt@}`xoCk]mdB}xAkcEoDwvE",
        "azdt@ii_qCteBuwFxPewB",
        "uvct@ymtpCkb@ozI",
        "whdt@axqoCfu@{gE",
        "qddt@yokoCeCggE",
        "__bt@ckpqCvjBmkS",
        "qaat@ezjqCm\\}oD",
        "gs~s@qwdrCao@__J"
      ]
    },
    {
      "left": "SDS",
      "right": "CAF",
      "kind": "International boundary (verify)",
      "lines": [
        "}p`t@m_yrClz@apB|wAdM`dD~qBhxAzVtvAqk@vcC{hD`kA_^`z@ri@~eDf|F|cAr}@vgQb}IjsE|iArjEpUxuDi|@h|CkeCb}BghDfyAueD|d@yaB`q@kwEhCke@hKonB",
        "ic`t@qworCsGk~@_DogF",
        "ionq@kubtCbmCqsCtv@eX`h@q`@rYgl@dMk|@|xB_dElE}eE",
        "yniq@qjosCaiCarKmUwvE",
        "ypmq@{ehsCxEel@fWen@dpAifBvP_`@",
        "ypmq@mkesC?myA",
        "e|cq@{qfuCl_Ac}Ih@ayBnM}|BdlBieE~g@whJ|yAsfEzjNwwOlcBk|@||EgMpbC{~BlnB}Kdm@ea@~g@_i@fb@cp@`\\st@fmIikHbmCuyD`eA}|D",
        "gwaq@g{xtC}cAsuL",
        "uodo@qynxCdXwxCj[{l@be@_^pa@ce@~r@g}CxlAcoAz`Bu{@tdE}~@heDa|A|hBq`@lzAoC~kGzVj|A{VzuAec@j{AwQnlBxZ`yBbkCnjCx{Kh}B`dCnmAzB`dByZhwHudCbbEasJzv@krAri@kf@bbBa{@hi@yc@lZcp@h_@sgB`]ug@lxAwp@zrDag@xyAq`@`zAybAbz@uqAvlDw}IvwDqrFfjAwaD",
        "s_co@whcxCmDquAii@w`EIowA",
        "}mkk@cpszCvPueBxx@_|An~F_xGrt@yaBbbB_`Kdn@}sBbwByvCzLkq@",
        "qdjk@gxozCkh@{vB",
        "{vvj@ei_|CxY_}@dbByaBlPcdAvEuzCtr@q`@~qAUbdByw@h_@u|AlY_xGxo@sgBjp@oYftByMnx@c\\vmB_dEnOi~@lQi|BnXs}@|j@ec@ln@gBlf@wOhS_hArU_xGblCwe@|bI_UdlCa{@tQi_@",
        "}tvj@wo{{C}@mxB",
        "cnbi@msb~CnWwZ|`@dBle@hKbe@sA`oAyXveAiIrcAsUbjA}~@tuAykCp\\apB|j@yaBjqFmaEnpDo}FhlBugBrlBavE|gCopJpiDulH`hCqFjgAaCj}@dn@j|DjdBjgGheEvzFxwBdm@rt@l`@r}@ri@xy@dhAri@ze@euBf{AuHjtBza@voBdM~_Csi@ry@cdA`f@i}ArcAmxBldBkfBreEouCfjAqtBfv@ubGjfAyaBn`DuSztC}@|d@cy@",
        "i_bi@e__~CoCkf@iIug@?ec@",
        "uy~d@{wr`DnWaeB`aBaqAdvBeBbrBvy@lsAjfBn~@tpB~vAjzB`jB`eBlxBvp@pcC_U",
        "ou~d@y|o`DeCazA",
        "}jgd@qas`D|^cnBfjBcdAneC_r@loB_}@~kAq`Bl}BgmJzX{gE",
        "y_ad@ebh`Dm[yaBumDq{F",
        "extc@ky~aDlmDu|LdfAuoBdrA{aA~vGec@|mBkq@v_AkpC",
        "octc@o_qaDuS{xL",
        "sw}b@{kacDdMgkAxlCkz@jkBonA`FcbC",
        "ug|b@qrybDsIuoCid@sgB",
        "_kwb@uvtcDxfAebAtpD_hArwAsrBb~Acn@t\\wg@h@cy@",
        "ehub@cflcDyaAqoG",
        "cbjb@usfdDrbB{eGxg@ew@zfBqk@taAgBnm@k]zg@s{Bpk@owApoAsiAv`Bss@z_BaRjw@}Anc@gL`[k\\xgA{jBh`@eDxg@nNfkBtHvyAb[bi@eCfz@od@nE}_@",
        "wzhb@ohadDcd@upBgAox@",
        "yhca@_xheDzg@a{@~s@oWbmBpLt{@sJrjTx|F`_B|KtlA}Kd~Cuq@hsH}`@h}AyX~hKueD|wDueBp}Cq~BboFqdJfnCoiD|tFaeBnaCotDpoAi~@",
        "guaa@i|ceDuMk\\oDqVwF_UwRea@{Bqm@"
      ]
    },
    {
      "left": "SDS",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "ak}]csnfD|oA_JzuG~h@n_@ga@`[wd@|Uuh@fQ}j@`tCkbEz{@it@|y@}UzdCcYn}@s`@z{AkoB`k@_}B|z@sfPpeAcnBjsC_qAzaGcp@tfBwe@j`A_qA",
        "odg\\s}ghDl`@yy@r~@is@ffAkh@hx@oWhfCgVhkJjq@f`GiKptCwZpdBel@NyZh_@axCbOcp@rs@}~@lyBupBhi@ufAtCyo@",
        "o`f\\c~`hD?qm@k`@wwBsAew@",
        "gpo[wj{rDlWkeCvOeXb_Aq_A~Ra]",
        "kdwYeewqDiUkfBqtCk{A_tC}~@mzA_}@isGa`IoqBolAg}Bur@apCag@_aAih@ukBqtB_dAsJ}~@xDykBkRkyEoN_mAis@sOu|A",
        "khm[{pgsDxSafAvoAi|DlB}zDnMshArxB_dGzq@igAn_D{sD|t@wyAdHon@",
        "}rk[}hcsDgo@e`BeDwe@",
        "mh~ZcrptDnOkh@`uAamChYi~@jl@qjApaAhTpd@f^ra@x[h}@ld@vu@cDjfBij@nv@uHl_AlGtzDnv@fpGpBbeFugAvhC{gD",
        "wd}ZggltDub@{iC",
        "kq{Zu|miDhJs^~bA__AjG}h@",
        "ilwZswiiD{Bce@sYyMk]}BqMcDuG~IqRoYk\\qv@",
        "acyZultiDjm@_aIrcAaR~jB~]xlC~RzaAeCnr@iIpp@mQbz@i]poG{~D",
        "uyxZgfriDkHmeA",
        "e~xZmkeiDbDga@vk@}hB",
        "{cxZ{x_iDiYqqD",
        "mmxZmhonDhY}tAhxBmyAxjCaHhxBi]l_Ag}C",
        "sttYiyfmD}O{w@uw@qj@agAeNscA}V_n@giA{{@w`Gu{@s|A{_Ci}AirNabGwGqv@?{~Bcj@gtAss@iu@g\\qt@",
        "qbmZ{j|oD~s@cp@tgEslHl[ybAhxAmP",
        "eviZwfloD{L}gCo}AezJ",
        "mnjZg~boDfWogH",
        "gtiZm~znDSg`AqXq}D",
        "wybZumljDlFcdBzq@ih@|wBeXv{EcmDxrBsrBvsA{tBl_@cuF",
        "sb~Y{mejDyDu}@cmBifBeb@yx@",
        "qvaZ_qjpDfjB_wF~q@meAhqK}lKhcAmlC",
        "coaZ{~ipDmFcQ",
        "e_xYohsqDxYu{B",
        "uanYyjeqDsUi|CccBem@wtBaQyhAmeAeBuxC",
        "akuYmdamDpBmz@pKw{@hEu{@",
        "s_bYkgflDyNolCepAadComBsrBqzHsoFs}@ayAw`@ekC",
        "o`qYw}vkDtyCqqE|bCgw@tvAiSfz@_s@hn@ouC",
        "w`oYacfkDcs@orGsJefG",
        "oapYidguDhSqhCv{Ae`Dj_CsgC|}Ba|@r}@jSd}@bn@jaAbe@`kAyD|y@aq@zMq`A",
        "g~oYye~tDgBo}G",
        "m|yXqlyuDrK_iAtvA}pCrrBg_BdwGuoCjdCu|Abz@_|Alt@seG~mAanCzyBq_AjoCga@`oCew@|pDouCfdAwg@~bAeM`aASh~@kI|y@el@tb@kfBxDsuKxeCqaL`lHmyNtjAwkFjHqv@fB}|B",
        "a|yXqdwuDK_gA",
        "y_sVaagyDtSw{@laDgtAvs[{tCbyBzBjrFzl@xkAza@|e@xc@~]rAns@g`AtR}u@|@}_A",
        "{~qVugayDkHa{@yOu}@wEs}@",
        "}vlUkgtzDdqAupBt|@eXhuEkRn|Asi@z|@mpAtkAkaE|mBmyAhaIr}@taCgiA",
        "ujdUmxizDciAadCazBigBafAq`B",
        "ikdUuidzDRwmD",
        "qi~T_fryDoNuzBuRcmA{kBadEug@ekB_HsgA"
      ]
    },
    { "left": "DJI", "right": "SOL", "kind": "International boundary (verify)", "lines": ["mecbAgp~dGa{nA{wr@ssNmcI"] },
    {
      "left": "ETH",
      "right": "DJI",
      "kind": "International boundary (verify)",
      "lines": [
        "mvuaAo|}~FwFfu@_^ld@}c@dO__@hTsrChaVqy@tzC{y@pl@ai@p_@_qDkoB}iGkf@cqd@{MkfTzkAmmUn`DatInC{uPwwDyxM}tAseEyaBu|@k{A}hBmtFaoA_}@cxA{a@{c@_t@}SmeAah@evAq`AquAycAcdAcmIinF_pUmcO{lMq{FsiAcdAafAgrCelAwp@ubF}}Ae|a@u_YqwKq}DapNqwJ",
        "ae_bA_utdGqL`qA{j@jyC_YjaGk]njC_wA|hBmsIr|Cmk@bwByDftCyfBbzL",
        "k}tbAsjbcGpBtm@jQboF|gDrqPzlGh~Kx}@jeC",
        "yqdbAosvaG{Ch}As_@z_BqUnlC",
        "{mfbAyflaGbcAbkEdDrt@",
        "qddbAaedaG{BvnB",
        "mhdbAiu`aGlDpt@zaBz}E~SrsA",
        "mecbAgp~dGw`@p`B",
        "egdbAun{dGbt@t}@vjAr}@f`@j{A",
        "ck`bAglu`Gi@duBygA``I",
        "gubbA_ug`Gbd@hwIvu@|fDbaEv`Evi@nkDpM~`JbPri@b^l[fV|_@"
      ]
    },
    {
      "left": "TZA",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "fbdZc_nrDboAkR`wFsUjoOvz@he_@fyJ~oOtzBzjOcPtqN{uBxd@_Hr|N}pEbyZmeN|q^o}Fzsk@e~QblOguBdbNxy@`_JzgEbtRtrMrkKt{B`wFeOpzTg{D`iVkgBntFekApeH_pDlaPkgL`hYgzHlkFmlCtmEudEf{RkgYdpHcwQpiCqoG`tKkgNns_@ya[x_QutJbl^stMbqW}{Eb{K_|@vlQigD~s_Agth@poa@ihMrqP{tC"
      ]
    },
    {
      "left": "ERI",
      "right": "DJI",
      "kind": "International boundary (verify)",
      "lines": [
        "i}~kAi~wdGcE}~@_{Pimi@",
        "o`alAgysdGxEov@j{@qlA",
        "camjAarncGqtBuqAcGm\\gu@idEmwBgtAew@_t@qa@uyDah@cmAggDec@acEby@_yD~Tq{FsoGeqIipCcyAugB",
        "a~lkAcvabG|j@{hDr|By}GjrYgr]",
        "}vakAsftaGasIu`IaRylB"
      ]
    },
    {
      "left": "CZE",
      "right": "AUT",
      "kind": "International boundary (verify)",
      "lines": [
        "afcjHymqzAlmAqzIdYkeNdwA{l@|sAoY|sArAbxAhh@r@_{B",
        "yvrhHy|`zAwFq}BolBwfAiJpLkg@xZmp@bZkf@fKsj@iIymAgl@mfKkcCwkDUg~DzX}pDsAybCgtA{`@xDa\\?_TuHiI_SsJ}gC",
        "av~iH}hf|AzXu^~]yXdM_^fAscHdYojCvcBkkHt|@wtGvq@keChoDwsHvc@knCj~AcsJnsDcdN~TekC",
        "s`uiHehp{AssAw{MqLg_@ocAquA}_@uS}rAoNqXeXIyn@",
        "_khiHspp_BbQcc@zkAgX|^_^~Jsi@xDovB|_@mcAzLom@",
        "m~diHscz~A?_oC_UihBolAe}EuGgu@Kg~D",
        "umbiHmv}_Bzv@~~@",
        "mkbiHab|_BgAks@",
        "cbaiHge~_B|@meAb[om@z`AmE",
        "yu`iHmv{_BiKymA",
        "gt~hHqje`BxY}_@fj@?~]aHhmHosR|}AkjI",
        "eb~hHs`b`BaQ}hB",
        "_j{hHcnycB|Kox@dl@qiBtfAktJ`HsrB~^ovBfjAap@vxAiV~hAel@`e@aqArJmbB",
        "gczhH_crcB}@q_As^apBeDox@",
        "utzhHwnlcBlPgsD",
        "k`lhHm~ybBaReaBii@mcAcfJe|Hyn@okB",
        "alvhHsslyAt\\eeIpvA_bI",
        "opngHsiqxAk_A_`BwQi[oaDu^_~DfBwgDsU}}BeuBe~DygIovBs^khAu}@{jAeXmz@yc@{Vi}A",
        "eushHikisApk@gzF|i@{uBxy@upBfjA}gC`xCocLlf@}u@rhB}fBhr@ag@vRu^rJgj@lPod@`e@cObf@rJxDl[",
        "{xohH}uvaBrtA_iZ",
        "}aohHmtdaB}Uo`Q",
        "ktmhH{hvbBpk@uqAlF{a@",
        "gcmhH}_rbBeCaF}K{`C",
        "{dmhHokbeBrTq~AdbBcaFl[}qB",
        "m~lhHw}zdBmEwlF",
        "{qjhHqh{eBdDweBphC{rCv|KquAheDwvE",
        "sohhHc`peBwHcwBow@ioF",
        "kv}gH_|rtA{Bj]",
        "gz}gHs}qtA~GtQny@~h@tGpb@bQrJftAc\\fa@cZbxA{jB~]is@bz@osEz`AstZhpCckR",
        "{r{gHqzfwAzsBytCpuAkxF~JshA",
        "_~jgHm`kvAoCa{@}Kap@_bA_}B{{A{cIibA{aBsuFckCsh@czA",
        "gjwgHslaxAjVag@|f@wFrh@ShY_SpBoo@",
        "m{tgHksuwA}Lu|Awz@izDcDg_B",
        "qysgHcahxA~Dug@|y@ebAvy@yc@zg@cp@nCueB",
        "mcsgHqaexAcUq~A"
      ]
    },
    {
      "left": "TUR",
      "right": "IRQ",
      "kind": "International boundary (verify)",
      "lines": [
        "{{bcF}pbdGfF}iAx_@gu@tjBcZn^st@|gCwcOv\\}zF",
        "k`oaFw{oaG_YavGy}AydJkgAcyOyb@ccB}`@iT{hD{kAgp[onWgp@}Vgj@wF}j@}Kuq@we@sUug@}bBwsHwBqv@",
        "q`bcFszcfGdWejBn`JktXrKgj@xD_s@",
        "}axbFqcaeG_hAciGm_Bq~CepAsnFst@izFkMmaE",
        "{nxbF_wlgGlK}iA~dBwcDjs@qsAfeBo}Fp}DuaHf`@aeB",
        "mtubFmzcgGwGqv@mn@my@eS}u@aMsrB",
        "_vwbFmuwkGd[_pE`OyuB|fEuyQxgAckCbsAwdB`kB_iAjnCgt@|gCi^~lAyE`|@`GbhAjr@xU~|@rIjfAnd@boAxkBrgBv}Brt@fdCzBd`Com@bfM}zFj`Aug@xc@ew@vt@ubG",
        "aq`bFwokjGyOymAa{AkoBwo@gnIaoD{}D}uEaxDm{CucF{b@syG",
        "{ckbFozthG~HwoAfU_r@~cAkqBnr@g}CnNouC",
        "_bibFobkhGwGcoAcn@kyC_IolA",
        "y~fbFcfziGfKcbD`]gsCda@_}@~gBkeCfW{l@",
        "s{ebFkefiGeb@w_S",
        "{o|aFyqkoGrhAknSpq@i|BtjB{kA",
        "ips`FckhmGyColAql@yy@sgByx@?SI_@S?mdC{_B_aB}TqeAwp@qjC_rOigAucD{`BazC{xCcvCchDy_FcmC{qFqiAggEeCqsB"
      ]
    },
    {
      "left": "AUT",
      "right": "HUN",
      "kind": "International boundary (verify)",
      "lines": [
        "u{_bHuhdfByrAmnNeh@kfMig@q_Ca]`fAsn@|s@_~@~]ckErJs}B~h@ojBlGgeAu|Aqf@tg@ysB`{@{Wbp@yg@bbCc[jf@ccA|@sZcmAm_@mwEsu@ueBc~@_}@{pAec@gnByXmKzKcF|_@qK`^cZlEyPyOsYcy@oIgKst@mPaf@k]we@sAkr@|`Aq{EcgK",
        "u~mbHy{bdBfUgeGrbCssNhd@wmAdw@s`@z`AgVr_Ayn@|o@wdAvZebAnd@a_J",
        "az_bHywlcBgPih@gl@iiA}wAixFqa@_t@yt@ga@kqA~Ik{@od@aeAidF",
        "y|ebHq`zeBvbDazAj\\alF",
        "sr~aHcwoeB{G{u@am@cdA}bCwyBin@uqA",
        "opabHqwicBz]ec@pR_^~Ba\\",
        "mnwaH_crcBy~Ab}Iak@~oBym@{u@_gB}}Ak^{l@",
        "}vtaHqkddBupBlzK",
        "shxaHcpwcBdYblD",
        "{hg`H_crcBioEy~So{BwiFam@}uAwzFdXes@_fA_s@euDwnAoaAg_BcFimAlo@sz@puAkg@|hBaxB{a@i}B|s@cbBdlBii@hgC",
        "ynuaHsyjdBzV`mE",
        "_ck`HwdmcBlf@irAtqA}iA",
        "{p~~GixecB}Tld@efB~T}gCg_BalBtSC?O?ofAmaEgv@owAurAkh@ueBdXymG||DmKxOgFvZkIl[{VlP_d@{BwOcZ_J_^mQqLsnFnNcnAi~@qMemA",
        "e~u~GiikcBwd@~rAqa@}@siBar@{u@|@kg@~h@kBhs@",
        "ws~~GajgcBzAvp@",
        "}rx}GidecBeDi]cPcZS?gL_gBi@yaDoReuBubAvZow@xxAkSbxA_N|qDco@emAulAuvG{]keAea@gXo_@~ToXrhAw[||BoqApm@gzAwg@{v@wbCu_CwmCehAu\\{jAdkAyEteB",
        "icx~Gq|qcBbdAfrE",
        "{w{}GmjlbBb_@ehF",
        "i{_}GwjfaBe_@ccBys@aoAesEwaFir@igAynA}}Cce@oaC{Ugj@ql@_i@}d@gBwa@dDce@cOcd@i~@kH_}@q[kq@y}AcZcdAmz@{FitA",
        "}l{}Gcr{bBdJkcCpv@{jB`Ps`@dEi_@",
        "wwz}GsssbBeTo}F"
      ]
    },
    {
      "left": "CHE",
      "right": "ITA",
      "kind": "International boundary (verify)",
      "lines": [
        "{whwG_ozi@~yEkwGt{@ipClZ{~DqAckEqWs{DmmBs`K{jAunDwRaqAza@qtMap@ggEs{DopJew@ayDsJcbCi}@mcAafAw{@yd@sgBbnB}{Rjf@eaBv{@s|AnvBqtBxNaHjQ{kAuGis@oNen@{Ci|@pkAkkHgAyjDzVwnBh@ec@u\\emA_T{Ms_@dDi_AkReIuFcCs_CyuB_PqyA{bAoq@eyAwdAczL}Ka{@yXqk@weAcmAqLqC_|Au{@sKsJ}pD}_@ceAUufAqLg_Aqk@s`@s}@uHg`CyNybAucDgpGoiEsfCidFlPmvFvwDewA~pCeW|Tus@oY_|@s}@}tAayBgj@afC_i@gnGi}@e`C_xGorH_}@_pD_e@ufAor@_}@ex@od@g~@rAyThh@oYzVinAis@o`BadC__A{hDof@khGiKyqAxTqrDztA{tAdlC{Xr{DgB`sDjTvbIjdBz_DhTlwCqWlcBmcAz`A_rBpl@mbDj{@mkDr}BspD~sKuiKrTw{@`\\wwBfuBkbHzBylBmPqk@wz@{_BsKwe@dGy^`D{Rly@{l@rUyn@tHccBgBy~D|Ui}A~pC}}CrqCj{AnvC|qDtnDxlB`]|VvOhIzCgjBpVq~A`eCoeJ|U_i@tf@ug@xbBk|@teCokBtpAks@vpA{a@dkBiInlAdXhiAld@f_BhVus@mvFr~@wkEpW_{DejDqfEqrEuzCgiB}VufB`fAcYxy@aRhgCgWt{@wy@zw@upBrr@on@dbAyNpLyNpCeOqCoNqLacCklEuxE`nBafAcZguAe_D_]}gCgWmz@my@wp@{kA_SykCpLwoAqWowBsrBctEaeMoCmBc{@ul@_gAa\\_}@{a@}a@ybAoW}iA{m@kgAg~@yw@{~Ea|AygGwuDshCye@koAlGw|E|rAixATymAeOs}@hK{f@hrAosA`{@axCap@ouCqkBqkAovByXgoHvU_{BjlAoC|gBq~CdMen@uQybAod@k]kk@}T}f@si@ir@wcBsFcp@ff@_SlvQod@h~A`H`b@gKr]gl@dt@giCr^ov@l`Fu{BzjAmnAj}@mcCxc@ipCxDkkU}_@qtBwzAs~Agp@qA{eAtHkfAiKct@ybAb@ebAr~@mwC|JcoAg\\y`C{rC__Lo_@qoGhEmxB`Vq_C`fAi{CvdBkh@tzBqA|gCug@|tAwzAxvCwuFfiBi~@blCcD|AwmEmdAofGgkAmmDovB_qAmnB`oAytDv`GwdAxw@us@dXcx@{BssAs^w{@en@kpAcbC_i@el@igCen@mdAzl@_]zjBod@tvGkp@nvDssAdaBo`ComBqXfu@_b@j]kl@zMyx@vFqaAcZghCi@}k@kGov@st@a|A_fCwn@ur@yjE{kAem@cZyUa{@ktBunQ]{_Ddw@mbBpeAiKj_Cfa@xbAwZ`|@w`G~\\cp@n^}_@v[kf@lUmeA`HaoAeMuxEdpAu~L_N_pBaw@_p@wj@ge@{yCup@i`DqCmwBdn@sjAlaCuRdiGmyA~oBovBhs@mz@u\\kk@ybAyhAa{@uwAqLefAxDex@eXsm@}hB_nAsjAauAnN}yApk@_|AtJwoBigCuf@yc@ew@sUghE}_@"
      ]
    },
    {
      "left": "CHE",
      "right": "AUT",
      "kind": "International boundary (verify)",
      "lines": [
        "__{}Gq{d{@oNnYgfAiIo}Fx{c@yIrgB",
        "a_f~G}e|y@vZnfI",
        "ice~Gm~qy@cT|sB",
        "av||Gy{y|@c@ji@iAxuAkz@~lG{v@xkCo|CrpFwrCp{SkpA~yCelAlnAsy@jIkbAaSsqCoNwz@yXyc@?kRzV",
        "ca{}Gibf{@bAve@",
        "ejy}Gsdk~@wM~_@sCza@",
        "q}y}Gw`i~@rCda@ffAptDtzBp|ClnCdlBvsBfB~CtzC",
        "ue`}Giwx~@kdCzMksEqlAmhBr`@ql@pv@srBnsEunCnaCon@p_A]?",
        "ejy}Ggek~@?R",
        "ylk}Gi_u}@yTlxB",
        "sbl}G{eq}@|KjdBrlB~}AbnAt\\rs@dDxn@vOx~@~~@b~ApoGn^n`D"
      ]
    },
    {
      "left": "TUR",
      "right": "IRN",
      "kind": "International boundary (verify)",
      "lines": [
        "a{vqFgadoGjs@g_B~cEqgDpjAqtAjeCutJlnAmxB|zG}zN",
        "qsjoFmjjmGqXqhCiqBsbIecAewBi{BghBapBsA{tB~TojC_^I??_@_iAi}@siA{BkoAhTewAfKueBgK_sAm[_aI_nEmoAed@wV{BwiAgKckEh_@weAyZmdL_wSgb@myC",
        "eqpoFefslG|KotCheD{nLjI{}C",
        "o_noF_cdlGgKaoCmdAcrI",
        "ulnoFcx_lGdL{iC",
        "yadiFavwmGal@hwHq`@`{Au^dx@qu@jQkeBuSux@{Bk}CjRuhAS{zFcnAgjBmFy|Hnx@kvFa\\k`Ci@ofBpk@ug@zl@{Wxn@m[`pBo^bmAge@kR_j@gu@ol@mZwoBh^siA~]wmArJ_|BeXocMqhDmvD`]e{BjjIkkAjdBi}AhtA{jC`{@in@bZ}n@tS_s@gBuw@nC}e@dn@ga@xw@wk@xd@k_BbYii@jRmj@fa@c@?isBowAq`AadBgiAa{@muFxx@cbBu^m|D_{BwxC~q@gdC|oFupBluGk_Bn`D}t@`FkpBgj@gv@dD{zBpjAgt@hT{v@pAkh@oNom@g@uzBrhAwcCxc@ez@fZoAd@ouC`cDqjAbe@sjAydAu|@g~BmYs|A}@q`B",
        "wscfFgmbmG}ZtxEsgCnlBon@gQgUqGc_Aq_A_bA}u@inAdD_wAh^snAiJakAae@goA_t@I?USC?yxAyx@efC{uCw~A{u@cbCur@mnAcy@kr@aqAem@mwBaf@qa@qtBtq@mu@uGkb@ur@cd@cnBap@om@mzAug@wyBme@mxBsTujHxYi|CaoDejCaaFg~CekCmbBrAeaBvn@osAzkAgz@nwAu\\p`B",
        "emgiFqs`nGfLlnAb}A`mE",
        "giweFsfanGsKbo@{eAvdA_lApb@kgAfVex@xc@ae@nbA}tAl_FaQ|iA",
        "kydfFgbomGrd@~sK",
        "ohoeFsvhnGgFzvA{eAzl@od@eCybB{Wi^nCa\\dn@",
        "i|weFgzcnGxEtg@fK|i@",
        "y|bcFi~qoGis@xy@sqDzvAcy@d_BiPpgFge@~rAkeBve@eyDirAohBdX]?q~Bf`@azC}JkyCug@s|B{w@wiBpWysAxkC{oBr|Bk|DmZ}u@ur@qiCkwEqpA}~@my@dMu}ErdFkjB~zCo~@vmD",
        "}wqeFktsnGnNdiDzb@lnA`[bcB",
        "_huaFkkfpGywBwe@shBve@qiBxy@y|B~R{nBqj@ys@{lAgg@euAekAkhAkiEkR}bCnlCgwDxfJmsAhs@owAxc@{w@xw@",
        "ixccFuayoGnZjbF"
      ]
    },
    {
      "left": "POL",
      "right": "LTU",
      "kind": "International boundary (verify)",
      "lines": [
        "{c|jIqm}jCeDxbA_pBtuJuI`dC",
        "wd`kI_nkjCri@rzCdHnGjjDd}Czv@ptB",
        "umkjIc~tkC_{AloBgaAUweAcc@kz@sUqa@jf@{MnuEc[jeA_g@lf@yo@vZwo@nb@mf@paAuG|~@",
        "iu|jIu{akClPbmC",
        "q_fhIe`jnCoc@yXga@{Bi^`Qc[xc@i_@paAel@jq@{w@nYyaA{ByZk]oWq`@ed@sjA}~A_|AclC|@sbH`zAkdCxn@{jCncA_|BdvAyxAjfB_Snx@sTheC{Xr_Amo@nx@q~BtpB{u@`{@wx@nrBm}@x{BwnBxvNqtAjmFg}DpbKi_@tpB",
        "scmjIu`blCnO||Bbd@ftCHjnC"
      ]
    },
    {
      "left": "TZA",
      "right": "ZMB",
      "kind": "International boundary (verify)",
      "lines": [
        "fl_q@uguzDrpQmbDziRswH`xPqlKt|LyeL|}CalElwCaaGbcBcsG|@seG",
        "x|js@gan}Dtp@_hAr|CeuBvp@{aA|KkoA",
        "||qs@_b}|Dg`AkcCmyAg~BmcAcdC?ouC",
        "xdls@euj~Dh_@qv@lf@gVtpBuSzj@iThu@irAvFmoA",
        "xjss@usx}DcQ_t@s^co@iqBibIoNigAmPqk@qWeOmG_S",
        "b_us@ufv~DbFi}Ajq@eaBvxCkeCr}@mbBxbAioFjfBu{Bz}Cgj@fhFRjjGym@f~DkoCriMkxQtg@}hBR_}B",
        "dhus@wqs~DaH}sA",
        "`wgu@oo_aEp{Fmb\\f|FptBvsHRltFg~Bh~@ohG",
        "zbmu@cip`Eel@{~BkqBetEgKipC",
        "fxev@geobErUq~ChfB{rDvQ}_A",
        "jzjv@oeebEst@eaCoaAayA_i@obB",
        "hgiv@qlacErAyw@de@mfA|]wx@ffF_eF`zA_zB|j@_}BvOadC",
        "|hjv@sy{bEeDwy@m[ewB",
        "|}vv@{xsdE~|@q{FdvCuaFpuAocAd{GmxB|gCyxAdw@}sAvQwiFhsBmxOld@u~L~h@ymAj{AquAxn@gVr|AkRnm@cc@dO{l@",
        "`nwv@sjzcEcOgmX",
        "~z~w@gw`gE`Hyl@p}DaaH~mD_rMv{@g_B",
        "~e_x@uj}fE_JqkB"
      ]
    },
    {
      "left": "DEU",
      "right": "NLD",
      "kind": "International boundary (verify)",
      "lines": [
        "kl~cIee|j@npD_QfcBoEj`BjRpjBti@phClwAlq@pNviAqCvf@{Vp_@k]ru@gVn~Lcy@|~EtHhfEnx@fpErfCzgNz_OzpAdo@dkBp~@|oEfu@taTdy@h{Exl@tdCtpB",
        "evf`Icgfi@a|@jjI",
        "gsh`Iw{{h@xD~oQpf@fpErp@foBvn@`kBl`Ais@~v@fKzr@l[~r@}@dg@}j@xhBwkE`jBzyIrDhfB`aB{kApnB}TbmBaHd|Aae@zvAkzBfp@wcDvi@ymNrjA}aIpPkoD",
        "moe`Imxyi@mi@z}EgWh}A",
        "crg`Ig{oi@|ZbsH",
        "alc_Ic~pi@tyJo{Jt_DyvAxbF|s@rqDh|Bh}Afl@nqBzBpdCqv@nh@sc@vPuNb_@lP~fBvtGho@dbArqCrqCbcAt{BjgA`kGhmAlxBvlDfiClk@xmArXhpJlAtb@pa@bcB~bA|hBnb@|_@rnA~q@ff@lq@fVziA|A|`AlOdw@b`Afj@f~A{Klj@obB`X}gCblCgwKrhBo`Dd]i_@bi@oNjkAxD`Rt^dDxn@ta@~q@f_DvmCjjBjpCtw@dhD|IhhPxbC`mRhqClrH`\\jfB?f~B",
        "or__Imubi@sEacDa[i{Cs`@cy@_i@ye@gJkf@",
        "}kp{Hkz~d@wt@frE}cBzgE}y@nhE",
        "qaw{Hwtkd@jfApsEnc@olAxvCghF~pA}rA",
        "{hh{Hagve@k`BvQuc@ldBsUrnFmTl[{kAbdAyYpk@{Btr@",
        "qfq{Hm}de@rY`bE",
        "gsm{Hyhif@ohAnoK",
        "w|o{Hix|e@~kCar@h}@zXpg@liF",
        "{kl{H{jqd@oNvcBkVhrCs`@xiE",
        "ktn{H_hcd@ni@n}Ft\\xxArz@d`C|^vwBb[d~Ftl@~fBtv@hTtbAcmC|wBirAh}B~Iz}@xdBzU`d@dbAbDrN_}@",
        "envzHesnc@hTufAv`AqjCtf@_}@~oD~rAtpBmnCxrBafLxjC~gAhxAp`@vkAcZzcJ__LxtD}zFvkEqk@jpBk]vzBrUzcCxn@brBjGpeAi}A|u@dc@|gCjRxlAr`@`v@~|@ndAz}Cdg@f`A|qJj_I|cBxbC|cA|~@n{Brt@pjC`QlrBqk@jr@sqC",
        "skvzHu}hc@qAotD",
        "k|kwHiamd@`^knCdQvp@nhAvmC`lAcbCrlA~{ArxB|bJn|GbaQ`|@|rA`~CdwBht@zkAvF|qB",
        "yugwH}icd@qeCkvH",
        "svmvHidcc@co@jrA{{@fiAu]puA",
        "ibrvHcp{b@by@`nDhqCob@vrDg_Bp|CoE",
        "mqcvHiwdc@lFquAfa@acD",
        "qdavHikzb@}IgtAwq@caDeNssA",
        "{xbvHcrsc@r_@{Krs@be@~r@zVbyAaHvp@cOf`@yn@ny@grCzk@ckEdXfK|`@|_@hh@rJp_C}s@vp@|@f_A`e@~s@xdA",
        "wgbvH}qlc@cPe_F",
        "coiuHuw{c@yFxkC",
        "}viuH{jwc@`^ztAr}@|u@|t@yDnx@qLfiA|_@ht@vxA",
        "gj_uHwvoc@eN~}A",
        "my_uHwwlc@boAoYhs@yn@lZ_}@be@ug@jpApL"
      ]
    },
    {
      "left": "LIE",
      "right": "AUT",
      "kind": "International boundary (verify)",
      "lines": ["mxe~Goiny@ktCokDmaDgj@m~Ch~@mlCpsC}iA~xDgu@T_}Aa}@qk@mEwuArt@ku@lz@}u@vZavA_i@iaAhhBex@xw@"]
    },
    {
      "left": "GIN",
      "right": "CIV",
      "kind": "International boundary (verify)",
      "lines": [
        "kue{@zdvp@_HzX{w@nXmUmQaG_]{MkI{`@tH{kBpM{a@|UaHzb@}@za@qK|S{q@rUy~@`Sgv@oDuq@aeCu{@{kA{{@{VyZxmA}cA`{@_|CebAghDi}BuiBetBauBc}HmnAwnCsxCyvBqyA_TcsA__@klAem@qeAs~@",
        "qvgx@tl{o@oEdkCwZ|fCys@jeBsnBtgB}}NrjJybBzm@}mBt\\amChTwhCpBix@cGgxq@}dFwdCv[",
        "a_f{@rorp@tHftB",
        "my|v@|xao@{{Bx|HobFxEw}Oe~EkoC_SaqNwcDgu@r_@I`aG",
        "qqnx@hhho@lZ`cC`dCvlFxn@d_CtIjqB",
        "{okt@znxn@uoBruJ{NpiCauAb}Gy_Et}@y|O_qBsqHoYsrCk]mvCu{@?IU??KuaB}|Ae{GuoP{LewB?kzBiUetCuhA_cBqE{Gc~AxmAooChcGmjBpjCwcAxbA{~CptAkI~r@",
        "{`~v@ll}n@dY~}@fLnlA",
        "inar@r}bn@sf@ikJihGx`CkdCvf@qtCkRc|C}k@okBIybGzlA}bCdMynF{M}sBr_@}t@pk@gsBfmDubAry@{lGptCws@fj@qeBztBqa@z\\smA|p@_Ztg@]tc@",
        "otlt@jqun@``@t`ApBxZ",
        "ix{r@|mhp@lPgt@`{@ecAzRyg@dBer@",
        "qoxr@x{vp@eLq~B{pAunEuHs}B",
        "}pzr@zvso@bOcxA|{@olAnqAij@|xAq`@xqAmo@|z@ocAlp@ixAd]qdBpBsgB",
        "atxr@dq|o@io@kyDqK}~A",
        "s|yr@r{}p@`l@y~E",
        "wcyp@nejp@exDx_RmrI`fOw`AwGwiBaeB{fAkQetBnMctB?}bJelAo_C~HinAr_@ycArj@_bAr_@ajARck@qa@cnFqnHuJgvA",
        "w|xr@tj~o@tGox@",
        "wsxr@nxap@_HylB",
        "syvr@|awn@brDudCvfKkcExwAylCrVmkD",
        "oukr@|f_o@mo@giB{vAiJefBlOo}A}UcU}gC",
        "ym|o@nero@ohAvQc~@bOghCdkAuqB~fBqdArsBuwAza@c}ApAg}Dmd@ukAom@wuAoc@{{@lD",
        "im}p@rczo@^plAd_CpwJjGvz@",
        "gm`p@|y{o@pRk|@tr@m{@ln@{jAvGwmB",
        "wb_p@p_dp@oi@sdG",
        "_f_p@x~fp@fBg~A",
        "{n`m@bffq@ggEsrD{j@{AmdBhSon@qA_fAu\\i}C_|BoWyZwf@ueAoXqX{X{Bi|@lP{XeCidF{gEmyAu\\ioEsUmcBgWqa@a\\qW_h@qa@kb@s}@cKecA~^cwBnjC}_Anm@}yFoMitMavHerF}~@cvCiIit@rJ",
        "w{mm@nojr@phDotC",
        "mdcm@`ixr@}dG}zGkpAs|C",
        "m}jm@xg{q@ft@qpExuDwkFnaBkbF",
        "erhm@~yer@kHisB{`A{|E"
      ]
    },
    {
      "left": "FRA",
      "right": "ITA",
      "kind": "International boundary (verify)",
      "lines": [
        "kdhjGihxl@_kHfyBc}Cj]o`Cq`B{vEsmGupC}|B_dE_bIaoBojCagAoo@ekCsr@ekAag@qv@ocAaq@myAebAwdAekBgKme@xWupBjhAybBdiCgsBfkAcjE}tAgXd`EbxB``GjIfsDv`Fb~`@oCfzFaIb{@ih@vy@_s@p`@ql@hj@}U`qAuRvaD{b@ptB{eHtwS{`AryFykCpnJmOxmAbD|rAbQ|iAtGhiAqWhrAco@xy@qu@j[my@tSk|@lf@mo@lx@i_A`{Bii@dw@cn@za@}}BrhAk|@bp@}rBphCm[zXox@fVs^i@md@oNcbEis@}t@}j@_rA}pE{`BlbDknCz|DanDdkCmaEjR}rAoaAwmDo}HyhGmuEym@evAwcCjeA}}Bqk@cdB}qBew@mnCS_rBxn@m`Fs@wnBkpAdc@c_G||Dit@zVkyCr`@ifC~eAcGoCoaB_^oCsJa]RwOyDaR}@yc@pLk^zXovAjoBwzAhxHmEnkB|j@bsHiTduBsqDzmL}|BvkEyaCdlBy|IgKgrD~f@ssA`cDoM~yEag@z`Aa{A|iAow@xOaq@cF}j@tHi}@vdB{uBxlBweAgiA{u@k{AiKuScwAwwEcFov@zAapByDcp@}Tgu@u|@koBcPen@dY}yExvAidFdw@y_FmdAojEwe@gKw[dc@{`@`\\_t@}_@oNcp@g@}pCuH{w@yy@wzAkeCokBqu@woA_gAo~E_j@g{EdNwp@dbAemAjG}_@i]}h@mxC{uBwcB{hDeaB?i|BdbAetDr^yc@i_@giDeiEmbDe`Cg~Aqv@ylAmEeYlo@kqAljGqk@hrAaeAjq@{lAhj@_l@hg@mV`TkoC|nGmoBn|GwyAdn@kaGda@om@pWshAncAkq@fK_s@yOylBufAqb@{M_|Abe@yd@zkAcc@xiEsk@jrAyaB`mC}TjrAgVjbDewArgDadC||BabGleAwnBxOknBqCweBq`@a{AmnAig@g_Byb@whDbN_u@fP_h@`h@wc@sG{e@c[oEej@oE__@oCoCij@\\kyCmZadCkq@mlCsiA_}BccBgtAisAkf@gjAmq@ox@{`Au\\wxA"
      ]
    },
    {
      "left": "RUS",
      "right": "FIN",
      "kind": "International boundary (verify)",
      "lines": [
        "k{hdL_bvoDljGzpVteBdnVjgLneq@~Hn~GhrBcQlz@gtAv\\elB",
        "{njcLmzymDhh@ccOvwDuhM|uMxqIdhEb`Enfc@raq@lnAfjAt{A|AzsCssA~pDu{Bdoq@uub@baC_eDp`AseF`{Gwxv@`{Gwxv@zw@ehEvbBcvDzxKobOH?p~D_nFpvYog`@baEmfKrySmvx@rrAteC|~@r~@voAlYvrK|u@~pAt\\ryGjdD~pBpjBf_h@pllA~}@`fAlnBtfAnl@jf@xe@j|@~tCt`Ildn@~h_AB?Dh@N?xgOhmH`vLcjFfw]sol@nmIwzFfKgHrwBspDfv@uQj|@oE``Au]lo@uq@zaN}mUjjBw{@zeG}iAxvBea@lwEwoBnhE}qCviJmgJz{SisZnfHweOp~C_zCluFg~BnbN_pDtkBa{@tgGwuF~aBshAjyHwwDbiGe_FtpBis@xaQioD~yCm[tfCzM~w@f_B",
        "kjicLoorlDoc@}if@",
        "kovoKsruvDc`@drE{eBr`K",
        "kwzoKy}bvDxzDdsm@|sBt~Jd`CawD`tCcpMx{B}eEvoA`oAp|F|tNnyA~uAx`@n_@r@?vfF~q@~iPolAvaFf`A`tJhoSnsE|yEb}BibH",
        "ow`mKwyttDdlAw}KdmFae@xr@`{@`g@~gArj@nv@~|@xDzu@{jAtIwmBtS}jAfsAv[xxA~{CdaB`y\\daBd|F`mDzsDjkG|~@xmOe{G`hLksKfoGg_OdbAy`RdCiac@fu@auFdn@}hBtf@uHfl@da@~|@|VvnAzKxd@|Lpa@qMvdAafAbo@ybA`yBysFxwB{jBlyBrj@hgBp~BxaAztCtdFli`@pV|j@xc@pWvQeXtHmf@~HuSxkBuHnx@gUbz@}k@bPtJ`QnClP{ClPiJpMcbAnNsJ~g@`QlnA}yGlyBkwErqCln@f~C~fClaDrt@ztBg_ChhB}yFxwBu|LlvCir]hhBmsHvmB{rDhrBqjCzuAmwCrj@cfJxw@wkEt|AgjCdaCjr@`zBbnB~fB}@`dB}iAnuBokBbjGyvC|pEbd@lvD~nD|{DvkGJ?H?dsQvhb@fwKvhKtlFboKpsDfj\\bgBfiIva@fmBvbDg~BpaYgcn@nsHk}Yl~Fc|J|sBwyBdbAmkDh{Ow{_At{Ooa]nnK_sf@nmAmbD~fBsfC|}Bem@rrBmFjeCug@p}B_~@`|AqiAbbB{_DxkC_iKbxA}rDn~GyoKz_AgrCr_@ymAjpBazCh{CquA|rCifB|sAsqE~qNpjPthFbuFpfGx~DlpQdfH`jC`eBboEnsG`oC|sBzkHxtCjeC`eBrgA~eC?h@XfAj`B`jIbu@z`BrbAveAtfChqB`zM`{ZjaArsA|pEr|C~lAjdBtx@`pBhxFzeUhiGhqP`aArnF`k@bnBvu@lnArkEvlDjiOtuWnyMvnZRh@?^nqZ~zd@j{Vxx_@~gLnmYj`Bf~BjyEzsChfBfuBr_Obc[liAx_E|wAjrKz|@xlCxaBjoB|wCtpB~aCdlBdvMfi[ziCduDpgAdkA~vAj{AzuGnpJ~iEtgMfzGvc\\||BlsIl{EbzL~aBvhJt|@vdB`_DvaEhsEj}Jd|AjqBt_CfhBD?RTN?zxDxsFdhA~ePvgBd{G~mMhi[vfLz}PvrExuQfgQde[d{AhmCryGjeP`_IvrO",
        "cj`mK{mysDkL{jZ"
      ]
    },
    {
      "left": "RUS",
      "right": "NOR",
      "kind": "International boundary (verify)",
      "lines": [
        "o}`iL}rf{DpvF_RzjBetC~eAox@nlB}_@vz@lE`r@wQrrA}hBhhBidDxaNkR`fBpVntEzrD|gB|yGdd@laR",
        "iligLu{uzDw{Axqn@wo@n`EwzMrkc@qiB|lKeXjuG",
        "iy`hLmvfwD~GtwGh`@piCtq@yn@vp@}gCj|@}vJrs@afAtpBit@fsCkQnlBfj@xmAzvAnw@rqBzl@toDzb@nx@||Aj|@dxAnWnlA|@jfAjTbdAdvAxfHfwVxbClwEjp@dvBzl@bgHxEbd\\db@tnCtdD~~Kj|@xfJ~Src`@|~@bhJlvCdgG`{Avp@blDzaA|t@rs@jr@fKhs@Tpv@jRbx@`p@paBjoBxx@xn@l_FbnBdaBz`A~fBlxBntDjkHxkClhI|jAzyI",
        "{ijdLyukpD{L~`J",
        "wwjdLys`pDvOlvErj@jyB"
      ]
    },
    {
      "left": "ARE",
      "right": "OMN",
      "kind": "International boundary (verify)",
      "lines": [
        "_`}uCevguIuCmcCu]ovBg_Aew@ajBce@gtCkeC_hFaeBOe@qe@c|AoYyhFwp@koBmwDkmEm^gb@upBanD{|@}_@aj@gCeoBaJ{jEeSy`@i_@u\\m[qa@mrI",
        "ymmwCm{ktIbb@w{FdA}Nj`B{hDvwDafAjrGwr@tdCcX",
        "kxwrCwszsIiDfhBymAlfKaa@|iAs}AtHklBwp@sjK{qFwyA_g@ymH_Ums@fMgv@bn@olAh|B}j@`g@}}A~RoqIeMI?kfGbmAybClGuuAi~@avA{vAspEwe@}qCanD}wBtSy}Dj|AsaAr_@yqBzK{gFcZqtB?g_Nhs@e`Eg`AczEg|D_sCwpDoU_Z_}BuxE_x@ioF",
        "iuvvC}e~tIyaBztCsd@toAmRfvA",
        "eq{vCchttIj]xlBtmA~Rn{Aqk@x_EehFjmLcwDzjCe~DfJiwAh@oI",
        "w}oqCcyrsI{oG_wU_xAijKibBcdAg}JzfF_hGrhAi_FzaB_gAhzD",
        "oz{rC{qetIbaCb}I",
        "}~sqCcbjsIbsBwaD`LgsB",
        "egrqCwj`sIgAg_Bqb@ueB}PmoB",
        "kksqC}osrItCinEn^ojE",
        "khqiCwtyoIwn[ebA}n[jf@S?axD}TaxQmaEo`]}qQm}JgiCinRmaCioEydAo`D{sBUi@gjFehFywBquAsfWamEshByw@}kK_cH_rAoY}xM`S}rDj[chCbcBy{BvaFkvArgBqoB|u@ezAeXqm@wkGu{AmhGe|@mxBk{AovDi~@oiDo]iqD"
      ]
    },
    {
      "left": "AZE",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "s{s~FcvozGsY`eC",
        "wm`~Fkff{GgdAxmBgiBpa@{|Fa]euBza@aq@voBm\\v_H",
        "y`t~Fu~tzGdDpgD",
        "}qs|F}}_~G}rBbyA_zDfu@_{DjyCieEtuHwtArsA}n@fVoqBr`@ic@`\\cZ~gAeOvaDsOxmAkp@ziBg{GpyKkgAt{@}sAr`@gtFdw@odAlY]js@",
        "gbm~Fslf|GvoAfhBhTrd@xi@ljAze@p{Ffa@p_CjdCljEns@pkBRxuB",
        "_|k~FmaogH|hJxlHz}KxjLbh@li@l}OpfGrrDf}B`tBbnCz|Fh{OxsEdfI|iAlwDhhBpoUz~AjmExkDnuBh~LvlEl{@nkC",
        "k}nzFqqiaH]z~BecAjpB_yDhoDeb@hgC{m@ffSsMzr@gg@pmCawElzMuqAxlBcnC~|@cfIsJywCfV}hAnn@cvDl`Ei~@r`@u{@rS{v@v\\ce@zo@_J`Ms}@nmBmzAfk@}hB|TekBzl@{uAxaBsU`pB",
        "_cv|Fyto~GlQbwBnb@nvBjYp~FVtF",
        "qsk{Fy|ycH_TbaD",
        "qhl{FuztcHhs@z`Az`Bv\\tpB|s@hrAvzAdl@hrAv{@by@daCbQn_Cm[boAs^`|@lYldA~qC~{@xgGlEh~Al\\~rL",
        "gmlzFi}kbHaRxvBgfAlxDw|BbfIiJh|B",
        "spszFsgtaHdc@xwB`nBf|E"
      ]
    },
    {
      "left": "BRA",
      "right": "SUR",
      "kind": "International boundary (verify)",
      "lines": [
        "khzM~hvmIquAxnFcuQheRcy@lY}tAiSkyBywBurA_h@_}@z`@",
        "eq|NhemnI|KbnB`eBn~FbnA~{BlkE|oFxkB`aFvQrs@",
        "aclNpxloIoDvp@uq@lo@evB}Tcy@j\\",
        "qlsNdbpoIvPntE~~JxrN",
        "ucsMxsbsIyXzzBks@p`AqgC`gA}u@nm@__@vz@clBnxLur@rhBuvGvrIemApiCqLzsC",
        "semNzyrtIfW|iAdb@|e@xlB|n@biGfaAltGdCdlBh_@fpGruDjq@|n@fa@liA",
        "yzfNnkfpI_HxpCazAhhAec@xaB",
        "ackNlippItGxmB|j@tjBjeBxgBrsBva@hqBxOf_Bxr@dlAfqD",
        "g|rMt~zlI_I{\\we@iI{a@vFqbArYoc@`Hs|B~Ba[|Zyn@nsAit@rgC",
        "wv`N~~bmIpCvgBxs@`aBhx@fiBtzA|sH",
        "usyMjfcqIeCx_F_^fqFqBffF",
        "mzzMt`yqI~^rbJ",
        "mzyMhddrIeOnvBSbbC",
        "gkzM|~krIdkBtfFjzBdlN",
        "g}rMn_|lI^y_@",
        "{icMjhulIwQvyBoc@rgAkq@dNm{@}EoaA`GcmC`w@{tB{b@yEwO",
        "wihMlsduIeDleAg`@jv@eYhx@",
        "kjjMpjjuIvP`lAxbBjpAprD|}A`xDhiA~rB`Qvn@_gAnOwpGlZwrBdlBeuBvtFkx@vcCmsArrBggDnn@}t@~`H{~EdvDmtEpeAen@pnAqRdx@dI~w@rU|nA~RvtGwFnxF{a@b`F|_@|lEreEnzBnzK",
        "ejeMp`jlIle@vtBrUhwBfBvxB",
        "c}uJzqiwIwQlzAeuB`dI",
        "ihoJ`{jvIsJdbBwp@duBunCl_F{q@xwBgMbwB",
        "ovwJxe`wI`l@nvDhKpsB",
        "mbeJxi|tIqpAthKq|CnfKygB`rK",
        "kzoJ`navI`Q~kH"
      ]
    },
    {
      "left": "AZE",
      "right": "GEO",
      "kind": "International boundary (verify)",
      "lines": [
        "gvt~FapkzGdnJjmFnaD~dCltFvkG`|@`zAnc@xbBjHbaC",
        "edy}F}mmyGaq@rcH",
        "gvz}FiidyGhJhgC`_BxwBbuE`z@~{H{AdxGynAlhBggD",
        "mb_}F{}hyGza@eMrfE{iCbl@gH|rF{p@|fCqv@~fBqjBzhDyeIpX_hApVg~BvkEscHn`Eo_RzhCyqHlmD{aB",
        "cuz|FahbyG}`@}u@sx@_^en@ih@qAquA",
        "kny{F}patGqMd`BgtBzkHol@vsBaGlkE",
        "wg_|FuaksGrs@pgEbnQts\\trJlsQ",
        "uxfzF}wzwGc[tlHe|Fp~[spC`zHsv@hwB_fDjaGgqDftCoaC{iCme@mnCyc@cxAwe@vF}j@~pCi}@|uK{fGna[koCnjEemAlyAqKj{A",
        "gf{{Fs}ktGnn@tmEjG~|B",
        "cbk{F}_q{GvTqj@vBmFrt@_i@`eBywBtaFkcEbzAkf@vFjR",
        "kej{Fa_n{Gw[{_B",
        "kg{zFcn~{GyDtr@",
        "em{zFmz|{Gvo@zu@bo@fKnlBxE~g@fLvf@xc@ly@tqAve@xc@hgDt{@luE~_@zgEhs@`d@xa@nzA|tAzMvyB",
        "uloyFgctzG_s@`oBiqDvmDccAjeBwzA`sJmy@x`Cq{FfoJojDntD_hAxaBu\\joB",
        "a|mzFgo`yGr@|tMdWfjCjlAn~CrnAbcDda@jzBjIbvC",
        "yuxyFmai{GqWzuBaHjyB",
        "mwyyFepa{Gt}@bcCbcBjeAdaB|a@f`Azu@nCrgC"
      ]
    },
    {
      "left": "ARM",
      "right": "AZE",
      "kind": "International boundary (verify)",
      "lines": ["{nfyFevxrGpB{XftB{qDbdAz`A", "}p`yFaa}rGwPtoCwnC`{@cOkRkH}T}AqW"]
    },
    {
      "left": "AZE",
      "right": "ARM",
      "kind": "International boundary (verify)",
      "lines": ["qndwFgtytGhHmyAleAwaDbbDrsAjyBfpE", "iayvFqkxtGap@bvEa{@ld@g`AhKg`A}K_}@yc@_j@emAkReuAg@mzA"]
    },
    {
      "left": "SRB",
      "right": "HUN",
      "kind": "International boundary (verify)",
      "lines": [
        "uqpxGiixwBoNdlBwhDx|Jq{@dgCk\\z`C{CjeC",
        "wiyxG{m|vBlp@~iJ",
        "ixwxG{bqvB{A`dC",
        "e{wxGy}lvBdMrrBlo@jyCnbAjpC`fAlyAjr@_Jbx@om@tr@eO~|@vcD~h@|j@xm@r^hj@pk@vz@hhBnNrt@lFbdAnXbmAfu@`r@t}@nm@`p@|~@dXrgB^ffFvPtpBh[bu@fd@dfAdlApm@fkA`\\r~@`fAfVvlD",
        "qhsxGsahyBweBpdGyXznK",
        "ciwxGelsxBle@fzFnZr~AntC~fO",
        "{_rxGue|yBcQxn@u|@|~@uQr`@cP`eB",
        "osuxGgntyBbDj|@fv@p|CpMtpD",
        "qnlxGutpzB{hExrI__@joB",
        "mxsxGopbzBts@~{CzBxl@",
        "u_swGy}ktBwf@vbPow@ziC_@?azBj{Ayc@xkC",
        "y`{wG_fosBri@`oCfuBdaBjxDbFhTlmB",
        "gqowGe~csByNf}C",
        "aapwG}__sBrhApsCrUjR|UnEfVcFht@yn@lYeM`SvFfKnb@",
        "qbhwGkkzrBce@nvBiSt~J"
      ]
    },
    {
      "left": "SEN",
      "right": "MLI",
      "kind": "International boundary (verify)",
      "lines": [
        "}}epA|adgAqB|a@a{@fiAmj@l[swBve@km@zVqa@no@}nAhdDkM|u@wcAzM}mIoxAcnBqLogAhj@_Tjq@aFxx@u^f`Aeg@nb@e|Apv@cj@jf@q`GbhJw}BrqBmrEpiCq`FdmAarFn_CezBhsAqfA|tAicHgtOgqEipEavGmbBk|Fcd@a~B_@qtBbe@a_CblBavArsBiaBvdBeaDr}@ibGSo~MokCo|F{l@miCpLslOreFqzAj|@ix@xvAkvAluF_~@fkAulA`{@wtAjr@a`@k{AulAcZ{pAfj@gqEteQoNpoA_nGsJa~B~NwoGlhAoaC`MwjBwd@qeAguBgf@ol@gcAcPakAeEy~@{Kg`Aem@crBwxBwu@}a@igByDyd@nn@oMr~@ub@|j@icAzMii@_Kwk@wZcjAqa@{BldAuRldByh@v}AmeA~n@{uAfe@ikBj{BeuDrn@",
        "{btpArakfAmFlz@io@r}@e|@zb@mp@pk@qKnxA",
        "yuypAretfA`q@p~A~fB~}@`_Cbd@vwBdOx`EfeGdb@da@",
        "{gopAr`_fAqFbdAa}@nO}wAmGiZl[",
        "waupAfjbfArDh|CfX`yB",
        "ananAjavdAaQn`Be}@cP}xBeNwt@SeXuSiY{a@iYuHkXfu@kSzWgf@fWkkAdb@qxBfuA_c@sKun@qa@}j@aFoXz`AuXvdBym@xmAav@|hA_r@puAkXlmBgdBj^oyEzAuqAby@_bAhiAwkA`{@{nBvQobAqVqoBynAocAuHe{@xYwyBllCmpE`yCixB|k@}fCR",
        "apppA|d{eAnSdl@tRnmA",
        "yuymAn~rdAUmZgj@gu@wVag@md@_ToaDfLofAdMc_Av[gu@js@",
        "i_hnAh|qdAtkBbNdfApl@j\\jgA",
        "uyzmAdrudApMgk@hTmf@",
        "a`jkAhkwdA}j@lq@a{BhgAk[fl@sVldAkf@}k@cz@y`CufAoNel@vF_j@nMoaAnDkdEg_@{_Af@i_At]{`@vo@mPnn@eNzVa{AxDym@ke@i`@yo@kcDeaAyXkqAeNquAwoA_r@gz@rJsrBz`Ac[?kl@sj@_cAqLsiAxDw~@fLos@`S{k@bZw[|UuD`GcDnN{Bj\\qMpWqe@pAqa@oNeYwQ}YuHsdBvRw_AiVq_A{a@o~@cYa`@pL__@dc@}`@h]ge@oCiT_h@",
        "eldkAdtqdAew@rJkeBlf@us@pLwbBle@",
        "ecnkAf{tdAjQlo@paAdb@dm@qB",
        "ksujArhodA_eDsJ_dDii@_qCqKekBbnA",
        "q|gkAfuodAnb@pLzkAjp@"
      ]
    },
    {
      "left": "FRA",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "ulvUzrb|HeCmk@kv@}t@mt@yJsbClPo}@oM}o@io@m~AabE}yL}pKcrC_hBedDilA{iEmu@s`EsxAyeCw|CieFarM",
        "csvUtad|HlEym@",
        "clxR~h|}Huh@aqA{_Am~@_fj@wkYav@qCox@~Ium@g@_|@ixBmkAer@amD{fA_eKycG_pCk{@{kGio@ewBmj@ajBk`BqVqz@",
        "wwxRxk_~H~Hmo@r@kq@",
        "mmkLtp_bI{Kod@yx@g`Aex@_g@cmCmp@}qCqkAquAykBekBalGedL{zTyvA}iB{kBsrAe|FccCojEqeFw`G}rDo|GkdC{v@q`@kf@{b@mo@c[kqAuHkgAfWizCvdBebAfVk]eYem@q_Cqa@kq@mp@_Te}Dkf@}ea@ufNcy@si@qj@si@_`@ar@oWmdAsi@upAkr@tG_}@zk@}iAdZ_}Agb@msU}jKcn@kI_nGvz@olCpCuyBug@yaDy_FaiHs}BgjBuyBeN{lA",
        "ismM~|cgIdXkfBn`BccA|~@dCxxBh~@rh@pBzX_h@lFetDnsD{bLvRkfB~GotEtTwdBpsB}dEj\\g`B",
        "ehyLtq~gIey@ynA}gByw@oxAomAsI_qC}TmmAisAk|@_hByx@srA{bAg_AmlBw[ssB",
        "e|iMrwqdIpWiqApk@ks@~xE}{ClhIijKv{@zAfk@`zBxwAvnBt|Axm@xx@aeA",
        "a{uLtlveIs_@s}BsJinFk]mdA{gDidFkpA}yEit@iiAotEojDcd@eMiKm\\",
        "ejeMp`jlI|JqhDlz@}qClzAg~BxlBwnB~RbmCxbA_Th|CyuEn`CgtBrt@ccB`]wiGpL}i@nm@q`BbO{v@dDa{A",
        "ehzLrwdhI|UkeA`Hq~B",
        "cohL|iwhIqKkh@k}@k{@qV{b@s|A{eGcnAcnBkpBem@cxCcEi^k]",
        "}mpLpudcInm@ccCd_Dw`ExYgfGru@umF",
        "izkLb_cdI{C{`BmmCopVIeuB",
        "sflLhe|jIlFkh@~r@apAxvCy`D~g@gkAnNev@th@}xH",
        "{}kLxr}jIwGol@",
        "q~kLbuabIbPmcA",
        "ymgLvyjbIiKwcC{Vkg@siAev@u\\i`@gC_^",
        "aojLxi{hIxE}^dm@_~@|I}_@",
        "uf{KdfliIoUcqCC[mtAapAqaGywAwxAcn@a\\em@}AeaC",
        "eneLpzwiI|Icd@zvFwaEll@yx@fVuqA",
        "eqbLtkejIiTekBeb@igBeZkzBiHg`B"
      ]
    },
    {
      "left": "GIN",
      "right": "SEN",
      "kind": "International boundary (verify)",
      "lines": [
        "erclAhelpA_Jd]md@xt@}Jv[iDtRcjA~wGugA~d~@",
        "ibdlAxx{oAwGlu@ap@~kAgMts@",
        "kjflA|papAzBzu@ve@dzD`Id]vPnMdNbPpAnc@",
        "umblAznqoAeMl[_~@vz@oOpa@",
        "kkelAriuoApBbn@`\\xhBlGfu@",
        "wvblAt|boAyw@poB",
        "qodlAfmfoAldAry@",
        "cjblAzghoAg`@pp@}Bdh@",
        "ioclArbkoAnE`k@",
        "_tbkAlypnAsInkBcp@d{AwcB`gAmxBvZafBsUosE_|AqjBwVs|BwEqtB|YgtAboAgMf~A",
        "wkclAb~{nAlP`kBpBnqB",
        "yhclAtnloAIzv@",
        "ciclApfnoAfVbnAdCdX",
        "se{jA`wylAoOz_Cir@xc@k|@~Yen@rbBgLfxDqUvz@cz@t`Ait@fL}h@_IqWwAwdCdzCs{BhsF",
        "cookA`bymApAfbF~wFrgBnwBnSj|@`gA`FjeB",
        "svakAzpinAsi@lnB",
        "gackAh`mnAfLbxB",
        "ghmjAh|wkAqAbxAgWvUqj@tCmz@l`@e_EznDupAzeBmp@|xBqMj_C",
        "}{{jAjcmlAhUtrK",
        "ksujArhodAwEnkDkpCdyKiTzqE",
        "y`{jAdbheA`g@jyOnn@tbG~nD|_Nle@`kF",
        "yrqjAfmwfA_Th~NmZp_C_{CzxJiIjGyEfK",
        "kpxjAr{wgAHhj@tIbZln@bdAr~BtlFlO~qA",
        "{erjAzgfhA{K`dCazB|wJ",
        "ymvjAzevhAxC~yC|t@boBvxD~mEp}BffFtlGn~_@",
        "ambjAvfmjAkq@fdBmjGnpDcnAvnB}~A|mGi^hbCyCdkB",
        "a~rjAtkikA~ShhBnm@`yBnaBnuDnLvm@hA~F"
      ]
    },
    {
      "left": "BEN",
      "right": "NGA",
      "kind": "International boundary (verify)",
      "lines": [
        "ouzbAwtpUqGtr@slCbvCeto@b_b@}hD~{AunC~IgoIi|Bc~Amf@sxGgiA_wUcqLamCqhC",
        "{go~@uw|U{Mo`BatB_~AsrBih@saImEueDgw@_wHo~CsfDen@}~D`@kvCZytD~]ywBnx@el@lnAoOnwAaWboAgdAvy@clExy@_bA~]st@bn@ql@|u@_s@jq@qiAr^gkBwFahIsfCcwDcFskPp_Cs@?wiB|~@uqBnm@y{BdXifC?wqF}~@up@hs@uAxq@MjF",
        "_`{bAoorUnIvy@",
        "_nv~@kclUbVybC~mEooK",
        "idb{@{cmTgeBmmBmhHwcDcnFeiEg{Bg~@{tOye@adBug@{zA{_Bcj@azAux@emAahCyw@_b@gD_oBwOu`BbQsmAdw@wpL~gLsmCdxA{sBxDyyGq_C}nFs|CiiAqWazBmEuf@mPsy@ih@uvBcyBgf@uyB",
        "{lc{@}kaTpg@}vJ",
        "gsxy@ajcS{oBojEwbD}j@a}Dvp@o_EzkA}yB|TmlCeM_|B}u@ciAwcByuDq`Mc_AqrF",
        "ipyy@qa|RrUayBlEmmB",
        "eshv@mjcQS}gA_mB_jL}hBwxCkbEs~Ac`S}nE{qFq_Cy`Cwe@{tKUigBhTicEnnAmmD|h@clDoW_`EewBg`@el@w`@wcBkg@qm@cmNa|Ji_@cFsnA|_@ci@vFayCcn@u]ycB",
        "wblv@wf{P`GybAh_@ocAdh@u{@~\\u}@",
        "ivfv@e|jPsJ}rAgk@a{@ev@_t@si@oaAsKebAcE{~D",
        "q}gv@gz{Off@}`N",
        "gahl@wr~OqKaSgb@oC{v@{MgdGyO_dFfiCizEvwDqgFh|BctF|_@wkEoMiiYwz@yxAlPyxApv@ieDxtCgrDleAqkAjq@}VfBa[zByn@gMcvB}~@qv@}TaiK}VyjKymAutJqLiqBwOwhBmo@kgBg`AyqBcp@ahCeBadCri@ecGtyB}hCno@{sCpUsvBwF{aGyn@_y@?mrBnNmv@g@cmA}_@ujCu{BshAwp@arEap@muDpMkrn@xxByEPkaA}@cn@qb@_o@ghB}_@s`@kv@wFa_Bh_@mv@vFk_BgV}pDemAo~AqAqj@zV_J`^wLlYer@~I{KoNchBmeA_e@_ScjDga@ekKqLudD`S",
        "u|hl@ojxORg`AxY_fC",
        "eyze@_boO}{JsAuvG{n@w~B{Ti|@cTynIyrBgcC}KofGrt@a_C}@keCufAicBapBoq@{kAseA{a@g_HtSm~@fKg[xc@iFnlA_R~~@_e@|s@m~@xn@gzBr^ifCwOaeGqaA}dG~]unFrsAuaFtSy_FcaDqa@_hAqVcoA}`@}~@obAqWcz@dc@_eC`cDebArt@kpA|Vij@oEsh@cZquBox@q_Awp@cz@sSquAoEk`o@bbCcdAoNmZwn@"
      ]
    },
    {
      "left": "AGO",
      "right": "COG",
      "kind": "International boundary (verify)",
      "lines": [
        "t{|Yo{emAcQztAc}@~qBmWdl@_^|tA",
        "~sxYoo{lA|tApsC`oC`fAdtCjq@vcBrsAr_A`pBjpA`eBbcBdvA|zFrfChgAbdAdc@daBr}BbtTziCthLjGr|A",
        "vih[smxnAuoCtaHshNbyK_dElvFgiC`yBkkHloB}|B`zAqv@n`B",
        "h~zYirmmAvF|iAp`@|iA`S|_B",
        "jdc[eswjAiTfhD",
        "`ob[}irjAfvAxy@`kGwFnaCt\\vcO~cGzkAf`Afa@bxA|TzrErU|}Aza@lyAvn@pv@",
        "|gi\\_utiA}pCxmAwfAxw@ob@xy@",
        "vja\\qrniA?fiAl[`\\v_S||DzgGtcD|tQt_U|cAzs@"
      ]
    },
    {
      "left": "HRV",
      "right": "HUN",
      "kind": "International boundary (verify)",
      "lines": [
        "qhszGcyddB_y@hrAgsB~lG{Rdc@",
        "u}azGgngeB}mBdkAqpAp}D}hBrtBevBvcB{_BtpBi_A~eCmU~dD{Wdw@yDbp@",
        "suuzGcahdBhTve@vv@bZ?be@",
        "sl`zGasueBoXhh@gWbZaRnYoMxZkGvZeYrgDeSpk@",
        "uvdzGkgjeB~wAnm@?ri@",
        "e|qwGsewhB}Iz`Aie@l}@}EfJsUtzAsi@?mFsi@{WolAmEom@qu@dw@uH`eBqXn`BigBhj@}}@zMggEbmAyy@fa@abF~xFw[jeAgK`zNs^t|A}|CtlHsu@~gAobA~]ym@rr@_{DtkIov@lz@ggEvxCg}DxhFcZfl@yc@ri@k{B~|@s}Abn@{`BsSwdB`{@cb@xd@{r@xv@av@boAK|_@",
        "a~azGmqveBr[pLxSxO",
        "cvnwGiwzhBkQ`Sqv@wH}iBdc@",
        "_ktwGyhyhBxmAdbA",
        "{jlwGwsfiBwdBtg@uRz`A",
        "idpwGeiciBvf@dtClEt{B",
        "ixjvG{{~kByXRssCjzBi{AntDwbDrxVoEllCqV`r@yh@pJy_@`HufAbF_|Ah_@wq@`Fkz@zl@ayEzfHigA|dFme@zgGmPzsO",
        "q|nwGusjiBfV~s@tSlPjRzVjQr`@",
        "_}iwGetjrBxCj{A`q@`}@bZvdAzXh|Bhr@piB\\xc@T`\\",
        "e|dwGgjzqB_r@voA",
        "eofwGoywqBdaAt}@dx@vZpj@xZpXf`A",
        "un`wG_brqBcFdkAmyAvuFsiAltH",
        "{zewGsi~pBlPzsBz`BnlCt^fVfjAvQle@vOp@`HhhAj{A`yD|gC|~@|iAn`D~lGri@xaD",
        "ixjvG_jjmBq~B|oS",
        "{wnvGayulB?boL?veBrUby@`p@v\\zk@nb@~I|iA",
        "eemvGkb}oBem@bkC",
        "ksnvGgvxoBbo@`eB~zD`xEf`AzuBtGxl@|Ati@",
        "q_fvGmtxnBk[djBwpAzjBi@bmCwcBz~DyXfsB",
        "qmmvGc{cnB?daOfKzu@|u@zjB`QzbA?hgA",
        "kzdvGwghoB}Ari@aGhh@S|@u|A~fBi@bcB",
        "_ehvGwe_oB`g@ldBj\\zjB"
      ]
    },
    { "left": "HRV", "right": "SVN", "kind": "International boundary (verify)", "lines": ["mxmtGgsgrACR"] },
    {
      "left": "SVN",
      "right": "HUN",
      "kind": "International boundary (verify)",
      "lines": [
        "szb|GmawbBin@dy@_gApt@y}@`fAwrD|tAgVdMeViG}m@{Os`Auv@_[wVmeAij@ekAob@{v@eMo^vZqBvzA_Szu@{V`[soAt}AeX|~@",
        "wb`}GacibBha@faQjOtrG",
        "ap~|GcmnaBkD`_@{d@haF",
        "ujyzGssxcBklGlyAi{BpqEawFreFmzAx}E}}@vpBil@zXqh@xVu|@ox@gf@yuByWgd@{_@ip@auBfa@aj@r|A{ChsBsHp_@o@fDkMto@chB|@",
        "}dc|G_xybBhIpuA"
      ]
    },
    {
      "left": "SAU",
      "right": "QAT",
      "kind": "International boundary (verify)",
      "lines": ["ez{tC_povHcp@~uJwxBfyHmrHlhHapTbhM", "qvhuCk~qwHxtHxfLrcBzcI|@t`J"]
    },
    {
      "left": "ZWE",
      "right": "BWA",
      "kind": "International boundary (verify)",
      "lines": [
        "dlrkBspdyCnvOp{FhoD?ftC_i@voL{sDxdLkaG`nDghDbwBosEvoC_{DdfFadCpaNggE|xHciEt{Bwp@nfGoy@jrAs^p}BwoA~~Kc{KrhCosE|rAgtAttKogHbvCsrDrrBqpF~eCi{Ch{EufAhhMce@fuMo~En}SeoWpjNafDnEeAd`ChTzfF`eB|~B~RnuCgVptBup@~vFwxCvlFg|DnqGmnClgq@mvQl`Fs|C`oCorFleAavGlEsmIt\\ybAhj@w{@`p@ap@voA_}@jq@oNnaCpk@nlAdl@tSjh@~I|@lo@gkAtSwp@f_@{|DvfAykCd|FokD|hByuBri@_rBrt@wuFzl@ovB~yCq{FtgBsiBzsB}s@nlCqk@|rAitAbp@srBzkAqzGvn@wxAlTaTjo@mn@joBquA~{Aq~A~s@siBfV_{Bf@}rCjh@yhFlsIibUjf@c`F",
        "lqbyBkiwcDrSeiEdlBipEj|@yw@toC{jBhs@ybAbZ{kAzBi~@",
        "~sbyBuypcDqAunE",
        "xnoyBqwqdDrAgkA~RmbCdc@eaCnaAuoBdlBaqAddWm~Hd|UkoBvd[p`B",
        "rtoyBqyodDyD_}@",
        "hs}{Bs~zeD|@ibUv{@gtN",
        "lab|BmzleD_rBcjFcZaxE",
        "fu}{ByykgDr~AkyEfBgzFfj@cnBjpAwxAxlBqm@vuFlQ|{EpkAb_Fjp@boNizC~xFgMlyN~}AjeAp`@rt@fl@xw@bc@tqAvF`fA}@dkCnNj|@Iv}Ico@vbCvGjjIzjAdlBh@duBar@btGavE|}A_~AliHaqLnuE_yD`lFq~Cd|Fe_FnwAwy@jq@eMz_BdBdn@iIby@ag@teBaeBfdJkxDp_AmPbp@~S|iAbo@lz@zKrJsTpLgk@bc@eXvoAh_@v{@qWlEk]",
        "~q_|Bew`gDw{@saJ",
        "lghbCcttiDpW}i@~q@i_@f~Bew@dw@qb@zkA{jAfu@ovA~]aeBjTwhJdvAisMhIygVjh@qfF`oA_xFvuFk{Nl[keC",
        "zmhbC}psiDmEeb@",
        "n{`cCo}gmD`p@qfExOayDnYovA|qD}pFrsAe}GdnKqs[bn@s{DhTo{Jtg@{sDxdAwnBfiA}xFpjAkfBdwB{M~pCfkAnuChfBheCncAfgGxXxgGmo@jmFouB|zD}{DtpBqgFbe@seF",
        "`pecCwnvlDaQ}gByc@obB_t@}zEu\\g`A_JcdA",
        "v`veCyxmqDlRu^~eAu{@fw@ga@jzBmo@by@kf@~_Ku|M",
        "pqveCmj{pDyOkmQ"
      ]
    },
    {
      "left": "PAK",
      "right": "CHN",
      "kind": "Indefinite (please verify)",
      "lines": [
        "gdpyEgy_pMwFpsCq~BlmDq|Ep_AuaGdXknFzw@abFjyCgsAhqDeXz`NugAtbEmwCz~D_fEnjCyrEpb@mdBqk@g_AaqAeaDauHg_@{l@mo@s^ycAeDaoBtr@qaAyDupAirA_i@upBur@coAwmBnNkrA|~@q~C~{Cs|Alo@_xFh@coNqtBqvCtf@_eBtY",
        "ecqxEmqrsMaEbvAup@loBkgAbmAojDftCkzBdiE}gCxcMg`BfpEwkEvyB_|NowAoiEj|@a\\hqB",
        "ueczEitcrMv`EffFbf@|rCzAxkCjHbdAlPxbAve@`{@dlBrjAnc@dl@lPzuB",
        "gutyEsweqMyOlmBSxlB",
        "ufuyEk{~pMjdCreF\\f_B",
        "k`qyEottpMu\\bcBiU||B",
        "ktryEmrmpMpMjpCp`AxfH"
      ]
    },
    {
      "left": "TUR",
      "right": "BGR",
      "kind": "International boundary (verify)",
      "lines": [
        "gyv~FadcgDcj@tqA_|CfsCk{@r}A_`EfjMo`BztCcxBphCqoHzgG_}BzhDowArfEqe@rzE",
        "_g}_Gy}feDjMfgCxm@xmA`jCziC~WdO~TbD`GdZ",
        "mev_GibodD}x@f_Bwl@|hBwYtpBk@`mBClG",
        "kiz_G}oadDpw@ptCfaEziCd}@xwBfZzuAb_Azv@ljA~q@d}@xdArIfu@",
        "ugu_GkkzdDw\\lvCuCzjC",
        "cjv_GahqdDtCvdA",
        "w`i_G{xjcDeMftB",
        "}ni_GscgcDtSz_Ajq@dbA",
        "{xe_GopkiDwRhtAk{@jdDq\\jyC}@nx@",
        "ohi_G}a}hDfMxuB",
        "gzh_GckyhDsFnXwAzW",
        "sdi_GwxwhDvAdXrFpWx}@`RrsAHn|@pLzk@e`B|d@jQhVdmAjAjpA",
        "{gg_Gq_ccDUnx@iOxy@",
        "{xg_Ggk_cDn@lcAl^dbAxn@vjAfg@v~@nRtr@",
        "klc_GmdubD{LxcAmjArrBwTly@",
        "m{f_GqqmbDrO|iAvdB~eCna@|~@jIzvB",
        "iwd_G{__jDmd@p~EsUh}A",
        "ksf_G_buiDnYnpH",
        "exa_GygabDihAnjQ",
        "oad_Gi|naDdIvnB`u@jdBfoCfsDrXzl@f\\ve@zg@xXnW_Jpb@qjAhTwQ`b@dDzu@nYx_@bFzd@jC|k@hDppBlYhqBtr@|tA~rAlcAliH",
        "y|~~FiurhDmTftAgeCfeIgEreF",
        "w~c_Ges~gDl}A`eNj}@dNn]|TD|_@",
        "gc~~FagmgDyYdn@",
        "a~~~F{wkgD`q@~q@l^r~@fb@`eCxMmGjHmP|FaRtGaPpL~R`Nve@zLzMvZquA~_@`eB",
        "ate~Fwpr`DyStaS",
        "{hf~Fan~_DfhDjaGnuCnwArfCfVn|Bgj@naAi~@"
      ]
    },
    {
      "left": "THA",
      "right": "KHM",
      "kind": "International boundary (verify)",
      "lines": [
        "{adwA}qrwRrPk}@r_@ir@zf@ce@|~@{MfsCpL~w@_SxO{l@dMmuE|yA}mJjLouB",
        "cj|vA{rhwRy~@e`Cqp@ce@qq@uHel@uQga@a{@kCi~@",
        "ehcwA}en~RhIufBzq@}sA~~@uqAnq@aeB|@gk@",
        "yy|vAkvb~RkRi}AkoCkzDsi@{tA",
        "kcbwAmy~}RjW_r@lnBi_@v`@sh@",
        "wf}vAavv}RoCgiBi^wf@obB_}@iTkr@",
        "sw_wAat_wR~c@wnBft@isAfRwyA",
        "k}uvAq_lvRwPyl@q~CmkFovB}oFmPihB",
        "og_wA_{q}Rv_AazC",
        "mwsvAyoa}Rqq@u{BmjAadAm~Ac{@swAwdAaw@yaB}@wcB",
        "ig~vAm}~~RfAox@~Rco@r_AybBtWwp@bR_lBjj@{uFdb@}sB|jAu]psAs@hzGj\\ft@iI~dJseErxBcmBl_AghC",
        "qv}vAqg{~RwO{tB",
        "ii|vAmazzRl@}t@rUjRzv@yD~w@qb@|YqjA",
        "oztvAu_szRsUcn@_dDazCg`@uH}P{L",
        "yu{vAuyg{RrKqsC~dCmqIhdBgfU`Psi@~Iih@",
        "mewvA}x~zRo]wnBc_AuqAwp@i}A",
        "epxvAsufvRnMgVd^_`@`\\mo@`Gg`A",
        "e|qvAqzvuR_OkeCmn@okBkzBcmDeXayA",
        "wtwvAy_mzRpQed@ld@}^~^gk@fAomA",
        "uwpvAswwyR_n@awEkZ}w@_AcCcsAanDq{@_cF",
        "qlvvA{uw|RrTupBxj@eaBtRaeB",
        "yasvA{{o|RUyc@MuTqQoa@ab@ag@qa@kq@mPqaA",
        "gguvAecuxR`\\cyAlf@obArm@_}@vf@wdAvPu{A",
        "gstvAyhoxRgFwpAgKir@Oit@",
        "qbuvAmlryRziCejD",
        "szovAgaayRqKcmByc@s_@sp@{N_s@cy@}OmqI",
        "c}qvAosiuR\\afL",
        "qzwqAmeipRe^c|Jsh@wwBueD}dH_^upBclCh{Eq_C~dC}bCaGcvCggEakHosRk{B}rCwy@eXq_CkGs~@qNys@_]}fCmnBalBkq@usIqjByfEirBotCwxC_rGwfJ{fBk{A}nAiUo|A|AknC_Tw`B}j@otDeaCwcB{k@{yBeNkqAm@mZO}cBw[w_Bq_B}n@ghBw_AseFa|@qiBc~@ojA}bJohL{kBkmEug@g}Bwu@gxJ{rAivGax@_}D",
        "}dwuAu`d`S{eBeqIsxHo_E_vHmmCm~AcvD",
        "udyqAskyoRbi@yxN",
        "yqafA}hcsRqmC_~A{cJ|UkwFveAofG|qDukJpfGg~Ov}GkuHj}@_xElcBal@zd@qeBbuAaeNl_IkwFlo@e~^wmC{uBk^{tBeaAqiCo`DewA}t@uv@rGubAlIwoAtfAshBfhEcyA|sAwo@xOsgBhIkr@fVih@|j@wyAtzCqwMt{MudC~yD}rBhbJkZzc@_k@hz@obBrk@kdCbOmcCaGk`Bw\\qbA_mAMM}dEi_A}{@wEkkAnMii@|Vqe@~]a`Adc@k`C~f@onFzXuoC|^idAve@{dA`R}_A_HajAweAcVaG}U`Gqp@ht@oYrJqWaIgU}_@mUol@oY}_@i_@kRu_@gAqDKy}@fiBeqAj}@adElbBeeIrzGcqE~zBaqYjiIyNdEgvL`Fc{J_h@qwMnYaP[ohAuB}p@pCyw@dWshBdbAuaAlGmrCqtB}YesF"
      ]
    },
    {
      "left": "MAR",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": ["eggvE`y}PuqBn`CykDtRkbBkvB", "w_ivEt|wPpw@j{D"]
    },
    {
      "left": "BTN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "caveDaxp}OluDbo@rc@dt@d~@xzAdvArwJf`Bf}CtoDheC`lEnbBfsDhs@jKyQ|e@iz@vxDyfKr}AyjCllCkqAn_Da]ltI?R?vsHae@qtBg_Ba{AywBeLi}BlxBknBnkAoN|_AtHj{@Rh~@}j@pa@g`AxEshAwPmeAcf@kz@mEadC~}@_{Cd`BupCz`ByaBr{CitAf~Buq@lzAyvAtp@kdEbQi`JoNkoD_i@anD}j@shAwz@q_Acn@qaAyEwnApBguA_}@kbG`iBgiDvtCgoFjeBe}Euh@yeKle@w_GhsAmvF`pB}|CxkBgLnkDxbBpu@{kA}@srBapAiyExD}gC`dC}mIhMqbB`Dcb@}@uwFnC{WrUa{@IsUa]_]sh@wRoc@uHqLJ}LgBk[qAi_@}KqWs_@|@oX`g@wp@hIqV~Eqp@b@sFdb@g~BtGi~@sJsfCs}AuiKu|@{fUk{@ulFg~Bi{C}wJs|CmxBipEuG_qB`GgeFga@irBaeAweBsjAirAg_AwxAmd@s}Bh]grEbrJwaQdfIm~TjpAcgX{hAilk@mSehKyLs`@k}BasHg@uyDdWszE_Hm{Lzk@muEvcBawD~]{vAeBq_CqX_gBsi@ghBox@}_BufAaoAsrB_hAkpBkq@{`Bs_AadAwnBsKquApLq{FzVmyAboAwy@jvGmnCf`AuqAwF{sBweAwaF{BapBrhAmsGnEyaBqa@imHmnAcwDehF{lKa^uyDzw@qtBjzA}a@ldBaQ|tAoaA|Iq`BkfAur@ueBlE_sAhiAmx@keCk{A?wpAzM{Vi}Atg@elBlwCieExn@mmBkr@yzJwlEseFgrEqn@maBeUofJ|hBS?ifEzjBkvGjvHcjEdkA_qBg@srBcQ{jBs^czAqk@{ToPaTwOelAkpAaq@}a@}t@aQquB_Sow@sUi|AquAgsCabEqjBij@iiApW}yZx}Ji_DdnH|TrhAlx@~fKug@`rGn]d{Fn]ddFsT|fIMHuu@fiCqXjyCkf@vmCyaBdaBkgBzu@a_CrpD}wAxy@iiMhgCenFkh@glJscHm{Dur@w_FaDynDd}Da`AvtFk|DjIgG{nK"
      ]
    },
    {
      "left": "THA",
      "right": "MYS",
      "kind": "International boundary (verify)",
      "lines": [
        "wc}g@g{nbRda@yw@fR}Npa@u[j\\qt@|@u}A",
        "igif@qbcbRm_Bwr@sgC}u@uzCyXqu@pAokBjS{v@oDm`A_i@um@{u@gu@od@swArKapC`q@qiBvEk|Fsh@ilCcGefAmP{r@kg@k[cxA",
        "yx{g@kl{bRvEkgAlVoaAzl@si@h|T}fFjuBueAfjBmyBruAmsDd\\y{@ri@ejCpGihB",
        "mlyg@}tvbRgK?}y@s}AeDyw@",
        "kywf@erbdRvU_|AfnCsfEls@_qBhmBm|Jh}AytElZuoB",
        "yfwf@up}cRqQo`D",
        "oesf@eyxeRre@wHjjC|@bs@wObf@us@dGcy@",
        "{vif@wleeRyMymBy}GwqK_@{iB",
        "_qjf@y`_fRhIafAnrAaoCtvBcy@bhHwPzfAgMhcAwZv}BsiAxr@}Jnx@fLzs@xRvDbAtv@rJpsD{Bns@cNn{Aus@",
        "apjf@q`}eR]g_A",
        "{bhe@gphgRbcDghEp`@sfB",
        "w|`e@c_|fRe]qtBanDacD{WovB",
        "cv_b@}uflRiJaeB}mAuhAmcCup@ce@_`@mnBwuDev@ce@wv@iTys@_^{k@mdAuoDyjEcnFwf@yiG{AebGu|AuyDayC}aJymMadD_eDcfEmeAagNx[uhIig@",
        "{zce@}_{gRlZmnA|oAkh@f~BcP|vCrJbt@dx@rd@~pAngB~rA`oCxDx|AccBdvAgsB`{Bqk@rsF|_@vbJtHbkE|j@ztBhInqBxn@di@tpBbYvbC`aAjfB~eOl_G|dA~g@dhAdNdfA}J`r@u_@biAmn@|qCihApp@}i@fWa|@",
        "e}ae@cargRu|@y}G",
        "mhce@ogqfR|IirAv_AicG",
        "gbae@g}lfReBcZei@ga@yW{kA",
        "}pac@}ozjRj^wdCbbCyaBpeAa\\vp@s`@t\\mo@bK_hAzVmz@pr@}@h}@jR~v@fB~|GkyBriBg`BlZy`C",
        "yqja@slehRwu@wlD_oD}cH}zAq_BqmBonAi}Bqt@ajCaRgzGelAgcB{~Dck@mtFoqBipFwlCgzE_cGe_TirAkvEi`@ipC",
        "mdib@mo{kRtXuqAh}@cp@vjAkf@~aAgu@pfAadC",
        "ofdb@ytskRs^_}@oD_EoaBkjBiUgjA",
        "}m}a@g|rgRfKa}@x|AokChgCouB~{C}}Ah{CwfAlo@sgB",
        "mh}a@meogRoDyuB"
      ]
    },
    {
      "left": "ITA",
      "right": "SMR",
      "kind": "International boundary (verify)",
      "lines": [
        "ajmkGo|dkAbz@}j@hgB_SzjBzKd}@fl@`GxDfLbObOtHxRjBxQ_DbgClnB~Rx`E",
        "kt{jGaszjAwdAtyDedCdvAgtCs}@ieAg_Bgn@s_A}hAsfE_UesD"
      ]
    },
    {
      "left": "DEU",
      "right": "BEL",
      "kind": "International boundary (verify)",
      "lines": [
        "abwtHe{qc@rJhIhJzBhJSrJaHpa@_gB`{@eBz`AfVjs@qWbEuqA",
        "odptHgm_d@bE_gBfkAewBnpJm{Jz`@hrAxxA_hA|i@q_CxEonLld@eMpv@|j@|u@`fApU?~s@njChgB~cE~qB~qBrrA_gBbo@bp@l[mGpLkq@pB_hA|t@vp@t\\kq@jfAst@nXwp@|@_}@",
        "eyntH{uwc@ij@kvF",
        "efesHixde@dBeMvGeM`\\s~Avf@umGdCupBpj@xdA`q@nNdw@cQh~@ea@pw@st@nDqk@hT}VhgBpCfrCpk@trAfj@|hAkGppFaxEvf@{Dnn@aFft@dmAjR~dD",
        "spcsH_h}d@sh@grEwGqLeBoN",
        "c~_rHskte@uH~rAwP`fA{BvdA",
        "m}`rHyjme@h^rsAno@~|@`{@hh@|}@|Kfw@wZnaA|qBlo@vkGlf@x`Ct{@j|@h_AnlCfu@p_Alz@irA~eA{a@leAzBbz@ld@jRnm@lEt{BhTrt@tSrJ`eAtSt]pL|_@i~@le@_U~h@bQ|i@xw@"
      ]
    },
    {
      "left": "DOM",
      "right": "HTI",
      "kind": "International boundary (verify)",
      "lines": [
        "eshwB~b~tL|jDev@rmBgUfbBdE~bDfI|lCw[ffKumDtgNsiA`vGdCpnCjfAtb@pa@p}DbnAfk@lz@`zArgDlf@~g@r{B_^psCmnBnXiYrfEgmEpyD}sKhc@{mAtsJl[ljB|^rmBxmA~nCzrEroAr}AnwF`zDz{G|mGbo@`qA`qAt_IbdAzjBhkBkQ",
        "iuurB|gjuLtCiqC|j@ex@~oDowAv~@cx@j{BcnCnw@om@rrBqa@j|FmErtFkq@jtBjHnrBr]rhBti@lsB|iAhcAnvAraBtfDhX~i@lH`OvyAftAnoEp_CbrAjpAtmAzpF",
        "irsrBjsruLsOcoBkq@izC",
        "wzppBvbvuLqqA|tM",
        "imspBtxdvLtm@fgF`lApjBdeBqv@dfPetPfz@kg@x|AqNfa@h`@nXxm@rcApVrrBmd@bp@u|Ahy@yrFjk@us@pdC}}Atv@uq@vtCyjFlwB{nI`w@cxA|o@ox@`QqLnwBphA`EvBreMrtGltBlp@~yBlPbz@kHbrDebAzdA{M~fBfCptD}LdkBrU~{DviA"
      ]
    },
    {
      "left": "NGA",
      "right": "TCD",
      "kind": "International boundary (verify)",
      "lines": ["mhynAu`ztAqc|@~tk@sc|@~tk@"]
    },
    {
      "left": "IRQ",
      "right": "KWT",
      "kind": "International boundary (verify)",
      "lines": [
        "{puvDsj~aHl{@ydJrmQshi@",
        "mwqpDwj_{GspDmtDcw[}j\\{~PmfKa_KooKkyB_|AwgLkxDoaTarMsiFayB_~@oN}{D{VyxAi_@wrJucFyzc@srOehGytEc`EofIwhJan^ce@wfJ?}mq@"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "iqpjDoov{OzCafBnkCmcCdvAg~Bjm@_jJ|h@q~ChgDauGhkBmmCxcBazA",
        "qkajD}pd{OyaAi}AmxBgtAavBshCmqDk`G",
        "qybjDij_{O~l@seD",
        "ckqiDqibyO}PiiAit@unCawCwib@sjAcbC?S?K]?_dFc|Iq\\wyB",
        "_wziDueb}O\\?tkBgKflE~|@~fByDbnAkr@lmCetCh~A}u@joB}Tz_BlFpyc@hlHtmEblC~~EdaB|aDdwBbyApk@tvA{Bl}BobB`fBfAb_EvPduD{`@~dDguAblCigCdn@aoAt\\ugAlf@ycA~zCkcCh}@ymAhhBclD",
        "_wziDkdb}O?i@",
        "gariDyf{xOdScxC|@shA",
        "qq`iD{qyxOutBhrAyvCdm@}vCcNkuB{aB{RmcA"
      ]
    },
    {
      "left": "GTM",
      "right": "SLV",
      "kind": "International boundary (verify)",
      "lines": [
        "iyxrAth|dPkwKvcBiaB|AqdBoN{aBg`@gyAsp@wiAwiA_xAojD}z@ukA_wA_y@{yAih@uvAct@snAq{AkxKqwQk`CadCmi@uaAqeBusGcEe{Av[kpB~yBsaDdc@uzAyn@mzAua@kAsItCsyAhg@_o@dE_r@yPgjMajGcdCe|ButBq|CehAmcDi{Cc~Swe@gg@o`B^qX~Rme@hnAiYhZug@rJm~AhJg\\`GebAhc@uVbQi`@bc@uQbj@yOraCowAre@os@_d@qj@s}@a|@qf@ygA`Q{|@tl@qeAxY_bBug@y~@swAlF}zAjbAicAvrBaQqz@}sAetDqyCyP_j@a[}bArKcbBbc@qeAjXseA{RiaBqmCcmCaWs~@vwBgG}n@g_@eMyE~~B}rDDg@"
      ]
    },
    {
      "left": "TLS",
      "right": "IDN",
      "kind": "International boundary (verify)",
      "lines": [
        "tu~x@m`luVuSoXwQqkAsJcwBcZiiBis@gsA}tA}u@wy@mEokBl[ui@f@cn@sTgtAk{@yn@}UwwDoNg`Auh@gK}Ti@m[_^yx@s|CkyDuzCcwBiTgWeXuRgu@gWiyE_]sxI_|Ak~B`E",
        "hr_x@wr_tVl|IakEzrCokDr`@o_E",
        "huex@ci`uVpb@uqAlnAi}AftAafA`eBw{@fjBqk@rgB}Tnm@zBnmB|Txc@?voA_SrJyD",
        "fepx@ykqtVyn@cnAejDi|BkeA}rA_i@keBqCquA"
      ]
    },
    {
      "left": "TLS",
      "right": "IDN",
      "kind": "International boundary (verify)",
      "lines": [
        "rkuu@}imyVzvCqQpsEhrAdjBvFr~As^lnA_s@dw@khAdXu{A",
        "zbzu@q_nzVzMm\\ve@qVtg@el@z`AqtBvoAapBbcBazA~zBks@tfChAvgKfiBby@iKz`AmYfc@aH|]wF`{@jSfVtq@",
        "tclv@c{ryVwFuoB}_@kpAueBq~Cq_CegHshAisA{l@iSmxByZob@sTm[q_A",
        "vafw@eokzVcDdxA}Vjf@}rAriAu^fj@sJri@i@|~B",
        "bdaw@en~yVdc@vkEh|BjfBvwDzVvvEyd@pkBoc@jeAsi@lcCetC~pAmcCjh@qa@`g@uGdaBpKzj@cErzEykCv{A}[t|J{aA",
        "zvaw@w{xzVuHvxC",
        "dmaw@_btzVxDlcAtr@z_Bzu@pv@dc@|t@"
      ]
    },
    {
      "left": "BRN",
      "right": "MYS",
      "kind": "International boundary (verify)",
      "lines": [
        "apiYeq__UuaBmyAo`CnNudClyAkmErzEu~D`oCstF~pAwfGza@}tFeBavFmq@ekBuHgsCdZe{c@dwKu}E~{Cwu@voAkf@hrAiy@nx@cnC|B",
        "_pl\\cwa}TlnNvj@j{NeXlqFgu@teNckEhuF_hAzfR}iAtwAwp@jv@sqA|bC}bJb[oaC",
        "oorYk`g~TvQis@zpAq`BpZe`A",
        "w|qYuea~TwQuyD",
        "ctnYsoq~ThS{u@ljAapBb~@uoCdD}gC",
        "ionYmwm~TyCewB"
      ]
    },
    {
      "left": "MYS",
      "right": "IDN",
      "kind": "International boundary (verify)",
      "lines": [
        "}vyY{fefUzGcdA~jKqoGnDkrA",
        "_giYivzeUw[ylBqp@ar@gg@pLol@~]c_AfB}xAcp@yaCwbC_nAsi@",
        "iqxYuccbUdr@}u@hbBk[|yAyy@h^u{BhPofGpv@gtCvi@olAfl@we@xfBqWdbBwe@jkAg`Anc@_gB",
        "qswXqwoaUoTquAq`Aa\\goAeXkiEwlF_zDwZ{mEnCseEk|@{pA_qAuH}iA",
        "ccwYs|{dUlbD}fD|@_i@",
        "wxqY_}kdUeq@spD_xAmmDe^q~C",
        "egvY_ywcUtc@ebAlJq_A`GkpCljA_xGxI{tA",
        "ycaYahccU_j@emAkiHikH_dAupBwt@}`AwjAcn@ofCur@",
        "m{sY}fjgUpManBx`DidFbt@unF",
        "ummYgr|fUgBywBqa@euB}fDudE",
        "{crYozceUhNgj@t^sUfnAqU|kGg_Dd\\i|@lGg`A",
        "w}qYqnbeUcE}j@",
        "mxqY{cjjUnOmyAxi@wn@vy@ec@l_Akq@x`DseFdbGmyNlrJa_JlyAgrCbo@clD``@ytEfCmdB",
        "wrlYuw~hUmUm}b@}_@w{@gzAccBaR{kA",
        "_soYswshUf_Ba_J",
        "}ulY_k|gUu{A}iNKu`G",
        "omoYenwfUx~@acD",
        "q|lY}orfU}oAg}C",
        "{ejYwlveU`BebAxZkeA",
        "asdYwqoeU{Rg`A}}CwxC",
        "c_{Xy_kaUzRwn@rt@ij@`a@u{@",
        "cjzSken`UeXg`Asy@cc@scAzBu`Ctp@uxDjfB_mAhTe~@|@}}B}Ke`AbFywJ`zCetCxX{wFi@gtFyc@{uU{qFwmEpCqyAxvAufA|~BexAxaBmmCgBkk@}j@_wBszEgdAcy@grFcwBsmGymAcgPwdAukBqc@uoCwo@sz@ew@oa@i|Bqg@si@iy@}j@guFmjG",
        "menXymllUre@wcB~p@cv@",
        "symXkaglUyJmkD",
        "a`|Sswh`U~H_}@vZqv@dOew@",
        "_efQonx~Ts_@_dEipDgwKk[a`Gii@wcBazBmq@yhG{VaoBwe@m`HuxEym@bOi^h}AewBzaBclBnCyl\\uxEkaHupBmgCwdC",
        "caqQafk~TxX}tA`lFq~CftA}qD",
        "wuyNw`l}Ts@bdAqvAt|Ag}BqL{jC}u@{_CwZu{@jRu{BxbAa|@xDolAwe@qVew@gL{`Aym@ybAywCcdAkyBtg@sqE`cD}rA~]yZqLeW}s@ugAitA_gAap@i_AgVq_AoNihAcZyaCuqA{_BmdBysFoeJwpAkgA}zEqiBy_DqiB",
        "gmkM_tv|TolAovBkcFyiGmn@{jB{w@g_BciGcjFssAieCoX}yGgl@oaCwwB_sAomBzM}qC`fAkoCf_BmdBh}Ash@~|@ec@fkAqWvoAaFfiA",
        "kj|Nqkr}TtRxbA|_A~eC",
        "galMuco|T~RioF",
        "qllKgjs{TwFjgAqiCp_Ass@nEyoEoEo~@fM_bBjeAwu@fV{sBxDatIafAosFq~AelBg|Dq`A{bNqv@}fDugAkf@e`B`QeaC`HqgCij@ii@ykA",
        "g{uK}af|SrmIpsB~aHtcDziC~}A`lAnaA~_E`cFlmApt@x}AxDr`Fkf@nm@pAtm@qArlAs^jkAui@`kAew@b{@afAp[_qAh@qqGhi@anBnvBs`@xkNjh@t}GcF`yB}_@v~BcdAbwCcwBj|MykPjaAui@jmDyMhIod@",
        "{dvG_s~yTqa@_qCe}AccBcxBag@oeC~@kdCj[yuC?miBafAkoDszEejBk{AsiGm`DogI}sB}oLcdAgaEbFklAjR{l@~Rcj@vFicAmPev@q`@gz@{w@}o@{`AqWk|@_i@ypI_fCc}IkkAwoAwtBiIadCnYajB?shByZa_Cgu@smAcOc~Ai@yqAnY{g@t{@",
        "wjnKa_{{TlPtoCvk@bcB",
        "_ctHm~xoT|KueBbc@ugBbZayB",
        "solHopnoTwa@}iAyr@{j@wz@ce@mv@k|@sh@srB",
        "abrHevlpTnNgjBp{@ytCpy@}hBbuAey@llCyDlhCxc@nvBxdAzdBn`BdlCp}DrbAxc@lp@aQpBu|A",
        "yvqH{gcpTgJimH",
        "{dqHo{mmTl_B{gy@`p@caDvB_i@",
        "el|E}p|jTqU{}C{c@_sAshAqk@_q\\ygIggKubEkaAkTohA{Bwt@xe@yC`mCsu@~]i{Com@qyAsrBkuIqnUqp@gtCid@}aKgb@ylBcrAokBuvAquAgfAwcB{a@wxC",
        "kieH{yayTdT_qC`fAuoCz}ImnNjh@_fC",
        "emtG{nzwTkQk|@e|A_fCwEaOueKa~[e^ovB",
        "gn}Gold}Sni@gl@~gGmmBfxAqkBhJi|B",
        "{l{Guu`}Sk`AyuB",
        "mg}Gc`kwTxfAidFvv@g~@rcAox@fz@i~@xYkpA",
        "kwnFejotTob@kyCixSo~]uxMivJqxBmnC_n@srBclCwd[{B}zF",
        "ofwGge_qTrTioFrmBidFf~CklErZowAvP_xGbjAikJhlByhHbfJylMtHszG",
        "gksGmappTsoA_nFsi@ysF",
        "_eqGant}SHywBjw@upBpdB{kAznJcwBvbC}iAxbAcmApjBe_F|hBgsB`mFwbCfhBcmC|j@guBlo@{mJxy@upBr}Bk{AlhG_fCbeMkvHbwCg_@p~B_JjScy@",
        "evpGarp}SyM_{B",
        "sv_GeswsTzDwbC|iAufCruJqyHxvA_pD",
        "kl{FiyksTaeBauFec@ybC",
        "wn|EmxljTpAowN",
        "k}`EstciTq_BswJyrS{~O_|BijK",
        "e_qE{gueTfKu{BbrJcfYtf@ojCvFwdC",
        "iloDqaccTu]gl@wq@eMwnBeD{_B_}@chHe{IirAalDi_@s{DsKwgKmfJaxj@",
        "orhEmdkhT`HwnBzl@}fDphCqdIrs@}qD",
        "gezD_~pgTyd@ekAunEuqCmjE{jOiKuzA",
        "mvfEwmggTrAylBly@s_Ah|A{a@riBeXdkCwdA",
        "kpcE}|{fToWayBqlAwuF",
        "wzaE}bf`TbeAy|H|^emAj{AifBddJgeGvxDejFdkCa_Hbd@chH",
        "aq`E{s``TyYssA{MmyA",
        "wrqDsn_cThImP~s@g~@bFga@",
        "{fnDi}xbTwo@u{BmQyDug@ymA",
        "u`oDa}ubTdXkeAR{X",
        "{iiDaplbTk]_qAomBisB}h@wdA?}_@",
        "ermD}dcbTbDafAb[{l@bp@_i@|i@qv@~IssA",
        "aheD{pwaTkzBqfGgkA_}@cn@sUkR{V"
      ]
    },
    {
      "left": "AUT",
      "right": "ITA",
      "kind": "International boundary (verify)",
      "lines": [
        "sik~G}_jiApa@irCfnAz@ntA~@dzBbdCjoCnyJnlBz`A~|@ih@jfAcZfoCce@pdAug@bz@ij@dx@Th}@tzAlQ{`A`QgrC`WydAvp@afAff@ea@h]ce@tTgtAfE}eGtm@yaBrgCox@zkA}@dl@lPhj@fVhgAxOvoAh@hi@{MpWqb@`\\a{@pa@maCfK{`C`m@_gBvgC{u@pgEguBnbCkwEjfA{|FbQ_uCzUc|DlyAc`Efa@kfBbEuzA",
        "k}t}G}}rfAoJkgAscAuyBk]cdA_^qzGgtBwvEeaBohGe`AyrGqMw|Lm`F_xReMuhB}f@wgH",
        "ga|}G_r_eA|PylBhOug@jVec@j]}_@~Tis@`Fyw@",
        "q|t}GyvsdAukCosESUso@wn@{[qv@{Hu}@",
        "wwz}G_}weAzk@u`I",
        "elx}GwzieAmFyy@sTwy@?USg@?Ukc@otDoHqsC",
        "{jy}G_hefAlGyuBteBeiEj]}sB",
        "ify}GyxcfAqCen@",
        "{jy}G}abfAr@wF|Acn@",
        "{jy}Gu~afA?gB",
        "kex}Giv`dAf`@{}E|_AmaErEe~D",
        "kim|Gu``bAqGcxAc~@evAwcDekCyO{XmTadAeScZi^_J}_AbF}VeDs_EqtByzE{`A{kAur@orGksKyl@wnBg_ByoLaq@}tL",
        "ue`}Giwx~@zoByiEvRabG",
        "oa`}Ggo~_AlPg_BjcE_}Md~@w{@fj@j]jlAziCx]`\\vu@md@r@ebA",
        "aa||Geeg_A_wBszRmGmmB",
        "gyq|Gkps`ArOigA`eAqrDr@k|@",
        "u|p|Gqlo`Aq[ybC",
        "exo|Go`aaAR}~@`Sew@x}@siBfQ}~@",
        "}`o|Gsi}`AgV{uB",
        "mpn|Ga}uaAtMuxEjW}hB",
        "mrl|GecjaAgB_}@mo@soEiIgjB",
        "_rw{Ge{_lArTwsHlBcJhN_p@fz@upBlPmx@",
        "aqv{GootkA}_@ujJ",
        "u}t{GegwlAlK}t@hc@u{Ct~CgbJngAavl@vpAg_OlgDilKnc@wbCtG}zF",
        "}|s{GewplAi@yy@}YccBoCap@",
        "e{e{Gg~rpAb`@gpG",
        "k}b{Gka_pAy|A{{R",
        "ime{GslgqAnJgj@ldAowA`Vyn@xEohGphDmsVvEi}A",
        "azd{Goo{pAgRc|J",
        "en|zGm|orAgLo`B"
      ]
    },
    {
      "left": "FRA",
      "right": "MCO",
      "kind": "International boundary (verify)",
      "lines": ["}pbjGqtel@hq@owBrjA_eA", "arziG}r}k@gfAmHchAw`@mjA_|Aab@mxB"]
    },
    { "left": "DZA", "right": "MLI", "kind": "International boundary (verify)", "lines": ["ezpwC`vl\\TM\\e@HW"] },
    {
      "left": "SVN",
      "right": "ITA",
      "kind": "International boundary (verify)",
      "lines": [
        "m{|zG}}rrAbp@U`k@tJve@fVb`@za@z~C~GdVfOxiAfs@lj@|sB",
        "ainzGkvjrAuBjyC",
        "wlnzG_|erAfRzrEvbB`xCp`C`dCbmBlwCjjBl`HvjAxtCbYplAdEtqAhw@xbAvcC|rAnhBpwAf_@`ZleAxaDr}@mo@hiA{a@r{Cce@RUTSxmAuqApuA}Tfu@_t@",
        "w_dyGus|pAfV{_B`HizDpa@gvAnWkmDdx@qtBn`C_{DlP{}C",
        "{~_yGgdzpAmQoiDmmB`zA",
        "cf{xGa~arAhJ_sAjGs}@bw@_Vn{@yWhdF|qDzuHjiQ|x@hlBlcCvmCxc@kq@jg@oNhj@lPpk@lo@xMh_@l{@r~AnaAmpAnOa\\dDyDxDcDbE{B`FsAhgC{hD",
        "gxzxG}e|qA{LcwD",
        "yotwGuk`rAzuB}hB~~Bxm@~wBhk@zwAxv@tiHtzDxtEtSreAgr@b|@kk@paAkmDjQcvErUsgBneCkvFn_@yz@|gCwoLxjQaqNjr@ebAld@s|A|Agw@vDcB~JqEtpAxn@vfBlvBllB`}BhTdfH",
        "m_qwG_qmqA_IizDobAqhEs\\wtDgDa_@",
        "yqeuGilfsAu|AvuF",
        "oohuGqu~rA|Q`sH"
      ]
    },
    {
      "left": "SWZ",
      "right": "MOZ",
      "kind": "International boundary (verify)",
      "lines": ["`eybDwf_cE_jq@_Ug_Or_AeuOdfHanDxm@scSzlAeuDk]emNumEseDsUkwE|i@gfF|hAy_F~_@kcEaqAg_B~~KevAprDqjCxaD"]
    },
    {
      "left": "RWA",
      "right": "BDI",
      "kind": "International boundary (verify)",
      "lines": [
        "by`MeilxDnNk]dn@sdE",
        "vrkMauuwDqCwcBoWovBce@stB{l@wxAiiAmoAud@u[_a@{Xyw@a|@w\\mcB",
        "`pbMobtxDda@w\\zvAi_@bp@yb@juGmrIp`B_oEvFmlE",
        "xwbMemsxDwFiT",
        "vmcM_`wuDl[aq@xc@yi@hH{It}AamBbFoo@",
        "vn{Oc~{tD{Vi}BcdAqtBy`C{~BapBirAe`CgkAigCmz@qhCq`@sdA{A}_SeYewMifCs_Nzk@w~Hug@cy@R{a@aQ}@}~@",
        "f{gMy{jwD`FugA~}AabElPolA",
        "`|yM_eyvDoCojCuhAqiB}`JiyG}j@}Kyy@eB}h@iU",
        "|xhM}z`vD|@a{@dXkfAxy@gkAhdFw`EvxAweBpuAmaCpv@mnC",
        "b~hMif_vDeDss@",
        "jwyNafupDzMwdBjdDozJri@ojC|_@{fGr^ccCf`AiqBzw@ekA`\\qCrhA`GtsAmTvDm@f~BufCnlAce@`fApL|hBpuAf`AhThgAeMz`Ccy@bmAmFzuBgv@",
        "lkrOaabpDgpRojB}iCylC{VujJ",
        "f`zOgwrtD~h@ojCnCkzC",
        "pncPuhgtDmPyjCyc@w{@cy@cZcbCuSey@om@SufA",
        "~m_Pk_xsDrAqk@`U{aAxtA}bG`Q}tB",
        "~`cPaeosDkRwp@m[om@ebAayD",
        "dpbPqcrrDnUuwBbi@eaF~pAipC",
        "f`gPalarDeMwxC}sBulG}KaoB",
        "l~bPodmsDpAq_A",
        "xbgPwoasD_g@{uBiiA}sBaQ}gC"
      ]
    },
    {
      "left": "BGD",
      "right": "MMR",
      "kind": "International boundary (verify)",
      "lines": [
        "ozt`Cie_tPaIs}BcxAsqCevBmxBkdByw@m~@hJe~@hJuxRv_F}wHz`As}CnNeqm@vzA_{\\elB_|DlPoxJxxA",
        "{w~aCswnrP~}@ggEjeBuqAjeBoYtgB}KnlBgj@rr@_t@pa@oaAzl@wmC|VegG",
        "clvaCiigrPwjGimF",
        "_ovaCscarPzAudE",
        "{np_CepcrPogEn~Fs_Bxc@_|Ahh@q_CrqCeuAdn@ymBdc@{`BiTaxD{a@ayByFkwFrk@myBi@clBq`@mjFmmDeiGssAuyBwdAeN_gB",
        "gdlaCucqsPda@o`DhzFmxBp{Fyn@d`Cqk@nmAiiA",
        "}yjaCusjsPii@_oE"
      ]
    },
    {
      "left": "ESP",
      "right": "FRA",
      "kind": "International boundary (verify)",
      "lines": [
        "wgfgG~gtIuVxM{YxOsxB~SilAxlAy~@frDekAr@sbCoCwgA{M",
        "im}fGhtyHmFnbAuXdkAq[~]}iBpl@wu@hIae@mPq\\]i_@t|@ih@nuB{Cdx@",
        "y~hgGzugIlf@|}B`LheChYjhAfGnbA",
        "yj`gG|k}G_cBrcGmi@laEgB`{B",
        "o|dgG`ooHnh@h|AviBlp@vu@nb@v[dcAlFxmA",
        "qcseGrcmGuIdjD_]`xCmy@fiCe}AjpBofCnmAys@kr@ijEm`G_mAcnAsdEg~A_xFybAucFzVofCprDS|iA",
        "}eagGjayG`QbdA`HldA",
        "wpneG`r_FgyBvjEkvAxuEin@jiJis@ptBixArhBurA`[{pAuq@oqAyaCmZblC",
        "yrcfGzq~F|e@dkCbxApjBh|Bfj@vbDdNlsAht@tXfiB",
        "eibeG`tgDe]`qNcx@~mF_wBtxEm`AfkA}TrfB{RlwEw[xm@mo@jfBsNfu@",
        "q`oeGpgxExNniF",
        "yiudGxtkCsDj|@ql@r~@_x@za@s`@yEu[_Tyj@eB}o@vXqlDlzAii@hfD",
        "}hdeGdrxCv~@z`N",
        "iwedGd{tB_Mhh@mVg@cZ}JuY~GsnFpqFmcAbnBaaBluEwFh~@",
        "mpudGvwiCrE`|@",
        "yuldG}rvCsPblBs}@vvEcGxlB",
        "enodGg`iCfHdjDxh@`oCxxAt\\ndCqL`nDzvApeAcdA~Ynm@nYfVx}@be@jVowArdA}iAr}Asi@rcBlEhNlKjr@xh@|T`qA",
        "gfcdGdug@uMnfDgsBfiAkaDbjJkEhMuaA`_B",
        "stndGl`~@~|@`a@rn@hj@zL|o@",
        "iicdG}{rDsSdbA{gAlbBu]fu@gt@lxD{tB~lG}LfjB",
        "q~ldGklzCvGlxB",
        "cyjdGv~aAug@fu@",
        "yaldG~tcApmDjkHpaAbvC~Iz}D",
        "ueddGjwwAcsBdpIgBf~C",
        "a}gdGxggBvsC~ItLzu@~s@rgBrDbp@",
        "_`adGlcnBk\\j{@id@]og@wGyd@dc@iElZ",
        "iwedGvuqB?ldB",
        "q}scG{`bFmE`dAyx@fjBauA|~@}_Bdn@wxAj|@ehAlmB_]naCoYzsOeTxn@i}@jfB_N|s@",
        "wredGcrxDhN|~@db@xy@|Ulz@",
        "e}ocGhrF_gAvuFsZdc@o^`\\m[bj@wOrnAyTz`Akg@lPak@`Gqa@he@o}@~eBq{AljA_kBnc@qkB{L",
        "}medGxo^`b@joBrc@~sD",
        "ivlcGext@qtAj`B}mD`eCoc@xbBa_ArkI",
        "k_xcGi``@rJldBry@ftBbi@j~J|aCdaNzMjwE",
        "akocG_}nAcQ~{BmTn]uXnC_YaAkStLukBxkD",
        "kgvcGqddA`]jpBdqAvmBxuDlnD~Hx{A",
        "el~bGcdvGevAlyAiuEhhBqyBbwBwqCnmB{Shs@kAvy@aXt^ywAcZk\\rqCy@|`W",
        "ioucGqqhFvp@toE",
        "c~ocG_m}Ac_@tfB",
        "g~pcGiezAhm@jmFzC|xB",
        "_yocGqu|B}Tp|E",
        "}npcG_xuBxO~iW"
      ]
    },
    {
      "left": "FRA",
      "right": "AND",
      "kind": "International boundary (verify)",
      "lines": [
        "o}hcGiklHnjDcrIvVmcArr@qeU|}Bfu@dn@wcBf`@kpClw@ss@vY{WxI|{C~pAjqBz`CbdA~zCpU",
        "odgcGgtcH{r@mvDcDs~A",
        "clgcGqn}GrFudE",
        "el~bGcdvGsh@giCiuFe_B"
      ]
    },
    {
      "left": "FRA",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": [
        "kilbGyklI~GuQxKiKrNoCfRfBjb@_rBpf@gcKng@cbCxpDw}IjXsqCxC}sBt^{_B|gBgtAxhFaqAr_Bmz@fnAuyBtc@{kA~HssA",
        "}}ebGs~{Ptx@eiE",
        "mzabGqhrP}KugBquBklE",
        "gxebGkseQrIqaApByuDvGih@|cAag@ly@cp@tn@u{@db@}iAd]q_CpLq~C",
        "gddbGyhbQ_s@qiB",
        "e}abGk}nPvAejB",
        "wbzaGgq{OiNmaCen@ccB}fCs{Dck@ccB{FycB",
        "ic}aG_w~QyDkbDsa@ulG",
        "}y}aGyx{LzgAmmD~l@}iAv}BsjJt^maEpBobB|cB{l@j`BeaBzeAwwBvUsrBht@s}BlPwdA",
        "ypzaGeriLmxAgaKuNkcE",
        "kl{aG}j`LpZgfH",
        "g|maGqlgKqLwaDkRweBwa@igAorAihBwsAgtCic@u\\g{Acn@s_@w\\_b@mbB",
        "u~zaGm|sO|ZysF",
        "wblaGmvaOcFgfDcZpAw_AnlAovBzw@}t@wp@kyCqfG_i@mmBcF}~B",
        "__oaGkmtN~gAm~GfRshC",
        "kviaGqdjNm@g`Aq]_i@gdBis@}_@mo@mAywB"
      ]
    },
    {
      "left": "FRA",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": ["s~hbGyj_K~aAs_A|gBi~@hxAcdArEjTzH~|@?lP", "{h`bGakbKkNbmC}m@~pAumArJgoBmcAoWafA"]
    },
    {
      "left": "AND",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": [
        "el~bGcdvGrd@xZd~@za@|y@vFbYis@`WRlcCjfB`fArS",
        "s|qbGebvGhgAylBzaBiTt`AjzBxEpb@tb@|hB~nEgsDhmA?jf@ufAhd@qyJ",
        "wnqbGkuqG{LykC",
        "u|ibG__fISsjAaWwdA_s@mz@",
        "gikbGcsbIdDmPjReO~RgiA",
        "gz}aG}reHcD_r@q\\kgAqb@kf@yb@cZm\\{a@}d@aiKo}@ggEqgDybAqRsU}EuQ"
      ]
    },
    {
      "left": "TJK",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "gzcjFswybMeNbwQim@n`BghCr{Dmo@pkBydA`aF}t@fjBqdBxuBiaB|u@ecGlz@cyAri@aeHb_F{_BfVqqGkf@wwBjRkwAlcAu~CduDu{ApjAwoBbQepBar@sbBevAegAexAes@amC]wjH{a@sfCwkAyxAc~Ai_@sgBvQmhBh~@}n@xxA_qD`mEe}EvqJ}oAvdAgcBlf@iuEnv@wuAnx@}iEzgGkhEfrCypDza@qxDap@ksLabEacBoN}~BvFqcJnaAayBoC",
        "uw{jF_k_dMiOlxBshB|_Ks@riB",
        "gs_kF_flcM|k@bxAhfBzvAlq@xMzv@g@~r@~G~f@|j@`aAvuFd^xn@hwBeDnfBmnAt`Bwp@zfBtqAxR~fB",
        "qvbjFiq`gMiNnlCicAfhBewAr~AqjAtpBm}Hjb`@kvIbyZ{Lx`C",
        "sq_kF}iqdMzuBjrL`BpjC",
        "mufbF}kbhMgp@g~BidBcdAekBmx@{u@isBwQetCamDkdQmjAgu@mfFoNojBgkAoy@sqCgoAqpHqnBtdEgiChqDukIzzHmmAxlBqfGnuPqiCr{D_qDtoCa{Et{@_vBqWewAmcAcnAquAi}AmnAur@uSgv@sJex@kRyx@_i@qhByaBw_A{l@sy@iTqoBfVq|@fkAejCv|Haa@fl@_n@r^erAbQs^{X{Rel@ifCqiBgk@}Kce@|s@g`@leAaa@~R{g@qAueDzMiiKeXykDnlAedEnwLooDdwBslUlxBmrQh@apBiVgcBkz@siF{gGidBigAsqByc@wxBi@cqDdl@}y@lG_t@`Qmd@~h@aq@lmBi_@fl@ocAdw@M?_@RC?_gBxaBey@dcBkRhqB",
        "g`cjFu`egMtHjnC"
      ]
    },
    {
      "left": "CHN",
      "right": "AFG",
      "kind": "International boundary (verify)",
      "lines": [
        "ajcbFseogM{b@dbAqlLltFgo@jh@kInbB",
        "cvsbFc`agMlj@pjAv`Af`AtfBllCzMp`@rIt{B`]`\\jg@tS|}@jpAzWlP~TpWbNtr@",
        "kdfbFyflfMgJld@aaAdmAiOtg@",
        "_bibFojgfMpFzvAd}@dpGpB|gEnb@`oAjbBpaAv|Bdw@xmAncAhi@f}AnNbdC",
        "mufbF}kbhM~`BxmNjHnvB",
        "mkzaFyefeM{WtlF",
        "id{aFcx~dMd^dvArwBpLlcCueB`tB}eEjyC{cKdgBelBlxB_hA|gB}rArt@uoC"
      ]
    },
    {
      "left": "AFG",
      "right": "TJK",
      "kind": "International boundary (verify)",
      "lines": ["o|bcFi|yeMeI~s@", "o}bcFqr{eM^fu@"]
    },
    { "left": "AFG", "right": "TJK", "kind": "International boundary (verify)", "lines": ["iofcFkbufMpoAzsDf`@|yR"] },
    {
      "left": "AFG",
      "right": "TJK",
      "kind": "International boundary (verify)",
      "lines": ["mufbF}kbhMisAlxDodKb}GovC~oDqgK~_X"]
    },
    {
      "left": "MKD",
      "right": "GRC",
      "kind": "International boundary (verify)",
      "lines": [
        "eli{FueijCr_@mwP",
        "{abzFspqiCcd@ybAi}BufAgpFmz@ymN{XqTaFcoDcy@ql@ucAmlAwsBmLabBuWquD",
        "m_jzFkweiCpLkgAtEuEn\\m\\lo@yZlp@mo@fjAcnBt]kpA",
        "y}}yFycshCcEqhCs[a_BqEeUybAejB_gBgjBar@eMew@bDol@iTwR}}A",
        "{ifzFiapfCrC}o@tEyfAdx@mkFjQq}DrKox@fWcOhqAaHtT}KnBkf@",
        "op~yFca|eCqb@ebCkyCw_Faq@wmCkHolC",
        "cndzFehqeChK{l@~\\kRt^kIvPoNrsAinEfLom@",
        "w_wxFgotcC}Sq|BwGus@k|@ymAafAsUobASur@sJwy@a}@u{BcjFSSK?ISqsBssAyaD{}Eg_BgtAmn@sJoSa@qfBmDmz@eX}h@ap@{x@}eBg_@gx@ylA}|D{wAynKwOw\\gu@}~@_KyX",
        "it`zF{togCdCcmA~S{w@d`AmcCjS_fAbEmxD",
        "sb_zFalegCoXis@{AguBiTg}C",
        "au~yFuwlhCfVckE",
        "m_}yFw``hCkGccBcPevAmZcwBUobB",
        "}vxxF_kjcCdv@gcI",
        "kerxFgibcCkG_^{a@{VwoAqLqW}K_|@koD",
        "c`uxF{lxaCnq@}{MnAuV|zDyrGzXmmD",
        "cskxF_pw`CIavE{`@{rEii@q`BojDkbFuq@}rCiAaxC",
        "girxFmo_cCzByxA",
        "iulxFwcvbCoZ{u@cmB_qCae@s}@gCec@",
        "qmmxF}hh`CxEwaDpc@udF`Ns}A",
        "ukixF{w}~Bm[}t[mdBczL"
      ]
    },
    {
      "left": "MKD",
      "right": "KOS",
      "kind": "International boundary (verify)",
      "lines": [
        "svx`GqafbC_x@bnB",
        "soz`GmrbbC`u@rz@`XpZ",
        "wkz`GkhrbCxq@heGhAn_C",
        "o`x`Gg{_bC_Kr_Akk@by@cPhgA",
        "_jz`GexyaCri@veBlu@uHzu@gl@~h@aFdDbbA",
        "{bt`GilvaC_}@txE",
        "{`v`GsroaCvEdlBlVte@xXti@vaLpnJ`v@vFr`@}Kp`@uQht@uHv}ByDrLzAzj@jHrIf`A",
        "us{_Gk~|`Ckg@plGkFpp@mg@bt@qQjWwxAnx@_|B`eBy`Dp|EygCtlFea@~rAwG|h@]no@",
        "ukp`Goxw_CxfAnuC`xCbpEnt@bhAbz@f}Cpl@xrDloBrzLhsCdhQdcAd_DrmB`yBteCt}@bsHzkA|lCvFd}De{@~y@sQf`C`TjTlBftB|`AzdC~fBrm@tv@xz@pfAza@heC",
        "atk~Fcjf}Bc`@b{@y{BxuBiZxy@",
        "imq~Fk|~|BnS`g@x}AxbAf\\nm@~B`eB",
        "wxl~F}{v|Bi]pjAirBtoC"
      ]
    },
    { "left": "MKD", "right": "KOS", "kind": "International boundary (verify)", "lines": ["ifz`GmvrbCmD`M"] },
    {
      "left": "MKD",
      "right": "SRB",
      "kind": "International boundary (verify)",
      "lines": [
        "_jgaGkgkgCoDjzBi^lmBuw@bcBgoAvzAgl@`QgiBnCk]xZ",
        "smraGik|fCvFxw@h}BvcDdlGt|Yp\\jwE",
        "y|daGuwseCiGz_BsHbnBau@bkEa_C~lIsKbmA",
        "oqkaGm_zdCpVdbAngCzrE`G|j@",
        "kifaGm|odCcA~xF",
        "okfaGmbhdChT||BdsGnaRxc@hpAppAlyAfk@h}A",
        "sky`G_{tbCuYpcA",
        "k_x`G}whcCAJyBnjBal@~yE",
        "ipy`Gaq~bCtC`uH"
      ]
    },
    {
      "left": "SRB",
      "right": "BGR",
      "kind": "International boundary (verify)",
      "lines": [
        "uv|kG}exhC{NcnBq_BshA{u@RccCvg@a|@lEkeAiKaxDq_AI`HwRfKg`@bFce@mGaGyMssAmdBaoB}}Auh@}u@gyA{jG",
        "e}|kGkethCnEq_C",
        "g|`hGgl~hC_JpaA}_@jz@wtAzvAm_@fj@{fAjnEyy@|tAivBlz@chHzsBuqBfkAy]bDk^mEy]mPeOwFcOqAiNpAaNvFmTtSgVlEsUmEsUuSqA}@gBi@gBh@eC|@elAxn@knCxDkqAhh@ql@r_AwhA`wDys@dmAw`Axw@kkAvp@qpA`g@qpAxZ_s@f@igBgVso@lE}kCdaDghD~pAcgC}_@aoCaoAi_Emz@kzDiKs^uQerAa}@}ZcOo`BeMetDgBqlAeM}sAgkA}j@ykC{UidEiJg`B}A{iC}_AmeAayAwn@{lAkgA}_@{~B",
        "mlzgGwpkiCcOlz@q[~b@yJ~M}iBvdA}d@dn@yJby@",
        "saahGgsbiCjD~eC",
        "qltdG__jiCga@}|Dgz@}|Dq`AshAgH{CaeAcd@snHmmB}mAwe@ys@}j@i_@_hA_]clDmVkpA?SIU_@?quAsqAcuDieGio@}_@sqBel@}j@_^qa@_t@sc@}hBsZ_r@}lCg~BwlE_rB_pE{`AinAlI}gApH}`@~fB}o@nrHqq@bnBa_AdvAwcDjdDsmBbvCci@ve@mp@jR_qBjRwp@rUgsAxmAigI~}Lm[du@iO`^s`@veBcDt{@",
        "}pzgGsgoiCnCzuB",
        "ajwdGch{hCn|A{uM",
        "cvsdGyzphCaRgj@_A{@ib@k_@gj@itAiOoiD",
        "wbtdGukmhCrKcnB",
        "_jgaGkgkgCcn@ovBqBkcGcZupBowAkyAodFobBi|Ag_Bca@s~AwKcmAyb@meA_cBoaAcdFitA_aCiTy|AdX_@?ewAxn@_gAlnAueBz~Du~ErbIaHbZo{B}TuyF_mA_`AeSgyCa\\wtApk@}cFyaDoy@irAwQcFkR}@_R|@wQbFmu@~{Ac}A~rAyhGpsCgV|TsVuHsTaRal@uf@yc@gu@e}@}}Cih@{`AmmBq`Bub@ew@o@{tA"
      ]
    },
    { "left": "KGZ", "right": "TJK", "kind": "International boundary (verify)", "lines": ["{nlrFkjemL|@s|A"] },
    {
      "left": "KGZ",
      "right": "TJK",
      "kind": "International boundary (verify)",
      "lines": [
        "a|uqFanxmL}Txb@yiFrqDk{@~|@upBzrEwzAhrAufBdn@q_BcF",
        "}llrF_hhmL`bEmtVxDgzE",
        "oihrFk~lnLdN{kAhrBym@`oB~Hfl@f_Ah^vlE`fA|qDffE``I",
        "adfrFuxfnLmdAudE"
      ]
    },
    {
      "left": "MKD",
      "right": "BGR",
      "kind": "International boundary (verify)",
      "lines": [
        "mlr_GqnuiCmKhh@_YxZiZfVmQj[e\\tyDwrBfoHiUxy@aaH||O_aBnaC{XfSu`BrkAwrDtqA}bClkFyiRfgR",
        "wgn_Gm|cjCq[bp@ii@hT_h@xMeXxZeD|~@",
        "_vr_Gmk~iCpHz{G",
        "qkh{Fc~zjC{vAetCgsBsUcbCr^mdC|Kme@_SobAkgAk\\oNec@vFs~@dc@i]jGitLlO}~ArBufBk]oc@eDii@fMwdAjz@qb@`SmrAhI_yAyDkuAkRufAu\\oT_^iTeaB_Oga@c^kRwyAug@qaAev@obBmqAipCmcAgrCnCsbClmBmVpaAyD|rC}UlcA_m@ve@ijFvdC}tEnaA_iAlf@eX`\\k\\~gAmNlQuE`Gin@bOg{AqA{j@tHwmCbbAwnCpm@_uC|IebAzMybA`p@_@|@uqAdDkB\\ck@~Ji^fa@ab@jeAw@pb@",
        "qao_G}ghjCzWp~A\\|j@"
      ]
    },
    {
      "left": "MNE",
      "right": "HRV",
      "kind": "International boundary (verify)",
      "lines": ["ajwbGo`poBfdBa\\nhEza@pkBoCt_Bqk@pqAqaAzeAaoAhUmo@nm@okB`eAa^t{AtG"]
    },
    {
      "left": "HRV",
      "right": "BIH",
      "kind": "International boundary (verify)",
      "lines": [
        "udzdGe~pkBcP`dCwjArdGiSphC",
        "{u}dG}i`kBzVfiCv`ArsA|wArmA",
        "up_cGinwnBktAjsIkqA`mEy|Ohca@o_DxpIwyAtqC__FtkG}tAlwCkl@~yEg_@ncA}`FtbEkfA|KuuCcFw{@`QyfAjgA",
        "sy{dGozukBl@xw@n^vp@~Rvp@",
        "ajwbGo`poBsZ`eBaQn~Emk@l{AuChCA@{gC`}B}e@ncA",
        "wx_cGqw|nB`GfhD"
      ]
    },
    {
      "left": "UGA",
      "right": "RWA",
      "kind": "International boundary (verify)",
      "lines": [
        "xwmEalyxDr\\c~AhTocA",
        "x`pE}bqxDoWeaB{c@_qAsJ}sA",
        "vdnEuggxDnNkfB~]qiBpLihB",
        "`c_H}fruDgMmbC_r@ghCcjFmgLqLq_AigC{w@_sAkpAmPo_@yaBqwDobBc~Fi~@ybA}}Ai_@gqFce@gtAqk@a\\ap@kGwp@{Bwp@qLem@ox@q_BegGcuGugBupA_pBebAkh@}JwxA{Lod@cQqPiTsQqUcn@ugBu^ce@}}Ag_@kaGkg@cxAus@ga@q~A",
        "|haG{m~tDhGov@BWza@mcAb~FunDbbCyZb`GyMjcCw{@bcBgjB|a@ayB",
        "dziGelvtDk]sr@kzBod@ebAow@cc@yx@eOgu@",
        "bifGqqntDxOgiAvoAadCnNij@",
        "~qnGgxwsDuHcbCu^gsBigA{_CwdAq_Bgu@ugBeZyvC",
        "ldnG_}osDpLgzF"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "saqyDkfrhNhJucFrrBugMfoHmjRnkBgzHjpBmlEfVghB",
        "wsoyD_ckhN{l@kbF",
        "cm}xDmjxjNjg@wbCjkH}eR`zB_pDpuA{kAniEwyBxxAekAf`AmyAbjEgtOtqB}~Mh|AqhE~oDs}BnwA{j@naBnl@",
        "i}{xDcqnjNeNu{BoX_|AcFs~A"
      ]
    },
    {
      "left": "SRB",
      "right": "KOS",
      "kind": "International boundary (verify)",
      "lines": [
        "ey`gGcl|}BrTs~AvLu{@dgA{uBfo@s}@xh@kh@dwAa{@",
        "o}cfG{l~|BmKpv@kg@ld@a{@fa@_fC|s@auB|iAqdAdOgpAug@}Yur@oEojEuf@giCamGshN{p@cvC{LuzC",
        "k{wfGkcj~Bc@jRkMh~@",
        "{jxfGupg~Bho@tfA|^{BvyAtHlpAvQbDdXzq@ug@zdEcmMrwE{xNj^ihA~b@e`CxOg`L~w@obBnpC{_BxfIs~ApqAst@~m@clB",
        "exneG{js|Bc@sjA_}AmaCi{DaeDenEwbCmwCoYme@zl@gAh~@",
        "}cdfGap`}BlEdbA",
        "khoeG}ao|B^g`AdNufA",
        "ovkdGmud{BoqAwcOa|AulHujCykC}z@zZghAba@m_AziCimAdaB}mD}s@eeB}hB}VsiB?mmB_^ywBka@wp@eh@ea@}~Amz@cj@ew@",
        "y_meGqgj`CpKugBpjC{_B|`EaHrdEob@bwCunDfMcdA",
        "{ojeGmzd`Cga@{vAul@gtA",
        "mzvdGod~`CbKafAd]oaA|jAmxBz[s_Ava@ggEnC}|Bhn@mz@z_@BdbCNxgBnYxpErsAp_BhTb^~RrQv\\zPfBx^u}@lVihB",
        "wyvdGory`CU_qC",
        "s{ycGkzzaCf_AetRfb@cmCh}@q~AjyD}gEdr@sgB",
        "svycGuwsaCu@qkAiBcuC",
        "}ipcGq_ocCn^_yD~O_b@h|@{|BfiCis@zu@pb@x^z`AzW|iAv`@h|@pQcDr}Bfa@|OvF~JrJrNri@|PrJbZaHpu@}j@vVyDvnCt}@p|JhvHvxD~xFpdApv@x~A|KleE_^``BvZ|yAx`CbsAxqJhgB`dCtuCbF`qGqrF`lDy~@",
        "glmcGyn_cCUuzAwyAumGgAkeC"
      ]
    },
    {
      "left": "KOS",
      "right": "MNE",
      "kind": "International boundary (verify)",
      "lines": [
        "ovkdGmud{Br~@vxNp`AtnFdX|s@~cAhs@`{@dD~w@uHp{@tHx`Ch{C",
        "uc{cGgaezB_m@zrEegBxhFcj@n~E",
        "_eadGadpyBzWleA|a@zy@xlA`bChr@~q@vzB~Ij_BafA|BqDj{FmdJl_Aoo@fUgK~_DhrArcB`fA~q@~TxcB|@xvAoPfpAbFdqApjA"
      ]
    },
    {
      "left": "SRB",
      "right": "MNE",
      "kind": "International boundary (verify)",
      "lines": [
        "_ouhG}adtBzoC~|BprDoCvcDaeB`eBmbDbyG{xYdv@_gBn}G}cG|xGyoJjqAsjA~nDejBreAi~@jgCi|EbGeLvxDc`EngA{jBtp@q_C|{@ctGbJ_fC",
        "s{mfGivgwBpBmq@hsFyuDbnB}qBtkAq_Ctg@_qC`IinE",
        "o`lfG{scwByTmnAid@_r@",
        "shdfG_~pxBtRemA`q@om@b_Aqb@v{@cn@~l@_}@`bE}vJ`|CsvEzGeK|rGwyJ~QgmAlPsfAzWgnIjx@}qDplDofIfnCi_K|bBkfB`zCuH`qFj|@",
        "eu~eGktaxBsK{rEg`@kgAylB_qCwVkz@"
      ]
    },
    {
      "left": "HND",
      "right": "SLV",
      "kind": "International boundary (verify)",
      "lines": [
        "wo~vAbml`P~Mi_Brd@opFnxA}`EdaAy}HdlBq}CrrAs_H",
        "s|zvAj}{~OxEsc@vZu]~m@{b@jx@e^b}@qLr~@nDp|@pWpz@gfAfWctEpo@_cBjlA{f@p~D{W~v@a[`tBs}CtbAsx@d{Aaw@jmAqVb\\oBbr@eEjaAiSve@cv@",
        "s~qvAj{c_Pss@gz@}gD}xAqp@qp@{Mgv@",
        "gltuAhov}O|@u`B`_BwyCn_DyaCzyDy|AhoD_h@",
        "kpquAhm}}OcLo{@ci@ciAsc@kvA",
        "{bcuA|gt|OffAwk@vhBdDzeBrd@~vAnBn}@_aBlP_eCjIc\\rd@_l@|h@a^ds@_Mf_@fAdJX",
        "kz`uAjiz|Og[miAwe@m_AoDqu@",
        "knauAl{b}O~RaqG",
        "q~`uAfif}OyNylB",
        "woptAzgc|OhIg~ChrCoxMhSirGtWq{@nt@{v@tRzCdN|@`BpBjCbD",
        "oiotAjmi|OkMie@{Ve~C",
        "m~ktAdlpyOtHy|AfB_Nv_@evChAsbB",
        "k_atAh|qyO_H_g@mtA{\\yObJeq@zv@iU|KuzBbE_T}AsUk|@",
        "mtktAt~zxO`HucD~x@{fA`gFqzAvhBsyAfeBcrBnuBaeB`zC_s@",
        "mnjtApdeyO_e@{dI",
        "iegtAzvc{OGv@iBtX",
        "{hgtAhrd{OrMyEdcA}^zgApC`kAhTd{AzKlz@mP`cDsbAbcBgChwAbv@",
        "ahatAvssyOtGmv@",
        "u|vsAxebzOimAmj@gWubAoDwjAqU_cAam@kp@cc@_Tcj@aXgk@_h@e^wiA",
        "e}|sAx|~vOdl@}y@lcD{{@biAuq@dRo_@|_@kvAjSae@vqAyaBhsCapDbj@}lB|yAjw@jzGb}B`eBl^pfBog@dbAx]|x@t}@tkAlu@hmBpU|fFcDxpBdM~_JztCxkDrc@vmCk`ArUm_A",
        "yxwsA|eiwO{Bg{@yh@q{@}~@ur@{q@y}@{By|A",
        "kuxsAt~nwOtBo}@zWgyB",
        "szusAh|swOaMs[k{@moAiOqo@",
        "{jxsAjtywOtAuL~Ekb@ly@g{AbKwi@",
        "wgssAvnexOqiC{{GqWo|A",
        "cdxsAnqfzOlG}p@nMwp@nO_g@",
        "kmtsAtyhzOcQmF_d@?we@qCgUoRsAug@",
        "q{usA|fozOdB}z@le@sbBpCul@",
        "_ipsAbpc{OaGueDgdA}sB{m@ypBku@wzF",
        "uhnqAxgqvOpa@{yApu@co@|iAe_@brAcJhoAtMrvBzjBpzEdkN",
        "w}lqAfluvO}i@mcC"
      ]
    },
    {
      "left": "HND",
      "right": "NIC",
      "kind": "International boundary (verify)",
      "lines": [
        "cucxA~}afOco@cd@q}BqhCmyB|oD{{@v`@_YeaBuMg_@id@kSgfFw_@u`Bqv@emAmtAkGwKy~@k`B",
        "kvwwAzlifOw{@ccC{wEo}E{sAkd@kS_H",
        "gucxAz{|eOBbaD",
        "qj~wArlsfOf[{pBziBybB`lAaiB",
        "w`~uAxn|gOmDeYkSqPul@yP_s@gk@ei@iX{a@ga@oMsy@{fAqsCqL}_A?qkFsYuyCkq@i{CwjAq_CefBogAmmCfEu{BhoA_bBpnBm_ArcBa_C{iDqf@cFm~ApMwf@mFetCkoCog@gU{zHsKmlDcZ_xAqp@",
        "ak~uAxq~gOhI_bA",
        "w~jtAz`wiOeEaRu`AjSg`AczEe|@}{@avAaz@ak@}gCkHmt@cQgfBmd@wsBstAiy@sbB{LyqA_c@a{@y_Fg{@qiBuzBy`DuvAigAuwB_dAyuBor@{~Ckl@aaBa{@qzA{fAiw@g{@{CcZ",
        "wcxtAfy_lOfdAp@jeCpbAtdDyPhwHoxLjmDifCbe@_i@`\\{uA",
        "mj|rAb~knOeSuaIoZsqBkk@k|AgoAugAi}Acc@gxDcp@mwCyaBalLqxKegIwvEmi@q`AwZshAme@qjAoiA_hAqnA{k@g{@qWcu@s_@_}@aeAmj@}tAgdAi}M",
        "c_ktA~qwiOJcP",
        "mzitAj_yiO?qe@k\\zAiFuH",
        "}ijtAttziOnNit@",
        "kzetAdcajOoc@qnAajB}}B",
        "ipftA|rfjOnMy_AlF}mB",
        "e}jsAjqijOaKqLme@cj@}cBur@w_BeLogAnb@m[t|Amu@pVmwB_Y_{D{|@}gCmFea@i]",
        "sp|sAfcekO~y@ghChkBihAf_Ca|@`uBsbBrm@kiC",
        "qh{sAzjkkO}Jox@}Uyw@eDitA",
        "{hnsArspjOhIg~BfzAerApCwJp@aC",
        "kdnsAreujOoC_qC",
        "iybsAjteoO|mB_nEn]ymB",
        "il_sAxh}oOy}Au|NeMwuF",
        "_`asAllsnO~aBoaBxXcd@pQcz@dEqj@",
        "{k~rApv{nOg[wyAgj@}rAsKmzA",
        "qm`sAjyepOf`@qoG",
        "ab}oAbfnpOcNcz@w\\qk@e]el@klAstAeqAmo@a_BqL}qDbd@}d@fLsnAfl@qb@jg@yHri@aRbd@i}@zVixAuHskDmnAk`BiIylVzhEmiBdBagEwe@_cBdCkg@|Vkg@pu@{QnXi_@pWsw@|JclI_QmkB{D_vAqMce@sIoXw\\so@_gAsdAylC}IyaC",
        "mjcpA|s~pOzGqjBllDyfJ`Qmy@",
        "sbfnA~_frO{dB{`@o}@iaCuaB{~CajAafAy~EiqCiZqb@{k@_{Ae_@u^e|@yOsUpWeNdb@kf@zNygI}t@sNhJmcBbn@kc@rJsOsI_oDgl@yrAqk@k|@kq@g{FkkHqv@uqAg[mcB",
        "qginA`vorOtHo{AluAwnCxCyhA",
        "wmfnAto|sOyxAsxk@"
      ]
    },
    {
      "left": "HND",
      "right": "NIC",
      "kind": "International boundary (verify)",
      "lines": [
        "qvvzAld~{Nt{@_mAt]ioAff@e`AzqAo_@",
        "sgmzA|rk|NyOsqCmhAs}BigBk`BkkB{z@",
        "adszAxks|NpLgqAx]a`@jpBakAt]ox@",
        "krjzArdv|Nw}AwBme@cIoh@_`@q{@di@o^eT}E}}@",
        "gdrzApzo{Nf[orGjb@niA|_@xCd^{l@z[akA",
        "aapzAldv{Ng{@m}A}EmjB",
        "cuozAx~mzNeLqqA",
        "aapzAvqtzN|J}qE",
        "sgmzAxm|zNmhA_dD_OavA",
        "_lmzArbe{NjCysG",
        "sgmzAl|e{NkCyX",
        "qilzA~ax|Ndv@k|@",
        "irfzAzyx|NyrA`RsgAaGyY{a@",
        "a}gzA|y||NbY{{ArOeb@",
        "iywyAbsk}N?om@kkA_ZcsAgLsbAu]wv@axCswBuzC_Y}xA}TfKgk@xOaRzL",
        "gc{yA|eu}NbFwiCb`@}qBt`Act@",
        "ycqyAta}}N?km@krDhz@mdAgW}t@qsBuO{zB",
        "a~syA`ha~NtGm_Ah[km@ft@qV",
        "}ceyAdw{~NuaA_kAg{@inBwe@_{B_@irB}^ro@o]x]ehApk@uSm{Igp@{`Ca`BvKyC}mA",
        "cfoyAb`udOnn@iaDnbBghCzrC{zArPjRd|@|o@hKjBbNk{BljAgPdrAhEbsAw~BngBg`A|tEi}A",
        "mh`yAhoueOolA}nBelGm}G_y@qeBaaAutJ}EqcD",
        "sjjyAnpf_Odh@mjAtgBscBxS}nA",
        "qnayAhzy_O}^yhRkr@b_@sx@i@cnCy]",
        "amhyAxsi`OhwAanC|[eObUqVpGw`A",
        "ei|xAffi`OmYyi@{m@?ur@vu@ix@fj@yqCpgAov@ocAgBul@",
        "aygyAbw__ObQkl@vEqWnNyTvk@ec@",
        "}ceyAnp~~NoYvFsy@z]",
        "q|cyAxq~_ObPc_@ho@}JpKmjB",
        "cycyAf{a`OmBmhB",
        "iuayAr|eaOf\\kuA~]kw@pf@co@nyC}rCj]wjA",
        "cuoxAvmmaOw`Ag_CqhC__@gdHh_@ciAqa@oDsmA",
        "sc}xAprl`OtGms@zMm\\zAmY",
        "sxxxA`~x`O}E{zAcj@mwC_T_d@_]eX_Y}^}Jax@",
        "scyxAhc|aOf{@{{@naDuk@``@yn@pGc~Af`@yvCzCgdA",
        "ujfxAxosbOuRgdA{vAy`DsnAahF{hCcrBy|CuuAauBqqA",
        "cgsxAhfzcOpKuvBldBaqFj\\ykCfLkgMfk@vVlyBtQ",
        "ycqxAvy}cOibAmrB",
        "g`jxA`szbOjb@aaAju@k`AxZy~A",
        "ycixAxq}bOm[w}A"
      ]
    },
    {
      "left": "COL",
      "right": "ECU",
      "kind": "International boundary (verify)",
      "lines": [
        "qcwG`fc`NlzFwmJxuDcbCtsCmwDrhBg_AfiCq|@||Bc}Ah~AqyBdl@iqC",
        "gjvF`yx~MnPsy@bwBuIp_A{VfiCyaCvcBeb@",
        "i~tF|r~~McOeaByZuvA",
        "mljFv}j~MlnAgyIna@gk@ru@aeAtlSckQloBmrCby@uvBbcBqrJxbA}~B|eRklX|~B}eGbOczLd_D_hLh@{bA",
        "aqhFzup~Msr@iyAwFy|A",
        "_|iDdjrzMzBa]|~@u{@r~@iUldA|@nbA{Kpw@gaAdw@upC`]kdCfAs}B",
        "ekiDbjszMyO}^",
        "uucDhflyMh@kyCrqCuyDp`Mwg@jcEucCpzG{yKlyA_cF",
        "q~|Cfv_zM{Xs|Bg|DiqN",
        "oc`ClpaxMp_AaaG~mHisA|oSag@|pEow@ryDmZp~Cs_Ad`CggDboAkyE~eC_xSri@{tBdn@a{A`\\o`B",
        "ye_C|dhxMoXquDeC}\\",
        "edyA~lupMxZi}@buDokDxmAcwBfu@u{B~]ifCjIcxC",
        "ycmAhfjqMmG_fC{KoaAiTcy@mxDkzCs^{a@kRs_@}tAkpBkRmdA",
        "ynmAlalqM~Icz@",
        "kei@|dirMsJmzAirAy`DwfAckRshAmmBu}Kp_AwpMoNug@fB",
        "}jmA~dyoMdDwdAfVks@naAmd@jdDeb@bp@__@",
        "ycmA|l}oMcF}fC",
        "e_fAdeeoMt|Ac{@hiAcZtpO{aLvmA_^dwBm[vcBycAlnCizCliFyzJ|tAks@jxDsyFdaB_oDjh@afBt\\axBrJ{iC",
        "oucAfbroMyD_qBkq@g}CoPykC",
        "uydA|~tuMhTysA|_@gbC~lG_nFt}@uxDnC_yF|KylAdc@ufBdl@s~@phCigCdmAqiBh_@yxAzBs}A",
        "ug`AjnfvMwF_gCguB{yH_SqkB",
        "weu@jghsMxy@cwEp`@qoHnYwxAbdA{aBtzC}eDtg@euB",
        "kml@~cmsMqAi~AuwFzNc\\elA",
        "gyo@tqvsMvFymAbcB{}E",
        "_xm@vcdtMg`AaqL",
        "{tOtvulMtg@k{BbxAyaBbxAmnAvg@i_Axc@knBfeG}dHn~EujJhs@euCzvAwxBnaAw|IhpCykKncAmrB",
        "w{LtifmMqLwnCk|@olGeMwtB"
      ]
    },
    {
      "left": "GUY",
      "right": "SUR",
      "kind": "International boundary (verify)",
      "lines": [
        "qsk_@dr||I_y@zWscAiT_bA_r@apH}nHybBg_AcqC{WaeCcFibBuRgaC}x@",
        "{hl_@pav|IkN~}@",
        "gxl_@p`x|Itc@byA?nv@",
        "{a{^|zp|IoNzu@ga@h^gp@hJosLtHmP`S",
        "yjl_@dzt|I|@jf@",
        "gik^fki|Ieg@e`Buw@oaBogAgkAavAu]c|Bzm@w{FhoE_iBli@oK~Cme@xYaRt}@",
        "qsd_@vdl|IpB`fAr]rs@|z@~Ij{@i_@vjA}~@nh@lOxYjh@bF|t@",
        "wbr^t`r|IzBanBpWcnAv_Ait@h{B}`@",
        "yos]npt|Iic@u}@mlE`cF}dA`[yqAwF}eAkRuqE_|AsrDuh@kuA_h@yc@meA",
        "ctt]dky|IhIqu@xSyo@dDir@",
        "}zm]bq{}IcFwoAc_@ihBuq@mmNyh@i|CeY{aAyXom@{S}t@qKywA",
        "u~q]~{`~InSs`@pyA}~AtSih@",
        "}zm]b~r~IkaBgqG_XknCkGo_D",
        "ueq]psz~IviBmtF",
        "cp`]jww_JeTcxCyw@ugA}pD}|Ae`DsfD{eBspEqLyiF",
        "snb]~}}_JhPm{@t\\a{@nNcmA",
        "gtpSnhp~Iwy@hhBec@hoD}T~s@eYt]y^~SciAbZk`AzK{r@{B{oBs^_i@qBilApLwg@^gwD_~AmmB_HyrBjeBujAbaCsJfWwQfLaHdbA}Kj]c^`[uT`GgUnDe{Avp@olBh^gl@rUmwCjmFs}BnpHeaA~fB}rBbeA}bCbd@qzGxO_wBlYq{G`dCynMz{H_vBvdB}bIbzKg}DnvCw{Et|@mrOtpAelGxmAk`C_J{cC{uA{jPe_PciBmdAkzBkg@g|CgLofBlPc~A|`@kaBtRiqB{Wc_Bu|@qnAufA{pAcz@anEem@wtG_rB_pD}hBc}HyaBe`DwnBokBaq@ouBuGomB~r@ytErfDa`GrrAcdAtfBys@hgBauAbn@cqE}i@qnCmcBayB_qBegBisAurEg~Bgk@en@{RmmA"
      ]
    },
    {
      "left": "SUR",
      "right": "FRA",
      "kind": "International boundary (verify)",
      "lines": [
        "impVnm|iImt@nYm~@ptBs_HtyCwj@~h@}dAdvAyw@th@qwEdbA{{@jf@e_EntEygBlz@_zC`Gg`ByXawE_sAc}AaQ{_CdWer@r_Aqw@|pEcs@nlActA~gAqiBzWwsBocAajB_g@}}CxDolGdv@okKp}D_aTpkBi}CyPycFuzBujBk\\__G?chAhJikExlAkxCdDkvBiTkiB|@irBfiAga@l{@}Pf_Aqa@tq@csAjSwbW?_wAjf@y~@~Io|@w[msBieDc`@k\\e{AiKexFru@kjBoPoaBke@{tD_rBi_KktIse@uSueAeN}f@wZsbAg_Boi@kg@{wFkgAqdB}eAorAgy@omGqfGcaJ{jNmlC{xB",
        "yzdUdt{hIsd@nBg}E~pCmzLp~BscAr_A{~Dn`Cwj@faA_~@btEm_@jfA}Uzb@kkAh~@myBvz@ihAxm@",
        "{ppVzw{iIpBrT",
        "wleSlpaiIqkBcbAqyBii@mlB{MesAa\\qjFabFeyFaeBuwMhSqeG_q@slCaq@s~AaHwmAld@oxApvAcUnw@",
        "cffUrjuhIdIz`AbTxcA~JzaA"
      ]
    },
    {
      "left": "ARG",
      "right": "BOL",
      "kind": "International boundary (verify)",
      "lines": [
        "xc~eCxvgpKew@z~DewBxuD_rZx_XufAhgCi}Ad~Ps`@r_@qnH~hAmaEb`E{~BxmGq~C~oO",
        "jg~cCjaesKda@tlBjc_@bhHhfQ`{@vzAbZpjAbe@bFzL",
        "jtufCvkk}JoP|t@qk@vPew@tGew@nYshA~hAiqD`jGkeCzfHouAdwAomBnm@sdE\\gkA~h@ur@cP_}@IwjFvf@yy@tQ_SxwAyn@rnG",
        "tpfeCrvt~Jnm@j{[RfB",
        "dwqeCrh`dKk]`fAytEv`G}s@r|Byc@|eQ",
        "figeC~u`eK`\\hfDdc@byA~R~Sxc@fBdkCvz@lxBpUvp@tTxl@bo@~Tvn@fKhj@rU|_@`eBpu@v}If_BdlMfbExdAro@|~@l|Bzl@`m@lgb@loMxkE~uCd{GraIztCryApi\\tlGfaMzBlxBpv@p_NrqCnnAkI",
        "x_heCfvq_KiInl|@iIll|@",
        "dkgeCdqlcKve@hoFhs@lcB|oFtaH",
        "tcweCjcvsK{MnY",
        "xtveCz}vsKtHxmA~]rt@~q@lo@v{@pe@vy@jXdlBnvCb_Fj}XlxDrvUt\\|Vdn@xO~f@~QvFt^",
        "~t{eCjsonK{a@`kIyy@zpL",
        "hwxeChqgoKdD|t@zVt]l[xZhTnm@t|ApeZ",
        "rtkfC`e`jKqv@luFseFluLy~Fjuc@",
        "rvzeChhzkKxJdf`@pQzbs@",
        "rdrjC`prgKur@hsB_cHzVevAtkAgtC}n@{hDhT{iCzqAox@bgC_r@lcAilI~dDqk@d}@aSdw@cc@pg@a|AxNafAmEayBw\\s}@mE{bAgWqv@yr@}~@km@k{AuHw~HpyI}qB~xAwmC|c@od@pVmcAboB{l@za@i~@s@ywBso@ybA|FcdAhrAgtAbbCelBdqA_qCe}@kyAuoAquAcj@ccBdB}~Btw@giAhs@}|DteDwe@hy@cZl|B{`AdkCuqAdvBwQzcCcOns@",
        "jsifCngyiKjGvo@dn@hrBtHnx@",
        "jkqfCr{vuKg_@teBgMlyBiTbdAyDxbA",
        "vaofCtebvKpb@rsAfsB`oC~zB`pA~pCdl@loM|hAnlCfl@~{AloAtr@nNzsDyd@p_AzBfl@`fAbkEd|TjpAreD||Br}BftAl{@`r@toAtSf_B",
        "hqnhCtt{wKiKfiC",
        "~dnhC|~_xKpCpiBhdQis@hgCfM|}AbdA|yIdwM`kE`wDvoN`_I"
      ]
    },
    {
      "left": "ARG",
      "right": "PRY",
      "kind": "International boundary (verify)",
      "lines": [
        "ldlhCneb{JaHdc@el@dNcdAi@u^xDu\\xO{Xnl@kRbeAyZt}EwD~l@gj@byBwvGhsLyaBrhBi}Apj@gj@|t@_hA~yF}_@bnAwwDlvCirAriB}a@prCwFveAgVrsA_g@zjA{w@dm@ur@sJ{u@ih@g`AqW_sAle@?si@mo@r_@ug@pj@m[rt@}Ij}@",
        "~jbiCx|szJcQnlA{`A`zCi~@tpAcmA\\apBcwAsgBgb@wnBvp@{tCpiCaHfa@",
        "dalhCd{`{JfBhi@",
        "|lbmCxhkwJsUbsAu\\xs@ycBz`Byw@dwAyc@lyAst@jeAelBl[srBdCshAlPa{@ve@iiAnbAgu@dbAiiAnlCi|@rgAq}DxlCqm@`q@ugKtwTwaFn}EcwBpuAm[\\a\\bQ_qCi_@mz@dMi}AndAseFpsBg~BlzAo_CjcCkgAnx@ekApVi@v\\we@t|@gl@|t@}TxD_Sfk@yn@dWew@lPqm@rUkmDziDqaA`f@keAbZst@~h@sUrrAq`@pXsqCelAmeAnvBkpAsAshCqj@q_Af`@_JrU",
        "lfbiCtwrzJpCbd@",
        "zaxnC~rqtJqA~h@{c@hx@upB|wB{Vjw@ob@d`CitAr_AyaBrd@mnAzp@ueDdtKmEdoCsUluAug@x}@_}@rhA_}@|}Amf@ldBuSxqByDteCq`@rx@sqCby@a{@xbBu}@oDufAe\\ur@q\\qAznBiKxhAmYlv@{qHtzH_g@lyA",
        "|lbmCrabwJ?dfH",
        "lclpCtcdsJgsB~cE{u@bz@}hC`yAec@rd@}rAhJe`CriA{uBldBquAjcDacD`jBox@nx@ueB{w@cmC}Ts}BrU{u@hlAga@zjBolAn|A}tAnrAwy@tlA{Dxm@",
        "lywnChvmtJlGt{B",
        "b|upChherJgMx`CmbBrrD}}C|pE_gBldF",
        "ncjpCbu|rJ|~@pmF",
        "dvypCnmlqJ{Mz{@kdBt~BcQ~y@",
        "xoupC`etqJdGplJbCttD",
        "dglqC`kxoJwdAlaK_fCflEar@~pBuHt~EsJdc@sfEfcBob@nEsJrx@qv@dkB}TxcAyDdgA",
        "~gypCdncqJdMh~G",
        "f_rqCbyeoJuHly@{a@taAwcBbyBwe@hbAmGtw@",
        "v~kqCjlqoJlGt}E",
        "l{pwCng~bJiTlnAqb@h`@ap@`Rw{@ve@oxKlpKg|DfsCcdApkAg`AllCotFbcj@u\\f_@wp@zNoYve@_S`p@i_@pl@oWxwAcFv}Hk]p`Cw{Xfmd@qk@reEug@t{@upBh|B{a@v{@cFle@i@ztBih@tzBykCxhFen@~qCsrBpqDkpA~bG}j@vz@_i@fa@}_@zl@}Kr}A_Sbz@owAjpAwdAplEgsBveBq|Ef~Bw{@fy@wbEjrFg~@nvCcp@bUyw@nNij@lT_^re@{u@~fCsjAfmCwn@~aAocA~bA}_@vp@iThrBmz@`iBwQ~{CsSn}@ce@`l@shC|lBm`FnnF{si@dieA{XzoB",
        "|`oqChzomJhK~_Cf_BhdH~]ttCpL~rM",
        "`zsqChjpnJocAhhN",
        "puqqCrs_oJtHndE",
        "zitwCbjwaJi}At|@}`JprP",
        "rifwCj{jbJdBhrBleA~fBhfDtnDtp@fjAxc@dnAjIteA",
        "vrzwCzkeaJoC~|@ggE`qL",
        "~etwC|{taJzBdmA",
        "vaj{Cjqx~IqAeaBye@ii@ipCa\\qk@ocAkRssAmeA}hAanB}_@s}OaqAaeBlFaqAzk@gtA~rAyrGzbKqjArA}vLf|D{@`BguBv|D_zClxBsvKzhEkpApiAevAvbE__Ah}AgdHnrGufAxwAkh@tzBg@lnNoYpvAi~@be@afApVis@ri@sJly@",
        "rbzwCh`aaJbOpjC",
        "jbb{CfbglIjlBrKphEybB||BaQdw@r}A",
        "xki{Cnh~~I|TcvD",
        "dnq{Cvdd_JyDu|@qb@my@mo@gVojCs_@a\\gK",
        "loq{CrwflI}I`{E",
        "ndq{CtsmlIjz@jx@vcDr@zeI{pBjzB}PrsAu]p|CmlCrjAkh@diCjIbnBj{@xaBxbA`eBh_@rxGmp@|sByDh}Afv@dOxs@jGrvC|Tnr@dbA~d@t}@gCf`AySz|Dy]fgEobAdkCzBxnKd`C~}AgWtyBapBvoAgUleA`g@j{AxfAtqAzq@lO~B`]hFtyBoNtxG?~cEf_Bp`@pGza@pQx|Jj{@jdBv[htA`v@hcEz~DnaCznD`eB~|A`pBfz@xvAsEnwA}_@rrBuRlnCxDvxC|UziCtq@jdBdvAl[l_A",
        "riq{Chff_JpCq`A",
        "|p|~CbjwaJmcA}u@e`C{v@}pEa{@mz@s~@keCstKejBuoE_hNypUccBmpAkrASykA``Hi}Aon@eaDiyEmo@we@ufA{b@g`AnEmo@jnC}j@vP{j@wPgl@acCi~@ebCgw@ysAk[wi@quAmcA{rE|}AcwBhUis@_}Aec@uqB_sAwwByaBihBmnA{aAcOdbAqWbz@qb@jp@sr@be@{sDoaC{bAylAkq@kdCyDceA",
        "`qx~Crt|aJtSi~@lYup@pb@{a@dl@sU",
        "hpuaD`jebJoC}hAce@s_@yw@bPwp@dc@ew@t]uhAf@kRqVwdAgiBkf@_h@ga@za@owAzu@yn@be@k{AblCob@r`@}hBzW}}AwR}_Bea@clBmPcp@aSmz@yvAq_AkS}~BbvCymAtTmbB_j@_mIgpEcxAu^ueBwOggEr^mdBI}j@uq@_SebBst@ylC}iAekB}rAzByy@lzAel@lbBi~@thAwnBxM",
        "vxsaDvnlbJhT__@fa@ucE",
        "zljbDjwqbJwF{m@s^{VafNcP{uBm[afA}^wFkS",
        "~cwaDfoqmIoNja@i_@v[gVdn@",
        "||taDp}tmI?ltGfa@ztCbxAnfB`{BrbAl~GfqAxlBjl@j{At|@z_BbxAri@dfB|V~pH|h@~|B~kJntKpiBbj@buFguArfClT|iAhcBrU~oC",
        "rkjbDfctbJf@{jA",
        "xrsbDnnwbJaqA}tA_r@|UufAjq@i~@vGcZkfB",
        "~brbDxg~bJ|_@knBzM}hB",
        "~dddDb`cdJu^{W_gBeDgj@sJcp@}TevAew@wyBmnBowAmp@qjAt|AuqA|KymAkr@k|@{`BoaAysGcp@ifCymAox@kz@i}@iTc}Gu}@aqAokBvf@{kA~pBevA|iA_hCelAu\\kgB",
        "fbpcDvvtoIsJvvFoYp_Bew@xrByn@ndC}@juC",
        "drkcDv~kpIdvC`pHp`@rcHfa@r|Bz`AlmBjfBhhBnvBliAf~B|d@v_HnNlbBz`A|KlxC",
        "bo_dDdygdJbZqa@dl@oNpW?nNcEhYyj@Xk@jIur@",
        "reveDfcudJmCMysHkY}~BhIyuBxlAkfBlyCqjAftAwoAvd@gsD}^g~BmyAqjAylCap@o{Hg`A_^g_BrJmoBi@{u@oNcp@uSyl@k\\qk@af@u\\kx@Um@",
        "h~kdD~dtqIcOnkD",
        "dnkdDnqyqIfK~zBxaB~fAp_C~XjoBjc@lo@neBnd@zdDh}AjCx~FuuCrhAyYnaA}Jf`AvKf~BnrA~h@eD`r@oNpuAnDvmCp{@djB|cBxbAvcChVtzCvwBnnD`lFt~EvcDtgF",
        "hbmeDbhxaJymAvjT",
        "nsjeDzsmbJvdCjft@vvEvmPrSfX",
        "pwifD|`{}IeMp_DwKbh@q]jaBqkMdt^WlAoU|dAovBx}RS`AkpA|jGK|@kt@ptGuOvuA_hAp~DK`AieArqJuTjqB?PcDvcE",
        "x_keDpqiaJ~|@zxJnCt{A",
        "viyeDhputIeXvhC??}pC|`LQ`BsYjyCiI~~C",
        "byreDlypuIvoA|}CvoAduBxhFjcFzw@blC|j@vrD~eAdoCtfCfa@niDaWpjC`Wr{B~gAbyBvxBr|C|xBx~DltAxvCvnBve@dhE",
        "bbofD`rhsIwwDvxJ_i@fgDwe@ljAi~@|t@oiFb}A{sBt|A}j@p}B",
        "~mxeDxogtIpAnpCtSxvC^|`@nBftB",
        "jgxfDdbq{IiIxsFwFht@sAhqCSdAwQfbA}_@nx@s}BreDwZt}@W`BmdA~zGmMbz@i_@p`Aof@rk@uxA`dBq`@zv@e_@vcC}DpW",
        "dfgfDneb}IRjcDvoA`vR",
        "bl{fDtboyIe@fAmzBt_FsxIfaKaoAhzE",
        "xejfDdcizI@RfTjcFtqA`bFfoHdiRhh@vkE",
        "v`kgDhqfwIg@pBmeAbaEkeCf{DseDn`DghD`uBsxGlzFM`Byt@|{K",
        "|rofDffpxIvg@j{CphAzxGn~El~Hjf@veF"
      ]
    },
    {
      "left": "BRA",
      "right": "BOL",
      "kind": "International boundary (verify)",
      "lines": [
        "vj}xBjvc`JboAt}@jdB`fAt|AlyAt}@njC",
        "r|gyB`bo`Jce@||CsJxbB",
        "zjfyBxcw`Jj]zk@fu@dOlo@|i@za@t|@pLjfAv{@||CviGvaEv{@xaD|Trh@zjBfjAxc@|_@`g@xnAtzAnhG"
      ]
    },
    {
      "left": "BRA",
      "right": "PRY",
      "kind": "International boundary (verify)",
      "lines": [
        "~nazBnc~aJbcB}A~Tmd@",
        "~aezBlg{aJ|K}j@fj@qk@`fAyy@z`AgK|iArdFtgBdm@rrBuf@lnAowB",
        "biezBb{|aJcFur@",
        "pdtzB~ptaJfVuh@lo@aq@lz@w\\xjDb{@z}C}L`zCgj@rgBwo@nkBebBzaBkeC`fAmkCvZquBvp@k{A`nBbPzsDnaBr}BfLd_DyEnuCcYztCkfAleA{CrfCxEpuAyO`yB_qAbdAm\\dbA|AbwBxm@jgA{AleAye@zj@wy@",
        "xyvzBn{yaJuHce@ec@k\\ob@we@{Bg_A",
        "jrc}Bnfr`JzMmbBlx@guAxe@oXj{A{b@~f@{Vza@mf@~~@g_Bjq@qu@`{@yNbn@ln@`^hhAlY~fCza@lp@hiAjeAz`Ar}Adw@zl@be@kg@dMcaDpWg~Bz`A}hB~}AcdA~oByNr_Af_AjeC`aG`oAxx@leAkRh]si@tJ}i@nNaR",
        "|bl}Bhhx`JaF}t@uxEox@yn@kqA",
        "x|s~Bjfj`JvnBkoChpCanC",
        "x|s~B`fk`J?u^",
        "tpx~Bdb_`Jh}AirBhgCuHtoCly@ntFfhDnwAqCn}DcaBluGme@rcHnXxgGzuAjcEvmCbyB~oDlo@|_@bmAzBxn@_^|_@mf@za@uQf`A_s@l[ccBj|@ebAlbDlo@jxQh_LbtE|~AxbCdWziCmElmB_s@fl@upBrt@mz@r{Bfl@bmC`oApiB~i@|hBeYloBq`AvxAomAxc@oaAlz@qa@|`LhnGxwBqBhqB}UnvBxDhgCtqAzjBpj@xxAyx@teB{uA`oCem@nlAl[b~FtpC|u@vy@t{@zLfmJhhC|tAtHh}AgAp_A_Jdh@_qAXu@pv@ufAnbB{v@nlAylAz`A}qE",
        "z}{~B|fa`J?_i@elBwY",
        "jlveCf{jwIlGowAf`As_Av|JkdDtmE}qCpiDq}Db`Eo{IhfDwwDr}@{jBpWclBjq@qr`@",
        "zi{fC`fwxIkq@g\\apB`aAod@uf@kRydA}Taq@ipC}oEocAkbAkoDqiByMiO_Uol@cZkTyaBoa@we@mRcbCq~Aox@ow@_t@s_Ai]elBsjAeaM",
        "xo{eC~l}~IpWmx@~xFg`Bp_CihAfiAaqAdXokB",
        "`f}eCdob_JaQmdAeXco@_Jsk@",
        "dc|eCbsk_JnEupAfVkrAbD{}B",
        "bo}eCthp_JSoXij@a{B",
        "lz|eC`er_JtSk{@",
        "vmafCrcw_JkGwo@qb@qjAiIzM}_@iAyc@gJkTiK}@gV",
        "jp_fC`_f`J`\\gt@lyAowAhTa]",
        "x`afC`yl`J?ebAsi@ekByDsi@",
        "||`fCpc{_J|@i_AzMs~@",
        "d}cfCfs``JcOqjAcoAccB",
        "dcifCzch~IvFolAbQco@vxAiqC",
        "jfkfCljp~IuS{tCsSqu@mPeXmG}_@",
        "zakfC~ax}IRit@dn@y`CnCccAh_@cyAlxBmlERuf@",
        "xvlfC|s_~I}s@}pF",
        "|rlfCdqe|IpWcZf_BaRp`@}i@pCwz@",
        "bsqfC|zp|I_SewBywB_{CkRqtA",
        "blofCpr||IvFq_Bf~@avG",
        "nhrfChl`}Ii@weA}_@}^mf@_JuQaG",
        "v`pfCza}{IfMmdBz`AizDbZcx@pLsAbZkGxXa]bQwmBhIqb@fBoc@",
        "zqqfCh|`|IyOwf@}Tob@kIen@",
        "ljpfCz`e}IrJis@lq@g_B",
        "ppqfCnwe}Ice@sU",
        "n}qfC`fdyIjq@ygB~bFusE~ToaB",
        "xwxfC`viyIkf@q_Akh@a\\koBaq@eXi_@",
        "jiufCvlg{IzM}eE",
        "dnvfCbhk{IaQmn@wQ}jA",
        "npufCx~}zIbn@myC|@cbA",
        "fxufCxea{IwF_fB",
        "|vufCl{tzIbcBxDpW_^",
        "pawfCfawzIsi@ydA",
        "zcvfC~~hzIp~A_hAh{Cg_AnnAqL~RyqC",
        "~e{fCldkzIcaDmdA",
        "jgwfCvykyIjGin@xZmFfK}K",
        "jeyfC~tsyIoCin@ox@}jE",
        "|hxfCvjvyIl[wtA",
        "fcagCju_zIyXoqACCerC}oCcy@ug@ug@wFkIsU",
        "zkyfCrmrzIpAmz@hs@imBfBm~@",
        "rsyfCfbtzIwFss@",
        "v_~fC`fxtInd@krAnaAwxAnm@q`Bfa@odKz`A}rB",
        "`_`gCli}tI}TmrAkh@}nA",
        "rl`gClj}sIflKcyH~oDy|Fz`Aa}@xvCau@`pOoSvaF}j@xiEkkBbaDsaDfjBunEri@a~Bdl@eqAhiA_n@d`C_Slo@lEjfBja@|s@zCfu@gLxcBqg@zu@iD~nEb_AzsDjkB||DtpAxhFeNz`NejCzjBHpqEdb@|hBqLtpDucDd_BkbAbyBaa@~bFt]jfBuCjpA_bAxaBwlD|u@gV`pM}gCtgBpAd{G~pCjfBtRdkC_h@p{Da_EfuBwcAn_EnInzIfgD`xE_O|yDee@hUqCx_FbDhpE_TbaDcwBzpGctGzcKifC|ud@s}AdaDmz@njColCboAy_EvZugKjf@udETI",
        "jzegC|}_tIqk@{Me`CscA",
        "vhhpCbvnlI|h@ueDziPua`@puAs}BbzLqxIrbIojQ`vAcmDl@{Ar~AxaCztCtxE~oDfsCx~Dt|@xcBmPfeEmoAzhFk]bmAap@|qDsrClnC_s@`bE_rAntDbFb`Elz@|gCnlAjjIpqFdiErgAf~Dr@zkLewAziEzB`cS`gFd{EhnAjmF|qDteBbn@|mb@n~GbvEdw@|sB|JfhBoDxwBuq@hoFg~CduBkRxlBnw@rpD|qEbnBfjAzwKfiCz}EtzCnjCfsB|rCrqDpgFnjCf{E|hAleArKheCzBfiCqWtpBs}@fuB}j@dtCxOnuCbc@~Lr@",
        "ljlqChm}nI_t@o_Eom@whBkGmpEeO{kBcy@qhB}fDsgColAapA}pEcrKsdGcoX_t@siBs|Cm|C{j@a_B",
        "dglqCxxioIfBojK",
        "|hrqCjl|oIwOk|EmdBotE?O?Yi@?giAk~C",
        "brnqCnljpIR]",
        "brnqCdmjpI?U",
        "vrnqCfkjpIpjAa}Eri@y_F",
        "vrnqCpkjpI?I"
      ]
    },
    {
      "left": "BRA",
      "right": "ARG",
      "kind": "International boundary (verify)",
      "lines": [
        "`lrzCprhiIjG_^`\\yYptBj\\vcB~r@jfBdc@jzBwP|u@}`@t{@qu@hj@_~@f@yx@",
        "vmzzCrqtiI_HymAce@obAclDcbDcZce@iIob@",
        "t|xzCjhziIhI}~@ve@yuB",
        "xoc{Cb{ziIaHazBclBxZ_fEr|B}Tcp@",
        "|f}zC|_biI|_@}~@f_B{iB",
        "vnf{CfkciIsi@gWebApCufAdMmz@fB{u@ah@",
        "`w}zCfiljIxXu{A|iAebA`dCq`Ahu@en@",
        "v|c{CtexjIsJg`A}~BsfBsi@afAoNokC",
        "nr_{CxwwhI`QqtA~|@evBxxA{lAlmB}h@p_C}Kd_D_t@",
        "bha{Cbu|hIgM{lAoWme@{M_h@",
        "zda{Chg_lIl[cyA|iAeb@`zAaGby@ag@",
        "jbb{CfbglIo\\}yF",
        "pmb{Clx_jI|@me@h_@{uB",
        "dwf{CrxcjIga@md@eaBcd@eDst@",
        "dpb{Cxh}jIdBss@jh@omB",
        "jlx{CzfikIqWs}@gu@eYmcCv[q_A}@ar@ce@a{@qsBom@on@mz@eMi~@nD_}@eDox@om@oWox@",
        "teh{CjwukI`p@g~BrhAuoBldB{lAvbCgUlz@}A|`AwQld@we@",
        "lai{CzyykIwZoaC",
        "vul{Cfh`hI|~@}hAfgCgaAtcFcdAtr@hJzl@nYxw@vQlpA}Kz`Aag@piBcwBv{@_t@rrBew@`nBaRrlJbZfnIgjAr_AbEfu@~Svy@fLdmAmOf`Agl@blDioER]R?xjDclDf~DagA`mE}h@~wEurA`~JslH~cE_rBz|Fi_@vkE~gAnqIliGlvDrt@rgQ_hAx~D^h@?xbAvyAhj@pk@zj@`Qj|@sJf`AqVlf@sU",
        "pkq{ChqkhIcOuyBudCkmF",
        "ng`aDro|fIzjBlP`xEvnAfsBpB`lFs^rrBhIhqBtg@pb@bo@vFt|@`Qvq@paAbOzkAa\\ve@st@jR}t@~Rw[~|@qBzvAjh@h~@cEhIkSdDqjAhIiUffFigAlrJihAz~DfJv_FrjAriOdqG`e@j\\rU~i@|KnaB~R|^`qApXrpD_J|tAhIhh@j]hs@`zAt^lZxl@{Av{@mz@tr@|ApiBnbA~h@|iA",
        "d|`aDhx|fIuSuG",
        "|jxdDp_sgIod@hi@ifBxw@i}AbcAod@~rA",
        "hzodDxzzgIfl@|t@tbErt@j|@|}@",
        "rhydDhe`hIeMnbB{`A`qAyn@dlA",
        "vhudD`hhhIve@tqAtqAfLrsAi_@naAnCnY`zB",
        "xs~dDfgnhIsJrj@gVlYmPv[",
        "n_}dD`jqhIxDbp@dc@xb@hqBfl@jfMfkMhVtbF",
        "nzpeDd|jiIyy@tyDigCgL}j@fv@el@nkA",
        "f~geDjmtiIdlBdmArjL|qDbn@lZve@r`@~s@dWz~B{Lrt@|KtSln@jGtfA|T|`Ady@j[hs@lPt{@lf@tr@|j@dX~]fBh|B",
        "velfDjymjIyy@`zA}rAdmAshAptA",
        "jmefDdxujInhE_Iby@~Hf`Ajh@fl@bx@xDvq@",
        "heqfDlmzjIiu@hT_oCfVkgAr~@gV|~A",
        "j_hfDpy`kItHzzFrUvdBdbAfVbkCshB`qApC`fAf}BfjB~tK",
        "jswfDrazkIsAt{@eX|`Ai_@zVupB`{@oWtSaH`q@qL|_@",
        "lvpfDz{clIfBdb@tg@pw@pv@ri@z`A`[tpB|`@fsBtaAtfAbtA",
        "li_gD`xnlIyDbhAgsB~]wZnS",
        "rszfDttrlIlErj@xc@|j@xbA~RhtAm@bn@tC`\\pWj]nx@~Ily@",
        "tpfgDb`imIiI`g@}KjGel@pf@uHlK}KfV_^_Iob@mUcZmKcdAnb@",
        "zr~fDlrlmI~RboAj|@puApv@|t@p}Ble@~{CxStdCpq@dw@|}B",
        "pmdgD~ozlI}KdjC",
        "r`dgDd{~lI|@d}@bmAveG",
        "fuqgDx{zmIg@lwC",
        "~sqgDft_nIvQ|s@liFiJtmG~^llCf`@j|@lf@fj@tzB`bGdeIjRptC",
        "jlrhD~}vnIq`@lrBwp@riBeXzyB",
        "z_ohD|vaoIdl@fhBvcBy|@~{Cu_Ed`CkzAz`AzV?bdB",
        "zq~hDhc~nIafA|gC",
        "xj|hDflboIdXr~@rAvhCtQvu@xe@xOjmD`p@",
        "nndiDfnloIyXz~BsrB~fCa\\rcB",
        "~c_iDvzwoIzj@b}BjfB`zA~fBhhAz}CfaF`Sn|@",
        "drliD~|ipIsJzaAkh@bbC",
        "d}jiD~bppInEdlA~pAnaBrrBvRjfBn]pk@|aCfB~~@xMxl@t^b[xw@jHvdCiEfa@fKr}@jg@taHxyG~q@jb@xe@ruCvFpaA",
        "trljDz`rqIaSri@md@hYaSdg@",
        "bejjD~muqI~]`pAt^zWvmCl_AzVr[hu@tpAh]xc@jq@f[xn@`Hpb@lVpLdfA",
        "jrxjDlocrIiTjkAwp@|Lqv@{Cag@jRyXjoC",
        "zqrjDrhkrIxmAliAn{A|f@nJ|C|s@lu@pb@bz@b_FzeG`yBfnKldBtxCd_Dcd@jq@}iAldBixFjR{qAr^}wAthAo}@jyCctAxfH`uAnwAxh@rjAr~@bn@pfA",
        "|jklDp__sI_S~x@u{BdWgsBnaBks@tcFcZjaGsi@jyD",
        "zk_lDtuysI|hBhxGvzA~pBz~Bs_@hs@gVjbHr@dl@bFvZxWr`@|t@`Qts@tSbjEdmAdkDxl@xiEpuAn|@vnBpHloBkNvuFvGhpCduBdsFtcKvwQr}Nr{B|qEbp@|dH~q@d`Cp`Bfu@nvOpe@~yE|hCn~ElkLbsFrwBf|FhE`yBzVrrBjkAtr@|dBp`BnnLjdBryEpjCn_F|qDtmEf{EzcDvoAvj@vxAdb@lyAdE~rAui@`yBr~@nhGleBldBrgAnwAhhBlo@|mAlbBl|Efa@dx@ve@dl@zl@nc@pv@n^h~@xIvdAgBnx@vG~q@peBdbAfo@plAr`@~|@pKvp@nXbzJ~gNfvAfk@zu@jq@lmDbtF`zAnwAdtE~sAlkD`wDz`At\\|~@zl@|kLthMzvA|sB`e@d_CpCnrGfa@pfGbxAjkGxkCzsDroEfiBfzU|~@z_B`g@fmJjzOjmS~nQx_DdhGtg@h|B`g@`lG"
      ]
    },
    { "left": "URY", "right": "ARG", "kind": "International boundary (verify)", "lines": ["nbfwDbhs~IzBdjCjz@|s@"] },
    {
      "left": "FIN",
      "right": "SWE",
      "kind": "International boundary (verify)",
      "lines": [
        "gtjdLy}z|BtpByeIhj@ilV~zC}kLza@efH|tA_qC`oB|@lcBveBxc@r{Df~BjRpjAmcCh|C_o_@blDowN`xCqmKd~FmpJ~f@ymAhJs`@dw@el@jTyZ|Icy@h@a|L~]{~Bh~@qv@jeAod@x`Eg|D`{@qjA`fAggEtq@}~MprEykPnxAsxItbEq}B`zBeqb@`dCuvGbe@yc@t|A}qDvy@gtAld@sjAxEk[vP{l@jg@mGpk@pC`\\kIleAerEnDabl@lo@ahLzL}Tj|@zBzLeXpM{kN|sAarK|J}pG`fAmhG",
        "gvs`LyeiiCpaAanDjoBgsD~qAwwD",
        "wfs`Lwp~hC_@upB{LylBSqtB",
        "ckm`LqvejCh~@_|CrqE}cGjyA}qD~nFq~[vp@k{A~r@kh@tq@aQht@i_@~{@uqAldCgyGrgB_~AhqCdc@zl@yw@vp@wF~zC|_@zv@`\\z`@pAdx@eM|JcQzCmYna@ui@",
        "ipk`L{aziCyy@usJ",
        "au|~Kw`gmCzl@irAp`AcdAvqJ{zF~s@sUpu@ar@hgDmoMrs@ejDbiGckPh~@cqLvnAyuBxlBxDbxB|{Cp`AxkEj|@lyLxcApqEnlBxlBrpCl[bwCuQx`Ca^dpJTdlA}VxaBcdAjwFkeAveBkq@lbDqsCnaBmo@dtCaSt}@`pBxaAv_FveAxaDfjAmeAf_C|sBvmBxkC~vBfkA`xColApjBipE",
        "yax~KipklCg@_fCcmCiqO{BcvE",
        "apuzK_i_oCtkBuhL~\\uhLtXigCfl@ymAxkChK`nDfiArpCSlu@ytE|`EdkC~gBvlDd`ChbUvu@byB~aB~q@fxBjR`k@}_@zWupBxnA`p@lcAlz@ry@bdAbp@dmAh{B{l@foAylB~cA_fCh`CqiDl[}~@be@st@xbAqUfoAsAht@gK`l@{X~v@qk@bkE_cF~aBsqCdi@wnBj`@}|D~rAwxCx|H{bJvcCgqFpzAcbC|fDyjDbtHq{Fdl@mPtv@h]tSj{A",
        "{rszKekhnCgE{fF}k@mvF_Io}F",
        "cotvKqmkqCqB~pC",
        "urtvKq{fqCdNhgCjpBlyA|hCdiExl@nChdFkeAp_Ci@t{BxXrrBnm@lcBv{@vmBgl@voByXfjB~Iz~A`{@zv@d`C|~ArmIldAtHv{@p}B~g@n_Epu@ztCxbB?dYh{C~v@xuDx}AlwCblCh~@fkAcZrrBcwBb_AcZlsAaHnpBs`@btAzBp`AjT`qApt@t|@jIbdAaSnkCuzAlaD}u@vyH_xE`iBo`D`pAg}Ej`BogS~lAgiC|aLoqIzu@ew@jg@{`AdbAyvCth@}~@dvAi~@jvHq~Cb}AiIviCpLh{BmcClxBucD`wFgiCtnDorF`pB|@"
      ]
    },
    {
      "left": "BEL",
      "right": "NLD",
      "kind": "International boundary (verify)",
      "lines": [
        "u}uwHwqaTwMrfE}h@roC}Krk@ogBxvC}{CnwAupCoC_zC{XuoF`u@",
        "_yoxHiowXbYhBnpCnm@d}@za@vqEbuF|wC`uHxsFneWhkCz{Gf[bkCxDrbV",
        "i`pwHi{fVmTnlAmdA`|Ag`AhImdAiI{pAh_@wo@duBm~Cd{ViOn~C",
        "gt`xHq~_UtDjyC~a@vwFvBbcBjMtzAfk@ncAdgArJbnAeObz@bQ`\\xfH"
      ]
    },
    {
      "left": "BEL",
      "right": "NLD",
      "kind": "International boundary (verify)",
      "lines": [
        "qvxxHw|l\\skBdl@u}AwZsxAwe@i}ApL}s@p_Acj@tgBcZtpBoDlyA",
        "ozhyHcoa\\jaA~lEfrJdbN`]r_A~R|rA`C|_B",
        "qyyxHslxZ{CtqAst@nvB_|@sJ{lA_t@mgBkGes@vp@aHxmA",
        "sdeyH{jpZ`RvwDdlAfnIjvBxeIxr@qjApk@|Kxo@tg@f~@nCfw@mo@rgBekCj|@ce@tjB`^pf@xuB",
        "e~cxHc}j^md@zjB{g@j]{hC|~@iu@|_@etC`vEw{@`g@ifC}T}bBwdA_gB_UoqCvyBylAhzD{MlP",
        "aaeyHa}t]nNf_Brd@nd@by@hTzkAfj@bdBp`B`yB`oCb_Bp|CfV~eC",
        "cf{xHeld\\pnAqoG",
        "kntxHq`~\\sdArpFkR~qBkHhtL{b@jcCajAob@mEmeA",
        "wnyxHmhd[o^pfE",
        "gnzxH{`~ZtSfsD",
        "aklxHkzxYwJhbH{XxwB_lAbaFg@bw@uAh|B",
        "o|ywHea}^qPxlBq}EdBovAxlBiFrrB",
        "mkdxHwnr^fLrpF",
        "e|jwHygpa@q]xbAmj@`{@md@rsAebA~`J_x@~hBuRvc@cmC~RcxBpk@}}ArrBey@rqCuH~eC",
        "qe`xHwtk`@hd@lzBbsBfeGd]laC",
        "}mzwHsp{_@oRrbV",
        "ma{wH_md_@r]jbEhElg@",
        "quewHsdhb@ak@hrAkpBnaCme@`eBiD`oA",
        "w~kwHux{a@z`@rdGTfjB",
        "gtzvHk|nb@mEebAcOi~@kWox@}~AbmCkfAaSwu@yvAa]nNsnApv@iDpiB",
        "gtfwHodnb@t]z~D",
        "{xzvH}wlb@rCmcA",
        "wtrvHubjb@og@cn@mk@ga@wtAom@eXlPaRtHel@nN",
        "c|svHuygb@jf@_hA",
        "k_`vHys|a@kwFcuFmwCyaBugArsA{qA{Mq{@s^yRar@",
        "ctwtHyt{a@wGxbAih@tpBmnCq_AshA_JkQp`Bah@~eCaOjc@gm@lgBg~AldB{jCpLw}H{aMmQkgAoOigAcNw\\{kAwoAkpC{jBekAufA}Ut{@_@b{@",
        "iw`vHi_ab@|VnjC",
        "}owtHinjb@m[~~@mxAz~BeNt}@",
        "_u{tHwobb@bZnv@`_AjbAh\\x]jGf`A",
        "esvtHg}mc@kHndMuL~bAADiMhfA",
        "sxwtHgl{b@tG||O",
        "abwtHe{qc@zM||B"
      ]
    },
    { "left": "DEU", "right": "AUT", "kind": "International boundary (verify)", "lines": ["}acaHwvgy@jEaN"] },
    {
      "left": "DEU",
      "right": "CHE",
      "kind": "International boundary (verify)",
      "lines": [
        "idwbH{ofs@xDszCfb@srBnl@wHvoAyD|jA}Tx]k|@",
        "ympbHuwwr@gl@ooIi_@i}AoaBby@me@obB",
        "ydubHshws@`QwoAp|@a{@hgAcp@vp@om@zHs_A",
        "grnbH_brs@ga@olAggCi_@ag@yw@",
        "copbH{qur@h@ydA",
        "gtwaHe_sr@wp@d`CqqAd_DeB~]kWdaBubAag@it@nNul@nYem@cFin@k|@sy@g}C_i@oaA_|Ben@ol@a\\_sAssAuRap@",
        "}znbHwzbt@`Gk|@b~@kh@pVxOnsAhrAxg@tS`r@oYnh@up@rn@qNtg@gK",
        "gqnbHuu`t@uHadA",
        "kngbH}_pt@dD}fDfoAckEdfBo`D`Q~qBlj@Uvz@kwA`BsCpzAotDbZcxC",
        "_jbbHupet@eBaiIse@~q@qyBew@",
        "ch_bHu``v@|s@}wT",
        "w~yaHynju@sNysFcp@kbF_hAmbBs^guB",
        "es}aHgs`w@hxAssA",
        "es}aHsyuv@?sxI",
        "wfvaHc_os@asCqb@wBzw@_Gz[wRffA_IdvA",
        "id|aHonhs@za@pnHx^t|Axh@puAh_@j{AfBbnB",
        "_zzaHuqjw@|d@{qFbqUeqt@",
        "{yzaH{gcw@CyhF",
        "aexaHwlms@~HyDle@{BzLug@",
        "wxmaHk_gs@aR}rAaOsLe_@aZym@cFmk@fBsi@wFoTpAkWzMm[hIqa@eMeLsUmG}_@ScZ",
        "odtaHapjq@p`@caDdDkgAbZq`@f{@s`@d{@}j@bZi|@ti@alFp@{nK",
        "odhaH_jho@?glXsi@_xG}Zu{@cZyZu^eXeh@}s@yYar@qp@sfCaVkqBq]si@o]_^eMi_@me@epII_pB",
        "{ctaHuo_s@`|@g_BrsAiiAxI_Lrm@cw@",
        "yblaH}ckr@cA}QyRqlDu\\wF}iB_hAqtAe~D}KizD",
        "seoaH}_wm@n{C`qAlj@naA",
        "{zlaHushm@w_Aw}H_IolC",
        "{}naH{gvn@j]yvAlOcrKxYae@ry@aSry@gKnYyO",
        "s~daHot{m@oe@gqGsa@kuFgl@qtBqoAobBiwBupB",
        "u}haHkkrm@[frCCdO",
        "u~haH}gmm@brAegFn_@wyAlKshC"
      ]
    },
    {
      "left": "DEU",
      "right": "FRA",
      "kind": "International boundary (verify)",
      "lines": [
        "{m|lH_k_f@vFcdA~yDs|PnbAejB~r@ye@tr@wOza@i@rAfKrh@gj@rqEsnHld@iTjq@bZpBbnBdx@fa@rgAmf@~qAsgBheGu~KlYuHh~@|KdXcFbPq`@jSquA`QoY|rBap@dYaSzLaFbp@iKfUyO",
        "gczlHs~we@kGoaAit@{uB}K_r@",
        "g`kkHwa|g@dbBkf@bnAr^nkAlPpvAaoAtSshAp@muGbz@orF",
        "yyikHyxwg@}@wZec@_sAIeX",
        "apjkHyrwh@`f@}cG",
        "ox}jHu{ph@}JonA_}A{jBufB|VadBbn@{uAcc@_Iu}@",
        "stikH}mei@vEcdAtoCceKpC_fCp{EdBnjDigA`fAshC",
        "_iikHww_i@sJeuD",
        "sobkHaqbl@vEmxBvdAcZ~JamGbZ_pBlyAkh@tRnm@dMpNtS|I`{@yvAxuColCdcA_qAxw@igCj^gpGln@{iCnd@{l@`pAu{@r_@ey@hHi}@pBeW",
        "iyujHywkk@{Wyc@ewA{`Ai^mf@sKov@sI}~BqMcn@qa@u^wyAel@_^a\\we@_gB_DgXaWkxB",
        "q`}jHcxej@zAga@~pB_nFr`@eaB|TcaBfBwyOtr@}fDzBmf@",
        "oivjH}n~i@mnAy~Du^uHq_@~Rqa@dDyc@{w@",
        "wujjHmhmn@dbB}fO",
        "{ghjHmddn@}KgkAus@sqCgKcdA",
        "otijHy~{m@vFcdA~]mcCzDa{@",
        "ghhjHa|tm@qK}iAuS_hA_JymA",
        "ckhjHitho@jGapBzzI{}]|rAieR|k@kgA|@rAd`Bn_CprFbbEbbOpzGfuAnlArTbe@jpAhdFr@zu@nNrLlQ`\\f`@`\\vy@pLpa@pLjSnb@~Ixn@|@tnDnN`fAzv@|_@bvBvFlp@xZlz@dbAht@rqA|^hiAtfCdjDzu@p~AhUjfBda@~gA|oGpfGbkE|s@jxETvcCuhA|i@?`qAj{C~q@ziAtw@h_@~uB|Kv{@r^jg@tg@fz@hj@ffAr^~cDzl@`qAbFfjAaSvnAug@jrAs^hvAvF|zA|tArh@|qB`v@xcBhbCfj@|}B|K|hBjf@vyAz`A|pJjjKlkAhh@`yAfKbp@t^vd@ri@zv@dl@h~A~h@|xBlf@z`GkRb~HamG`bEqLfjAlz@tuBteDnrAp`@pdBwF|ZrJt}@lf@x]dX~Yhh@bZvQbYbFzNgBxNeDvZh@hsBi_@zdApLd^rsA`]za@niEbxAtuAxOxyEolA`eBfBjh@xc@fiAhfBnd@~TneCmPjbAaSt[oWr_@k{AxnAssAf}DykCr^od@pVag@r_@}_@rz@qLlUzMv~@nX",
        "qrgjHkp}n@qW}bJ"
      ]
    },
    {
      "left": "CHE",
      "right": "AUT",
      "kind": "International boundary (verify)",
      "lines": ["o_n_Hgrby@qfF{gEwmDctE}i@}VemBi_@_w@a\\ynEeqF_~Aw{@ygGeD}iB|qD_gApgFs{DvwDmd@xJkmBza@"]
    },
    {
      "left": "CHE",
      "right": "LIE",
      "kind": "International boundary (verify)",
      "lines": [
        "o|d~G_ijy@mj@x|Jm[xkCiy@`F_bA_hAebAq~AirAmz@kdCfBccBhs@cyAxbAkfBxn@kqE{MwqE{jBevBkfB",
        "mxe~Goiny@|Zn_C"
      ]
    },
    {
      "left": "FRA",
      "right": "CHE",
      "kind": "International boundary (verify)",
      "lines": [
        "axbaH{dxl@}t@~fBeCxMecCkmF}Qea@qw@{tCcw@wzE[mB",
        "{j_aHsnvl@iJkq@ub@cZo}@|@",
        "kxbaHezxl@HhT",
        "gt_aHantl@jHq_A",
        "}xx`Hmnql@my@s~AoI}IwPmGiOSkA\\iLnDoi@pk@eXpLuRkGgLec@",
        "ie|`Hcbxi@zH{w@p\\yw@~NeaD",
        "qz_`Hoc|h@}nA_^u`BolA_qAk{Ai_A{_D{tBuH{WacDuf@mdByt@_|Ass@cn@miAh]muAr_AqdAnNaWgsBq\\qv@{Hew@",
        "wr{`Himjj@zSirCx^kpAf@qJvFwfA",
        "{mz`H_v`j@{c@ivH",
        "c{z`Hmkil@|U{_BdKe[~Uet@`GwoA",
        "qxn`H}b`l@oOm{@}]ipB{mAywAs]qa@my@_Sgb@hIe\\j]eNtSse@r^me@RoM_hA",
        "u`z`Heoyj@hpDtpB`eBqb@fv@sfC`f@mvD`M{XlUmPrUeXzLmo@",
        "auy`Hietj@sJ{hD",
        "ceo`Hyprk@`D_mDnFccG",
        "_bl`Haudk@yD_i@wdAmkFqVidD",
        "gnfyGw}~c@{Aec@w\\shCsh@cZyx@xDobAeB_pDqk@yo@uS}kC_zAikDenBcdAjGs}AfkAocAtzAoaChrHwKz\\mn@ufAeh@sJii@|Ksn@?gRnCyXzMk\\pL__@?ce@qW}s@afAw`GuxEo_E{{EssBbvCiqAjR}jA}rAupOmgYahDs~L_c@_}@w~BwcDqjAinEw`@{`Aw{@meAyr@{VmhBpAgb@nm@u]|_@eb@lPk]_HijEeaBwt@ij@uSaKaf@yUquAiIcdA~RykBhrAqw@zXgzEa|AewB}mHuoCm_TexE}_L_lCwmC}rB|iAibB_sAqf@yy@me@}{Cwf@gV}IgVu^yxA{iBvFqk@izDuxFwjKwGyLudCyuBm~BotD_sEmgLazCdXe_C_g@kqAqtByC{w@aHq`@yrAczA_Yg`A}J}~@qXwy@scAmo@m~@d`Ayx@t|Aor@~{A",
        "{qb`H_~vi@rd@~qBtp@nfV",
        "o~gxGmrxh@i_@m[si@kq@yn@}j@yn@mEg_Ap~AgkAjpN}gBhu@cuEox@{~EqkBwiHq|EqhDbmC}aDp|EwmCnvBegAq`@udCwcDugBqk@g|@~Egx@pE_}@by@CFe_@`}AoeDdb\\eHr_L",
        "qupzG{u}f@zu@noKp{FzsOzb@ziErEjlEbj@n_EpxBxiE|aDhqD`{BvbCftAr`@h}@{XhiBmx@dXgBhfBa{@nYoYpVg`A",
        "wdkyGglge@fL}j@`oCi_@nuBn`DxvDznKhbG`~HjgAxiE",
        "ocjyGscde@g`@sgB",
        "c}fyGq{{c@TsJ|Icp@fBmd@",
        "mzpxGwyjc@sfCirA_~@yn@st@kRg_BlmBqtAf`AgjAgVebAmwCg~BuuJgAiIUiI",
        "mmrxGg}gd@{`ApsE",
        "iotxGuhad@vFz{Gxm@pzGh}@nuC",
        "k~_xGss|h@yDjz@c\\|u@kRzBcY}Kmo@rAeEaHe`A|@a}@~I",
        "udhxG{cyh@dElP",
        "{whwG_ozi@kq@fj@_~@r`@iqBzj@{`CvfAoaApUgMj]skIbfLsj@`mC",
        "mfbxGkdai@zMjs@|^pk@fXxn@"
      ]
    },
    {
      "left": "PRT",
      "right": "ESP",
      "kind": "Disputed (please verify)",
      "lines": [
        "soujFd_kk@ao@jR_Uxc@wQjh@af@t]wp@tHm~@zAsmCqKotE_j@{k@_TerAgt@qV_J{qDmuGux@wxA}[i}AccAigBimAssAgz@{a@}f@a{@kp@m_H"
      ]
    },
    {
      "left": "DEU",
      "right": "AUT",
      "kind": "International boundary (verify)",
      "lines": [
        "muihHkbcsAmz@gMicGuyD",
        "kfkgH_azrA{Ly`CgMwp@aa@ur@q\\u\\ayCgjB_qAwe@cyAkR}gBqC{hE|_@siAcOss@irA{WbmAaR~]{uApaA",
        "e}ihHubdsAvFh_@",
        "sdpgHkwoqAbwB}fSbf@clB`q@mdBn`Bs~AtkAc_GpHqL",
        "{xudHgxzlAsJce@o|AcxAsSeXssBuwFs}@kpAowBkqBuh@yw@w`@i}Aal@gyIyMjGis@{_BcjAqhEetCogF_o@ycByjD{fSgcBa|YkmA}pE{bJabRk`BevAscCqb@g_@gKi_@m[_j@wZa`A}KooDrJcy@sJix@u\\kuB_sA{{@mP}u@pLg{@by@uoBdXc[vQsUzBmj@ga@qa@ew@yq@ckEwQgpE",
        "sikgHukyrAfBiT",
        "q{cgHe_vrAyeDov@gfA_t@",
        "czudHqoylAf@ug@",
        "omdbHi`cnAwj@d{I}dA`eBcxBgsBSi@I?gk@ag@kh@}I_g@}@wf@iKcp@ga@urLarKuR`\\sfC~eCwiIzrEmdAhhBgQjq@kvA~|Bk{@xtCqp@jq@m`Ar`@_HdAebApOqjCr|AwsH|vLu|@by@gjApv@kqAr^isAgK{k@ce@eHag@",
        "ctibH}`viAp[jRtaAbOlp@~Tld@`g@rj@rS|cAea@hd@a}@",
        "yspaHibgiA}Eup@uyCiqD}f@sUmy@mE_fDhIka@lPkMt^ga@~q@_h@zl@qa@`S_r@fKcZyaBssAouC}Uiu@_ZazAaAoN",
        "}rlaH{`rnAmxAwcBiP{B{zBiiAqLoNqjAqL{jA{BcoAlPwyAvp@clC`yBy}@zkAmf@nlAoI|_B",
        "igfbHe|jnA~m@f}CxIr|A",
        "ydbbHckvjApLueB~b@a\\fdCg`Adr@ga@zg@kq@`dB_yDf\\{vAfAq_C",
        "qy_bHukkjAsJ}hBs~@otF",
        "qmabHsb`jA~r@ahJ",
        "ch_bH_kuiA}EybAgp@ojCgLigC",
        "qp~aHmgmlA`|@w}I",
        "kmuaHewkkAmPwbCg\\q`B}b@sz@_cCwyEkg@{uBec@{}E?y}E",
        "{||aHmq{lAdlBp_AjpAeaBjgAcaD`pA_{Bbx@niDzoCfkAdyC}_@hsAkyChJg_BdMyy@v[}s@~sEo|Gt{CeqHzQocA",
        "os|aHefxlAkHgjB",
        "c~qaHifzgAhi@_{k@",
        "q`kaHctcgAoMs_AiiBs}@k[meAkgAokO",
        "izmaH{r|eApAsrBxc@qoGl@a|N|o@__J",
        "cz|`HeuaeA}_@gdHoc@sfCqtAupByx@u^woCap@eaAsi@keBmmDaQiT",
        "qrmaHgquz@rTowA|t@_hA|hAuS`kAhK`aA}Vpk@g~B",
        "wr`aH{mty@uCooK}u@qiDq~AmyAupBolAgjBigCs_@myAaFs|A",
        "cwlaHapqnAdCyO",
        "kihaHguqnAwlCdD",
        "{dlaH_vx~@rJ_Uhy@wZnWvF`]h]tf@hVrt@_Jv[}_@pWar@j]o`BlZeiG",
        "oso_Hgj_}@{Fe}Ao`@oqK_c@igCwsBuvG{jAcyBweBkoBw|D{iCef@od@q\\q_Ae^ybCqWqt@y|A_gBm}BczAokCyw@aeCh@ilAxXav@p`@kg@rt@o_@zvAcxFi~@yx@wF}dAhh@_dAhu@}t@~G_Xs|AwKugBwKwn@",
        "mphaHicr_Af@cvCfrE{wXtReXh_@uSt\\_^~Ist@",
        "}{aaHauf_AwGshAgj@mnAuvBs}Byg@quA",
        "osu`HoihnAcAebAoXij@mnCgqD_s@|@}d@bO}^~Rga@fMwe@dD{kB?iOqNgdBkz@_HcF",
        "{lhaHybrnAnBpL",
        "kldaHeqd{@dn@_{D~H_yD",
        "kbcaHir_{@qAkq@s`@{kAyDs^",
        "yhdaHcqu{@jfBmPly@e`A~s@emAbsA{w@zQ?`R}@nc@uHvZmcA",
        "esbaHegp{@sKi}A_h@sjA",
        "q{baHyehy@|CqYzbAolJ",
        "umbaH_ceaA~BouApXqaAbhAknC|i@hs@d|AnhEpp@si@bdBu`I~bF_wHl[uQ~h@}@fj@dMv[~RTzMpsA}~@pa@evAnEyjS",
        "g__aHyut`AeNwwDcmA}zFcPowA",
        "uf~`H}mxdAdMwxCj]olC",
        "gsg`HkvqcAii@igC{_AcxAsjAuqAekAywBeXgsBkCinGq\\kdB_}@st@om@zVe]xbAgMzkAwdFqeHsUamC",
        "w~y`Hkpd|@fpHorHhhA{u@v`A`\\`jA`mCfu@mcA|_AyOdbAyDvz@q`@`g@w{@",
        "uww`H{z~{@cO}u@}_@ov@_UafA",
        "irw`HycdnAvTa{@zW{a@dOwe@",
        "qqv`H}y~mAmK}s@aRur@g@g`A",
        "{mn`HkhicAbd@udCzhDpLrJ{tC",
        "mwf`HmxsbAkXayBy~DgwKg\\s|C",
        "ewd`H_le}@di@_rBnoBnCffF`pB`h@eMld@gBth@nNhSj]xOtqAxJdXpeAnx@`f@dX~IyZ",
        "uoa`Huty|@{LoYuv@iiA}`@oqG",
        "emb`Hytu|@tA_^tYs_ABg_@",
        "ey``H_ip|@i@_i@aWwn@sYaqA"
      ]
    },
    {
      "left": "SVN",
      "right": "AUT",
      "kind": "International boundary (verify)",
      "lines": [
        "i{_}GwjfaBlgBz_Gbt@vaCxBjUjj@j~FnMxc@bk@t{@tLyD|LwZfk@eD`aEhj@|Qr@vyA`GnlBeDzwCufAny@adCv_BmeAznCoLHA",
        "ojz{Gqgw`BWZ_dBtsB}_@ncA_^z|FirCtfLqVxlD",
        "a{d|Gczv_BjIvlDlaApnFbr@dwDlEjdD",
        "ut`|Gg___B}o@r}Mci@vcB",
        "woc|G{{l~Ah}AjRfoASvu@nd@xOt_@lOz^xNvoA",
        "kyz{Girf~AkQh}A",
        "wk{{G_tc~Af@`dCfWtdCdq@r~A~wAj|@xJhBfz@tOpb@bVbY|O~}@fsBvUjzD",
        "odt{Gqux{A_N`iE_^paLgHd{B_JpsC",
        "wfv{Gex|zAnnAvfJrcFpgF",
        "qlo{Gq`k}A{{@llCqP~[gbAdnBsn@`wD",
        "{mu{G{n||AnK~xIz[h~W",
        "srl{G{gjzAyuBbwBuJxxA",
        "cup{G}uczAfe@~vAdz@bgC`A|UzHfiB",
        "wgm{GstxyAmFzvA",
        "eom{Gw|uyA`VxmAtgBrgBfhB`fAhdBno@v~Axl@zfBx`AtnAlq@dT|a@rj@diCjQd_D",
        "spzzGkybsAidAx{KoDr}A",
        "gfuzGgcmtAwGteBuyDtzPsTr{D",
        "i_|zGgdrsA~l@rtKTftA",
        "kvwzGk~|xAiZpv@",
        "uqxzGyf{xAn_@~fBt\\nd@ni@~]z{@~gAdlApk@",
        "golzGmbtvAwM|kVkJx`QiAbKqKtaAmpEl~Iy^tzA_T`eB}@xlB",
        "m`vzG{ustArLrlBpK~cB",
        "}~pzGwdrxAwDhm@qC~c@",
        "giqzGmqoxAbDl[lyAh|B`\\p_A|Kh~@jGtfCbPt{@zzAj{A~wBhs@|t@p]vo@pZb`@pkB",
        "e~gzG_vhwAiJtgBoZbuAea@~iBa\\za@gb@`Sk\\t\\iIpaA",
        "eomzG_uzvA|^pqE",
        "oiazGa|vwA}z@tqAajBjeAgpAhtA",
        "waizGumowApb@tvE"
      ]
    },
    {
      "left": "BIH",
      "right": "MNE",
      "kind": "International boundary (verify)",
      "lines": [
        "imxhGi~}rBd~@{vAd{AebA`jAaqA~YghB",
        "scdhGcmsrBc_@Ukr@cZug@gBs}AjrAySdl@kRf_By_@`{@ss@fBkr@yc@y]mz@ei@_rB}wBqsCqp@k{AkIamC",
        "mpvhGcxzsBl`@yhH",
        "{kphGuthsBkBwdCkb@uyBaoCifDwLuzC",
        "kragG{m|rByi@g`Ais@wp@gv@kf@u`@s`@sLqLw[kgAsEacDwZqk@wdG~zDywJjxD}nEjwE}V|j@",
        "s}dhGwvwrB~XrhC",
        "kdrgGsfjrBr^wvC`uA_gD`l@{j@|i@{Bvk@bDhs@yMfeA{w@nwBg~BvDoBv]mQ",
        "okqeGwlwpBg{MvnBgbDfBsKiBm|Dsp@a}CmdBysGklGmu@nuC{dB}}AmkLw|Wge@wcDaX`Syx@nb@{WhTeg@}qBoXcsJ",
        "{ereG{nopBjY{|F",
        "_fxbGgvxoByEq_Ace@gV_w@pLo}@|j@cu@}|Ba[i`Aw~AkcCyq@oZamAii@euDqAejDr_AueBdjBg`Bf~B}cG`xEutCrsAqtCby@ukBxD}dAk|@uk@cmA{{@{l@uvBnb@yzE|rCc|B~|@ekBfB_tFcwBwcCi|Dyx@m|IqBmrJ",
        "ykybGogtoBdCigAr`@meA",
        "ajwbGo`poBwj@q_A_UmeA"
      ]
    },
    {
      "left": "BIH",
      "right": "HRV",
      "kind": "International boundary (verify)",
      "lines": [
        "abbsGw_mfBqa@dc@}t@{Bmp@`HmbCjq@yb@tr@",
        "gsksGiphfBjeBdjDv[tQ~r@`r@rr@f`AhUjq@vdAza@`]j|@hTvdA|j@t}@piAnb@hu@oCnl@tHbp@bmAxM|}C",
        "ggasGw`wfB__@z`AoaAdkAqVj{A",
        "iaesGivofB|h@yXhj@yO~Hd`C",
        "_h~rG{|xfB_s@mYae@oE{c@tHco@fV",
        "awcsG{|xfBxnAb{@",
        "oaqrGkz{gBc_CleKwt@xbDmmCxiGszDlxB",
        "maasG{k~fB|T`e@|k@zaBpU`e@",
        "y~vrGiqmeBqeGj|e@uG`jJ",
        "an_sG{h{cB`mCzdHj`IvkEh~AhtAza@dbAnc@`cDv[by@xx@nm@db@i@tg@{KhhAzKtq@`\\rgDf~BvqDlcA@?|vAr`@l\\nwC",
        "uhtqGowqbBed@peFshAjmFcmAjoDksKrzPmeBdlBcsF`dCmoBr~Asi@bmAsS|gCw[fu@w[{B{l@gV}u@eBov@zu@oY|iAgAncA",
        "yv~rGkos`BtRjnC",
        "cc~rG_`o`BsJbuQ",
        "wn~rG{i|_B`f@zpIvyA|iCth@z~@hgC`fAbo@xD`rJgVf`BbZtlGrqCpsBpAr|DgiAlmBzVx~D`zCb`Aj\\`l@jS|{CiTr|B}tAloBccBxuByy@nmBv\\bc@dlBl[n_CfuAbzArgBwFpkBydAhyDq|C~^}a@jgAgrClx@yn@h~@ug@jh@gu@",
        "siorGe_biBga@puA{a@nx@i~AjlEea@|sBkpBzqF",
        "sayrG}ykhBjxDbwBb[nYbNxhHnZbbA",
        "us`rGkpzkB{b@~|BshA~oBw_Iv}IgtB|fDqiA`yDwGjnE",
        "ojtrGgqvjB`q@~eCllDpeFnx@d`ClEncA",
        "iumrGgfqiBaRxmAmf@gl@oa@kRqb@bFuh@dc@gU`p@",
        "yusrGu{miBpWl[ve@bO~S|Kbn@~nEvG~qB",
        "qz~qG_idpBqBnuCgj@`cD{Xvw@qk@r`BccA`xAA@yjBzkC}~@zjBwe@nvBoYdxLa\\~{AuoCd{Gii@puC",
        "ayrrGwainB|UtxCt{@ncAzlAdMxmApCp`Ari@lo@xlB~R`dC",
        "wbgrGisxmB[d}@??a@biAcPlxBem@diC{{ErxIce@lbB",
        "_gqrGij~lBRp`Bpa@t|ArbIxzJncAhfBrSrt@rVdjDpu@vwDdD~|@",
        "aljrGsluiBkg@i_@caCmx@",
        "qvorGkfxiBzv@dtCjH|iA",
        "akkrG_~djB_I|gC",
        "aukrGau`jBj\\|xHrJnm@",
        "wh`rGmiypBwO~q@kh@hj@kq@nb@upAri@m[xZeNbn@",
        "qrgrGarqpBdDjh@vd@dvArJ~h@",
        "_|erGoglpBg@jq@yPvcBgAjq@",
        "iqfrG_~epBbZvzArKV|i@nAfkAk]xvAsJ",
        "m}xpGekhrB{l@d`Eco@rfBA@ueA`wCwbDbvEqrDdbA_|@gl@khAsfCu|@wQsTtHu]t^wPpLkQzBi`@?gLdBae@bQeYlPcPdXsJfj@}JlmD}UrhA}~@|iAeqIdhFk[~]eOxc@",
        "ccerGqa_qBfBri@dW|_@nc@nPxd@zK`]jRpUxy@",
        "gyypG{_asBpMxbAfLzoU",
        "ci~oGuy{_BpBemApb@si@ly@gV|_AyOfu@iTdb@wn@",
        "ayxoGo`n_BaIwzAeMa{@cEwnB}Kst@ag@om@qt@q`@cf@}j@",
        "elwoGihf`BfBcn@xbAebAtzCen@dvAirAj]i~@jQcmAnNmwCnY{kAxy@cp@bmA_^~rAsUxDtH`Rtr@hqAxZ~}AhfBbcBbp@xaBq_CrJe`C",
        "emvoGs_c`B_I_t@_Tur@",
        "efynGcjdaBzNmcCbcAigAxlBkh@lyB}_@vrHwxCpuB}h@f_Bi@pk@ld@zW~s@bYhh@xo@fB",
        "y}vnGwf}`BkgAkbF",
        "wb{mGmvoaB|@wdA~SupBl{@{`Cxn@ebAvx@iPpCk@rgBvOhs@~TbdBh~@bcA`Q~}AyDjbEmz@tkG}sBfjBaeBfqEgnG~pBmyAnsF{iCbmBwzA|uAcwBjf@meAdXk|@zCebA",
        "_ozmGe_oaBwRgV",
        "gf|kG}{bcBlQu}@p~AwoA`{Ak[rhAar@tfA{pGj|@ylBjqA{_B~gAecA||DipDnbFeqHbkEmjEhlDw`GzyAcn@bhBsUvcC_t@nfBwxAhpKavTb~Ui{]p`GsnHp`CueEtyAcjCjtCujJhcAs{Q~}Aw`El`DobBjlOptBxvHojCdlGgqFvlDo}Fbz@s}B`k@{`AjaAih@|~Bks@hwBigA~qAs~AvYgv@r{K}sYtx@qaApcD{|DtiIe~DDUb@SHSblDiTr~AhoD~r@loI",
        "o}{kGey}bBwGwaD"
      ]
    },
    {
      "left": "BIH",
      "right": "SRB",
      "kind": "International boundary (verify)",
      "lines": [
        "idbqGsjetBa]~]is@hVmd@jf@",
        "c|eqG}lbtBfLxmAhaHtoPzXvcBfLd`Cdk@rfE",
        "idbqG{jutBii@btG",
        "sncqGwultBtG`}@r`@lmB?r}@",
        "mx_qG{j`uBoN~|@gtAh|B",
        "e}bqGqoztB?pv@jQtr@nElx@",
        "qoemG{lqtBqBnwAgKzu@cn@d`C_i@`kGkh@~|BoaB`pBwuEziCu{Blo@evB|IoaCqt@mmAquAwzAshAejDiKctGbcBoaBcOis@}{Eu\\ap@si@wg@wp@ob@gk@gKccBlE_i@}Km[_^m[ybAiSm[{dJ{dHizDyxAyx@cn@ar@qaAqjA}|Bq_Aa{@srBs_AeqV}{Ea\\yXcE}_@cP_Ui~@xD_s@bQob@xX{Wxc@w\\dc@A@sRxV",
        "{i`qGi|buBxDh@xExOxCh~@",
        "_vllG_ktuBaQzj@co@paAupCfpGewAptBaoAjf@}}B|KkeCnlAkpBzjB}~@|hB_ItfA",
        "wrfmGmvwtBdb@phE",
        "_yzkGmgovBs`@by@yxA`eB{tAnjEse@pc@_vBroBg`Az_Buf@lf@wnBpLmp@|s@",
        "arnlGw{xuBRnd@tr@jeAvFzc@",
        "{~kkGkk`vBuHaxCye@}rCoiCc`GstAqiBueB}s@qtBnm@kq@bmA",
        "c~|kGk|rvBdMdw@ld@be@nPrU",
        "mhskGy`vtB~TuqAvoAg}CblBo`Dnc@woA",
        "e~zhG{_|uBsUap@_YqLq[lP{]dl@_aAj]wuAvFcyAsJqiAoYeqBe_DkdDjIkzIxtCwlEh|BmsNz}RyeKrmIgqDp}DkvB`vEg`@~gAkq@afAgk@qLomAv\\qk@Rmz@ga@ga@st@u]e`C{BazA",
        "wxlkGmguuBzX}bJ",
        "apkkG_deuBoBmyAaS_|AcP_kI",
        "gjdiG}rauBjl@ihB~bBqiBnvBowAbhBur@pv@ap@",
        "sg`iGmlvtBgA_hAi]shAorAuoCqMebA",
        "oz`iG{lqtBzQq~C",
        "_ouhG}adtB?eiC}hB}iAyjCyy@efBquAqMmcA",
        "cc}hGmstuB|cAmkF",
        "u`whGadnuBet@st@wgCemAoCqjA"
      ]
    },
    {
      "left": "SRB",
      "right": "HRV",
      "kind": "International boundary (verify)",
      "lines": [
        "_}iwGetjrBz_Bob@vo@fjB|_@`p@dm@zw@`fAq_C`r@{`Alo@wQ~g@dl@|JxmAfL~eEpiD`Qnc@|KlYpUxY~Ile@gVxcAs~Art@qk@r{CotDr}Aa\\r|DyXjoAks@xn@{tA~i@siBdw@azAlxAec@|t@|a@~eDxjDnb@lcA~s@pjAptBzXftBvFpt@hTj]}s@xlCu{Bhh@w{@g@srBsk@woA}s@s}@kg@elByYst@}Jqv@~\\yw@vp@we@h_@kRvZyZbe@s}@pa@ihBzLmyA~^aoAbyAydA~{BptDqe@nqJkD|r@hzCtqAjqBuC|hAc_@h~@mwAnkBa|AhuAju@hO||C`u@jgCn{BgK|v@wpB`@sC~NidA"
      ]
    },
    {
      "left": "AUT",
      "right": "SVK",
      "kind": "International boundary (verify)",
      "lines": [
        "_a_dHchtgBawA~pCgo@diEss@jnCqeBq`@yh@|iAkIpWgsBqb@i~@i_@ys@}~@iy@jpAcc@t\\eqBt|Ag[|`AkIbcBeb@ztAsrBr|Ck`Bpk@ofCRapBv\\m_Fn`B{\\rAqfAmGcZxDsThV{Gve@_i@bdAmPxw@oSxn@yc@tSm[vF{b@~Ri^hTgLxO{KbZu^sJec@qWwZeMqp@j[sn@~~@ec@z`A{Lnb@}G~|BoRlo@sd@jRscA{Bm[_JqQoNmf@cOslIqv@ixAyXcsAi~@s{CmbDerA}_@}y@om@kv@kfBagAueB}^oLomAa`@icHdy@"
      ]
    },
    {
      "left": "CZE",
      "right": "SVK",
      "kind": "International boundary (verify)",
      "lines": [
        "k|~lHgfdqBmEanDwxCm_Ga\\}sBoCy~F",
        "oibmHkyvpBxDgj@dbAwkEbc@{sD",
        "if`mHy{opBk|@gqDyDij@",
        "o`amHiggpBdYosG",
        "crllH}_loBa{@ekCqsEciG_gAklEga@ur@{u@u^isBoNir@g_@_t@q_C",
        "}lmlHwifoBxYeuD",
        "q`ejHqc}lBs}@inEwoBcwDkoCy`CghCkh@gvG~Fsd@`@sfDsUalEmnAq}D}sBe_DouC_qBawDouEahYiuBefFmjAirCygHoN",
        "uqejHgtrlBbPinI",
        "e{qiHqr{kBqCqvB}hA}qBstAar@m`Emo@u{Awe@elBuqAqv@cbCoNcvC",
        "ajriHynwkBzMwbC",
        "ex|hHgy_jB_wH{od@k{@mmBysFwvEgv@wcBmPwxC",
        "{cgiHiw`hBtr@kkHrmFchU",
        "a_tgHoqlfBuuBoN}nA{aB_vAufA{yQ{zHclDwxCazBavEgjAyxA{tByc@cy@{w@o`D{nIkf@uvG",
        "grbiHizoiB`\\azAldCg~DpVscF",
        "qa~hHyl`iBqLokBws@{xBsp@qqBw[qsC"
      ]
    },
    {
      "left": "SVK",
      "right": "HUN",
      "kind": "International boundary (verify)",
      "lines": [
        "udmgH}p}}Bz`@{_BloBmxDrNmyAzLkcEfiCksIfL{}E",
        "{hoeHmmvzBwp@wmCayBotDq~Ci{CksDoaCaoN{qFa`BigAeqAu|AwdC}|D_IeMorA}rA}TeDiUqAcUR}TzBkkBfK_s@}@cn@aFco@gsDmPqbK_jEiih@c@kdB",
        "_skgHonwaClQczAhrA}pEp\\_pBl_@st@rt@kh@bxByw@|j@_i@j]mbB",
        "}g`gHcuw`Cqa@k{AaeA_hAqaAqb@iy@is@}n@ayBeMsgBcBetEicAgcI",
        "_icgHooo`C|_@apBlj@olAtSafA",
        "}o}fHk|y_CwxCybNi^inE",
        "mecgHsye_C|TcwDns@kmDtqA_}BjWg}C",
        "k}bgHi}`_CaGi{C",
        "ix~fHmxtbC~NqiB`fAiu@`aGkpAxaA_r@deJc}I~qB}rCppAkdDpk@ubE",
        "ev~fHyqmbCcAseF",
        "ykgfHsaweCsUgsBsx@elB}cBeuB",
        "kdhfHskkeCpW_uJ",
        "ae_fHyxxcC_J}|DgmBsbIyYklGugAq}D{VazAiJeeIoY_rB{CapB",
        "e|reHw~mzB~h@u{Bzr@keAlTsjA",
        "etmeHasbzB_^ugBisBs{DuSkeA",
        "ykneHie}yBzN}~@vFylB",
        "{gvdHuunxBec@grCyoD}yGqz@aoCwp@ulFoGwS_eBswFo]guBiZsr@{v@{l@koBga@}j@qW_}@cmAcFst@",
        "yijeHetwvBn@oaAfKu}@jg@afAfoBsfCxTs}@",
        "qwndHgqquBg~CsmIi_@uH}_@eB{`@dBga@tHeC|@{Bh@}Ai@{A}@{aBgiA{pFyy@}yAmcAyh@{jBgeB}}P",
        "cseeHybmwBbOsqCbyAcnBj|@eB|t@nb@xs@nNfz@wy@dDmz@",
        "smdeHubdwBod@c_H",
        "}y|dHkl~wBv_@wxC`oCwlFf`@y`C",
        "i`{dH}jwwBsx@m`F",
        "ocodHsewtB|JsjY",
        "syidHykitBkHmcAo_DktJ",
        "cykdHsdqsBn~@efW",
        "mtjdHsnesBuc@_uJ",
        "y|jdHag}rBlCykC|BwyB",
        "kfrbHcg|pB{KcuDo~@mwCk~CwmEgu@okBeXolCsc@yxCiAqHauBfoFmwBxuDctBtg@qbCoNaaGs}@egAtSaXfj@aVjGkbAkpAgUyw@}LmxBoa@mz@ehFifDyz@elBqxAqqQml@klHu[uzA",
        "u}adHcl{gBp_@m`Fro@}aGbKu_Ahh@svKnlB_dEn`Qm`Sbe@k|@`Qq_AhU_|CxXcy@htEgrExs@ekA",
        "_a_dHchtgBu{A_cF",
        "_s}bHmimjBh^_|At}@y`CfiAsrBh_Acp@`p@g`A|_BaiGxr@emC`_BejO",
        "su|bHwcgjBs@s_AsSs}@cFmeA",
        "ipubHupfpBvLkwGtbAkbFnWuyD",
        "w|mbHouhnB{M{fFg_CurMmcBs~f@",
        "qrobH{rpmBxt@saW",
        "qdmbHuqxkBuNkhJi}@yvk@"
      ]
    },
    {
      "left": "DEU",
      "right": "POL",
      "kind": "International boundary (verify)",
      "lines": [
        "ihluH}skyAgsBUk{AowAi{Ce}EyxMgzHe}L_vGufAwQewBi@o|@}Iij@s`@{[mo@uh@kh@goA{K}|CcFknD_r@oeDssAgcCgjBmPxXkRrUktDi_@qyBbzAogBllCk~BrrBcj@lPaoBbZyD?}gGld@ycDhVemA_t@auAr_A{jArrByn@n`Bii@nlCgu@fdHar@vmCS?wy@xbCwtAdwKcyAfiCeaAlSwk@xLmxB_r@_wBoxBc|BshAqcDjIs}Ch|@_kBvoAc|CrnHweBxkC{}Cr_A{cDnWagApuAqo@`pBk`BteBmcCvQkkBaqAgaFoeJm~A}qBqoBg_BgyB_t@q|J}Tw{@s`@ivC_fCcz@mYix@uJ_w@_Sct@yn@kwA}qBszDhuKsxAr}@caDce@upBebAixA{VavAlyAwe@?cbBayB}~B}@ylBz_B_n@`nDiXrpD{aAzrEw_BdkCupBod@ytDbbCwoGpsCgwFza@qmDsbIwqCcvCuqCkfBuaA`\\{_AhsBepCmo@i_FanDq`BlaEqWzb@iwFtiJiyA~tJotCprDw`@zuBie@d`Am_GxtE}cA|_BihH~vSkv@piDiqCbkEs`@h|BcEziC{WbbCur@nkByvAvfAkvAaeDwjAq_AeuByXemAdMu|EdkAy}@nd@}e@?yfCimHewBm{JcpDgoJgxBy~D{oB_sAks@mPy`JizDmyA|KowAld@qdBrUerAmPkkAqk@uv@a}@iT{`Aeh@{l@y_EwaDgl@jpA{a@pWqo@r~Awf@`e@k|@jRkpBzB}s@tHotBfi@gkJzaCsbIf`AacCbbCoaCf`AekCxvC{_Cdl@qiCpCscFyOu|@rJ{qFbbCmyBh}Ae`ByXwnDvFSG"
      ]
    },
    {
      "left": "HUN",
      "right": "UKR",
      "kind": "International boundary (verify)",
      "lines": [
        "_xcfHw_zfCsbBi@_|D_|A}hAn~E}PdtE",
        "otofHkiofC|t@vkE`l@~|@PbE@J^|I",
        "{olfHemffCcP|rC",
        "ujleH{hpgCgGdl@mZtg@e{HdqH}}BdbAguAxD_gAeMk|@?us@nm@cDfj@",
        "}~cfHgl_gC|EnkD",
        "ufleH{t|gC{LzaBq`@tyBsAnY",
        "wxmeHy|tgCrAdX`GdXbYbp@fHlo@",
        "e|pdHks~hCi@dOoXp`@csCpiBceEnwA_`C`qA}wKloMkGdXqBzX",
        "cwmeH_idhCfAlYjg@xwBxDz_B",
        "crscH_hsjCi|B|dF{jAhs@ywAqiB{`BsJux@ih@w_AsUeuBri@}tAf`AefAhrAyrBvwDwsAb_Fq\\~T}j@`eB",
        "yutdHwoyiCtRdjBvl@|hBhX~qB?faMz]~pA"
      ]
    },
    {
      "left": "ROU",
      "right": "BGR",
      "kind": "International boundary (verify)",
      "lines": [
        "wj}lGw}niCtrSo}h@jfAaaFvZg{Gbh@k}Bbm@ulCb_Eyw@z~DpiBdvAhyEfLhgCxy@twFpLd`C`z@t{BnkCvdAbtMdvCnlCgBjuBolAhbBg}C``@o_E",
        "qislGwx}cDnjEweMf~AeqSht@mcC",
        "g`piGkazzCoIcmC}j@srBoSqtBgk@mlCqz@wdCybAo`Bux@wnB{Gy_K_@qh@upAsbGkmDkpCmVsJ{yCumEylAizDynGqeH_xAmq@chAkz@_oK}nVq_Byl@owBomBkyDqeFssAwvEi}AowN}{CemNoMkgCkv@qhOubC{ve@gt@}pEuIi|BgKmz@ow@i{BsKwfA?ixGcp@o~Eo|FunQst@y|UsiAcaD",
        "yshlGqnieDhDqH~w@eeBllCj\\fkBmbCbxBa_Jvo@iiAjxCwwBfb@ocA",
        "oihlGcvdeDiImwC",
        "aqvkG}ctgDxc@ymCr|D_{Bff@_g@voF{sF",
        "iuskG_lcfDmFwfd@isAeoJ",
        "kmokGmqjiDT?dsDssCbnUgyGrwBgrEjhLgig@hfDgth@",
        "svfkGskehD_hAeyKioDcoLm\\ozI",
        "erzjGeujmCld@ed^xlG_bTjT}nDpJk~A",
        "}jpjGgn{jCut@e~Xa_@snNqy@}zD}`@_zE}yAoiFay@uuP",
        "msrjGu}woCpRgiCnvCqcJjmKqhcAbJa|@",
        "_~ojGulgoCmtA_pO",
        "cdjjGsqitCfQgrE~pGcq^hiA_qG`^}dH",
        "{n`jGcsmrCmf@isa@yCoeCaW{jBm|De{Ior@szE",
        "az_jG_vjwCt~D_`Vbk@uiXdl@m_GbxAumE|GuShwBmuEj_BucFnY}nG",
        "ov}iG}navCqbAafh@",
        "a`}iGasplD}d@ya[",
        "{kpiGwgqzCrJsxG",
        "ykliGqp`zCcZmnCorAkaGiK}|AcDmf@"
      ]
    },
    {
      "left": "ROU",
      "right": "SRB",
      "kind": "International boundary (verify)",
      "lines": [
        "qnlxGutpzBvsIwgKr|A{iAd}GcbCvcBs~Apv@qiBfkAotFnv@qtBpsEwgIvd@wpBlQimF|_@}sBdbAg_BtbGinE`\\}j@hr@qkBbf@{j@~r@iTf~BsL~RoF`g@aNjfAw{@d`CknCrsAmz@bo@}iA|KirA",
        "iyivGiuv}BxZ{kA~{@ur@dx@h@bz@pWf_AnN|cIeDnwAxO|t@dXhqBbdAh{Clo@`eBsUn}EmvDvoCcoAnvAdOf`AjyAlnAdkCpvAag@hi@kyAdXwnBnb@kfBr_AyxAdrEckEv`GurKl_F}oF|u@s~AteA{zE~}AqfHzb@s_A|i@_t@za@{u@rKshA",
        "ihcvGuql}ByP_sAel@ymAkgAyc@qt@{u@aScdA",
        "ckosGix_`Cht@mdBp}EetEftAaeBhfBinE~_@wnBxDqfG|qCawSxbAioDj{Ae_DjdCg{Cnn@sv@tqAm[nmAfVlo@xmAdBdmAfVd`Alf@rt@tq@dn@`HmGve@{Bdm@?~]zBdYlPdl@~s@dYvQxvAnW|j@fB`]~Rnm@xmAbOf`A`Gp~ChU~|@vp@fl@p_At\\ts@}KxNssAzB}hB|^kRjh@nN|`@{BvdAipCld@kkH|u@i{Cj{@uxExx@wzAbdBkq@xvBlPft@nwA`r@z|F`RtnD",
        "}|ksG{vx_CkSw{@omAwcBiJ}~@",
        "wqzpGwb}aC}K`jJ",
        "u~zpGuwqaChi@ffDtr@lpAlcAxw@rtArU~_@eiBBGl@uC~{@koB`dDokB|`@mdBhi@srO",
        "klipGasqbCzWuyBhhAylBxbBgu@toBod@voBwy@`cDucFdaAqpH",
        "wuhpGstebCsUm}J",
        "i``pGya{gCdCcxClP}qBve@k{AtuIwqLtzBytEriAqqEri@olNbn@czArzFezHjpBxc@`oAxlBzm@njCxNdwB",
        "sqrnGoydfCyZetC_|@mpA_s[yfUeaByc@wp@k{A}h@abG_t@ayBoiDuxEoc@{`A",
        "kdyoGoskdCnNkfBpqEetPfVsfE|j@_}@hlHkmDvk@}Kvh@aKzmAyUxn@s`@fk@{`At]afAtg@ox@zsDoaAzjAokBrj@qjC~I_fC",
        "u~toGihncCg@}aIkh@kwGweAscFiSgjB",
        "mqznG{rpiCgV~eCylBjbFce@bbCqBlaC",
        "e``oG}b}hCxY`{B~}@~{A~fBdc@dkBjR`|@tr@bYvoAbFrzEpLby@vZfj@ny@bZ|rAdOlpAf@~q@uQpuAcbCfj@yZzm@yDxaBzMxn@cFdtDylBbbDseDn_CipEdmAsnFnYkaGtf@{uB|sAwp@jkHzXj{As`@vAsD"
      ]
    },
    {
      "left": "BGR",
      "right": "GRC",
      "kind": "International boundary (verify)",
      "lines": [
        "oky}F{n~~C~CwxA`Wur@hmC_eD~q@woAr[cbC",
        "_el{Fsok~CeOye@{tAigAs}Cg_BszCwdAyd@}_@sImf@qMs^kq@_Jyd@jRu|@puAm[nYcmBp_A_i@}Iow@_hAcnAsUmeAuHkfAjGiqAt^m\\za@qLdaBsTza@_i@~IoaBuHcn@nCq~Cnx@ss@dc@yn@pt@uXvfA}KxvAo^bxAwr@lm@a^zZehAt\\owAlPkyA{BulA{a@ec@si@uH_i@y@si@yMom@keB}fDma@ifDaGkuIuaB}gC",
        "opq}Fevn_D_PioF",
        "szt|Fen_sCptAwcBxy@ayBpu@yD~s@dMpa@_JxMcy@",
        "kvj|F_worCgVaQeaBcZuf@yXm{@wzAgC{Giq@egByd@euBiIelB",
        "iot|FocrtCdwA{`CvbDolAblD_Shr@cQ`\\yXpWi_@dc@q`@jQsUl[mz@~S{V~]cFbdAnN|UoCdbAg_BxNgtA",
        "skm|FyhatCoN_|AigCg~BgVgiCss@esD",
        "coo|Fwm}qCnOixFhh@ayD`\\mo@dc@wZxYcZzAqm@",
        "w}~{FchuqC{XwdAcn@ce@_t@gBoiCxOqgEnNi_AyuD",
        "a|m|F_e}sClOybC",
        "_al|Fi{qsCoCov@en@}pEkFg_B",
        "yol|F_tlsCxMifD",
        "imk|FwihsCsIgj@wPug@cEiu@",
        "coa|Fo}ypCbDkq@baD}dH",
        "gp{{F{iipCiJmcC{We`Cyc@wcB{tBghD",
        "{ma|FssnqCbdAeiC~IiiA",
        "{g|{FyudqCyCk{AemA_gBwP{a@yDga@{Mu\\qk@sU",
        "ot{{Fm{epCfCmmB",
        "emt{F{j{oCaSmdBipDmlC}`@u|A",
        "yiz{F}iluCh}@`e@",
        "ggz{FgpeuCqAuxE",
        "okx{F{souCpLwyB~g@kqBtqAayB`mE{rEvzAigCdC_{B",
        "okx{F{ckuC?_oC",
        "wpu{Fm}toCpb@mlE",
        "{go{FwxboC}d@qlA{GaQovB}{Cg`@ywBi@inE",
        "uhu{Fy~xvCvF_sAdxAe~DxeIg|^",
        "gtj{FgsivCwyAst@{kBxOirAkR{K{qF}a@oaCuH_}@",
        "k|t{Fwc|mCpLqfRx_Dc{KbEipE",
        "e}n{FyzjmC}JmcC{l@wnBigB{|Da\\{uB",
        "wqt{FekcmCj|@srB~fAwy@dn@g`A",
        "e{c{FaualC}UgeGi^ykCm\\ocAgj@qv@w{@}_@_qBuHyn@iTg`AmyAyaAojCen@_qCyDcnB",
        "wml{Fyaj~CvGyl@",
        "icd{Fsak}CmEcdAur@mlCssAseDi]woAk|AguO",
        "oli{Fyep|C~f@qjClxCmvDxd@ywB",
        "iz`{Fwrv{CwFmeA}Tsi@s`@qk@si@{kAmQkeAgKaxE{uBehFuQ}~@",
        "kqh{F}udxCHu^bOwQ~|@mo@hToWnqAghF|GeXpkAcwBxrGciGdv@mxBnPuoC",
        "}`h{FgoaxCmOueB",
        "qkh{Fc~zjCjoC}ue@",
        "epd{Fmve}CRevAfK_sA",
        "geb{Fsa~|C}LcxA_|@uzC",
        "}md{Fyo}zCv[ufPbOk|@by@maCrKmz@",
        "sr}zFymtzCcQk|@ir@{u@cdAug@cz@oo@sTqsA",
        "uf~zFkkozCpC{_ArJcp@zBmo@",
        "ciuzFc`eyCcGsqCm_Gkw_@_Tg_D"
      ]
    },
    {
      "left": "TUR",
      "right": "GRC",
      "kind": "International boundary (verify)",
      "lines": [
        "cmr}Fqj{_DtYcnBptBqgD~l@ioFnb@ylB`RyaBfzAtQxmA|u@pgEsaJnmBqzGlo@a}@",
        "oar}Fofv_DsJacD",
        "yl~|FsliaDzm@f@hm@mExh@eMpb@gVfiAvZbaD{V`}@ve@vxAqaAdkBi]pgFa^zoHkdB~|BoY`cCi@xaCj]fjBzw@j{@voAvGfsB",
        "wfz|FyueaDaeCyuB",
        "ecg{FoqhaDyYjeCar@xuBs}@f`A",
        "uok{Fas~`Dv~Fx|HxFz`AhSbZxZnNt\\|a@|sAjmDvnBvcD~h@piBj]|jKjp@xdAdkB}_B|gC|`AbxBvZxmBkRdkBiiAfiC|sB~q@?jSu|Al[qk@baDriBlyAyOxkCevAdaAst@j|@_eD~gAeDhhAfj@f`@~s@lGt|AnWfu@`g@lPfv@cQr~@e`AfUw{@tTaQf~@r}@~r@zvA~~@fqDly@pjAnYaQfj@md@jg@qC`QjrA",
        "kntxFu{m_DwE|s@aR|j@m[h_@eb@|T",
        "ygwxFqdi_D?be@j{B~q@xw@xc@dc@rk@?ri@",
        "mnpxFkob_D{XvFkz@~]",
        "ucsxFsha_Dp`AUr_@nEdMbZrJdw@t\\nC`IkGp@cOnD_UhU~|@hTbQhh@nCncAgj@f{EznI~qBr~AreD|s@~|BziCjfAz~D",
        "edswF}`e~CgQdjF"
      ]
    },
    {
      "left": "ALB",
      "right": "MNE",
      "kind": "International boundary (verify)",
      "lines": [
        "ce{bGq~owBu}@nDi}@nDk~C~s@ofCf_Bqu@vmC",
        "q_jcGqofwBxq@hpCljAnoBhi@d~@vmClbD~|BrgBduAdc@|bDza@viAza@v`AplAbe@vxAvn@|iA~|Aza@^?lsBpjArgBpuAzuA`eBf{@jzBjeBjrA~qGv~Htb@f_@jeBxy@jl@fKrtA{Bh_@xDlsTxuQzsCjxDfaAbQvbBa}@^SpoAeaBtdE{dJpsAq|AbMqNzz@{MtyDhqBjjBj]vzBbFnvBsUb}Aox@^}@fj@yl@hhB|_@fVld@bD`r@rUf_@`oC_g@pk@xMl_@|Vd^vF~h@gBxXzBzW{M~h@cy@naAwp@lbDpCn`AsD",
        "qk{bGqsowBlE_J",
        "ofebGo_~wBiItpBgg@|hButBllEs`EzjB_y@hTii@zBm}AsJck@_JyhAom@oa@a\\",
        "g|tbG_}myBycAz_D",
        "aawbGc|hyB`gAjeCt|Ev_Fba@|}C",
        "eylbGavxxByEzoH",
        "_`mbGeeoxB|nA~yCH?^h@~g@nx@tfBlkFpHhg@~Lbz@"
      ]
    },
    {
      "left": "MDA",
      "right": "ROU",
      "kind": "International boundary (verify)",
      "lines": [
        "utseHir{aDlsAmnCtHccA",
        "qqpeHyxmaDg~AajH{BmmC",
        "e{reHaidbDx}AccAvPazB",
        "qvpeH{ebbDscAebA",
        "empeHuirbDzb@giBbwBwmC",
        "sjoeHghjbDqa@m`G",
        "mmleH{e|bDjsDqfG~m@kf@vhBeX",
        "eqkeHubzbDg[ebA",
        "a_feHijlcDpl@ylA~fAu^jaAom@`v@wvE|t@?~m@`fAdDvyBze@?ncAejDxY}sB",
        "i`beH_nfcDmTw{@idAafA_c@ow@",
        "akxdH{i}cDrOst@x^yw@t^}_@bDNt]jBdx@z`Aza@bObxCom@bwBelB|xAytCn~@mbDhm@?ff@f~BdYoEpV_HhT}JvPeN",
        "w_wdHk|zcDij@olA",
        "mq`dHgdpdDpnA_qAbtAex@",
        "_b_dHuckdDmn@q_D",
        "wl|cHkcwdDpv@kgA~x@mEzu@fj@`l@hiA`fAcbCjMmf@tK?`Y?fdBxlBzw@ybArt@olCzyAupBb[dD~_EiIve@bD|_@e`AhNsjArUccAbt@on@lxAxtEzh@giApyAguA~|AweA|s@a\\h[{Vjv@cnB~Ss^hIwBtr@{Q~aAtHjl@ga@bf@?~R`oCfhCyw@jdDmnC~jJ}uKbwBmmDlq@ubE`QkEha@cKjnA_[|e@wRpUaGtw@h@nZ}K|IqWbEybAfCcO|fDgl@`zA_g@vf@}`AlDov@fLa^nNoWhKec@pB{_D",
        "wl{cHmotdD__@}rA",
        "k`x`Hyy`gDfVgtA~c@s|App@onAz{@qk@rZjr@bo@z`@f_A|VhhAvQz`AcnBn_Evp@fg@{vApGmMrh@eeArtFouCf{AwoAvOmo@zX}gDv[eaAfZen@dTup@bYk{Cbo@e`AdvCg~BbmAvFxmAqaAvhC}|CtiDgjAzB_Jbp@wOrd@cQnYhJ~M`eA`eAgiArcBumGni@?xl@be@pQwZbLmz@d\\cy@dpCe~DbnA_pDbo@emAbyA}@jSmwCl~@sqChj@ufC",
        "y|w`Hcp`gDqBuH",
        "aca~GgfajDdfBew@bE_FrgDg`E`iBgtApbFmyBh|AyOtN{Ab}Art@bp@igB`fA{CviAvFd|@wdAnm@?piAfIxp@zEjnDwdBlhHg{FptBJzbNc}I`hDi~@nWgDjaAcMltAh@jbAhh@~lAt}@rxAr^teBgu@lZly@dn@|UbiF|Kvp@}KrmBkpAnN{W",
        "ky_~G{j}iDuh@kzB",
        "gmtzGsakkDhEsT~r@kGv`EU~r@lFnn@nc@t]nwA|sAel@jb@`\\nBnJvLhl@b\\jh@z}Dbc@lYv\\xPfjAnl@dNx}BeXtkAyDrTtHn`CrsAjr@fjArT`z@dN`fArUv{@fj@xXriBiTz`@zM|KjeAfVhiAht@sKxaCsqBlc@mf@~i@yc@pu@_SjpCtfA~xCxc@nrEhhBt`@xObwAzj@rUvp@h^xOr`@}@jQce@r`@}@hzEnlAt|@~InwAiTfxHmwCbeAsJld@oNhj@od@jp@yXnn@pLxn@dXjp@jGdm@mPnnAqv@pVgK~]bQth@rqAz`@xZzsDmPp|Dq`BftCylBly@}s@|qR}u@lcBhK`pAye@~]dxA",
        "mgtzGcgjkDyDoY",
        "{rnuGuwyjDi@jlE",
        "etnuGijsjDtS`qArs@jfBldAteBleAxmAnaCc|IbmAmnC`dC}gBve@}VfLoNpMkGpqEgB|~@}j@dlC_eD"
      ]
    },
    {
      "left": "UKR",
      "right": "ROU",
      "kind": "International boundary (verify)",
      "lines": [
        "evfeHcsu_DmUqiBmdAknEwQ}hBoHefHsO_gBquBasWa{@q}D",
        "ilgeHykp_DpMur@pFsrB",
        "scwcHyln}CsoAglK}AwhM]}oC_{A{fHi~@a{@etEgiCoaA{kAa|AmbD}y@qjA{cCg_BmaEkdBudE}`AslClGqmE{l@",
        "idqdHgjflC|LolC`dBkrLbt@{jBjmEa`GziDmiHxmBykC`Kgl@`Com@",
        "euzcHs`lkCiImbBcmCmjGqiB_sA_cHckC}}BwyBeh@{~B",
        "}b_dHgeynCbYsrB~]mqKny@c`GpLipC",
        "{kxcHceenCcD{`C}KgWeI_Rg\\ec@ob@s^uh@cZae@ebAwLwdAq[cjF",
        "ib_dHsi_kCpa@cnBdl@g_Bvg@eaBrSmdB",
        "crscH_hsjCoYs}Bir@koBssAis@s}B|s@}hAis@eD}}A",
        "{v|cHk}wmCXaHjAuHxfC_tK",
        "_d|cHaktmCqBom@cKwp@kA_HYaH",
        "}p{cHopcpCpa@ueB~hEgcIl_Bui@",
        "wa{cHw}uoCeNwqL",
        "_xwcHace}CjSwhH",
        "{jebHwr}vCgWshEcIosAkw@_tMuqByeK]SIi@}hDicG}bTq}Qu|BkjGc`Fkz~AkoBmzKwZygI{v@g|DwLihB",
        "isvcH_ajqCvE_dEvp@ueBtw@uuH`f@a{BdqCkbFbNylB",
        "}cqcHcfrpCi@udCamDetR",
        "ivtcHeebtChy@qcJ",
        "m{icHyr{rCgmC}`LyEcsHqmCcsFis@mnC}AwwB",
        "{_scHckxtCnSayBhScr@~~AopFftAs|CtpAq`BnbB}h@zpAyD~kAm[|tAmmBxwAsqE`eCcxNpu@azAxgAemA~~FqqElwC_qCfu@qtB",
        "_|rcHwimtC{Bk`J",
        "w~lcHsykrCx~AopJnBufC",
        "wylcHspkrC_D_H",
        "agntG{ubkDhgA}rA",
        "kjltGgdjkDjgAwuDdtBcyBj{Br_@npIaxDtzCmxBp`AaoC~R}hBnwAiyEbdBekPn_EaeO`cCi~X",
        "w~ktGyiekDa@{LqIqkC",
        "_wjtGg~}qDrIybAdXmcApLk|@pa@s_Np|EcdZ`xDsbHl[uhAvzAeiCbuEihBdrFi_@zrDlpAlf@{b@dl@kHpm@dMpl@b_@@?",
        "wnftGe_rqDq@cbCqMgu@yY}u@s_@mo@s_@ec@a[cy@",
        "i|ftGwynqDpLmdB",
        "kqjsGyjqoDmd@mnCij@k[mwBaRst@yd@}V{k@gJ}u@qBqiCa]ssA_zD_`Iur@{}Fea@ojB}`AyxAmPur@wEcvCcQu^qk@gV{k@}s@yx@i}A_s@keC}AueB",
        "}vssG}d{nDpV{_BtqAkcD`QcmCvf@ynAxlAueBtr@_{B",
        "ok`sG{lfnD}TehF{BwbEgWmnAox@meAmx@hpDoZ|j@em@l\\ow@`Qyn@sJ}~@}qD_}AtHmxAcFa\\_eD"
      ]
    },
    {
      "left": "UKR",
      "right": "MDA",
      "kind": "International boundary (verify)",
      "lines": [
        "u||fHwhjgD|JigCjcD{K~g@_}B",
        "yjnfHufgfDkb@ugBcuEezJ_bCknC?M?}`GmKiiA}gAcaD",
        "{gvfHqgkhD``AipErfEwrK~aAs|A|~Bi_CjeAseAj\\cp@`oC}gCz`A{|FxQw`FjZwhI`h@}~BjoAueBfoBga@~sFvyBtm@azAhCqjC",
        "kcvfH}{rgDoCsjW",
        "udsfHug{eDrScwBfnBspD~TgtA",
        "{ldfHmdaeD_qAalFq[aa@mzG_qIylAcaF",
        "_alfHwv_dDpKoaA|u@{`CfhDq{SjFwkE",
        "}zcfH_z}cDiNs`@o^vFwa@tSyWnCkh@qA}s@lPgl@yDcOcdA",
        "{{jfHmvybDz{@inEftBwkEjvAwvE",
        "irffH}ttbDwd@gu@am@mP{e@}T{M{bA",
        "ungfH}bpbDlZ_fB\\_j@",
        "m{ueHaohbDmEwzBij@_fA{oAeZauBpCcwB|_@gjAxc@aw@dCe|@{`A}@qa@",
        "ywdfHcrvcDbDel@lPui@",
        "krbfHgjmcDsZmkFyh@mz@",
        "gedfHmn{cDhIqjA",
        "gadfH_jycD_CmcA",
        "sn~eHw{yaDt^uyBv~@ssA`lAqaAdbA{kAnb@qsB",
        "qqpeHyxmaDir@oCeaBug@}iAocAavAkmEqoAu]_t@ec@",
        "{ppeHwr~jD~eBel@xwBsUteA{`AnUsiB",
        "ufleHkirjDwP{_B_mBw`EmIweB",
        "u{leHsg~kDjHejB|p@g`AtuBsJz_Cth@bx@ldA|f@vxAtkAdaB`vAjh@~uAsJds@ydA",
        "{sfeHacfkDyT}pC_s@wdCix@yaBam@}hBsUc_H",
        "{i_eHkcllDxl@eaBnsAa{@v}AvFzlA~fBvuFspDxr@siArz@g}B",
        "yxvdHu|{kD_PcbCshAg_Bs}AeaAsiAupAeLmnC",
        "um|dH_pemDbEggEd_D{}P`CaqLnYcaFbnAanDzp@sh@fl@eNli@eD|i@yMx`DccBlbDaSxd@}Ixg@_i@x_AweBjm@_g@jsC}~BprCohEtcAadC~l@exArs@q}D",
        "wtjdHklylDqBg`Aiy@gVmiBsAsiBeb@oWaGKEoaFypBsi@gjC",
        "aczcHqdqpDdBekB|UevAxo@{kA`oA_hAz_Bap@duE}u@dzAwp@`m@yvAjq@cuFj]s}@ftAhSrwA|~AxrArrBleAfkAnlBdw@rcAUtg@a{@ns@wvE`q@wnAnbAgWvnAriAz_DtxDfbEfa@z{EyDrjFr_Af}Dx`DtoCn_DjcDtpAxyFapARSHSTKxv@yg@bWsPl{Dq`BjaAsr@lz@upB",
        "{rocHii{oDk\\kbFwpF{pGa`A_eE",
        "o{r`HuuiqD|_@cxA|aCapB|uA{~DxaAsi@liAa[vaAwq@da@quAzLeaBb\\q_B~pAupA~aBi_@fyAqAxwAkRvVqSpfAc}@tr@gtA~]i}AvEccB",
        "usn`H}rbqDcd@s_AkbAcz@i^_fB",
        "}`}_Hu|`sDtDk{Bj\\euBr~@igBzjBisAzoCox@toCyDdkBtfApv@jyCrfCrUjfI}~@vxCdc@fiAlyAxYrfC|JvlDvPfMlRnCdReDdSqLbtFe~Dbe@gu@",
        "ubq_HydrrDsTycBafAclBevAij@s~Am[_`B}~@wHg}B",
        "opl~GolnsDze@uqAjaAwfA|sAel@h~AyDbtAnn@ly@fjA|cAbcAzgFxm@vqAhZbN~CzpAbFfdA}u@xDob@",
        "okf~G{sdsDce@ybAmoAsu@ueAsgAwFqtB",
        "can}Go}ssD~S{w@~lAeaBb_@st@zWkdBrJykEfWq~AfeAaeB`cD_qChx@iqB~SudE",
        "yvm}Gg_osDiIg}C",
        "{t~|Gah~tDnNupDteBqqDfj@m\\fpBup@ja@w\\fBqv@",
        "sh~|G_pxtDgKawD",
        "ijv|G}fruDjYebArh@oN`eCh@nx@mGnl@eWbyAycArn@wZdrBkHxcKjr@~gAxXzv@j]hz@|TnqAzBp_A}U`_CylAhz@gMneCjgApQphCvFzjBjjCkR`jAowAloAyrGtNsJzz@_^fL}T",
        "q|t|GwpnuDyYmx@}Qw{@",
        "_c}yGggfqDy}@|hBg`A|@}z@gj@cy@{v@a{@wf@shAgK{oObDeeC`h@{vAxbB?jFI|}B",
        "an`{Gez~pDbvEvcPx]|uBrx@l}E`xEvpMrhCf~BtnDve@~cFkq@nfHylBnaByDjoBxc@xxA|j@ftA{BdbB}iBH]pgCkoEjhBy_D|fCqa@|rChiArfDllC|gDbvExaBxn@vxC{MzoGcnBvyB|Kjr@tzCzfEv`a@vp@nkBbzAbdAhgBxCjwE{uArgByXt|BtGtoAhi@|u@nnAxn@xvBl[xtDj[dn@zb@fAnw@yN|_AmGvz@~TnbAjbDv[haL|sBlcBdo@gQ`cAuX`q@ve@tg@zsDjq@zjB~r@bdAnvChpC~fAhj@zk@qv@jg@q`Bxx@aoAzvA}a@dvAsJfuAcZ~rAeuAzu@hdDpVnc@dFjDbm@ja@dMr@rJ}KpsEag@|hAxZhi@vbC",
        "ywxzG{g`vD^ob@|Ymp@le@_h@zkB{kA|t@xn@p|Ce~GjvAgiB",
        "klwzG}r|uD_Hug@ma@gkA",
        "k`~yGwhwsDwFpiBeh@p`B_nArsA}gCfuAev@xwAsUdvA_YjcEcZ|}Amk@dc@cn@~Imo@iKwp@{a@sj@q`@}i@iKug@~Ise@za@sOjpC",
        "m`vzGamxrDbApD|n@f{BxwAfsBj`H~nGr@xmA",
        "qrhzGexerD_qBvnBawErqCkSxvA",
        "_qszG_~zqDf~BxlB|jA`Sl}Bw\\jw@zB`oAri@tHt^",
        "gtyyGyx`uDq~Ar{B}i@rKywBqB{w@hIis@v\\cmCx`C{wExgIa_BboA",
        "ykszGipjtDtnD|@`{AlcAv`@||Bl@~oDlf@`g@`xC_^|dBnm@pz@~rAnYteB",
        "aokzGshvvDvKkdBrc@krAh`ElwCrmBxaD|_@dqG",
        "u}izGilqvDwd@_}@sJi}A",
        "gudzGukuqDuHri@",
        "}~dzGaatqDfRdkAfmDvaFly@ziC",
        "yl_zG}sivDq\\fdV",
        "kj`zGunruDnNvcBrj@vnBbmCreFzKvyB",
        "kbvtGytylDiJnoKquAhsMeWj}L",
        "m|ytGsqpkDFNvnDbkI^TH?hhAfu@nmAfj@fk@|K"
      ]
    },
    {
      "left": "POL",
      "right": "BLR",
      "kind": "International boundary (verify)",
      "lines": [
        "aq_gIinynCI?acCxvCq_Cz`AkkInx@g|C|~@aoCtqAwwCp_AcvDvF",
        "idv}HeubmCsiAp`Mkv@xkCcnBup@eqA~Rq|@lcA}Vlm@uV|l@{AjRejJ_aHylB_rByzDsyFwjU}wV{vG_fPucEqhPitDos_@swIa}XkyDuwFcjG}tAuzD|KstVhs@yn@bOo^dXmd@jTabAxDgp@mPisAcdAqe@wQaq@pAamD~s@}f@RajA{M}n@jIq{AtfAyqCf|D}hBrt@{xBkGcuAc{@gjAqjAayAew@ovCeMgjAz`Aaq@fjByhAvnBw_BfiA{yAlo@kwAj|@qyAjoB_qDnmB{mQ~xFsdEh|BimJneHck]jqO_sLdtCw~JfM",
        "aq_gI}nynC?R",
        "s{n}HaswmCiIbQux@{l@we@?qGbbCsxAdcK{q@`qA",
        "m{v}HmuemCbVf_B",
        "swl}HmdgnCq\\hh@__@`}@wZnW",
        "}po}HqdcnC|~@|tA",
        "_qm}Hsn`nC}Elz@ub@dw@iTdmA",
        "}po}HylzmChTvxA",
        "_yb}HqasnCwVlxButEvlD}TeXwiAmP_n@|V",
        "cvn}HamjnCn}@rgB",
        "aityHy}ynCqAsi@_rC|gC_vAfu@yxA|TwgD}_@q{@lGco@`fAum@?yCgw@qMae@y|@coAcZ~]cj@be@gg@~RmPoWcPox@{e@dM}j@~h@i_@rUaoCqb@_bAeX{k@eX}jA}hB{p@cbC}hAcwBkpCydAk_B~qBgpBdaByr@wdAofC{X_Y}iAw[fBmFpCI|IcEpWweAug@iiEqC_rBug@mlDeuB}nAaqAal@eaBwiBvfAakFnwA{lArr@_gAnEegAdXy_@dkAcOxy@qf@ld@{q@t^mo@hh@}j@ptB",
        "u~b}Haj|nCtDngH",
        "sktyHesxnCpAsi@",
        "w~lyH_raoCsrApW__@ftAqVnbBu`BnlA"
      ]
    },
    {
      "left": "POL",
      "right": "UKR",
      "kind": "International boundary (verify)",
      "lines": [
        "{pfuHktwqCyb@g~B_@inEoX}|DokB{kAemAvoAytDrgOwuFneLeaBr|AaqAfa@ew@lEkr@nPoaA`dA}_@fkAkSlnAoXzl@cp@oYwe@?qdGrhAurAhu@e_D`cDuzBj{Aox@gVw`@kfB{jAvdAw}DbhHm}Bx|HwjBzkC{zMdyIsj@riBm@vwBy^daB{cCtg@krAq`@{zA}tAyhAanB}ZkqBmsAve@g_AwFsj@qk@eTigA{iA~q@uiFn}F{e@tH_|Bo`Bsd@nwAiY~oBoi@daBovA~h@se@rJ",
        "}khuH_orqC`z@kdD",
        "ow_kHafniCg`@be@{jAq`@ifCyaBg|EowAg}DihBwyA{V_|PpsAmbBxZyn@za@_|A~eC_sAjpAqa@lPafAfVyhGxe@kzA|h@o~EdwBgpFuzCk}KcyMsfE{jB}t@gl@af@wdAmPkeCaRmcAcdAihBecM_`Kco@u{@qV}u@oYmmBeb@gu@qk@a\\_}Bar@sr@}_@ylDsdGw`SqdTipDuwFsrBucFizD_{Dad^esk@mkCiyGsfDksI?UKS?Ss|A{sD_vI{kNwoAquAwGcC_eDqmAwzAmcAgt@ssAeb@{jBsj@wvEaHkkb@evAygIwlE}gCobAk[apAkImwBtHijAmPieCmqKmoAeuBufAemA{LwFmPh_@uqApk@ehHh~@e~CuoCqAr@}qFp}CmbCbp@mmCce@cY|fD{bApiDq~AxvAolBkpAwe@?qLjmDsj@|rCmnAj{AovBrJgjB{kAcdAknCoMokD",
        "qc`jHo|njCybB_hAkSdKgLzFsqBjdByy@dZ}sAwFkyB{w@_t@Ri~@rjA_fBhwG{v@~qB}|CxuDu|AxiE{B{VqAwFgl@baB",
        "ghbkHyuqiCdcAtqApK`\\",
        "q_rjHokuhCnXi|BdiDoiFbdAwxCtIieC",
        "glojHwgqhCirAwbC",
        "sejjH_hyiCdDybAlf@i~@piBsrBnMcdAle@wnB`qAgiCzb@s}B",
        "oiijHe{tiCc[ykC",
        "otijHcymiC~IaaF",
        "alijHksiiCmGwdC"
      ]
    },
    {
      "left": "BLR",
      "right": "LVA",
      "kind": "International boundary (verify)",
      "lines": [
        "aituIuyxjD_yA`lF",
        "acwuIslqjDtx@bjGdj@bjBzcAriDtgAljG~]jaG`VxmA~w@p`BdcA~|@nkAzu@tqArjAnvDrhLhpBvbEztCnYbkEljEreFllRxsG`mDlhH|j@jdC|t@b_B|u@pKtnD",
        "c}nsI{xkeD}t@xjDyyDpdK_i@|fC{Vd}F",
        "woxsIkandDvy@tiXtBfIdo@`fCbxFlgJbrJneJtqAt{BhpCtqNdEjnC",
        "m|osIwufgDug@bqWab@`mEq`AjbEkeB~zC",
        "cpwsIev|eDftA|~Bt_D|bH`\\lxB",
        "ujzrIuwabDsjAtkI_IhfD",
        "i`}rIucraDnn@`xCbbCxbC"
      ]
    },
    {
      "left": "LTU",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "gympIywmaCxlB{~Dv}JecKrgBwaF|JkwRtfAo}FjdE{vL~pAgjBjs@{jB|t@yoLziBosEpl@ywBr^{{Exy@owCpLi|@",
        "ewepIoyx`CosF_aOqLi{C",
        "imgoIopheCt^}iAldAaSjeB?jfByw@xbA{iC~]}fD",
        "indoIiu|dCqLst@agAmbDkHcaD",
        "o~coIwpqhCvp@owCxVqb@xf@kz@~{BmcApyGugBzjCirApjAshAt^ueB",
        "cn`oIwa}gCkoB_nS",
        "y_coIo}xfCdGgsBnhA_o_@",
        "swznIc{veCkGaoCcp@gsBox@afAyn@coAkdB{eT",
        "a`lnIkxqiC|Iwy@dYug@ri@sk@`f@a{@vQirAhsAvdAlo@ur@vcBusJtr@olAxnAmq@z{Fs|AhrBeXlmBbOdlBvoAjz@h}AjqAlaEhsAftAp`@`r@pa@xlB|_@z`AvF|s@tIhT`]|K~\\}KxZwOzWdBptB|gCpj@nY|~@TvmCye@zbAaF~oBvZxhH|gCbdNpk@bsFcc@lvEaeDneKqwJ",
        "m~knI}xfiCs@m~I"
      ]
    },
    {
      "left": "BLR",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "wy`uIenxkDqWvbCogA|~BqwCb`EoiGlpLejBf}B",
        "avktIawynDkkAp`NqpAp~C}}BbcAmsCfa@wqCvy@s~@hu@aoDtxE{jBjeBea@xx@qWrgBg`@rbJ",
        "uqkuIkxdmDbx@h|[bz@hpCjsDvmEhn@xkC",
        "c{dtI{wsrDgEsi@}f@gW_q@~Syx@lz@guArrB{{@dlBmf@tpB_vCp}\\evAlaEi{BxgH}dA~aJ_EthJ",
        "cf}tIiaepDpaA~vH`dC~kJH\\?HHT~`BbeKv_BteDtpCpLjR|gC",
        "_~dtIydrrDzAar@",
        "{ezrIm~|rDwe@`{B{{FtjHgsCjuHczAbnAwaCrk@ebBm[spEqsCa`AgVwwCu^mu@iTss@ap@_Uyn@mKar@yXa{@mK_r@",
        "q_urIse_zDkQxkCcp@r}BquAvmAwy@?kq@a\\{w@_SymAxXkg@zl@u\\z`AwwCpjPgu@jfA_s@yNar@od@wt@pAec@rt@agFtte@sj@lwBolB|qEwPnlB",
        "mw|sIqniwDjh@tnC`xCtwG~]`bD",
        "_vusIccwvDozCt`VuGf|F",
        "ezzsIedxuDb^hxFbnAtnFloBjyCz_GbsFxn@n`D",
        "yjjsIekwtDc}@nnL",
        "}hlsIu{itDtRteDrjEnhRhgIzaNlZdiD",
        "cvhrI}{xzDyPfqDyhEduD{`Bv{@k|@`{@eYztA",
        "ekurIydgzDrJd~F",
        "syxnI{{a|DcZi{CmxB{CwxCfkAmwB|sAyn@bn@ym@lPsk@yMii@wp@q`Ak]s^`H_Tl[}_@vZkGbOsK~~@uHhTs^fKqw@cZeXtG{u@nmA{`CtaHolAxwAgfFhgBsiAlpAccAp|Est@zjBomAh|@etBaQqtB{vAmnDavEizC}wJshAelAa{B}@uqAhrAmmAbdBwoBvo@_gByc@ugAwaDymAye@cEt^oc@r|A{{Eg~B}fFhj@qe@rb@}lC~aC}`AroF",
        "}olrI{|g{Dhu@hoGnbAroE",
        "geznIiux{Drj@qeH",
        "{~tlI{ne|DsrB~TyaB~{AswKf}\\_s@v`Gsh@p_BybBvp@wmDga@anBkzBguAwmCybBg_Bs{CkGi}Ar}@}_AdOwdAqsC{k@o{Jon@wnBowB}sBqiAb\\ybAjyAkfBr_AgjAih@oEs}B",
        "gyzhI_v~`EcPpkAshAfu@kzAri@afAxn@cp@`fAsSncA}AtmDqWb`EwkDzjOmp@peIug@`xCmnAz_DydMvm]i}A~{AuoDpaAqmJpk@wcBdl@yx@paAcp@nlA{kAjpAk_I~pC_|B`eBs^jyDo@d@utAndAglAloMkoAzsDsoGszCqdH_wH}pF_qDqtBxtFkmDrqCs`@lmO",
        "mmulIywi|DpM|gC",
        "ajfgIkfpaE{jBxwO}AliGuyCcx@mkFgqFg|CylByfJaeBghCufAyn@mGom@qA{l@_Jmo@s^kkIjnCa\\}@uSvFqU|u@",
        "s_}hIqsdaEvEp`@r~@~zC",
        "_bzfIwrqdEg`@byAy_DhdEg_Bf|EeaCxoW}|CpnJyOdkC",
        "gulgIoiybEdjEbbh@",
        "mcmeIyb{eEiJxm@wf@fj@g@?upBp`BqaArqCywA|xHebAxkD}}A|qCy`C`oB{jD|_AylBjRup@yEeX}j@wnCkpMgl@el@ym@{Mcn@zMem@dl@a{AzuBqk@lxBsJn_C",
        "ujzfIyi{dEtG`vH",
        "ypgeI_qifEqMtfAycA|^q_Acd@_s@yOi^bzAaIxlB",
        "cboeIkvafErJxlBdd@jq@zLjr@",
        "yendIaiqfEqw@ayBucEjpAasKmrAss@{ImlChqBUlnA",
        "{yheIinofE`h@h|D",
        "mvodIu|gfEnMihBl[i}AtDwcB",
        "eehdIg}qeEqV}eE}y@ifDiUdXsy@rs@uR~Tcy@_tL",
        "idjdIszfeEzp@s{CfL_eE",
        "y|fcI{i}cEscB{hD}gC_|CmmBojE{k@uaFo^weBihA_pBuhEggEmtBssAsxB_}@{PtoCscAzu@_hAyn@q\\y_D",
        "wuwcIasy_ExDq~BvyAy{JpMayBfAorGhd@wmBdkB_sAtaGebAv_ByaBxM{`A",
        "}mtcIkui_E_DgtCkkAwjFmUu{B",
        "{rucI_i`_E|c@kkH",
        "}|s_Ig~|_E}KssAo}@cZw`A|rAiwBbaF_lA~pAa{F`yD{cFvtGa_BbdAI?{oCocLgyBqjC_gGnCgyBhu@_o@f_A}^fkAyhA`yAogB|u@cnAzMap@vn@yKbxCef@jxDmpAllE}mBr{Dq_CrfCktHfhDevBhfB{gFfwMuvA}iCujH}vHsQ__AgPkyCuh@wz@m~@_TobApLm_AvS}FnAimAvFelHgsBeoBmkF?whH",
        "oagcIacscEtCyeI",
        "wracI}gpcEmPa]a]yEk\\fByNi@wWyM{`@aHmVi_@",
        "endcIogjaEbKkoAnqB_bIlUgrC",
        "s`dcIsgcaEqL{~E",
        "wabcI}|jbEnoBmfMjDwvE",
        "cy_cIcn{aEiI{tCgq@o`DaKmvD",
        "g}acIyymcEjH{u@b@gV",
        "{k~bIc|_cEqRyx@wjAc`DaQwaF",
        "{}t_I{zu_E|_@kbF",
        "q{~|He~z`EmwDeMozBdXewArsAkeCpyHge@nx@w_Apk@avAbQgzAeNwnAsj@or@{`A{b@bcBwV`xEqVzjBor@`nBqeAjfBghD`yDqk@qkAe~@cnA{kAq`AmsAoc@uoBdBicAdn@ys@r~@icAxm@q~C{A{xDyd@qxC`Hu}@dkCa{@bmAg{@dNuq@on@q\\anB_lAzkAyTbZoCi}A"
      ]
    },
    {
      "left": "RUS",
      "right": "UKR",
      "kind": "International boundary (verify)",
      "lines": [
        "}hs~HeuriExgAkbR",
        "atf~HaazhE{Gox@i_@oo@qvA}gAgUk|@mZovByn@moAazBe`Dgl@kdBiIitA",
        "ewq~H{q{lExDqzG`a@_|Cpz@wdAbtA_r@tlBeaBlhAwyB|dBgeGpcBqtBjsEuzCfdAirAnfDcpKjfA}hB|cBihBbhAa{@l{@qb@vy@cOfeA}@tkCzjBz`@?pjBiT`mEoN~vBqb@tkBqjA|bCy`CpjBuS~zAlo@vu@rAh@_wHly@s}BdzDgfF|Tod@fb@sqAjWec@p\\eOduAqUjNpApPshA",
        "alc~H_}okEcG_fCgeGgkLm{CmcPi_@e|G",
        "_cq~HgdjkExgBeuBpkF~f@p`BqiB",
        "qim~Hye~jEeDmoBce@myAym@ssAi^}}A",
        "waq~HslrjEjMqjBfcAmwCrGkR|[y`B",
        "c`q~HqxejEs@asK",
        "qak~Hg_vdE|yBkzO",
        "u`s|HcaxbE{CirBwyFw{YigCmtGyoFotDkwJqjA_nByy@kf@a{@sZ{kAsd@wdAqeAqb@it@fV_aCptB_bA`^suE{vAs_@o}F",
        "i_i~HuepeExoKene@",
        "sfg~HszfeEuw@ajH",
        "wrg~HqvuhEvAow@|Z_qA",
        "{iz}HcpzgEkc@wnBgaJidSga@kpB",
        "sn~}Hc{mgEb_@ghB~{AayDrFupB",
        "on|}H{tvfE}@s{Dc{@cqJaAovD",
        "kq_}Ho~faEdYmlEbsA}pCjeB}`@nrBs@`_ByYlk@sqB",
        "q{~|He~z`EyTi_K",
        "g~t|H{hlbEp|@gwJ",
        "u|p|H{nwaEsKihBkfBilIqLkbF",
        "u`t{HktepEzl@wnBbqCinE`v@cyB`|AysCbx@mzAzxFsgDt`GaHbmDlkF`RlxB",
        "u|r{Hot_pEyb@guBEshA",
        "uvqzHsiupEwBzmJ",
        "mzqzHwzipEv}C|f`@hwAzqF~qC`{@x|@wdAve@}{Ejc@{vAhm@wZp_CcZtx@{X`p@yl@hzD}eGnwAkpAvjBur@vgCeMv`ApLrmBzu@d{@bQx~@cFvu@{Vzu@eOx~@dO`b@rr@tRhgChd@t^dr@qWht@i~@`iAkzBbe@k{AnYihBzLqiB",
        "m{oxH_gjpE`rEst@roE~{CvhD~vFh|CliJ|wBs`MnRetC",
        "qnnxHogcpEIobBqk@_{B",
        "ibzwHsfxpEfVqgF|cBk}Ljm@umE",
        "gdtwH_tfpEm_@cnB}xByhFub@uxE",
        "idvwHsp`rEvOs{Dxx@yvArtAce@p_Ba\\t|Aa{@~v@wzAzWelBlQihM",
        "wwtwHg|sqEqk@ksK",
        "y~qwHknktEdc@srBnm@qvB",
        "qbhwHqvasEo}@aqLyfC}_OmnBuaHoEcaB",
        "alqwHep~tEj\\ywBd}@wmAryAcp@`}PwxCflE_{BrnB{sDrI{rE",
        "clowHqyrtEiNwwBab@u{BqLe`C",
        "_nqvHcohvEdHcvE~XkzB`h@koBvcAgu@jkBhs@~r@nwApl@lsIldA{Xt~B?xi@?`}@cO|h@}u@hTgrC~^}iAtqAymAhhAwFzkAbO|~AmElnAqk@vmB{~BzkAiu@nwAgKfjAdMr_AiIfv@{vA`z@}{Chi@wdA`|@{w@jnDst@jzCtSfhCiInuBsqCpiCbbNrhAf_BxnAuHhuVchHxwCmcCbx@qqEdOigC~\\y`Cbz@apB~gBquAprCwn@lnBuH|~Amf@xbBqhCzu@ewB~h@}|BfWq_CxDwbC",
        "ipovHkg{uEu|@wfL",
        "c~xrHatjcFhj@k|BbaDs|AxiEssAtdDmdBxjD_fPhfCw`ErdG{MfsCt}@zaA`QnbAiI|i@ui@vmC_xEfsQyuQvcBo~ErqCcoNlcBorFjzBetE~{Cy~DrdFyiErJoE~pBq~Ap_BgBbe@m[",
        "ybfrHgtcaFghDgk[uzAkxDumFslJco@wwDqv@yrR",
        "msxrHi}hzEnw@e~`@lz@ejDpsBcn@xx@iqDn~RinRzl@mnC",
        "cagrHolvxE}WyuBcEc\\q`A_sAupAmcAmoAueByM_t@qBcwB{Mew@on@ydAmmB_{B}i@evAeYapBgj@kmQ",
        "mmgrHstu`Fri@s~L",
        "uplqH}ij~EgKykCyn@euBkr@st@_fCccBex@wy@wn@coAaiKkl_@g_B}wKaRw{K",
        "qo`rHeld}E|Kk|@bo@o_CtSgiClnAyjDvZsfEpMew@~g@s~AnNoNzXlPziCpLt|@fMpv@wQlo@_|A|_@keCnN_qC",
        "wczqH{go|EeDetCih@}rCs~@}gColAayB{M}j@i@gkA",
        "m{ppHo}ahFhV{nK",
        "{ytoHactgFudCqeH}nGg_@k`Hdl@ayDk|@oOmbB",
        "cyppHqxshF|J}sBxcAmwAxeJ_{D~fAiiAdb@q}BvR{pG`[omB|_A_qCpu@kbF",
        "cdppHkmnhF_TejD",
        "iy}oHau~jFnN|@`zB}s@xbBmPpu@s`@b[kf@hpDqyJtyBkkSz_CetEvxCcvC|iB_gD",
        "e_{oHwzujFcOyy@gWqv@s`@mwCcOoN",
        "_d|oHsfljFxc@csH",
        "aozoHq`~iF}s@aeM",
        "a}voHuilgFjHwdAlo@apBjHqaA",
        "w`qoHo}|fFky@wkCcpBsoGyOymA",
        "_}koHsr~mFdwAu|CbE}IrfQqxIz_CwmCxlAotDzb@yjF",
        "uf~nHw}slFgW}oQ_SihB{`AcwB}}DadEwnA{jBox@qpF",
        "ousnHsyvoFlbBwaFfa@cwBzX}kJxaAwoAblCwdAbjG{aBvvEq~CftA{|Dvf@}{EbnAe|FniEicIve@{~BpC{hD",
        "odonH{d`oFqa@kvFolAgqF}_@cjF",
        "obxmHeccsFfAuyBdkBcbRfLsQ|t@ikAn`C`\\|tAf_BvzArpFbcAlmBlkElxBjdEmd@jxDybCf{FcuFb_F}bHbcBufAxmBxMdsElyAv`FnElz@vn@|t@rsCz_AvwBlvEjnEdxAxwBreDnnJdkBzjDztCjcCzvAj]fqDxOr~@`\\r_@tfAdDnbB",
        "eakmHm`brFqX{~Dco@izDu{@g}CmvFwqJob@quC",
        "_nijH{gnrF_TlvD_@p}D",
        "_djjH{qbrFdvBbcO",
        "ylfjHwmrqFqLn{H",
        "kzfjHgqhqFjq@fjBrxHpk@nmAssAzu@s}BthAupBtoB}rAftAwp@~|@afArj@irC|iAkpN",
        "{kkiHifesFzL}}CjeBayBxxBlEjzBzvAfhBnvBrqC`tGvQ|zF",
        "{pdiHwxyrFen@}gC{~AmmB}jAeuB",
        "mziiHehorFjH_hAbd@g`AldByuBrTonA",
        "ydiiHyohrFsTkwE",
        "yswhHoxvrF{sDnsT",
        "uh}hH_darFpCjnCzk@hgC~{Ah|BncA~q@`fA~h@dw@`r@~h@rzChr@~s@~iYv|J~yCh~@",
        "o}qgHe~fqF`}@egVf_AkbDnkBmzBxaDwn@tl@cFtb@eMxX{MvQoErs@zXfLvy@",
        "espgHgq{pFkH}oF}_@_{B",
        "ap_gH_kgrF{Ady@",
        "}r_gHyperFxCj[f`BcOjq@a{@`b@g`A|}GkcEz~CoaAftAyn@rt@a{@j|AllCt{AnkBtmFjiLhuD{mL",
        "shweHud{rFrSieChhByxAvxBbOhqBlpAtrAdjBlwCbjHzzAduBdjKn{HnzBhiA`pCpLlaEs~A|x@lGvGvO",
        "unteHe_mrFkIg~BqnAgeI",
        "wyddHyhdrFmF~h@",
        "eaedHy~brFrj@juIn]naAry@tr@h_@{Knb@ar@ncAi~@lgCowAd}@}Ix`BpLvp@|Tl~AnaAru@nPtk@gBrtAm[pf@eDlqDzl@r{CjfB|hBr|C|ZtmE",
        "oo|bHmjvmFaUp_CgzCnoIMfQoYj`^",
        "w{bcHwehlFfpAj`H|oD`xEjsFp|Cn|GnmBveG~q@xbBpaAzGheC",
        "ij{bHutloFqb@~oBm~AhpEiNf~B",
        "s|_cHcs~nF~v@jp[~m@|zFbEjzB",
        "ik{bHmtcpF_T`wDg_@xmC",
        "q`}bHqmyoFtq@hlGpBpjC",
        "aeybHw`iqFgoB|pR_Hd~D",
        "i~|bHsoopF~q@dzJ",
        "gt~aHkchkFcz@rzE",
        "ko`bHwgakFxJdaB~{@ptB~pDffFdbA|sB|n@z}C`yB`{g@taBzrEhqDf_DhyExuBdyEzvAd|LuS~pDpb@r_EtxCrlDjzDvmB`oAnbBrJv_A{kAnJwwB",
        "uzs_HgeohFxDapBz\\wcBxcA{w@~{BlP~{A~rA`{@x`Cnn@nlClu@ptBfnCxuB~yDtg@xdEwZtjDg~A",
        "}as_Ha|ghFwWehF"
      ]
    },
    {
      "left": "ARM",
      "right": "IRN",
      "kind": "International boundary (verify)",
      "lines": ["mnqlF}fazGvMitAtaFcjSjWkoB", "cqelFe|qxGyi@i_Lih@elByvD}cI_m@axBqMuqAqFqqFme@ovCyEoaA"]
    },
    {
      "left": "ARM",
      "right": "TUR",
      "kind": "International boundary (verify)",
      "lines": [
        "es{yFumchG~pCzXreEur@rqDobBztAovB`\\mjG`eB_lG`zCmuFjyDwbEtyBufAnvByYh|B{LbmCs`@`{B}~@nzHubGftBcy@jfB}TxoLs_@tq@jQhoDz`Cve@be@nlCyn@vkFxgGd`ChrAztCmE",
        "y{jvFe{liGsUxd@kGvZ{CxZuI`e@",
        "kjlvFwwhiGpXuRtQiI|k@yOpL|rCjfA~eClaExtEhqA{XjpBucC`dD}{Fri@?xLlDlmF`|AvdAht@jeBri@z`B}~@vxB}gDbtGauGp~C{xAhJkEbcAhqBbmBoaAbwDabEleAkg@voA~{@bn@|yG~|@puAfsDwoAlxBc}G~{Bi{P~`HmjTdaB{nV",
        "g~ksFseimGru@ucFjzCoxIliFkhOfqFkhJzhCo_DbzAmeA|}Aa\\fu@gVth@_t@ft@i}A`|@kRleA}@bc@gV",
        "mzgsFweklGyEg`Aa\\{~BcP}qDymAqwJ?grE",
        "wojsF}celGrKk|@bz@mnApL_t@",
        "{desFuawkGoYobBetBkxEeZkdC",
        "evcrF_ehoGdhEaaFru@srBdBu^",
        "ynbrFuqeoGkf@irA",
        "q{{qFc`voGdDu\\~Sk]lo@{b@ncKk~J|}Bq_B",
        "es{qFkzsoGkGwdA"
      ]
    },
    {
      "left": "AZE",
      "right": "IRN",
      "kind": "International boundary (verify)",
      "lines": [
        "{ijqF{sucHNyA|OutAf_AywBbsG_~Jjn]ky_@fqHgkLryDunDlaF{iChOx`Adg@daDdkDxgI~{@lfKrsApqE`eCzsDrpD~qBruErJlfD_sAxfDmwCpkG{bJhrBgdJtfA_}AfyHs{D|mAg`@`vAfBnsAh\\`B`@joAlo@faAnw@?^H?\\RD?h{Bl`Gl~C~`c@jg@hTbn@i@jg@`Qf}CnfI`fAby@``GyMhqDa{Bz|FguKz~HozXzr@ymAtr@sO`zAg\\`yBzXrhBsJ`}D_nHzpBeaBxrA_pBpBe_E",
        "{xeqFm}ncH{MykAom@g`AsrAkgA",
        "_`fqF_b`cHbFmzM",
        "cf_nFaho}G_J{jAkcDguJwQwi@g{@g`Aim@g_@alFihBuwGaaFk}@kTqt@u{@cmCajHi{DwmR}^qgAuqAwzDecDsmEQUauHwuHwcCakEwnBsdGsrBitLgKekCsi@woA_cGwiI}o@koBifI{nVurEikGwkAi`B}_AywB_^qsC",
        "kd}pFujnpGjQsObg@kxAzIiW`SudCdBaoCl[vQlQpWrgAybC~eC}iAvwQizD~|B{kAlxAyaCzjA~r@rk@gVlxAg~CdDq_@",
        "qcroFcxsqGhIwo@pWiUl[qL|T}TnvBm`F~^ga@pk@sS|_Aar@`z@_~@dXyx@b{@kq@neEmqBj`Aud@`{@gt@nbAij@hvHg`At}Akg@",
        "}aroFgtqqGs@{bA",
        "}bknFi_wrGhfDcjS",
        "o{inFq{qrGmf@wbD",
        "sognFu~nsGhDyy@ff@mPxy@dOlt@f@`Vi|@pLgvAtg@irA`bAob@d{A|t@h~@uh@x^gu@rYcy@xo@yy@jp@yXjeCcp@rs@s^`a@cz@ns@etCxh@a]l_AzLjs@pX|s@jQdbAiJnaA_gAldAwcCru@cmClNuiAjSmaBry@o_CdDq\\fGin@tCclD~bA}bJnCykPx`B}~H~j@{nCjwEadh@~pCm|KnfA_jJ",
        "s{enFmjksGsJcOcVij@gPyw@",
        "kvanF_|f}Gn{@kmDvRu|A",
        "sdilFww{zGcDuoBsi@kfCmp@wcBi}@{_B}iAquAoxAufAe{GaoDcsAirAyiA_qBaoCkiJykAweBs|D}gBk{A}jAi^mo@wj@ifBk^wp@ge@qb@axEo_DokA}sAu|@}}AQm@gd@{fBaAeaB",
        "ujelFy~oxGmEk|@",
        "erujFmbofHhfCufApdDsj@vsAuoAtfAccBb}BweBhyAghBhfBa|A|xCczCpoAgpAh_FqiDlwCsfE`Ay^vQq_H",
        "k~qjFsr`fHyrBy{H?_rC",
        "awsiFy{uhHb@{fE`aAqrK",
        "aqiiFqv~gHq`@ouCyw@ghD{lAg}C{`BkzB{z@{jC"
      ]
    },
    {
      "left": "AZE",
      "right": "TUR",
      "kind": "International boundary (verify)",
      "lines": ["omiqF_`hpGnmAa|@vkFkfAzlAgeA"]
    },
    {
      "left": "MNG",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "izvzHilkaR}mBjePexFvoLslHjsKqkGloMqq@r|DmPl|VgjG~nl@iy@fqDsbBf`CcrBzsBaeBtoCelAdtEkrFd|`@ynA||DaiCr}BahEziAyjAbzCq]p}@",
        "{pd}HwxxzQlEv`GrgCn_EnfBnd@jrEnCbiBzMxvAtp@hjEtnFh~A|s@dgHh}AfrOpxKf_DrpDjhCvbEbhBbkEhvEnyd@jmD`cQxkKzmJtyBh~@vqEjyCzoBf`AhqCpWxnGmz@vrCpWlmBlz@",
        "{wuzHkisbRulAf{T",
        "qexzHcm}aRfj@x_Q",
        "i|_yHs}qiReqA`xEgtDn~EclCjmFyb@b~F}@feGkh@~cG__DbhHgaZ`bsAwnAvfLciCfwJ",
        "c|uzHc`ndRfCvuy@",
        "awdyHmtnvQuaAbcO",
        "wyfyHip~uQhFhdDp_B`vGvPzaB~w@vdAfiCnvBb_L`_HdqAzkA|rCtpDdrAlcApnBpk@`{A{BbvEshArbCsU`_BxOhbHprD`zAza@|qEzw@boEz_BnvOpmKp~DqL~xD{hDrrCwaF`zBogHnbA}~@dkA{w@jgAcxAnbBsdEteA}a@vvFljGjeChTt_Iq}D`zN{oHdvB}}AzvA_fC`lFcyMjf@ejD|j@{cKfk@y_DloAquCdvB_pBn_Dgl@R?HTbkExMlrJrfEtnEvZ~cEur@|hBqLlyBvQn`Bri@r}i@ps]b~FxfJhwHfuZnvBtdEftCzhDhi@blB",
        "az_yHchkkR_|BplM{b@rnG",
        "}zdyH}jtjRlQbtGnjC`lQTbjF",
        "{uxxHaanlRkc@hdDa~C`kIyb@rrBsJfhD",
        "wh`yHyrukRtMtiI",
        "wj~qHecosR{l@~bH}iApzF_uJjiWgvCd}Zy@xIybB`bEsgPhjMwcCv`Gqu@vjRiiArxGsqBlyC_fDd_Cq|DxbAyuDcZuyCyaCmcCiqCylCcx@wvDrgC{}DpaKs|BpsDq}D|tAejDw{@anDovBckDon@y`DnvComAq_AowAga@yxAtGsrAh_AqmDdjDcfFheDmyFztBqgFbZesEih@yfBwFwjBxMiqBvp@_}@xc@}y@kHm_HyqG{`CewAigBlz@s}FvaQs~@tfB}u@rqCsUf`N_h@fsBiwBjyEeXptB",
        "ukyxHuu}lRxTrsN",
        "}ghtHctntP}sA`lF{xIzdJcmBjmFu|@tbG{aBrdE{}CxvC{qFnvBu|Ar~AmPzrC",
        "ifnuHufvrPt\\|}Cno@r}BbmArsAnaBlYxmBrAfsBbOj|L~aId`EnkOlPvwQ",
        "uqysH{pgwPadAndKag@jzB}j@tfA_gA~s@u{BbdAkvFrrByiH{Bc~ExkAczAz|FaR~jK",
        "}~_uHwgwuPzm@~_KzjBb_FlcBri@tnEri@jdB`fAvpAvnB|~@fiCjf@~pCtHdiC",
        "mtjtHa_|pPyaCjx^",
        "gwntHue|oPnb@nxMdlB`pMbkDruL`fBjdDzxJdzHbmBrgDlaDbtRrhBjyCf_Cr_Ad_Cbn@hgBtgB`g@|pE",
        "}qgpHkjp`Qm[vbC_~@xdAqrDvnBylAf`AifDhlGqjAthA_~Ari@myAfVwnAri@i}@rgBupC~fOgjBjpCmaCxvA{~Ch~@}bIpjA_eSv\\ayClo@{lK~xFkcFtHe`Bh]ynAvzAco@vbC{{@lncA{{@jncAayCtlU",
        "qs{sHmkeyPvz@fpl@fAnrHzBxtE",
        "c`wrHauwcSwsI`u{@",
        "{tasH__{aSfWrxH`zAvjFtuJvjT`q@z~Ct]bkDhIvnD",
        "on}rHmawlPkfA~oOi@zhF",
        "ew_sHqf_lPfrEp{Qjh@|pElDv~U`fAreFveB~dDhjJ~}L|rB|fFh}AlcNpuAb_FldAfw@rrDf@xvAv\\boAvoAzv@xaBnc@dlBfVjoBdC|nG",
        "ei}qHk}mgSeLblC{l@vbCk{BrzFym@d_Dkg@boNm[lo@kp@fVmz@lFyx@?kh@bZipDxpI{VrfDi@poIqk@jtH_sA`lHk[niD",
        "ukxrHk_sdSpj@hiZ",
        "yoorHcrd`Sa|@`sU",
        "{lqrHa~m_StTbkExc@dlCz~CdyJnb@zsD",
        "_oirHuuq~RqBbaQ",
        "qrirHqs_~Rt]h|ClxCjuFvz@rhCj\\fpE",
        "q`dpHujmmSew@lkEcoAblDudEtvHkf@zuAcz@f}Dap@jqA{`Afu@srCnx@{`Adb@ij@dm@myA||Ba{@jq@ehFr~Ayx@nw@wnApgF{aO~|[mbBdfGmyBjoP{u@~cT",
        "uefrHgeiiS`p@pdTljFhae@",
        "iaarH_eh}RqVvaS",
        "{xarHgbt|RlnA~iL`fApqDdkBhlDxlBznD|}CnfIdjCheCtcFlsH|fCt|Mfk@p`O",
        "eyiqHeapuRqk@hyDykB|rCyvDvoAwgIroF}jA|~L",
        "a_arHsqmtRhsAlm]",
        "wirqHo_uyTwo@jkHq}Dz}Pm[|bH",
        "ouzqHippxTd`CvyO|eEr~Np|FjhK|i@||Btr@rdG~q@||BtqNraWrVlpAHbbC",
        "cjooH{tg_UeZnvBu{Mz}]mtSft[krA|tAotD~eCapAboAufAvnBg}Pnqn@}}AxjQ",
        "gvuqHcnyzTnkBrmc@",
        "kzlqH{g_hPolAlxO",
        "{goqHmnngPpVfpGblD|xHxYh|BvPl_G|^h|BrwJvrVriAf|FhqB~rX~rAz~D|{Bp`BbbDve@dbCdIbcAhDn_DrfDldBvrHtq@|nIvQxm[xlAjjI|wBlvEx_@ly@ly@lPpqFdc@xmAK|i@yb@|~@wnBdd@w[dbA~HteA`zA|u@xDnmAcmAlxAuvG`q@mnBjoBmdA~}A|~@rgAr|BbnCl{KdjCbwQjzB~wG",
        "ag~pHmtvwRoMr_Ls}BxdLioDtuJgaAf{Ek\\tdE",
        "cdkqHkucvR|i@dsR",
        "ke`qH_f_zRcn@pxKy_FpbXaH|vJ",
        "k~hqH}pmxRhvIn{U",
        "qsspH{stuTw\\viG",
        "iqtpHciluT`RnaCpmJvu`@phDrbIthAblBpsChcI`eAjdB|rChfDdrRhtf@j|B`yDtxCbaDhqPvoL~qBr_Az`BvQn}EbO~fCdbAdm@fjB~Gx|HzX~nCfj@dkCvz@lcC~xE~iJh|DlwPrt@hnGhHphE",
        "q~yoHorhcQwnBjkHag@~h@knCxlB}fErqCebB|fD}_@zgE",
        "yqmpH{jjbQpa@|ea@xkCdsQnOjdD",
        "srxoHoorhQce@|rCi}BtpBumDzkA_@?{hC|{Ci_@xsF",
        "}phpHgk{gQrs@hzFrsBprD`wEniFbmAv~Fby@jzQzw@x`C|fDvaDldAjfBbQt{B",
        "mbboHw{dgUo|Fb`EipEbaFwwC|cGa|Lfut@oaC`eOqBdaO",
        "cmgpHauycUxbB|}NfdU~bz@|k@jwERllE",
        "gtyoHof_qScZbbCokBtbFaJ|c@u[n~AcYxifA{rEbqJ",
        "sqfpHi~|mSbNvwChu@p~CrJhzD",
        "yjnoHkyekQyN`eDey@jnCipDpfGknCz{GgoGvc\\KRIh@IR{V~{A}Kh}A",
        "qkdpH{|giQnDt|A|^xxAnn@tzAby@ftAncAxmAbmAzbAfvAfqD",
        "usuoHalbtQcp@dwBi{ChnEg`@lcC",
        "kb}oHc`tsQtRbmC~oD~yPtqAzwMbp@hTdkAst@ptBmz@f}Dxn@tyCb`EzsEthLbtFzjOp~AngH|t@hcG",
        "_onoHcn{eQga@h|BwJhTot@z_BshAjfBywCpzGev@rxG",
        "clzoHa~~dQpLpju@",
        "{lbnHco}qSgLhqCsi@fjAcoAzBckFykC{jAga@wnAyD}eFzb@wiHlmBccCpM}}Aga@guAqv@qiBir@y`DgWi~@h}@sK~lH{`AdfHgBrhA",
        "aezoH}ieqSxOlbE",
        "qxhoHcholQmYpiBapBh}AshC|tA{uAd_Buf@p_C",
        "gluoHqh_lQzA|qDbo@n`DziCtuHpb@`cD",
        "u_onHqf{pQoBbuFwp@zdJcdBpdI{~CxtCknBzw@it@jzB{U~{A_j@`nDq`At|A}eGjbFudChdFghDles@",
        "}wsoHabfmQdXrfC`bFbrIp`A~eCp`@dwB",
        "ovloHilaaUybBppS",
        "izooHwzl`U|i@jrL",
        "konoHkg_`U}@f}EcZvmC",
        "mlooHkzs_UhAndK",
        "{o`lHwq{uS{KloFuIlfEetDlqKsrNnbZm_HxgJirAt|@guAlo@ynAdw@}}@nwAmo@jdDij@rhO{k@p}BuyErjMwoA|hBe`Bf`AyaBgMgiCur@om@lpA",
        "yybnHmherS|KhxF",
        "m~~mH{sbaP_@zqE",
        "m__nH_a|`PbxBvnCr|Cx`CdkBx`DnDbjE",
        "_wrmHobh`PelArrDwaFplJs^n~E",
        "qf}mHyap_PbmAztD~qCbx@`mD}pCh|C{vAntCf~BptBvvEpfGrs[j\\fqF",
        "ajzlHw~`~Okf@bnAw{@vp@mcApk@u}@h}@azApaAoaB`p@wnAdbA{b@lxB",
        "obkmHwbp}OhUn`CbbAbz@dbBbObjF`GpgE{~Bdc@j\\",
        "sgamHe_{nTa\\|zD{|Dp_Pyo@vtT",
        "ksimH}lnmT`^l_GtlPlvz@lnDhxQz_BjbgA`}@luG`uF~`UfVlwCr@vxC",
        "_nvlHmpl}Oij@`p\\eXpsCmoAbbCqsClaDwn@r}AuIbnB",
        "}qamHowz{O^~HdWbyAlnB|dGl[dvB`Q|jK",
        "yz{lHij_{OkHxvCyaAnrH",
        "_g~lH__qzOHtoC~dCn|a@p`Ar|C|tAjpAvlEvcBldAj|@jwDr}Bp~DgtAlvDewBn`DxZtpCp|EffEdkNzsC~dFnbBblBfj@|sB`}@|yR",
        "iidlHwmggTuStzCcbBjuGq`@pjC",
        "ubilHcpufT`QxvCvy@blBlxCxuDvp@tpBjbErjYbmOhx`@~wGjiWvyCjlTtRrmG",
        "kjalH_onxSwaCl_S",
        "cmelHqnzwSrr@~}L",
        "}o|kHekxzSce@p}B{vAvtIox@lwCmd@r|Cuq@`sW",
        "q_elHwlgySxlB``SjFt{C",
        "oyclHqolwS{BjaT",
        "k}clHemwvSnlBlzZ",
        "mhskHo{l{S}i@lwCwf@dlBym@l[mnBxXmd@rUga@`fA",
        "aa}kH}a`{SbPvuF",
        "g}`kH{xn_TibIzks@kqAxxNoDlyAqrCvkEi}At_J",
        "ijukHijv|Sz`Axmh@",
        "wq{jHkwqbT{LjlGst@jaG{rFfsQ}~@|bJkq@joB{hFb~HsI`dA",
        "}opkH{zs`Tpk@h~@pvAp`BtyCl`FptBl_G~gAtmGhTpoG",
        "oj`kH}efwOoEtpBoc@f`C"
      ]
    },
    {
      "left": "RUS",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "_x}eIerloVfKqhEvd@y~Dp`B{jDvQcmAxYawFbPihA|gBkwFxDi~@",
        "msfeI_qajVkHirC{kAw~Gox@yzjAsoEa|Zec@ao\\iSoaAewA{aBwo@_pC}hCucEom@mnBiIuyC",
        "}q|eIilnqVrjA}|CjbEumF~|@euClf@}|Dzu@u`Vlf@ucDfpEojQrtAyvBrfDg~Bvn@ql@fk@omAt^y_D|_@uqA`cDacEtaAueC",
        "c~reI{g`qV_~@yuBqqEy`Ega@yjC",
        "cl|eI_|zpVxo@oaCbwAgkAtTvq@j[hi@dmAjpAxc@qjC",
        "_wseIsntpVmp@{WaoBqBadBgu@qMuyB",
        "amoeIu~piVj\\ybChhAq}B`oB_fCzaA}gC",
        "mmbeIcachVqt@kdDaoCawFaq@yaCa]gcJ{sB_hL_TaoC",
        "etbeIam}fVxCoqY|@q`J",
        "cmldIga_dVgBwm@kRi{Gsy@slIiwIodXo|Gslo@",
        "yhydI{obuVnEqtCle@g~BnbAojCxrAwoB~iCueAnwB_gBpVyZlpEigBlpAykBhrAqsCf`AcxCxm@y|GvyA_bHxSclD",
        "imsdIipqtV}^irBmkAolBgt@wwC{X_eD",
        "kzmdIgtucVfl@_lH",
        "sdddIymmbVaM_bIs~@}wHq`BaaH_lBipD}UcnAqA_gB",
        "oegdI{ozaVz_B}|Q",
        "kg}_Iuzn|U{CjiKaa@fpE{`AlnCgpAztAciApv@ovA|U}xBoNyx@{WozCaeBkgAjGkuBdn@k`A}KueD`qA}kCmlEu`DgrPev@aeCygD{fGqo@klEaa@a{Aso@apAaw@qa@k`Ai^yc@ugAyo@cwCau@{`Aio@i_@eq@eYa|@ym@me@wp@ukBuyDiaI}kJugHebN{`G{_P_`DyhF{cKsaKsgCqgF_pDwdMa{@_h@miBvZigAkzB_i@iqDo|@wgb@",
        "i_xcIqmkzVjb@{nIbzTcvy@tV}oDdm@u|BrlEunCdr@igC",
        "_tccIkucyVk{@abDufBvZqyBxmAssBwFepA{jBus@keC}gBqqRgHcrI",
        "uswcImxvwVzHafA|y@ehDzb@c{@n|@uq@jm@{Axg@`Gvk@yOluA}gC|EqhD",
        "uswcIe|`wV?g{T",
        "wzlcImgvxVlp@e`CxpEcbDnb@shC",
        "elkcIsukxVqm@ypI",
        "kuzbIolv}V~bB_gBfmCekArmBspDduCkvIpsDzx@jg@vZx^zu@t\\nkCdSv{@tuA`oBhrBpuAbcBzBhj@{iC",
        "czvbIe{b}VafBcgKeSehF",
        "_j|aIor`_W|n@myBl`Aii@pk@rJ|j@bZb~@pBxr@oXth@ag@fnOkkT|A_s@",
        "gvvaIit_~V{SaoCqyAuvGicAmuR",
        "}edaI{km`Wro@mdC|aCccBh_AvlFfk@fiBh}@zuAp}DsfDrgBuh@dm@xbBfG~zCpb@~{CxlAtzBdeC`{@~`CyXbwCssAvoB_rBpKqtB",
        "iq`aI{n}_WkwA{iCgVs_A_DopH",
        "iwx{Haqf_Vqb@mlCuvAmyAcuEaeCa`CejCis@__@yqAeCubAdXk`Ajg@ogAl\\_xAyDalA_s@ka@qlAwUevAqg@upAk{@aq@giC}sAex@emAsh@j]kr@`Rct@?em@yYg{@it@{WnDqQdc@sh@db@sp@~^c|AtoAet@nNov@wEccBk\\sz@oE_wBnvBshGdlOghDxvB}x@pM}`@bZ_d@jQgdA{LaWs^w[w{@ge@ow@aw@eXokBeYevCcbC}cBew@}`E?wZqLowAyy@uw@qL{eAeCaw@uSeuCcbB_r@tfBegBtiIwj@z|GkxDboL_tAliHktBblDwQh~@",
        "_ah`Isde~UlQnuC`vAd|Fr]hgCxe@txSzVxuBdpBzqGr`@piC",
        "wo_`I{wm`WhKmwA||GobP|yAgeGdfCrJnzCj|@rxB|@nMueB",
        "{zy_Iize`WoSufAqHmeA}Y_s@_hAiT{q@ce@",
        "off_IoqpaW|NmuDzqAapAt{Agl@bnB_fBvaDy`ElyA}j@xwB`g@paGrqD|sAgrDv~A}~M`jAapBhcAdfHpbF~qN~vAbQdwAem@zf@ycBnIwnB|aDa`ShZg|Fvt@ohFrhCazClmBb\\bbI~cEnmAp`@pe@?lVvmCpk@bxCloAjzBxaCjq@v~Aii@~bn@qlf@|o@wyA`_Aw~Hpb@qLvu@k|@nb@yMla@jRhh@pj@t]pk@lAhThkCss@|sA{u@rtAbDhjCjzBr|CfsDrhA_JvuA}rC|hB}sMdgA}eEbbDmnCb`E|rDnpBnv@jpCjTfhBycA~i@e_DtLo}H|PuqArd@}hAz|@ym@~vAdBb}AjfAzb@pjBjMlxBl[zkBz_AteBzvAloAbhBri@~uBiI~qCa{A~vAqiC",
        "w_f_IyujaWwEuzD",
        "afy{Hio}~UvMw`H",
        "eas{Hknp~UwFa{Aua@wyA{m@kr@kp@gi@mj@u~@wMykA",
        "ygs{H_qn~UrEk|@",
        "{rizHcpj|Uq[_iAcyAcbBudQk|YgcDswIqsC{rEin@cwBmPkdDmVobAav@uh@i~@wZgo@_^kv@qkAqH{v@",
        "wfjzHwkd|UzRkcE",
        "_rqwHe|ezUiOomAyi@h@u|@p`@gfArTc{Cg_A{b@iTc^ox@}[igCg\\i}@etDylCk[st@er@qsCauBlQ{_CnmAwtAh]yi@miHyi@i|@wi@{Wso@wRqz@ol@c~Bq_BaaApLofA~f@wmC_RsdBu|Am{EiwHktAebAezC{B_xB_SsrBar@gwDcbCk`BazAw_@mo@iKowA",
        "{hhxHiyzeWza@ylBr}Aew@zkAhTx|Aj|@hqCdaCp}Cl_ErdAdm@lsArV`{AjG~tD_IdqBeY~lFsrA~gCwPziCed@p_BuzA~_CaxEfxIw~Hr_@k{Ad~E{lK`nDipEzoU_}MhsAg~BdaA_|CvpAacCxaC{w@nl@xDnm@fMrj@~Sxc@nXxn@|T~g@uHbf@iS|i@sJpu@od@duD{gElz@shB`mCa{AfiDis@~nCfMh~@tp@lyBtoCjeA~}@r}ChrAnbAxn@hgArtAbzAeaB||CcuG`dAmy@|iCcFhgAxDbp@pWnw@nw@hhAjr@dmAnb@ziAlFvwDytCxlCsxHfyI{{`@|hAqkAnjCdDdwBjRtoB`e@fuBf`Af`LflKlkFt{BxfImo@|fE{hD|sBolAt{A|IbbB`fAbmCxx@tyCt]fhCuGpiE{}DlmCesStmDe~EzjCkf@`oBgCxkBuQdaCitAfjA}qB`{AakHnbAk{BxbBkzBtqAucCdw@ssC`\\ahI",
        "u`ywHwqeeWs@euCqzBy`Cu`A}Lwl@fVkf@dZkl@}Asn@yd@od@aq@q\\ov@wTqw@eXejBeD_}B",
        "orrwH}_`zUn_@g{D",
        "{hurHg}ovUsK_s@i|@yy@q_CyjD}qEylB}T_Tsi@pB{MjIaG~RqV`\\{m@rUi^_Um[we@cd@{WwgJghCwdA`Gs_A_s@}Tkz@sJqbAs`@okAyx@ox@ev@oc@kh@wo@cOg_Bga@oy@etCmy@}`@st@mFqkAaRouA{u@u{CceAmyAy}FauFssAur@kaG_}@aeCxCykCtfBekAkqBssBekA}}BsKwmBfjAm_GgxIgsCcaC}t@__AwkFolNokCqgDqtCi@{KuoByj@qlAciAom@sfBeNoxAoWuuAgk@exA_Uk`Bfk@sI{v@qQyb@aw@ymA_jDniDccBeXoTi~@",
        "_ourHa}ivUbEe_E",
        "}{irHu{mvUuGxmAstAi_@yc@|t@yDp~Di]lo@cdAqXihAcx@qk@ar@yOaoA",
        "uogrHmdzvUiIbZst@~rA_Tby@}Ah~@",
        "qgjrH{{rvUrJd_D",
        "yq`pHgiguUel@wwRq`CubRap@quBu|@k{AipCmlDadEgyHkoA_|Ag_BolAocBex@iqBwe@qfGcZq`AlEqk@|U{v@bz@we@bOeoJ{LcnBu\\om@iiAyOgjAsh@aR}t@tHadCzl@w\\fVmZxwBiJbwB",
        "eiirHuqfwUnx@flK",
        "u~bpHshztUrK}iAlZgjA~Ra{AxOkmD",
        "cwzoH{bqsUsUiqD_rAqxHapAknRmPmdA{a@g`AqWybA",
        "}e}oHazhsUxmAygG",
        "gvonHsaupUalFskKed@irCiTszCu|@ywBg|Cwp@it@aoA}t@gcK{l@mcCkg@eX_qBq`@gv@cZel@gl@ekBipCeaB_oEocAmcB}~@ovDsrCmtGym@wbD",
        "mbboHw{dgU`fCulFxcXon`AfzH{ce@~q@q}i@tyRkzv@~Is}@",
        "qvonHwtrpUH{kA",
        "kvdmHm_fnU{BeXiUmlE}oEi|Bce@ybAazAwaD_qDa{O_qBkkFmdAaeBs|AwnB_hA{jBazB{cKa|@a{BowAkzBigB}}A{iBmd@",
        "ovxmHefjpWhr@_|AptBogHjh@g}CnNghDvPq_Azl@w\\h}@uHdcAi@nlApWt\\zw@rKvdAlZ~|@~pB|}A`oBpWhtA_}@z`@kdD",
        "wtqmHexapWwPug@wbEw`EgKqb@",
        "ecwmHqv`lWb[}rCveAoaCbuDavEjgAs}B|^g}CdOmtS",
        "msrmHu{tkWoDurAoXcz@{aAoaAg`@qk@iJen@i@ylA",
        "yftmHitroW`qA{bN",
        "{ukmHgqenWaSowCug@kq@g~AekA{a@}j@eXufA{w@kw_@",
        "mmnmHci{mWpvAcgI",
        "uqjmHkvmmWyPifDwz@g~Bem@ekC",
        "uufmHyy}mUr@st@fj@gkAtIsi@zAcy@zC_^",
        "sbemHkvxmUuJst@kf@ylB",
        "md_mHwumqWdDe_D`q@cmCpiCgyGtr@c~Hr~@weB`sIw_F~|AaeBvz@cbCtSyjD",
        "cf|lHes`qWiSipC_iAgpG",
        "wlulHgbytWhT_bInd@o~Cp`AigCptA{jBpkAkq@z_BoNviHsJlnBij@tqAaoAnaAu{B|a@ogH",
        "k}clHa|ltW}t@ybCi|BwdAo}F~ImyAgl@eb@kyC",
        "msmlHwztsWj]clDpaAifDvaEgpGjQszC",
        "ylelH}y`sWs`@e`CwbDszEmy@cmCyE{tC",
        "wywkHs_mvWh^geGf{EgtC~oEoN~{@mYjfAsuA~h@g~BhTeoHrj@ihB~pAqWjwGpWxOcbC|h@e`CboBoiFblCdw@jzB}IpuAmpAz`AmiHvnAmlC||D{|FvmPab_@`pBchH",
        "a{vkH_gcvWu]swH",
        "cbmiHgoc{Wh_@e_D|hAybAxaBg`A`r@i{C|KyuD",
        "ezfiHki~yWgb@osG}}AkuGmcAgoHi@wiI",
        "odiiHsul|Wza@}rCtrAqLxbBj|@zzGzqFph^`nQ`yB|T|nBcdAv~@_fCl\\{tC|h@adCldBcmA|dA{BrvBld@zaAlG`fAgMjzBst@be@{Kh^woA",
        "audiHsgw{WeN{tCirBivJEgAwKq}C",
        "cn_gHgmy|WxIspDpgAuzAfnB{Bx|B~pAjoB`r@zpBa^zqDe~BbtBi~@`p@yc@`r@qaAda@aqAhPadAve@yn@|bBwQrrCbFtkAj[rjFz{Gnm@~]tfA~_@z}ExbAx_@jf@~f@|hBfzAziCnjDnjExxB`fA|xAaHt_Bce@nlC{V|sAyn@b}Vsda@|nGauHzlK_xEj_E{B`qFdX~mE}TtvAgtCjWcnB~mBixFr^{`C`LgzF",
        "ye{fHqnj|WigCu}M",
        "knhfHuifsXxcAovBlbDyhHxYupBnCsrB",
        "_kseHaqnpXs`@cwDug@ccByyDygGkm@yaBk\\kfBaq@eoJ}wCirPukBwl^yYcwB",
        "excfHkzdtXbdG}fDb{DsdGhrBkvH`a@_wF",
        "yf`fHipzsXiT}qBag@omB_s@sgB",
        "swseHs}bpXrKmrJ",
        "g}neH{csoXg[upBswAaxEk^_pBcE_}@",
        "imqeHagguXxbAdaBlkEn`BbnOxZbkDp}Bdc@j{Al_Gj_Kx`CbwBx_Ebp@duCen@paGavEzpBftAb~AafAj`A}rCpWaoC`{@{iAphCk|@nvCug@vcB{MxuDi|BxpI_iMxmC`\\nm@om@xgHpeHjk@tfAfl@xbC|mBve@jjCdBfbC~TpuAlyAhwCnqGfpAby@tv@zbA|}G|nGjaAfV`b@~eCteDtxEpu@xaBtHlnA",
        "qaqeHiwcuXwJwnB",
        "i`oeH}tgoX`B}mJ",
        "onodHgcrmX_d@ezJ}d@uyBshAobBwxBqjAqkAec@s_A}j@ev@ew@om@_hAgb@obBoh@umE}d@eaBqjAq~A}wD}iC{pAqsAqf@_gB",
        "krvdHigclXzg@esFxY_}@dbAmoBnRebAhF{iC",
        "qzpcHinniXuTmdBqe@k{Aux@mnAkxCs}Bmz@wdAweFewM{XqAy_DqkO_Z_r@u\\ug@k\\a\\}`@_Ucj@}TerA_}@uw@myAsc@kfBwoBseQgF}oF",
        "owrdHytamXlAsgBpQ}hBjgAcjFrJwoA",
        "upqdH_xvlXye@y{I",
        "kgvcHya~hX`HsgB~\\eaBd{AmwC`b@{kAnEk{A",
        "evdbHqdqgX{CqpHcUshAub@ebA_i@kz@qcBelBos@we@{q@iKmu@vHukBpk@ge@i@yc@cOkg@_^ggDyaDwfGa`I{fAox@_qAcZkq@xDui@tSug@dX{k@`S_s@dB{l@mPkg@_^ea@ug@gk@myAyO_gB",
        "kvkbHysbaX`HykCxh@ctE|oAykEnqBs{DpwEwuFdWyl@zMox@xCcy@",
        "qp~aHala_X{GayBg\\g}CmbBwlFmjAakGyoEstg@",
        "gpjbHsdufXlFetEpa@ctElwBygIrVykC",
        "_jabHmbkeXqBavGeb@oiDk]uqAkzCsnHyTgtA}n@ahL",
        "u~bbHoeydXlRenKf`@wlD",
        "ua}aHymcdXcGe`AsS_t@}zAmwCeRox@cp@qnJ",
        "_tbbHwfzbXpiBybN",
        "s{{aHkwfbX{Aox@iJox@aRew@mlDwiIuHmxB",
        "ik`bHmetcXzA}sBtN}~@dgAcwD|Jmx@|A}`A",
        "mi_bHqjicXs@gsBg_@seF",
        "}kn`Hq`wsXmF|{Ewy@~eC",
        "cnp`Hs|ksXrJ`qAt[`oAdOxbAdDdvCtQtdC|e@jzB``Aj|BliAhrA`~DphCzjAnlAdgB|eGhcAlxBviBjq@prCp`@x}Ah~@|tAxc@pxBmo@bp@ug@lhBapBdS}h@b_@eXtgAhIx`Cdc@tkBew@vnBelBn{BcdAtpCh~@~x@h|BzW``ItaAheCzzAt}@fcJ|fDfe@tg@l[~h@bj@~]bsApLb_G?t{BnY`fMdgG`zAzVhrAu\\jfBmyA~lB}u@rwBbQvdGlbBd}GbdA|vBlz@zq@li@hmAl`AjvAd`ChaC|dHjgBvnBz_ArUt{CnNrx@vZfoHbiGf{@~TjtAiK`lAih@rUqk@pBqv@|SufA|`A_rBteBmcCbxBolApxB`p@hmBhyGxxAdlB|xBcdA",
        "_hwyGesfpXp\\qaAfz@ew@ldAziCz`A}@~qAcp@dvBeB`r@nlAjf@z~Bvp@dxA`pA{a@xd@jq@ziBjdBhUtg@",
        "syuyGgjbpXoi@ebA{BwdA",
        "my}xGeuyoXkSpv@yvAtr@aS~h@",
        "uyayG}_uoXjRlnAnn@|j@h}@t\\t}@jh@pu@xw@fuBj{Cdv@bbClF`dCzk@`fArfDgw@d~EknCf`BoCb_Gp|CrfPhdFth@tr@",
        "_hiwGsnvnXa}@fiC",
        "afkwGkdrnXjHh~@jg@bn@r_AjRvxAdDjg@jR|~@jfBxYzKxYiI~Th@tHve@",
        "i|~vG_xhnXkI`{@yXnd@a\\~]aSri@",
        "sqawGylcnXr@d`Cpv@zjBzjB~gA`zCbZdWbZt]xw@~r@xn@bxA?xx@ug@zv@wyBzw@up@~}@hdDjvFzvAbwBvlDp`Ast@|a@i{Cfj@wdA~qAgVp`Afu@dwAlbDt\\ga@jgAa{@t\\ga@t^ptBpKteBr`@xxAt{AdmA~{Bu}@fk@~gAp@rpFh_@xkArsBphEzk@jcEftAzhDh_@n_E|iAfqFpk@voAr_Avy@|kJlvFxaBzj@hhBxZlmBtHvbRf}CblCk]xbCnx@dsDew@jbEowAlnDug@xvAfK~}@fVhr@be@h~A~fBfjBz}Cnv@|rChqCn`Dt|@`bElyBjdD`[boA",
        "myxqGomnjX}TzgEkbE~{N{`Pd~sAy`Pb~sA]dD{b@duBew@~qBkfA|hBynAnwA_qB|iAgtBtp@ueBv{@meAlmB",
        "__vsGupwcX`]~yEjnDvkEvmPfcKth@fiA",
        "cy|rGmz{bXyDbtG",
        "}~|rGiesbXtRdkCvp@rgBrsAxmAz}B~|@pjB|@psCclB~{BbOfvAdbAtdQvzYhTdc@jz@rsAplAnx@r}@lx@pMdxA",
        "o`lqG{zbaXqw@boL",
        "aymqGwju`XhAnaCxW`eB|k@tqA~oDv~Fld@xxAftBthLrIrrB",
        "uz`qGsxo_X}^xlB}u@hhBoWrsA",
        "ajdqG{lf_XpAbxA~}@lsGpUve@xn@nYr~AyDjp@`S|jAxvAle@jfBfLjoBR|sBdlAjmFrgBrSnsH_bGhqBy_Ff`AquAhtKwtG|h|@wkR|h|@wkRtq@tQl[`}@f`AjdB~|AxlBlx@`\\htAh@frBve@r~AwFbqEg`AtkBnEnlH`xC`}Jh|BpoBnNnzIcn@duC`Qbo@Sby@{MjpBwp@j{@cOhu@nCjpBdc@ri@vFdw@qLjpBis@jl@wFrwAjf@|}Ch|BpdB~]bhAwe@jcIcxOj`@ev@|mAymAlnA_UlzGeXvoAxDv_BleAhw@fiA`gAj|@lmCfa@fjFpA`oBbZzuAfkAbcCxiExrAlyA~`Blz@~|BrJdqAmo@ljA_}@jjB_^rqBxc@fpA`zAlrB~yEnj@lo@zj@bOtn@nEpu@jRpk@nm@n^~qBp\\pt@f_Apk@jkAlRvbDxD`oD_t@dyDifBh{CiVpuAptD",
        "sfydGmk__X{GvvE",
        "ooydGusx~WxIn`Bry@h}A|sAri@zyAzMt}@pk@",
        "q{odGymo~WmEjrYixA`wFi^ziC",
        "szsdGowh}WhS~yChmAnnAtaBzu@fpA`qA",
        "adkdGad}|WwGnWaRr~N",
        "{_ldG}kl|W~gAlfKtbFzsQ`{GzjO|pFxjDnvBouC`MmuE",
        "awncGsgj{WvFwwDfjAwmC||BmwCvsC{`CfnColAnzDi@|cB|hBdjC~dF",
        "s_ncG{dc{WmVwaF"
      ]
    },
    {
      "left": "PRK",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "oveeGkfoxWkGdmAe]vxAyj@`{@yyDr{D{\\nm@sJ~rA",
        "emoeGgc~wWlJtfAjw@rrBdTncA~m@cZtb@od@hXyn@hOcy@v[|tA~Nr{Dfk@`fAjaAxX`oCxDd`Ah_@l_Azl@tyLrzEr{DdXnvAfa@p~C`cBraCfkAzeAdXtlAhIlsBgKni@si@|Ti~@xt@}iAfp@mEjg@~q@pu@rk@lyAyZrYd_D`vAlz@hsAa\\nRihBle@?xbC`eD|tEr^nsFqLr_Ft\\hpEp~CvZzgE",
        "oh{dGq`iyW_yAhcGcn@aoAcxAocA}cBwp@{qAkR_x@rjA",
        "q{ieGijeyWt]zhD~|AzdHjGdsF",
        "mb`cGwo|zWqLncAirGhiL}iBxn@q`GlsIexEtyBspFdDmqOcxA}{EblBid@hyG",
        "io{dGonsyWxE|lI",
        "ovqbGihu{WgtBza@}tFnb@kbAvQkfAh}A",
        "mlacG{po{WzCzjB`{@`eBh~AlnAf_BmbBx{AjRva@f_B",
        "klubGi_f{WakA`dCgaAh]axBqUip@dMs]fl@iAlo@",
        "_f`cGsf~zWpBzu@",
        "at_bG}kmvWym@xjFyN|cG",
        "urabGe{}uWdlAoWrrA`FxbAri@jl@bxCvl@`Qd|@dDh~@|_@ta@pv@~Ih~@",
        "uv}aG_wutWwZnwA{lAdw@kQlcA",
        "urabG{aotWnN|iAjk@tHdx@g_@vt@ks@ve@dxA",
        "whraGyyruW}Ths@m_AhTin@jf@qgAjoD_r@`g@}|DhmH",
        "}g`bGab_uWJp~Ax^xmA~b@dbA`Lnx@",
        "ca{aGuhltWelA`fA",
        "in}aGsajtWxZ`dAzzAjs@voBrStMpk@ft@rmIbZ|j@~h@~]xs@jRdw@{BxU{a@xNce@``@gKz{Ald@zb@h~@",
        "kghaGmnvsWUphE",
        "ahhaG{dpsWtm@?zBk|@~Mgu@pXur@bd@{l@th@hiA~l@fKjq@{B|t@rUtYtr@`QbbAb`@|u@nfAbOfk@ae@lGekCdw@_^xb@jRfb@fj@b_@bp@haBzsBjzBlxDbwChoDjl@bxA",
        "e{e`Gs|~rWwEriBaaApsC",
        "_dh`Gm}vrWlmBvFtqAh~@bbChfDni@lmBpLdtClZlcC~qAdw@dxFj{Azw@tcF",
        "ego_GwmwqW{X|}BcsA`|KgVvwQ",
        "mls_G_yspWxkB~gAxZhfD",
        "cwk_GmrvnWelAz~Bec@~pC{f@f{R",
        "kpp_GidzmW`rE~o^xCx}Gr[h|B~uA~pAf{AnEduOcyBp`Bap@hwAk|@tq@soEnvBod@lgLefH|aCqaAbhCmYduB_gDrqCimFhy@ifDrgBapBl~BolA`oBsJhfCkzB|pFf_BpkZz{RtnDlvF",
        "yco_GuhlpWyZjqM",
        "s_p_Giv}oW`Rp_Ark@j|@~`BzvA|Tby@",
        "qji_GybioW}GzvAaoAluE",
        "qcl_Got_oWlK`aH",
        "_hj_GkfuoWoc@bdA{G`{@",
        "kuk_GeeqoWxiAjaG",
        "um|}FidyeW{a@fa@ghClEul@j|@",
        "ogc~Fg~ueWn]`dCfeAtdC`fAl{@fcDbnA~kBl|InzCxmAnw@xn@",
        "muu}FgdjfW{~BppEmeAjrByTblC",
        "qq|}Fer{eWzBzlA",
        "mvn}F{kzdWqt@zjBmyChyDgo@dxA_Zj{A",
        "uqw}FcpkdW?lbBx_@|iBviAyn@nn@emAtg@wyAbu@euAdk@baBfjC|gEz\\nbA",
        "}wk}F{srfW}nAtr@k_DteCyrAzX",
        "a|u}Fs_lfWrEjz@",
        "_al}FqiofW`HiiB",
        "qwl|Fq~}fWwz@`g@aSdm@sJpv@yCnl@uqBirAisAsrBmy@kdC_h@sgCg|@ftAg_BpdIaLtgBo|@c\\gWmPqz@p~Don@~|Ai~@vz@azAzW{{@_Uc[oaA",
        "obi}FcbcdWkHz{E",
        "{ki}Fge|cWxOncBdtCxaBlmD~yEjkAdB`tAebAvpAqU|rApUxkDrrBhyGjfB|cGjwEloAlf@r|Csj@~cEquAn_D?dn@lvE",
        "gmm|FmcvgWyNfuAwnAxkCi_@~{A",
        "cmq|FkclgWdWhi@p_CvpAl[bn@",
        "wwf|Fq|fhW_TnsFcZftBcd@dkB{Mce@k]ss@uf@we@ij@dD{a@xm@",
        "cpn|FctzgWzBhi@jRdl@rJdx@",
        "}wk|FexfgWqMp`@a\\zWw[r_@qKnx@",
        "{ln|FscbgWhh@rsA~Jlo@",
        "cle|FokjiW}VnkBel@dlBiTrhB",
        "qfh|Feh`iWnXfiB~h@zvAt]daB",
        "kde|F{cwhWwGziCoMpVm[|`@a\\nm@mPlz@",
        "qfh|FqumhWnC`p@r`@zkBtG`z@",
        "wwz{Fsj`jWuQxn@elBjnEmp@zpFoaAzvAekCrJ",
        "wwf|FavmiWrj@piB",
        "wdw{F_tklWiJfu@cdApUaoBuHmnBpCebAlcA",
        "{wb|F{gglWv{@fu@pk@tr@|U|~@",
        "sw~{F_~alWg_CtzD",
        "{wb|Fib|kWv[z|Fr`@diCpk@b{@`eB|h@be@vdB",
        "sc|{F}||jW}KvlQaq@lkD",
        "sb~{FwbejWpAl[|sAbdAjRpu@",
        "w`{{FmnikWoO~{Ba{@rrB",
        "im}{Fy}akWth@z_D",
        "utr{F}oslWs_AzjBghCgV",
        "q~x{Fi{plWrj@|hBdMj|@",
        "cip{FepcmWmPpfGmxAcxAme@bxA",
        "mzt{Fsh{lWxaAxaB|AztC",
        "oaj{F{r_cWem@?wQce@iScPiVsIcZkRqAzrD",
        "wkn{Fgt|bWjpBtdE~wGvsHxmAbcAtaGjpChhAvdAptBh|CbdAtfAfpGh|C~fA`{@bz@xvAx|H~bUrgB|rC|rBcyA|tAhhAnbAh|Ap_Ar~@voAcPlQzaAfVl{@z`@jq@bo@tf@|u@wO|iAle@ntCz}Bxy@|hBbOzuBbZnlB`{AtfA",
        "gevxF}u_`WlEsrAv\\i`@j|@zm@f_@vnAxPn_Epu@vzAh_@|rA",
        "e}uxFoq|_WaGmcB",
        "wznxFa|s_Wuh@|jA_~@hhAg_@bbA",
        "ucsxFucm_WfJ`eB`]dmArgCl_GvEv{@",
        "_kmxFgr}~V_|AjjG_Ijs@",
        "_rpxFors~VpBt|@zWve@fj@zWjh@h]jQpv@v\\f~DxFnMreAnaCdhF|nFtdDgqD~}Acy@~h@dvAlDdnJ",
        "aexwFcet}VaQhJit@xo@cx@duAaRj{A",
        "sx|wFmvl}V~g@~gAlyBl\\hfCpKvdA|i@xXtrAnD~aGpLloAnc@t{@jgAzx@xn@`QnvAzBlf@tS`\\by@",
        "qbfwFavs|VeNnkB",
        "wqfwFqip|Vv[nm@tuAhVtCf@bnAqLxm@fW",
        "cv`wFey~{VgVhsA_^r|A",
        "klbwFggy{VvF`|A~]vcBvdAve@j}@le@nm@pu@fVrtAfu@laDfu@~xEj}@~pDldA~{Bpu@frB|t@~zCxm@lcBve@hrCpm@tzCnlAj|@ptA?nlAqlAplAwdAnlAom@h}@h^fVt|AvF`zB",
        "u{~vFywm|VeCxjCmOlf@gv@pjAmPpv@",
        "_yawFmad|VdCbn@t]bxB",
        "kb|uFmduyV}JxvCoMxy@aStp@u\\lPqaAlz@qk@h~@",
        "u}avF}shyVzb@j]dlAri@dsEdsEniFnqHdaAbbCxY`oCfv@p`Bx_C~|@`oC~r@jeBp`Azm@lxBft@fzH`r@f_BdvAbcBjzBzzFxcAbcBr_@jRtfAtHzVtHjSfb@hInaArJdY|fSjzZbkAn`B",
        "{q|uFij~yVwF~{B",
        "sy|uFimzyVfVzgD"
      ]
    },
    {
      "left": "PRK",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": ["mwcaGwiv|WecBfhD}y@h~@orAnN}|C}@iuCnWemBzbA_vAzjBkc@llCefArrBwtArhAcfFhhBs]dXiPj]u]zVycAtHmYrJu{BhiA"]
    },
    {
      "left": "TJK",
      "right": "UZB",
      "kind": "International boundary (verify)",
      "lines": [
        "yq}wFwepnLsrBgK}u@tr@ip]bsb@yaC~cEmQtR}SxNobBbwBs~@zkA{vAluG",
        "{rnyFgfulLdn@bjFdrSxkDxrHzyI~mEncMlbEngSpxI`nQdrG`_c@hs@phCbnAvzBd|FfeGbdBdtC`f@hfD",
        "mdcxFiqenLvnCkxEza@azB",
        "edtuFwoolL_{AhqAyO~Ik\\~HobC`IcxB{aBuzAuxD{kAemLwQc{@}}@}}@cbEouCq_AssAw\\gvAuRk{A}`@i}A}r@wnAknEizEklFyzJq`Au|Ast@mxAuRss@yPweBeWiTk\\iI{X}Tom@}_BwAUes@yLqqE}t@ghB~mFycBtzPg_Bx`BqjBdNcnAwy@iIu{B",
        "up~vFgojhLgu@n_Equ@xmAq`Ap_AgsCjqBi~@bdAymAp|Ckq@thAm_HnrFmcBnlC{MpfEol@p`Bi~@bmAkr@jrAuH~oB",
        "mq`xF_dufLtq@djE~h@vbBpw@zwAh{Cd~CvaDf_BhzD|j@~dFpBhkI}i@rsAxXth@xxAdWnzJftBx~Ed`CpAhcIgzF",
        "g~cvFsbreL~~IudClnBw{@d_FwaDnuBybApiCwf@dqHdm@nYdhE",
        "g~cvF}areL?U",
        "mftuFelolLfAqB",
        "ypfuFuf}lLa\\bbC}hBjvHkxEssAmYlPcp@rt@uHpL",
        "kajtF{rhnL{KpfGqiC|zFohGvnBa`HhrA_oE~dDgk@fiC",
        "s_huFa|hmLtHzuBvZptBjH|gC",
        "{`|tF_|xeLmeAroF",
        "ig~tFkkqeLxNbcDvwD{XhxHweM|rC?rqAxiF",
        "y`rtFodbpLuHz_C",
        "ojrtFsc~oLle@|hP|pEvyZvO`kG",
        "{~ftFa}seLwF~uHe`C~pParAxuEmkArdEcQlmC",
        "myptFeigdLxwBvw^jf@h{Br~AjxEzMhqC",
        "wjhtFmhxbLmo@`iJ",
        "e{itFk~lbLtHziCleAlzIrr@r}F`eAlaC|gCm`DteCwvGf`A{{E",
        "od`tFs_vcLb`DibHpvAug@r~A_S`zAtHpkA~q@vPbmC",
        "o`ysFamfbL{Gkz@czEevl@",
        "cbksFca_cLmbE`mCu{@daB",
        "gbssF{pwbL~qB`pAdw@eLlcAcnBnn@iTf_CfLvy@kHt}@_^|fQkePziC_TptAxhG",
        "yrosFytzcL}u@veM",
        "wiqsFanlcLj^r}BpsCp|EtRvoA",
        "aairFc~ccLeiD`nCkmGh~AmuEf~BmdAnaC",
        "ou_sF_ntbLvo@|i@|sBgU~eCm{@hdF{jCzvAr@xvB|jArKpVtGp`A~HhT~|Apk@vGg@h^R~|@pLtg@~h@",
        "wg`rFcbqbLg`@|rAipEteDwz@teB",
        "avirFy`fbLtpCnsE",
        "kderFil_bLoYjrAeChgA",
        "acfrFspzaLjeCr_Atn^r}@duCfa@`zBhrAjyBnuClbCxiGt|ArsAle@sT~mAmk@`Ac@|j@jzBxmA~~JpUjuH",
        "mwfpFiwk`LaPnqHolCt}NgUhf\\_kLnvaAyChdH",
        "a}ypF_bi|Kxx@dgFt`ItdQt{@rrNj|AvzBxsGij@H?fUhTlQzXrJ`\\nD~]",
        "qx~oFydzzKcPx_D",
        "ui_pF_duzK~G~}Azw@nx@roFbmAfzFjh@reFvEfqEbnAjnEdn@rJhh@",
        "ahynFsegzKqLdw@",
        "suynFmmezKbPpaAtg@vy@vZv\\rj@zKbxAtI|uF}l@l@G`~BunDnpEcrVzMk{NblAwuFfWcZvdAwp@f\\{a@xDsi@",
        "sfzmFia~{K`Iag@tiAgw@d@]ptAsJxcN`fAjwCa^j@G|CkEprA}jBfdBa~W",
        "iuymFiyz{KiP_gB",
        "qq`mFugv}KRwxAf[ihBrUap@xgAg_BdNweB",
        "y~zlFyw||KgA}fD_|BoyME??SM??s@o_@irAkQ{vA",
        "sl_mF}vm~KpB_r@zHwo@",
        "af|lFybd~Kk\\_gBwz@_gB{Hap@qBar@",
        "e__mF_|p~K\\_@Dg@pyAs~AhkJ{qE|eC}sBpiAs_A||Bi}@vhCbF~fBpv@lsAnlAjaAp~Axo@~hBpVfqC",
        "e__mFuzp~K?i@",
        "yvwkFs|r~K{AxmB",
        "uywkFymo~Kz`@vdAhfChTd~@wQjv@yc@xx@wZfeAnCfe@h_@tvA||Cb}Abp@jqByOxhFurAh}BqLbfJ~SfhCmOtqAom@ptDyvCf~Aqb@xeE{KzyAiTnwAmz@rwDysFxkIgfFfuA}iBjnC}bIn{IcoN||DcvC|oFwZfmJ`eBfxI~yCpdHnrF`vB|iALTX?NRNRpiBzm@b~Aj[xmAzm@|e@|aAfQf^fVp~Ah^hbHhs@xaExxAvmBz|RbiGr}GbwDdwNjfM|~FdpI|cI~`IznJniGh_K~mDpeGfWzlN_{BdfGuTx_Fr_@zrEvfAtyDztBzzAl["
      ]
    },
    {
      "left": "AFG",
      "right": "TJK",
      "kind": "International boundary (verify)",
      "lines": [
        "culiFg|spLuh@p_A_s@tg@eqBjs@kp@bd@wu@~}@gk@p_Ay_@jfAgPvnA",
        "mkyiFybepLzBtpCjk@pl@|lCuS~~@z`A",
        "gmqiFkv}oLc\\ztCe`Bv`G",
        "qkuiFw~poLtH~gAnYxb@v[rVrOfi@",
        "_zriFapkoLwA|v@mZvcBqGxw@UtdE",
        "matiF{t~nLlQ`dB`k@~i@liBnlAj]rlJhx@frBhi@?|iAi{BhhAjq@n`C|{EnXxx@",
        "ebnfFct}qLgL~_@coAfVeaAyFslCg~@a~C_i@ctGayD}~FgtAopDsrByuDag@{lGkpB}lC{`@wtGtf@wvDrsCwoBbuEqhDbbO{yH|`KekC|oFaeA`nDqMplA",
        "ckmiFcfypLfAfjAlPvo@hAzl@",
        "ggaiFsibnLwElmC",
        "_naiFe{}mLxXby@pv@nY|_Af@v~@aFns@RdtErsAdXr}@|PhtApa@dkAtxCxx@v{GxvDrwIbaDfhBzkAtr@|~@ngAdtEhe@daAjaFbsG|dHtwG~]~r@br@bxBrK~\\b`@t^zv@~]bVbdArIrhAfRrj@xx@|Tft@r@jr@_Utq@ap@hj@hqCjRhqC",
        "oxz~Es{rtLis@fdHmnBfeGspDpqE{kB~rAeuBbdAq~Bbn@c_Hri@i|Bt}@{lMraJuoBfu@ufCjR}~F?yhA~TueCzjBoaAld@qkA|KgxJ}Kw_Gcp@y}Acc@kw@ij@iuCrU}yHseFqmDcDmmAod@cbCyOqfGrJ_oFdn@ixAkR_kCmeAsyFu{@ewNxvAupGcZkb@qUuqAsjAos@i]c~@yOy_Ew\\saE_fAo|@kImcAfMwcCxw@sy@hI}nBsr@ouBseFymBq`BuoBoWssCeDggChIsjAjRgj@om@uxD||DmeBf|D}Ib_F",
        "yjrfFoalsL~nEpyVbcAtpBpu@`{B",
        "{`ofF}xpkLsUnkCoqAr|B",
        "_jrfFynhkLz}CtgAd_Em\\~tDevAnaCghBxYwfAjq@klEls@si@hxAyOvpAuh@daAow@|j@wz@dgApa@~uAqLduDi~@`{AmFzu@xNlq@~TbmA|JfzAnmAlPh]|TzX|p@}@~w@mGrh@bGtm@db@|KzLxX~^",
        "c`hfFeylrLol@tdCswC`lFmFpaA",
        "umnfF{c_rLnJvn@",
        "}hcdF_gpjLm[laE}Pby@wNfTkYpb@uh@|Vs^h_@sKtoAme@lcCywAxbAwbBdy@wfAteBmEfrC",
        "qhrdFilriL|hBfeGl[f~BfV`}@jk@p_AbZf`A",
        "cbrdF_}ukLcErS",
        "ghrdFkhukLdCdwB|@fKduDvyAlu@xNhS~h@fwEtxEdx@prD",
        "mckdF}f`iLw[|_A}Ydm@q`@ziCoDvp@",
        "ebndFe{vhLbOjyCryAdgGlTnjC",
        "_bjdFcmehLu|@~rY",
        "u_ldFcyjgLbk@~{BjeGpjBhhBtfCx`D`tGt\\rU|iAve@d^fWjb@bo@jq@vxApa@h_@bbBbe@~rB|KrmFqCbU}JrKmy@rZcQp`@|@tHzMzBxOvQjGxx@qAry@uHvt@wQxi@i_@d|A}s@bvEkh@tw@ir@phCjq@ve@giB`RuqB|nA`Rl_HbvE`oAhfBf_Cf{Fh}AlcBjq@zbA|T|hAvBrTtWvnC~m@~zBnHr|B",
        "woadFcb`kLyY~zD}t@tyDyUxjD",
        "iwddFs_ojLjm@kf@",
        "awmcFspt`Ma{A`qL}zEtkV",
        "aowcF{qo_MlE`vGdjDzcK",
        "m}qcF}uz~LaWhfBoq@hhB{NpsC",
        "{wtcFwpo~L|KtzCfa@p}B|y@zaBbdGzoHnXxbA",
        "kbgbFkmi`Mco@bcByaCbZmyBwmAezAybC_e@cbCuRioFyb@azA{fA{jBibBihBwyAih@weGi@kr@aF}|Cag@oTx}E",
        "}{mcFi_}`MzCtmG",
        "ykjcFmxrdMmpA|_@",
        "g}lcFowqdMdfDrhArOnwC",
        "mqecFqyeeMiYzsDiAjeAiO`}@ayB`zAy^j|@",
        "gxkcFygwdM`C`fAjg@hgA",
        "cohcF}~w}L_h@~eC",
        "cxicF}ws}LnN|u@dtCjmFx~AdaBluDdjBfuAtfAxcAr}B~b@p`MlvEv|LlbCphCfj@`zClk@fdH|xBtwFvkE`yDncNhbHhfIhcGnwBbe@jz@pv@|mBlb\\~sApqE",
        "megcFkujdMse@ntD",
        "alhcF{_edMbAjdD|rAjdBduEjIzjB|qB~r@lwCjnBluThhCpvM|TvbC`dC`_JjW`kGd]||BjoDvlFnObxA",
        "ufccFigxeMkv@l`Fen@hgC",
        "gmfcFq}leMbGduBtRxlB",
        "izmaFopseLw~HvnQ}J|_@qkAdiCsr@dy@g}EvnB{jAtoBsiAlmCmyA~zBkbF`{AylBf`Bu{Ap}B{u@vzBui@riLkF|TeEdc@",
        "kr{bFetmcLtSlPhiAs_@jg@kg@t{@kdBbZa\\lyA_Upv@h`@zMldA",
        "irobFm}pcL}_@`yAkwA~qAgcBfw@ynAjeAmYxaC",
        "czybF}nccLxb@phCveArUh{D}hAjdCcOt{@lY",
        "wdobF}_nbLc[nrF",
        "{`pbFmlfbLpC`pBjaAteAtW}^bZmPdkAec@rPllCfyAfkArcBdb@hn@fWpL`pBry@xhF`Lt{BnZt]bwBduAbZpv@dCz`A|t@dhHfVzbK~pCoxAd|A`h@pp@jyB|LxaD",
        "eqjbFkn`cLoChiAivBngFi[~gAcEvpA",
        "moobFy`rbLtIz_C",
        "i}cbFui{`M_Yri@iaBxxAwa@dn@aGn_C",
        "mdibFquq`M`aAdgG",
        "ytebFu|iaMwQr~AkIxkC",
        "}qfbFgpbaMbQ~|@b~@jdBjBdbA",
        "w}j`Fqsf~Kw@lp@_@v[m_@xw@yo@t^av@dXyr@nc@otEvuEkf@pv@o}@|rCin@xbAq_CnbBimBz`AolApuAcu@ryGm~@hzCerAxlC}rAzkAu|AvEknKqt@",
        "avmaFmug`LcVjzBge@lxBmFbxB",
        "{zoaFog|_LxcAnuBnfBdn@b}BeDzeG_i@rxAz`A",
        "}o{`Fcov_L]duC_dAl`G",
        "{u}`Fowi_LlQlbDjkAhrBdrAvbB`f@hsB`f@zkAd|Gj|K|`@~~@zWziA",
        "gay`FugjyLu~@nnL",
        "}`{`Fex|xLdm@~wG`mEjwR~fCvuFzv@`}@bmBlyAnn@xw@~`BnsEpnClbDz{`@dtw@vpAprFnm@xqH?rnH"
      ]
    },
    {
      "left": "AFG",
      "right": "TKM",
      "kind": "International boundary (verify)",
      "lines": [
        "{{bcFqv{rKuGjgAar@||BgtAdkBuxDllD{lAtpBebL`zj@ceAnvBkg@pj@wz@`q@i{DtgBeX`p@gUt{Bga@h}A",
        "{ojdF_`kpKbxAbObcDve@`v@tqA",
        "q{`dFmvfpKiAb`G",
        "{}`dFiu~oK|QzjBnc@dkAf_Ah~@vcB|_A^?HHRRjzBnlA`dCt}@`kCt\\zjGkp@fiCqBv}Bp`@~vAboAvnCtnDl}Hj`Ht{Ap|Ev@hsAxu@d~qAfyBnmMngNjkb@blBduD|}CfsBtrFl[fzM{uBnsFyXprEpsAxpIfdFjz]||SfgEjfBvuF`oAz_C`Sf}Bi@p~Bk\\tmF{vAn`CcP`xF`\\peFvfA`wEvmBtdRriNtzBz~BhfC`nEh~@pqEzuAfkMxe@hqBhr@r~ArjArhAfzFxaBhi@`}@",
        "czybFigxsK}KbcDmjAh|BwsA~fBqP`j@yU`w@gLly@sy@zvAaLdbA",
        "qdccFgebsKtGtmE",
        "cu`cFmb_uKht@hgBnkAnmBhtAp~Af`@~s@jHz_A",
        "ksxbFevqtK_^plAcnB||AuWh~@",
        "ez}bFkkjtKhNftCvoBxmL",
        "}_t{Ei~fgK{MnlA{a@tfBga@t`G",
        "}sv{EmgyfKdb@pgFzwA|{Eb~F`|KvoAxmAnbBrs@lnB]nfHox@nmA|A",
        "a_vzE}x{eKi{DpqQk]`nD",
        "wy|zEiwceKlKv`B`LbfBdn@jzD~vGbjQrs@hzFxe@fbWpUh}Bts@psBhgApuAvcD|rCxbAt{An_ElxNj{Ap`P",
        "sdzyEitraK{Wjoi@",
        "o}zyE}ch`KpVjcCtpAr_BfkBlYvnAgj@vnAk}@nmBmZ`pAuf@bjFc_If_BovAl[uh@`p@{}Cr_@u^rj@dDxw@xc@rgBvlDr~Br~MjdCtdD~{AtIb~HeNpkA_S`dA_gBr`A_UjcE|~@tkFnYhsBxd@tfArrAnYjzBjQtbG|Vr}B~cDdbLznJnuPhJd[r{C`fKtfC`cDlxAxmA|_AjpAxn@t|An_DldMtSjfB",
        "_xgxEqcpuJqv@nlAmeAst@mOeDii@xy@kRzl@",
        "cdnxEehluJ?|s@tr@nfIxXftA",
        "_wcwEsoywJghB|iYufCx{KsdGl~GgoHhuK_Rls@eNzh@kH`fAqVjq@ed@jf@wo@jh@{W|@obAqWcZpA_gAzaBgBpL",
        "sygxEgmpuJr@tH",
        "alnuEwgd{J{_Ap`Ay`FztB}}Axc@{{FiIylBtGomB|i@caBpaAemAvzAk{BpwI}}AdkDmcOv_Si|AvcD}iAtxDyD~kJ",
        "_ekwE}r|xJvuEznVfVlrJ",
        "_j_vEy}t|Ja]bcAuuHnyK",
        "w~ivEe_f|JvF|gDjyCnjErdTb_R|i@zaB",
        "gx}uEimb}JmFpv@s~@`wD",
        "i_`vEu}z|JfAdbAzM~|@dCt}@"
      ]
    },
    {
      "left": "AFG",
      "right": "UZB",
      "kind": "International boundary (verify)",
      "lines": [
        "ev}aFqpoyKkl@zjCq~AtfA_sBnl@ojBt}@k{A||BctAbtGc~@~|Bc~Avy@inGjfBow@zkA{]bbCgnC|xFcj@tpBcDtlH",
        "qxdcFittwK~jBf}P|[lpXtR|`AbtA~yBnRpaA",
        "is|bFceavKsDfhDoJdlAojC`|K{LztC",
        "y}acFw{guK~Hz~Ct]lxB",
        "kodbFuqj{KugAleBoaGztBuw@tnC",
        "gspbFue_{Kv[z`CfdA|qBtdDllEbiA~zB~r@t|Bt]hfChIxvCv[d_DpzBjmF|TnjC",
        "q|fbFovc|KaGbnA}ZbdAqqAhgCwPtfA",
        "{dkbFgrx{KbF`fA`\\bvBvEf`Ar[bf@d}@`e@jz@lo@jSnbA",
        "mm~aFkku|KwsBj[irAhhAit@nmByXn`C",
        "sdgbFuuj|K`Gd~E"
      ]
    },
    {
      "left": "TUR",
      "right": "SYR",
      "kind": "International boundary (verify)",
      "lines": [
        "u_ybF_ks`GncAafAhgAwFj}@hIrYmEnJgtArhA}|D",
        "agfaFkcnzFgaAeku@}jNwjpAidCo`UmbCgpG_aJ{uMkjI}xHij@myA_hAupB",
        "_pqbFk}aaGjHwe@p`@cZ`|@u^p`@cZ|gCetE|Psi@rnAug@b|IvnBrnAafArd@ap@hwAiKzoDoC",
        "wdobFci~`G{Lob@qa@mf@yYih@",
        "{oqaFyqrxFhoForm@jzAavGb\\_fC",
        "_aw~EsndnF_J{nIiaEenf@cvHce~@_tK_|h@mjHmlRu|@y_Feb@miF{vA{hFwnFm|Lg|LazXo}@}|Beh@adC}TigCoEwmC_bAy}GcrJ{bYc~AmtH{iCwrc@",
        "mtg`FsthhFxh@eyKf~G}bd@rhCwsHnoPmtSfxC{sDz~Co{Jpl@{vL",
        "wbr~EgupcF_|Mow[afCczJspDoj_@opJ{h^ae@kmDyx@}oBauH_}QuaCgbL{PytE",
        "max_Fg`u~ElEyy@v@eEf`Iu}b@hSuiKrUovBjf@u{Bfv@qtBhgAg_BbmCq}DloAap@daCoEpgEfu@tfAgVrsAqtBzu@kzB",
        "cz`|Ecdj~EccAmyL_s@ec@{kCxDmwArUafBzj@c~At{@c@TccAjgAs_@`eBmP`mEkq@h~@i@m[ow@{a@u|Aug@gv@i@cn@bF}i@lPuh@j]wPh]{b@zaBi^zj@en@|_@mrIfuBifBbOu|AoYsoFsyD_mGc\\wtGpCegGssAiqCiiAwyBiTywBcDqiCcZuyBqlAymBaeBywBkeAwwChT{Acy@",
        "ie__FanfmFhcGq_]",
        "qj|~EefxkFaf@aw^_`@shCuQeeI",
        "e{v~EyxhbFxuCcw^r@icG",
        "m_t~Eu`xaFuqAglKaH{iC",
        "uku~Eu}maFvEkfBdXueBhK}sB",
        "sio~Eu|caFqLcy@wy@mo@cnA{_Bsi@qtB",
        "ewb|Ecsw}Elz@cyMr@{uB",
        "mh}{Eyem}E?ga@_S}s@qb@w\\qk@kGkg@sUuRkeAqM_rB",
        "qub|Egb_}EzjAymAfl@emApV}tA`RcjDjHod@",
        "o}szEq_x|E{b@adCspDnNuf[kRwzAsJcn@ec@uh@_r@}t@kGgtAvxAcz@igA",
        "ukvzEmip|EdmAcuF",
        "wqmzE_ug|EkRmbBg{Eis@I?_@UI?ug@_{B",
        "itnzEm~b|Epa@quC",
        "s`syEshq{EiNahBcAmMmwDwdAexLce@otDqhCcz@{gE",
        "y}gzEskrzEhgAemAvoA}@vpAvQpiAgM`r@igAvQ{_BxCwbEbeAwwD`vEujJ",
        "otezEexfzEkSmzBmd@}|BoNayB",
        "}dfzEu|dzElOoz@"
      ]
    },
    {
      "left": "IRQ",
      "right": "IRN",
      "kind": "International boundary (verify)",
      "lines": [
        "awaaF_eopG_Iby@_^v[g~At^wg@dWmYfl@sJxm@iOfk@yh@xc@omBvp@k|@^{rD_tA",
        "{{m_Fwa|pGw\\vaD{aAt{BykBbp@kyCebAkyE{|EwnBguAouCs`@ckCv\\}dBnx@smBnb@seD{a@cdAocAybAiIgw@jh@mx@fgC_}@`fAwRrj@",
        "_xbaFw|tpGfAj{@t]jzB",
        "yzd}EsuirGi_AfhDeaAtfA{w@fVu|@jIapA~\\a{@`q@uh@rt@ir@`g@owAxDceAboAscAxaBsNrU_}AvyAobBsKeNwZoWqlA}JuQybCyDotE{aAaaFmxB}sB_IueCnaAw_FxvCycBj{Ayl@rgB}@lpAwQ~gAcd@p_Agv@nx@}u@bmAgKlyA",
        "sdn_FqcbqGvGx`E",
        "ovqzEmhzsGcNjeCwzAxlBIh@IRK?]?wcBtg@{_Cyc@q_C{kAcbB{kAi|ByXi}BlnAckEx`EmbCr^m_HoNyvB`\\_hA`zAshAhsBgjAnb@cnAcvCcxBftB{kBfj@klGxNuoCj]s{CdbAaoBxlBkHf}C",
        "ewh}E{izrGvoBb}IrJbuD",
        "uiqyEkjfvG{XjoBkqAzkAiaIp~CilIt`H{iCjyDeYzhDih@voAmlD|eFsfA`pFch@liC",
        "crxzEmtqtGhAlbDrrAhnEdXbnB^h@HR?r@HHxcAjzB`e@ziC",
        "munyE_iwxG{j@~|Bga@~q@qa@be@ij@xYq~B~]gU~\\eEpl@wz@n_Eq@jfB",
        "wjzyEsdcxG~]vcBdw@xwBf`@h|B",
        "irvyEwixwG{MzlK",
        "eawyE{{kwGpw@zgE",
        "shuyE_sewGoDr_AyOf_AgAr~@",
        "eavyEor_wGrhBnvCvo@xwBlFn_C",
        "{h~xEgwayGiKoaCekAq`BkeBgtAqaB}|DsgAcbBaeB_hA{`BqKurAnm@k{@~fB_J~eC",
        "}utyEuinyG|k@vnBt{@ziBpb@puBbn@nhGdC~dC",
        "k_qyEuasvGow@vdBsJvdA",
        "ocsyEevmvGxx@xjF",
        "et~xEyazxGhJmtF",
        "ityxE_hlxGgWo_CsfCixH",
        "i_zxEur~wG~IitL",
        "}tbxEgfwwGeuAmPioFv{@afBKmlB}TebBmp@ufAmnAoc@q_C",
        "kddxEkgqwGln@{}D",
        "qc_vEi|mxGwp@fvAoaBvOmnAqv@{jAolAa~@u_@mXeLcwDfl@mlCdtCq{FrxIqjOxnKgsDjpAwx@rAmq@oN_h@}_@_^mp@{W{WoXkGoY~GeYfWyuB`eAi}Bhu@mEm[?a]",
        "kucuEyyixGgj@{}CsKqlAu\\ebAqjAup@wzBd`CioD_sAs|DifCkcDqV}_Ah}A",
        "oe_vEonuxG|@dqF",
        "qmduEajfxGdWwnB",
        "uy~tEqdywG_TebBmeAuzA}qAsfDoD_~@",
        "gmduEaxgwGbYk{AbeAybC|Tq_A",
        "qn}sEycwvG_gB}}AcxCyn@_qB_t@qtBmOy`Dxx@]?itA`QsqAi@agAi]}t@gaAiJ_h@aF{vA{Nmd@k\\}K{kAlPk\\mE}sBguAoMqj@",
        "e|`uEgiswGnaAizD",
        "aw`uEyxpwGcDmoA",
        "apatEealvG`p@coBh_@}hAbo@qgD",
        "_b{qEm|{uGoEcd@kg@oXoaAyO{aAs@ug@lQapAvdA}hB~RqtB|AguBtRqj@xXu]~^yd@t]oaAjRar@|Tel@zl@ec@dw@eWtr@gvA~{AwcBwn@kcDylDwfAkRg}BpM}iAuRafAk|@cZcnAoN_qDebBalDmwCu^q}ChKcwBkh@yDuoC",
        "aecrEczutGbz@qrFh|AmuEle@c`Eb[qlL`g@shC",
        "e|opEmtqtGueArrBefCboAeaOb`EeqAw{@{{@cgIga@gl@gf@ug@el@ob@sp@w\\_xDuG}{F~r@ojDyX",
        "ukcnEu{ktGuGlaDuaAxlCuuCd`Ckq@wdCqa@u{@mk@ur@?i@S?slDg~Ao~Css@wiCmeAcnBmwCqpAwzA}jDq{FqeAs~@sdA?wt@zb@iu@zl@efA~\\yx@qKeuB{vAkw@_^ukHirAgyCsKwlCfa@wyB|~AccAd`C",
        "sorpEs|ytGRnjCxqAt{B",
        "oe~kE}ocvGsj@ri@e}Es@em@~Sgo@|TuoDpeHcnA~}AmdBftAqdBr}@mmBhj@o}BxYyfBzk@gjA`qAibAf_BulA|rA_iYdkPwGrJeDpL{@nN",
        "kcdnEmtqtGtVvwD",
        "{iikEgvcwGkc@jxDqkAfjBojBq`BovCogHc}A{kAgiC|j@akAlcC_}AlmB__EoW",
        "gpglEgbawGb[~eCzBpnHng@~pBhqCztDdx@teBvUdlB",
        "_|biEgxhxG}OkdBurAybCokCqgD_wA}tAgoAqk@ow@zBme@jgAey@vZer@eC}vByd@i_Ah@mhBpv@iiAdvA_fC|eEueHtwFghDhpEazAh_@igBpB}}B`RauBjq@{jB`fAszE|pEgK~QgHvR}IjVqBrFeD|^",
        "ummkEoeowG~Cj^pM~]d{ArrB`Sf|D",
        "ybciEqoexGxEugB",
        "efbhEgwuxGid@|lJcyF`dC_@?kkA{kA{eA_gB}oAu{AaiBuh@stAzb@sbAbyA_i@ptBoYnqGy}@fvAakAeE}y@s|BkIqhC",
        "oqieE_bf~Gwhj@txy@ywF~aGooEpxKubEb~GsJxVg{G`fQqsC`nDyxF~mRilDvvS",
        "ykdhE}wlyGrdAt_V",
        "{{aeEmnx~Gsc@~cEosAf}D_{BpfEOH",
        "oqieEicf~G?h@",
        "co`xDspieHuHrhAyYldA{l@`q@wz@nZerGhr@ggCdw@wyBboAq`BrgB{a@r_AsSvdAwpAltSo~DtHI?oa}AiTcoA`S{a@xaAIxd_Akfn@{Tym`@qNmcdAmw\\mlCed@wcClPwnBrtA}|CluFg~AlcBen@fUolBh_@ow@za@yd@xn@}}@`pBaq@ri@atIn~EcmBj\\_@?wmBt|@yyAjyEi|Az~AgoGlmC}oBj{AsOpLsi@xwB_Ih}Ast@pv@}~@jq@gj@loA}Vx`Ba[ti@mp@xDevA}KybAqW}u@cd@u{@g`@gvAuH{oAr_@ymAvxBmnAp`@kXv{@ub@~f@_aCnmBwa@pVka@j\\ouCjyD{b@v[msAth@_^_@wVeX}rB}u@qa@{a@_h@qUegAtHwl@za@_kB|eDupB~gBm_B`eAcmAxnAsz@tdC{eB~`JyCxvA",
        "cygeEkwk_HzdCd}Gjb@lmB~Rh{E",
        "myzuD}uegHiP~j@wn@l`Ecp@~{Amz@puAyb@tg@ah@`\\wxBpv@kpA|KuuH~pBuIbPg_Anb@myBt{B_pCdmAij@fKmdAqL_s@ap@ym@c{@}t@ol@oaAeOobA~Js~@|^_t@~g@o_E|qF_eEzgEmvD|}Bgj@ly@iUpjAgBxmA",
        "_saxD{`seHh`@tcFpApjA"
      ]
    },
    {
      "left": "JOR",
      "right": "ISR",
      "kind": "International boundary (verify)",
      "lines": [
        "ubnfEkojxE|dA|qBxhBh}Arh@pv@~Npk@tSpLhr@fB`l@eXnY_t@|e@??hj@rm@?fw@qb@b`DkRjlA{a@z`@zXpB~G",
        "_hueE_ccxEuMfBwUjG",
        "mmveEkwbxEfUzM`bAl[",
        "ctseEalaxEyi@ve@",
        "}~teEie`xExaCiTdg@mP?ftAhi@?",
        "ylneEww_xE\\yXvv@sk@lY{Kzr@yy@`f@?dMdw@b`@nd@ri@fVxh@rJ|LgVrJgMjGwOzCyZrm@?rUlf@bOri@ri@we@zm@ftA|IqL",
        "sineEyv~wEeB}_@",
        "m|}dEiq_xEdCiIf\\uH?nm@ve@?v_@we@dXyDlPnY`It{@|cAwZhS{MhZk]ve@yX",
        "kz}dEkd_xEaA}K",
        "qwe_EillwE|@qAbjJxGp}@p@xlCdXfzF`nBzrDhsBfl@qm@~eCjIbbCxvAbwCdmAdjDga@n_Dmz@r|BoaA~zC_|AziD}j@|pDt\\tqNfdHbvD`g@`cESjpBvdAdkCtgDf~@bkAnlClnAllCxOzjCgBfiChTlz@dc@~pA|hBbp@no@pjAhh@jeAhT||Cl[jsC`o@d@Jv`SrlJb|V~lG|sCt\\b}FnkBduC?h_A_^p}BwxAzwAmPzuApLdbAfa@f_A|h@bmAnd@pdIvy@pjBpk@rqDrAj}J}~B`dE?fqEldBd{IljGluFhgAfjA|Bdv@dVlo@`^|t@nWfsEzl@xzJxD|}BnYpiT~`HzzCpm@f~I|_@~zClz@~tBhrA|gCpk@biDvY"
      ]
    },
    {
      "left": "JOR",
      "right": "PSX",
      "kind": "International boundary (verify)",
      "lines": [
        "octdE_o`xE~n@wQxw@iI?ve@",
        "uzpdEie`xE}i@?",
        "serdEie`xE?nm@|i@?z{@q`@nzDbDz{Ayw@xgAvZdvB|@~uBgV~gAwp@~M~]xO|V|UxOva@hI",
        "}kwcEkwbxEbfHbpAzbBlZbiAoYnm@?fU~q@b[l[z`@?`g@}_@lwCrgBjgAzBnlA{`AhhAhhBzjBfa@l_HsJrqC{bApaAqLftA{B~r@iIbdAyc@tp@nCv[l[tIfj@jQxe@vq@lPfsNowCzlAdbAnm@?dpIwbCf|D|eEtuHz{CnsGrjCldMnbBnnMda@~H}@xDS|@pA",
        "}kwcEie`xE?aqA",
        "iue_EeplwEgAzB"
      ]
    },
    {
      "left": "CHN",
      "right": "NPL",
      "kind": "International boundary (verify)",
      "lines": [
        "sxsxDqfcqNbd@ufCjkHiwVh]ifC",
        "kobxDqxnpNiUweA}nFkeAkr@k]oXom@mQ{uBq`@_sA_t@}_@gu@kRme@ug@mOckC",
        "{llxDi{zoNth@}sBvaEidF`z@s}B~TkcD",
        "kd|vDswgoNuImoAa|@cbBqtAshAaeBgl@abEk[uqBomAmz@sTqt@xDocB~f@{u@jHuyEbEcbB}TyxAeaAquA__@yaBzMapAoO}_@i{B",
        "yzjxDmfprN`dBmjG",
        "yhhxD{mcrNiSokC}i@adCwQ_fC",
        "qdhxDih_sNhTkzBza@qv@`{A}iAp`@gj@`Hk|@",
        "wugxD{qxrNyMmuE",
        "gsdxDqjxsNrK_qCpk@g`B|~AwZxeJldAtdDaQpkBecAjeAsqB`r@mbDbnAs~AnvBj\\vkFhqC|sAaFlbCug@|}Bey@jeAcy@xOq~B",
        "uebxDynjsNmQa{@yYw{@cPaz@eN{fG",
        "azhwDcpjmNjq@q`A~fBwoAbyBufAbjEwnAtmEmnCh~Amn@drGa_ArIoAxx@woA",
        "gi|vD{qdoNzCwdB",
        "_gcvDuhqnNgVojCcxAg`AanDtH_s@guAu\\ylBag@u{@cL{Eep@wXq_BqWui@`He`B~q@{l@{Bii@ebAcEe`B",
        "s}nvDuwwtNtyCsxGbPs}BTg_Ch^yjCbe@ur@~eBsiAdc@ir@dMweB",
        "wemvD_tptNmd@aoBmQsrB",
        "e|fvDsfhnNdtBaaH",
        "ytevDal~mNoc@sfD{A}qC",
        "e_cvDstxuNRq~Aht@}~Ah|AwpAzuAmcB~gAkpBrt@etB~pAsmHdx@ylBhhOi~MnbAqkB",
        "irbvDktuuN{Kg_B",
        "}cbuDq{pwNzBs_Ath@_hA~q@i@t|@l[|iAbQbiBox@zaGqyJf|CgsBpw@ocA~a@}iAbUqjAnc@{_A`kAui@ppBywA",
        "m~`uDeyjwN}@{`Aqb@o_C",
        "soetDij~xNvVwy@n|AazAda@kr@vFs~@",
        "u|_tDs_rxNag@maCe|AolCul@wyB",
        "ybatD_~jyNrJkgAfoGgcJr~@_q@nvC_tAjl@g`A",
        "mp`tDcsfyNkQ{iC",
        "ggysDyfozN|AgjAjWufAhx@qtAn_@sUxqAsUl[yOdYmo@x^}hBdWom@t`CipCdqAur@n|AoN~r@hTfa@xc@~h@|_@|hAtHxfCsgB",
        "mbpsD{r~yNiDkzAebAmd@uvAcQ_bAu]{Ngj@yb@adD}L_qC",
        "kx}rDy~q{NvvCeiDloBeOj{AdOxmAiJrgC}{D`dAqLlkAbFhvAk]`|@iiAza@wnAnm@}_AjoDow@|s@ycAp|@mkDhbAylBn}Ac{@riFkz@nfC}Kb~@oNvq@uh@fZqkAvQ{}C|o@qaA`f@shAxh@{|FjCu{A",
        "im{rDsne{NajAeoK",
        "}`xqDurj_OlPqlAbZcy@|n@md@~qAeO",
        "qllqDmmh~NsNclCiwBavGye@qsCeSgl@irAgt@w_@yd@em@m`E{MgtBIolA",
        "ihtqDslu_OpMugAd`Aew@|jAqtA",
        "mqrqD_pp_Occ@olAwQcnA",
        "cgqqDkic`OhAmmB`{@yy@fhDwe@rbA{j@vPitA",
        "sloqDac|_OcPmnBkh@{uB",
        "mzlqDooc~NzL}|C",
        "gh}pDmxn}Nib@gaBiAkEuvAem@olBcZueB{l@{kBq~Bim@ovCoDe_D",
        "uvgqDk~p`OdIgsAdwAwe@rfBjg@`aBfsAzeBbz@rvB{b@xvBeiC|j@ce@rz@_U~cEyb@pjAcmC`g@{jCvoAybAftOjyCzdD_sBbwAs|@fcDy|HxlA_hLl[{kAjp@i_AbxC_fBlcBwcCzw@ss@l}Gi}ArxBmpAdh@szC",
        "cjgqDqzm`OqKybB",
        "c|inDesvbOjg@siBlu@aeBjf@_{Bdr@gyIl[ew@xlBa{@pl@si@~f@wyBnT{tBdr@_iAt`Hr_@tr@upAhKe}Gvu@yuBtdDmbDtkAokB`\\coA`H}iA",
        "qxinDmdrbOqBwmC",
        "ynxmDkhcfO|j@s|BvmCieFjuAyqHxhA}j@xwHbdAnr@~Rtw@be@t]pl@pf@njBjl@dd@nc@tHftBR|rAbe@`uAd`Dp|@`e@ttIuq@vxB?lyDzVtoAjIvzA}k@biAqhCv@uyC",
        "_kdmD_uheOmPa|@kf@wp@}qCcmAsd@od@ixAkyD{Lcy@sUss@wq@uh@ekBa{@mt@ug@kb@si@{[wmC",
        "u|emDq~`eOrJ}jAt\\ueBjGybA",
        "iiemDudvdOkR{xI",
        "cf}kD{{_jObgCs^btG_Jx_DyaBngCguBhqBgiCr}AkbDbmB{rGdgAudCj`Bi}A``A}UrhCk\\~_CokBry@iKf{@vFljA{BxoCap@|sAqaAblD}yErrBymA~wB|@l|BvZp_CzBjzCufAve@ylB",
        "wvlkDkpmiO}@moAsdFoiDic@cp@yi@mcCoc@gj@qu@cFa{@h@ar@uRoMguA",
        "_ewkD}mzfOvaD{gEdh@upBrVyxBbEadB",
        "ywtkDowrfOqv@q~BsT{uB",
        "swukDgzlhOt]i}AppAotD",
        "}mnkDak_hOmf@i~AqmCgrCyn@quA{BaeB",
        "i_skDag~hOzNaoCh^_fCdkAg}BdlA_sA",
        "kgrkDanuhO_UsgC}@koC",
        "i~rkDwrugOp`@aqAlu@yw@nm@{`AzHqjB",
        "i{okDkgkgOcQssAgeAmmDsIigA",
        "iizjDwizlO~Ti|BvxBu}@dzCaFt{B~f@vhBht@ry@{Lhn@em@leAql@ntD}i@|iA}j@ln@a{AJ]f@}Ah_@}|B|J{~BvWevBteAufBdeDgrCbe@mz@hIk|@",
        "_wziDcimlOaf@h~@kc@tH{f@}J_s@?shBmZg`@{C}o@tRy|A`fAy}@`HqqNe`P",
        "wrpjDkd}oO|E_pBrj@myBp`AuoBzeA{vAljAoYxyDrVbsAon@xy@s{D",
        "wlkjD_nsoO_Su{AsmBojCkb@emA",
        "iqpjDqbkoOrt@}sA`gA{tAze@s_B",
        "adjiDc}nnOyDssAsgB_dFg_A_eC}yAssAkuBmf@K@spCz@olBr@ufAce@i}@}t@isAom@s|AyMicBgBq{AaQqdAyy@kNybB",
        "ks~iD}_`qOj{BclD\\?nuCqu@zeBadBtw@kfCrKe_D",
        "qb~iDkgrpOyOqwL",
        "exeiDk|elO{A{RoEkk@yb@gvAmnD_dEuWob@k`AzBsj@r^md@jh@un@~]}cAdB}t@kQuq@S{w@pu@]?IR",
        "iwziDcimlOH?",
        "_nriDq~|qObE}hBxrAizCjxDucE`nKwsIjtBotFbGwbD",
        "kspiDgpsqOcZuyDeSciAiJoh@",
        "cfqiDswbnOxXew@~zC{qEfk@myB",
        "wsoiDux}mOaQkq@gWkq@aGey@",
        "_ziiDirbwOt{@mxBtSgiNvQqaAvz@kcCzLgjA",
        "gxuhD}~gvOgLucDymAwwDevBsqCeuCqtByjD{_Bq`BihA}IqbA",
        "k|fiDejhxOri@ymClcCkkGvZokC",
        "gldiDeh~wOgLurAmz@kcDmF}hA",
        "agfiDk`alOzM_{C",
        "iieiDs_xkOw\\w_H",
        "in_iDagftOnc@ieC|sA`\\rgBhgAr}A?",
        "oywhDw|wsOemAiqCanB}gCqv@anD",
        "_{{hDm_guOt]kzB~\\a\\`q@{Vjr@}_@nc@ur@pA_gB",
        "smuhD_hgtO{AmmBkjC{iPct@orF_IsiB",
        "wnzhDstlsOftAcgJ",
        "cnyhDovbsOs_@c}H",
        "yhyhDol{uOpVetCxg@csBdo@chC",
        "yquhDklruOi|AmaEuXu|A"
      ]
    },
    {
      "left": "IND",
      "right": "NPL",
      "kind": "International boundary (verify)",
      "lines": [
        "ws|qDgn{hNgGrt@w_Afa@q{Fzl@mkElcCygBdl@}mBqWgk@oaAcs@euDkx@md@qoAmP{g@si@eb@gw@m_Ayw@Y}@srAi|Bco@st@kw@qk@y^qA{a@bOme@`Hij@sUeWga@yc@olAgVqb@giCykCa`CgiAkhCuHibDnx@gfDftAi|Clz@w}CRykDwzAqsBacDqvAusJe`BadCw~Iw~HkbE{iCc`FkrAgjB}s@ol@_|AeXm`F}_@ovBsk@onAieCwaDwcC{}Ecz@_}@gdGizDonAevA_xF_wJacD_{BueDtqAgiAevA_qBolBe~@qaB"
      ]
    },
    {
      "left": "IND",
      "right": "MMR",
      "kind": "International boundary (verify)",
      "lines": [
        "uyciDsoypQak@shCwz@gsBem@a\\ugArJekCzBgdBcZwrDugBmxAea@aoDpk@ibHpnH{}ChtAotEod@yzJ_yDujDf_@",
        "gqjiDcfspQrIeaBrmA_hAxrA{Bni@mY",
        "eqhdDw_uoQk\\aqAag@gVy`Di~@mo@}I{`Ada@yd@~s@u]xw@{k@zl@yx@xOuoBpAwp@dc@o`DnkDujd@jx^c~EpsCquBbZwvDuqA}zA~Iau@zV}rBrUcz@nCsx@vQc_BvdA_}@xXyaCSuzBkq@wjBirAeqAmdBkxCuwF{vAelB}oF{rEyn@_qA_u@}gEcWwxA?we@}UsUsoAiIoaAuSm_@}j@mf@_{Bqa@od@wyAap@}Uag@kQebAm\\st@q{FqyH}bBobBqdBuoAy~@}iA{q@kqBcYmxB",
        "{a_fDkfcmQbEkoBb[euBvyAaxEldAelBbnAaoAdhE{`ClnAshAbwCggE`q@yc@byBhs@|gBlz@dbByDrhBmlCzcJm{Yxm@qv@~r@}j@fl@ap@vZmeA",
        "c~yeDqhylQeCymAs_@}~@mdB_gBoXafA",
        "{n}eDcsolQh_@qiDt\\ew@`^ce@tRqk@",
        "cfqeD{u|kQ_JoaCwd@maCmp@}_BsgC}|B{iBst@ar@ybA",
        "streDuslkQlP}`L`\\g_B",
        "{otbDi}ifQon@ifBe_CqjA}rCa}@coAmcAob@eaBk]c_Hu]uqAkeA_}@axFy_DajHwkGa{@qgDcz@k`JaoAejDcwCmkDiqD}gCuhK_cFmjHunFcsFc|JykDsjLe}Foxr@",
        "ahkdDqkooQxYmnAlf@kq@rSkq@",
        "}lidDwvgoQ{Ci|@uYscAyR{q@wF__A",
        "wiubD_nafQ|UaoC|Ag~B",
        "ursaDqqldQg`@_rBwcBgfFylCi~Mu|@koB{qEmvDidGcmCspEghDwz@ubG",
        "w`xaDkhedQn`C{aBrCap@|FgtA",
        "ysxuCio``QqH{kAcn@{tAwtAqjAajBwp@wsBgVsnB?oxDec@isHsyFucDeaBkvO}sBw}BmdBo_EqtBygG}_@ocG|j@sqDlmBq`Bd_Fel@|zFqkAl`F{}DfrCa`G~Rmd\\uhJwkEykCkwB}zBiv@}w@eaCojEkg@ovB{VkwEu^isBuoAkoBwlFe_D_fByxA_Tgu@}@kzBmZmz@oYoCoy@jq@}_@gBsSeXs`@{`AuSsUslVipPwn@cn@uTc{@oNadC{a@qv@koBug@clCrJidSr}ByxBeD_fCih@wy@afA{kAyhF_~@weBaaGygGuxEwbE_|B_hAmbCbF}iAxmAg`An~EyaArsAecLj|@_t@eXwo@{l@om@u\\yn@fVqWtp@sItr@yO`r@uh@xn@g|DnlAwvFj[syFsJ_cEsi@spE{tAu{AsJ{vBbZumEnvBmbBfKowB{tAI?weA}_BuyDmvD}}Aq_AmeAs`@ii@wFkf@|@sqD_Sem@gVox@k|@cY}u@w\\qhCoXk|@ap@is@evBevAsi@ey@mP}qB",
        "ytxuCya~_Q^olA",
        "iqopCmem}PskA}iAcRwQa~B_SsgC`Ha{BaHe{Bk|@o_JqzG}xAsUcoF}_@m{@m[kfAg`AilBcZy_FgVsjFshAavS{oH_gB{XqqEkR_bBq`@ss@om@gtAoaCgr@}j@or@mEukBhTmd@qAagAmeAqp@ekAufAgw@q{FoNmiA}h@st@wfAwu@}}A_}H}tAwxAwn@eaAuhAqdDuvGeoCqjAmkLoaCsbBis@{NwzA",
        "qz_rCmcwxP``AkzB|~FioD~gAu}@j~DckEbtA_g@fnAiT`w@yn@hNupB",
        "aalkC{ecxP{GacDgjAwaDeaBmxBmsBi}A_cNubGslA}@mjApLq`B|@odLkq@{fGbZikBaH}dBkf@e_DcyBct@}T_x@gBqeArJclJbe@qmDqAcwd@{gEkmEzKk`AbZ}nBhtAa`Ald@k{B~cEouUjfBa~EyDgcB~Rij@zX{\\xc@u{@hs@ikEjeCoeBvp@cnBf_@adCrJawBaHo`@qAwmC}h@ocBemAev@wcD",
        "cupqC{`tzP~b@q{Hr~@qfEhvHuwFxy@oaC",
        "sxgqCmu`zPoMu{@e^yc@eh@k]co@}Vqp@yMkuAmwCqLkkH",
        "qwjqCue}yP|Pug@|j@}_@``@ce@",
        "mefqCwxoyPcIoaCsdBmaEka@_gB",
        "eycqC}p_|Pjf@cuDh~@koDvp@wvEtWwmCjtDgdJ|hAacBhsBexA~{AwxAbEgjB",
        "k_bqCe`p{Pyx@woN",
        "grvkCwsuwPv[mxBdvAq`B|xB_sAhbBcbC",
        "_ycjCkuiwPuoCwy@muFo~Eq`CmyAsrBsJm}Bjf@s~Et{BadCvp@mlD~]oeDsJwoB{kAct@kyC",
        "ubdjCk_iwPtH_U",
        "sbufC}klwPmy@sfCuHk|@mZmo@emAa\\i}@{Bo{Uhs@y~FnlA}{Ez}EadBtr@wlEf`AupCxDmuF{bAifC_HkyB`e@seFzkCevBtp@cbCjR_rNgu@eiDklE",
        "yfufC}lkwPdC_^",
        "afkfC_ljwPmf@{iCmaEhsB{kAsA_IwF",
        "{gpfCk_|vPlZueDf`@apBj}@{tAve@_~A",
        "_ieeCsqkvPgA_g@}Usi@gLqLoMuJij@yDgk@|@qk@jIsi@vQmoAtg@srAjRaqAsJ_oEkqBol@u{@yO{kAsj@koBkq@`QagLkGem@tHob@qLcZiiA{Bwy@",
        "m_ffCshutPvf@yvCppGglKlgJarKxjCcnBrrD_r@nsD_^lz@g`A",
        "c~yeCoortPcOwZs_AoC_pDpUiqAaQgl@k|@",
        "kkzeC_aqtPxDoNlF_^",
        "ynceCgf`tPcPwp@qWom@u^_i@ae@yc@urAafAgU{kAoEykAcc@cdAitAom@{tA?qvAdM_{ASyxB{c@",
        "icleCascvP|u@weBlmBwoAxb@}_@bPce@",
        "in_eCcc{uPu{@shAgrDyy@}gCcn@c[k{A"
      ]
    },
    {
      "left": "MMR",
      "right": "THA",
      "kind": "International boundary (verify)",
      "lines": [
        "idx{Bc~}`RbEs]no@s_Azu@ag@j{@oMnx@sUxo@a{@duAkgA~TobA",
        "ska{B_g}_Rkb@ylBe|AihBwdBew@w`FirAq_BafAceAkoBgk@{iCmn@atIgMc\\",
        "mdl{By{kaRrPmyAxn@uqAbs@ug@rz@_^`dAap@zcD}pG",
        "}cl{BoriaROihA",
        "q{k{Bwz|}Qt^owAffE{oHztC}~MzAa{@",
        "smmyB_u`}QqVo~C}{EgnVkdDwmEiqAkpAgb@shA_d@az@gEaIgjB}~@q|C}_@_cBfj@coEbkE_kJleAirBrt@ecF|dFmhBdw@kh@ywB",
        "ila{Byiu_RTe|F",
        "sd}zBqgf_RuSywB_|AggF_Ue`C",
        "uj`{Bmr}~QxCg`ArUew@~|@_~ArKu{@",
        "{{_{Bc`z~QyMiqB",
        "ekyyBc{e|Q|IywB|eAw`Gfo@clBz}D}qFp{@g~B",
        "cpowBefpzQwRq`BizCo~EgzAeqFqeAquAifCuqAuzCcp@quBbF{sB~]{uCtSm~@}Kck@u\\}_@w\\u\\cO_y@nCypBdc@{|@bFalLocAotEwyB}aDgfFofBerG_c@w~F",
        "ut{wBcpluQvtAu|AzfB{kAxXkpA",
        "{ezvB}scuQqP_r@_nA}_@smB}@gaFrr@cqBnEgxKirA}sAkh@a\\wbC",
        "{m{wBalazQzpA_{Dvy@evAtbAymAllDcwB",
        "a}awB{skxQyFqWmi@aHwu@q_A{l@u{BuXekCc^wn@k`CsiBgo@is@qm@ylBelA{iPwe@ovB_lGgmJ",
        "cvuwB_kyuQfdAmaCrvEuwF|}@{rEhV{l@d|@a\\d_CvFl`AoNzkA_rB",
        "g}twBaltuQ{W}}C",
        "}}gwB_bcxQnd@{u@nx@en@zq@q_A~m@gjB",
        "u~cwBgtpwQuGgyGylBkyE_AkSwEwcA",
        "mydwBsogwQvYscH",
        "iw_wBu_rvQi_@s|Cy|BkuG_C}zF",
        "mgzvBewauQp@w{@",
        "{dttBijzsQ}Ua{@azBap@_kBxw@}sBdvA_uC`g@k}@tHswBnm@wk@zBimG_oEqmDinEuaAst@gzAkh@{a@zB_^|V_nAtSs{BzK{pByD_lA{u@yPa_CoMogBaxD{cKmj@kq@ofBazAgm@}u@cSmcA",
        "kjttBgcxsQnDafA",
        "yxipBokqsQiJaQkfAce@}zFwp@a}Fpk@ewF`fA_iF~]{hCfBsnBjRagFzkAor@xDcbDqWcnAnYaaAz`A_kBdvCadCxkCsiAdXu{@}~@oxAebCkzAcxAa`Bqk@coFug@gtBybAk{GgcKc_BowAcxA}h@shNeZ}nBdOauBzl@gy@nv@w_CteD_x@za@_bAqWkHcy@",
        "s`jpBcmpsQxFk]",
        "yqgpBkcgsQymAwhH",
        "ozgpBsx|rQtGwiI",
        "oqzoBqycrQgnB{qForGwqLge@mxB",
        "ygfpBg}dqQ|NkeCjDel@pa@}u@~_E{~B~r@mPvj@yZtg@ybAvGoaA",
        "gmnnBcogrQgeAr}Bk`B~eCswBr{BqiCfvAkyCbc@}mC|@qiChTgkF|}Cc~G`oCa{AxXouB`fAovBjeCmeAve@",
        "{xzoBsuzqQjF}bH",
        "w}yoBe{uqQcZmyC",
        "qnfmB{qhsQ{C~Twt@~Gk^yDqz@cZmd@mEicAdM_qBby@uhArLmt@?cd@lE{g@pWiiL~_IeaCbdAwy@mPug@u|Am_Bcn@iqBgB{|Ave@gk@voA_zBx|H",
        "yt{nBkkprQbO`fA`MrJdkHhsBxn@bZjl@by@",
        "ibzeBoajxQgqDrt@stAtg@af@vy@qj@p`BwzAfVigB|@kqAxc@kqAxbAmkE|hBg~A|`AelBhqBmdAjoBeb@~|ByExqHi_@nkBmnAhtAwlC|rAiTqWgw@g_@mo@xD]vaD}t@pLkfAa\\}u@_r@_}A`mCcrHh{Ei|AbwBit@p`B}hNxuOc{@vp@kpApLwbCsU{kA{BowAnd@gl@fiA_]bzA_i@rsAisAtqA{tAfj@}qDr_AuoEdiCi|AxZu{@pv@cf@z`AyaA|rCyy@j{AeoCf`D}gW~cZ{kA`{@{uAxe@mnAjGwfAh@g_AfKq_Art@myBbvC_gApb@_sA`\\}hAr}@k}@dmAeuA`p@wQknCegHrsA_|Amf@ohHioDwmByjDcPuSq`@_SihAdMkhAl[g`@~R}^nYmrE`zAakAjRyX|K}e@ftA}NnY",
        "oufmBsmisQ|EvZ",
        "}k|eBskexQlQafAdv@ymA",
        "glibB{{hyQkqAnvBs|Alf@}`M`zAotDvoAccAvFoaCu}@{`AuHkpB`r@iiNj}J{_Ave@ebAh@gaAuSmx@qAqw@fKs~@nY}qBlyAwoCtxEovBpuAyiD|j@meAr^{iCjxDcnBhKovBcp@ifB}iAoXuzAa}@mdBelAqjAmdAwQkq@zl@{Vj|@i_@dw@gjAbZywAoNa]kq@",
        "e_haBaq|yQqKe_Bce@}u@u{CgrC{v@c\\_pCpCadCiKazB_g@_qBemAseEunDyaB_^gzGw\\ioG_}@upBdDkxCzjBmyAtoCymB|sBysEzV",
        "ugpcBkrgzQ|gBnaCbcBtr@jaGhs@fsC|rAl`HfxJrmGtyDtfAbcB",
        "}wlaBgxkyQbo@a~Jf`@giArj@qb@vZ}j@",
        "e}|`Ba{vxQIkpAyE}s@oXen@ew@cdAwyBevA_|Bwe@_gBis@u|@oaCoCylB",
        "}y~`BgepxQtHshAh_@{kAvQi~@",
        "ijp|AuykxQmvDwcDscHyw@azHrJ}a\\rqCadJ}K}eBpIkeFtViqCmP{sRwbEupBeMgeGzl@euCnCorFqjAmnBkRu{Bri@ehF|fD_rAjRaq@qv@",
        "wq{|A{h`xQfu@{~BzeA{~BjaBk{A|fCuS",
        "qvb|AwznwQmK}j@uh@oNy}A?_c@xOm[ld@sTbe@iOnNi_@kGi^{MwUoNyEcFu]{u@ka@ga@qv@wF}hBxXuq@oCiZug@ym@y_Fyd@ccBo|@ovB",
        "yyi|Aog}vQrUamCri@upBr}BytEjb@u|A",
        "}l{{AmumvQqp@elBiwAk{AoqH{{EoOsjA",
        "ww{{AmffvQrGs}DdAko@",
        "gravA{oiyQgB|}A_^ri@ifBboAcf@tg@sSzl@oTf_BcPzj@ct@lpAwp@rr@m}If{GubZvqLwi@jpAm\\zkAivAzl@ovCda@{eCfu@ezB`qAqeUnqVekOlqImxBvp@}yAiTu]}@{f@~Rst@dbAa`@vQibC~I}_FwF}gC~h@cvE~zB{`ApWw^Osp@Ysz@cZwt@ga@i_A_SggCp`@g@f@oaEz~DMDorCrn@mxBm[syEy`C_rB_^kvAxd@u`Bhi@Y?_hAnC",
        "uj_iAm_b~Q_TxvAmnBjTk{@_`@co@u{@qw@ar@gtA}Ii~@pUazBdbAq`A|VoaAbDupByMybAvOocAti@upBf_BqkAda@ovBtSozIlPsgCjh@syF`mCq_CnY}}@oNkeCebAqaAqWeiCaQwcCi@s_B|New@fHquAlz@qgDbsHgu@bdAk}@j|@q`A`g@mn@nm@ug@rqC}a@vy@up@jTs}BdMow@vZkh@f`A}UvmCcZdw@kjBr_AgoBxDevBwFu_CfVogAxn@}sB~zBybAvp@{|@hTi_EhT}|D`qAsw@pLqpAoEoy@gVku@g_@}eAoY{xBnNowB|tAqdBfsBw_AfjByhBdiCc|Bj]qjCga@gsCgu@q|CmP{iCjR}xBRugB{iAgk@ovBcZmvFijAqtAgC{C{jBaQa_CxX_iFxmAisAzByy@yXms@ec@c`AoYa{@?cwBtSewHi_@cwBxDsf]b_FelOpNcmCuSmbD|@}u@|b@ws@la@e~DziEwcBvn@}iH`fA{jB|@cjAyMwn@}@{g@pLss@f_@}Ql[qVdvAyO~_@}d@nWo|At^cd@vZmnCjcEchAzw@mhCf~@ouBfkA_iF|eE{qBr`@amCdMsdBt}@scAxlB}i@xtCsx@vdCybPpdVcqCllCoaHnuCwG`{@",
        "ckbvAqykyQzWthA",
        "yvxaAeuq{QakAst@s{Dqv@uv@cZ{eBaeBs~BixFsd@ap@sr@gbAg{@ug@e`Cwy@cz@om@qa@k|@ak@adCor@si@wmPi|DqjCuoAonFqhEojCqjAczF_~Ak_BoaAa|FalF{fBwe@olBuHayC{a@gcByy@grDesDegB{kAuzBox@ogBgVe|FrJ_qCmG_fBmx@s~@aeBc[aoCoNubGwz@iiAqsOwpKgsC_t@w}KuzAa{@zK_]|hBsjAdwBq_BjoB}}AnlAgiCzl@q_CuS{zF{_Bq~BaFiiBzj@ekAhtAyd@xuBwxAnbBmlDuS}eHmbBkfAkIs~@oYwy@eM}u@xXeW|u@",
        "i~biAm_o~Q|@|~@tpB`_J",
        "sk{aAw_h{QdOu^rJmnAhTafA`a@{`Ar@k|@",
        "e{}`Aw`zzQg_B{}EyEu\\kr@qm@kp@mYy|BgV{zARc~Bvp@akApLw_A{BicA{Mw_AeXau@ob@m{@ox@mFeX",
        "ae_aA{mtzQfLcy@dYst@lAcbA",
        "yqd~@iruyQezJwuBc}Hg~@qmFquA}|ByDqgKxvAebAtg@keBdwBynApUkkGov@wlCa}@whJmsGyhBovBwPmz@{FadC}L{l@qu@qk@{z@aWucAsZiy@}s@yc@krA"
      ]
    },
    {
      "left": "CHN",
      "right": "MMR",
      "kind": "International boundary (verify)",
      "lines": [
        "m|dmD{~jrQ`pAadCn_EekCnnA}rC",
        "yrskDouqqQgAu{B}dAwdAo|Bm[gkF?sy@pLex@hT_w@`H{v@u\\k{Aq`Bur@ec@geAkRiaBssAu~E_|AciBocAuxE{tA{v@srB",
        "or_mDigcsQhpCeuDzqSq{Fr{Dg}Cbt@sfE",
        "k{ylDadxrQmeByjDuoAmvD",
        "i`dlDebhtQn{AioF``JefH~pBosE~gAowAjeByD~oDdw@v~@we@pb@}zFlu@{jBh{I{}KjRaVdfBur@ptBmErqPda@n`CdXjfC`fA~eAag@fjBq|Ez{AghBxgBufAn{AzBvv@r{BnaA~fBlnBob@vnB_gBzyBytE|z@eXdqApLzzBzBry@oYx^kf@nc@kRpsCt{@xx@cOfeHsqEpgEaeBtfNadCfpEyuB|tA{rE",
        "q|~kD}_|sQwbDgaK",
        "sdtkD{anqQxPsrB",
        "gffkD{n_qQanBq_A{pBo~Ei~@ur@wcCug@kXquA",
        "qa~gDawswQ|S}iAfsC{eI|tAanB",
        "}p~fDwxcwQcy@}{EsrCywB_cEa{@ckE}_@gfFnCguBcOgt@}~@",
        "{rxgDsrixQ`uAmcCtrFcbCxhA{vA",
        "mbvgD}wcxQmoAuyD",
        "i|ogDg`byQ~]gu@p{@k|@ncA}s@zu@u^jaCoN`{FpaAr~FlP`iPce@p`AcQnN_g@|A{l@lYmf@~dEq_AvmE|TnbLztCduDjh@zhElEnxKi~@nmBgu@za@afAbZ}tAptA_|Ar|Bag@dmBbe@ziBbdAptBvp@`dPaoCnw@{Br_A~Rf~AlyApaAzX`yBsUpgEyvC~qBwp@p_CbFdgF~{Az`CzMxiEmyAhs@yDtr@zBfu@}@`{@sUxbCi]dvBzj@roEp_CpqEri@plXpWnwBfV~qBbe@fiBt{@bhGjxFnbCtr@xuB~]riBxMt{@md@",
        "i_lgDartxQiEkbDob@}iAqk@ey@ma@mx@eCgkA",
        "kre_DkcfyQpv@}u@~kHaxCldBeX`{@|_@p`@bp@nc@xc@naCi@tr@xc@fhDjbFbEftA",
        "a}d_DafbyQiTi|B",
        "u`h~Cqy~xQkgAtg@c_F_HuG`g@",
        "{qq~Cyq|xQbc@djBru@xsFf`AboAr}A`\\nkB_JpjBug@z|EqtB~pBm[ziC~IboA}j@tHs}@",
        "suq}CosyxQjR}iAxy@{w@~wGwkElwBox@pWs^nY{kAld@i_@xmAcO~rApLxlAp`@j|@|j@|dFrbIxc@bcB",
        "sjq}C{iwxQ_JshA",
        "wdn|CuwzxQaFt{@c\\xy@i}@fqDokBvmCu^nnA",
        "msu|CuojxQpCnkBzl@`fA~zCfrCldAtqAhgBfu@vuEjrAxm@zj@~_@dn@hh@ld@tgA|KnlA|@tq@jRljGvlFdmAp`@drGxmAh|Ah~@xbAlyAlz@n_Cfk@nlC",
        "{h}zC}c|vQ}K`oA}eDbwDem@j{AudDn`O",
        "spi{C{}`vQ~Hh~@bmAjIpoHyDp`Bf_@nlAxdAp_B|qB~h@j]~h@|@vcD}_@pu@yX`|@mRtlF~IxwAsJzl@fVjQ~qBt|@bxA~fC`qAzgGlmBnaA`fAptB``G|~@xcB|nId{GlcAnaC|JbbC",
        "i~yxC{|mtQkp@h~@ewA|j@ueBtfAolBhdF",
        "a|dyCsdatQztCllCxlNztCrxGlnC`oChfBfeAnbBl`@joBtv@dX`aF{a@rjLrJ`nE_^|zDyaBhgDseFn`B}iAd|Blo@dr@tgBb@|gC",
        "i{ovCafnsQel@z|F",
        "ohqvCehfsQjVphCfpAtdCp|D|oFpaGvfLHTtfCrSzrWcc@hnYjyCjoCzBxo@mf@",
        "g{dtCggzrQtQ{_Bnj@om@`{@_^naAaS~}@sJriA}_@zkA}qBx}@{l@vcCwFdb@p~AfLd`CjaAf_Bt_Dkf@nyC{lM|`Fob@dn@za@ja@zl@bi@tg@nbAjR~gAwQrmBowAf_AcZ|sCvQjiCnlAlsb@~id@nvBifB|cBawFrwCqgF`q@{a@bx@oYnwB_^",
        "ksbtCgxerQsdAazNgA}rC",
        "q}jrCyulzQdNwFvrDug@z~DzjBraJnuPppFzoHxi@xlBb`@xwB|h@~fBts@vZjp@gj@`eB{u@rt@tHzzC~q@dpAzBfkMel@fq@jRdb@t\\fe@Svz@}iAdOcy@R_qCdx@_{D`f@wuFtbAq~Af~A{c@tzHwFxhBwn@p|JicGp\\ag@jb@mGvtArk@jh@fj@`bD|dH~bAfiAtwA~TtdIqvBnh@i|@",
        "gh}qCu|uxQ_m@giA}Zg_BoqAmmDie@kaGmyAcvEsn@{{Ro}@qgF_i@g`A",
        "c}grCmqxwQdNmvF~g@qrDtiDuwFbiA{hDzf@u|A",
        "y|arCuedwQaa@_gBelBkcEib@ihBwLauF",
        "sterCqagvQ`GcjFvjBenM~ByhF",
        "}pppCeizrQihBolA_^g_AeX_s@me@adCss@a{BmdH_`IolAwyBuh@sfCqGczAwU{tActAsrBmiG}zFkr@irAelNg_i@ajB_}M",
        "o_inColizQduAi}Ab}BkgAvvFyvAj{ByOtuBpLxpBtr@~^jq@zW~gA~a@pv@d~@i@rN}j@",
        "cxgnCixazQ_d@s}BkAqtB",
        "oijmCivrzQn_DowAftOzzHplEbFfl@apMb}@ehFrLwyB",
        "{cjmC{tkzQsDm`F",
        "mzjlCuwh{QrIqiBtvA_i@nwBce@rlByaBpp@_{B^{jB",
        "emjlCy`e{QgL{uB",
        "codlCich}Qv_AgjBbjF_{DbrA{iCdOisMhs@_|AzuAgKl~AhTfdBvFhhBis@n}Ge_F`nCiTbmBbmC",
        "qhvkCozr|Q{`@keAshBcdCa\\cy@yY_pB}t@ox@{aBar@uuAgiAuRkzB",
        "_}_lCoi`|QlEgu@~m@g}C|FwzApFeXfAqL",
        "m__lCa}x{Qq\\mkF",
        "s{}kCszl|Q~Ti_@brB}@~g@oNzb@om@~X}j@`Bur@",
        "yu}kCo`k|QyDcy@",
        "akyjCsqk~QaHn_EodD`tI",
        "sy~jCa|z}Qld@jfBzfApLtwGqb@~kBnN~aBxbA|lDlyCrnF~zBbi@hs@dSfkArZjeAzf@|~@zv@fw@z~CRbuTqeH~dC{M|qEr_Ar|B`Qr~@oNrhBu{@xaAaH`fAbZleAhs@v{JndKftB`wFlpApb@zk@aS|j@ec@nkAgKzlA`\\~{BjoB`eAzl@foHfkAlcBri@z|F`mEt{B|j@bcBeaBr}Ad~D~dC}gCvyBy}Gj{@{|Ffl@{`N",
        "mc`fCir|}Qh{BsbIbEwzA",
        "epzeCmkg}QuSiyEgrCivJiJgtA",
        "}u|eCqep~QfhCanQ~\\gu@`q@ap@pkBox@nc@m[t{@i|B",
        "_a|eCuqi~Q}S{rE",
        "etueC{gt_RzV{_BbvDozJtg@on@vp@cd@r_@on@",
        "{noeCeol_Rkp@_}@oxAu}@my@_{B",
        "wdseC{fp`RdlAewMjpAzm@htApB`pAga@z`AqaAdiE}}AhoF|_AldMfzEvmC|LrhB{Xf{E{iBb|IcdAleBg`ApsBc`FhIevOnbAsmFveAmzAnm@yn@pb@}Tnx@bO~Rdn@fK|}@r`@|_ApuArhA|gBzw@fiBve@dxA`R~fB}AphCoWz_Cql@vnAq`AjqAq_Cl~GotE~s@ayC",
        "cjkeCkhg`RsIcnAon@kq@u{BqBaq@qa@wP{uB",
        "cizcCov}gRhj@m`Fz`Bod@dqHmPf`Agu@tp@woA~qBekAf_Cem@`zAfL`fAsk@hhAxe@dvA~|@tpB|T|~A_]",
        "i`}aCm{tdR{Ko`DqvA}vHobAeuCg_Bg`BI?_@i@I?maCchG_mIchIu~Iq{FkcEwkFuzBciGsfD}{Qql@srBesEixHex@olAym@srAm\\ewA",
        "ollbCkeqcRpWq~Bzv@q_B|qCs{DfiB_^~{Aox@~s@uqA",
        "icxaCuxnbRi`@cbAqrCeiEco@quAqaAmaEup@oxA}jAwnAI?_@i@I?ykB{jAweAiiAce@q_BuGadC",
        "ew~aC{ikdRzu@qpH",
        "{l}aCimcdRiJylB_^wmC"
      ]
    },
    {
      "left": "LAO",
      "right": "MMR",
      "kind": "International boundary (verify)",
      "lines": [
        "iopbC{rlhRjoBgL~|AdX`f@dvAn~ShhZx}GhgQbZzuAxiE|pEht@ldA`zArdFvPllC",
        "os~`Cy|dfR}i@bxB_^nn@kS~r@iJzv@eBly@",
        "i`baC{mzeRjR`pA`q@hTlcAqBfjAjHjuV~dEjoP|bId`BfjAr~@ftBfv@twGbo@~qBbkD{kAbp@kHrh@|_@hiA|sBh^dXjeCpLz|Fxx@~zBfLnmAsrB",
        "mxn~Bi}ceRdc@otDle@?joCp~CdtArtBbg@nv@z`BtyDh~@biEdCtpC",
        "_}k~BwqrdRmzAqjP",
        "wz~}BsondRmeAxhG}rAz_P",
        "cuc~B}ducR|TztBloAptAxaBdx@hsAzkAxcAvuFjpAz`BrzDd`DzjCphDfkAf_A~fBxX`oAj]`yDpiClcBfl@jpA?`dDjoA`wEnbAnjPxmA`cExx@`eCpLbmBxYdvAj|@xmAveApuAbP|rAqB`jBkI"
      ]
    },
    {
      "left": "LAO",
      "right": "THA",
      "kind": "International boundary (verify)",
      "lines": [
        "aio{BwbfcRv{@mkFfbCi|BjeVodJ|gE{_Dvo@_]puAi_@nb@gVd^mo@lj@ihB|`@uS|s@om@|z@ueBta@ueB",
        "k}ozBopdbRIwnBmyA_~AurFzBaq@cy@sJkR}o@{iCeDga@sJgK}_F_gA{sCazB{uBuyDcp@waF",
        "ii_{Bss}aRbwErKtyBob@j`BitAvv@uoB",
        "o`bzBs~tdRz|@qLx`I_KtxFfl@f{L~yCN?pmKx`DtwEl\\vdBxW|~Av{@za@|t@xn@bxBt]vo@zv@|j@zlDbcAddBjoA~|DzuCtpBbZltAa\\pn@{e@tnAc`AbhAii@`aBiSfkEeNpjBcd@nmAkr@duCq~BzpAkq@xfBiTldB?`{AwQtjA{kAv`AylBbiA{rDjq@grD",
        "yn~yBwrqdRkVqm@{qA}_@mFk[",
        "{wuvB{avfR`Foc@",
        "ed|uBgi}eRqpAa{@s_Go}Gm~Gq|Fm|BekAm[}V_c@wz@eCs_@",
        "gwuvBgphgR|PuoDlo@}fCx_DqqGp|@mkDpLgsD",
        "ypuvBkfwfRmE{hP",
        "waqvBwdvhRdZsiBzj@sqAlp@wp@h}@k]fqA{VfwC}KdpDr_@jiChsAbd@jnCxsAdkCj}Eh}Ab~Fz`@`yDae@z[ah@xS}hBzWec@~r@}Tzb@fAn^jIpe@s@riOg~BpmJjRfrC{Mv_B_h@~kAihA~dFgpGjsD_fDzwDgt@dsFlhGbyAhj@xjEt{@n|At}@hfDbwCdoB`q@nwB~HduJg`@tiB`\\lhEj{ApdB~SnpB}`@dkC}qC~aBg`@|}Ap`@peBboAv|CvlDtYzu@pe@xlB~g@~i@j|@`PdjCcEtcApVrlA`rAvrEbpK`\\nXb~@rJhwBfl@rqDxtDh|Bf`@jkB_i@joBovAjaCeoChm@er@tmDkjKnrAu|@tg@vQloBfiBdl@|_@x~@pL`{EqA~i@_T||Bmp@tb@yc@pWel@h^ug@vu@_UtaBfMxiF~{AjoBdXbwB_T`hF{iBtvAkR`pAvn@nvBrgEr}@~pAhgDzkBvaDvoAbwCxaBhhCtcD|gB`dEf`Anm@f}BfVdtEuRvnAda@~s@f_C|`@dl@ve@rJhh@yN|j@_h@|KyDfL}@pL|@dLxDt]vy@jg@lf@jr@pLh~@qMf}BgKzoB`]ho@zK|yGnaCxiFhpEvbCduAfiCgA|hAmbBfg@y~Efp@spGvy@wwBjgAupBnvAweBrhBquA|TghB|hBuyDveA}qDlPoY",
        "}hlvBc|ehRkSanD{f@cvCmd@ufAie@gw@yOoaA",
        "qygvB}|eeRvxDi|Nvo@myA`{@{v@t}@{l@bOym@",
        "}o~uBapudRwEqkBonAsq@cmBceAo|AobCwFacD",
        "czpoBou_vRHi~@rcBkuIxS}qB",
        "m}tmByqetR{j@cbC{}@ufBy{AqiAadCug@ipEec@a`Bag@snAccAy^it@aQ_t@m[uxDco@igC}d@}dFsYcoAom@ow@ax@cFor@be@yjD~cG_T|s@{a@pLaVxOaXhIug@}@yvC_~@y|BigBa_BggCc~@yvCuaBuqN",
        "uomoB}usvRjC}t@vd@}}CdMe_Dz|AskJf{@ywAbn@st@|_@gu@pyC}bJ|TssAzQajJnPykBdb@_hBjp@cbBp{@u{AdgAi~@xnAii@t|@{u@hScdB",
        "k`moBc~ovRc@k]eMmxA",
        "et{nBk~myRnMcvClkAwxCvwBgsBfjOavHhuRyhGlwBkfAp`BirAbqIeeKhj@q_@r}@en@fhQmsGp|Dox@paAod@ly@wp@vReVt\\}a@xhFsuKftBs}AhnGykCpjBazA`f@eXjf@cPvzBwe@vo@yZprEuxDp~CouDjfN{h]tf@}sB|rDchHfjAiiAhpDkzBprDg_Bjr@qk@pa@ap@bx@iiBlf@ol@da@qVz{HgsChhAcQzjAeCfpHhU~tJ_Kv_HfWxjCl[|t[trKziC~]`pJkd@pkEwSlcA_Tz`Cu|@bcA}TfjAeCtfArJbmChi@zQhBjw@|HjfA}AlcOueCncAeCxbA`HzgFpuAfeGxaA`kGv[blCwEp~Bk^zlBoaAbxAylBlvDw}IftA_gBz`B_sAtfB{`A`oBur@vaEcy@f_Am[zw@kg@vo@yx@`{AgfD`g@aq@r|BmxBnb@yo@h\\ou@~_AexBti@kq@bvBecAjfC}SjuGlDvbDgVzsCu|@r}By`BnaBmcCzz@_lDpxGamXhIs~@~Ia`GpqDkvUrUwz@f`@mn@f]gFdQkCdm@dc@nc@bbAvq@naClaDduCf|ErJzgFsiAxaOwuFbbBmcApkAcnAhi@{kA|KcyA",
        "e}qnBe{~xRmF{l@cOa\\_YgUce@eY{oBaeBukAmwBw`@ihC",
        "gkdnBse`nRzGqsDfMm_Hh|@}qBnxAkg@rgBgVfjBcz@z~B}{DhTqVdXen@h{DsqCbiGixHbyAiyD",
        "ws`mBudzlRgf@e_Cei]ep\\}cBkaBc`@el@",
        "mevmBwhftRbZpLhCbBzDhCtA|@",
        "mpwlB{dxsRkg@elBmxAufAcxAqv@ug@_}@}{@k]wlJtr@{pBuHcrA_^ux@}t@gWoo@yLuZ}@}B",
        "{~hmBcdilR|dAwy@b_AosF`dCipF",
        "wd~kBmybkRydAebAovBqu@s~@aeBokBmcQ_{B}TezKcwCshGgv@_qB_r@{|AafB?af@",
        "oebmB}lxoRbmCgtBrgCghDteB_oEjh@icF|@guOz`BqgEhxFmnArvKrgBxx@|@zVowAxuC_`IlPgiC",
        "ozamBgrroR_JuyD",
        "y~|lBkkksRlZkoBxvBc`EbZ_gB",
        "_pukBegvqRol@?cyAvz@iqBzb@s~As`@ar@{tAsr@q|E}t@_~A{hEidF}|DkhJoaAme@ur@wzAseFywO_SaeB",
        "uz`lBuj~jR|tAwmC",
        "i_dkB}_ijR{LgLaq@qVem@_]wo@{WmyBkzB{tAgrEmpAkzBykBziCuXufAoh@srBst@ug@ccAm[aqAoN}}A?",
        "y~ikBgcfjRdDcOlZaGjf@_JnvBox@",
        "ejfkBe__jRyF_}AekAuqAsTm[_J}U",
        "}rfkBq`|iRvGs}A",
        "os|jBchwiRgMmf@}fCknBmPkHce@yD_I|_@{B|_AmQjg@st@ce@wZquA",
        "wv|jBsxuiRfBon@",
        "gkqiBsvfhReBiTga@mz@i`@q`@ipCqiBI?u{AoNec@__AqMirAwZgiAuq@wf@qgFs|B}rC_rB}}OgpTyXmmA",
        "qif_Bic}bSxOqhCbwAklGlmDmtGvuFanDdgH_~@p_Ih~@tbKvxChgCnYjgGhIfoBbe@zgAfjAnVdW~fCf}EfyAhbHhnAt{B`iCzu@hqBoc@p|@eaBpUg~B",
        "qte_B{bubS_Tm_G",
        "cep|AuxgcSnYsT~dCuShgDbD~HhVvoBfrDlgCvkDbcGd~FzuAfu@n}B~h@heCnWjkC^rfB_s@zX}gC`xCwwCvF_`@",
        "sko|Acg`cS{AyvBsUwxB",
        "sx}zAku_cSfEcZ~]eMrdA|@nXaHz|FyuDly@ymAJ?",
        "sj}zAid}bS_MapA",
        "q{ozAkmicSb_@ieDnqAlz@bxCvvFbvB~{@heE_fBviCln@|K|`@",
        "q{ozAmkicS?g@?U",
        "uzxyAcyccSgCdaB",
        "}~xyA}v`cSnExXld@~Jr}AyEpvAqk@``@}@rVbZ`RpuAdR`\\tqBbo@rlCj\\xkCuHpnBybA|z@iUb~Gno@z}D~Hj}KyxApwDdOhgDpjAf`GreEx_CrpCjm@vg@`|@~]jnCrt@bk@bZ|^f_A`]jdD`VhgAff@`q@npBptBnZzb@",
        "uuxvAkg|aSeCloAyhAxlBoD~|@",
        "ei{vAcktaSdc@|j@jcC|iAho@pk@zk@jpBxiAneI",
        "sxpvAyoaaSgBzuA"
      ]
    },
    {
      "left": "VNM",
      "right": "LAO",
      "kind": "International boundary (verify)",
      "lines": [
        "yxrgC}jinR~|@cd@jdEs}@fUmPbe@iu@lZiS|`@?|hAtSle@uH~|AyyAleAekBvoAwxAh|Bag@fiBowBhpDgwJfwKs~LbmBacEjr@my@daAkh@~yCk|@leAgj@j{A}~B|rAi{CxmAg~AdmAzu@`QxPvRpLpU|IfWxD`kF_hA~qBkkF|tActGnuCo_EleMetEl~Faz@rmJ~\\vmCgLllCu]p`Bug@|~@yl@jHoP",
        "ozgdCamnrRh{AkzBp|G}s@~wF`RxwBkS|iAgjA",
        "{vdcCcopqRgLyWoDmiI{MybAcwBy`EsgDykCegE}iAquNoNoaBylB",
        "s{tcCo~hsRrJg_@hqAkr@dcAgW~fAsJflLxDlvCsS~gCk}@lPcD`QiAvPhAvPbDvoB~{BfpGniFhqB~eCtsLfzG",
        "{cncC}ivrRmFekByvDcdMoWgb@",
        "k~|aCenasRdOquAtfAvFfyH`mEz~BdYz|GbDfhBrU`gAfkAjp@nrE|iAleBdvBtfAnYcp@",
        "yswaCmyvrRii@i}AiiA_|B}t@mxB",
        "yzu`CasrrRxCshCfa@i|Art@kpAzaAw{@|hA__@zw@lFh{B|u@j{@?t}@ce@rJsi@fAur@dc@}~@rgBaeAjEs@bnFyy@nlB}i@dw@a\\|i@w\\~Rkp@",
        "eou`Cg|nrRsJyuB",
        "{wq_CecosRh_As{CfhB}~AtxGclCbpKmaEbvDsrB|pEsqDhsAa{AvZuf@vZgaApM_pBnNs~@xXus@xx@}rAjSk|@h@_hA",
        "glq_CwglsRsJmzA",
        "o~|~BwoizR|T_j@paAg}AdWks@jHaz@pAylCjHoaAt|@_qDxZem@vo@oc@z_Cg`Ah^}T",
        "snq~BmlryR{b@ucFe|Hc_HyMo}E",
        "}pq~BocpyRhA}gA",
        "atf~BiusxR{Ci~@w[{v@cmAa{Aa]uq@{iCsjM_t@i|BeNi~@",
        "iyp~Bchj{RbPqw@`\\u|@bc@{v@dd@em@|}AqiAd_EccBt{AaqAp`@_s@|a@{`B~]yn@dm@q`@nkB_s@dm@em@dc@s}B",
        "ano~Bstb{R}@sj@cd@ykCeCaz@",
        "qdg~BuvoxRnOs}B",
        "gna}BchxwRaFyw@gWgkAs_@ybA_^ec@uq@fBmxBh~@cz@vFaqAk]oWwe@yEst@oXelA}iAi}Bsi@eXm{@hT{~BpLwcBgVs}Bss@ssB}_AadA_|@iUmdA",
        "_oc~BmmduRbZwdBhqDu_Jzu@cmDlGoaARga@",
        "ggb~Be{~tRyKgl@wTykAeDew@",
        "ipa~BeogvR~]quAjfA{jA|oEiqB`pAebA|`@mo@xXwp@zM}t@zAi~@",
        "sa{}Bwf{uRuh@g}C{A_J{bAg~Bwe@}j@kf@aRcO}_@",
        "_yv}B_|k|RpL{~BdvAssAjcEmz@vcB_gB~pCiaItpBibJzvAmyAdW`FhrCti@|gOvrKteB|gCzl@tzC",
        "muv}Bgmg|RqBwmC",
        "wzr}Bq~xvRHI^?xlAiaK|`AmxB`vFqpF~oB}gCzWaSnNmY~IocA",
        "mzr}Bq~xvRI?",
        "qfe|B{ix|RoYjbDgrBlyC",
        "iti|Baln|RxsFjcC?T|eFxdJdtBjh@dvBieE`{@c~F",
        "ybr{B}{g}Rdl@quA~zDknChcAycBtvAklFnbAwyApp@gVzeAaRdhA_I~v@dCxsAhi@pLlo@",
        "cpq{Bg}k|RuQu}Z",
        "c~xzBed{}RqAtr@",
        "u`yzBopy}R`e@~s@fqAzVf~BtHz}BmEzpAeX|cBgrE",
        "ellzBwnw~Rj|GejP~m@eE~aApa@hkC_HfuBisAntCsoFdaBen@zWjSdOptAbN~Tle@|@vu@mPxrBsJzjAuRpkA_J`uAfVpRvVhr@n}@~JtqA",
        "msgzByl~}Rir@cjGcxAqyGiKg{F",
        "_x}xBktk_SkStwD",
        "kl~xBu{e_SvPdvBt]`]xt@rJ~uAxx@`eBblCn_EvtIblCztBrrB`f@va@i_@bJwwDnd@ouBza@em@xw@s@tfBhJ~cE~}@fvAtzB``A`xChaCztCfa@puBjH|sAdSbmAhbAdaBbsAvoAzqAtr@hrNheEnaAzu@~Ddy@",
        "}y}vBmdq{RktD~pBqeA`yEubAhqA",
        "qygwBafd{Rjm@xrDxbAteGv@rgCj^r^xg@hi@d|Apl@he@vp@pQd_C",
        "a_svBor}|RoT|hBeiEraJkaAf}Co^js@atAlwAqlAlz@ys@~gAqLh|B",
        "sedwBcy}{RxZjpBznDhbH",
        "kg}vBoyhzRie@zuBiqCvjHoRtfA",
        "oscwBeoyyRzVby@~aBdc@jlAoNtdIazBxxAkgAvnBkbEjw@afApdBag@jjBaGpeBkSltAufAH?H]H?xhAbYhZhu@dMbbAzb@t}@~aAjg@joCxXh}@~SdwAlo@zAfB",
        "oktvB_tm}Rgz@djB}Krt@",
        "usvvBesh}RbPdw@n|@f_B~Tfu@~N~pC",
        "yqnuBg~~yRkVtR",
        "eiouBqj~yRnI`{Ajq@fsCjeAxlCl\\jcC`{@rhArqDlzBrcAd_Bd|Ad_Fp{@~qA~jB~r@p[i~@",
        "wuwtBsl_yR|JobB`tCuqA|j@s^j]}j@lmAg|C|}BaxD",
        "{rwtB}z{xR{AupB",
        "}xktB_tzyRz[q_C~fHwtTlcDsyFd{@i_Aj{BqUvnBUrs@{u@",
        "a}itBudryR?wFmt@mcCmEcbC",
        "qessBghf{Rv\\g|BL_AfaAcyA`pAwoA|hAo`Bdr@ovB|_@gjBvl@ccBlxAihB`aGqrDhx@cmArVmnB",
        "urqsBks`{R{q@{sD",
        "aozrBiwq|Rj\\qtBv{@sgBtgAgkAttHcvEr_AshAnkB}pEb`AmxAncDgiDj|@s|AxPi~@hHywBnT_}@`a@}_@hhB_hAzf@mo@nX_hAva@y~FveAeqFdH}tA",
        "y{yrBeuk|RgRcaE",
        "kqrqBu~a_S`m@idDxzCu|@b~@s`ArZmlB",
        "kvqqBewv~R_ZofJ",
        "mkjqBmuu_S`RaeB`nDsxHhs@mvC",
        "wliqBwpn_SeBwyBoZ}hB",
        "{vcqBwkn`SfVolA|yGupD~vA}fCrs@kh@nkA?tT?dgBdm@tGt}@",
        "_ubqBqlg`SoDqlAaR_hAiHsgA",
        "_eopBkox`S}UhhA",
        "}{opBafv`StHdkA`pBvyAjxD`qAfyIh~AzaG|_@zlDobAvdCapCfhCucEfjBykBvjAzBxqA`f@~`CeCppAmz@zsDsnH`k@yb@v_B}u@rc@sh@fR}`A",
        "yblnBcasaSdCc[zaAii@ldAuHztCjg@zeAeC|yA{`ArcAwdBnm@_qBjW{aB~Tem@bY{LxEmP",
        "{vjnBo}jaSwEg`A_PubDeSu]",
        "y`bnBu{jbSlGkdCzo@i|BnhAs~A`w@ce@zhDkq@be@}@r_@|K`WdMnMdD|Uw[bOafAfQoXv{EweBhj@_r@hx@elBro@is@xcAq`@lmC}Uh|@qVfk@ui@dmA{rC\\?bdDctAr^iO`zMhiAprEcdAntEgqFzdHo`DdtD{iC`fBox@jmFymAvbByx@bz@ekAfhC{dIf_C{iEfrCmbDlzN}uKvbCmbC",
        "e|wmBawbbS{b@cx@gk@qXqiCk[}x@{c@_o@uoB",
        "icxiB_|peStwRs~OzwYkm_@ldAsgCvGwyA",
        "icxiBa{peS?]",
        "q|ohByjsgSr^siAjr@gLdaAbEfkAeM|i@i_@fvAquAlc@gUnx@xCnbBtq@f`AdD~|Aqa@tjHs{D~lGukHpkBg_Adc@pBz`Ajg@`[xCjjEqhB|x@a]vz@{NR?|j@ov@jr@}hB|i@ywB`QqjBhi@koC",
        "qcghBkmigSgk@igAcxAwyA_s@yZ}t@eNyd@g_@{BcnA",
        "yeufBkqdiStfBqv@rhCWlds@qHlwC{a@jdCyw@nvCylCldAquB`p@}|BxEsrA|i@i~AveAyXrmI`\\jfAkH`vFovA`dD}_BhfB{iC",
        "qgpfBgd_iSg}CclD",
        "su{cB{y~jSxD}sClaDokBhzFmP~nEnYvOvFjStRxYnMnb@?vP{W",
        "cnecBuzkjSqAii@{W_}@ci@}w@uCkEen@sJco@i@kr@m[}fBqgDs_AceA_gBoX_yE_eC",
        "anhcBsgkjSzbAR`[uR",
        "iqgcBsmejSw[_yD",
        "ssecB{gikSphD{jAdlAcy@fuA{jBjpAcxCza@ug@j|@a\\nkCiThi@oNzk@ebAvHwoA",
        "{ldcBeafkS{Lsh@uSmf@eCsT",
        "knnbBqfdlSdYcsFrZezA|CkOzv@srB~sAyvBjoAst@fnIqaAxnAoc@lTqOro@ud@ncAelAbx@s~A|UqsAzLgvAdZ{`BfhBmaDd}G{fF~zBaoCtq@kmD",
        "qgnbBkq}kSyEetE",
        "skbaB_sunSj]w[tfAzL|JXfjBfFjfAw[vp@si@zv@mFzvAfjAdlAvzAliHdjDrgBh}Ahi@lyAjg@hmF~h@vnBpoGvpLzLts@",
        "o}~`B{ganS_SqtDguAozI{BayB",
        "cjw_BeymmSkHbx@cZxx@kQ~~@",
        "_ay_BgfhmSvOdlAzbAvcAbrIt{CbaCtG`{AufA`bE_wIzaA{_AbyAcZdbGm[xaBm[tvAa{@tlAigBduBkmFxcAmoAfbQuiI~m@{kA",
        "qct}As}wnSxEu]`kAga@H?hn@kRtWcZD{b@",
        "ibs}AyyunSsIoc@sUi^",
        "_at}Am}qnSt]k{B",
        "kbp}Ag~knS{W}j@_w@kf@mk@_~@i@{k@",
        "s`p}Ac~}nSxi@stAj{BwOlrCdBvnBwYjaA}sB",
        "eho}A}p|nSmWel@",
        "m{a}Ak}moSf[ylBbr@aSjTkG~nFqLvnB_i@pnAiiAxkEuuGj_BwyAvuAwg@f_Bq@rgHbn@he@vP|Jtg@",
        "{s`}A_qeoSqf@kkG",
        "ihw{Au{_pSa]j]iOxc@",
        "uvx{Aox}oSlt@bz@~x@|UlkEdMzuBpa@d|A|_Ahc@ve@p`AxwAdn@b[h|@}@voBox@~aAxDhcAbdA`Hf_B",
        "gsyzAiiooSw[djD",
        "_pzzAc~ioStHjdB`]xfBxr@xqDdI|sBpu@jz@xsAnDhbB_i@t{AjHtqAeXbdAaq@pt@}hArp@eaBlxG}vJlt@it@v`AvP|wB`{A~sF~cGxrAtp@v_BiTj`Bs}@zyA_^hnA`eAj{@wf@lq@}~@pz@mn@dwArJ"
      ]
    },
    {
      "left": "LSO",
      "right": "ZAF",
      "kind": "International boundary (verify)",
      "lines": [
        "lhmoDii{oDktHtvIodKfzFitAboAaaAluAa@j@mq@h}As_@naBq@zC_^`bE}a@tr@slHntDocAj{AmEbtG{vAz`Am_Gfl@uyB`e@kfBzw@owAhrA{kAfuB",
        "ffkmDkswmDhI~{AdtE|bJnY~zB~q@beZdn@z~BdjBlxBn_GfhDf_BbwBri@~|BvOtoC",
        "vifnD}fqkDqL`oCap@||B",
        "bkdnD}xhkD|EtmAz\\|pI",
        "|oenDix{jDkRzw@",
        "p|dnDm_zjDnlA~|@`zAhrAn~EnkDdc@~RhcGbtGbtGlkFvp@lYlo@}@xc@vFfMpv@?zhD",
        "nwgoDkjwiDu^leA{`Aby@a{@hiA}KptB",
        "|lboD}imiDzl@`zAtqAjq@xaBlf@h}Aby@z`AreD",
        "x`|vD_uxmDkxDipPolAm|KaoCmqKk~KuuUidCyuFqgGqhNw\\gkAsi@idD_^wfAst@_g@i|@xMewBncAyvApLqv@{Bqk@lPst@xmAwnB`zA{tCgBkdDmd@gjCaGaP_@uyDqsB_pDcnAi{CmdBi|BotDy`Cg`NemAmeAkfBh@o`BuHk|@aeB{_BbxAgtC~i@wWKmfC}@cbCel@qtBwbCybAkoDkq@_yDi~@wcDom@afAqv@is@wdAa\\myAdCeaBsJuoCsrBczA}Ucc@jRkgAhrAce@xZel@lEs~AyDce@xD_fCh~@inElmDi{ElcA}hBdn@ssAztAe`Az`B}iA`eAyfJt^wdAz|DyD~xF}u@`mE_}MnbOquA`vE}_@xkCwp@tqAmnAdc@wyB|@s}@dx@ew@teCqb@frC",
        "|cmoDkd~oDnC`zA",
        "npnoDit`iDsi@zfU",
        "zemoDmljhDhhB{l@lo@zaAt\\naBvp@~q@puATjq@lEr`@nM~R|LjRvEzl@HxXjI",
        "th}oD}lchD}@dXkGt\\",
        "j~|oDavahDvF|V`xCvwBjgApkAj]xlAzVdbBnx@w[leAemA~|@gu@lEvf@zXxx@hI~]",
        "jfmpDmhvgDsi@|i@",
        "v{kpDo}tgDri@hi@rrBiVza@aFpgFnlC~_KzdJ|Tdl@hT|~@|_@~}@pv@th@`{@dBjpCaf@hgAiInm@h}@vMlr@bhA`~Fnx@tfBjq@vQhpCfKdw@nNjgAv{@vZby@xOnx@`g@dw@fj@xMdc@eXve@yc@bp@aQlnA`Hld@nWdZjh@twFtbGn`B`dAloBnYlYr`@",
        "bu}rDmx{eDyDrqC",
        "ho}rDyeweDrUp`@tfAhKz`A~]pv@hh@tKtLvY|[rgBnjEbp@`dCr^tnDrt@vnBtSh~@vOlvD~|@joD`Sp`@tyDdiElPl[",
        "bawsDueidDkR~q@we@dOi_@jR",
        "tftsDcofdDh@j|@lYp`@xcBxn@bn@ri@",
        "jvysDwu`dDgiAxy@",
        "blwsD}z~cD?z`Avy@bn@vcBrA`zCxkAhTkq@h~@mxA`g@aqAp_AirArnFeuD`|Agt@R?",
        "fqqtDywidD`n`@ccOncJyjD`yBovBh{EujH||BcxAngHssAzvA_i@~fBelA~Ryx@",
        "fqqtDcwidD?U",
        "boxvDoiemDjIugB`eBqnHf@grE",
        "va_wDmztlDyn@kyColCinGiTkdB",
        "je|vDcb~eDfVq~A|h@yy@`}@dDtqAt|AneHpgC|qDsJpoIejCp`BjI`F{bA`@iCr]q{BjGs~@",
        "nu|vDuiweDcOolA?}iC",
        "r{}vDwlklDbe@ulH",
        "n`czDkckjDayBi@ccBnNmdBdC}|Byb@ey@kg@g_@_s@eXit@{c@wp@yw@aq@ce@iTuaH}hB_r@wF_}@`SylB~gAcp@pLgiAcp@miJ_rOssAsqA_fC}j@wmCvOqv@~gAyc@vzAssAncAgsBsLi}Ae_BcdAebCag@iqBgVwvDgVm{@md@gj@eaBolAce@ey@gtAy`BylD{hBevAat@i}AuzBsSouC",
        "v{~wDermfDh@mcBtg@ql@`xC{l@~}AebA~eAcaBbzAacF|dAaVd|@eSnjCmbDbwDouCpv@uSdw@gBdw@iI|s@kf@hzFy{JrkIopIjfB_{Dxy@uxEh]geG",
        "~q`xD{ahfDmE{j@yn@mcC",
        "dhxyD}``iDhTigAdc@_t@ri@ap@tg@mz@fu@u{Bzc@cbCnv@iaVzw@ouC",
        "~kzyDotxhD_Hu}@ar@ovBwFgu@"
      ]
    },
    {
      "left": "ZAF",
      "right": "BWA",
      "kind": "International boundary (verify)",
      "lines": [
        "~omfC_y_rDcO|qDocAttI",
        "j{jfCkpoqDbQlbDzkAlwBtqAbdBjf@bnBlf@jsVpUzw@jdDlaC`\\g@hs@p~AhsBzuBhoD|qCruLco@rhAl[rt@~|@ryF`oCboAvnB",
        "|ilfC}lcrD`e@|rB",
        "ln`hCi~moDw\\tlG",
        "tp_hCspeoDnElmCtqAj|@nvBza@naAvxA|_@j|B`SphCbmAhnGvlFbcMxbArzE",
        "pxuhCerumDUteDwOvyB",
        "bguhCwplmDtQvmBzjBjdCl[bcB",
        "bbzhCoxamD}}AjiK",
        "dcwhCcnulDp`@xbO`{@hnFdwBrdF|iAt|AtwFvaF|_@t|@dMbwClPxbApb@by@ffF~cElz@~]voAhKdkAiKlo@uQvp@f@jpAdn@lo@xw@rU|~@pLt}@pW~q@xc@nYr~Afa@be@dXxc@~{Ave@`oCjq@fsBxbA~IvdCst@ziCnYh|BzkA|}Ap`B~q@psAfw@fuBdl@bbC`QbwB`}@~gAvmCqAxgGar@`nDbcBdkCvvEvcB~cGzw@tlFhqBug@p`@xaB",
        "dgdlCi}uhDkGjeCsJdbA",
        "dsclCwsohD`p@nNno@aQfj@yZj]gK`QsKbZcZdX}J~Ij\\jG`G|a@dn@dBtHhoFj{Aby@dc@ri@lyA",
        "hswlCwxhhDyc@|rAioDpiD",
        "d~plCgz`hDhzD~vFxXtgA",
        "hswlCqyvgDyXrtAag@bxA}@vdA",
        "noulCaeogDlmD|u@bwBptBr~AbZnb@bDnb@pLdZtThIfVxObOhh@_Ivp@wPhh@aIdkCpb@joBj{AzkAh|Bnd@~eCjGtbGj]jpAj|@lz@tfA~q@be@j|@",
        "fx{mCknkfDij@zvAmyA{l@gKvp@",
        "ffwmCsrhfDt\\tzAfa@rjAdc@`Q~gAlz@fa@h~@",
        "ru}mCo~~eDy`E`eA",
        "xswmCmx|eDncAbyAjwEfrCvzAveBfiAblBbnB~nFnaAngFthAxcAbwBowAdXt}@h@dw@",
        "rdrnCo{|dDgVvp@wp@dl@",
        "r{onCq|ydDld@nNtr@nm@ri@dZ",
        "j_tnCkcwdDox@jq@yXtfA",
        "`lqnCiisdDhI|~@vp@bZzkAcZhh@ur@`g@ga@hiAxZ",
        "tpznCocsdD}j@zkA",
        "vdynCsvpdDbFbdAnm@`{@pjAvp@",
        "|e}nCumldDfkA~qBld@bc@nx@jR",
        "|e}nCuckdD?_i@",
        "bqboCecgdDqWti@aQ|i@",
        "nfaoCqmddD~zB_IdlBmf@vxA{Br_Ar~A",
        "`jmoCgccdDoCdjBocAno@gkAza@eXf`A",
        "r{goCmc{cDzl@j{@b`GbmBheEbxBzsB~^x{@qNhq@{KbiH|pDf~B}i@pgDzVb{r@fvLjuGhKlcPbwBdlBz`AtqAnbBxbAbbC`cDrfPpaAxbC~{Adv@jiJzyJfqF|uKz~BzhDr{D~{Cl{LxuDtfAzl@t~J|uK",
        "`bjuCgbd`DIfAkSzjC_H~oBeXzuBkIptB",
        "x`huCuvt_Dbe@fdHjiEn`U`pG~v\\fgCziEfl@h}A",
        "zw}uCwnn}C_J~_I",
        "zl}uCwmd}Cr_A`mEvFxn@t\\pb@bxC~GtgMq_AzzFdB|gE|`Ab|JbuDngFrJ~mHf|D|~KrhCf{a@laPrkXrfEvpCxaAtvQzqGpwJ`fC|{PbdXdiEr`MjzBdwg@",
        "jjfzCuyu|BuyBrSox@|a@}iAvuDk|@jfBcdA`g@maEhh@ap@zXwoAf`A}j@xXcn@R{a@wZce@gVyy@pLae@tg@_t@`pByc@jf@ug@fKmbDtJsi@bwBs_AfsBssAxy@sgB}u@wzAuH_fCzbAorFdhDs`KvbEwoAnaAe~QlfX{gGj|MwO|~@wFf`C{Mjz@}j@bdAclDhfDyhFrbI{hDptBgkAxlB}j@tg@aeB~]",
        "x}jyCauumCsS|_BobBz{Gwy@ttI",
        "|jeyCqa_mC~R`uHboAbhHxiErtMdl@lz@lf@dkA",
        "vul{Cyx_qCebAxuBwyBh}AayD|yGe{G`lFu^pv@md@r}Bi_@by@qv@~h@maC|~@yn@xy@q`Bl|IshAdmA_}@bn@}uMdsSyvAp|C{kAxuD_i@t}@mnA~pAadCr~Akq@pv@eXxxA",
        "lchyCsabnCpLtoA`dAxkEvF`nB",
        "nnqyCceykCi_@ve@i~@bZ_r@jh@kRdtC",
        "nhlyCudqkC~eA|rCn`FprFnv@da@rt@fMlo@xXjh@`fAza@puAve@f`Art@rt@zkArr@zqFbcBrhAzbAby@z}Cj|@~h@|aKt{Bf_B`p@~q@lP~s@zBj|@ec@naAmz@z`Aa\\v{@fw@lz@psAvp@xFfu@}VxbAuHbxApLr_AdOj|@bc@vhH`vG|~BhrArfCnd@puAqC~R{VhKyc@~|@}j@vxAwe@xe@kGfhBdbAh}A|}AxaBh|BtgBnaAjoBaoAxmAi_@njCqAhrCtQrgBj]xmApv@`g@j|@`{@rpDjq@paApv@gBt}@gVhgAdDvhJ|cGzL|Mnw@r{@xmAvyBjrAleAjwEteB`cD|sBlf@djB",
        "jzlzCmty|ByX~|@}~@nColAea@ks@{B",
        "v~ezC_xx|BrJh}A",
        "~ks|Cwco}Box@{BcwBoaAu}KvbCcnBj|@mo@p_AkgAp~C}~@`r@q_AR_fCgu@cdAzBod@lo@iI~gAiTr_AybAjRqk@s`@gkA}gCk|@we@kdDjq@uaFjwGmmDsJyaBwg@}hBkxDg`AjpA",
        "nckzCa}~|B|@zw@r^|u@hTxw@",
        "rtq{CsroqCu\\`Hst@q`@ar@xDap@d`Aec@~~@gKhgA",
        "vlj{Cy{iqC~gA~aI",
        "rcf|CwozsCyn@pyH_pDpfGupMnnLaoCnsG",
        "`al{CsirrC|@bgIp~CdhS`QtdC",
        "n{f|CkptxC}h@rdGwoAn|Gec@|oF",
        "r|a|Ci|{wCh_@hoF~zBpzGv`G`sJbn@~zBxxAvsJ~Rf|D",
        "xrr|CekpuCel@|{EykEviIg~CdyMs{AvrG",
        "||b|CqugtCdMt{Blo@h|B`g@xjD",
        "rws|CknjvCih@jmD_i@xkE",
        "hdq|Ces~uCnm@~fM",
        "thccDgdh}Bs}@t^ieE|~@ocAj|@wy@h}Ai_@nb@cn@ve@okDpuAaaFh~@gfFfa@_{D|@wfLigCaoCiImyA`\\maCjdBgkAxe@q~CtQ{sDuQqmIwoAgkAcZkzBwwDccBquAivHwwD{yKchJy}EknCspFsrBgwI_mG}_B_UgvJniFqtBhTs`MeMi|Ofu@asJpgDgVh@_hAvdAgBdc@",
        "ltq|Ckvs}Bb\\~|@lYrsA",
        "rz~~Cw~nhCqv@pzG",
        "`c}~CecfhC|_@heEteBrhCpzGdrEf{GfeItfAnuCt\\n`Bzl@x}Gnd@dw@~zB|`AdhFzzFb_FnvBnnN|gElhItlFn|GfzHbkEzmJftAtiKzBp}Qr^~cErt@teD|`AfiAn`BvFjwGew@vwBmEjqBxXlmBbdAbcBrrB`xE~`J`p@llC",
        "jc~bDkn|_CifDnxXykChzFccBlhG",
        "bkqbDcpr~Btg@z{IzkAl`DxuDjbHpgD`rKdvAtdClPlP",
        "bu}bDmjfcC}@lcCwxAlrJiKzsOi|BnrHgVvmC",
        "pxubDm{waCjGd}G|~BnkOdBxvA",
        "`dzbD}x{`C_S`nD",
        "`pybD{iv`Ch@bxAxkCp_PdDx`E"
      ]
    },
    {
      "left": "ZAF",
      "right": "ZWE",
      "kind": "International boundary (verify)",
      "lines": [
        "r{bfCqxctDiiAtpB",
        "hq`fC{f`tDlPf~BxaBzfF",
        "pmagCce`wDwFxlBkeAztCmxBfqDec@vzAuS~xD_SfMyZjGovBzuBu\\|~@m[jeCgVj|@eaBniDqW`zAuQl`FsjAlxCsi@ntEm`F~iJea@f~B",
        "bmafCahstD~RndLnY~hA",
        "pedfCw_usDkRfrE",
        "drcfColnsDfXnvBhfBft@~|@zaA",
        "vpifC{|fsDyMtzCmeArwH",
        "n{ffCqhxrDbZx`CzuBtcFdbAjeC",
        "tpmfCu{hrD{Bj{AmGjf@mY~i@",
        "ntigCwxv|DaSdkByvAxtEgtCxgTae@rvJ{l@nuD",
        "l__gCy_f{DdkAxjEtr@~vTdc@vyBvnB|fDnYt|A",
        "pekgCsxcxDmo@xtEq_CjcE}gAzvAst@~{A}_@|sB_JjyC",
        "`j`gCgzhwDnb@btG",
        "zuegCacryD}j@~sK",
        "|idgCaneyDzBfuBj]bwBvcBniFpb@xuBhh@z|FvFzfF",
        "pcogCs}p}DwQlq@cy@n`BiKzk@s^|j@knC|}Bye@dbA",
        "ptegCwnc}D|K~{A~{AjnEvHxm@fKxy@",
        "vmhgCs{}yD}K|i@_}@f~AgMnx@",
        "ptegC}wwyDh@zsD",
        "jnugCwb~}D}eErpCen@j}@qA~|@",
        "tumgCwtu}D`g@vcBxDjq@"
      ]
    },
    {
      "left": "ZWE",
      "right": "ZMB",
      "kind": "International boundary (verify)",
      "lines": [
        "|{n~AqmdvDw\\tlGmlCxvOeXvtG",
        "pwh~AirbuDj]`oC|qBl_Gjh@~lGfsBzdJtSvvC",
        "dgp~AezjwDeX~gA}hBd_D}s@twF",
        "boj~Aix{vDnb@ryFdbAtwFbe@lvF",
        "tbp~AimbxDurA`fEii@tcBiTp|C",
        "jok~A_dtwD`S|u@xmAh}Ar^`p@hTnbB",
        "|{l~AswoxD|_BjvFxD|qD",
        "d{r~Aev}sDwQf_Ci_@lxBwOjdC",
        "jwp~AcwqsD~f@psCz~DpgFdbAbnBnm@~zO~Rh}AfgRbbj@x_F|{Enb@xw@j]||BjgAbyBftAbcBxbAj|@nrF`dChiAlnAbZxvCdD|yGzVheCjKtZrg@pyAheEfpE~dDtfCfj@jR|~BztAbdAjRxw@{K|j@m[za@a\\r^oNpsEza@rbGvoAjxFp`@fqDqiBrmIdtC~eC~TzjBgVrdGkfBbmCi@~mFdvC~q@pWbaFhh@z_BftAzsDlvFpiB~q@~qBjzBnm@ht@pLzvA?jnD|s@lgH`|Y||eA|eGleLnlNfgRnkFhwPtpKdd]jzD|aIrbGlvFbpe@tqYtxE`eBvoNf~BpyH|hD|cIjjItoPx}R~sr@fwr@`zAh~@~~@hI~yCwFhrCoN~vF|pEtxEzgFpiDtxDbxAzhDxXt|A|KpeHzXp`AtoC~cF",
        "b{{kByfuyCmGt{@yw@vyBwmCp}Dis@zsBsi@hj@",
        "bvzlBqtn}CuHlhGejDn{JigAh~@aeBzl@exAmG{a@wcBejBdvAsrB|yG{_Bv{@g`Afu@qlAh|Bg`AfiCkz@xhFg`AfkAwp@`oA",
        "txukBy{v{CnNlwCziCjjIdmAzbLdMxc@nx@|u@pLnb@",
        "~g~kBy{czCsJdbAuhAtmE",
        "tr{kB}i{yClGbbE",
        "nv_lB{tvzCcFlf@i_@vy@aFh_@",
        "~g~kBkrrzC?puM",
        "`cnlBkut_DiIdl@od@jf@{a@`r@oYlz@g_@l~GaSzw@we@|_@cy@nb@is@pk@_Unx@",
        "jvclBoo~~CxZpv@tcDd}Ev\\pv@lYtoCfw@hhBlYnkBfMnd@zVlElnAgKpWxDzVxvAfB|sBhTnbBfkAld@",
        "tchmB_z}aDoNlxAylBhbJwp@vcBkeApuAugBz_Bq_A`qAag@~fBwZhdDonAjcG{zFp_Nis@x}G",
        "namlB}}{_Dp`@pgF",
        "plvlBo`}}Cij@ri@",
        "faulB{u{}CdjD|wItHjgA",
        "daylBeggcDom@psC",
        "trwlBsrbcDhcGblQlPxvCpWvcBbn@jpAf}C|qDhTriA"
      ]
    },
    {
      "left": "CAF",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "ozx_@k_|zCdMapB",
        "ilr_@}itzCa{@axCyNiiAgnBjq@aRmcA",
        "gxx_@{ic{C~mAmo@zpAuSpu@_r@",
        "ilx_@mp_{C}JuqA?we@",
        "kgu_@m}ozCtHmQjbAoaA~Lqv@",
        "ewn_@opbzCc_@ufCcxCiwG}U}K",
        "wbr_@enk{CbUjR|UbOrUvQhTr^ze@?v_AcxA",
        "y`r_@_bg{C}@ekC",
        "ixp_@ab_zCb`AmmB",
        "gtp]{wqxCqWgnKid@shAwt@ox@yX{pGaXq~Ai}@ox@o}@{XuyCyDmdAkRsiBowAkf@_Sc`AaHuzBea@{l@nCch@zl@iUjzBoX|j@whC|h@}hB}s@auAmnAulAkh@upCiIc}Bwe@wyAemA_h@q_CulBboAef@}j@c\\uzA_mAs_A",
        "{bn_@axp{CzNqb@vt@{l@|JwZ|EkGpf@{iCx~@gvA~~DclDtr@mcApe@cxA",
        "cbl_@mqk{CwJyn@me@si@qMekA",
        "ccd_@uyi|Clf@gvAvwCyM",
        "wh__@mze|CmE}tAyrAwy@gf@fiA{Wyw@",
        "_cb_@gon~Cfk@cxA|hAkh@zm@ug@",
        "}b~^abk~CuRsk@ck@ea@g_Ak]",
        "ui__@qkf~CtR_^rJu^bEce@h@up@",
        "axx^evg~Caq@|Tq~CtS",
        "ui__@m|p|CltA~Rby@mP`k@u\\d{Bqk@",
        "}b~^w_m|CuIw\\cOebA}JwZ",
        "}b~^gz{~Cz~Dqv@lt@_g@",
        "kq{^idy~C}y@qaAsUkR",
        "}b~^aov~Cj\\wZtXag@nYmP",
        "}}|^mzs~C_d@ssA",
        "}_|^qso}CpM{vAbe@qaA~{B{jB|x@kpA",
        "sbv^g`m}CalBh@o{@yZwRyw@",
        "ubz^ouw|CxCaoCxsAwdAnqBwy@l}AwnB",
        "{qu^cds|Cg`@i~@ygAk|@we@uS",
        "_yy^eed~CvEqv@dYmx@",
        "wsv^wja~CqCi_@efAwOoXkh@",
        "smw^sha_Dr_@dBhbBeB",
        "smv^yy~~C__@ymA",
        "slw^_`j}C~h@g_B",
        "cxp^yuc}Cw}BkIgfA_qAoMylB",
        "ygw^oyfdD|QwiG~{Aa`Gj|F{`Odg@koCnN_fCzWelB|z@quAngAwoAx~@cwAhS}t@rJk|@xEovBpLcdAry@gvAdLkz@n}@kdD",
        "u{v]en~bDoY{a@ogAwfAqu@ea@gtCc{@ms@u\\ghEuxDwxCwmDs|B_{DwsBo~EorAw_H",
        "mtv^wa_~CT_hA",
        "itt^gkz}C{p@g`AgMgtA",
        "itt^qhe_DhmByl@xqAsrBpq@ywBl[q~C",
        "uis^sha_DqKm[cQafA}Jm[",
        "}zm^w_mvBrhB}dFnMogUfLox@|y@i|Bbf@{|DjcCg{G|y@evAfuAkgA`sAyp@vuDmkB~_Bk]xrA{`Ajw@axClsBshP`fBghDb}BgrCteCieEx~Ca}K`lAovBl|Ie{GrcBoxBtx@upBt_BgdHdOy`Ctk@ueBdfBi}An`EwyBxfHigCll@ur@xm@ghB~pBwyBhlCmdBn_Cih@ryAxc@xgBh~@xvB~]zeC}~@rXmZzyQkcSnrA{~B|_@wmC",
        "gui^e|~uBqLq_Cg_B_dE{V_}B",
        "ktl^kla`Db_Bmz@hcAmwAtv@i}Alz@emAdnFqtBzf@gKzMemAd|@ejDjH{jB",
        "ybj^}}{_Dw[_i@ys@mcC",
        "wql^gyv_DbD}hBxhAwy@",
        "edl^kbs_DqL{uB",
        "ybj^}eruBpLguK",
        "cbe]{{`tBqW}fBc`D{uByaDi}Awt@gl@keCscHmxIamP}vDybCyrAk{A{a@ykC",
        "kmg^i|{sCtbA}_@`xDk|@vt@ga@nc@{tA",
        "wza]k|_sC?we@oc@_t@um@sJ}x@SegAuSupD_hAmOsJer@i~@ix@}_Ma}@mmBktAemAakA~Io_@tzCwz@dbA_fCkh@upCuzAgyAquA",
        "opd^sghtCz^scCrH{f@vsAkdDjvAwwBbo@qb@dvBgu@dm@ce@hY_}@|Vs|C~]ymAry@qv@~{BTrgAga@dr@}iAf{@awDx}@quA~kBhrAv_A~Rj^i~@`j@_}K",
        "kv|]wrbtCuq@oPguArAkeAsUyi@knC",
        "}~a^mpebDfLexA~Xgj@joGw`G|`@ug@",
        "{z}]{puaDy^s}@icAgtA}^g`A?miH",
        "{h_^w~iaDzMejBzdAwp@",
        "we{]cbdaD{zA_hAgf@srB",
        "uz~]g|raDx^ssA",
        "ct|]u{naD?we@_aAod@qCis@",
        "ct|]owbaDjm@si@",
        "ipx]ysz`DgL}s@o^uqA_i@mnAal@sk@",
        "u~y]cwwbDzLsi@p]ga@t]iTdMyDtHanB",
        "kew]i_sbDwE{l@aaAg`AoOug@",
        "oes]abkxCfCebAzVom@d]ij@|Uyw@",
        "_df]wt`xC{Mgu@s}Bqb@m|Bg`AkYcZeRew@oi@om@o}@mo@",
        "g{m]oykwCj`A{fFvtBetEb_Ae}E",
        "qec]aetvCyn@a{BckCaaFg\\cmCmQ}_@yqAsrB}Uel@ImeA",
        "i~g]ak{rCjk@ueBdvCsi@",
        "gp|\\yilrCm_@i~@kbFanDajA{sBe^_}B",
        "iee]k|wsBdBo~G",
        "wwqYamvpB}F_}BoXq}BicB_cHipCohEglE}rCyuWm_I_tEcvC{iDetEyuD_fAkHgMgVcZwj@ywBiUcZoiJctEo|AupBgeAylB}xAssAenFar@kr@qk@og@qv@qv@is@g{@k]kbE{u@sqCmeAapBcxAsiCmqCyv@_z@og@ghB",
        "_vd]{pnvC~N_r@hYox@bEufA",
        "{s_]cofvCgGwdAow@qaAegAmcAeX_t@",
        "wza]yddvCzeAiiA",
        "mm_]ie}uCwFewBqdAifB",
        "cp`]utcrC~XufAbsAywBvPssA",
        "mas\\oejqCccAcnBgtCw~HkdCo~Ce}@gjBwPqtB",
        "siv\\_cfqCfLod@|yA_|A",
        "q}k\\cldqCsoAxD_}@`\\}dAqAc}@uSme@cZ}Qkf@",
        "qko\\ojdkCbEolAfp@ur@hgD{`ArbCocAn{AoW`qAwe@za@}iAfK_sAh_@olArn@ufA~w@ebAxy@shC",
        "yol\\qm}jCuXshA}d@kgAc[}iA",
        "awm\\wlwpCxw@ohGT{tC",
        "sak\\cfrpC}Pmx@qv@s_A}Jqk@",
        "gfm\\_yxjC`Rcy@jBmyA",
        "kdw[msnjCkjDufAchBshC{|@sr@qeAzu@whAvZqkAeB_mAyc@w_Aa{@{Ben@",
        "yol\\eujpCzFigAl`@wyBzC{l@",
        "us_[wc|mCeSkq@ql@k]kl@yDqu@R{fA}IymBqk@goAydAwo@sgBmO_qCeh@mmBakH{xJmz@keC}dAm~G{hCqpFye@_}Bib@sxGks@giCuiDioFsc@upB",
        "el|[ucllCfoAs|A`xEuzC|j@gkArTiTviBmkDjmDkpA`Rur@rZshCnNwZhT{MzfAcdAnNiTxDmxBdS_pBjf@{jBn}@gjB",
        "yfw[gr~kC{WaxCokCkwG",
        "o}z[_udjCvd@}}Av_AcwBrQkfB",
        "upjZwtgiC}JadCij@quAi|@{a@}`A}KgsCTg`@kRm~@ssAc`@kRaf@qLolBw{@sj@oNgz@jGw}Bnd@yhAf@uv@cxAw`AybAimAgu@c~Amo@_tEmeA}yAa{@md@ihB",
        "qx_[cpxmCzCsrB",
        "m}~Zi`wmCcZyn@",
        "kyjZqa_iCtGerG",
        "okeXmbcgC}d@aiVqVox@uq@azBaNoc@_{C{{EujBcnBa`Bmo@m[qWmbBiqB_}@qb@wu@rAcbCld@geApAulIyuDcy@up@ySwfAis@giAobAyy@ycAwZym@nN}~BzjBuyB~]ojD|K_wCga@u`AwnB",
        "qxdZ_nk~BtyB}}PrzEuwQpRweBdl@_r@nyEewBtlAg~@`r@owChd@qjAdfBkq@`Rom@vEi|BtRi~@ff@el@t^wp@",
        "yg|Ym`w|BqpA}sO?woNiT{tCkq@}}A_y@_hAwk@gtAwOysF",
        "w`uY}ekpBjHywBpfAqrB`WwyB",
        "mafT}}tpBunl@toEyeWa{BklEdD_mA|@{jCiKcuEmaCykC}j@evCgValKwFwnOpuAusFjpA{|Kn~EevB|_@sbAbe@{pCxjDqiBvp@cgCk]kcD_|AisBwyB",
        "sjmYc{|`CtR}`Afk@ih@bk@k]z}DujHdm@kfBxg@wmCtHewB",
        "ieeYiwm`CoDemAs`@ew@qo@_i@ar@ga@eh@ae@eb@yn@oXen@kNwy@iDkpA",
        "{~eYmvccC`SmkF",
        "a`|XmtmbCwtHawQaH}hB",
        "s{eYkwqcC~IyxApo@mcCpWu\\|ZmPfV_^tHcdA",
        "yjeY{bkcCyOosE",
        "kraYw}bdCvFqv@fu@upBjgAquAh~@yaBhZetCfVkkJ",
        "sjaY{h}cCwF{sD",
        "sjaYkm~aCnOwoApe@cy@~i@om@z\\{l@zKybA^kzBv[s_A",
        "__aYw~uaCsJsmG",
        "a`|XgdheCdMom@zoAalDz|@ocCp{@o{Hhi@mxBrZi_@~vBgsBff@}~@pt@wmChxAykC~eCcwQ",
        "czyX}a~dCgVmaCoTmz@qMoYaGs^qAiiA"
      ]
    },
    {
      "left": "RWA",
      "right": "TZA",
      "kind": "International boundary (verify)",
      "lines": [
        "rxaFij_yDyc@zu@od@jImd@yOob@qV{c@gLgtAtSs}@`zAebAtSmeAwRmcAco@yr@qp@",
        "jcxHi``{D{kAz`BykC`{@y_Fv{@yn@vZsqAplAgiChfBkpAbd@ec@g`@shAkRyaDsJmbDpb@shAlxBmPtyBaxCx{K}a@lx@cxAt|Aom@z`AgkAbwDu{@voAccBp`@om@mEyc@{McZeMkReEar@rKqjAby@g~Bxc@s{DtpBazAbe@o`DpWwe@nYqv@xkA",
        "xs`Fs~byDbFzX|Ttg@vFvp@",
        "bhiKu{a{DujJkqAkdDvQu\\hzDkq@_^ug@ce@onAmdBwnBxn@g_Beb@s|As~@}hBga@syFvp@}`A|TyjDufAox@nNgtApv@i_@dMcbA}@{kNwoA{_DcDmcCnl@",
        "njvH{td{Dzw@psC",
        "x`pMuqvzDoNyw@yXgl@iTevAqv@q_Bom@}gByy@mpA{sBq_Ag~BoYsjLnYerGgu@uvTcvEqtDhs@kyAzaAs~Af~Aew@voB",
        "|nhKspe{DdX|sB",
        "l~iMguhzDfTebAz_DeeIfKar@",
        "lksMwzzyDcFyaCwy@aeA_gDexAew@ufA}IwoA",
        "zsqManryDxOadCve@sfC",
        "|zsMgunyDafAywB"
      ]
    },
    { "left": "UGA", "right": "TZA", "kind": "International boundary (verify)", "lines": ["vjoEuo~xDsFgF"] },
    {
      "left": "TZA",
      "right": "BDI",
      "kind": "International boundary (verify)",
      "lines": [
        "|zsMgunyDhcG~mElcCtrAx_Q`lFheE~q@z`AbZdmAb{@llCdtCnlA`r@vxCdWdbAmdAh@mxB",
        "vmdO_mhyDduBjg@fxJlfJ~pAlq@|_BhSz}CfAbwDhgCziCtfAzjBqLdiEi{CbxA}}A~]upBncAl[vp@ec@pt@gu@vlAkYjAW",
        "`tjOuyxxDij@wbCaeBe_F}s@knC",
        "teuPaskyDlGuq@zqF_uKza@uqA`QcZbe@cO`eBoPbZwObQkrA",
        "b|}PywayDeMa]qiDuzBk|@iiAi_@evA",
        "nacQa|gzDl[{kAr|AanCpWkqA",
        "jodQioazDeOe`AqWk}@cDelA",
        "xudQi`_{Dh@_qCliAth@l`@vQx}El`EnbBhh@vzA_^toCuxCpuAu|@|_@_@hrAt\\dc@dDbn@gUlz@cpApk@yXxmAmEdmA|IdtChu@||BnwAzl@gBbnByZdc@eB|fDh}AteBnuCjRllD",
        "btgQkjqzD}K}pCkpA_cH",
        "dkbSomtzD_qAjdD",
        "dy_SchozDfiA`Rdw@~f@fa@`|@tHzkAr_AziDftAzhCxlBztBfiC~qBvVqj@xeBs{DteD`Gz}C`cDhgCfdHz_BjpAhj@vp@nN|i@be@jeDnNtHfu@rIpLxEtHnvB",
        "v`mTguayDsJfBi@fK",
        "xslTweayDnN~fBjRbOthAfVdXnNr{BbmD|iAz`@h|ByMjqBfAfsBxm@~sKv`GloB|j@rCFbsBxEhhBmYf_Bqb@p`BkRxlBhT",
        "d|bV}{lxDczAvuG",
        "`a`VeedxDxcB||Ct}KhoFznIbgI|~B|iAdaMnkBjiFh`Bnf@jOf|FrqChdFr{D~`JthL~{Ar_Ab|Jp~ClbBvmAdmAziC~q@h~@lxBnuE|pEb_FtzC~jIvQ|u@",
        "peuYazbuDmPrgBga@xbAkGpaA",
        "nisYak{tD~|@ldB|TfJ`eBfLrt@h_@vp@piBxc@lf@nwAfVvoAfBleA~Qnv@`gA",
        "zvfZgentD}Il[aSb~FigAnrH",
        "pocZev{sDtQ`vl@"
      ]
    },
    {
      "left": "BDI",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "lkrOaabpDdvCuqAbOh~BlcAlnAriB~h@`dC|JhhBaq@|_@_qBfKyaChh@u|Avp@wZhfDox@hgC_|A~|@{XvcBuHbcBug@jq@s~Abe@iqBh~@_}AnbBoc@d`CoWvnBst@xn@ewBpLsrBtg@qiBnaAquAj{Ayx@`gJej@`h@}CvfAl[pk@vnAfhBzm@r}BhTr_LmPbyBij@ftAqiBlZv\\vcC~nChrAbZxuD|Kvrp@srBhiN|JbgGje@deM|`A~_V}s@teDmz@jeCi~Av~FalFxjS}`KxuQklDnvBsa@den@kcE"
      ]
    },
    {
      "left": "RWA",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "ldnG_}osDdvAntFprDhxFd_FbvEt|DjwBb`@`TpL|K`HzLzBnNjRt|Mjh@daB~{AjgAt_JdjD`qAf~@|xFtlHnmBpjA|xFxbC`_G`_DbtJhhFdrGptBn~E~]tcFqLdt]_eDx_F}K|cGdc@zfHdaBnrFh{CzhDbvErhA`uG",
        "|m{LgbepDyDzrD",
        "bh{Lkn_pDvQ~s@`{@f_Afu@lFdbAhT`|Adn@~oBhgAlyAxwA|~@dkBbe@naCby@|fDrjAzvA`cDxm@tdCqK~zBgV`pBi~@fkA_Uz_BpkB`qApU`oAgVbe@qv@p`@aeAf`Ag_AjpC_i@h|M~h@vp@mo@lwCehF~_@krA~RuyDh~@e_CpiBi~A"
      ]
    },
    {
      "left": "SDN",
      "right": "ETH",
      "kind": "International boundary (verify)",
      "lines": [
        "{rnlAmti{Eme@q`BwyBqt@kuTwyBmwCh@e|AbZexF|pCqiCxDwiBigAazA_|A{zAgw@st@|@mt@`SubBvp@ovB~Goh_A}zQu{g@g_\\_pDox@u`J}Ts|BsU{pRmbGwqG}pBuvHlPcwHpkBmxCda@{}CrAadCyZ}dt@ipP",
        "e{rlAiw}zErKgkArSih@nYec@j]yw@dm@qiD",
        "qgn`AigqsEqGmcAyfBcoAinBmd@ujAUoiAyXkiBupBk}F{pIetCghB_uEyn@y|Afa@keCjxDqpA`{@scAoCsjd@w{KsaE}Va_ClnAcwBdlBqhDv{@efCcQapt@mrWazBgV}sBnNo}FnaCo_Cfl@o~FsJwkFbn@g}B{BssC}j@axCybAwnCgtAwwBs~AwyCqpFwr@ygCo}CwaL_oEq{D_|@}K}pBsB{[]yx@aQgu@ew@kcCyhFgiCcyBqsCgu@uuI_}@gpGcnBweAcn@_r@k|@ceAigCis@g`AssAox@cmAaQcmDyOumDoaAge{@uvc@i}@ew@uTst@_HwwBsUgu@qaAa}@}~@qU{aAaHo~Csi@i`@h@uRsUue@stA}BuG_s@e_DmjG}{y@}@}s@",
        "{xlaAi{_rEh]{kArpSksVvsBovDnfAsqAt}Amf@|zDdXfzAaHfWe`A",
        "erux@{l}nEu}MxVk_\\wbEmsbAedW_qIeoJ}oEolCcdAuHmwChTseAg@k`@mPk|@a{@kc@aSigG}s@yxGlEm~i@foHoaGvZm|Emo@unVayO{mMspFcbCyaBy{A{jBg`OepVuf@}hB",
        "u}n`Aa{nsEbUgkA",
        "q~d`Ae_esEaq@mq@a_EirAuaA{kAiIghB"
      ]
    },
    {
      "left": "SDS",
      "right": "ETH",
      "kind": "International boundary (verify)",
      "lines": [
        "iear@k`}lEsIybAmGcZu|EabGwj@g`A_j@ccBa[sgBwWmuEg@k`Ju^gsBakA{~BmfPqhRcnCe`CqmCwoAyiCoXm{Cw[_ow@zxA_ow@xxAevo@nlA",
        "_gvr@_~nkEvz@ghBtjAi}A|f@i}A",
        "wiqr@a_}jEqp@edL}_@wy@mUsA{m@za@mDg~B",
        "wbtr@soalEjS}}BvbDkbExtEwyBhjDovCdc@e{G",
        "swpr@{cxkEuS{uB{p@ywAqc@a{A",
        "q~rr@qt}iEftC{eT",
        "sdon@i|ciE}JhrAa|@fiCwQfhDuRzj@me@rUcx@`Rus@fW}~@zjBe`B|s@i_Lr|CecAqVmxAuqA_IyCyx@yZk^w\\gj@i]mbCyZu}@s^gjBmnAwfJsaJcz@od@m~@u\\ys@}Ku^yXu]kzD{p@{jBy}@cmAkvAcp@{zBwOm`@jRu{@ftAw`@jRuvA}@e~@iIyw@gXsdAwn@yh@qv@kRoy@s_@{j@{oAwGwa@~rA}_@xw@wdAzl@om@|j@m{@|j@yhA~Rsm@gKwtBgu@akAgMsT~Ieg@dw@wRpLw`@oCii@_^k[cFshBRco@iIck@m[_h@{tAeRi}Auh@qm@ic@vQ{WxDs{CqrD{NylB",
        "_|qr@_nzjEfQapA",
        "iinr@m{rjEkRmz@kaA}tAaWym@{Ckq@",
        "orbn@sbpjEewAdzIwcB`pB_qBdaBarAf_BoN|s@_^xiEufAhqDkHrs@",
        "atrn@gmliE|k@niExMh_@tr@be@",
        "s_|m@{a|kEce@`eCmn@p`AupBpuAew@t{@k]j}@s_@rqBsj@zv@uf@pjB",
        "kqhn@qrfkExDn`Ddv@~lGxYpv@bdBvxC|@bnA",
        "ebvj@snioEowAdwBesEniDo~Ex}GwQ`g@}^nNifQfB}qEfj@yjDfjBksWvfWelBtyDyMf`AoNd`CeO~|@egFfzH{qGrdE_}AtrAk\\lz@ew@~cEcnBpiDyOz`A",
        "we}m@owhlEbe@rtK",
        "uro`@cpgvEs|Bzl@maE|oFsbHrsNalE`vGowBd`AuiJhu@ueDbxA_kUvxNciC`}@eqA|IscAsJkfA_SswAqL}dAjRomBteBybAt^ygAsAqeA}TmcC{`AofAjJ}mIdt@sxBvp@mcCpiBkkBfuBouB~fB_qHduBs|Jh{E_|B~]eoJnCcaD`g@{hLhxF}|B~s@cgJ~q@acJziCm{Fr_A_~Fr}@cZhj@wtApjAsqBj]ecA`e@swG`hL_i@piBsOhgCIxiG}VlmBe|@hgA}~Fti@oYvFy~@j[wd@nEeEqLog@ey@mPqLqyB`HelBnY}}A~h@kqAfu@kwG`rKqqE|sZ}UjRaRti@_]fj@ekBt^od@h]izDx~FwnA~|@oc@ve@{Nno@u|@lo@clCnNkbA?obE?g_Cj]mmBjz@ar@htA",
        "cmxj@okpoElp@~fBnXzsB"
      ]
    },
    {
      "left": "CAF",
      "right": "TCD",
      "kind": "International boundary (verify)",
      "lines": [
        "qi_bAolthCuHvbC}}BbmC",
        "ercbAszkhCbu@zw@",
        "a|abAwajhCcEpjAa]lyA}PxaB",
        "ercbA}xahC~NhrA~h@lz@baC~qB~n@dkAj[~}AzYthDnBbU~c@tfChs@d`Cni@`oAxfB|sBjm@dbA",
        "kk~aAspdiCmKh~@yw@nvBeOtr@",
        "y`abAcf}hCxOpsCle@`dC",
        "ussaAs`pjCm`@fwIswBn{JkaCr|Cgz@ngFyDlz@",
        "eq~aAijkiCxDtxE",
        "iqqaAc{}fC}Ajq@kf@f_B",
        "s{raAohyfCvy@voA`vAdbArpCprD`cExbAxbC~rA",
        "k}aaAuvafCys@zjO",
        "ercaAyjqeCnr@nvB|tBvdAt_Chj@`uAtg@~aCu{@peAbbAx|AzzJzq@blBxaCd~D~eClnCpGfVxr@t\\",
        "ip_aAeijfC}yAtnD",
        "gkbaAoydfCzLxaB",
        "qqb`AqfmdC{LzbAe|@~zB",
        "s|d`AufgdCjFp_Ax^zuBlF`r@vRz`A`k@be@jk@j[zRdc@|Ft|Al[|hB`z@puAdaBbc@pyBrL|wDlx@fxBpLl~BqLnnFmx@jeBsLby@qU~{BylBtv@we@th@i@th@hIli@cDvk@om@v}Hd~DhbCpUtbAyDn{AcZdr@yDny@nYjR~|@|EvfA|T|s@jzB|iAx{Bjq@``BxmA|e@d_DlQr`@b}@|eE",
        "uqi}@ouubC{LxmA_YdkAmGlz@",
        "_bk}@a_obCxxBheEdaFvlDbbVpdI`|FjdDziEnjEnqAtxE",
        "}_j}@_nxbC{KfV",
        "ylj}@wvwbCbZf`A",
        "mhx{@{zfaCwP|rA_bBx~Fcu@puA",
        "is}{@qpy`CzfAxxAdoJj_IpuAdl@~`BvQrL`r@b~EpxInlB|~@zbFt|AhUbDjuAcDdXtH",
        "u~sz@oby_Ci@pUaFl[",
        "agtz@oow_ClEpWhhAboA~]pk@tRxl@",
        "sdpz@mlq_CsIrUq{@by@gMl[",
        "azrz@g_n_CxEpb@pMbObOlEjHvFrOfa@t\\~h@h`@nb@bZdOnvBjRfhDnwA`~A~RvrEdDfnAbe@b\\nwAli@?nYeZtRiIzpAkG",
        "_vry@sga_Cgj@z_B",
        "gaty@wf~~B|Ur`@`v@|Iju@l[flArfCrm@nx@jaA|VpzApt@ldGhoFlu@f`Ary@njCbhCrk@p|ChIzvBtg@rJxc@",
        "kbnx@sma~BmOzf@u@`CiYtg@{Lt\\",
        "u|ox@i{}}BpLhVry@xc@fLdXnXrhAz{@fa@zfAvZ|y@fu@",
        "anfx@chu}Bim@nm@",
        "k|gx@sys}Bhm@b{@ltArxG`_Cx~F|~FmpA?l_I",
        "k_yw@_`q|BgjAvdCqGxw@",
        "es{w@mak|Bp{@rUrnAxDvz@rUrd@dl@fLfkAjaA`pBrqCwg@brCq_AjaAdc@vt@z}Cf_CnwAdzCfkAjcCp}B",
        "k~xw@s|t|ByEzsB",
        "eeyw@wgq|BxDvF",
        "sxww@auy|ByCfj@}`@hhB",
        "k_yw@o`u|B^zB",
        "spsv@_m_zBw`@|hByiAfiAwiArt@{`@dn@",
        "yizv@_tvyBjRpt@bj@`Hzj@yDnTbF",
        "spsv@emszBkpBzkCem@tfA{Qp_A",
        "acyv@axjzB|ZvzApyBrpD|Zt|A",
        "ixwv@yfv{B}^rjA",
        "gxxv@e{s{BlFnaAr^lz@xrArrB|Tbe@xUduB",
        "}ivv@attyBqAzu@ab@htAwGrr@",
        "ixwv@gtnyBrV`r@xuClvDjb@lPza@uH~^qArXld@",
        "spsv@img{B_ZbcO",
        "sktv@eiwzB~Y~zB",
        "_jnv@c_fyBaG`g@q~A|TgWdn@",
        "{irv@}qbyBrIpWjYhTnb@xMdc@dDnr@tSvGbn@",
        "}`mv@gl~xBeEdw@",
        "cgmv@at|xBbGpm@fiBd_D|NveAtC|S",
        "c`iv@sisxByh@dxA",
        "}ijv@mppxBdlBxkA|`@nnA",
        "yzev@ctkxBw\\nkO",
        "qxfv@sg{wBzMnaChi@`cDdChgAbKhu@|~@bvCp[~]zWdw@",
        "op_v@m}zvBmmBjdD",
        "}~bv@axuvBpf@n}D`jAnvD",
        "kt~u@yswtBuSt{@ix@z`Agf@|iA",
        "sibv@ijqtB|@j|@jb@p_CfLb~Fr]nlAzfAt^tHdc@",
        "uy`v@ctfwBeCroG",
        "{}`v@oc~vBjl@`eB",
        "k{|u@uafuBoIfjBc[duB_h@piBio@vfA",
        "i{`v@}mytB|eAby@",
        "ki_v@o}quBs[nx@",
        "_f`v@_dpuB~wArnFrPtqA",
        "{e~u@_uvsBqq@lbD",
        "mx_v@qqqsBhdAhxFnuBfqFj`BdkCpqAtzApj@lf@tm@bOpVdX|e@`{B|t@n`BnIbp@rTnb@v_ApLpw@vQp[pk@r@nx@",
        "il_v@abjvBeCjnC",
        "op_v@urevBh_@lz@",
        "ep~u@gwcvB{Bfa@wPdXuIh_@",
        "op_v@o{`vBbF~|M",
        "{f}u@{{~sBkg@reD",
        "go~u@guysBjH~s@?fj@",
        "kbhu@ytjrBuWfu@",
        "a{hu@q~hrBjrE`oCzzASxsAugB",
        "ao~t@o~jrBfz@_i@xhBmPxqAk]xt@shA||HkjVxbByw@hx@eaBnkC}|DpnCs}BziCbkEt`Bj|@n`@vy@`f@ncAfsNd~FbdUroRrvBh~@bwCxw@nmBpuAvaEnjEbkKrdG~uBfgCvu@dlBt{B|mJfcClhGtyDpsEtrFr{BfnHpC`gG|qDpjBlyNtfAfotAphCreQvxDboNzj@bsF",
        "_w|t@ywgrBaw@ueB",
        "ywqo@m`_lBiItbGkoCbzYwEjoB",
        "gyvo@gqxjBvF~gCjf@bwBhpDd`C`|@bwBxc@bbCfVx_Ft\\||BthAveBllCpv@bo@ziA",
        "wzbo@wkriBewAffH",
        "}reo@odiiB~}A~pAlmAr}BxhH~iY`eAjdBbDhDzmAzpA`fAxe@rrBhT`[tg@",
        "c{_m@wxleB{w@ztAabF|gCk`GreFwoBjnCugA|rCkeAppFccAr_AshCbZ{kAgKi}@cZg`AiK{uAt^ew@`p@qW|u@eN`{@oYf`AqiAjdBu|AxbAiqBxZq}Ds`@ox@eBew@zB_s@~G",
        "qb`o@id_dBhhAxuFnw@blB~rAbcBh}@lf@vbDdkAdn@lf@fVrsA",
        "gdpn@qlicBkRf~@oZzw@g@dbA",
        "ktqn@gqccBxlA|}AbbCh_@vgLSnvAxX`r@fkAnlAhePhr@naClcDjwEfjAh|BlP~eC",
        "{jkn@og_hBkG~q@",
        "gskn@ot}gBlElo@tfB`pBdhG~yE~pBbwBdx@xxA",
        "wpzm@afkgBgB`g@{a@|_@ce@vdAih@jzB",
        "if~m@}{bgB|hA|tAnx@j[|s@mEl[jR",
        "oqwm@u|~fBi_@x~D",
        "yqxm@{|xfBxDdbAdd@rt@fjA|j@",
        "q{tm@cxsfBiKbwB",
        "{gum@_`pfBjh@jlG`eAprFrs@|}A`pAnaAj{Bxn@|i@yDxZcZj]iTjp@fK~H~T",
        "enmm@agxaBgAlnC",
        "mpmm@swsaBrgAzrEtr@flKpl@ziCnw@~fB`zAzvAd`E|gCxwAtzAh{BnjEpk@vnBr{D~sXdNd}E",
        "{udm@yazeBuHdbAI`Q",
        "{_em@qlweBfoBjfClJzLdXxl@zNvoC",
        "wwyl@un|}AoMjbFcdAvvE",
        "idol@uxd_BupAtnFyhHt`IsTfpG",
        "mu{l@avj~At|@jfM"
      ]
    },
    {
      "left": "GAB",
      "right": "CMR",
      "kind": "International boundary (verify)",
      "lines": [
        "aj|L}myfAuIf_BghB``IigBf~B}a@j|@kHdvA",
        "srdMyxcfAxPxmAxx@vaDj|@ncs@xw@rJjpAm[~qAiIzvAnd@z`Alo@jfAjf@jeB~IdmA?pkA~IhhAnWz`A`g@",
        "}m}Lk|qjA}U`pB_|BvkEa[plA",
        "}}bM_qejA`Fjz@xdAnaCbPf`AvPjzBloAhoFpVr{B",
        "uxzLsmrkA{`@zjBupBx{IoOhoF",
        "w|_Mst|jAxmAfwI",
        "_b}La}nhAu\\nxM",
        "u_~Lqc`hAth@h|M",
        "ef|LqiniAsJhnGag@p{FeC`pB",
        "a~}LslzhA`[pnJ",
        "_v|LgfqgAcPxbP",
        "cg}Lmb`gA`\\nsE",
        "udyL_juoASby@wPjh@obAdvAga@jmDkGp}D",
        "ee}LkbdoArTfu@~r@jgAlwBh|BpWlz@f`@biG",
        "mzsL{eylAi}BplY{u@dtC}iAnbB",
        "qz{Ls_wkAz`@~pC",
        "saeLarcpAkyC|@_{DyXuzAlYihAlz@isAt|AwdAz_Bw[leA",
        "yszLaoyoA~Hfj@bd@xxA",
        "wovLisdnAaQnkBobA~zD",
        "ieyLyj{mAlz@|~@bY`fA",
        "cnuL{fpmAcZjzB_}@vmCa]piB",
        "ieyLerdmA|_@xmAxx@tfAfv@dvAzWr}B",
        "iiuL{`rnAqjA`nDgVbcB",
        "clxLuminA~g@ztAjRncA",
        "wovLycwmAmElnAec@zvA",
        "kzwLo|qmAfkArt@"
      ]
    },
    {
      "left": "GAB",
      "right": "COG",
      "kind": "International boundary (verify)",
      "lines": [
        "ojkHydjoA{~CrrBotD`eBuzBejBeuCaSq{Gnd@sbC}VktBsi@klBaQejBzl@{l@ymAerA__Ac}Awn@odFs_AccBaH}hAzXum@h_@{oBjq@wmBvoAm[{XiTgiA{`B_i@ugAsi@eq@_i@}e@ih@sj@i_@c~@}KatBnb@us@}@mUyw@}U}_@i{BupBq[od@}yBy}EytC}~@}gE_UyuJ|@",
        "_omFqfpoAuGz`AUBouAfRag@lz@k]|iAqv@h~@gK{uB{kAom@evAgVkh@wp@gK{vAec@}hBa{@cxAi|Byy@_Uae@}_@qL{jAhs@_i@tS}n@pAar@{BofHjGes@mEs}@bcBimHjoBw`Ap_CswAod@mtAvFyhA|j@mu@`fA",
        "{xlHmokoAjm@ri@",
        "mqkG{d{tAaGlcCgeAdaBsyAj{A_cAtpB{VzjB_mBd{c@",
        "gdwGchesAhTlwAv\\dDn`Dxy@ntCdkApLtSjXdbA",
        "emhB}ypuAwO}xHi_@_sAyXob@_`@gVmoKenMwdCih@u_IwQ_cG{sDavFa_Hm`GytE_bHhh@elAhTwq@cn@ek@iiAey@ox@}sAsJaq@xn@gjAdtCekBzuBkzBrgB}gCzvA_qCbdAw~Hp`Bg~BftAgiCtjHmaCp`Bq~C~q@qvMmEmbDxOceK~{AwdAnd@ks@bbAu\\`fAqa@rt@sa@tHsa@tHgMhiAga@bn@oh@`g@yc@fu@ibAbuFiKh|B",
        "}doGwteuAb\\joBjuAn~E",
        "gsjGsk{rAmEvQab@|gAmEt^",
        "eclGgpwrAbOri@ry@|iA~Rjg@dT~qBzBlx@",
        "kkhG{emrAsAxy@",
        "_nhGakkrAhJ~zBxx@nwAzaAjpAdvAd_Fz~DvmCby@voAve@fpE^r{D",
        "amxFswgqAed@d`EylAhyEwG|}A",
        "yh|Fe}wpApNhgCp`@`yBxm@jq@xmB`g@l[|hBbOtpBbmChsBvp@hqBlYd`C",
        "esmF}|zoAcObvE",
        "icnFyetoAhSf~B",
        "qtiBe{euAjf@w}I",
        "zvr@krvsAwZld@iwIv_H_pDyD_zC{`AgwJmzGafBslAu{@__AwoAg`A}`AnEwdAh_@uzAfKa}@oYiqBowAg`AuH{kAbp@qL|iA}@~gAsi@tg@obMlYmwCv\\y`Et{@}{C~]gtCk[o{HqsEwoNq|EmlCadCo}FylMkeC}sBe`CqW}~Bve@maCleAqfG}|D_i@ktH",
        "bfr@q|itAw{@dl@_i@lq@{Vt{@{Xn~E",
        "rmm@w`~sAxOlo@jh@|Vdl@vOxZnYh]tqAvF`g@",
        "l{wA_qluAyhF|Iw`Gzl@syFzkAytEhhBq~CvaDanBtcFye@ryF",
        "~ip@}_qtAb{@jbF",
        "l}jMad{uA_fEnm@ooKnxMytE`S{`AssAcmAouEczAirAyl@i@wnBve@k|@aFw\\s`@ce@{jBsi@si@cxAa\\mhI{a@kzBih@_}@oE_t@j]md@~q@i_@h_@we@zBwy@}_@wfAfBqv@oNom@_^el@qk@c{GmvUgDoLmyA_eD}tAgl@qoGxn@_t@{By_Dce@aqNkR_fC_g@_sAsjAcxAgrCih@xn@_UvbC}_@piBe|FrjAybAlxBqm@hh@up@ew@gl@{~Ba\\yy@gj@mz@i~@_i@kgAeXgu@_g@we@ykEi}ArAkoBvdAmpA~pAysDymAquCiIwy@sUwdAigAar@mnAufAsk@y`C|a@kpCrzE}}AtzAovBnd@cdAmPgl@ij@_g@ur@ar@el@{`A{a@a{@sUekCeXabEmEew@hIwoAlo@qgB`iBiXtXekA|j@st@|@{jB{a@st@eD_hAjT_fCnaAgiNhqDyxAi@adC{`A_mG_^mnC}_@uxCg_BmxBomBwdCkeA{|DlY}}C~h@wxCh@axC{a@adP{|FyiEsi@kzDdw@slHrqCaqAzkAejDtwF_yDfiCybCpqEghBvlFkq@jmD",
        "pftAkpfvAvOfjBzl@z_Bh_@r~A",
        "newAsd}uA}VjdBom@jqB",
        "`_uA{lvuATdjBnb@jfBdw@hhB",
        "fncJmgblAlmBciG~iHw{KbSwZftAggGjgAghBlwCkgAldMqhClcCew@zl@ec@p~Aq`Bnd@wZvmCqWpA~I`\\?nd@lEf_@qLj]qtBdc@zBhh@pWv\\rJbn@nYlf@|Ihh@yMboAaqA|j@{Vp_AqCbnBcZ",
        "p}vJ_xekA{j@uoAi~@eZybAoCiu@_JmnAae@ug@_^ob@ce@mlEeqHqWebAkGorH",
        "l~nJgczjAbOwdA`nAqiAv|BsuBda@ylB",
        "ttvMi|rhAsrOcplAqhC`fAeiEgl@cvE}rAqrDij@kaGpk@k{AsJ}}Aqk@_pDkoB{jBwZmmBnrFggEx`Cq{Frt@w`Ths@ssA{V",
        "vqxKye{rAvFaSbn@{`AtqA{tAfuBsjAvbCgu@jaGyw@`aHcmC|qB{kAhsBiqBj|@_i@vlDuSzl@mo@r^{`Azl@s_AfsBgtAtg@nYzl@fiAr{DnwAf`Az`C|u@nm@|oFnC~]bFvxAaeBdn@wmCvFcxC",
        "nw{McucqAod@{`Akq@m[cy@mPa{@ga@a{@_}@ekCyiEis@_t@iqBazAqv@_}@od@iiAyn@etCsi@u}@qv@wZkcCaQs_A_i@qkMmzMwdAkq@g`A}UkzBuHcdAyOu{B{`AmaEoaCq`@eM",
        "hgiLim_nA|s@gu@f~D}sBtfAwy@pgDu^lq@wOvn@sk@",
        "`xkLk|wmAgBcxAolAyvC",
        "tl{LkvjnAlEw\\leAoNnv@hs@`r@za@h~@|Krt@pCzu@lPhs@dX|j@`\\xy@vdAby@h_@ld@cQ",
        "|m{LipinAg@ae@",
        "|{eMyuzgAbe@s_AhrA_pBzeG{rEbbCg~DhTw`E",
        "juvMkbwfAw{@_gBabE{rEqv@{iCqk@m`FssAqfG{_BubE",
        "|{eMimreAvFgfFp~A{zH|j@{tAlo@ye@hs@eXpv@wn@jdDgrE`{@upBlGkfB",
        "d|nPebkeAsqCh_@inFm}@ql@{J{eVkfMg}Cox@y`Ck]{`C?o~Cr`@ekCvy@q{Ff}CybCno@clBpAgyIgl@qhCrUikJjeCwyBwp@{BqL",
        "vtgMk}nnAxZazCvuDarKt^oaC",
        "pjnMi_dnAoC}rAigAigAapBcpB}VuoA",
        "~kjM}hzuAlPcZ",
        "tggNyd}tAkGyw@en@od@gpAi[gnB{e@qv@}s@cn@a{@gu@}j@acDpAi~@m[st@_r@mdBovBce@{w@k[_}@wdAmiH",
        "hilMirloApLk|@jsKu`a@|KcnB",
        "~foM_ndoAeMmcAydAovBuHkgA",
        "|uxMmx_qAjIag@xkAis@jIi_@",
        "`qyMs`}pAcZyvA",
        "nzxMsxwpA|TufCRi_@",
        "dxyMo`tpAu\\cwB",
        "fpaN}|ftA|h@ox@jqBwQxc@ag@Ryn@",
        "vgeNeu{sAcZcbCg`A{jBcZa{@?u{@",
        "bqdN{gvtAdDu}@pv@g_BxX_}@",
        "~qgNaaltAwxAm~GcFkf@",
        "ntqQmcrfA{MaoC}}AkyCkeC?_oCtzAcxNlzMixHvvE_rB`eBug@t{B",
        "dbgPg|{eAfu@rpDrpDd|FbQfjB",
        "lmqQqmofA`F{tA",
        "hxsUqdggA{DoN{h@ylBycB_fCwbCmmBykCcp@mcC|j@q_AdwByn@zrC{kAd`CoaC`}@uoCmPiiYscJouCqsAqhEklGkeC_sAohEz`AapBrpFkpAngH{jBjbFknEzzFymAxbC{rC~`Jec@lo@st@rt@{VrJqb@kIyoLyDylB_^_zCuqAkf@g`A",
        "`llTeuaeAfl@gxHrpD}fFfaXaoN`pBsgBzl@ufC",
        "j|_WsuybAgtDo`Ba~a@m~K_dEueB{iCyaDgiCetEaxC_yD_{BqhEur@a`GonAkmF{qDojCo_E}sBguBokD",
        "d`pUektfAdMi|BveBwfJdBisB",
        "blqUwvifA}j@msI"
      ]
    },
    {
      "left": "CMR",
      "right": "TCD",
      "kind": "International boundary (verify)",
      "lines": [
        "{k|lAi{zwAgCxc@e\\fVqv@|K}jF?woBjoB{mCd~DsyAr_AsnAgBy|G{_Bg~BuHofBtQq{Ajs@y|AnwAqIzEcsL`|GybAzjB",
        "c|ynAq`_wAtRz~cA",
        "ufxlAmv}wAga@l[sx@lGe|@?",
        "w_}lAqq|wAzRfu@",
        "yqrlA{coxAex@`eBcc@`g@ucAdlBgd@|Tye@pAc_@hKuRlo@",
        "us{lAisdxAtHhh@fyAnvB`H`{@",
        "eeflAiwxxAafBhgAalEwzAueBti@ga@lbB",
        "gbtlAs|txAlo@vwD",
        "c`blAy|fyAsKnkBwcBpm@cz@vOg~@jh@kr@zu@kSnx@",
        "ssklAgw|xA`S|_@jyC~}A",
        "aa~jA}avyAym@hs@{BxZsJ`HmdA{B_h@sJg_Bmq@s`@gVk~VvmEq_ChgA",
        "soclA{jmyAnn@`mE",
        "wxxhA_yizAecAxvA}|CrhC{jBd_Dgj@r^azA`SoZu^sIcn@uh@{X}~@`H}_@nYmZ~]om@`Q}iA?_hBs^{jA_JwqL_H{v@iKoxMpiBkxC|tAmZzBwfAiI{WlE}St^qLtg@",
        "qc_kAynvyAnBdX~]iK",
        "snpfAupa{AoC}h@w\\{Xkg@vF_}@paAyX~Icz@}a@i}AkdBs~@{a@yfJtxCebAvg@eMpiBuq@rhAeaBri@u{CpLwo@_^ur@a{@ev@si@mz@dXqb@zV{_A~]a}@fMwZoYwZ}qDydAbZmyAfjBkzA|~@{kA_Jyn@oNme@zBkq@zl@wz@h_@siA}@obAgVwe@k]aeBzuBco@fsB",
        "{}{hA}~rzA~JloBlmApiBtI|iA",
        "eqpfA}g`{ApAwg@",
        "wnr{@qn{|AkHu_JasIkyj@i_@clBwpFrmG}cArzEavFr_LmvFn~GcZgByr@bxAegIpgFsuW`|YujBxbA}}Bjf@c}C|KazB|VkjA`{@{aA~pAcbBlyAwgFdvAwiBpv@}x@~|Bm\\h]e\\~h@gLz`AyE`fAaQbdAcZnx@m`@ve@_vBtg@kyC{ByvCce@imBs}@uaBaHouCxn@}n[j|MgjFlPcjGemAayCiTcmBlf@i|A|~@qnKniD}uOvf@q~Rnn@abK}j@uaBu^enE_oCefB_i@c~@dDi`@vZwZ|_@um@jRofA?c_Bk]gdIkf@mxBag@}mByw@_wHw_HmkDirAeiErhAuyEtnDwmBz`AuwGxaB_{BbQwxB_JmdCap@aFgV",
        "ue_|@alcwAz}L{_x@zKsyF",
        "ylwt@wpkyAi^bcBqsa@nkj@qsa@nkj@cfE|qBkkGj|@ar~@fsv@enLpjP_|AhIo|OyzJwvL}}NygGwbEiuQsnHc~@eMa|@gBkm@yMuRar@aEozA_dB}tn@",
        "wn}{@y`o{AbNmrJzoIiy_@",
        "{}t{@kcwzA{f@ioD_i@g`AkdBcnB_i@keAoOqv@c^y}G",
        "_lx{@kx|yAjIm~G`uAikJtLg~D",
        "}yp{@qgdyAaqFyoW",
        "kk|l@qsn}AciIy~F_uIqgDcrJuqAe~RqCmZfiC{k@jcEyDjeCmvEpeHq`OxtE_{h@j}Jmyv@nhYieJxgDqxB|}Ak`J`hJqlLpfGo{B~fBo|Ad`Cgp@|}Cqa@dhFkX|rAih@rU_y@?akAzMq}Cdw@my@nb@_e@pk@mOzl@q\\jh@olAr^gz@pv@etDvuF_o@puAqKby@_@|u@",
        "gixt@waoyAtHzu@vQby@"
      ]
    },
    {
      "left": "CMR",
      "right": "NGA",
      "kind": "International boundary (verify)",
      "lines": [
        "mhynAu`ztAv~r@k~Iv~r@m~IxaNkG`]oH~eBo_@zvB|@d~Dnd@~gAqC|}Ayw@lp@uqA~Rg_Ble@ycg@|~A{nKbxAoiDr~@_S`{Af_@xx@gK|j@qk@|gCkxDv[ocAnm@?jHzVf`@j|@puAuyBz`A_}BloAyaBx`Cug@v[qb@m[kpAqk@quAuRis@ve@iiAlz@i]paAkIvwBxwBbf@nNld@~]tgAnd@f_MzjBp`AgMjgAvnBxvBgKtlGeuBdcA_Jpk@i@ppEfVjdE`fAf{RtdC~gBpm@liHhdFzu@`\\pu@aHrjAyw@hHgXg@qiBvZom@jg@yXpk@_Uth@}_@`dBaeBriBwdAr|Bec@f}CqAnaCfV~yCxn@ttCf`AjqBziAxw@fjBrrB~aIjmAbbCxiEhdF`kAbbChqBbqJ|_AptBfzNxkP~Rbp@~RpgDd_@fkA~nDxjDpoAvnBdcA`dC~a@ziCuQd`C}vD|tLceAbuFTn_Ez}DhoFpjFbjFpbGtmE`eGztCpwFfjB``BziA|fCvlFbtAvcBjjBbdAf_CvZdlFih@xaBzk@riA|`@xbp@hxa@|fJxjDvlWniFtzc@btEfcKpjCdpA|@f~Bsi@pgAkIlrApL|qEnbBh|A~gArcB`dCz`@~x@ds@fxAjq@hsBxs@fiNhnAroE~sEbnBx{B}@hkE}iA|vBqWfsCzXndFfrCv}Bxn@hlCiIbcB}~@zyDqtDrkCmcAbcBnNzeBvy@ptCv{@hdLvoAxsK~]hzL`nDn_D|uKbjApjN~yDxoLv`A|rA`fFzsDrcAbdAdb@tr@nkDzmJz\\jh@npB|j@tSw\\rZspDl}Bw{@hzDkq@lvFxDlrB|VtjBve@jaOv_HrhHh|Bj{F`FzbFel@|xc@xkC`kGvdAvwD~eCdb@jrAi@nlAeMlnAqBbxAva@`fAlhAfl@toDzu@dhEvzAbxB`nBfnId_S|Uf_BwPj{A{zAnhEcVlpAbLtpBjg@bmAnq@jgAri@xaBbGpuAgMbxAav@xjDlyA_r@haJsqCtwAmP`lD{Bnx@fu@z`C|zDv~@dn@vjA`g@zfAtp@xs@hiAjQvbCeg@hoFjw@hgCxiEjnCtlGlo@j{GoNxwNmbBj{BxDjt@~Q|oAx[xgJb~FvvCpb@vqFU|nFga@lxCgj@jfByOvyApb@vtFjkFxyYxkRruKv_Ff_Cri@phCjRxbCiIpmJcxAf~BpW`fAbmAxbAdaBjvFteDl{JjfKfdJrnJf}PpbKpuBp}BrrAvnBpv@vp@nc@ec@b[qsCfiAyvA~~LuuHdgGqrFr{ColAxlCxw@nWb{@yM|s@{Xdw@mEvdAdYhtA|i@tfA|nFnhGvz@~{Afw@`Q`{@~I`p@dc@dNri@zBp`BnOvdAoE|~@vFt\\l\\fXtpApUr_@fV`bFvhJj~Ij_Kr}C~oBlfDza@n|Aug@tyCqhCfoBk]phDbOheDvg@ddLxsD|kE|rCr}AzhDjWvuF|cCvcDjrEt|A~aG`e@rmClf@npB`yB~mAd_Dnc@jyC{BncAi`@rfCcEncApLfVhz@paAbOld@mEdl@ck@xdA_Jp`@fRdwDjg@zaKgV|fDo}AteBshHvyBuaNfhB_sF`SewFkIyhHjRczFdwB}eDbtEgiBteQ_fErfEapGh|Bq{Glx@ixF`eBgiCxkEo_En`O}eFhtLgu@vcDmxA~oBorHr`@grCrrB~nDlyA`bFnlAbjF|s@r}Mzc@tSlYlGpb@j\\jf@teBzkArsA`r@z`BxXnkCzB|Uvhq@ar@lkDwdBbbCwxBf`A}jMxxAkdB~q@mQdvA~qArqC|jg@hyn@j|@rqCqb@lxBgz@lxBsIpsClbC|sBhwm@~xMvQ|Dt|@dmAh@d~ENzjAfd@jxDzlA~{AxrG~pCl_BxaBl~@f~Bp{A`yFzLld@nqB`wDlkJf|DbhBlmDxDxaBwExmAlFrhA~m@|tAt_BftAnvJhqDx}En~CbpTdxY~tQz_Q\\?~_EtdCbsAxmAtr@bcBli@r`@~pDpLnpApUpLnmB{o@fgCaRjeCdeBpiBfiB~rArrC|{EzeBnaAv}BsJdbBebA~kB{u@|{CvZdeCxlBppAnmBxxAvn@`}C_qAxxB_}BtjBojC`zBqtBreD}~@zuCvZzxB~}AloBptBpxBr|AjfCve@fyB_HvwB_U|bCeBzjChh@jgGjeCbvC~f@nqAaF~uCur@paAmE`pYffDroAfl@t\\f`AvKrhAt^vdAtaAt}@jxDlxBnrAve@voGj{AjzBby@x`C~{A^?pbKntF`pB`e@x|BpiDv~Azu@`dC_SjuAwQrxAgVpfBriB@vD?@"
      ]
    },
    {
      "left": "NER",
      "right": "NGA",
      "kind": "International boundary (verify)",
      "lines": [
        "y~usA_nu`@|i@ojEllT}gv@llT}gv@h^{w@x`@kf@vPkh@",
        "izzrAs_|^ag@cvE{\\ufA{dCy~D_cBquAwdFugB{{AufAqtAwlDo{Caz[",
        "cgasAqrs\\~}@mnClbCykCz|@cmChT_jJ",
        "qikfAol}T}{Da`IsjAqjA_fCqk@uzB~]sqBzkAmyCrqCoNnY_ThTeaAnb@k|@`S}aJbc@keBk[oxAcdAekBqiBunE}hBwtE`\\uhMrzCinGeB_tXsgDcso@~|@{`AyXan^yui@ozJksKq_o@_e^yzh@gdEsnCcTewm@{KwKksKab@_{DmsAkmDkv[ev]ijEscHsaCmqI_qDogVmhHwze@_TggE",
        "aa|rAi``^ve@i~Z",
        "oqxrA}gl]qnBkwR",
        "arurA}jppAl_Awho@",
        "wy}qAy`{oAgHag@kp@mPkb@`Hgk@r^eX}@y}@q`@uw@ij@ycFixFm`A}}AkjBdBqk@ox@a]gtDc@uE",
        "}unrAmw_e@`gA{rIzVioBviFg`L|lXglZ|ca@g{^fq[k{NxuGazCn`LcqJdmEwaFvrCyiEpfAq}DhUsoE",
        "cfgrA_und@cPe`AeeEchJoWcwB",
        "y|}qA{tyoA`B}j@",
        "scpqAskgoAyhAifDu]sgDcu@cvCaoCkqBgJnwAk]|KmuAcy@mIcZ",
        "kruqA{dfoArJw{@zp@qL~}@pLfq@~T",
        "scpqA_eboAwk@om@ogBom@oX{a@",
        "kruqAqdznA|e@?t{@fa@nXmeA",
        "{viqAmyxmAi_@mkDurG_qPmx@e_DaMokD",
        "}|rqA_eboA|T}@jbA|@",
        "guqqAwh{nA}DqtBw`@ueB",
        "_}jqA_ksmAbe@mmD",
        "}qgqAixpmAeD{w@{dByX",
        "ariqAkgkmAjY{_Bvd@aoA",
        "{jypAgchmAqBuQaPqCqq@`HwPoCw|DylDgaA_qAeq@jf@yd@lf@kX|j@kMrr@om@?",
        "srypA}lfmAvFiu@",
        "aurpAsgamAaFyvAgWpAkm@lf@shAnWmUmPa\\irAqMcZeCcO",
        "{qupAuq~lAfZyc@~i@qb@pUqL",
        "enapAumjlAs_@{u@aoCij@}_@_hAo^mlCimAueBy_E{_DofB_i@}AkG_XmP",
        "{xtpAuwv`A~`Csnb@",
        "}xxnAmej{@oCeXqq@wp@s}@a\\ywC{Va`AoYygBmmByiSk`d@{iB}cGy}Ru~}Aqb@mhDon@_yQ",
        "ufqpA_kydArsMm`z@jrGqqTrgOmdZh~Ea_H|z@wyB~uAqnJ",
        "{vppAigzaAyNub~A",
        "aompA_cwn@l{Eoop@x_AokDvt@ufAbhCsqCrgBokDlaDerEhi@czA|o@kxD`BqE|d@}pA|eAuqAxuDszCplP_oRl[{l@vVu}@fA{V",
        "ob~nAes|k@y|@ubEk|h@o_fAu{ActEuSouE",
        "{tfpAqxalA|p@oaAzu@st@vj@a}@bQ}}A",
        "}r_pAic}kAeMsk@{]gj@si@kh@_d@gKgdBwF",
        "}v`pA_n|kA~b@iT",
        "arvnAmackAoh@evA}hAm[ilIqt@wUm[eXolCgMcn@kv@kq@uaAs`@aiCkf@kc@lbBy{Asi@oqBkpAmdBaQ{qEacFyTg_@",
        "}pboAyaniAzkBezHle@afAxh@{Vpa@sApV}IvGwp@",
        "yc~nAyn}hAaPknE{MmwAiwAebC{S_gB",
        "{xaoAggak@`tBwjSh@e_F",
        "_nhnAulpi@iAapMiQooB{Dcc@m_AudCi~FyfHmuL{zJeYojC",
        "gf}nAopajAfa@_}@|u@om@l^{l@",
        "}pznAg{|iA{MgVi_@yZ_]we@cGmz@",
        "}pznAifhjAd\\aeBrFwzE|DikDrUmnCdh@ovBhSaeB",
        "smynA{jfjAib@mz@",
        "k_znAkmur@TiiAdb@qgDpeAgtCdhEepGnbCcyBhbHqrDv~BgjBx`CidFj|Momr@bXgzEtoE_}w@",
        "{awnAwikr@mPyXab@afAqUwfAmQ_zC",
        "m}xnAwei{@nCu^",
        "ugcmAkbpy@uHmcCwPgj@yj@ybA{{@ufAaq@ij@uxe@}o`@ebEgpEwjAewB}UoaA",
        "c`hmA}rfx@lwCmnh@",
        "e|dmAulqw@I{fFe{AilImFapB"
      ]
    },
    {
      "left": "NER",
      "right": "BEN",
      "kind": "International boundary (verify)",
      "lines": [
        "gvtjA{ojPnfGwjHdbAg~BzaAs}@zkAmo@nkCag@hs@ar@db@cdAxYshA|UinEbOks@r_@gVhsBk|@zmJe|F`c]{q`@h`@kR|}@ssAr`@kRjdCoNxlC_^tpB{l@vkFwmCtdBcxAxo@_t@~q@{kA~TquA",
        "qeqjAaqaPsK__AcDqsC}}AgiA",
        "ajqjAor}OnCq}B",
        "s~ijAmrrOyNg`A{l@ox@qtBccBqk@adAsJc{@",
        "gjkjAqppOrj@{`A",
        "eu_jAahgOi_@yw@sfCgvAmo@sScp@iK{k@aQyc@q`@{X{bA",
        "_oajAwk`Oxx@i{E",
        "}}~iAmo{NmQce@qu@}iAaGgj@",
        "ud`jAibxNnCoW~]st@fB_^",
        "ki{iAc|kNeBen@_Tob@st@{w@aQk[mz@g}E",
        "ea~iAeifNtGyy@rAshAdMmPfa@uH`[kR",
        "_ayiAu|bNg`Aob@elAa\\wP}j@",
        "ezziA_k_NtIom@dc@ob@hIu^",
        "}dwiAaxyMwFcoAcOyMceAur@gVi_@",
        "wjwiAuhuMxDknC",
        "mjbhAuk}MuH{l@gjB{BylA|Km\\tg@{Llz@u\\naA_s@r_Awq@pk@_}@za@{hQpqEe{Ij|@amCdDqkB}u@mcAcvCuI}tA",
        "abchAmj{MrVg`A",
        "{v|gAeosMeNgu@ym@_i@myAap@}k@ij@yDs}@",
        "}~|gAktqM`Gyy@",
        "kprgAqyqM}~@fKekB~gAocAlGkoAqb@qL}s@",
        "eurgAa`qSdMshAve@ebAhUwdAniDkwGboAscFxn@wdAbn@mq@feHgpEnc@_i@tS{a@nXyZ`p@gVzaBs^xn@gVdv@iKxn@}Tb[is@bbBcy@zb@}j@",
        "a{ogAgtkSme@}rAur@{vA"
      ]
    },
    {
      "left": "BEN",
      "right": "BFA",
      "kind": "International boundary (verify)",
      "lines": [
        "kprgAqyqMh{Ql`FlaDzvApgGfoF~oDdbAblBzBncAcDlz@pUrqApuAlwDrmIpnJtgM|xXduXh\\d\\poAdjD",
        "ssvdAgipHkh@_JyvAeMkh@}Ksm@xjQqWxwBuw@`eB",
        "a~_eAudxGvxAbc@pa@~~@XlAjWtjArz@jpAliAtr@ns@vFddCmz@n}@veBf|@llC|nAt{BjuBfu@`jBec@ptAu{@foAiKpzAdlB",
        "qhtdAakbK}Oz{EwcBfgGcjAbaD_JdkA",
        "ktzdAswkJlf@`{@",
        "}lydAq{iJi_@pkB",
        "gmzdA_ofJfWnvBj`BltFjGfuB",
        "gkvdAykwIkRlsG",
        "s~vdAkwnIj]p`Btw@nvBd{@v_Hzv@piBdh@`yB",
        "ijodA}xwHynFbbC",
        "czvdAyusHnEpkB",
        "iz{cAok}FibAjf@{pA~gAma@vdA",
        "}qadAkuwFbjA~]pp@qL|z@k|@j|@eMpo@tH`pClnA",
        "iz{cA}ybGor@hj@mPpk@",
        "g_~cAab`GlPzj@nr@ti@",
        "onvcA{seFWzu@__@kGgfAdn@cn@`{@",
        "se{cAcz`F~`Bf`Az{@p_AjmA~]p|D{sB~sEqWtjBi_@",
        "izscAkvvFk`BjnEs[ldByDduB",
        "c~wcAkkiFhKfu@nRh_@xN|_@",
        "czccAagaFgUr_Asy@r{BSpaA",
        "skfcAggyE|^vZzpBri@dXdc@zl@`mEzLh_@h}AoE",
        "er}bAmspElLwy@nXcFtlA|Iv[yBfKcQxYmz@",
        "qf|bAytnEqGgVab@kf@",
        "azwbAkguEfiA}KveAg@~bAkIjaAkf@dgAafAfcBbFh[tS",
        "wywbAw{tEIsJ",
        "_ambAyciEkM~I_|@|_@qLbQqLp`@g\\r^k\\~h@oT|gCeI`\\",
        "yasbAqt~D~IxZpv@hh@ljAxc@fnA~s@pM|Tb~@bF`eAgBzw@}TfVwp@p`@ec@hhAyD~gAnNl`@nY",
        "}yhbAqrxEei@xl@e}@pk@u]xOsTh~@ySn_E",
        "mknbAqgmErEpWz`@xbA|@jf@",
        "kk~aAoc{D]vnBiJ~rA_gBp}D"
      ]
    },
    {
      "left": "GHA",
      "right": "TGO",
      "kind": "International boundary (verify)",
      "lines": [
        "cptbA|dSa\\|qBsdAb~Bm}AtfBkfBnm@",
        "qbm~@ecb@_UbQ_jQl}H_gB~aBmlEviIo|@nr@{iC~gAmy@lp@ma@xw@}~@jbE}d@pw@sd@`f@k\\pk@mQjoCaRliAm_@rcAgl@|u@e`Cx~@iaCaCw|Cie@owAmTidGg`@_lBon@smBewAmtAq~B{q@}t@kaAsJ{yB~^q{@xC{rRifCwy@k]{r@aq@ka@wu@}i@wj@imA{Mm|EwPm`E~RiqCh}AsmAtoE",
        "auvbAthE|@ptBjv@dsErJnqB",
        "k~m~@spl@kG`{@m_AzdD",
        "egp~@une@`QlOzg@xOxc@nYzCvn@",
        "{cz}@_i{@m}B{u@sbBt`Ac~AliBkpB`eAmt@uGgaAyS}cAvAe|@t|@qM|~@",
        "y~o~@yjr@xPtw@j[ry@fQzeA",
        "_|e|@ewiAaQwdAeRcCqfBkUm}BvQeh@jq@mOxcAqq@hnAo`Dd|@syLy_@mqEjIyrAgl@qeB}Pw~Au\\_pBmxCogBr~Bm[zz@",
        "ar{}@grfAfl@`qG\\dvA",
        "ykf|@svfAxNq_B",
        "yn{y@_g}@{LaoBalAg`AilBmPupBdM{zA`\\e}@th@wo@vk@kbAv_@gsB`HwdNaeCafA}@oyFh[evAyKy}Akq@wtAaoAme@sj@er@{BozBni@}rCviA_i@hIyx@gKwe@eTwf@uBo|@bd@uSolB",
        "}ubz@qwt@llDmeDtx@_hB",
        "_vry@_i{@uSvaE}aCtbBsuDnCupDoxA",
        "kjly@igdAk[gdBcuAgj@o`Cpt@qVvzB",
        "}uty@ofcA|~@n|F",
        "suny@g~}@zv@wtAjRirB",
        "qdly@ixu@uGeuCkgAwnB",
        "mgmy@w}k@za@qyH",
        "agay@kop@yZz_Aaj@z|@sf@tl@{PtN}f@`A_oDe\\ag@kN",
        "}fnx@yxo@qKxrBurAl[kfAar@wbB|j@_xASis@ocGsd@k`Bsu@}nAw_A{VsbAzu@qChwA",
        "ydby@ynu@v\\l~C",
        "oc|u@gzuA}`ExrAe~Dg_AcaEyhBkhE}_@u`BRg{@qf@c|BmlCs~BqjAsbB|@s~EnlAgzByD}z@ar@ug@keAw_Ai~@smAyXcvDkI{{Hcy@sqCve@_aB`pBy}@~xDoEpCcEf@cEg@}dAkh@c_AeMo|@~Iqv@~f@yvBvjIaRjtB",
        "o}|x@{koAzLlzFzWnkC`h@x}Ajp@b^l}B`Rbt@pWvf@nn@~aBx|G`VfsB",
        "{mst@oiyAy_@ycAoqA}Tk`BaH_mAu^_@U_cEohCqpHbmAuzNnlHU?",
        "oc|u@q{uA?h@",
        "cvtt@i_sAbG_y@dRc~@|KapA",
        "awmt@ysnAegAq`AogBuh@qWr`@yT{`A",
        "_`st@_gjAl[}hAnkC{aA",
        "mx~m@yqvBayBlP{eIqLedJxw@kuJeDc]nCs|Kl|@{gFeDyvBfBehFnx@}dHfVkxC|_@gk@_^sd@cp@}oAga@kuA~Ist@hj@im@lo@w`AxX{oAcFgWg_@yDyn@{Wis@{xD_oEocAugBmxByrGy|@ccBc~Acn@wxCnWiThV}JziAiTpWq\\zBu}@cDuzAnNufA}@w_ApLqdErnFqkFvoAsdFdlBa~DnxK{sBxaDmiCbvCqyBpiBghD~xFaxItwFyfKbvDmdFtf@}nAxLgz@oi@qMymA",
        "yv_n@}|pBj]{sD",
        "}p`l@_smBoNtpBmlD~cEerGvcByrH~]_jJ{V{kAsU{aAwe@k|@i~@oc@aqAcZacBgj@ssA_sAqb@{hD|@y`EkRg~BaoA",
        "sbeg@ajcCyDvy@ibB|u@m_AxvAwiA`qAsaCza@qzHgu@mdBlE}cB~s@auA`zA{z@dlBsUdjB}u@jh@knIzsDoy@dkAub@`{@wz@`SmbC_i@izEwbCghB{MccCrhA}gCrpDs~AvfAa[czAyEuzAmcAqfGqk@woAcvEovB}nGoCixGvZysFiTuuJouC_aHcy@idFkrAkfCwFyxKbcBsu@jh@",
        "{{cl@_uxBrsA|dFhU`{B",
        "aofd@wofFwzEaOcbBrhAyy@ldOwj@ztAulAdbAw}B`qAwu@xn@oXbn@gRnm@cc@vp@giCz_B}sNlbD}@v{Mga@z~B{{@voAisFnjE_bB|{CyvCvsHueCxbCevCxaBksC|iAmxCve@o_CoGyd@oAsnAkf@sy@}j@iy@{B}lAboAuJxw@",
        "cheg@oxhCnDlmD"
      ]
    },
    {
      "left": "GHA",
      "right": "CIV",
      "kind": "International boundary (verify)",
      "lines": [
        "og|x@pflOfiBssA|wAwErfEnXro@aGxgB_^pgD?liB|^tm@hiAff@ftAhrAf_AztBjIj_Bcp@l_AowA|VclBvt@eaBtuBjGzuBriA~eBheEjpB~gAl|ExkBrfC`dC~r@dYrwH|J`aBxXhwAxy@la@a|@hh@ag@`a@ap@fMquAvFe_Ddb@}|CnrA}|ClcBkg@v~BmEfdHq`B`[cd@dE_i@xM{a@xt@gMjjBwF~rLg~BltAxEnc@daAnh@dm@rnAdObp@i]fAk@",
        "ezrt@nl{N~`Bw\\ruu@q~Gruu@s~Gh~A|i@pcDtwGp[ftA",
        "_`rt@~d}NeYow@",
        "ojyp@lhuNsF~fAcd@nnAeBtr@",
        "mzzp@rs{Nbd@~f@nrArj@naBnY|mAeN|rDuqAntCkg@~kBxD|oAt|@``Az_C~zB~sJlpA~qBdfId|GftA`eB",
        "a~ko@bg|OaSvGob@r^mZth@",
        "aqno@dy~OnCff@zl@fQtqMbZbdArSht@vp@hrA`jCtq@vt@h^dDbpAgQz`@r@~g@`W|jAx}@~g@dWx`]jbMf|FnrApzz@zpHhhAyDdvAmf@tr@yh@vq@wZftAnClxBpv@zcJn}G~}@r^rwHtr@fk@r^lcBptHjC`FtAfCzn@`lAdne@zoUroFrgBz`FvGh~@cZhcBemA|`DisAth@oM~uIvyBzg@z`@l~@brBp`A`l@~gBvGt~cAelNnxAgiAbUiQffD}vDx{IadClq_@m|Dh~EwyAbvLwoFfaFgkA|`F}NbhUd|@",
        "ceza@~`bQreKb~@n`Dw`@dqAwrC",
        "qbya@~vnQqa@_uK",
        "c}ka@h_qPnqBe|Lx_AcoAzpAap@zcBsVnfIyMj~LymBnmKoiDloByY~kBxNrmA~|@dN~qA",
        "yjfa@rj~PeNgyBwyBmjEkg@sdB",
        "mbr_@dgyOme@rqE",
        "{hs_@xy_PvaK~g@vuAwPb|BgvAzfAwZlt@fBtaClY~w@cDrTuRfeAkqAdg@ga@vtB`{@l~@bxAtSpnC",
        "ikl^`sbPuHxwF"
      ]
    },
    {
      "left": "CIV",
      "right": "BFA",
      "kind": "International boundary (verify)",
      "lines": [
        "c{y}@p}v_@{Ch}BoX|gBsj@rtAiy@dbA}d@jR{v@hT{q@bZ}Tbd@qAxx@sFhj@i_@xwAukB`Fq|CfkAolCbmB_}@dlB",
        "_x}}@td}^ci@``H{BhhB",
        "_f_~@`oi_@z[xm@hj@t^|e@jf@vOjgAfAjfA",
        "{_y}@vmp^wqDbrH",
        "sr~}@z`z^rYxbB",
        "{c{}@ttq_@mD|_@cQlZeMh_@",
        "si|}@jqt_@dWfVfb@pV`Rj\\",
        "mph}@r`d^wE`kAyZbFic@wV}`@iOivI?_|Adm@yAhCk_AvaBkGjeB",
        "cy{}@jgm^brAnm@bEzv@",
        "a{b}@~ga^_cAqBapBmt@k_CpP",
        "opl}@p``^jh@fQng@r[r^bd@pM`k@",
        "mnp|@tyv]aIldAmhAzq@}e@atAqKtg@yO~b@sK~g@Sns@yr@uw@gq@oqCap@rJ{eB||Cy~@nd@uoBii@",
        "_bc}@t`|]|EhfD",
        "m|f{@`oa]aRbu@}gDvvD{eAvFg_GwxAqf@rJiqCbcAsyAbeAi~@|ZuCmcCmsAwVoqBhj@c~AzdAgo@vjAwe@dqA}z@`bA{oBr^",
        "}as|@jrr]hs@d}@d^bhA",
        "scp{@bj_UiUviBym@taA{q@zg@al@rn@cZhsA",
        "ycv{@jdjUpMbTzeA~x@`Rf`@",
        "i{r{@vtmUwFlf@{l@npAmEtm@",
        "kwt{@j|rUbd@rnHl[`zAnh@h~@jiBbcBff@bt@pb@bwBvF||KnB|Jx`@lrBxuChjFp`@~dC|o@z{AfeBhYtvAvf@zAjgExOzr@tl@|~AbPlEr_@fAp\\fKjGxe@",
        "w`j{@b~lSka@taA}bBtlBw\\xmAqoAbv]",
        "kuq{@ltsTvp@ttJ",
        "_diz@bntQiDtoBgyAdlBopCj|@_lHhmAovCd|Bi_@xoC{AjkCy~@~kB_|BlZmrCqLmwB`Aem@fkA",
        "sso{@f{rRbcAv_BxhHjrE`tAfuApMdtC",
        "aba{@xzcSgpA~}@w~B~Is{BeDui@vZ",
        "kzl{@j{fSfXr_A~k@hhAjRxw@",
        "{d`{@v|k\\e_C|h@_mAtwAaf@d{BuIhqCaL~r@k\\lTm\\h[kL`fA",
        "azj{@tz}\\p[`o@jw@~_@tg@hb@",
        "}juz@nqh\\wFct@kb@_cBchBlz@ylCt]y|Azq@",
        "yja{@jeh\\|d@jvB",
        "wixz@f}wWiJnc@sb@d`A{fBrbJ",
        "q`}z@pffXfLpjBbsAtoBdxFfrDb~@hrB`]ljFfe@vjBliAdrAnDyZfW_hAjcEf|D~w@la@`v@\\prCqQtmAtNx{CzoAvn@|g@NL",
        "couz@dnj\\dCu{@",
        "sdpz@xxg\\eq@zPqW~Jgp@nv@om@?",
        "qylz@fsb\\gbCtqA",
        "y|pz@|ee\\dWzqA",
        "}_bz@vgq[{CnCeWs@qb@t^ka@hsAeYp`@}n@pL{`A`H{g@fVc_AhgAqk@fb@w`@rS}Tj^mGl_A",
        "sdpz@`n~[lFb}@~SbU|[oI|^ob@vP|}A",
        "ob|y@p{gZkSbjEe`CxwAoqBeMy`Dk|@qjB{Lu]tMaRld@uH|o@",
        "ksnz@bkqZ?ppB~JtRnW~Chi@tR|tAt]bsA|Ar_ApVhXvyA",
        "gjix@~wzOoJntCukBrmCsuXhnRgvQzuH_bH`oBkpC`kAiaB`aByZnuB",
        "ybkz@~vmQx}@bvE",
        "q`dz@~|zZuXngAedC|xAiy@veA",
        "wyjz@dfb[drAvoAle@rhAnIjlA",
        "sufz@|mi[KzzA",
        "_vfz@xil[zNyEbd@bUbi@`h@|_@nq@~T`r@",
        "otny@xvtYkg@rtA}bA~h@glErt@gzAzv@{b@rvC",
        "em|y@p{`ZtI~~E",
        "svsy@|fkYqdAphD{X|~A",
        "avvy@lpsYtaBtQpeBg@hw@|S",
        "og|x@pflOjwDjbEl~HxwCldBftB"
      ]
    },
    {
      "left": "MLI",
      "right": "BFA",
      "kind": "International boundary (verify)",
      "lines": [
        "mh`{AjkzAxZyx@zwJaoCnmAu|@zAknD",
        "k`kwA~weJmUgvL}oA_sLyvi@qubAazByhGc}G_id@obBkmFueCg{E]c@awa@ckg@S]{eI}lImr@egA}pA{qBqu@inE{Fczi@e@wiE",
        "co}zAjfm@rbBurL|nI}aY",
        "kbqzAltlAo`BgaFgfFidK_cAoeK",
        "q{ozAnnE|qO}cp@",
        "q{ozAvoE?g@",
        "sglwApyuJff@q`O",
        "{ljuA~_}K_N{_Bat@ywBweCyqHcj@}t@u`AgW_~n@}qBidDwp@qpAuzDgLkjH",
        "ufdvAnx_NfdBmzMpeTysl@~l@ggE",
        "knmtAp_oPihGgdDitN{y[yrByhBuaKc`J}sB{jCu{GuzNqpAmsI",
        "}_drA~ocQmFul@koA{vEaqAe{E}lQznD{mIf\\onFibB}qDsmBaiXisF_IhIiNzHkHjQ",
        "yumtAt{mPlFzb@",
        "qbvrAbb}Rtw@oeDvmEwuGlPgmD",
        "_mjoA|acTaRwjAicBo}@koB~EuwE|gAuoDgVys@qhCq{@w`_@kv@cuA{uo@v{EseFi{AgrC_`@{zIcYcuC~g@m_Bd`CowBi{B",
        "_jnrAzjaR|yAs{CdfBmnB|y@u]pzAmP`_Bwj@",
        "uimrArviRm[}gC{ByaC",
        "oqfrAltlQzNcwCfQis@`[gk@jRwj@",
        "iq`rA|bvQoX{fAatBukBac@ygAqLcp@",
        "qukqAz{gWbEyUnPqVhj@i]xGeEd{Bm_@ff@eSrTst@xZouCvO}`@dbAzB`Xlj@zGry@jQxo@ltBv}Bd]vt@biAtlAt{@ulA~c@_pCpBmyB",
        "ig_pAlxnXec@ybA_eCeuBovCa`Bi}FyhBqpB{_As~AogByXor@}i@ifDaa@qw@wiBq~AoYakAmVuaAa{@s}A{fAerAgy@c`@}`@bp@iDvnAyYzb@a`BisAgQeS_E}T",
        "kttpAnmzV`RwdBxrAwvEtbAc_Gbn@mrBnkJynMfhDu|GtdKm~NpKgk@",
        "uitpAbj~VuIs{B",
        "{u_pA~nrXtJsy@zA}z@",
        "_wkoApi|XqRafAev@}j@mu@`MogAlcCsy@bj@o|Aw[smBa{AicBepBm~@y}AuIk{@",
        "s~poAvpyTxNoh@dfBicB`c@kv@vE_h@",
        "urpoAfc|T}JoqA",
        "ejloAvyhYdReoK",
        "}yqlAthfYyNyaCaf@ssBaq@akAcEkHulAo|@etKiaCajAwGgzGxnAsaJ{SclD`q@wnCxrByvCttDujB`oAueJteDwbD~sDkw@tb@okA?av@g_@ar@mf@ynEomAwj@ghB",
        "{_loAtvmTjf@ufGnJalA",
        "y|koApbrTaB{jC",
        "uawlAhhtYve@wvDxgBiqDdWqtA",
        "oprlAj_iZiHaaAAMwdAqtD{q@snEeNknE",
        "{zrlAtijZjIii@",
        "ytajAzjaZ{b@qxDwjGtx@grOvaF{uCwp@g}BsiBkqByuBsrBowA{tA_h@sVfAsTv`@apAvu@scHvbCmcBtfBamErnGifBzu@icI}d@cPcU",
        "ezfjApqfZlp@k|@xbAcp@bo@ew@",
        "chrhAfxq[eCi~@yy@e{BqNcEo_AkXmcBsKcyB{`A_|By~EkG_{DeaA_|@miHr{Cu}LuePyXgWod@aGkeA~I{`B}Tkq@f@_j@yNih@scAoD{zA",
        "iwrhAbwu[dN{}B",
        "u_fhApyi\\qa@akBa]ooD}s@}xAi~@mp@ijA{h@koAuk@qv@u`AoNgaA",
        "uhihAfvq\\fAgbCveBmxB",
        "ajfhAdaz\\s}A}iG",
        "}vghA|of]hKofCh^udCf@q`C",
        "e~bhAjnp]cOk`Ag`@w{@co@uw@gv@sfC",
        "abchAhur]zB}eA",
        "mubhAlgv]sKcqB",
        "e}bhA`~}]vFsuF",
        "wxfgApvf_@cE{l@eb@gj@ejD_|BcaEgqFwvD_eDynAi}Aaz@u_EwyBomEug@mzAwFe`B",
        "wvhgA~dj_@tR_i@pX{`@vOqa@",
        "_scgAtxw_@_Ig`@cp@ym@eLkSqb@kxE}JcYiUqVuRm[}@wf@",
        "e_fgAzd|_@tHmZpt@{kA|K{b@",
        "c}}fAp}w_@eYdWk|Ax`DeL|a@meAve@_^\\}Jag@}JgtA",
        "{nyeAnkh_@gKfw@ceAvn@afAh@ybAqa@g`Aym@i~@qa@csFst@ihCgLylBbEi{Bnn@}tA|hAk|@zaB_s@vxBkR|_A{B|t@",
        "yr~fA`qt_@tTnkB",
        "yr}aAfqq`@maDwe@ubIn}@_w@xIiaBkR_z@myAsmAumRs^{iBqk@ugBwzAqsCkvAs~@y}Fme@goCaz@ubEwcEoaColA}cB}JwjSfj@opBmZgpAq~Am_A_gCmu@uq@{oAnD}mCz`@gdOHc{Exx@unDf}EiIjeA",
        "}vyeApkf_@`G|~@",
        "ifs~@bsu`@qyAga@o}Huq@or@}V}`F}qCcgIssAsz@lQ}i@xm@w~AcFicBgj@_w@_}@kc@z~Ass@vFqeB~]iw@fBgnIwz@q{A}^_m@ii@qWkr@q\\ug@u|@aHss@|@sgJ{uAkkA|UwbCriA{sL|rBwkDrsA",
        "at~aAncm`@f`@vlC"
      ]
    },
    {
      "left": "CIV",
      "right": "LBR",
      "kind": "International boundary (verify)",
      "lines": [
        "mdcm@`ixr@naCidG|zEwoBnxL{~B||QqjA`xBs`@riAih@xuCqiBjqAkg@x`Ecp@jp@k\\j|A}iA`p@eXjh@gBbnAfL`g@cD`f@_Uj{Aa{A|_Ame@by@cPlwCuGzrQ}iBnuCzNxy@xm@xaBp~Brt@|`@vmBvFveBwFz`BxDlkDvnAxm@u]|`@_r@nc@o]rsAuCnvAhItzDhs@dtDdmA|gCbxAfpRxpPxgCzyBvcJpbMzdB|sA",
        "gg`g@tjds@SnM",
        "{g`g@dyds@rx@~fB|@xEtHyE`vAb[xYfLpPv[hKfjApLt\\`aEvxCxEmhB|K{{@",
        "atrf@nmhs@dTkgAj|@wdApvFwxDze@}qB",
        "oorf@tcms@qCeuC",
        "e_rf@|xtr@bYkf@n|AigAngBacE~{AkqAdc@tGvf@dm@hfBh_@bz@iJdqBew@|n@eMtw@h^x^hx@be@bUviAgiA",
        "acgf@trzr@w~@ylAcsBcp@srBm[ss@k]",
        "skye@|l~q@tXs_ArcAk{@lz@eaA",
        "_gwe@h~`r@scAkpA",
        "ifxe@`mer@fAqkA`\\eaA",
        "ehue@x|ir@a`AebAa\\qkA",
        "}dve@n`vq@zWol@jq@i^dr@cFbj@?zXkHrS{w@nlBgcNnZoiAjf@ybAd^sh@vP_t@",
        "{qte@vmxq@gBk]m[uSkReY",
        "_yme@j}_p@zWekBfdAaeBl~AarKdCs`@",
        "qkhe@byzp@i@kdB_T}tA_lAqjC{\\}gAkg@uaH{BghD",
        "gjhe@j~io@zKqe@tSuIxgAmOz\\sTp}EytGduB{_BlsAoNbpFtqAhbC`\\vlCnNh}ByO`vAccA",
        "gwge@lvko@}IyYaGg\\",
        "osbd@j~wn@zBew@pv@w{@jx@{WjmCiShUaS~Hq`@dO__@zf@eMf`@fLn^dx@v[zLrpDnCjl@mEzdBkpAp_CyuFxiAekAnzCcnB",
        "ga`d@dk|n@g\\qA__@a{@_TemA",
        "yigc@~a{m@l_@kg@~mAccAxhAk{AvOymB|UiHfeA{_CpBcP|y@_fCtg@u^``Avq@fg@co@xfBuqAfWqk@",
        "un_c@hgbn@qk@evAa{B_hAoqAcdA",
        "gowb@btsl@`vAggEvwEa[xfGtg@jdFxD|hNirBxbDwpAtiG_dCxcBomA",
        "s_mb@~vvl@un@oo@oeB_^mxDkR",
        "whwb@rg}l@bhBtSlP}_BppAii@~vAu]~c@kz@",
        "arsb@tkcm@{a@kgAc`AklAuQim@",
        "_u~`@veal@oTbbC",
        "oj_a@zhel@fjAri@puBa]xkBgsAfF~zB",
        "stu`@d}fl@}@tg@",
        "qvu`@zehl@t{@i~@fIsIxr@f`@hy@~gAfzAdl@fjFeCfaAb[",
        "wxc`@hkkl@em@nvA",
        "}fe`@xbnl@rbBs@pnBoW|iBij@lsAwy@~r@u{A",
        "}lw_@hdel@tHom@dtBea@twBoOfeAxDv_Anc@vhBpjAxh@dNzeB|U`f@h^~Yv{@",
        "k`w_@|egl@qKs`A",
        "{qa_@d{il@aWnMen@Hyg@`Ss_@vE_^s^kW_IsKjfA",
        "qfh_@pbll@lPnN`vAn`Drx@nm@tw@nY`mEz`ApeHkr@bhBzCxlBxc@jpHfgD",
        "yna^~|zl@{a@~vA}@xhB",
        "ssb^x~`m@bn@jeB`pBnmAjkBxMphJwo@",
        "o}n]vpem@jeCvGduAsj@fqAcy@bxByb@v}AK",
        "o}n]vqem@?_@",
        "yv~\\poam@gApW_d@~r@uGjqA",
        "wf`]nnfm@xuCz}D|y@zAb`Eqk@reAvGd`Cdb@po@ZhFBdgAk^`l@mn@xc@cp@jl@md@dw@yOpcImZrxh@lZdw@aHtx@wO``AiJf}C|Jb}Bqk@ry@wGz|@jRpsBf`Ah~@lGnhA}`@zkC{mE"
      ]
    },
    {
      "left": "LBR",
      "right": "GIN",
      "kind": "International boundary (verify)",
      "lines": [
        "wqnr@dziz@y{AfuAylB|_AinBv[wcH`g@{jBxb@qpA|`A{MfiB",
        "w|gs@dfwz@`lAqBht@~\\~l@|k@lu@vi@`q@C|n@_Tzg@jGdl@`zChy@~oBnOzv@",
        "q}kr@ndl|@}ZhrAerAbZgdH}}@mzAri@wt@r|AuwArbJgArhB",
        "a~_s@ni`}@t^|hBdmEdrEpz@~gB",
        "asxr@nod{@qg@j]m[`\\eM`\\",
        "gf{r@~gg{@fVdwAnC~]r@vxBzL~gBx^bcB|u@|hB`|DdsFxrCfzFxT`dC",
        "stvr@rom}@igB`p@",
        "}|yr@t`o}@|o@p_ChJp`A",
        "sler@hj_z@mPpv@epBkGsnAyy@uw@aqAwiAsr@wdCz`@qpA`pAmx@~{Bi@jzB",
        "ktxr@hdfz@`vApkA~_CnNbyAh@lOnW",
        "u`xr@xbu}@eBdcA",
        "ac_p@zlyx@egA_H{oBecAy_A}KcdM`qB{fAHmiAtS}_@~|@u]xvCkaAvyAsfD|I}pDkg@yaBi|@yZa]k[iI_[~HcZj]o}@db@}cAdW{`At^wt@nx@sdAecA_^we@cVsh@}I{X{l@elAyOr_@sn@pk@imAxlBcbChxHgnBloAec@tq@",
        "_wir@~_ry@tp@zk@dh@`]rUdm@xEft@",
        "u~er@jnwy@yDjq@",
        "odfr@v`yy@zAzjB~St|A",
        "e__l@lz{x@iA|AwPpUmy@ycAs~@we@shAoOitA{BylAeXa{@mz@{_By_CsqEylCkdC_t@quArVy`CwnBweAwk@_fDo]i}Aec@woAst@_r@ccAcxCjcCgqEvHo}Ew|@{_DccAcjEp~CqiBfu@amElaDidGvnC_cG`|@{fGeNinGwoAkRmGyx@{k@i}@{L}_AhJ_bA|^mtA~gAmFfaA",
        "orcp@b_ux@zr@naApzAfjA",
        "mdcm@`ixr@yvBp{DsrCfhEmlC|sB{iD`f@ciFq`@me@vgV",
        "wx}m@`r_t@r{Blp@~dEvbDn`Cbj@`wEhNpb@`Hp_Axc@zb@hJve@cFhJeX`Gc[l[wOtpCyE~zBfWjpB~|@jpB|hBhgBjmDt]nd@by@fUp~BjHpv@rVbo@|s@j\\`eBbd@ry@zjCzpBpuAdw@dbAt\\fiB}KtoBem@puBk[~zBjg@`g@`dA`fBtmGtHtqA",
        "}f_l@vftw@{NbaB}i@nd@_{Bfj@}t@rj@__@hs@cOfl@}JxwA",
        "wohl@r_ax@zArgBhJnx@rTnXxbApLtSt^hJbc@hgCh}A",
        "y_`l@|jlx@w{@`fAerEbxB",
        "wohl@bkrx@~eBvdA~nDztDpXtr@",
        "gykk@la_w@wExd@ylC~yCmfK|sA}}BlyA_J`_B",
        "e_al@tqmw@fw@`tE",
        "wvfk@zfnu@_{DnuBwo@boA",
        "ocnk@nmtu@|qCp`@",
        "yi{j@xhuv@mvEoy@_rAhU_}@`yBwe@lo@ekBpBoX`b@",
        "u~kk@vuzv@lDtjC",
        "qpik@`ouu@k\\|`A",
        "}mjk@~pwu@`Hv[x`BrSfBxZ~g@piCv[jq@",
        "azdk@b{_v@uGdjB",
        "wbek@hfcv@bn@fuA`fAxmAt}@puAxX~qAzMzvApJdb@dO`p@r~@vfA"
      ]
    },
    {
      "left": "CIV",
      "right": "MLI",
      "kind": "International boundary (verify)",
      "lines": [
        "q`d_Ab{de@oN|_@c}AgAqq@k\\{zAkqB{r@_h@whAkGmjAvPwuAdc@{v@wp@y]ccAyc@u}@ciAg`@qp@~Sen@xw@_c@xbAii@|tB{p@vP}`Gi^uuAtG{b@h~@",
        "o_n`Axzde@`SduCb~@frCfnArsBpw@vxB",
        "odg`Arrue@eDn`DiSd_C",
        "_~g`Aht~e@`F~fCzr@pjBnpBpj@btFtJ|tAi_@jl@ugAnc@olAry@om@~pCfUhmA|sBbZ`xC",
        "q~k_Aj~if@aGbbCuaAbsIga@`dBaeCf|FauAd_CwsA~|A}vEf~B_s@`qA",
        "kha`Algqg@zk@zhCjSaG|qCzvAdDdMzsBv\\drBfLbt@uJfj@qUfq@mPj{G~]`hE~{@ziB}I|xBmnAzVqm@tSwcAf[qaAzl@we@tbA^`v@|^bo@~g@~l@bZ~gE~Yb]`C|iA|s@~l@lnC",
        "{i`_Az~|d@qKhi@ed@zb@wj@f`@g_@h_@yEdw@",
        "mnd_Axfce@zLhs@",
        "wf|}@xv|d@{Qkr@s_@qLeh@vGyc@dNsTdB}fDmwCyiAt{A}qBkRy`Ei}AkuB`eBa{@tT}t@qLqoB{aA_d@uIi|@b[cUnc@",
        "wv`_Axdyd@|@jq@|ItfA",
        "{ha~@fmjl@{AjpAse@lG{z@oN{bAtG{lD~gBk}@zWkv@nCw`AeDyfAdDqgA|`@mx@|t@kc@`{@yNrgA",
        "ouy~@dcxl@dDxxAr{DpsCpk@xo@dS~v@",
        "ifs~@bsu`@m~@phD_xAphCiZbnA",
        "azx~@juaa@|@l{@vj@llD|`@n{IfnDncXxhFr_M|cAf~AtgB`gAxpBxXjuIoY`u@~gA",
        "gnq~@rihm@wL|pC}fCn_F",
        "}cv~@`|sm@xSn`Chs@db@jlApWj`At^vPnv@",
        "}rq~@jzbm@s@foB",
        "qtq~@rjfm@hE~}@",
        "izn~@np|m@_HhiA",
        "ico~@xz~m@zKfv@rdAftAxi@?~H`[v[xx@tzAgjAdfB|eAppA`iCdY||B|hBkqAb}BriA|xA|Jlp@za@`\\dm@ja@vg@tbA|Trn@zVr{DptCpp@j{@dc@vu@|Tf|@lUd_Dnd@vy@j_B|sBxs@`pBpa@baCfAlbC",
        "mzb~@bt{g@{MziC{hCljFij@rgC",
        "o~h~@`skh@pLfgC|gDznJbOnwB",
        "{wb~@tc_i@gk@haJ",
        "cdd~@~eji@tTxkCrmAhiA`pNxtCnrA{Ljw@eaA|r@aqA~cAwz@p~C{LvbCpkAv~Ax`Cjr@~pCdDtyC",
        "in{|@fb~i@obBxmB_lC~{A_vB`eBq{@rhBeiD|eRmjAlnNkGjhKyYveBalArs@ouCnDi~Fwf@w~And@aHvlC",
        "{vc~@zicl@h~@zhDtMnx@",
        "qz}}@~m_e@~HeNzXu\\|Nii@",
        "qiq}@~vae@wfFtSysAoOmsAelA",
        "oet}@npbc@qcBjbH",
        "ajw}@zskc@xw@hhAh{CfUldChj@hvBfiAnqBptBtBvmP",
        "_be}@hmgd@_eDdwMcs@~rA}rC`zB{k@nbA",
        "}|q}@`x~d@jR|}A",
        "el~|@byso@gj@ftB"
      ]
    },
    {
      "left": "GNB",
      "right": "GIN",
      "kind": "International boundary (verify)",
      "lines": [
        "swxiAn~gsAeDgfLeaAktD}}C_hBucD_XcxBaq@ugAcEosDnRcoAgE_s@gLm`G_mBejBgV}iBxO}}BpeA{bKzyH{hDvz@ejCnIezKeq@",
        "mc~iA~whsAh]}hBnlCloA",
        "g`ifA`nesAa\\o_Dmz@ovCugA_bB_rAi_@wkGm_@aoBi@k_Vl~AubGsS{{Fsu@euBlGafBrcAa\\lz@{`@`{Eij@rdBaq@biA{sCvgCm{@va@wn@xNyc@f\\yy@tiDsj@x}@}rB`yB_gAjvBug@p}BsUvbD}U~n@ycA_YudCUg_AyNowCigCwlDyzJayBcvCwdAquBkg@_jD",
        "_utfAx~ssAr@y|Ale@wu@~{BuSh_@ss@dXcyA`g@{Bnm@pLdm@}c@lPo|B",
        "miefAjn~sAgAs|Bs~@ujBouBsoAc{@wPanCkLueAf[i`@wQ",
        "}kgfAzubtAnaAofC",
        "_{_fApiptA_i@wsBo`DklGmd@qp@",
        "iaffAp}evAdCs_@jRyb@r`@gjO",
        "_efeAbe{wAql@gaGaiHeiPuwHqdQi}@snAa}@yh@euCigA}t@}o@ob@{aA",
        "e{dfAx}nuAhJi~@`e@wu@pm@wt@db@wz@pVgeB",
        "chdfAzmsuAaRaoC",
        "ifafAtzxtAhj@cpG",
        "o``fA~oduAqB{uAi_@szD}@yaB",
        "c`heArlkxAbz@ofO",
        "wa}aAbxtzAorDmpD_@?guFqpEavb@ovQ{iNi{B_jF_}Ac~ZckRgyBaoBeqAyvCcZuaG"
      ]
    },
    {
      "left": "MLI",
      "right": "GIN",
      "kind": "International boundary (verify)",
      "lines": [
        "q|gkAtv|w@xDec@vn@irAh_@ewA",
        "o|viA`dcx@apC}pCwoAu]qsCjR}UkqAcbB{v@quBmZmnAdCu]db@}UhhByY~m@kz@z\\qv@dBom@xOwzAbkDshB`pB{iBlyA__Af`@wnBcyA_fAofH_hAigBwF}i@",
        "angkArvpw@xbBi|M|tAqfGrzJgjVvjB_sEptBaoBbkCwdA|hCkIziCnw@j{B`qAvbCpaAvbDhIh}@oSnbB{{@h}@_T`fA{l@",
        "ufekA~fvw@cZco@kf@om@{CwpA",
        "ksujArhodAlxBh@zNnuB",
        "ajqjAl`sdAoEnuC",
        "qpqjA|vwdAts@f`BbkCnYlvFah@`oC}@`vFrsBntDrpDbvDvcBp{FupBtfBqtB~eDu}JnwAmnBhlIq{FxwA_gBjoAcyB~~@{~Bri@azBRwxB",
        "w}xiAlcox@f`Ak~J",
        "{ukhAt_jz@{~CcvCejBemAcnAu\\g`CfLqiBwGq_Bqk@yaBs}Ag~B}eEseFm~TcmBkzBwdAwdBguBo}FoMqkB",
        "srqiAvazaAtg@ywC`oAwnBt`K}yFpiBipCbcAsqCvyAmoBbmDag@pv@xOlmBj|@tq@vGfaAc\\heDgfD`|Me}FjwDetD",
        "stniAtmfbAowAsnGoDi{B",
        "ihqiAjgt}@dXwp@~g@k]le@kf@jg@amEleBizEfVayB",
        "_aliAzz|}@}hAyd@k|AulF",
        "yyniAj_kbAdDupC",
        "a_fhA|iucA_qAghEoD_eBoY{aBi}Au{AovB{aAqsDaf@_Tuh@{A}s@qVwp@qiCywA}`@w[mEoDwmCyhEwoAagAmkGapA}}@ym@cPssA",
        "oeniAji_~@~^gk@zb@cQRcO",
        "qggiAtce~@yxApCqWqb@eCyw@_^cz@my@yY}LqK",
        "a_miApnqu@~s@u|AnlB_qAdiCcp@zjCxDxtFt|A|fCbZfuBeYr|A_rBlF{hC",
        "kkkiAnuwu@qA{jAcp@azB",
        "{|iiAvrj~@h`@_h@rSih@j^w{A",
        "mi~hApdw~@myAw{@ir@}j@koDwuEit@kqA",
        "y_iiA~sz|@dE}k@bZi|@~fAitA~]kp@bLmj@fE{SpC_gBnMs~@le@qjAdaBq~Bdc@}jAxb@ovBjpBuxEjSi|Bh_@sqBzgDcvE~s@uoBf@c{@",
        "syhiAll_}@eEmwC",
        "u`_iAho`_AfVwiH",
        "}iqgA~`k`AiIwaGij@_|Awy@_}@qiBycAirBqv@guAgVs}@mo@gkAkpBg`Ae`Ck]{_B{hC|j@qjAcdAoy@i|BywA}}Bel@i@gaAlPa{@gAoYmy@qV_Us|Bjr@a{@mEwf@kpB",
        "qoqhAns_{@nYoaAxlAmdBbe@s~@nb@koBvF{zI",
        "g{phA~~d{@uR{~BSsj@",
        "}}lhAffau@|U{`C|_BupB|hBcZztBbE~dCoHncA{]lz@ii@j|@q`@fiAeDnzp@|xH",
        "mmlhAhueu@oOanC",
        "}ddfAhi{t@nm@ihBj|@afBnd@koB",
        "e}cfAd~~t@wF{sB",
        "ehbfAvkgt@vy@itAfaMqiCpoB}Sb}B_s@nuBcdAhyAceAbwCatIhJqgD",
        "qs_fAphqt@cQe`Cyl@adBuSquA",
        "idceAzyds@~lA{a@jdCs[zpBkWzzAwp@rZshAzCykDdpBqxJrwA}zD`qBqjC`\\voBpz@x`CfpAriAn|Auq@~S_rB",
        "gh_eA`zis@a{Be_D",
        "{|bdA|}cr@l[__Ax`Dpb@xqA~gAhe@hqBvEh}B",
        "mjbdAfpgr@mQiqB",
        "w~xcAb{lr@{KlmBcu@ppF",
        "wa{cAb{wr@pk@ny@zjCz`ApV{Cx]kRnd@{L`l@~InM~SnD~|@vFfUb`@~s@zu@f_CnYzk@dkBzjAt}Ezb@jaB|s@v[fv@|@l}BjRdr@`jAnx@p|@|@zz@yN|eAnCx{B`aAb_Hf_H|mApv@dfBjr@~lBzVdaBc[f`Aq~A",
        "_`nbAhsar@ldAshCnwBo`C`oCq_B|kCwd@~dSaHfsBzLnw@bd@ho@fk@xzIxaCz_CfLn~@ucDfnByZnse@q`BvbDkdAzaG}}D`aHi{Cly@iqBvAueC",
        "}rkbAjtir@{Gi|@gaAywB}@}iA",
        "}vmbA~g|r@HkgBvf@i|B",
        "mp|aAlkms@wKymBk]mcBakAkoBm~Aa}@{nIw`D",
        "{cmbAnaor@`Hyw@zf@isB",
        "{nlbAhbur@qC}}BmO{`A",
        "}c}aAlets@vOihBvAuoB",
        "{bzaAzn~s@c\\eaBkv@{jBqKkzB",
        "i`t~@zfup@pMkh@z`Bs}@~jAuSjdDmF|nA}`@nsAaxBh]yaDzNwrIfdAmxBvcCa{Ar|Cs_AzmCih@p_DsKhpC|`@`kHhfC",
        "e|p~@ll~p@}ZaoCeg@g_B__@gt@"
      ]
    },
    {
      "left": "KHM",
      "right": "LAO",
      "kind": "International boundary (verify)",
      "lines": [
        "s~vxAmagoSpdAfsAzeH`nEtm@d`Bjh@jg@llCvp@db@~S|z@zk@pq@lQjp@pBxs@mFbt@?~n@jRf_AvoA",
        "mowwAgnrnS{AtfAo~@tpCeWftBcVh|@yfB|tBuuBzgDcG~qB",
        "wgbxAopymSfqAh}AlwClmBbZt^ri@hgAn]zWjh@jHh|BfLv}Bz`Af[ht@",
        "cjivA_kakSgBt|Am`@dvAk{@zuAy_DlcDomH|yE_|Ano@gf@`\\wp@lo@sTbZ_fCveMyh@dlAqw@hgBgvD`zByd@f_A{]lnCg_@fu@wz@|TkdE|_@mnAzW_vBnmAm`@bd@",
        "ut`xAcfbiS|wB`eC~Tpl@tBhh@rPt]h|@hIb{@gAtk@{Lp]cZbO{l@ve@?",
        "{tswAiy|hSoDf_B_SvnAmFdcA",
        "yutwAceuhS|_@by@hYpL|k@hI|h@yD|e@igAxi@bZld@zl@fCzWzxBf_Ah_Az}Czk@foInD~g@rU~qA",
        "wfnwAytgmSUf@ITIh|A",
        "ahnwAqudmSliAtq@|iBfb@t`Btq@ztCpiDn{Bn~Dvi@ziC",
        "cwmwAaujmSsNf~A",
        "wfnwAyugmS?^",
        "aedwA_t|gSeErtA_Nt{@_cFxzJce@zc@",
        "kdmwA_akgS`iBby@pdIh~@jeC|h@hbCj{Arx@nbBfLnvB",
        "{s{vA_xplSk`@zaAoiAft@gnAleBs`@vmA",
        "spbwAujglSdDjRn^fChzEluDtxDlxB~MxYnOnmAp~CncAve@pAb_@rU~SbmA",
        "eduvAgf|fSgKhzE{XduC",
        "ijvvAwtpfSxDd`B",
        "odvvAqsmfSoCnbA",
        "_ivvAapkfSfB~^nXjQjaBnNd\\xOzCzjB",
        "ygqvAoqefSg{AdrGmT||B",
        "oytvAk`yeSrcAl[zfA~HzeAkG~aAa]|~AmxBxbBmdAbwBsTdzCpW~|Bss@pnAguAlcCouEjkBo`B|qJq~Cz{AssAbrAccBfzA_rAvtBu]|rBdm@fpAz`BxgA`oBrwAbyAb~ApjAldHsJdlBvzAvEr{B",
        "ksauA{mgbS}@hpDsKldBoW|}@in@~r@uxEp~CyZzl@sZbyAgU|i@cmB~qBadPvrJq`C`z@uoCfVidEI",
        "_|kvAantkS_Jh~@efA|sBwQxw@",
        "}`ovA_amkSzCfaAvPbc@bZl\\`dCdqF",
        "ojhuAumhcSqp@nc@}j@hh@}d@bo@c_@jq@",
        "anmuAk}bcSlwBlmDzq@j{AnZ~fB`_BpsC~x@jmDxXvxD",
        "unauAyjscS}mBdm@q`Bp~A}n@voB",
        "coiuAilkcSrc@r}A",
        "{t`uA{i`dSuHnxAoh@lcBag@h~@oB|~@",
        "sscuAulvcS|cAz`B",
        "}d}sAqkoeSka@rzCuLpXijAxkCciMbxOmxC|hBslDjeA}wC~{AezA`nD}AxbA",
        "qhauAgpddStRjeC",
        "sz|sAsvgfSgoArbIcErqC",
        "_q_tAk`yeSp{@`zCnNvxC"
      ]
    },
    {
      "left": "VNM",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "a{`mCqwhbSkB`{@}d@fuAy}@lcB_nAp`BauArhAktBlp@_mBxYufAjp@}ArrB",
        "gvrmCkdtaSzm@~sAvqDvvE|_A`{@rvBtr@juBpVfeBtf@zeA~fBhJveA",
        "ctskC}t|cSup@tnDiPxyL{a@byAuaBfiAmsBnZu]HygFpAiwB~g@wn@jj@s[`YifDtmG{fAlz@usFf~BI?C?elC~pAw`@~]}_@jfA",
        "oqamCowkbShExo@bObn@",
        "gm|lC{y_aS{Lpk@{Snc@mIxn@cFtRm_@dm@yElP",
        "yh_mCuey`S`L|_@fWdObYrJlQ|T`dCj{Ndb@byA~{Bl`EzeBbuEz}DlaFva@h~@",
        "eiilCecn_SkHxvAazA`cDqG|uA",
        "evllCkpc_S~q@nbA~vArS~bBvFtuAnY`{Bp}CfUxwCjaArsAnsX{tDx|ByDt}@bZjmDxsHzfAteAd|GvwEbjAloAdv@`zA|d@xlBxFz~B",
        "wfjkCulpdS_@h@]?y~@ldA}^tfAoTtgAq`@piA{pBpuBme@|_A",
        "ywskCosadStBp}C",
        "aqxjCwqaeSsmAtpBaoJ`_J_vBtqA",
        "wfjkCimpdS?R",
        "_bnjCuctgSqUjcCox@vdCehAfj@ceFpXkwEx_C{uBdiEew@`lFsd@vsI",
        "mngkC}gmfSjb@rhNt\\xx@`_EbcBxm@xnAj\\jeBtStdE",
        "ml|jCodmeS}Ejz@sYriB",
        "_n}jCo~geShHnaAh_@xc@fq@~Ttl@bZjRhs@",
        "aymjCuuyiSkSzjCwjA`eAibBnm@}xAt}@ct@`{AygArwHgf@naBgVtrA",
        "{r|jCuk}hShc@h|@rkCnYzq@naBxzEnxZxOlwBLvzB",
        "mqcjCysojSwA`{AoNgCmaDxcBgiC~xDyqAdbAyd@hj@kNnaA",
        "kxqjCel~iSvQpv@|sAjq@rVpk@",
        "ymejCulj}RsKnx@iTv\\{WxWaVnc@yZhTaa@_Hm[|@iIdv@",
        "idkjCurc}R~RpMhrBvnBptHjsK`zBvyB~gIh_PjWfg@dMr~A",
        "y|miCa}y{Rme@h|A{jAdaC}rChvI}tAbnAe{Bpk@ieCxDqdCcZmyBkq@{BjmD",
        "k_ijC{ca{RdoDrrOzLduD`RdkApv@rsAbu@zl@r}BriApt@by@naDxaC~nDt|@xzJjg@r~AnX`xDhrAh}Ab[daB?vxAiJlpArKfiA`fA`r@jyA",
        "igfjCc}x}Rq|@pqE{LdwB",
        "wrhjCkrn}RlPp`@|dAr~@pLnc@",
        "_~vhCsj|iS}@ueCs_A{kAk`ImlBg~Aem@waEkeCkpB{v@acEeXylBgk@u|@_iA}nBkmEokAel@coApv@wKtdC",
        "e~cjCyetjSvK~pC",
        "k|jhCaroyRoy@rt@ir@|~@iUr~Ai^hs@g}CdxAqaA~q@yNbd@sJbcBiJnc@etCnlCuT`p@_g@th@wwD~{Bgu@bZijAldAgbJvfLw_NjgLoc@jgA",
        "a}cjCiprwRznChlG`q@fuAjkAxm@n|Azb@dbB~s@xvCjcCj{@dOvgGo`@dp@gEly@j\\nrGrfEdd@naA",
        "ylyhCwpvvRyOtpBen@zkAieDd_D_`JtcF{vAjh@wmBfKqkBiIevAdM{l@xwAogArt@w_Ar~@qv@~gAmj@voAim@blC",
        "}fbjC{~ruRhNriAdsK`wFjvGblBt|@nn@loA~eBlvDtuJlxB|eDztDhhA~q@cOpvAqjA|~@mElo@fVlkEb|Hhj@hhBvOvcBfw@dwA|sAeClcBoYvdBdXz_AbcB",
        "mroiCy|}pRoDblC{iA~i@kpBbOewBz`Ac~A`eCer@~dD",
        "u~}iCsflpRhTr{Cd{B|iBX?|{Ez_AjeBvp@voAzkAlPr_A",
        "o{{gCozysR]r|Bql@`{BgiCljEkz@|eFaq@fiBi~@pv@uiKbvEaoBle@_hBvp@myAhrAew@hrByw@nfG{m@xwBqyGxpJcp@p_Cih@hxFkh@tzB}^vf@ebBh|A}Tb[",
        "ovsiCymcqRdMp`A~h@nc@bn@v[v[dm@",
        "{fliC}~{oR{BtfA",
        "wjliCgwyoRxDf`Axm@|i@beAqAnl@gk@pb@oy@th@yc@rr@eWhKsJ~qAnm@pmV`hWjqBt}@zqExc@|iBf`@x`B~qA",
        "m__iCuxtiSbnAiiApjB{`AveAwdB",
        "sn`eCi{ajS{Bz`Bae@nc@gu@~Tcz@~G_t@I{eHazBiqC}^_dDbD{XfL_}@ru@q`@lOar@|@kdBkRgl@^kgAr_@_}@nm@cdAjf@k{AxO_{A}jAyo@qu@u|@{MsiMjpCwnAxc@irA~eBiJ`xFem@diCaqArsAq_B|_@gfFrK{c@fHawCfe@q`A?ycAiTs|AcdAur@c[{|RanCo`Cis@{lA{bA{LuyB",
        "waxgCum{nRgJlyAst@fiByZrhC",
        "m~zgCk_qnRxZllBr~@tpBhrAr~@",
        "yobeCiezjSeNxlBu}@d_CwZj]g`Avo@qWdc@wZfuA",
        "_oieCwmljSjG`g@dtEvjExaAr}A",
        "_twdCk{qkSobAteCe`B~rAqvAft@ebArjAqa@lvC",
        "_vbeCkhbkSdE`bG",
        "whncC{zjmSk|@twFonKlcNihBdtDur@ffGkg@baCqtAfuAq_ChKccB}_Aa{AoxAigBcy@e`CxDwyAzbAmp@blB{Ad`C",
        "{i{dCey{kSri@dlBdw@bcB`RnkB",
        "_sybC_menSeqAbzAcUnWaeMjdDaxDz}D",
        "mzpcCcuvmStR|rD~|@heE",
        "klcbCc`crS_yG|dHsTtqA}zEtxEwzBrpDmdApkAejBvcAqlAv[az@zm@_t@n`C_r@zqE{LbnB",
        "ybecCw{upSdCr~Aza@f_BdiDxsFfk@|qBfjArmJ?f~B",
        "qcvbCgjcoScOf~@kg@zkBec@vnAszEzWq_BldA__@j{B",
        "m|ccCustnSth@lcBtdDfhD`yB~wE",
        "azzbCgfuoSs_@pdG",
        "uz{bCu`moSpLboBr`@tg@lbBtr@za@rs@r@ht@"
      ]
    },
    { "left": "VNM", "right": "LAO", "kind": "International boundary (verify)", "lines": ["uougCs`hnRzuAii@"] },
    {
      "left": "BRN",
      "right": "MYS",
      "kind": "International boundary (verify)",
      "lines": [
        "qej\\_ik|TqAylBe|@mbBm~Aug@ogBeDa_BaSkmCmmC",
        "a_k\\ucd|TbEiqBjR_rB",
        "un_Zo{y{Tqk@tyBgmDvnBucFnd@myUj]oiChTg`Cbc@qeFxwB}rBnm@efB{BaFsFsp@wt@c_BidFuaA}hBe_EohE{eAapBme@ekC",
        "cta[mkxvTlaEuwKls@kuItcAwbCz}CckExy@wxC|n@shA`_Cyn@zQwe@rAg_BlPel@rh@gMfp@yDzg@uStgA{`ArcAyc@`nDmo@fmD?j_CgtA`vGsi@`{@rS`kAfvArc@~Rn|A_Jdx@a\\~MctE|t@gpG",
        "s{_Yenq{Te_CzBux@yc@_e@kf@cpCouCmiBebAsgBom@wkFox@}qDeMo]nm@",
        "{}_Z{w|{TdNj{A",
        "gooWofszTejDqeHmcP}}PqzAwn@aaG}a@qxB{j@_tEwmCyqBgl@_lBhT",
        "{jbYgqw{TfnA`bE",
        "qg_Y{_gyTvEsrBnqAymAdjKy`CfyBk|@xvBcxAtiJwgKd|AmcCtn@wp@`_Ak]`zCom@jp@_^v\\a`G",
        "wy}Xa`_yTyl@y~F"
      ]
    },
    {
      "left": "BGD",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "ynceCgf`tPgw@nCev@|Kc{K`qAqcLllCu|@}iA^_|A_^afAq}CaH{x~@`jJqjBtHabE`oAugBhV_jJ}Kg`N|j@q_BbZi}AxbAigCpgDo|A~gAw|D|j@aeNfu@mhBlyAemAjnEqbDptBwqExn@{qLeDosZz}CowFyDe}AyX_xEkoBgoBsi@s~@zBw{@`\\ufBf_@u|@|@{yBmPex@xDi^fVqz@tqAkh@~]cj@lGquAuHym@tHau@za@ehAjpAqp@|_@k{A`\\moHdc@sgU~mFeoElPshG_hAolBdKaWtAw_Ap_Ctw@~fBp_HlnAdsAh}AwjBrsAenFh~@_nD~zBxrAzgGphBjdBrdGnjE`vAzjBja@~pC_m@z_BgpGrdGmsBbmAauAdmApBdvAzpAve@teC|KnmFuHhrUwcDhtFtHf{EnlCdrAjpAxaAbcBvhCpxIbpAxcBrjEvaDlcHntDrrHfuBnxFga@reEk{AjmLi}Aj~DwoAxgAqU~w@lYn}Ah}AfAnNuClz@^tStW~]j\\pAf\\oCpWvFfrCrgBzl@|j@xwAhhBlo@nm@fl@zkAja@fhDp[rsAfHpk@{Gzj@kMrk@wFzj@vTzw@jr@`\\lz@fV~l@xc@bt@`eBmTjR{|@SycAjf@qe@htAaMhrA{[tqAorAvoAc`AlYawDvFgVdO{Mlz@eSlPu~Cf_@ahM`oCw~@`\\u_Eri@}@zMcsAj{Ac_@lE_c@kGei@|@{p@tg@nD|@fj@hTjD}@qzAhs@ovBbzAuvAbwBxCziCxxAvdAbqC|_@`uGg@pkO}sBzlEfVyr@hpEkzDdtC{`GlpA}l^hpC}~@bZkq@p`@wo@~Iex@qk@ex@s}@kp@eZyc@tSwRjpAow@boAy|B|~@shG~rAuzCt\\on@zM_x@tg@s}@dlBkl@tr@keBlx@okEjs@qmBvn@ixHptD{kBj[iuCiTqHymAhEowAkdB{u@e}Ajf@eb@jfBgp@xaB_gCnYiwBwy@y^{aBuHyuB}t@_rBoeB}~@atIi|BwtBcQemAzXipCjeAwtAdDavAcZyzIetEuqA{`AocAuqAeh@elB~DirAnGwT|Qso@~H{bA_m@}iAc~F}~@umFuHa_DekAoSubGn}AcyMpP}fF}Za`Geg@uoCqv@wzAwuAmz@ucCmo@_kKebAciAk[rUg`A`{FomBp_Bew@f`AkoBxNayBwd@elBw~AufAqkBzBk~Bve@guBlPcrA_}@fnA}lK|Ag`Adh@wOrkCkIvv@{MvlDo}Dp\\s}Bqm@ymAmlBgl@yrO_fCezByDqwFf`AaoBiTkg@qhCbn@{w@jvAeiChj@ovBctAbDqrExkCciAaFzg@ihOqLmvDkaAq~CcwCywB_pDqU}{J|_@_vB_^idA{kAcs@g_B{s@efAyM}RqzAe`Ao}A_`@_tEk[{qFmz@emXy|H}_ByOe`BqAcdBrJk@PofEbqA[DqlBrX_hBq`@ogAeuDtgA}lFHa@tiFifLRa@bl@gEn@Et^_YROjR{l@rFk|@}sBa~Jct@y}E{zBquAqdAwQ{kB~R[LwaBvm@ys@vy@IVw{@~wCCCc@k@oh@eq@w@l@o[vVUr@}Xxx@ILifCxfEw@B}Qd@GXSv@sb@fjBsJlo@UBo@Hiy@bKusBfWwsA`zCycAtnDu_CbcBqb@rt@ug@zcI_YvnB{`@rsAio@pjAcdAfvAmlB~{A_`@tg@_Ivp@|VztAiKfa@k\\hj@qBlyAoNtp@}`@dc@ywA~|@eb@dn@k|@|fDqk@fgEaGphEnn@reDza@ptByo@d{IpkA|zSeXfmH|J~}Apa@`g@pjAld@h_@|j@oNpv@oc@voAfAtfAxcBh_@by@|~@tR|pCwEp~CsV|hB}iAbcB_fA~h@co@zl@cFnkBrTrt@xlArgBxOthAlGbbAxc@~|BjGt{@eXxsFm_Gj{[mnCtlH|@dbAh_AfgCrJzkA_JzyIhqCfh^|_AheEtEvt@|vAf`UkR`nD_h@`zAst@dmA}j@voAsJ`cBxN~_@f_AnaA`Rpb@pBfu@ec@zfFow@~eCkS`fAgAnwAxy@ryFii@f_OtzB~yRcErzE_{DvdN_dEds]gtOfjj@lG`lF~pAn}EyNf`BayB|gAg}Efv@ctE|TqrDiYk}@eHoeDep@euHszA}uMsJgvLcy@wtFr~@e{HvlCapP~qBkyC{VemLklGqsCcZ{b@vp@aGdaBs_AzsBae@ayBq`A{vAstAaReaBtrAmE`Fi@`H|@jIdDrIR^?|@jg@ri@xOtg@sKbe@qk@da@_qAdn@evCp_Ccx@db@elBjHemAeNelA`GigB`qA}sAtp@_fBxZa|Anc@}t@piA{Bpv@jIt{BeEzl@}^dkA}KzMoXaHegCsBi`CmBu{Ap`@uR`pBjg@~eChs@fj@p|D{KjgAsi@t]lDqa@r~BdBdl@lRri@p`@tg@jpBpaAbmAkh@|k@keBpLirBhi@~gA|h@vzAtr@lcAhiASvZ_}@yMquAfAupAxlA{m@|hB~s@jmEfpGzhD|s@rsAcFbnAbPdx@dm@bO~qA_^~~@{`Apu@ekCdwAeMj\\uGh^gBh^bYxqIJ?HHH?rIh_@pBt^qBh]sJ`\\q~B~}A^~gAt|@|iArt@tdBuIbdBkr@||BafA~pBg}CptCkzA|{E{w@hs@axBve@qlAf`Aqu@j{AyaD`}KkoAnlAwnBxm@ezJ~r@ebBzm@szD|{BaeBjg@}fDpBkGufA`e@myAcYqu@itAzB{k@zk@ce@dtC_g@~fBij@bFgu@_S}iA`\\kg@pv@i_@fhCoWbcAsj@zw@e`Bf~Ai_@beA{aAbcBis@bx@oNdx@nl@teBdcAxmArgBdmA|sBhr@fiB{B~zBo_Cfv@}rDtgA_zCfqDcy@vq@ag@dNwp@gL{v@gb@my@`eCpUtg@el@fAsiA`RobAfsBq`@nnAp}Bh~@zrGst@|pD_yFxrGwZhgDnkA||BvmEt|Ada@xaB}i@fhBywAlz@}hBjg@}~A`q@omAl`FlnDloOkgAxlBgk@qm@sgBgeFk|@moAisByx@elAxNk{@~rAg`A`nCom@bd@ylBwEuRnm@oOfv@}i@xMgu@{Kkq@cZ_^hpCyZpaAkf@xbAoy@vp@keAnb@a|@~h@_]|iA|@lcCyDhr@su@lnCqkA|{Bel@`r@ccAdbAox@bmAquAlpA_i@lbBwz@p|E}sA`qAazB`QmcCyDirBtHoa@zw@piAvnArrBpkAbyAnm@doKz~BjzBlpAH?hrAda@`fBwF~qAom@fUupAcd@w[aoCmPsi@}TqB}j@xx@_qCr~@mgJleA_eDrgCexAdpIi|Bp}CqLkRziC~Izm@lE~|@qAly@yOjh@ce@p_AxYpb@nx@~\\ht@dm@hfD|dHxlAh}AxvBh}A`zA|UvbFaI~{Atr@j|@xlB~oB~kJzWd_CfWdcA`g@fj@zl@lf@fi@pu@zvB~mE|iA`r@vjEvdAr`@jRh_@`Ht|@wF~]sU|Twe@za@}`@ncAkHnvB~i@`oBf|C|oExwBraJrrBpl@r`@tR|_@`\\tQxsGwn@|}Aij@hu@vGdw@?`dBqaBht@k\\zuB}i@dlAcoAeD{sBmp@wzB{u@_fB_iAuvGh~A{iEpmKexJ`uGmeMrgDkdDr_KcZnlAqvAzjBcjFt{Bs~@fuB{hD`yAco@zw@k|@fVe`CtGmiGhu@myBbvBohExZyaCwQihAaq@ew@u{@st@mq@{`AaFwp@tGew@rAmz@eY_}@ylBzBnbA}|Dhi@}t@tqA{jAf_AmnAvpA{w@tdCwGz|EhiBbe@}@zk@ebAjs@cQj{@yCdbAyYrfD}rCdb@}j@nN}~@vFyaClZcd@z`BsgBlQsrCqLepH~q@em@lz@}L~}@dOj{@|j@r{CxiFdbAfu@hsAvE~qAmP~|@bQhU~pB`dCwyAaHn~CqhCrjL_Ujh@gKtg@tHvp@pk@hh@teCr~@db@vq@qa@~sJq~BtuJq`@p|DoDrzEvQdw@bnAnlAlY|j@pNveAiAj\\qK`\\uh@~fDweAtbEyWteBp`@dtEhgBj|@j_JyO~xKhs@rwD~gAddDjoCpcDtRtoCfkAdbGjxEbwDjpBzf@bx@wG~gBc_AfeG_CpjAqpBnD{xBnw@ohBzvAm~@`eBoIlxBtc@rrBjyC`uHlZ?v_@}`@|t@w[pwE_qAfuBcQ`oAv{@dmApuAnpB`{@qK`pApj@~g@vjAbQxsAjG|x@|j@rKlnAbYbdAppGt\\tkBlpA`pBtr@h{Dp`@f_@ovBpf@aeBv~Bu}@fuAazAld@uR|dI?h^mEfV{Wv`A}u@vyAcx@pj@sKzb@gsDlqWugr@dpIenMb[knCfPusKv~AmsHwF}hCucCs|AcnCqaAhZifClrBwkE~oDmnCfvFqa@~X}JpeByNfVqMhx@hTz`BjgArt@~RL^xi@d`Bnn@fiCzu@r}@pkApb@f{@i@f~Bk\\tgAlFbaC`g@nx@`GjfAu]n|AqtBxmAkR|_@ouCfz@}AxwAtgAhxBpkAhhAii@tvBod@zcCmPjoBvQpfAt{@xtE`lFv{@trAvUxvBuIx`CxDlyBnhAxbBpz@hStw@wEzv@qLzw@RtgAh_@pcCvzAzaA~]vz@f@r}Ael@|x@aHbxPxbCzdAaHdZyy@`Kg_AlV__@hmAhKnn@rSdh@{Bp{@u{@~Wi~@qKkzBtHwp@h|As|AjqFiqCxgBihBrrBcvD|[ybAfhDk{Ai[emAigBshAgz@aqAh}@irAteCfMtfVznH~}EnvCrwBxw@tfCeChwBi}@pdA_sAlyBoyKRq`AoTaq@cc@ii@c`@st@}J_qAtR}hBzjCstL`Wus@zKov@sDqiDp\\{b@nr@^naA~^bz@dv@`_ChfD|mIlrIb|ChsAp_IbO|pDdy@fyBzBfeA{WpiCquBt`Bg`ApeHadCnqA_hA~r@umDd~@kfAfsAgMnxBjIlxBnWhrAbZp~ApaA~mAjeAbtAti@tpBeNnsDsiAloAiTziCoXbcCelAz~Cm{@fgDmZvnCbe@puAnjCteAcaEpv@qiAffFew@`wF_rBhpC{Xbp@~IjqArt@f_AxO`|@UrkIqiApkA}`@heDufBnx@byAxaCmz@~jI}oGtgBss@tzBga@bvCgKf~BdlBfCx@"
      ]
    },
    {
      "left": "TZA",
      "right": "MOZ",
      "kind": "International boundary (verify)",
      "lines": [
        "vmecAmunnFom@_|CymA_qCig]ihe@qt@{aB}a@gjBob@{`NwaFkw_@{`Ag}CuhL}pR}nGscSk|@{uBizQslW}~@kmDmeA_hAyvCqtBuhJopJmmDmkFojC_tK}}Cc_F_dE_fE_tD}aB",
        "~u~bA{yxmF`\\irC|gCo}Fxn@wbC|@_eD",
        "zubcA_almF}h@kwE}tAo_E",
        "fubcA{orlFRcpX",
        "|yvcAigqkFmz@kqB{hFuwFsr@uqAi_@maCqjAylBaoCifDyn@grE",
        "rdtcAmlsgFnN_Jnx@}_@hK_S~Rw{@nwAuyB~RiiA",
        "|oucAispgFuH?cQkRyMs^Uce@",
        "`lucAkujgFzAclC^yo@",
        "dqpfA{bmcF?ymCkRyuB}T_i@sk@is@_}@{a@quAqb@olAmo@q`@qjAcZoaCqtBaaF{XsfC}@ieEgVwdCg`AgsBszEmuG_dEweMyxAy`CmcAemAirA_r@{kArJ{kAld@krAdXckC}_@}eG{tCkoB`HgkAwy@gyGg_BwzAeOgu@si@szEwgKqWifBoNo}FeMqv@k|@yy@a{@edJ",
        "|oucAgphkFvF}iAr^_fCrAcdA",
        "betdAs_}iF{|DszCozKsfRanDykC}rAccBwp@_yDcy@s}B}KybA",
        "pdxcAa~ehFpk@w_H`xCc_FfdJ}wIvnBq|EvyBonNdhBcvD~@qB",
        "lzzcAcn}gFgKufAyw@giCyO_}@",
        "betdAyityEnm@y~FhiA_pD~Iag@",
        "rbweAkhhxEevAepIkf@s}@q_C}j@quAis@irAcdAoo@qjA}gClo@cbA_rBgw@}xHgtAmmB{qFabEqv@uqA",
        "hfxdAmnjzEtg@irAp_C{jBpjClz@duBgw@t{@{sB",
        "|hxdAubczEsAwjF",
        "hefeA}qzzEnx@maCfiCacFpWi|@nb@giCdXa{@tg@ks@~h@ug@h_@si@|Kyw@vn@ycB|sB{a@llCeMt{B_i@t|A`g@n_CwQ`pBew@bp@ufA",
        "~mgeAi_tzE{a@ywByDyxA",
        "lwqeAo{_aFn_E{iAhpE}hDzsDiyE~fBszExuB_rOb\\qoG",
        "zeweAydg`Far@caQeXyy@ih@qv@{w@eaB",
        "xjreAsvy_Fv\\mz@`HkzBxaB_zClPk{A",
        "lgrfAqed~E_}@agKs^a|AcQseDm[{l@_g@q`@cp@w{@quAqeFmd@wfAur@ew@gzFwlDmhI}yG}a@}hB",
        "vmseA{_ltExXanpA",
        "l`teA{sewEfa@_J`g@ih@vQey@`FuxC",
        "pgteA}n}vEcF}cG",
        "jaueAamswEfBa\\~h@qv@bn@s`@hj@cOza@m[rUafA",
        "pdweAa|mwEqAcZ}_@krAyDg@sJug@gMqW",
        "~aweAgahxERcF",
        "jsyeAsncxEkpAsqC",
        "brweAcc}wElf@wcBxXweB",
        "pb{eA}vzwEgjBwFeDmcA",
        "zlhfA_c|bFp`@kgArrBanBdXar@|tAktH",
        "`zkfAyinbF}Vc_FcZw{@_^ap@gVoo@{Bwy@",
        "zlhfA{{v}Ep`@ap@rqCod@~_@kf@zK{a@zkA_|CrJ{jB",
        "f{mfAeul|EuHuzA}~@kbFa\\kcEa\\ij@a\\g_@qLw\\?}xU",
        "bbkfAwhe|E|K}iAby@{_B`Qs_A",
        "lmlfA_g}{Eij@w`G"
      ]
    },
    { "left": "ESP", "right": "GIB", "kind": "International boundary (verify)", "lines": ["}xq{E|pu_@AsyB"] },
    {
      "left": "CAN",
      "right": "USA",
      "kind": "International boundary (verify)",
      "lines": [
        "gz_jHheflV?mnR?i}i@?a}i@?o|i@?w|i@?y|i@?}|i@?y|i@?w|i@?o|i@?w|i@?}|i@?y|i@?w|i@?_}i@?}|i@?}|i@?i|i@?w|i@?y|i@?w|i@?_}i@?w|i@?o|i@?w|i@?c}i@?clV?yoR?y|i@?w|i@?y|i@?w|i@?obA?myg@?o|i@?c}i@?a}i@?i|i@?}|i@?}|i@?s|i@?y|i@?ghB?qsf@?}|i@?a}i@?y|i@?m|i@Iy|i@I}|i@?y|i@?w|i@?y|i@?c}i@?}|i@?w|i@?o|i@?w|i@?y|i@?}|i@?s|i@?{jW?aqQ?i|i@?}|i@?c}i@?w|i@?y|i@?y|i@?w|i@?}|i@?o|i@?w|i@?y|i@?w|i@?_}i@?w|i@?y|i@?a}i@?y|i@?s|i@?y|i@?s|i@?}|i@?sal@?}wg@?c}i@?w|i@?y|i@?mtZ?_gN?y|i@?}|i@?w|i@?y|i@?c}i@?w|i@?}|i@Iy|i@?m|i@?y|i@?y|i@?eqc@?akE?w|i@?s|i@?_}i@?s|i@?}|i@?s|i@?s|i@?w|i@?y|i@?}|i@?y|i@?w|i@?c}i@?m|i@?}|i@?y|i@?y|i@?w|i@?{b\\?}xL?s|i@?w|i@?y|i@?s|i@?g}i@?}|i@?s|i@?s|i@?}|i@{Mst@ce@oh@oaA_OwaR`AofUhAkoP|@_`Jl@d`B}gJ{L{nVdaAu_JpiD{sLvy@qiBbcBgiAd~Fam@bkCqz@|sBoYbtGr^||Bom@t{BchAzqRenFhxT}hG|bIdB|}BrAhsB`F`eByMxkB_x@leAsoAnfIgwQfhCqkMpV{vFuqAox_@rKuuBvPot@~]qz@vf@kw@fj@}j@pl@wO`cCuS~^{G|_@auBlu@cpe@jk@yf^dvBssFvjMucDtuCa_EfQwgCe{A_mZ~]qeBsiAeoEeXsrMi}A_fEw~A}n@_xAnHk`AkMyh@mtEebAodEq_B{~Wnb@wrWlj@{t\\`a@yuCdiEe}L|aEq~]tlA}_N|gBcrBhgB}Ol`@lwBhn@|uGrj@lwBjoCtr@jzA{{AhTggD~To|Bus@y{OnEmoGbmA{aFnlCscBfdBmj@p_GgBptCw[xfBgdAp~DenEduH}pEj|@}nA}@woB{g@caDo|@ivCg_A}mA{`ClE}}Bny@w}BlIiaCieCcp@okCq`AmkSjTmmOtjAghDzdCerAz_Dwu@~zCmrA`zA_bBzeAegBpr@upBdiEsoS|t@i`Plo@iaCjeAqfBd_EkgEp~CxaCrwAqtCzr@{lMeDacC|Kwo@dm@st@h}@aGh~@f`@tr@rJfZ}jA}_@kcPf[{jCjr@irBxYsqBudCyeKij@okPwnBinFi{CetE_jKk}XkvAkkGqz@i|BskE_rOel@msH|wA_nEvz@cP~hAbcAbx@nDtmA_i@l_@qu@rT}_Azl@igAjuAyx@d{Dwf@xfB}~@zeBw`FqBoqHkuB}rPgGovChj@apAnw@_hA~^c}BeDa`Aw{@uxDgKgfA~I}j@jQ_b@jIgl@_eD_`x@vE}jJnwAqeHr~@kkA`~JciIpdAqoAdt@y|AllCeuJtHqoBamDuiRoTokCSmmBbUkkB`p@odCxNyhAg`@itEnC}hCvfAykKvGkkQnB}fFnvAerMxDsqCk[kpCmfFyoQgnJgj\\woMmfd@qiHm|VwsImfZguA_nKmqEqk`@sEqcEjg@ouD`lMksc@vkMmsc@zkMqsc@pkMksc@zkMwsc@|kMgsc@~kMasc@|kMssc@hgGsmSpgGumSzfGumSngGkmSxgGsmSfgGumSdgGumShgG_nSxbI}kWrbIilWlbIclWxbIglWrbIclWlbIilWbcIclW|bIglW`l@sdBtl@gdBfl@kdBdl@}dBzl@kdBzk@wdBzl@mdBfl@qdBvbBo|Az`Cqz@deJmtBdiJouBpiPetDlsCkwApkLupNzoPwjS~uAymChs@}|ClFetDw_@w|B}z@wuAchAqoAegAekBsgCkzCgu@spEoNugF`cCqeHizCyjKk{BqvGh^_uH`|AwgF~dQhmHbpEqdAhzCmsBpiDsrCd{Btm@ftAve@rsB_^fsBum@bbDom@ftA?nlAkNrrCi}@~xDs`E`{BkxEn}E}i@|Uw`@vdA}oAjnDmxB`}@whAbOakBwf@ofBw~F{iJcp@qdBsTajBlOwcC~}@_aIcnAszR|To}HjzCwmHhnGy`Jf_A_hBdvAaoB|~AqeAvzA`RnzJltG`gKf~GfuQbwNnKsz\\x}IojW`oMsf^`qN{eb@tkUiuq@dvMsi`@pgFa|Fv_G}cBfah@kkHdah@kkHdah@ykHdah@akHz`h@ekHdah@alH`ah@kkHtah@kkHxaAeLnvCf@rfDvp@hdKphEddKzgE`dKdhEhdKfhEjdKvgEtdKjhEddKdhEhdK`hEjtEf`@zrEiJpfE~aB`iEbmCz{EngA|yBjSjsDfxAtfBlQf~BygAln@oO~aAfAzqB`b@zfGjg@pdM`mDhfDn|A`tD|nCrvBbeDzaA~jEnSb_FvpF|wHfwRxsSx{BhkExhGxrTrrCf|QlfDpvF|kEtyD~hEvsB`wFjm@rnOfVpqL~zBv}GoNplJcxC`fCsw@puG}aDfnDatDzvF{oOjzIadVnbMcb]vdAisGqPmbi@u]kdDo~K{_[u~Kq`[a~K}_[s~K{_[u~Ks_[k~Ke`[o~K}_[u~Kg`[kyB{cXgyBocXwyB{cXkyBqcXqyBycXcjBa_UiNocBgyB{cXazBycXutI}}\\ktIw}\\gtIs}\\cs@cqCq`HmkXwtIs}\\ktIa~\\utI}}\\wtIs}\\_iF__J}qHurGc_G{|@ukBxe@ulAvbCse@rrC_}@frCe|AdzC{dAltA}dAd}@ybCgVe|A}e@au@vFqu@xm@cu@ldAulAltAau@jm@oy@nMsxA|Ay}@_Z{q@oc@ss@{WgpAeMibAoC{oPf_@_lB`\\osKpnEqyVvcOcvEwrQqiHa}XsvL_de@e{AagKdDsal@xCqal@zCmal@xCual@~Cwal@tCmal@zCwal@dDwal@{Nqa@_Nqa@iN{a@{Nqa@iN{a@eNga@oN{a@oNqa@uuIwjGevIwjG_vIwjG_vIkjGsuIckGavIkjG_vIwjG_vIcjGcvBwxCumHsrNig@qb@on@_Rwp@oYmo@oy@iUeaAeiEyqTsr@oaCkgBweBg`@rAwwC~r@ug@zBy`DqsDsnGybO}cIo|_@}t@kpD}rAkzAiiBg_A}|CmyAyiEqwFo_EocFcqIivI_rNivVstN_{VssMihU{dHo~Lw~JsmZq_A{pIqa@mhB_{C{pGag@qdB}~AilJclB{bFeYujBoCwoBjeAexWmAwqDrFyiB}AonReBonR}AinReBknR}AinRgBqnR{AinRgBonReBknR}AinR{AqnRgBinR}AonRo@{iHu@ocIgBinR}AknR{A_nRgBunR{AunR}AinReBanRgBsnR}AknR{AunRqBinR{A_nR}AknRgBknR{AsnRgBknReBinR{AicRAaJupCxNmbBsJ}sAym@wtGe}F{aAq`@isBs_@{_AoZ{|EqqDgtBkg@qkAvcBw{@tcD_h@}~@kq@oqGyx@gtAckDeuD}_AcnB}`@mmChJipBxiFelOve@ovClP_zC_h@isBkxEy~DguAuaBsSq{@OwBiPs`CsSe|@mpA}mBkeAuw@_t@cdAk\\eqCtSm{CdmAefBbwOkvGtgAsyAcdA{oBc{@mVeuBxJ{v@aMel@sn@{bAm}Bqt@qk@gtB{RmuGbT_|BcIokBcp@apAepAsj@gpBfAunCbo@ywBt{C}vE|t@{cCI}aCii@wiCmpAukAouBzv@kgAznBokBbtFwyAr_Be`Chx@keBoIusKcoGemNk~Qq`AojBmxBogJaoBizDqWwiA]{jCqLqeAycA{zBmzAwiAipBu]keCjHq`AbZyd@v`@ce@xTeaAcKwf@c`@mxAw|BciGgaNwmCgwDojE_`Co`Deh@up@`l@qN~jBcy@~qCwxAdlAccBtBabFebAuRsNkg@iy@gVkMs`@hE{VdRgWj\\oYzWyc@dh@co@|Fu{@{kAekBi_FqvAo|Aq~Bga@_gCx_@{~B~vA}t@deC_|BkWuvFyjDieFwjBylA_mAm\\ggC_|@{M_fCoNueC}t@a|@cbCa\\yxA_cHakNs`DcmAszKihAsfRqkB_aIyw@mjGebBcmBgnBspPasP{oPmsPepPksPuoPmsPipPqsP{oPksPcpPasPuoPgsPwpAogByc@gtAoDs~AvlD_w\\hsAu`BduD|@jsJbiAhoEsEpa@yHjdC}d@p~BakBvnJidYmAefBeaHk~Wer@erGhJeqHsJwxCa}@gsBkzAmmBcnAylCokB{{Gu]ifCmPmaDrJ}|C`yAkcEmJynA}YelAyYwxC}`@{Lqu@`HsiAmP{~DytEgy@ukHjl@_lIxvBwsHtr@onAjdDsoDp_@ycAjx@kxD`e@evA~~F}bKphCw_Hp~Cc_EbdAsu@ptAgVns@_h@~_DysGjcEgqDlz@ebBrbBk`Ghi@k]|uF_UzfYmOjgYyNpgYeOfgYcOzfYyNlgYeOjgYcO`gYcO`{@iJnn@we@pj@{w@dm@wo@zw@iJz_BhgAdvAboBxxAfiArgBih@`pBkfBvnAkSdlA|j@jfBdxAzkBzjAf~Aj]fnIqXjpAgj@|t@ovAldAcwCpM}tAoc@ql@qk@s_@kHcn@|i@eaAj}@ij@`eAeb@|_A{vAteBe}DdkBciI`{@yzIzBg{GuRe~DpLo`DloAqsBbuDox@|{EnXleAhhBzuA`xCr}An_DbjFccA|jLimIrdFzb@hfEbxCrfB`{@xxBtf@lcBgVtxDgpGrnGqfFzhDcuEfjAqfFyaBawEmy@u^_s@gAco@qKom@u|@{NelAnNomAf`A_qC`PsoAbbAm{D"
      ]
    },
    {
      "left": "MEX",
      "right": "USA",
      "kind": "International boundary (verify)",
      "lines": [
        "}qe~Dd|odTig@h{Jqv@xiDkfBt`I_fB`aIufBh`IufBt`IufBt`IkfBz`I_fBt`I_gBt`IiuWr|nA_vWx|nA}uWz|nAuuWx|nA}uWr|nAyuWz|nA_vWr|nA}uWt|nAqeA|cFeDdOoDbPgdAcnAu~F{uAwgCmGm~B~s@ydDebB}j@}_@ygBcmCem@wn@ihB_hAylBur@ozC{l@gGpA??",
        "gftfEvaf{TvQrzFdb@rjMla@pjMza@|jMta@pjMza@rjMpa@rjMfb@fjMda@vjMza@rjMva@pjMva@`kMza@hjMta@ljMva@pjMta@rjMza@`kMva@rjM`b@fjMja@ljM`b@|jMpa@vjMta@rjMza@pjMva@ljMpa@rjMza@pjMta@vjMza@rjMva@vjMta@rjMva@fjM|b@rxN",
        "up}`Ejr_sSSn`DIbaDIn`D",
        "}q}`EnwnsS|j@?zj@?|j@?|j@?fk@?rj@?zj@?fk@?fk@?rj@?|j@?fk@?|j@?zj@?fk@?|j@Irj@Ifk@?|j@?zj@?|j@?|j@?|j@?fk@?zj@?|j@?|j@?|j@?|j@?fk@?zj@?|j@I|j@?fk@?|j@?pj@?fk@?|j@?rj@?fk@?fk@?|j@?pj@?fk@?|j@?|j@?|j@?zj@Kfk@I|j@?|j@?|j@?fk@?pj@?|j@?fk@?fk@?rj@?zj@?fk@?|j@?rj@?fk@?|j@IHfjG?hjG?viG?|iG?|iG?|iG?xiG?|iG?fjG?|iG?bjG?|iG?|iG?`jG?|iG?|iG?~iG?diD?p_B?fjG?zaC?`gC?|iG?xiG?fjGH|iG?|iG?bjG?|iG?viG?bjG?bjG?viG?bjG?viG?xiG?jjG?xiG?viG?ljG?xiGHljGHviG?viG?bjG?xiG?viG?bjG?`jG?xiG?ljG?`jG?bjG?viG?xiG?`jG?xiG?viG?hjG?|iG?fjG?viG?|iG?hjG?|iGHviG?nfJ",
        "uo}`EvnurS_@x`D",
        "up}`EppzrS?x`D",
        "yl}`EfamqSSn`DIx`DIx`DIn`DKv`DSx`DIx`D",
        "uo}`EfmprS?n`D",
        "{i}`EjsdpSSx`DIn`DKx`DIx`DIx`DSn`DKx`D",
        "yl}`El_hqS?x`D",
        "ue}`E|_mnSIt`DSx`DIx`DUx`DIl`DIx`DIx`DIx`DUx`DIx`D",
        "{i}`Epq_pS?x`D",
        "ac}`E|simSKx`DIl`DIx`DSx`DIn`DUx`D",
        "ue}`Eb~gnS?x`D",
        "ya}`ExnzlSIn`D]x`D",
        "ac}`EbrdmS?x`D",
        "{~|`Er`rkSIx`DUx`DIx`DIx`DIx`DIn`DUx`D",
        "ya}`E~lulS?x`D",
        "_||`EvrijSIx`DSn`DIx`DKx`DIx`DIn`DSx`D",
        "{~|`Ex~lkS?x`D",
        "edy`E`pzhSyW|yBsl@zt@oW|[gUrdAKbdGIx`DIn`DSx`DIx`DUl`D",
        "_||`E|pdjS?x`D",
        "yk~zDpmkaSyXf`A}`@tf@cd@t]s^bf@mwCbeJah@bwDox@nlAakGbuFypI`zN}zEdtEecAf|CyvA`|@{|EvoAowBzkAq`Ah|Ass@dmBirAz}BevCnvCoXzk@qb@riBygGlyMmnAj{@kqBrj@obNdaNcmAppB__@fhB}T^ym@xgAcz@hwBow@tg@ihB`l@qv@bi@a|@hnAcaDboGs_@peBoN|{Ckf@~uBaoB~sEi_AxcG}t@`pCylAl~@siBjxEih@pe@a]rKyc@`Gi}@~X}~A`|@wiG`fGolBdgA}jLlaDspEzuBg|EzhDipD~nEomAjgF",
        "oyy`E|{qhShTbsG",
        "wrwzDpfz`SobAhJaf@v[mPxm@eCp_AuSt~@myA`{@uSzk@wEle@iTxcA",
        "yr`{DzqgaSvEpUnn@rj@dNxXp@t^",
        "o}tzDrfv`SmnAboAyNl[",
        "w|wzDdsy`S~HjR",
        "alesDnry{RysA|`AsyGx{NmOdm@qVre@_t@j[}y@~Tgf@tRajAnwAwsDjfH}sArwAy|@jYy}@\\exA|JmxA`h@etDvmBafGpv@e}AdrAekAbmBiqBlrBus@nXuaHluAg}BftB}~@vYa\\xP}tAppAga@tWk|@lKy`BuMiu@fAsvIlsBetCnNu{BwQe_FevAunC_YmaFiJclC`Q{_BhxAg}EbxBir@ly@yn@xlBw[fl@kzBzkAejDxlAcwClzAq`AnuByYh_@u|@|KkfAlEgt@dMuh@nd@}i@~qAsj@dm@mdA~r@g`@~Iug@wGa|AmFu|@zL_rAj|@ycAzL}i@_HaeAgb@me@gA__@rV}s@hgB_~@dNyaCrJs}@bOolBjgAi{D|zDycAbe@}T~h@{W|dEyOt}@ev@vf@ebAxNwdA`Gi_AvPg~AlnAaqAxxBcx@heCkTrsBqk@duBukH~aH",
        "_lvzD~{t`Snm@ri@",
        "u{huDbyfoRst@foAkeAdqAm[vtB",
        "ctmuDhqooRh^rx@jqBrz@dXpeAnM`kAtg@xm@l{@|VheDvKb~@rTf~DnuC|ThK",
        "ev{tDjffnR}sA|aFgv@ngA_fCdaHwQp`Fme@ltAupBf]",
        "gtiuDficoRpWznB",
        "ctttDhnsjR}^vbC{q@_SakBix@_^_Kk{@tS}i@jl@sLpl@",
        "}f_uDjhxjRxZtSzuBhYv~@hcAt]`_B~c@rcI",
        "wzztD`ccmRyc@ppAg`A|xAyX~}A",
        "sz~tDpmkmRfpA~`B",
        "ki|tD~`ulRkb@n{BaHz|@",
        "yu}tDj{zlR|Udq@p`@hj@~Sbt@tI~x@zA`z@",
        "ypvtDj`ikRi}Blu^{a@xs@q`AvQS|h@",
        "et}tDhhllRxi@ffA?lpE",
        "ki|tDponmRkc@reD",
        "wm}tDdvsmRpv@doQ",
        "gnutDjpbjRyDvcAk]|z@kpAbi@eO~s@",
        "_tytDdpijRhd@bxBzgAt_Btp@hcB",
        "_{vtDbe`pRom@liT",
        "oixtDpoupR~Mro@nlAjq@pm@``AtMhJ~LdSbF~g@",
        "oz~sDnfoiRcc@|nA{l@`u@ux@th@ytCtkAsnBdi@{iCpdBakAfj@qoAhPcnAiY",
        "gbwtDzt|iRdXtv@vQx~@`G~bA",
        "szrtDb||pRuMh_@c_Ap[sIfW",
        "atutDfq_qRtf@|rBzkBl_FfUnlB",
        "giptDbsmqRyCdhF",
        "anptDh|tqRxCjm@bj@hn@jm@bOzu@xEbdA`RrxGdtD|uAf[vEnY`hD|cBjMRtgB|z@fe@`f@d^jjAfnA{a@|UzMzX|y@vsAc_@lo@~b@|e@`w@`lM|eEbx@nh@xy@~^ftAzK`fAeNfeAgVbiAh@drAly@hc@nEtwAen@hYgAp[pv@tCtl@",
        "kbssD`jhiRgV|dAe|AaGwbC{q@{`BkIo^lu@",
        "}{~sDbajiRl@jdD",
        "}dygDhvo_R{Wf`@mj@b^{jBllAyZln@w~@dTkgAdMmt@xXaWbj@i_@rnBa\\ry@cnAtkA}rArt@kz@`gAeEpFeZtyC{`@HgfAxhAc}@bsAcF~^k{@pG_gC}P}z@jHav@hn@u\\|x@{a@xo@ceAnSe`Byt@c_AeW{[xNkg@l_By~AxlB_pBj`Bg{A~{@uzAefAym@tlAoY`cC_^f{A}~AvyAymA`z@eqA~i@shBrh@ug@{Boh@uQ}_@}@}Kbm@ybAfvAisArsAel@jQ_sAnDghCnn@afB|qByrGjcRmP`eBoc@ts@kqAfU_wA~Iys@vQuL|i@}[jmDsbApjBogBfjBowBxx@yqBag@gdBzBojC|~AipEprDmzEnw@ocFb\\qb@dWmd@tq@sp@fl@qdAvFem@i_@stAetD}xAtaGilAh}Bs~BrsAcdAbEouCiIqz@bZak@r}@k|@~pCam@`fA_kBaGegG~bFqjCnmAszQ|{Cu|@dd@__@vYg_Ah_@w`@dY_Ttg@mAvyAoR~g@mk@tT_mAwf@co@`QiTpa@eh@j{A}UvQcbB|`@obAziAyo@hiAmi@fa@qpAzAaaA~Jcs@nXwe@pk@aeCew@eaCdW{vFlxBqhJ|t@ssAvq@_Slx@_IdnAoO`eA{g@`]q`@`Q{mFvhImsAnn@qdCaq@avEvbCgzA`pA{pAt{Ba{BviHoc@lp@aiClxBsrB|qC}uDbeMme@bcAwq@`|@gz@~q@a`Abd@wuArV{qD|UwiB~q@}y@r{DqpBr`LgtAzrDsbCtvBec@lu@sNv_AyDfdAox@~|@mtAbV{xDmu@cbDvFilAd|A",
        "stxsD~f{hRrNjzCdlA~yCltAtkB",
        "sg}pDdmfwReuBxePixAnvDmzEvdHgWzz@wQdhAaa@lj@_jC{r@k}@`]ol@|y@mPv`AsVbtLygA~nKuiD|wP}sBnmFobHtkHc|AxuEcdBrgCahEjlEi~EbnBi_@`g@_Sxs@g`BdtCkoB|cBaf@z~C",
        "ccgsDttp{RnB`mDpr@vnB",
        "gqerDtswrR_@nd@",
        "grerDdyxrRdIx^bu@`jAjk@be@|_AfLbsB|@zpFzuAfkA|@lz@in@nvAevCfeAix@hZhdA`[zgD~zDpzGdr@~_@",
        "srbqDb}isRubAziC",
        "ivdqD~gnsRdaBlsBvyHnjDjaAvs@dd@ds@ptBnxFve@jr@fz@d]pnBbd@",
        "iucpDnz|uRu^|yAqrC`nDca@~v@iSrjAyaCvjGqvG`_Ics@nc@ql@lOag@xToc@ht@uHpo@",
        "iq}pDpdawRtHrgD",
        "ujjpD`aftRcN|V",
        "yyjpD~xftRbNfy@rvEf[bgDxsA~eAr|C",
        "iucpDnvtuRklBvjA",
        "ubgpDfbwuRhJtw@|z@jv@be@dgA",
        "yo_pDraouRco@|zAybBs\\c_@oH",
        "{cepDlvpuRhZp{AfRnb@",
        "}c|oD|aqtR}^nsF_rAptI",
        "{v_pD~kcuR`FrtJ",
        "q_tgDl{d_ReYpV{iBx}@s`@xd@",
        "gfygDrwh_Rh@t}E",
        "udd`Dt{s{QaQtvBg_BxaCaeAnNonA}f@aoA{u@afAiZmoAfLknDzfAssAvjAec@n`Dow@ntC}qC`g@uuHlk@mdB`PmtSlzFmjHrnAsnGtwA}hBvyAo`BlhB_gBhxAi{E`gEuqAxcAetDdxF}s@hy@ecAbY{~Bg@wdAlOmp@zg@sJzp@gAru@wQvt@cdAb~Aeb@dWyjCloBckEazBsu@oOcx@rKgl@|Y{b@xZk[dM_}BgLimG{yAyvBwVcxBvKmnB|i@keBhcA}~AhxAsIvPu^pfAiTxNuq@bKmPrI}Ujh@i}@~nD}`A_h@giBqjBwy@gUqaAcFkpAi_@k{BkRunCuv@iiAmPegFnCc[oCywA|Tur@zWeWfp@yDf_ByZhc@q`ApBgnCwQa{FXu{Axo@mdBb|Bgu@~{B_^tjBcZhd@iwBbjAiZ~|@",
        "euvgD`d|~QlPtkA`aAxbCbAzeA",
        "wxa`Dt~h{QsJ~c@qv@~g@cQp]oCnzB",
        "qrd`Dvfp{QzL|sB",
        "i__`Drg|zQ{`Bvu@{a@ju@qBtuC",
        "sgc`Dlkd{Qbf@|iBvFhg@",
        "a~|_Dl`rzQmwCleF",
        "ova`DzfyzQdvAv_B",
        "ijp_DlctyQ_hB{WqjAl`AayBfvE_gBx|A}Vfa@}@~v@",
        "yz}_Dh{azQpW|j@|Kbo@",
        "iu|_DjwdzQqb@bdA",
        "{x}_Dn|fzQlf@`f@|Ibt@",
        "of|_DtxizQ{Lp{@oc@p{@",
        "{x}_DxqmzQxYrmC",
        "ijd_Dnv`yQoNzpAwf@~cAmnBt_C{Kdq@yEvv@i^pK}sA}nAqv@d}@oYnhAmEppA",
        "mqp_DzmqyQbFptA",
        "yt}~Cj{_xQmnCp_Cq_ArqDem@jbEevAfsD",
        "ejh_DdfuxQz~BhoJ",
        "_qa~C|}`vQuHtxEs~@~iFc`F`eNk{@ry@sfEdpCsi@ze@}@tdDiTzfA_~@?g~Bqp@qk@`mDufBxdEkr@blD",
        "ega_Djx|wQjqB~aB",
        "sj}}CblpuQyZp{@yvC~q@eXtzB",
        "mwc~CjwwuQleApeH",
        "af`~ClfxtQym@vfJ",
        "{ta~CdncuQzBluA~{AlaEjh@`dC",
        "gbx|CbgoqQsTvcCcyAl_Ay`Bza@em@lj@{BfcCmPrhBme@hbBecAzoBgeGtwGugAbuD}sAl`AccBrr@upA|z@_sAptB_r@brB{WjzBi^z`PiUnrAg_BpK}^`zB",
        "iqa~Cp}|sQ?`{Mfj@xkK",
        "mmn}Clo{oQl_@lyK",
        "_mm}CzihpQwPtkH",
        "w~m}CpvqpQvPdrAvdBvPdaBhrB~g@xpC",
        "a|e}Cr`}pQaeAdlB",
        "cbh}Cxm`qQ~{ArlCdb@~WjqBwPlmCmk@vxBpB~r@r}B",
        "ksv|ClxgqQwPr}@kg@tX{l@vQ__@hi@]pp@",
        "i|z|Cj_nqQ`\\jIvd@pAfVxY"
      ]
    },
    {
      "left": "GTM",
      "right": "BLZ",
      "kind": "Indefinite (please verify)",
      "lines": ["}t`cBbpk_PgdS}u@c|u@gqBksq@mhBwrv@pHqcu@ha@mei@vY"]
    },
    {
      "left": "MEX",
      "right": "BLZ",
      "kind": "International boundary (verify)",
      "lines": [
        "gnzoBteszOhJy_@fv@a{@pZmn@",
        "gpwoBtg|zOgFav@cj@y{Bs_@_cA_Jci@",
        "egyoBv`b{OxEy}@t]yx@lPm_A",
        "}ydlB`mn}OoN_w@kq@od@giCg[{k@wZidFc~HgaAyy@osFmxAow@u\\giA{{Ayn@mtA}t@wiAq{A{{@ibAwRelC_Rc}@cPyxFkzCgeAySavAlTcQ|Ua}B}pDorAouDmu@miAo}Ay}@ogAiQcUsDyaBmIgiBsVscBe{@usEe`E{sBilAwfAuTq}CoWeuCkw@}{Dm`@ubAs_@im@sn@mnCo`E",
        "gyxoBl}~yOxDqb@",
        "cpwoBjynzOwDuc@gRoc@aLsn@aBcbK",
        "anzlB~mo~Opk@{dCbxA_fBxbBo|AnlAchBlFmiA",
        "mjvkBbde_Pq_PlDwvFom@muDqdC{sDofO",
        "y}plBbi}}OzKgz@vnDwtAvy@goAnkCyyF",
        "soplB`p_~OeM}eA"
      ]
    },
    {
      "left": "MEX",
      "right": "GTM",
      "kind": "International boundary (verify)",
      "lines": [
        "cuvkBns|iPh@g}i@f@s|i@r@y|i@h@g}i@\\m|i@r@c}i@h@c}i@h@w|i@",
        "oohhB|zjjP{ut@mB{ut@kBst@kq@ga@{_C?klG",
        "qbihBhq`mP`RkutA",
        "su{gBfvolPiTf~B}sCjq@aq@f_Bme@d`E}~@hpCeaBoYaGym@",
        "{~{fBt|kkPeXh}@ohFd}EquAnx@}}@xYymB~^sj@lYs_@nx@}^p~Bag@pW{_BrKwoBnb@yaBfu@ew@dcAwGxiD",
        "oo|gB|njlPzXhfD",
        "yw~eBtakjPmP|_@aqAnmAm[dc@iqA~mFs~@riAq`CvZeaAdb@c_Gr{E{u@dWovB~^ye@f`@}JfaA",
        "un|fBdfgkPxNnuC",
        "ihqeBvgiiPUrhAo_CnmLs_AhrBipDxtDk{@p`CkfBycBap@dNgMftAIzkB",
        "y~cfB`wijPdYtIbx@}Udx@oEnYj|@",
        "wsfdB~lkhPwe@?iqCkqAy_FrtAojQleLmdAlyAekBx~E}hAj{A_iAiTii@?ym@ftA",
        "ywreBfmgiPnn@ny@",
        "{krcBxwdhPwz@s_@{k@ov@cn@ij@q`ApBui@~fAyD|~AgVfu@g~Air@cdBfUqhBug@exAkSkp@~sA",
        "meidB~pghPrh@`QtS~ShIr_@`Hhs@",
        "qymcBpeqgP{v@re@kdC`\\Ip{@",
        "cwscBxeugPxm@baDxNp`@",
        "oxqcBni{gPuRzc@mPxvAqBlcB",
        "eascBrjbhPhTdlA",
        "oaecB`i{fPeOxc@k\\hm@mZb_AqWtcEob@dOst@mGcdAr_@qa@~c@kg@pz@aRvdA",
        "i_pcBtolgPvdAztC",
        "mv{bB`isfP}sB`gAyb@dGaqAh@yxArKkGnb@",
        "mcfcBvjwfPfWjv@tH|eA",
        "cv|bBr}xfPxDctAzXm~A",
        "i}xbB`i{fPowAeOi_@gz@",
        "aymbBde{fPs_@zyAqk@n~@gVwj@{b@erBqtAk{AmcByc@moAns@",
        "ykzbB|sxfP?ri@nm@??ni@",
        "ovkbBne{fPoNse@}`AI",
        "}gnbBp~yfPzMre@",
        "g}lbBl~}fPnW}c@fM_s@",
        "iskbBtl~fPuGwFyN?mPoE",
        "ovkbBbi_gPdBm[",
        "qngbB~s|fPg`@lVmdA`e@g`@rV",
        "k}hbBzs`gPnYsZtHkRrI{oA",
        "kngaBjbbgPsiBlWwxBevCqiAfoAye@?qu@qhC_~@dh@mbBxtDquBpVgtAgk@yw@ukAga@ohAi_@nsAyn@n|@_}@~HgjAqeA",
        "gaxwA|y_rPeRy|BgcCwoBcpJmhCcpFkdC}~AqWutBxDyrHhmBal@nCgzAaGap@pBayC~x@es@pLsbCbDwiAi]irC{`CizD{eA_dK`QqlE_TegAaiAuT_mA_HsoAga@eqAegA}~@ysGuzBq|^thXgdBhn@}sBfA_lBoh@}_EmrBa|NqoH_hI_dEmeKuhFexXklN{wX_mNsnUomLi|NmoHy_EsrBwkFclCuzAgjAyo@mcBSszGs@_}Y_@u|Yg@k|Ys@w|YSuxX?ic@s@u|Yi@m|Ys@k|YSyoP{LmyBsf@goBCIqA{@_^_VywAci@_s@mQ",
        "{|haBl~}fPnMzb@dCxNxDdJ~TpU?nm@"
      ]
    },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": [
        "cmlcAdimiO|yA}qDr{CioD|nB_iE`fFqwRxrHckYzpAg_FxfIw`[fnJ_p^xNwnC",
        "ofsbAzrajOeqF_vC_tFeqBuhF_oDwtAooE",
        "aeqbAxjycO|n@wmBrgD{lFnN_lB",
        "_rwaAntfeO_s@mqC_cL_dSalHomM_m@wbE",
        "mdjbAnzfcOjl@eoCnfCuvHjHw`@vKi_@bOk]`RcYlmDcmCjk@mt@h^aw@zXuaAvEocA",
        "_}ibAdakcOmFueC",
        "o{yaAfuhbOoWgz@cwEeoIi^ct@"
      ]
    },
    {
      "left": "HND",
      "right": "GTM",
      "kind": "International boundary (verify)",
      "lines": [
        "il~~AvsmyOlYbhAdw@pRxbAeDjrAth@",
        "obw~A|tqyOom@pe@",
        "_qx~An{ryOfk@tjB`p@|zAzb@hbBpAvbCzl@db@vyHb|DrrGdaHjdIvjL|yCtjEH?~xK~`PvvKp}OzuK||ObsKhyObpQ~tW~bBxxEzlEtyRd}Ax~D|^bg@|cAtuAvoBviAf_HxaBlmBwxBvcDHnpDjlAfaA~n@vqA~z@~`C`zCdhA|o@ptBbE`vAu\\poAmu@lrC_}Bh}Awy@hsG{tBltA_cA|o@ex@dg@}Y~NuIjiBiJ|o@zN|dAhaAff@hUzyHeY~mBfBnfB`\\~bAnhAlDdgA",
        "qr|wAbui_Pss@|{CkLvkA",
        "qt~wAx~p_PjLjiB~]hn@xo@j]fcAtw@bcDvbEpzA~uAtkBd}@bt@nr@ja@ziCtg@~~@ppAng@~aBhJfaEqL"
      ]
    },
    {
      "left": "CRI",
      "right": "PAN",
      "kind": "International boundary (verify)",
      "lines": [
        "_pry@jppxNzmCaiJnyEycGhUe{@",
        "kmhv@bbfyNcdAZu~^hLglVtHwdOxE_wBeOkvAos@{g@wsBel@ilIys@e|A{q@_ImPv[gKzg@_c@xYojDfj@}cCvjA}x@sJkbB{eAk`BcsB{KirB",
        "}|ey@ha~vN}Aqo@kiFdbA",
        "e~gy@z_dwNdNc~A`q@m~A",
        "en{x@zajwNwKarA}nAig@ynFeYobAmk@",
        "gggy@`sywNpfA}~@ruC}nA~gAkaAv[q|@f`@ilBzRasB",
        "ipfy@he{wN}Ugq@",
        "{cmq@lyoyNgApf@sZza@iwAl{@eb@``@geB`nD{{@jx@imAcFmk@av@{}Cq{GceGssGqzAqrDwt@uoDynAcbDahDeiCawDsy@szEmQwrLxc@{|Drp@o`DrlA_qCngByxEdcEgqApv@iwAz]o|AmF}t@qq@_rB_yD_bAiy@ctA_@i]rp@m[t\\goA{{@{r@ygAwdGucSwoB_zDajCstA_G_Dyy@zWulGd`Duv@vsAc_Bf{GaqE|}Ge}@nkCiTtc@me@vZgp@rPin@lU__@lj@",
        "k{jv@lm~xNHtx@tlA~yD",
        "eh`p@d}}xNmmCcf@avG_^qkUfhIieEr[c_Avi@cx@jlB}F~w@",
        "wanq@`nmyNz\\jjA"
      ]
    },
    {
      "left": "COL",
      "right": "PAN",
      "kind": "International boundary (verify)",
      "lines": [
        "si{s@n_gwMduAzGvl@d`A~HbdBfUvcBx~@`eBrn@nEr~@a]lnBcF~zCfjAryDnoDpgAtcAjxD~r@bnCHbc@qw@",
        "qlur@`{uwMza@shBbu@}_AvmDifBbyEwyAvkLur@v}E}t@tjBwdAf\\onAxCirA|`@coAv_Aom@jzGsfCfkFa`DltAgy@rxIotDtfNaeCxuCsJ`zA_h@dx@k{@bo@{aA|~@a|@z`Bwo@dYzb@",
        "c{tr@~v{wMmP}zD",
        "eylo@ha_vMsApfF",
        "y{lo@zhfvMbf@|zDldA|pEbcBz~DvbClcCpdJz~CngF`wDfkAjSbvDurAbxBe_CrrBcf@jdDnvDr|OpkZd|Gx{Gr|Bt{CpMxlC",
        "y||l@vwsxMkfAnaAkwHzjAsqAnn@qhFblD}JlOqK~s@yOjQqVIqv@yXoOqAwcAt{@{gGhwHqa@r_A",
        "{qbn@nsnyM`qAxtCrdFlf@xhGk\\b`Eew@ppGelC`eCwQx_Dfw@rrB~{A`fAnvBrT|hC",
        "ofrl@|qyyM}_@dtC",
        "mgsl@bg~yMvuTtxEhmXd~F"
      ]
    },
    {
      "left": "VEN",
      "right": "GUY",
      "kind": "Disputed (please verify)",
      "lines": [
        "ou_p@``smJgFqeC{|@qhBilBi~@yyFys@o|A_hAygAgG{fAxN}xAXk`B_m@e{Be_DohAkaAyr@kkBqfAiwHwFk_Cih@u`CqkByvBaiC_nAo_CsEiqKdyFgtUliSipP`~JE?",
        "gm`p@jyzmJvVixF",
        "afvn@rnwoJoYkpGupBcwCunCaq@u{B}hCkmE}mH{TeWcrA}zAccBg_AqsAiiA_sBekHwxAokBweBsbB{~Aq_Cei@gdC",
        "movn@n`hpJjH{pO",
        "srpm@r_}pJ}j@wy@moAwVu{A~MqgD}~A{bASouBtS}u@qCox@s]}eDukCqfFkzB_rA_wA{m@okC",
        "ccqm@fz_qJnOsyA",
        "munj@~wppJ_vIfrLebAhbA_yDpzAayD`B}gDylA}fCcwCgk@g[em@eMwp@Uur@|JisA|u@kmDpfAcoApj@ea@lk@iUtw@s^nq@m{@dXss@gAmf@wEcd@vA{l@fZmy@xsAuR`vAk]hmAogGxoCwyAtc@i}AnDmbD_wAmyAmzGyvBa`Bq_DiwAqtAg|@k]yg@",
        "_qwj@fdtoJ}ArxAqa@hcA}i@z_Aw[jlA]h`D",
        "c_{j@vqbpJjp@`dCf_BpdBluFvhCr@zpA",
        "{dji@jmooJwtHyx@_hBms@mnAo}AmcAmiB_hAiwA{uAq|@ufBqo@ylBiY}hBtCoaBln@kgApoAywBfxEwChCypA~hAug@liAmEdqA",
        "e`xj@h~poJdN|dB",
        "}bli@tvroJ`}@ihB",
        "aggh@ptrqJem@kcC}hBgdBk|FepDeqAqdBar@{tBqjBw`MmmNq}Wcf@ifD",
        "gbrh@h_wrJvEgpAxd@qiC~\\yh@xi@{k@tg@wv@lU}iA",
        "seah@de`sJwQy`CyXaa@mqDqhDyX_Jkr@qAyx@zLqvAt|@{dAzLeXic@",
        "k|mh@nv`rJv`@{~BvrCucFx^k|A",
        "wmlh@bjirJyCgy@m`@aoCkGihA",
        "yhbh@pbisJdb@k|G",
        "wq_h@tulsJavAcrB",
        "_nah@t_usJjRgcCzg@wdC",
        "e|}g@~xvsJypBix@",
        "}k_h@pv~sJpK}gCdb@ssB",
        "evvd@j~btJkRsdAobB_SmtA}@{kFo_@u|@bKeStR{LhTii@lPgk@z]ecAbmBcx@|_@mmD~m@gdAzGklHce@uuAo]cjAgv@cs@eLur@sAer@lFar@vPi|A~bA_zDvz@o|A|o@_wAl~Aso@dvAu|@|z@}~BjM}uE{k@qfFgzAu}EcyBs_F{bEefAgz@}U{tB",
        "q_wd@|yetJjHqzA",
        "k`w^`gvqJkeOp`NwhOnxM}hO~xMciOlxM}hOnxMgiOxxMmhOrxMgiOnxMu}EphEwzFziBycAg`AgsBmpEogAuzAyoMcdHgfE_nAuwAix@uk@_rAme@knEy_@oeBgk@gjAeqA{{@e_DebAgeAmoAqLauA"
      ]
    },
    {
      "left": "COL",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "g{`LhyrzK`Hi}A`_BakGro@ybBhzCi|ClfFg}BtgNseErgGgtC|e[ohThhN}oFfpSytElkKmy@~ew@vxCzdIgVr|Cis@tSoaC",
        "}zrIjky}KcFa`Fss@{}EyhAckEokCawFsqD{|Dwk^oqVe|N}~MoqB}oFsqCghDubAqiBwZkyEc[yx@anB}hB}`@wy@",
        "aphKdxe_Lnh@w\\h|B]nm@gLhn@kq@rT{l@dY{_Chy@unCduA_}AjqBu|@|oKshChoGo_C~qF}fDdkDspEj|@uoE",
        "mdoIdzn_LSquMos@|iBme@hs@eh@jQsmAcEqu@lP{]`q@_IzhF{oBpL}gCqLciAly@uRp}C{X`h@asDmxBef\\_vJak@}t@",
        "i`dFttixK{uC{~OuoBatKyn@snF"
      ]
    },
    {
      "left": "COL",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "mfyIdlmgLv~AweMvgEyxMr^c_G",
        "w}qI~ijhLsTm_GqbEulLoNunF",
        "usrId~qhLzAsmB`RqdC",
        "anlIbhaiL{`@sqB{jCwjG{VqjB",
        "i~nInkhfL?gjHSksW_@}ya@g@c}f@i@{|f@]}ya@UusWIcjH",
        "_plI`xjiLRu|Ah@gqE",
        "ynmElpeiLqLvmC_uJs@qlLkA}kLwAqlLcAklLqAwlLgAelLmAmlLgAklLwAmqF~l@",
        "ewmEblohLeNp`AghCtHs`@vu@qLfoAqBroA",
        "kbtE~nxhL~i@|{CpgDncG",
        "odmEnrmgLwFr_Ai}ApnGcDvoC",
        "uopEls|gLnwAtwQ",
        "oizBrgceLae@wsBymAye@woBlVyjC~bAii@jm@s~@rfCyn@jq@guAvQqu@gl@mo@k`AgaAoi@knC?wuGp|@oaC{LqU_e@uHwz@a\\im@ssAHks@zg@qj@vhA{v@toCq_BrcBw`Fkb@ssArgC__AlQ}gAlE{x@xOol@dm@meA|hBadCviB}~@zyAo_DjwHmQ`dB",
        "eloEn{hfLnXhbBxuEtfH",
        "{{gEnfufLsJb_AceAztBk[x^c[`RwZbZoY`w@wFpz@",
        "cdnEb~`gLl[|eEdBllE",
        "ecnC~|`gLv\\i}BzkAopB~|LiyLtT{f@",
        "sa~Bvn|gLsgBczA}gCk`A}t@k{B}LasBy`CkhEgu@gzBaSe_D",
        "wzaCxghhLbnAkoD~h@ugE",
        "}kqBjt}iLaSquB{a@mxByXmkLur@u|F}tAakFiqBwwEayDumFaG}}A",
        "mf_Clq~eLlcAiy@zjDnY",
        "{d|B~jjfLey@m}Bae@}hCi@epB",
        "c}{BjuheLfj@atBjGuw@",
        "_{vBz{reLoEgdBu\\qk@i}A{aAk]mo@g@k`A",
        "g}wBv`zeLfa@{cF",
        "cvwBrq}eLcF{oB",
        "_irBbhbjL`\\wrC",
        "efoBjqnjL}_@gtB_}@{dC{BcmC",
        "yzqB`nqjLrsAu{A",
        "~lzX|_`jLqLyEeMaFeMyEqLcFqLwEgMwEeMcF}KyEqLmEeMgFgMcFqLyEqLaFqLcFqLwEeMcFan^mvDun^ivDan^mvD_n^mvDun^ovDan^cvDun^}vDan^gvDan^ivDun^svD_n^mvDun^mvDan^cvDan^svDun^mvDan^ovDu~J{dA}xHsyAg~BbA}iLoqBe}GtCy_QkeB_wGbPgCHm|IkfCkzDxcAczJrjF_hAXq_Cwf@wdAqLalF|_@{MqLcn@jXeX`RsL|^uHx}@s^be@}eE|gCyc@hy@ey@hgCgj@~r@_sAnh@s}@{Byy@_N_hA|EybAhd@ea@lj@iVjl@md@xh@cxAnw@u}@dNe_DkQowAtp@ohGnjFsqCr}@_pBag@qeHabE}rC{g@qjAbPks@zb@wn@~g@i~@|_@k|@vKkxD`B{iC`\\i|Bfq@omB`lA_|A~kB{w@`iBsyDxrNgkAn}AckEtyDel@j_AebA|nC}j@n}@u}@|m@ojCry@yy@fg@ybA`jBqv@jwFyl@psBqv@`bAknEhjCibHd}HavGnqFoaC~gAg{E`c@}xHgGq~CeC{bLsJspQyOygTwQ{gTaQspQyO{bLsJo~CoCwqLsJ"
      ]
    },
    {
      "left": "PER",
      "right": "COL",
      "kind": "International boundary (verify)",
      "lines": [
        "joj@|o`hMod@xfB{l@jtEwy@zdCs_AhrAwtGr~Fu\\`f@mPhy@sAtlBuQbt@ydAhgAypIxtFu|AxuBoaAnbCgkAhxGqLh|B",
        "xtDdy_jMtS|~A|~@`{@xwBhT`oAh^j{AnlAfkAzaB|_@r}A",
        "tcdAtowfM{BjuAgVdd@s^nRk]x^i_@hj@cZbYuQff@{MnzCu^`zBaFl_Ace@rmB_sAap@maC_kDyoLhtEi|B~wAsrB|aC",
        "nh`@`eugMlPhiAhxFxzC|u@feAdDn}@",
        "zndDpnpdM?avAcdAmd@ymAfa@{`A|~@_hA~b@ccBwo@iTro@gB~jBaQp{@m[hi@oiFtrEazAlj@ovBkAst@}[cdAmoA}j@yM_cSpiHew@rKmAFgdAxEu}@lLcZ~]eBbtAgMl`@evAfu@k{AnqAs_AbiA_cFnzJq_CvaDwtG|eGchHtoDyn@zz@",
        "pjaAlqqfMpLjbAj]~r@t\\jf@nNn^",
        "l}cDdssdMlPscB",
        "`lfEtnkcMipCr{J{bAzsJazA~dDyuDzjC}yGbxAirAj}@sgB~zC{w@`e@shA}i@eMolA",
        "fetE|kwbMi_@zkA_i@vq@qt@d]krLhqC}`AnfA",
        "`p`EpcccMxuDv_BdDjiD",
        "pvxErxmbMyl@ltAur@vGylBmy@ur@`Fqk@~r@",
        "~foElwpbMxOn^~f@|TbZrUh_@hcAh_@r_@tHnb@",
        "x~mFzpmaM_AriAiT~bBwy@xeD{w@puAe`Az{@koDpoBawFz~Acy@dc@md@dfB",
        "tjwEpugbMzj@`bE",
        "`h~Frwh`MyDfXm[fJmcApH}_Bjl@adAbOqv@h_@si@|qC{vA`vB_SfdAqW~oCqaApuB}}AnvAkoBds@",
        "zbfF~edaMza@b}Af}ClcBxy@hgB",
        "`tvIlze_MeDb\\iT~G}rAtSgV`HmvF~rK_zCh|BspFqLumEefA}}Awt@yxAyvCovBcE}cGt`AaqAvG{`Ac@_}@vJebAho@}_BvbCclBxdAqkBtfF}}Atx@{uBaaB{`Ae]el@z`Bkh@nb@kq@l\\si@|JsfClFks@|Jel@tRyDlV",
        "l|}Fndf`MrJbrA",
        "``iM|da}LadCle@qv@pv@ybApoGcdAteByn@nNuyDt]q`@vRg`AftA_^tRod@|K}}A`z@k|@|K_}@aGkh@kSybAow@wkEabFufCwy@}mHcwDymAhsAcbCvo@knCfa@}sBhi@y_DnkBaqAhi@eaB|V{vAwG}{Cs}@ox@}LsgBdc@wlDrrCquAf`@qgFem@ocAhi@q`@hs@eXby@ij@b{@izD|eD",
        "xhsIz`a~L?|~@jdDpXhTtf@",
        "juvIz|`_MkIxwA",
        "~jvItuc_M`HvcA",
        "d`}Izgs~LuH|~@igCduCwp@dmAiIpjA",
        "brvIvw~~LfBbdA",
        "ncyI`be~Lgu@rpE",
        "fmwItsk~LrJ|~AdaBvcBbdAnn@",
        "xujLf`ytL}hBrt@g{EkHs`@xn@",
        "~m_Lh|{tL~|@hgC~dFtjJnC~}@r_Ah]|wIv`FrcFffHno@xl@ziCv[zkAzkAbZbmB",
        "`dcMjnksLyn@lbBq~Ahj@_dG`GqtBj]st@jeAgiAxfJwdAd`CyxAfsBshA`zBoYrrC",
        "pvfLzuntLzjBhpEjR`xB",
        "vspLxq{oLk]t{CkoB~gGqCprD",
        "l`lL`knpLzvAz`AbmCwLz}Cix@r^tw@lGhhA",
        "dt}MljenLq`@~i@{kAbJquACi~@dGybAre@mbD~cEgKvVotDBcp@zM_^b_@uSx`DwZbsBaqAbeFmlCrvE}wI|bIsrBv|D",
        "fznLnpwoLnx@h`C",
        "jmyLzgrpLyOdmAi}Al|C}@zpA",
        "h|uLje|pLj]llDdbAvmCxfHnvBxxA~oDvzAptBdMnbA",
        "daoMdk|rLoaCveAyn@{WolAguA}s@cPs_ArU}zDfsCmaEnlBsUr~@",
        "xvvLtiesLbxAzuAniFt|@rhAbo@",
        "huxMhed|Lmf@bp@sgBlz@w_HfiBmnAvyAob@jSmkFnmL",
        "be`Mvy{|LdbAdNllC|hAhiA`qA",
        "`xeMd|fvLqv@xfK",
        "n`dM~csvLpAljEncAlmDbvCvmDzzHnrG`\\h|A",
        "lihMbcuqL}TdaAqv@|iAoNdcA",
        "lleMlt{qLbc@t{AncAnaCvZ|rB",
        "xpiMpgfrL{tA`p@",
        "|zfMrxgrLtxE~}Lpk@prE",
        "dt}MtiwxLmY|rByy@nmBqjA~qAqjA|^oo@zv@wcBx_Smd@ztBidF|zGmz@xlBmPrqB",
        "|zfM~ikzLvcBdmA`tItcDrhAbnAza@tfB",
        "faxMtsxzLeMxc@mbDhT}~@vP{u@dYsk@~]",
        "dlmMvx|zLzc@dlAdl@vq@by@h]zkAnO",
        "fetMngb{L}sBjcDcc@hgB",
        "dloMdtj{LnlA`zCh~@pqDtfAriA~]fuA~s@xgGRxx@",
        "rwuMl}owL_|AjrK",
        "rzrMxp|wLdDt}@|_@x_DxXh_@|~BoDzj@xPxOpt@nNjpCz`ArxFrJdkC",
        "r~fNzy}lLec@hhA}s@~a@}~@~TybAhc@qaAhmAgu@tlBec@duBqLbhBmo@v_ByxA~kAur@vpA",
        "fytMh{wmLbdAblBdy@tNjeAeDlz@nDxXho@?t`G",
        "zbsNnbmlLwQh^{l@lf@ox@~\\}s@|Ba\\{\\ag@miB_Su]ufCk\\u{@vmAgMvcC",
        "`hdNhzplLh@feCbOfdA~~@|qCbDb`A",
        "zaaOnjqkL}j@|rBwnBfeAohG~vAsrBnmAybA`hC",
        "fenNft`lL`g@~vBdkAd|Bjh@`xC",
        "vihOlgdkL}_@xx@{u@|Ii~@aAu}@jQ{_BvzB",
        "`s~NfxjkLj]jiBlo@zfB",
        "jqtVppamL}@neDuqAvlI{l@taAk{L~nYw\\xnGofIypEy{VgiNc{V}hNo|ViiNy{VgiNy{VoiNm|VaiNe{ViiNy{VgiNe}EekCeDc@sJta@ew@vfAqjA|r@k{Arf@erGfoA{l@rbA",
        "pv_Odp{jLrsAr~Bnx@xb@paAb[hs@v`@dM|t@",
        "~lzX|_`jLozIvlDy_DdlBirCv}BmwCnzDiaIpwRueDxeDamEz`Ac_Fdb@szEplAetEjtCmuEfkEqiDriF}rAnoF",
        "~ghVzcklLvQtnDjpAneCb_FrtFbdAz_D"
      ]
    },
    {
      "left": "PER",
      "right": "ECU",
      "kind": "International boundary (verify)",
      "lines": [
        "rwVx~flMwQp`B{l@~pBu\\joB",
        "hySvbqlMh]fzApkB`b@fiCa]`yBa|@f`Asw@zK_z@",
        "z{SxxnjMr~AbiAbcBhlCjf@|nAvZbrAdDxbB",
        "z}^jikkMoN~_DalFpwLaSlsAg@tvA",
        "~kV`oclMrJvnB",
        "|g\\bw}jMk]xtE",
        "pi[|ldkMpCds@vnBfgD",
        "hlb@lljlMjG{{@zl@{jAjzByaClf@klA|j@odCr}@ybB`zAkfA`aUggExgGsrBbuFyqDxlBksB|j@}eA~Ia_A",
        "rvb@hrnlMiI{dC",
        "fjzAtk|jM`Sub@xc@oXf|DurF`\\uYtfAg_@v\\gWlEs^",
        "vpzAvx~jMoEalA",
        "|jeBjmmjMtHc[bnB{eArrB}UltFjRtr@eDfl@oMbn@wGpv@|Kjz@bw@@@ve@vjApk@taAhiAl[h|@oE~qBwYh~@gB|~@fLloBtf@bmArAbn\\stGdw@}@zjB~Hby@mJ`fAio@hs@{z@~|@kl@~h@o@zBzv@?pfHr^hhG",
        "hifB~gojMk]sy@",
        "xo}DbbwjMeBlmCkq@t|@u}@hc@eaBhtAwaDbpD",
        "rvqD~xfkMzu@re@vsHbnAl_VrzD~_VrzD``VtzDj_VrzD`hJzzA`xEfpAfy@do@jvBvaBn}HjvIfdHpzF~iJxvHtjJ~vHtjJnwHtjJ~vHrjJ~vHtjJhwH~iJ~vHtjJhwHn|GvsJp|GtsJz{GjtJn|GtsJb}GjtJz{GvsJn|G~sJn|G`tJhnG~`JfgDltGpw@h|AzgEp~PdrGbqWpqGxpWnqGlqWdrGxpWnqGxpWdrGxpWpqGbqWnqGvpWj{@zkDhsAppFb{@ptBvpKdkMdmYvvRryF~lHf_BzvAbqJb`EbnBdlAfhDtbFnwAxhA|gCRtpBcgAvdAqaBxxAmmAxjDgLz~Bnx@vg@d_BzVxmBvoA~aBtg@btA",
        "z}kTlqm|MupBvz@ypKjuAs|Axm@u}@dmAqjAxmGaQ|aC",
        "l`tShrb}Mr^bhBduBhcA`g@yDvyBae@lcAtB`mGxn@z|FxoA`ZrGtyFbrBn_C~h@lxBpMx_F}Af~B_Yv{@`Cbc@rn@pLrnAjIt\\f_@pBxmAIvrK}nAbwBbe@psClwCt^pp@dc@`lAj[vd@xwBl_AnvBvk@nmMt|@hj@OxXzXxn@dvAdXvoAxDvjA`QpdA|`Ar~@teBf]`sJeEbtGzaAxzW|{JfpGrz@`yB|t@r~A|qBbbCzr@liFsF|fFkq@nvBakAlyAqsCvcBxOduBp_BjpCfyA~qBdOr{ByDdwBpFvcBjw@noBhiDlk@jbA`cFh{PfrCbdGfeGz{Gz_D|sBxjDjeAdjDoC~wG_lCdtC}^`{BdaAf_@toCh@lcDr^l|BveBtaApoHhdAbbCzk@djDh`DdtCfsD",
        "hgoWlqgiN}~@oaCy`CchBuoCwyAylBywAo~EafNwnBibBmy@e@oFCyc@xd@ec@~v@g~@lu@st@xOsrB?ew@zF_}Bfv@ggEn|B}|Bd\\yn@sJgj@sYoo@ySi|@fE}sBhe@mo@|Du}@?{u@iImxBug@_}@{HocAlFovBzb@wdA\\yy@~OeXfu@_St|@ij@dg@mo@OqgDqo@ovBuJk|@Dqv@zMgl@`g@si@~eB{a@|d@oaC`My`Cce@elBgLybA`wAs}@vkF_t@tdBeUti@",
        "drhWrn{iN`Fg~Btg@_`CnlCwfGzVetB",
        "|rvX~{|iNgV~xEosGhcCcy@OyuBaWyy@`AaoA|`@olCzeBolAh^}qBcJgDO}{C}t@cvCogAycBccAoaAk|As`@irB_Hm}B",
        "joiZbxwiNmd@xfB}}CjwGqjAvsAcbCvu@qiBmVega@myXgiC_dA",
        "h_sX|lkiNnb@l_HboArmG",
        "r|jZjb`fNec@`gFe_DjzCwbEhbC_qCj}Cih@bcD}@n_DkRlaDk{AfhDowAb}Bg{EdiEg_BtoBwe@pjBgVf~Bi_@~fBybA|f@",
        "jpcYpkchNlEvP|_@r}FfVhcAt^h_A|h@ls@zvAdt@~yE`_AxaBtm@|hBjaBdoJp_N|gC|~Ffu@b{@pCfp@dB|mB",
        "fxqZrlpdNuSne@{`AbxAgVvo@kvHpzH{tAvkD",
        "d}aZheeeNh]|`F|~BlvEd`CtbL",
        "zdi]tl{bNae@lnCihBdvAccCtaAyuBnqAec@bv@{l@zxBkf@lu@st@l`@kzBtg@qv@v`@coAnkBybAz_C{tAzjBmcC|k@}rBbRcGj@mrHpbDyqJzfAciGbuDieCeCy~F_oCwzAuNwy@za@iiA`~B",
        "|vqZbvkdNh@nuC",
        "jhl]he`bNqWdlB_hA|oEaQxlB",
        "vth]fqmbNpDhwCpIbbH",
        "`xq]pdqaNiqBvrBwp@hcAs^jbAwFv_A",
        "rlk]v`{aNdX|cBpAr~@"
      ]
    },
    {
      "left": "BRA",
      "right": "VEN",
      "kind": "International boundary (verify)",
      "lines": [
        "k`w^`gvqJzWesDn|@mbD|oBq_Cpz`@eyKteHci@drHj`ClcOldLlqE`mFluDp{GriGdyQvF`u@JnwBfO`p@zv@rn@vcKtkDxmGly@z~Bdm@lpFfwDdgBvwEhaAzhOv`Bj{IhJtkB",
        "__lZt~itJgWhkBofBttEo_@foBap@|pJ",
        "iprZzbcuJjQnqBriA~l@~wFkhD~aCmP`{A|}A`z@d{Cz]lfDlFrbC",
        "{y}YvnsuJiTrfJ",
        "eo~Yjv~uJpKfyB`kB`pGfhD|yAf`Nbd@tkAhZliAhi@`aAvt@jq@z}@dg@l}A",
        "}mcXldfiKsn@|rBm~BfoAosG~aB}gBndAgyB~oAidF`rFsqC|~G",
        "sldYbudjK~Rn|GhmA~rAjvB`p@|fCnO|~BuNvhCshAnfA_mBpq@o`CxhAmbCpeBq{ArlBin@vzFqjA~wOkuGH?",
        "}n{XfdfwJkH|t@uw@fcEqLrnF",
        "q~}X`nuwJbOduBtb@|rBltAxmCn{I|bI~bAbcBjw@~zB|i@vcC~Wr|B",
        "ix|XlzwvJmFby@aVfv@cEltA",
        "}|}Xfa~vJfPldA`r@toBtHzkA",
        "i{}W|jjzJyZdsFakN|kd@u{@pqG",
        "{_pXr~_|J|s@~xEhd@fU`jBtSho@f`@j\\ht@|d@`bEbo@|hCzfAbz@~aBpLz_Cf@zvF|jAfk@blD",
        "oxhXlmzxJs@jpCic@ztBap@~pBqf@~eC",
        "awlXtmjyJxg@jwG~vIjzM|yAnhG",
        "_~tVrhreKsIv`G{tDlbDibGb~Aq|LrgBwqEjlA}|D|hB{hC~eCgoAlaDmsBlgLq|@jhW",
        "e|iXbhzgKfmEh{j@",
        "}frWbj_}J}oAp_O",
        "{wtWtjo}Jd_@|aJ`[rhBdrArgCv~AvZhqBkS~jCaFvyCfj@h{B`{@``Cnd@jhD}UxcAg`@dg@qa@|j@qXd`D}SloF{jBdcGex@hbGgBnyFl{@jfF~dCjuBr~Alk@h~@zBteA",
        "etkWlmtiKL?vtCi{BtfFocHnfCacCjzJcoG|sMq|Q~jCiyFbnBqeHrwA_pCl`MgmJ~_FsnGheCovB`yCgl@fgFSlnBzLpoB`l@r_F`hDnpBt}@duCrTzrW{_D`bGgUlwOtw@~bGkNtxEcmBzgF}eE`sKy_FhyFedEvc\\m_NdpIghBrsBafAd`AuSzv@|@jdD~g@raJjSzuBb[xnLrnFnvCpl@|gCmFpjBcu@~r@w_B",
        "etkWbntiK?U",
        "cnvTxaz~J]jqBmPrpCag@h|BqoAnuCocB|gC}aBhtAmmCbxAghWvtS}uGzdKyqNjiJcuEjxE}kFxyKgoAjwF",
        "iufWpc|aK`SdsEdtDvmCjqFpk@noEhsAfnAhdG",
        "aj~VxgfdKmYlyBqeBd|FgAdrG",
        "imbWrrzdKv~BrcGxjDryFvbCvuF",
        "}yoVtlsbKcaCfoG_uJpkL_dA|oH",
        "awaWlzrcK`MxvBvtArwIdH|{C",
        "gn}Tncj~JmLbzA",
        "u{}Tr~l~JvWxx@fmB~yBnhAp`C`\\xkB",
        "aaaNlbueKth@ooJjlEepV",
        "w``N`jyeKi_@sfC",
        "{a{MpeycK`SgmXt{@siKnXoqWzm@s{BtpAsV~xEh~@bcBtHvgLeMlxAfLl`E|uAlbExvAvcBrSjoBsIbcCvz@fkA|dErmAfcLRt|@",
        "_jyMv`rdKeCypKur@khK",
        "c}}KjjubKeWrpD",
        "iu~K~{zbKpKjpAl|CdzIzpU|i[taAp_CxOdvB",
        "}e`KfkldKsKzcV",
        "qr`KbpceKrUniFhnAhdFd_E~bGvpE`iB`zOzh@`cKx`B|zJiTtvB|PvoB`a@xyCrjA~uCrfBl~Bb}BfgD`gHnpIbwIpzHppLziCf~BlzFztBxqBfkAlk@fjB",
        "akhGbh{gKaaAvxBanCl_@q~CiTwsBqf@}~FqcCkzBxCgqAngC",
        "a~eHdn~gKbPblCdsAnuC|`EfeGniDliIfdBnpCduCdvBvzGraCptBppAfjOrvWlY`~B",
        "{yqF`vejKiTr|B{sChxHs@pnB",
        "uewFp|vjK|jAbcBpsC~jCf~A`zBt]zjB~IdqBve@poCve@``A|qDplEbOzWrUt|@lPnY|_@`MrtAfEdXdJln@`gF",
        "qtpCthqsKssA`}JwiGn{JkmFxgGueB`qBumGhlHk}J~hLgvLhgNsuLtgNk}J~hLumGjlHueBhqB",
        "md|Er}alKgVr~F",
        "u{|Ef}ilKnx@paF~bHhqCdjOtr@v_Gz`AjdEhuCbz@t|BvFl}B",
        "gy}Brh`oK}h@lnBywAjuAwcCdcAyhHfLqqFkuC}nFc{DkaHcdBgsCjHigCjh@}|BxaAmwDduCeaAxcA{w@pjAcd@zpAiIljA",
        "{l_EtamoKhSz_C",
        "qx~DpbqoK{M~bM",
        "mg_Epf_pKnNn{Bno@|wCh{CxxF|yF~{OrrAtzBbbCnkCtbHboFbbCzdCpkAr|Br^|yBxOpoGvy@xfCn~ErfEzaAhpC",
        "_jqDbzemKcf@f_G",
        "cqrDjzmmKpCx`Dhs@xhBjqMlaKnvBrcAlwC`{@tr@rF|qDwGftAvZd`C|tBn_ElrBbmBhfCfuA~zC`p@rgCtHpnC",
        "oxmCzzsrK}JfhCu}@ngBgiAxbBar@dzB",
        "m`tCrkbsK|@byB|hB|aJ"
      ]
    },
    {
      "left": "BOL",
      "right": "PRY",
      "kind": "International boundary (verify)",
      "lines": [
        "`}utBr|sgJt\\i{B~|BkzDvwBqqDvwDgzHjuIseQjuIifQttI_fQttIifQjuIseQttI_fQjuIseQttIifQ`oCysFjgAybAbxAkStmE`RfgEqKzdJsiBvbEsSziClOpfGkGlaC~HviIj{AvaDoC",
        "jtufCvkk}J_wHwmCwnQwnDykP_eDcoYqoG}bUubFsh[kbHwuSytEkvU_cFsxTizEgfScjEaaSghEeyK{VgB@cm[zJwwQvFudPbFmwP`FueD}s@qdIubFwxDmgC}pDuaCyzJkvGm{JuvGyzJkvGo{JkvGetC_gBgtCufBqsC_gBetCigBo`DmoAkqAoh@omAqf@o`DmoAm`DapA?IijMunD{jMunDijMunDsiMwnDmrH{tBiiAaq@mf@ybBaoAikPkRkeCsi@{eHsi@ifHkRaeCcqLobaAuqLebaAcqLibaAaqLqbaAc`Eil\\oE{_OeM{xc@{Mgxc@eMsxc@{Mgxc@mEkzN"
      ]
    },
    {
      "left": "PER",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "zybXheenLtSeaBlyAeH~qBlUr|AaCblDkfH",
        "z{mXxlnnL}s@scA}|D}cAkeAex@wg@wcB",
        "pmfX`zzlL~GgzA~h@cgBziCe{CrUokA",
        "pzoXxskmL_^g}AykEo~Fel@uaB_SixA",
        "nngXd{ilLfV{lA~pAmiAbzAon@f~B}IvjFnw@`pBoItqAu{@nrFysH`Qa{@",
        "`bmX~mmlLqrDyqB",
        "fvgXpfrmL`e@k`BbzAo\\tzAwQlf@c`A",
        "vfrX|dymLoaAku@moBoYqiByh@_r@ubB",
        "~ojX`b~nLhhBkcKpA{oB",
        "dowYhadpLwbCw_CovByx@wcBcmAeuDezDaeBk|@wnBaa@_|Akm@om@q_Bi_@{_Byy@kQyvCbt@}rAqRkgA}oAuoC}hHwFm_A",
        "lynYnbnjLgKkwAyvCmpE}rCylBseDyx@ylDzM",
        "hu~Xfs}jLnm@k{BtpB_cAtzCa\\zl@ga@zkAukAzu@ilArUavA",
        "jfoYd`okL_gBevBmkF{dBiqBgpAw{@yqBqLyjC",
        "fegYxqukLrJap@xy@eh@xaB}p@zvAmdA",
        "dggYzhwkL}@av@",
        "lcpY`gkpLfsBiaBnvBmbC",
        "lrwYh|opLccB}wB{iCi[",
        "jbsYnikqLlf@_h@llCqaAbn@is@dOo`B",
        "vn|Y|~sqL}}AsrAsqCwyAyy@afB",
        "vjsYxbzpLtfCoeI",
        "pvzYbhcqLga@{v@ykCosAw{@}wC",
        "xquYb|}qLl[uoCn_EokD",
        "|dbZtvgrLwoAa|@g`Aq@k|@dLiiAmOowAwcB}_@}rC",
        "p{`ZzmxrLtHguAlo@my@z`Akg@nd@mp@",
        "d_kZvspsLmd@qa@shCwe@qt@_i@ec@guAqLk|A}@e}Dij@w_H",
        "pfaZfxjrL`Huh@lPeb@zBuS",
        "`}eZjcqrLqb@qtAiT}UshAqv@_Saf@",
        "jziZ|~atLvbCfV",
        "jkoZpbltLeDgu@wZonAi|B}}BwQ}}@",
        "~ziZvawsL|_@q|CfBmo@",
        "b~mZdvbtLuyB{{GmGqvA",
        "bbjZfncuLlEq`A|`AanC|TmeA",
        "lcd[j_vvLiKkq@we@my@yvAaeBey@wwD{{GqeHiqBcaDu\\siBox@wbO}Ksj@wZ}Usi@wFwg@yOyXir@",
        "fijZtwrtLfiAwbBh~@i_ApWap@",
        "l`mZdwztLmPovBkq@kfAkRs_A",
        "bmb[pk{vLfBus@l[cx@rUk}@",
        "~va\\zsdxLeBwpAce@_qBg`AaoBwjFy{He~D}xI{aBevBmyAkfAkbFwnBur@mn@",
        "`v`\\t}kxL|_@yhF",
        "t{{]|wwzL?goIcOwy@}u@w{@ew@oOa{@cDebAcZmnAwoAkpAmlDkdDmwC}iAoaBkq@coByOgtBgBkzAcc@we@}t@aRox@s_@gVcEga@r@ce@}A{a@uQ_Jm\\}@euAwFs`@afAkeCufAueBwcB{`AatIql@_hAebAafAuaG}_@}_@om@cOkh@u]kR}jA",
        "hiz]ho_{LpLgtBxc@caC",
        "~lb^pyo{Lcp@c~Fwn@qkBweBwnAa{@ymA",
        "ppa^his{LxXcnArAs_@",
        "|axk@vkeaMwQ{xBa{@efB}|B{gAiqBvQqtBxs@ohGn}@ggRhnLyt@`So|Aza@kyCac@ioDmxAevPmxCgwI{LugB}d@giAubAcaDgdGqlAk|@g}CiiAwdA_qAsgBmmD_yFsxHw_HcwNujJwfLytCosFieEq}Eqm@ieCoC{xL_hAswG}qBmwEkoDyjDw`G}rCy~FccB{iCu\\sfCIipCri@szG|gCknCnc@ssNp`A{jBdb@msI~lHwvCby@c_HeBehFobBg{E_gCuuW{cJ_dEwuEs~YyjSclDowAmvDg_AcaQueBanD_@ggE|u@wmElZciEcy@_`KyvDeaByYakGug@myAmo@_sAybA{vAqu@mbB_Jw|J|`@}_B|_@uzAly@ylB|j@k{AeXwe@{uC{B_qAkIcp@cn@{uAqWwFazAeCu^aRqA_^",
        "|vwk@tbmaM~I}uF",
        "vb_l@r~`bMis@ejC}gCabFqb@ylB_J{~C",
        "xx{k@rolbMdaBu|FvFirB",
        "fico@dpbaM}|BoiEioFwdAawF`{@ouC~zDwdAnhFgtAddE}sBxkDmpYboXgrCvzFylB`v@ewAksE}`@upAqhCmnA_fCyD}}Amp@weBua@q~C|e@eoHnsDapBrT?mgC",
        "j|`o@n_laM|@_}A|iAipE",
        "r`tx@vxpzLkIxb@cn@|u@{Mt]cvC|vVsJnmmAuoE_eCaiImhIc`EkpCsfEkeByaBmcA{l@_iA}KywAwZwdBmo@ssA}iAmc@yjDgCy_Fe{GmnA}_AguB_s@syDyYgjOpaAkfBvd@u`GnkD}tAjpAmwCzfF{kAv{A_xTnaNciGbmBeuBldAihBzkB_}@xuB{kAjjJwdAn`C{jB~pB_vInhGkfB`g@qtBdCavGwy@s}BlEiqBpk@azAdwAuSpv@oNvbCqWv{@cy@r}@cbCvdByw@dbAgpGlnNirAhxAguBxi@m_Gn^kdDhw@alFpsDuoCbnAqtB`QehFeb@ywBpBgrCdbAosGjlEojChj@qhEjeBs{BvkFihBbiGwmCl|D}tAle@_lHtbAapBcF",
        "tuky@v}vmL{Moy@irCrsAmnA}J_}@yr@_SsnAiT|Kyn@hOaSjLsr@wsBemA_^kfBoOmmBk_AmPaIkpAvF",
        "l~px@dlmmLbZleGnYj{Bby@zxB`nBt`CdiGnyErrBftBpeFd~Kr~Af_CjmF|iFn`BtzB|fDlyH`pBrcBtbGfrD`{@peAp`B|`Dlz@jgAfiAlt@f}CviAtfAxn@fvAzpB`eBvbKxuDl`LbmA|gBtfCloA|pCnx@dwBrrAjdB|nHdjD|zE~|@bxBdD|tA",
        "hy{x@ljmyLk]hwG{a@rtB{~B~bGymAz{FqWlxB",
        "xprx@trmzLdDdWda@vp@lGb[",
        "lbey@vynxLcFt}@ekA`oBevCllDi~@lwByXn`C",
        "x~zx@zoayLnYpyJ",
        "tma|@lsvrLSxgFi@rya@qApya@i@hya@i@pya@SrnIcbCcdAylByEokBrKg`C_Iq_A}a@gsBy`BqlAgMg`AnNe~Bjr@cdAbP_yFnaCsoGnwLalFrhAwjFgiAovBsTwnBld@ggEdiD_gBxx@oaCnPmvDcGw{@bFis@xc@qAf_A",
        "xvdy@jqlxLrJjgA",
        "n|jy@bszmLrJs_@pLwsA",
        "hgvz@faxmLoCw`@ec@i^qjAoNkf@uS_gBwjAgjB}o@}sBuHo_Chi@yxAjgAaoCvvDs|A|dAsrBpg@ckEdm@kqBz{@kGo_@oC_eD",
        "~}tz@~bzmLhh@w`A",
        "npebAjcdnLyxNg@czWy@ezWaAyzW_AezWgAyzWgAyzW}@yzW}@seOg@qsGU_uJSgzF}y@}`Aec@{u@{q@el@g{@od@w~@?i_@",
        "z~~{@`lgrLu\\rr@ce@fl@sUzaA",
        "ld|{@xolrLtH`yAza@pa@xn@dXlo@`|@l[voB",
        "`kuaAbrniLaFlxBga@dvB}K|dG",
        "xtsaAth~iLpxVjkn@fvAt}F`{@~vHnNraI",
        "tq|aAhfphLih@tnE{tCbjFqk@zjBsJhfD",
        "hztaAhtfiLvOx|F",
        "dqpbAjnilLar@hyHojCf~GwmCr|CygIjvGuoCfgD",
        "jjwaAdeomL`\\`eC`hLbwO",
        "|`zaAn_xgLvoAxeW"
      ]
    },
    {
      "left": "BRA",
      "right": "BOL",
      "kind": "International boundary (verify)",
      "lines": [
        "zqaz@pvlnK|@ccDjh@_qBdtCyjDx`EgyAhTqM`vGmtA`dA{{@thAwtA~pAkkAp`B}_@hpC|Zz|FhfCrfCjq@r{FbU``GkWtlF{u@|cIcsB`dCuXtmGuMp_AkMtoCi}@r_AsKvy@jSbaD~jBzqHb_AtoCfkAbnBngFbwBxwAllCncAtoBzZhAPlo@kItSiI~R_YnhG|rCdvAfyA~]vxCri@?nmBmjAhh@{Lj]lEby@v\\nd@hE|s@kDr_AoMzu@iTfVkWdbAiPvsH`g@t|AH|sBwiBlcAmnBzvAuvAfqDob@xlBlFjmF~m@f{Gn|AjpAo^p_AiuFzkAepBp`Bc}A~{A{q@zuOwe@za@sOfa@ab@vn@u]plAaBfu@fWxc@rh@p`@dr@zl@xt@rqC``BbnBnCfjBkb@x`CmV`pBno@~xDjpFriBd}AtxChTp`B}oArhAmhB~rA_s@|}Axd@vp@lmAvdAn}@lwCkGjqB}nAj{Aq_Cz`AivBhh@is@lnApUr}B~kB~gA|e@~|@nEtr@_JbwOcpE~oDghD",
        "dn`{@vvjoKoC{jAyZw[ih@qM{l@i_@wQ{Fk|@kCoWcKcQi_@qLajAsJ{WmnA{fAazAy|@cy@eXg_BuY{w@uf@cjFw{Gi}AsrAuHmy@",
        "p~kz@nippKtqAuf@t{@aMnm@iOr`@u]|Tyx@",
        "fivz@fxupKuHc~@ov@_PebAd@om@yFwyByq@a\\ed@",
        "|mpz@f~`pKbmCrVdmAfUtQcY",
        "~ssz@|jkpK{_BsjFeDa`B",
        "d|pz@zeypKzj@_Nhu@sY`p@}_@xXab@",
        "louz@jw~pKug@gjAqiBgeB",
        "`gsz@hykqK`H{vA`{@i~FfBwiA",
        "xtzz@fk_rKoYkvBoiDovGs`@}sBcFcmB",
        "f`vz@trjrK`F}_@xZolAj{AydDhTerA",
        "pfzz@ruprKqUs^}iAck@wQoXaQu|A",
        "r~vz@n|zoK~Rqf@p_Awv@xZs_@`yBaxD|j@qyAdXeqB",
        "r}wz@tm~oK{B}O}VebAeBa\\",
        "bwwz@p_`pKnE{p@",
        "||wz@~qapKyDmq@",
        "vbxz@tatrKrJsVzXqVnWcZxDw`@",
        "jkj{@jartKeO}|Bgj@mxBkpCubGkf@{eBk{AecR_i@uqBi|Bw`Eel@ekBqb@}wI",
        "rmi{@n~}tKv\\c|J",
        "p}_~@~idyKSqiBqk@qlAcdAom@afAec@ar@yl@iTk}@mEmbCiK{aAe_Dy|Gy~^gq^osRgxXa}@yuBkaE_}Nye@_}@_r@}_@cdAqM}~@gUEEqp@gf@sUebAg~Bu`V",
        "nk}}@xpoyKxOkpBf`AmtF",
        "rrk`Arpp|Kiu@ysEesDufBaaF{w@kzDafAwdAybA_zCq|Du|AcnAo_EazBirAwdAgtA}~Ayc@ayBqkBo~E{tAc`GemA}|BaeBolBsrB{uAafAmZ_r@iAen@cOqv@ocAwOcx@qCesGsJ_gAgVoaAwe@en@a{@_IigCzb@{u@aIgl@mxAgVwmCaHkbG",
        "jx``Aple}KpL_|AdXcyAncAevBd~DytFxn@yvB",
        "f{a`Ahu|}K{a@wgV",
        "d~``A~fb~K`\\upD",
        "bwlbA`tv`LeXywAyuDueEyy@ipBm[qeH{j@ekBmyAg_CguBquBadCghBigC}tAeoJwbDovBovAwqJw~IqxK}zEaeBywAccBupCk{Ao_Eg_@_gB}KqhB",
        "~vvaAr{pfLt^mlEby@gpEza@m`F",
        "ruzaA`xegLeX}uFmdBodL",
        "zbzaAdktgLvQcrM",
        "vfzaA~xqeLnx@ihN|s@kfF",
        "tszaAn{|eL}KoaJ",
        "z_}aA`ptdLlPk`BheEmoMpCc[",
        "du}aAhh{dLiTgwE",
        "vkbbAbl}bLzu@c{D~s@yhBtoCfeBbvCxgAn`Dpa@x~F_Yby@{Q|_@kq@fB_mB",
        "jsfbAd|lcLyc@}{Ci~@giDob@{gD",
        "zocbAlzzcLvoAqfHvQuuC",
        "d|cbAbbbdL?_x@qCwZwF}qC",
        "~dlbA|_z`LbQ{jB",
        "`__cApjtbL}qDgzZquAclD{fFqcIowAmjGeOugB?qhB",
        "vddeAvrhmKjpAgxCxw@}_AnnAsh@j|@?joBrn@`qAi@|rA_YvQk\\R{k@l[miAxxAeeCdw@{g@vn@xqCnx@bNjyCoXj|@|Kh}Atv@lz@|K~bF}ApuAib@`|A}tA~pAkoBtSapA",
        "n_feA|lomKwy@eyE",
        "|hjfAxmllKxy@kQllCjRftAyxAfl@kpB`{@{_BnjEyx@phCgpAbdAk]t{@gEr}B|Ij|@uC`dC{\\zw@{a@t\\m~@h@iTj[e}@|`Akg@xkAeIj|@hZdwB`uAtpBtIxaBcj@|iA}iAxn@qvAdX}aBfKkhGzXe`Cxl@cbChT{dC",
        "`mzfAz{slKcy@wp@snHqa@ymAeXkq@ie@eXgyA",
        "p_jhA~_wjKza@mkA~TmqB~h@_hB~{Aul@r}Bk\\ptBoiA~nEseEnuAdm@ncAa\\|_@qdA",
        "|qkhA~j{jKkq@_jC",
        "jc{hA~vyiKza@sT~fBo]rr@?zkAvj@~h@pA|_@aR~s@wu@hTmJ~|@q`AnwAyvCnaCueH~GklA|@mbDlGkg@~pAaeBf`A{_C",
        "p_diAngajKuSwjAkq@oO_eD_Tec@kW}I{eB",
        "hztiAhkvhKfKgzA`Hk]ztAeeBbp@{WhgAuD|iChF~eC|^ryFpoBpiBsOdXme@xn@mhCr^_x@xy@ys@lcCchAd`A{m@|tAssAfkAo`Bpt@quBtSgrC",
        "rcviAv{vhKkRaFeMUwFuG",
        "lr_kAveldKz~B{`[bQcQvlDasIdrEscGlq@kfB~RghCpAonA~IafAxX{_Azl@wz@ncAom@r}@_Jlz@{Bj|@gWhj@sr@lPqv@bZ}k@vdAkQhh@qVnkDkmFp`@{iCv\\ugAnjCotD~]emA",
        "daqkAvrceKu}@sjAov@sh@w{@{a@y~FsqE{a@}@eMekBw{@e~DeM}sA",
        "t}`kAbapgK|Vo|AjcEo~@pLcy@",
        "pkbkAn~wgK{l@k|F",
        "~gckAb`}fK~]mmBnx@gyAntDcmDhTk`A",
        "pghkA~iigK}Kqz@gKk]yZ}j@afAmdAeXex@iIkdC",
        "nkfkA|kjfKblBc_BhK}uJprDefC",
        "hklkA|gofKmz@u}@kcCi|A",
        "hamkAxrmeKxXaqAzu@cy@zl@ocAh@knB",
        "nxokAtmweK{MqsBigAieE",
        "|oblAfkj`KpLsgAby@a{Bnm@s{DrsAg_An~Egj@`g@oYh_@ug@za@sU~gAxn@nb@vEpb@wEj[aSzuB{iC|iAmcA|~@m\\rhCkQnvBmp@j{AwdAdw@mnAfVobAxDoy@",
        "~hilAx|s`K{Bk]oYw[meAwZ_^w[shAokDsJmP",
        "r~hlAbfv`KjIihA",
        "fzolA|wmaK{BexLmPafAom@oWst@oy@uzAcaCoEm[",
        "v~kmApxa_Kri@}^vy@uSh`LogItg@wPt\\_^rJmdAzB_~@pLym@t^u\\fu@aIldBs]dvAynArhAylBj|@cxB",
        "lfnmAr|f_KgM}t@cc@}s@iTex@",
        "ffcnAlnr}J~eAyvBtr@wz@bp@_h@xw@}VpsCoM`\\}T~dFg_P",
        "negnAdd}}JmPowBwp@moAwp@s~@iIelA",
        "ddgnAzk`~Jh@ufB",
        "lblnAhzb~J_{BiJga@cbA",
        "nwvnAhrl|JhTq_Clz@gtA|eEckDv\\{Lr}@wFhK_T",
        "nbwnAfux|J_J}aK",
        "paaoAx`nzJbQ}}@`cDykCpW{aA",
        "~peoAdjnzJmnCkH",
        "`qaoA~tuzJzMeaA`pBsgD",
        "vxeoApae{JsUigByn@myAmz@oiFyDi~@",
        "trboAdo|{JdDiUz`AgiBlPap@|_@scH",
        "zwboAve_|JeDquA",
        "jfdoAx_i{Jjq@g}B",
        "blfoA|xm{JaH_sAu{@cdA",
        "vbgoA|{czJ~Gec@bzAqLzaLIfjBaRftAs~@r~AkeCvhHyrG|j@{uAnYoEzrCg_BrUea@t}@ekC`fAgiB~`HinHzl@q_A~|@myBhj@mn@`p@gV|`L{_Cj|@ugArU{jC",
        "hpgoAdrezJqLgu@",
        "lxdqAbhrsJt}@gd@x|F?h|BiwBno@{rG~RqnH~h@ojEblBsrBt^in@prDklLrmJo|Mv|ImfM`pBkwEt\\wnC`Qkg@l[kV|iAc`@l[yZbZsw@bnBqvMf~@moB|sB_m@|fDkLxjDkc@n`Dct@~eCc_Ajs@uq@`nBigCxc@}Jh~@n]ve@qe@nYq{@pWyd@hs@sNbe@xCxuBlt@hdHroA~eCr}@h}AhnBhh@|uCt^~i@psAv_@bmCzXbmC`GhrAkSdkC_rAz}CmA|hDrUniDaGjqBs}@xrG}rI`eBst@vgKqzAvzLqlEhcGs`@|~@h_EnjE_fBvkEgoH|gC_lAdzJcQf_OuWf_O{Wf_OeXd_OwW`tKkRrhAh_@jGriUzMxtd@jwGwhIdvNcpLnnWkbTjxS}{PziC{vAlwCss@n`\\eqAhkf@mnBp~[uqAn}Smi@~bUwk@jjGovBtr@y_EzM}pL~h@_ed@hh@ied@jh@ked@|h@eed@jh@ced@~h@oed@|h@qdd@jh@oed@nNobM",
        "~qoqAzdftJcc@e|@i|Byb@mz@{{Awe@}iGqW}Vel@kjAeOsoA",
        "rnjqAf~luJ`F{~Abe@i~Alf@m_F`oAmcCbZufA",
        "~buqAjkkvJwZevGq`BomGavEmfL",
        "b|lqA|t}vJhCiXjDe^h{CaiDr`@y}@f~@egH",
        "vcsqAnsxwJwfAcxBst@wmCea@azCag@szL",
        "dcoqA~`stJxMc{K",
        "lnpqAnrytJ?waAgj@wmC",
        "fsqqArk|wJno@cwB",
        "njtqAh`hxJqWazBij@i|BkRi{B",
        "`qjbBzzkcJlE_mGpv@s~@n_Ri^puAxYptBrqCnkB`G~bFyaCjbF~rAvkTrnRp}D~gBbtEnn@tmGsUpvMq~BzqFuSzj@pLbnBzv@xy@bOrhAgAtuH_}@f|DgjB`pB_i@tsLob@f_Bi_@xlBoaA|gCm\\jnP_HlkFqb@~xDkoBjzBeiFpW_dE`Qs}@zc@u|@vxAwnBnd@u|@nNks@vOkdBl[is@bzAweAtmEcdBvdAy`B|TquAlGafAvQocA~q@koAzsD{iDlo@ccAvzAg|E~f@gjAbvE_oG|iAgrDxw@alFnNukF",
        "hutbBn{ycJmPokCu}@{_Ckz@em@myC{uAi]em@",
        "jsziBdsb`JnNokBfu@qjC|tAqtAnjCi}@`zCoNfrC`G`eBsKhoFrAfsB}KloBwp@tqA}_AfiAcnA`{@wyA`g@mbB|eEft@zbA}UheCkoBxvCwyAloBfKtQvbE|g]ieQhwVk`Il{JcvE|gCixF",
        "~||iBpul`Jkq@irDgVanC",
        "twbnB~s{}InNadBv{@qv@hgCbFxDxmLdXjpBhgAloA`uHvdB`{ZzdHlzZrdHlzZpdHjzZfeHdtEjeA~RsyFjs@g`Ar{BmYbqJec@hnGcd@zXj}Iz`A|iBb}G`oChaK`aE`qYhkL`qYrjLhaKvaER?T??H~yCzkAlsIfgD`tIrgDjyCzkApwL~xEtnDco@zwKyxMjrLewNz~OotR",
        "twbnB|s_~I?}~B"
      ]
    },
    {
      "left": "BOL",
      "right": "PER",
      "kind": "International boundary (verify)",
      "lines": [
        "zbzaAdktgLve@qUbe@_Ube@}Uve@gUve@cUlf@sUve@sU`e@cU`jb@kkSvjb@mjSjkb@mkStjb@gkSvjb@}jStjb@qkStjb@}jSvjb@ckSnlGwyCtw@q_@bZh~@nx@nc@t{Bxd@|}Arr@j{A`gAxmAxwAxaBnyD`fA`uAlyArz@`eBlFvy@_y@|u@eiEbdAs}@tvGxoCpv@nn@phCnbOrsAf~Bz`Cj_BhoD~mA",
        "xwcmA||pcLwQjhC",
        "`ecmAhfucL|sBvjAdvCzaAnuC~cExkCfb@`kGiA|eRwkAxxAgJfcV~m@f{FoOpjN}wAdce@xgAnlCaV~yC|d@ztCdv@boAxt@bkC`cCvfAxo@ztAnMxmA}J~gAl@ncA|u@zKdfA",
        "~rhrAbdldLq`@v}D",
        "lqgrAzbrdLvFppAbmCnvAdsDk_CljGopI~{AidAtfA?thAj]vcBrTrsAmFrnF{oA|}CgjBzrEwVjbF]zgE}d@hqB{qAbvEqmIxxAc`Az_Bcc@bvEcf@paLezC~yEwZp}BlwB~s@neLhs@|pExlBv|CzjBta@xwBpHppFsEvnBcp@t{BqtAh|BiZ~oBj{B|{EbuKdvAlxBbtGruFhTpk@bZpiBl[|d@zjBvRb_HgQvdAxc@",
        "vd~wA~ydeL{BlgCa\\|lC",
        "xc}wAjpmeLfKfzBlxBfoA~_Xpf@dsDfuAfw@hbBh}A~yIrqAzjCrsA~w@fjB`Hr~NoYlo@`LliFjeBhsBxZnkBwf@`yBieC~}AogBduOofJldBkeBjlGasJp~AcdBxtEoyCxkC}rCjqBpMxkAbaB",
        "nfd|Ah_deLuHnrC",
        "x|c|AxrheLvFfxB~oFbsAvdAdoE|hBrwBn_CxbBxcBbc@~xDegAfu@fBxZvj@dw@ziDp`@b~@loBppAvyB~^h|BbO`yBb`@rpQxsKtyDfv@hzDob@vwDwjAtcSiiG~bSohG~bS}hGtcSkhG`tImkCdgGkxEf_BisBjpAyeClo@gtC",
        "fu|aBv_ndLxDubAj|@sjE",
        "~cabB`d{dL?e_Da\\qeAmyAcxBgVmcA",
        "r_}aBv``dLhrAykCrmGu}Fr}BqdIh}A{nCrgDo~@xtEtjC~lGh~TteBnoEvbEjbDnkBzv@f~B|K|kJwFlaEnN~fBe^baFmfDp~A`kAz`CnfBpjAtgBbuD~jJdZvrBrSt~E`{@|bBdxAby@xpItuBlcCfuAxhShyRzyIvdD~rA`iA`xCvjGjh@fg@t{@pQdc@kSjRol@jf@w\\zaBv\\dtCzdCv{@|eDh_@brDp_AniD~|Bd`ElgHxpIrJbe@xOpjBjGvZtfC|cAzyIj`Bp~CviBr@}K~g@i`Ip`@kaBx`Ea{FvyBa{BjoBqyAvwDceAz{E_Rj}L|I",
        "lx~aBlpedLyw@unD"
      ]
    },
    {
      "left": "CHL",
      "right": "ARG",
      "kind": "International boundary (verify)",
      "lines": [
        "tbptCprc`LuH_pBmcAynAsvIogFwnDw{@om@k\\afAaoBwoA_pEwwB}xHywBsxHmxBqxHywB}xHw~HilWw~HglWk_IilWc~H}kWsS{w@}j@u{Bqk@}{BuSqw@{vAixFq|C_wHayDclC{wKkfCovRwoE",
        "llntC|lj`LjR{kBza@olB",
        "bliuCzlx`LovBqk@q}Duh@ymNiyFyy@knB",
        "pmcuCnj~`L`xC{uBnd@weA",
        "tznxCtlr`LqWueCkq@}{BirAomAi|BnCo`D~eCwcD`dE}zD~nC{hFiTa{@cPug@dNmd@~^yn@r^a\\fWcp@jeAa\\pWu\\pBu^mE{V_JoEcFmwAzl@ks@`f@gVpaA}@r}Bea@dm@ymAxtCiu@bz@ih@xX}lIxmCsiBnBggCwe@anQa~HosEmdAmyAqLmyAeZ}`A_r@uQqtA",
        "vbnxCxwy`L`SueBzBmcC",
        "ziadD~eb`L{Bol@cn@}Ks|CbPqjAsKovBg`@kbFkeBmoBi`@}qDjSkmDj{Akan@|bd@uwFnsEqpFbaD{gGzjBm}Hlp@qjNwG{|F_h@wvEgkAcvEotDipP_tW_zE{bAo{Hjq@oeq@bpLi}NrjAwaDxw@kpClxAiqBlxByvCvoBwlD~HueDkGy`Cnx@}}AguAoaChgAm_G`bFcnBh`@{sBrIqgF{Win[ibIq_TsmFkrCkyBwXkTg`A{uBgB{`B",
        "~|`dDpyg`LzKqrD",
        "nxxdD~owaLcQkzC}rAq`A_{Bwe@giCshAsiBemB}rA}fCur@qsCgKw~Ha\\yaCylB_wGyD{bA",
        "vzldDzoubLzKo|Gr}Bo~ExvCuoElyAeqF",
        "~gekD|sufLi~@us@e|FqhCudE}lC_fNabFobBevBel@eDkh@xP_r@gCu|Au|@i~@akAug@mbByxAiqJejBu_DqiDkjBks\\mrF}kFy{@{kAie@kf@u|@}iAeiDyn@}_@wzAdY{kAnm@mnA~b@aeBoDybAmi@ywB_lCq_A_x@imHc}CsgDwz@cvCcPuqArUssAzBwoAkRigAkl@ydAofB_gBoyEekA_cBgtA{dAsqRomHueBmVwuF|KylBiIaoCaw@ceKycGeaB{zAen@uqA_r@}dF",
        "rm`kD`q`gLbp@s|BlnAw~BxXw~A",
        "rntvDjr~iLuSj`B}hBpk@quAu\\{{GsuEwaFerAogFcc@edYeh@y`PhsAqAr@aqAft@ewBd_DmxBp{@knCs@_{DeX_yDwA}qQtoC_hAh[ybAvd@mz@|o@}aIrz@myAnm@mpAvu@quA|i@}hBrJqnH}Vg~Bqz@ebA}bC}Tm~@}a@w`Ayl@kw@ox@{a@{l@zG_sAriA{a@vGce@yZoNe^uHi^ekA_aB}}AifDqv@kaAiiAyh@{l@qB{a@qVmd@{eBwp@ixHox@whCudC}qBshC{h@_eDeHgxH~c@a{Bz[s}B|@s{B{VovBio@u|Ak{@_qAukA_t@kc@is@oDur@lAew@mKw_HetDapBeR}gCpUciGvzAgiCj]muEyNwkEkmAizDktBccDmcCa\\}n@gKqq@qW_i@ebAgU{qSoNkaJoqBsRiEubGu|GgoFeoIsyHonGejBkv@}cI_bAg`AsxA",
        "||oxDtwljLew@i~EirAuyDewB_eDwaDy`DihBiy@iqBmQmkFcJsrBkX{w@oSup@a[cp@kx@yn@{yB_g@ys@qgFoqAi{EjvA}fDr`E}iAdlF",
        "posvDt~viL`^trF",
        "|ngxDhqckLz{EscObp@_tE",
        "pkm|Dnf}kLwQohAymAlEssAvkAgiCprDifBhfBq`B~}@wnB`XmyYkzB}{EiyA{l@_^g~BcnBgkAge@_}@vAs}@bPemAfBi|BgWyaBec@{~DmxBiyEa_B_}MkqB_pDw|Bw{@akBgj@obBg`AsmA}|Bkl@oaCz\\_cFr{CylBgAebAodD",
        "jgl|D|pelLdc@miG",
        "~uc}DfqylLgVg{AqlAk`BccBakAawDct@ovBy|@wbE}lCkq@wtB",
        "pcw|DtfbmLtr@azBjcCym@xkCe^plAkkA",
        "fbqaElyslLen@huE}eEb_FupBhdAekCvu@qsC`[wiGqL_gBl`Ag|Dd}D}}PpjIwxClz@_pB~HqqGo}@}dFsTseFxE{uBsUabE_mBqtBqRadCx_@gsBtl@qtB~IawFqiCcnBkWqpFzAu{BgKo`Bga@eyMw}Iyl@ajA",
        "dirbEvlclLyDk}Cgw@_y@geFkr@k{Agz@kgAy}@_qAid@ewBhPifB`eA}sBxwBccBvcCqv@viB{a@hqG",
        "b{paErsllLbFxdF",
        "||nbEfxolLlQgbCxxAggG",
        "jvfjEpyhjL}vJlaEgtAtaA{tCzrEmyAr}A{jB|t@}|B|@mgJ}lB}~BrSueBf|@iMbDkwAx^_}Bor@s}@uvAij@uiEgu@ovAeaBor@qfGk}@upBqk@mkDaiBolAH{w@hwAmo@dkCew@rlByjD|lEuvIvhIuyDdaBicTjyCmlC`CgsBqM_t@}Pmo@g`@{BsqCkRsy@_eD||B{jB|J}sBiImcCxOg~BxgAafAhcBeuB`qF{~DzoBqkMmQ}bB|tAc~AtpAkq@tpCyOpjB_r@pjAwxCpp@gu@HapB{Pyw@`Ac~@hUsG`BadCrhAekAdNew@_IkfBck@ox@cIih@fVebA~fBa{@|YywBeCcp@fK{u@xi@i}AnfBqv@|ZafA_IweAowA",
        "xrgnEzksiLuSxx@wlDkHorFwy@ylBqGmeNhlB_fCgB_hAmo@wmCesEcdAcmAs|AiAckElhDweBrt@ayBaHsaJcbC{`AdDgu@rS}u@~IoaAcUyZsd@ag@_|BgVwo@_hAySsaH{WweBkSq~Am_AkoDgbDg_Bio@_{BxDszEpoBkuIjr@qsCjnCwcBflEafAp}E",
        "|yziE`ktiL`\\l{EhaIrmG`\\lbD",
        "pegpEhruiL{Vgb@ij@wEg_@_O}}CqqL_}@gW{tCts@ysF~yC_sApg@sgB`\\ew@oDis@qWi}A}Zk|Mgt@_aHfAghDd|@_UvsB",
        "ltfnEvgpiLj]bcB",
        "tddpEvwdjLxDobCzVo`CdbAm_F",
        "zhdzEflwlLcZts@q|EmB_kIehK{gEnYufCt{AszRbyGyaBjF_cFk`Au{Bw@kxFfe@kaGu|@i}Adr@irApzA_gB|xAi~KfsCs~AdOis@gfAoYozBu{@mkAuzC`fAapB`}EwZzzGmeAfwFqpFlrBgzH}_FciGuo]wqLepB{rLpW}O\\i}LauB}g]g`NiiAzW{u@|jAmyAtzAelB|u@yc@yi@_SaeBmz@y{BcbEyaCi|Me|@etEgzAokBmsBwwD{aGs}BqiBgoHujCgiCawAwkE}bHqtBqv@wmCtCyuDhYs{DhDojCgj@io@wy@eg@_p@wp@k~H",
        "tev{EpjhmLcF{mD}~@}yBmbBkeBmj@eZ}nAeq@mlEgjAcy@{f@eaBokBmnAkh@}_B~S_`KptDigA_@{uBcn@{a@}`@q`@{q@ye@oh@up@cF{l@bk@",
        "tzczEbeslLdMbfC",
        "|kq{E~zumLfV{nCnaCq_H",
        "r{j}E~odoLqtBmhPafA{{@ipC}@shAd^adC~_BymAjR}u@yNs|CkiBst@sE_r@pLur@|Ewy@iZec@em@iTsx@oY}tBap@yrAcuF{eFaQq\\eZqeAsSyYug@aRwoAoE{a@gKoxBo|@{j@ck@{X{pA",
        "pmd}ExwtoLnYcgC|}AqwFv\\ct@p`@md@hTqk@",
        "dau}E~odpLwQwnB_}@upByaB{gAyhFak@owA}s@w\\{kB",
        "los}EjclpLdc@c~BpLgsB",
        "dj~~EjmxpLox@k`BaeBgLydLpzAyhFsEo~Gym@m`FkpBwRs_B{UonB",
        "nmz~EbqcqLhIs{BncAewBzl@}mB",
        "twt`FdviqLu}@kpBevAyn@evA`[q`BpsDcn@gBkq@s]en@eOis@gB}TqKoYr@}`Ajg@md@`p@_Sv{@m[dv@i~@r_@yw@sIiu@we@kq@}k@cn@s^yrIi|CmxBk\\{fF|KeaBiUafAg_B",
        "n~s`FhkqqLzVmyBh@uyB",
        "fookFfxcpL}TwiCwfAe`BgrCiwAec@kc@shAs{D_Sqa@k|@iHkh@`\\we@ld@ur@rPcdAkC_g@oIs~Aa`AwlD}|C}_Bo~@i|BoS}dFxxAwxCvaEi|BbiFgrCjnEaxEnpC}f^jkG{|D`Rg~DsJsoEuv@yO}@cO|@mPhEasBne@aaCdj@iqBzAugBqsA{a@_O{a@{Cob@zCga@~N{sDrjDaeBjw@cbCza@oaCzw@_nFhdDkjGvl@goJrnFmzXrbIiyGfl@maCkHowA_j@afAufA}iAg~AiiAquCwe@g_@shA{BcnBnkAmcApLcyBg`@ulFe`B_{BuRkpCp`@upBhrAgpEhfEkkHhdDunDt|@cmCdEcnBis@ysFwvFoaCmdAmxBcEayBnNybCgAieC_s@uqAowA_gBc`Fo`D`kFobBbnA_lHzw@ebAdm@mbB`cEmyAjzByDkg@",
        "nsnkFjclpLvZcjG",
        "fmxpFh_ssLoCigBkrAafBm`Fap@_oEj`Hw`EkcDkpA{wA}hDouB}iAgjAq~A}u@udExbBcwBwEyaBybBydAkeCquA{tBcvC_r@g_O_~@emYxaAkqMtqB}fD{CqmKmyAazCcbBykCouDkkFmwPelBmaDcxAwnAsi@a^oPaq@s}@{tMih@ybBuzE{jJe`A}{D}@goF",
        "jeopF|{ptLTelA|cE{aFdn@mu@zw@azA`QqiB",
        "vyvsFdvotL_nFynAg`ApLmcCxn@cdA|Kst@qMs^ae@qWsk@q`@s_@ooKogFmcCkr@k{Al[igAhrAyvC`xEafAh~@wxAr_@_hCnM_fCt^ohGrrBkcCdWwnB{a@upBi}@sgBw\\srDrhCudCvOshCmZanB{v@_~A{`B",
        "d{wpFrqvsL`QiqB",
        "beypFxo_tLi]cwCsJaeC",
        "norsFd}_uL|hBsxGh_@klF",
        "`y}tFfwxtL{KlnAa^dm@mwCd`C_zC`bE}}AzvAsiBlo@el@uGwzA}u@}TkHi~@`\\i~@s@e~Dom@ox@mYst@_Kyn@nY{u@nm@_i@eBuqAkrAmPesE",
        "nxuuF`sxtLks@__AweMo|FwcByZq_AgAk|@jHiu@nX}h@nm@ec@fjAeD~h@",
        "`qztFb~stLbZlpAfVz`@|_@hJtSnY",
        "xysuFpmcuLlz@mhGfBapA",
        "ttl`Gvr~uLa\\oxAox@gu@g`Agk@is@cz@m[ylAwy@qwLs_AioDq`B}rC{~BkqA}cItScn@xY}hBpsBwo@di@kqAdfAowAyCobBa]ejBeCi_MvyBkxDz_CcxCvvC{hD`oBoiFtIumE|_AyeKzbJ}zDJonAewAq~AotEg`AywAgjB}~@afApUybAbeAg_BxmA}hBdm@ymAzB_yD{m@ywByMyxAbE{tAb[ylB~p@yjFtgAgeEsIm|KmxCq_CcZo`BbO_oEdmAq_CbEqk@aq@yc@}}@aeBga@o~EkSo~E}t@ufCcFgfFnxAe}@n@geAv@kaGmdBwwB?uzCrs@mmBxcAq|GtwFojCz`Ac~SxuEcdAed@{cKu{M{~Ds}B}dFq`@cy@~R{bAl{@u{@vF{l@aRucDaoBaoPkdFiiAmo@_S_hA",
        "lnb`GnlovLzBeiEbyBycBdkCirA`{@mvC",
        "fkigGjx~tLkgAs~@iqBeMwnB`Far@rJeaBza@_}@fCew@{NgjBaz@yw@yOomBzk@cdA~{BioDh|PcoAt{[s|AtuG}fDjcGwaFrnE}nGdwB_zEag@}uKolCaxEsi@cd[rt@yaBlZosEzwAowA~H{tCew@yn@oDcy@`RcxAnbAcp@tQe}Es_@{hDo_CovBkyDkzBc}Hk|@cPafA~g@m`FbwDg`A~GksIwbBguBnx@}eF|aI{}C|jAyvCgw@ekCsfCuyBo`D}rC_qBghDen@o`DufAu{B}zD",
        "|_hgGzlguLhj@osG",
        "ntfhGjgavLgV|}@a{@bo@_^cZcZgu@en@g`@_pDxYih@Uew@ce@a\\om@}Vap@ug@gl@kq@uR_{DiJwn@eb@oP{kAiI{}CowAwvFiTmwB",
        "~kwhGrlpuLsUvlCmyAbo@}_@iSs{BwxB{B_@mcC}@_|Ap`Aox@dkB{Xt|B",
        "tdehG|d{uLjIf_AnWf`A|K|_A",
        "||ejGb{euLag@rqBaeBfVgsBcc@_sAu~@{u@ghB}iA}eGcp@gsBkpAkfBmnAqa@yfJ|j@iiArUom@bz@amCbhGm[`h@od@`e@ae@`\\od@lf@i_@bcA{KbmC",
        "liwhGn_kuLpAblD",
        "zn_nGvvjuLyaD~oFkoBfUcdAufBom@clC}j@azAqtBag@cxAxn@}tAzkA_gB`p@_pBeWwwDkfCokBkFqkBbm@ohGjdEmiFvzA_sA_rCis@avF}gCipEgvB{hBosO{wMi|Bq_A_sAxBmeLn|IemAvoAwZ~q@gl@fuBce@vd@wdAdNyn@sTgj@i_@{w@yO{iC|KoN|j@",
        "rrcjGx__uL~h@hsAh_@~eC",
        "~j_nG|xgtLox@v~H",
        "nq}mGtxqtL?rnGby@`kGfBjaG",
        "~hmpGzxkrLmd@kmFsrB_zEyuDayCsnFqk@szEtr@mdBjGywByb@ieEkeCe_BovAij@gaA{BueCuSi{B}~@eaBmcCyx@ovBr@_}@vp@kq@fjA}tAvnAejBdl@i}AvQowApb@owAr|Ag`ArqCgVr|CgB|bIggCvn\\",
        "pd_nGlu_sLlEnbg@",
        "bzapGzgksLby@}xF`wF_hNt{@akG",
        "~aipG~metLuwDmvPen@umG",
        "xadpGtc_uLtSylCnaCycL~GabG",
        "nfkpG|aquLmPuoCa{@upBuhAgkAkz@ewAcQmvC",
        "lddpGzyvvLbbAklFhj@{iCrrBu~X",
        "rzaqGb|wvLa\\f}Bq`Bnm@soEae@ycBqCcrIlzAqhCemAmd@spD",
        "dwiqG|{wuL_sAhyFsrBfzFebA~yF",
        "jlaqGnlovLfMrnG",
        "x~oqGplktLga@d}Fcy@vdBssCvbD{u@~|AwZblC",
        "d{eqGj_cuLrJ~oCld@lmC~q@`dC|V`wF",
        "rkztGr{wsL_^c_F}~BudFyaBmcAk{A~RcuDr}Bi~Bpu@s}@qKkxDqrRwp@}rBkgA_}AucDgrCu}@weB}pCmmCqhEfb@amE~dC{}C`yCymCzgEqgDrmI{}E~mF_hAt|@y}G`pBsuJhyFclDrpE_Sf{E",
        "hdoqGx`dtLnYvjF",
        "`sytG``gtLpWmcN",
        "xnh_Hhl|uLymA}eEg}C{kBclDoCucDhgAmcCxwBazArfDacDdoKisBnaCkzBs_@wlD}vKobBk{BuzAhiA_fCrpE}tAh~@myAqCcqJueBel@m[kh@si@ih@eb@ar@eDap@`\\qk@ve@en@b[a{@{BmyAybBa\\seDsA_bIyc@sfCa{@yyAkmDucDwoAqjBykCy{Iq~CkmEq}Dsj@ycM|~AkoBoMs~Aom@eaB_`@euBnZwsWpaL}yEt{@yuFlGy{G}UupDnX_{BlxBgqD|vJknEhmHeXnx@gMdw@cZr_@}~@}Kec@_r@aQevAih@onMk]ouCcy@giC}iAywAcwDe_CssAsiA_kJsoMosDmeFkbFpjAupD|hBsfClxC{_BryEocApgGwy@p~AgjB`g@i}Aa]{vA{t@i}AeN_pBpuAcnBvbDmcA`z@obBjSij@gMgsBcbByw@uRwg@zLmd@|Uom@tHueB}KmeAsTs|CmnBk]{b@s^yl@ob@cf@kh@eN}j@hVcdA|}A{V~SuoC}_BccBc_Fa{@icGsUmlE",
        "pga_HjlsvLzB{~BvwDeoKri@_oE",
        "rwl`HdjvwLmPggCa}@_hBy_Di|CusLmaPuzCuzBokBsu@s}@bFu}@le@sgBjg@siBfKqjA}Uwe@wdA",
        "pok`Hlz`xL`g@goI",
        "plbfHfbkxLmPupAcxAgl@{jB|t@siBpuA}rAjq@}hBkHcjFymAkzBqKqoVfsCg~Bj|@ur@nsEcZncAgj@nm@st@nM{w@xEyw@fVczAtfBq`@vmBkRbwB{l@ldCy`CzfE{hDn`Dy`E|t@{gEazBayDqsC}tLwaDqqE}iBehUkmQsgBmdAccBql@qiBa[cyB{M{nIaoBssAvFg`A~fBm[x`Cov@fkAirCcy@uzAczAk|@wnBufAo|FcFs|C",
        "t~`fHppsxLnCeuAjh@cwD",
        "|jukHd{c}Lis@|tKul@dp@yhAjnA_zClFuzCkpAmsIyoKssA_~@ymAeMwoAp@k{AwPojCqtA{xJc|J?Scp@oo@waDsyFqjAcgHoo@e_RoaAgpGi|BinFy|HmzLumGkkIgqDkdDe~Ds~@spFyXauSve@uvIzjCm}Htq@whJalFoaCerFwcBwaGk{A}jKox@keB}fDknDevAagAqWyb@iTynA"
      ]
    },
    { "left": "ARG", "right": "CHL", "kind": "International boundary (verify)", "lines": ["x}mmIls}aLnsIdAtjEthA??"] },
    {
      "left": "COL",
      "right": "VEN",
      "kind": "International boundary (verify)",
      "lines": [
        "origAd`prL~Cg{D",
        "ky`cA`bexLwZylBsoAq`AiuIkyDuuIsyDouIkyDkuIkyDkuIkyDkuIiyDiuIkyDouIkyDurB}}@wwCgkBmoAayBih@o`Du|AgmJ}|AgmJu|AgmJu|A}lJ}|AgmJk|AqmJ_}A}lJ}|AimJ_j@{gDghBuwF}rDytEu{@mnB",
        "ebccAjdpxLpKwxBf{@qgF",
        "i~|v@jrz~Lqq@hrAwfC}@cxBihAc}C}eFsgBcnB}}BymA{uOwuEkyU_sNitGouBcrAa{AuzCsyFugBybByqBq`AgfL}|CgoOsvIglKacEy`Dmp@srBzWcrBfv@{_Dtg@o_CyCusF_s@urF_@qia@qdIixi@s|BgyBnCqxAiEq\\aAgyB{l@}~Be`BogBufBgrBqvAegI}qB_yL_`KaoG}gDosYslHitGwoC{wDacDyzDqoGymBisBmwCuoBejOcvEseAuq@s|BeuBu`Aen@w{@mPevBoDkw@a[ihAmnBoSkeCiJukGk~BgzIuXs|B",
        "}dpv@nkd|L_]duBywCvnBsfCfa@meGoOmwCdXwZlPsy@ny@k^hTkV_@gv@eXkV}@maFxlAum@le@",
        "covw@vur|LzClnC`{F~mGhnA`mCjk@z~CpfAnlBpgEluEhlBl`Fzb@~bGvOhmTbApwA",
        "eyap@|zqxLanCkdBcoF|JoiLjeCucK~nEejCz`@gdBmFokE{v@udBqJchBlPygBfi@o}Av{@miA|hAw@hBk^jy@oNbz@oWh~@k|@hhAw}C|rC}bCjyBybC`zBwbCvyB}bC`zBccC`yB}bC`zBwbClyBacCjzBgzBrqBaqE~{BczFdaAcpGvfA{oG~fAapGtfAwoGjgA}oGtfAapG~fAyoG`gA{oGtfAauBh^}xB|hBunCcyA{fA|`@e|@~fBgoBzuB",
        "qnxv@x}n{Ljq@nm@",
        "e|vv@hlp{L_@dm@kQpu@}@tfA",
        "oqwv@vxu{LrUzkAhXvp@~jCxtEro@h}B",
        "sobp@~iyxLxTybCRgjB",
        "wjbl@hjlxLow@dqHqs@h{Cof@ptBadDhdFmsGdjDirCrS{_Cae@s|Bit@qhC{WovBhTesF|sAq~BlQ_nSox@y|J_|BylB{M}mGxOokBdYcdAzj@{uCdbC{u@j[_hAiTwf@ew@yXafA}_@{aAgkAu{AsrAshAeaBur@ayBu\\qoBu}@aNetB",
        "c`si@dzouLcPblEwwBxeOkj@fyDQb@oe@peAkzBhqCkq@rrA{kAzjDem@jfA}|BzjBotSfwIioDnbA{tDzl@uxDbPst@oCe}Fcz@s_@dMiSr`@muGvvEwy@fpE",
        "orbl@`i|wLvFf`O",
        "epdj@lvcnLco@zrEsT~y@gjAhwAkS~g@",
        "quij@rfpnLzBjxDxwArvJ`ShoGlnAtmFdCn`Cf`@lp@j|@`\\zuA~aAtzDrhG|rBdwHtf@xqI",
        "efwi@zlemLi@taAcYhbByc@x~@qmK`{Hkg@pk@",
        "k}fj@h{wmLvPlcBpv@hoDzBjeB",
        "a|{i@v~|sLeDfj@_r@rhAkq@pb@ec@hr@wFzrE",
        "qr`j@j~itLrJnnApl@tg@~eBqW",
        "en{i@dnqsLwFtzBcDpCyOrIga@zNqWh]",
        "uf~i@fgwsL~J|t@lo@rsAdM|k@",
        "kr{i@~}ltLel@rpD",
        "q_}i@rortLtH|rCnX|rCpAfrDbnByNrU`f@",
        "wrxi@bpesLafBt{Bob@djC",
        "i}|i@~wmsLt\\jpBtHlEvFs@",
        "u~yi@nlnrLwF~fB}u@dhEiHdaB",
        "uf|i@z_{rLhSf`BfjAjcDjSriA",
        "a{ni@hcnqLcP~{@ah@bo@eb@hhAmF|oHob@hsA}~@f_@ymAzCugAzKgj@fw@aIf~A",
        "cp{i@nhfrLlp@~bG",
        "atwi@~abuLqLnbA",
        "saxi@neduLdBbdA`q@bmAjr@`|@tg@dbAdOd`B",
        "{zii@r`_lLmGncEktHdhSs_@z{AcPzRew@vd@mQ`\\{Bf{@",
        "}xwi@b~`mLvQvmC",
        "kdsi@f~vpLmn@~wL",
        "ysti@fwdqLbd@ly@xw@jr@fw@lnApa@xmB",
        "_wjd@vezfLecFdtDetQbyMusQbyM_tQbyMatQnxMysQbyMatQhyM_tQbyMusQ|xMafCpjBunDrjEqj@rqD",
        "_eri@buekLfKtgFnw@paFjdEf_J",
        "}k_`@lvp|KoDw[a\\{`@{fAm{@_Zq`@keAmwDic@ss@{{BirBgo@obAaR}iAw`@ga@caFwcA_m@od@ug@}j@er@cd@mjAcPk]~S{yAj|Ag[hTgzB|IknJveAs}GHakGwp@}vFccBm`FotC{}IwsJ_bBmx@_aI}eHwu@mxAw~Aw`F_~@{kA}iBgWunCzMy|Bnn@oqBx_DsgJreFmoFf@kuAwZ{gAobAk{Ac{Bo\\sf@ShEoUzuFsaCxlDq~CheDopBxtD{bFft]_d@hsLc_@xmB",
        "}cpe@vx||KbAfu@xc@riAdvBrrBpt@p`AbKvdA",
        "cdie@pth}KgArsA",
        "kfie@dik}KtRtfA~mAj]v~@|J~}@r_@|n@`p@jRlz@~Il{@biAtwE|e@l_G",
        "qe|d@z}c~KakAx{W",
        "sq~d@tz|~Kbd@ppGh~FxfU^|eF",
        "glyd@bk_dLegB|iF{\\n`C",
        "ir}d@pwjdLxDnvCxs@dvBrfDhoD|mAteCdeJ~pJxfEzbJ",
        "a{vd@vsncLgZteCus@dtCw_@~kC",
        "wkzd@r|{cLn^nmB",
        "elud@~zb`L{oBzxKeNn`C",
        "glyd@jvs`LnM~eCtfCfjMnSzcKx^ncAtnCjcDxd@jrA",
        "glmd@vi|aLmPbuCswBtbGm[n`C_NnkCixBpmKsT|cC",
        "upwd@`ebcLrTtmK",
        "csbd@bsseL_hBnkCwoHhjGm~@h|B",
        "ilqd@fhdfLt\\ffDfjC|jHjk@xzC?zD?rgA",
        "sv_`@p|r|KtIceA",
        "ynmZznb}Kgf@pv@mp@ht@gz@~h@gdAhSwuAiIoh@ec@a]sj@er@ea@k{@aHmfE`HkdDwf@ezIuR_gCi^gcBu}@icBmo@irGqM}sB{j@iy@|^oc@kHci@iSqkAgAmi@lO_mBzw@oh@fKspCeDooFii@krFwoAuuBsI{tG|Ie_@qLi^k\\yi@a\\kaAgLsi@|U_aCjoBe{@bf@o}@|Tg|@fLm_AxDkfAgAkkAoOgrCew@cu@{KgsCtFslBfWo|Avf@scBnw@ynFj{@{eGyw@}uFazCy_EogFeDa\\",
        "{swUfpm{Ki@hqBk{@xwBcdCbmBspC|j@ctHdb@{xCbz@mpL|xFqdCl\\kbK`RqsCzu@sUjh@kBS{fByPmrB~g@gfAxcAeiEht@_{BdtBa_BptBavB~s@qbEl[aaEfu@enEfa@_jFu^alEwnBoiAcOepAhSshCpvA{pA~Raq@kH_vAob@{q@pAcd@zWiZdlA{WpXoyEhs@oqAzk@{qAfsB",
        "iynZznb}Kni@?",
        "}z_Ppbd}KsjLeCwmD_gB_pCi{CwvFwjGuvFmjGwvFwjGkvFwjGwvFmjGkvFakGawFmjGmvFakGokBgtB{b@qiAwYsgCiUs_Acy@qkAawMeyJmdGo`DcdG_]}uEhnEq{AxiFm~@`{AgxBfuAoha@xdLqkFrpD_mBbjF",
        "}qxU`|e{KjGz~BtThsB",
        "icbP`}~{Ki^~yC_|Bv`GqkAbcA}T~s@",
        "cbjP|ro|Kj{@xvBxD`eA",
        "}_hPxpu|KwE|gC",
        "ufhPvyy|K|_@~{BpjAt}@fuAjp@~gAvzA",
        "uwmFbpdwKmjGdaC}rCh^qfF_rBqtCnEuxCvn@o{B|`AabAr~@ix@tfAg_Aly@wuApVc_Gsi@uiCpWkeCvz@mzE`dCyfCv{@azBdWquG?kfCvPaqk@bxOwrEloBsbAnNco@vYgpAftBmoAlo@uq@pm@m_Afk@imAxNa`CycBul@mZslBsToqIrTscBvf@eq@~|Awa@~oB}s@t}AirApt@{hGveBc`Efk@imFlbBirBpA_rA_fAupBowB}~B_rAi|B`g@ew@za@quBfA_}@rUyn@jp@{}B|qEkfA|zEgb@dx@ouBxuBcp@ncAiSncAi_@zu@gjAnc@gtAl[s~@~\\wp@xx@}iApiC{l@lz@}_A~g@wdA~^qv@pk@}UnmAeWnXwyBz`B_r@|Tkg@dY}_AtdC_i@dx@cn@xX{tBnd@ks@bY}rAh}Aqb@rrBoCtwGmy@hiAihCxc@sxGza@koBdl@okCnwAu{AjpB",
        "{ndPdiw{Kt\\dvBzl@t{B"
      ]
    },
    {
      "left": "POL",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "kztjI}gpiCoc@~uc@ol@|pl@yt@piu@wt@riu@isAnssAcdAf{dA_w@xkw@aw@xkw@qjA`tjAcg@fig@cNjfNi}@ltH_~@rcC",
        "umwjIcv}iChrAdmL"
      ]
    },
    {
      "left": "PNG",
      "right": "IDN",
      "kind": "International boundary (verify)",
      "lines": [
        "f|zNkam{Yx~DCtka@pBpbe@zB|mo@xDrt_AcDfsi@iAdof@eC~m`@eBjnqAoE~ua@{Aj}h@_CvcAElP?pbe@?doW?x~F?jgq@?fec@?vee@?nkk@?xsS?~GdXtfAbx@j|Bt^zK~\\rUnExc@qLhs@m{@xc@eNr_ApW|j@dn@vn@z`@boAmO",
        "legf@czh{YeDjeA",
        "f`gf@wsf{YfBz`AnNv{@`\\zu@vFoaAh_@si@zu@aSfkAhA",
        "txmf@u_h{Yr|Ak[tpBjQ|u@~h@pLh~A~h@dl@tfAzLr|CxDp`@bP`Qr_@pCtr@tS|t@vn@}Tzw@ui@zl@iIp_AbyArU~fB~]jzA|}Apv@|j@wyAfsBoD`mE|t@thA|`@pv@xNf~@mFpaAom@fsBoaC~gAec@~h@hJjpAbz@v\\zM`dAuS|u@ur@dvAyvBbcB__@xbC_I|rAco@",
        "f{mf@c}d{YqAqaB",
        "~bzh@chf{YheEqU`}@}tB",
        "`k{h@eta{Yag@}rC",
        "|~ai@grm{YtbT\\bw\\?npWTx~F?bpr@?dec@?v}c@?hxF?~y_@U|ur@}@hla@}@dpc@Tjtd@fAdnU\\",
        "jgbi@stj{YmGs|A"
      ]
    },
    {
      "left": "KAZ",
      "right": "TKM",
      "kind": "International boundary (verify)",
      "lines": [
        "wqmaGya{hIvo@qvMbyBceMdaNei]viO}{_@|wHctRtoJqdVltU{}_@dnCqsCpyB_}@rhBh@~kBxXteC`Hx|B}_@voBg`ArrSoiSt}G}yGx|OstK~oOskK`oDo_EtoCiyExiEofKhsAyaBfiBqjAn{HanD|iBihBpiAy`CpjAanDlp@w`E",
        "oay}Fmv`_IscEi`G{fUwx\\gkRw}XU}@c@?k}Xwxh@q`Gip]m|C_aJcvKmaj@q`Am|K{sCaka@w_Ci|\\_iEixm@",
        "mrf{Fe}ftIt]}iL",
        "_kyzFctxqIga@wsWojBeoJi~@ucQclEcmPgLipE"
      ]
    },
    {
      "left": "UZB",
      "right": "KAZ",
      "kind": "International boundary (verify)",
      "lines": [
        "}hkhGgnqyJwf@~|Buf@r}BoeK|sM}cHv}IcdHj~IkdHl~IcdHv}IqjHbfJqjHdfJwjHvfJqjHpeJckJ|tLcjG~uIwiGjuIylP~kUugLpnJ_qCt{@sbItg@yvC`g@udD`pBcaCl`DaxDpdKucGjcPgaJbiVyoLvm[coNns_@{~Otwb@e_Qv|d@sqQpaf@{rQ`ff@ifQhje@{iPpoc@g~Nnr`@q`ErvK}aGd`PoyJl{Wa`Hn_RwwDndKg`AhgCubF|~M_t@niDuHrqC",
        "_eauGq|fdJ`eBlyNpkA|vJzkArwJzkApwJdkA~vJ|jAjiJpjA`hJfjA`hJzjAbhJ|gDrlWpgDplW|gD~kWrgD|kW`dCzhQ`dCzhQjdCzhQvcCpiQjdCzhQ`dCzhQvcCfhQ`dCniQh\\~_CvfBzgM`dCfhQ`dCzhQ`dCzhQldCdjQ`dCfhQvcCzhQjdCfhQ?RHR?THRH??R?TJRH?HR?T?RH??RHTHRJRH?HT?RH?H?HRJTHRH?HRH?HTJRH?H?H?R?J??RR?H?H?H?JTHRH?H?H?H?J?R?H?R?J?R?H?R?J?H?H?H?R?J?~xk@i@hyk@S`yk@i@ryk@S`yk@i@dyk@Sdyk@i@~xk@Sdyk@i@dyk@S~xk@i@dyk@Sdyk@i@dyk@Szxk@i@ryk@g@",
        "odudGw_upKoCrt@oCzu@m}QbpKeaUhsMg~NbrIi`X~qO}nAjzB}nAtzBkeH`bSmeH~bScnFvuH_oFhvHw{Rb`Tg{R``TicA|hBubA~fBsJlbBiJbcB",
        "mrziGy_akK`^boBt]toBrtFx_RbyFlkRjqFjxQ`|FpsRvUnkBxUdlB",
        "}gxhGcjfhKiUfwI_x@r`Zox@p`Zex@dbZix@z`Zy}@nv\\i}@xw\\o~@bw\\y}@bw\\",
        "u~giGaix`KxbA`zPjbAjyPhbAjyPjbAjyPnbA~yPhbAjyPtbAjyPhbAjyP~m@t_Jnn@v_Jnn@t_Jbn@h`Jj\\rzEp\\|{Ev\\z{Et\\rzEvcAfcOx@vL",
        "kki_GqzvtKsAxqVw@viT}@tlTmApoViNbZeOnYw`@`Fq`@nEo`e@iU_d_@kRm{DqBij@uQaj@cQiTshAkTshAwt@_^wt@u^{cDoNwcDoNaoo@ueCkoo@ueC",
        "opkeG}kmrKdeJ`e[xdJbe[",
        "}qz`Gu~_pLv_CzrEz_CzrEdl@ptBvk@ptBvKduB|KduB",
        "u|n`Gm_doL{\\toCa]jpC",
        "sxp`Gk}znLfAfiAfA|iAvk@pk@fl@fl@xx@dXfy@dXxh@|`@zh@|_@~lAzuA~lAzvAzdBhhAvdBrgAdqBzw@bqBxx@|zAnaAd{AfaAta@daB`b@z_B",
        "qhm_G}}wmL{FriAmF|hAwRf`AoRdaAoc@nn@uc@lo@my@|Tsy@~T_h@rUqg@pVsh@vp@ei@`q@e]xw@u]nx@mEnm@yEzl@",
        "{l|_Gky_mLjaBfoHnaBdpHjuAteCluA`dCz~BplAf~BnlA|u@|Tpu@pVp`@lf@h`@tf@dS`r@~Rtr@~Mdw@dNxw@vUhu@hVft@na@|k@|a@dl@zpGfrEjqGnsE|cAlnAfdAnmA`oChcGlnCjbGvn@tmDno@vmDd\\lo@p\\lo@ho@ti@fo@ri@xrAf~AbsAh~Anh@d`Cnh@laCpHd{I~Hd{IzvAndL~vAldLn^rt@b^ts@zlAvxAxlAxwAr{Dn|H~zDb}Hhi@|pDri@~pDnl@tqApl@hrAtpA`g@vpA~g@f`@}J|_@_JvfAur@hgAis@h_@{Bh_@{BnNxc@lOdc@",
        "wobzFozxvKkq@l`G_SfdBw]xzCo_CziCq_CxkCow[xiGyw[`kG}bWpfEqbW~eEutWxkBytWdkBoEnNwEnNqBhT{B~SUrVWzV",
        "kpi_GaixtKjArUrAzV",
        "wpb|FwzofLoXtyDyXjxD",
        "add|FufdfLtHnn@tHdm@ly@xwBby@lwBdDpl@xCxl@",
        "cr_|Fk|veL{Wj{AoXv{A",
        "oda|FgcqeLvF`q@lG~q@`pApiDjpAzhDxw@zkApw@dkAz_At^|_Ar^",
        "u~s{Fkq|dLmPxx@cPly@",
        "gau{Fc}xdLpLxy@zLxy@ht@hoCrt@joCxNzXnOxX|TdM|TpMzXuGxXcGnZw[vZa\\jGoN`GoMhJwGhJaHnc@kGxc@aHtr@qAjr@qAbhH`p@lhHlo@dc@dXzb@pWtf@|t@vf@ht@zv@piBpv@zjBhh@voB~h@`oBfLteCfLtdCxNr_AdOf_Ahg@~g@vg@lf@`dBxlAvdBzlAjfAbuEjfA`vEhhAzuAhhA~sA~xF|qBhyFtqBly@h}@bz@r~@|~@d_EzQ|w@vk@|eCdl@dvAfl@puA~gAda@rhAfa@",
        "_doyF{}f~Kir@~h@kr@tg@cxBdXwwBpWqv@r^qv@t^sgCdiCghCrhCqa@|T{a@~TgC`FeC`GywAdd@cxAbe@",
        "k}mzF}_t}Kve@vnAve@bnAvyAzsDlyAzsDxE`{@lE`{@",
        "mmezFe_`}KaQncAmQlcAur@bbC_s@xbCyM`fAeNjfA",
        "swjzF{`o|Kxb@j~Wdd@riXfVvzNxb@l|Wj]f{Sjh@ln[bZv`R|_@vtU",
        "cuuvF{lz`LeeHj_Vq`EzbN_dBn{F_}BpqEs|BhpEavEn|GmvEz|Gug@f~Aah@|}A_SjzBkS`{BiJhS}ItSqW_IqWuHkRm[kRwZmd@ylByd@ylBs^_s@_^kr@mf@em@kf@em@ah@eb@_h@}`@apAyn@kpAmo@keByl@aeBqm@ihB_^}gBk]{wAg@mxAUoc@zXoc@nX{MpMyMnNkInXsInX_IcZaIeY_g@sgAag@ufAcEjGoEjHmF~\\kFv\\c\\wFu[aGyE\\cFReaArJoaAhK",
        "czsyFqdw~KbDdbAzCnaA`eAhj@`eAfj@",
        "_doyFihp~K}_@|_@g`@fa@yCve@gCbe@",
        "goqyFgxk~K|Ljf@nM`g@pVxd@fVbd@",
        "gqtxFkisaLyEfMaFpLwGt\\uG`\\yDpMcEfL",
        "o|uxF_woaLna@f@fa@TxdAwF`eAmGj]zB~\\dCdb@vRpb@rShJtSrJjRbOvPnNbPbo@hKbo@|IrdG_^rdG}^lz@kSby@uSdXyXzW{XzKu\\|Kk]fMmnAdMcmAve@pA`f@fB`g@uJ`g@}Ibe@uSve@iTpa@yYza@yY~SnE~SxDf~AdkAr}A|jApWyz@fWu{@~g@vQ~g@tR`]zaA~\\z`A",
        "yqxvFgataL_HhrAuH~rAen@h{Bcn@~{B{Cdc@yCxb@",
        "ol|vFsxdaLxMl\\dN`\\bZlPbZlP~TfU|TfW",
        "ilxvFwl`aL}@dn@}@bn@",
        "epxvFmn}`Lv\\ve@t\\be@xNhIxNjI"
      ]
    },
    {
      "left": "UZB",
      "right": "TKM",
      "kind": "International boundary (verify)",
      "lines": [
        "}sddGg}qdJr_AmwChpc@{_i@~}GqaLrqCgvL|c@muG",
        "cehcGom_dJow@maG{tDkcCsqOitAylCsrB",
        "mxpcGgqqbJtBowCphEkaTdv@k_IzM_`I",
        "wvaaGa~ocJel@ypK{a@olA{q@_Uav@l[yo@`fAa|E|zFqmPxnMobHreDoyEn_Eg~Bf{EcoG|mWulAzsBiwBpb@gzAcy@m~@upBgkAyjFutCkjIgZ{sB",
        "oesbGogzgJfeAouCnqHilKhhBowArvBkz@j|MiiAfnBuqApgAqrDxXm}Hrd@uqCffEixFrk@i{C`F_bI",
        "mkobGyfdgJ{FmvDoc@esDa`AqtDsKo~C",
        "kilbGarfaJdBmlC`^{uBdaAmyAl|CwmClj@ccB",
        "mql`Gszy_JwRcwBgiAqhCgz@jRabA`oAiaBfl@wpAar@mx@_nFsiAwxAmpLo}FupCiu@k`B~IitEtdCodDpb@waA}hB_w@{hDufCq~CygA}u@o}@oaAgf@iqBeR}iC",
        "kyebG{|fbJfQ}gC~wEwkRhrB{rEz~Cy_Dj}E__AdqBhT`jBr`@``B|@bsAshAjRaeB",
        "a|bbGucyaJ}EkdBigAwaFaMapB",
        "gsfaGmbikJnc@s}O",
        "g|aaGoy_jJ_vC}gh@",
        "}gfaGcxblJpVqzGp_D_dEnhEylDhrC}yEzoActGb_AuoCppAgkAxgBhTtv@veBff@z~Bvv@teBt`Hnx@brHwyBvuFkRpjBxqJ?|@?|@",
        "wneaGaazkJeXavG",
        "c`m`Gsol_JtM_jL",
        "cag`Gqzt~Igj@uaHm}BqxIiTywB",
        "wsj`Ggfy}IrqBisZ",
        "gmxzFux}zI_t@ywBogGo_E}iBkzBylBibHufAadC_~@meAsi@qLmZxn@yx@fxHob@r~Aco@nwAisB|gCayCbwBclD~rAalDl[}{EqCgsDhVwbDtfAojDziCi~EvnB_dEcFahEap@ijFoNolNdiC}oF}@utDioDmqEcwQspCa`GuaGyhFs@?c_NavI{nJouNytEyjQaQcwQ",
        "yyh_GynylJM|@",
        "gzh_G{lylJzVlmBn|@leApqAtHrwAcdAz\\cxA",
        "od`_G{pbmJnxD}oSfuBawDzbDgnClpAgfAngAs|AhbC{fH~v@yvAdgAgkAfuAu{@xwAsJfpAhgA~HdaB",
        "y{__GqlxlJuGicI",
        "ci|}FwwqnJah@`yBkeBvvEqv@djF",
        "cpb~Fwz_nJrKtbE~wAxjDbkDz_DdyE{w@|tGo_ElyL__LxqByw@xmA|tAf`BjaGteApiBpvAjpAziBbp@ftNbmA|rCgj@bbCunDdhGakTzgFmxQfpEexJx_GcrIn`BsrDdn@uxE",
        "wse{FchttI`h@eu^bo@kjc@~s@alg@hHyaFdx@qsj@r|AmmQdwBc{V",
        "_na{Fkt}uJtRseFbxBy~QhpD}~OvhWetj@`dBayBrfQsiMtfB_t@p~BiTzwLwO`{Ak]xm@bn@tzBwdAnkOucEd|GufAldCwp@tqAocAbjDamEfvA_fA~~J{_CbcCisAtkFqgFdy@yc@lmCkq@rMyIpg@{\\zlA_fCxbAygH`bFycOdw@k{@zfGkRrrBwe@`vF{_DjpBir@h{B}UtdD{Ch~BoX`~Hy~D`dCqW`pBza@jpB~r@~eCbYjnCmP`~IylB~eDybAlqLs_Mt\\obAtvGahJ`rKgzUrtM_sYlnPmv^fnb@sk_Ah}MccZrcHskKrwUy~S|nHyzJ|`KmsTbeNugZnoPwl^jkAkzDbZuwD",
        "{iezFcqxtJcEkmFkqAuvE_qCwnDacEyuBeaAcxC}zEu{@mbCssA_s@ekC",
        "efxzF{wmrJxnAitLxhFkiH",
        "ufpzFcccpJcFgvJ{}DoqVox@_jf@",
        "ucuzFcaksJpM{Vzv@mRxw@{a@",
        "qlnzFqwdsJeYkh@ea@ug@siBkqAco@cd@",
        "etrzFw`ysJpAcnBpxIkbSdmA{|F",
        "mdqzFiomsJwn@mpJ",
        "ow|lFyfpgK~fAqsCd~D}{DzeJuaJnbZcch@jjJ{aXd}F{v[tmE{bLxpQ__YreLkmQ|_M_jYjiIklRbbPkc_@xmBydL",
        "_nulF{dvfKcZo`D}{DybNmPs{D",
        "{srhFa}zpKzMerE|nFytRjs@w{KxgAwnDhtFgbK`zAitKriAckEvhCmvDt`HuaHriFuxRdm@maEfA_}Mpr@_nFtuAmaFpuBgqEXg@HUfiDckAh`C{x@laJrdFjdJfyIbsHtxEbtFzVhiNwp@twF|V~cL|gC~}EfVhpDgtAbsAazBbtAebBxbBqW~_CzaBx~AzsBviBh}AlqBrLh~AwyC",
        "_xghFunyoKoZqkLufAe`Do~DimHex@iqD"
      ]
    },
    {
      "left": "IRN",
      "right": "TKM",
      "kind": "International boundary (verify)",
      "lines": [
        "mumfFsv|}IsyGbb[eeDh}CaiIkzB_gBqNilB`^kuCtdCyyDjgAqmDvkEgvA~gAkwE~oBy_E`oC{u@nYqm@pAog@lPkb@bdA{b@vdCwElcA",
        "washFk~}{IvEncAth@nkBpm@lu@lOdRrkD~|Bb~@fiA|hBdiEj|@dvAvp@`pB",
        "omahFaic{I{Nf~BuoA`wF}iCnk\\_Xz_Ba`BxtE}{CxsFaHb{@",
        "ayqhFs}fyIdg@`jHllDftNjMvcB",
        "aujhFqxjxIy]~rAgp@xmA_i@dvAuSpiB",
        "ycohF_t_xIpM~{PlcAjbFhsBpqE`_H`iKftAjf@`yC{hDpkBw\\|rB~TnaBr}@rx@daBffAnvO",
        "yvigFchttI}Bf_BgUdvAafAzhDyXhhBsAl}HoWvzAwnBbsFqbA|aKI`yD",
        "s`tgFer_sIblEtre@pLflKro@xvCtzGloMhs@d`CjrAd`CvF`fAzjAz{G`{@tfCzaBxw@zVzkAfu@`hJh_@xwBnn@rt@~pBlcA|n@fl@jSdbAlJxvA|_@rjA|sA|_@f`A`p@faG~bHf_Opi\\r`DhzD~fBjpAxaBfa@j{BxZbaEteBpbCmEba@_Urs@shAdh@m[vj@wFjuCvF|wAjR~{CftAp~AlR|k@`\\phBf}CjzCbhHxy@dmAjf@jzBvbCtxCfb@t|Ar@fiC",
        "gijgF}hbvIiJldBk~@jaE}Hl]oXp{F",
        "kwmgFcfpuIp_C~|Z",
        "wqlfFals~IugAl}H_JtgB",
        "meofF}df~IlL|hBpVn`B~IzaB",
        "o}hfFc`l_Ju@lUiAp]gg@`oA}t@dmA_h@|rAi@h}A",
        "_jmfFsz__J`Rt|AdDzoH",
        "w_cfFcax_Jy]t|Awe@xc@o}Azw@ka@zj@eItr@",
        "kpifFefo_JzQ`eB",
        "yttdFqvgcJkQfvAu|AtcDu\\xmA_y@`fNc_@piBmeAriB_fAh]quATaqBbOom@|TiqCzaBgo@bDwk@qLgj@Tii@xn@ah@fhBkQxcBkMpqEukAb{KwsJzr]em@lwE",
        "q_dfFova`JbEjdBjRhhBhEteB",
        "_bwdFwgdeJwOllCewA`mG}{EzxH_i@`eB",
        "{qbeFiljdJlFbyBvv@z_B~vA|iAngBnx@nfB|rAhh@pkBpk@xtP",
        "}a~cF}}ohJaIvdCu|Mz`Y}fDbkEu]bdAwTntDoTjrAkq@xvAcyAvuFowAbdN_eDtuJ",
        "qfaeFyq{eJfj@da@`|ApNnqAhrAvPz`A`C|~@",
        "}uydF}jseJkS`dC",
        "ijzdF{eoeJD`fAv[pk@hd@lf@bYfu@|JxkC",
        "ks~aFe}ejJmArr@eT~s@g_@jq@s`@tg@sTveBwk@`Qor@wQ_i@wFcPaHcTqUk]wFci@xc@ugBptBibGlfK}tA~gA{mLvyBwaCxMsdAsSq|@we@yv@{X{r@lPicAnd@uiCkRqqA`\\adCvwBc~Ah|Be]`oC",
        "{abdFu|zhJ|~Bv}I",
        "icncFijjlIgaAl{J",
        "qepcF{m~kIlPnlCjgNl``@vy@x}EHfiC",
        "up~bF{umjIcN`oC",
        "y__cFyeijIbDfgCt|@rrBxwAtrBle@~oBjD`{B",
        "kxxbFeiviIyuBfht@",
        "iwqaFarxjJws@|rAqfBhj@euBt\\k`Bpk@}xAtgB}Kj{A",
        "ar`bFocljJt}@heE",
        "cur~EirhoJw{AtmEytDp_Ck~JntD{iDxbC{fS`uSy`Jv_H_oKniFseEjxDmpAbjFihAz_O{jBhdFmtGdyKciFxb[qBpaA",
        "_|vaFe}_kJzWvy@d{A~gArd@|j@~Hlz@",
        "svkxEov}tJo_ExvCclCftA_fDdOmd@qWecAgtAqj@wQymBnC{a@oCgsCih@u|@f@{l@`g@ckCag@mdBzB_}ArUy~El[mmBjf@_hBpv@quAr_AybBbcBupAblB{u@r}BwR`xCi^|tA}hAkgA}sAg~B}`AekAmy@{Bs|B|TqjAaQw\\mf@wQwy@i^_t@obA{Vex@qAi|@_J{v@kR_j@_^wdA{`Ame@iK}^jIi{DbOqcKt|AayB`zAw{@tS_pCpAg`A~Iq`AdXyc@xXyd@ve@g_@vp@_T`{@ij@wOmPwH{W_S}qDbxAoqHcc@evNkeCs|Ald@ijAjIeaAcZon@ye@a{@q`@wdAqW{kA_HomAhIwx@fVg_Btr@qsE~q@wZz|F}j@tuH",
        "uwt~EwxwsJ`Hx_SrI|cVtRfth@rK|hZpMn`^"
      ]
    },
    {
      "left": "IRN",
      "right": "AFG",
      "kind": "International boundary (verify)",
      "lines": [
        "}wkrEap|rJoM_hAkfAe`AcwCeXo`DrSsrCwFykB_pBg~BudEqrDmxBkfBqb@}s@y~DamEwp@}{EcZgu@nCisBxZ}~@lEmmA_SstBowAwz@kRayBuSoiFazAkaGod@mxAel@mmDevCyw@|`Akr@tHqv@yOafAiKmYnPytFd}Ei}@h_@c[od@cZs}@a{@sAa{@j]cZza@w{@pCkdCeDadCyc@w{@yxAqAadCuSetCew@ewBwmBwp@u`Ib\\g_Cc\\cdAcc@koCcbC}~@ga@acEgu@cwBcdA_qCsqC{tBkrAy`Cwe@i}BnNy~F|`Acy@xl@",
        "k}krEs~yrJlDmpA",
        "ytxkEyauqJo^rhNmmDnwNe{H~hKegMtzCskEkq@uiJe`EstFqLaz\\|qDu|OhcAmrAnIuvGmd@keHunDasEadEw{D}yE_bCehHiwAo`BadCfj@yTyxLc_@_zRwUupMctB~eA_rNxnMmaDxaBogAv{@uw@pjAcy@bxCsj@pv@atCpt@}i@`g@{Wrt@}FnaAmbCuzAeaAuzCce@kuIec@szCwcAcyBmjGqzGwp@s^uh@wg@uf@}rAsJevA",
        "stfuDktjrJ{mJahJ{aNyyMs@}@if^ie]{tOccOgmJk`J{zTicTmmOk{NI?yhVujUsuX_uWwwOccO{`BqiBg`@nNyEjGuoBaH}j@oNaQmd@_jLzV_hAbZcjEovBobCqk@uyBTk{Bh]ckEfkAseEdlB}_AnNcvDhIokC|s@ulFhfDq~Bv{@k{BpAkkGgj@srBfj@orFn~EkrAvyBqu@x_Dui@fvIwxAhpUkxCjhe@ycCfc`@g@`IcbCbv_@cnAbvRsiA~nEqhQrhA_mHr|AgqCzM{lMmnAmaQpuAumHpLgaKom@sfC|I{aApWk|@~]g_A|KshCst@eb@xc@yXhs@me@hT}~Amo@}qDmbDigBmd@kpN_sAa|N{K{{SnsEuaZdrGirUz|FaqS|dFooRtxEg|QzrEk_O|qDqnK`zA_mN`HkvAce@cvIimHo_KwrIwxIgoHumGwlF_eCesD}iBwkEefAg`A{{B{a@ojBrJegB|TyxAaQu|@omBsOogHa[k{AadAeo@sHuEsxApv@gnAfhBin@|_Bgk@|pE{MppF",
        "oiykEcmcrJtShjM"
      ]
    },
    {
      "left": "AFG",
      "right": "PAK",
      "kind": "International boundary (verify)",
      "lines": [
        "smq`Fq}yeMkVccBseEsi@sn@qWql@cFei@rJmd@t^",
        "klz`FckmeMr^wyB~MgVlQuSteCapB~uAuyB",
        "sae`Fin}cM}j@{tCkgEopHyhG}hO{jBcaDox@ubGgFudC",
        "sjf`FospcM~g@yyK",
        "kpu_Fs_{bM{`B{oJ_~@a{@muEk]{uAug@qv@yxAoSaeB",
        "_ke`Foym`MbNwpLJiI?i@BcBhLq|Jbx@m}Jh_Aw`ErcGs~Nxd@_yDxw@mxD^ysD",
        "wza`Fkht_MgoBcpX",
        "okc`Fw{g_MpUy`EdYyiE",
        "i~a`Fk~z~Lel@k|K",
        "apb`Fsrq~LvPwjH",
        "{n_`F{`e~L_HwxAewA_wH",
        "mpa`F_hv}LxOudEjf@yuDjHk{A",
        "{rz_Fu}n|Lk[shAkrA{tC_]mdBynAkd\\",
        "ku|_Fsff|Lh~@e`EdB{tA",
        "ovw_F_ve{LsUigP_h@cuD{_AevCk]_zC",
        "oty_FaluzL~|@}hO",
        "{ki_FabbyLk[cbCoiGmfK_|B}mHelAmqKqVa}K",
        "uzi_F{cyxLxMe}G",
        "msb}Ewz|tLqCobBk\\eaBcdAshAqtAbQqhD|hBudEjGyaAq_CkT_tKu]wcByv@woAs_AsjAyx@{tAshCogH}rAwcByy@{`Caq@m_GolAwcBow@kG_t@xXur@~I}s@iu@i_@shAih@s|Cah@_jJ_r@elBueB|j@owBt|AwnA}Vyx@kdBi}AqqGwdBggPqLosGccAa`G",
        "a_p}EeaetLhi@}|BtbEyfJp~CawD`]wzA",
        "og{qEanspL{l@iqBi|BebAmwCuSo`CrUqjCxm@s~AuG}gAg`AegHqvLsgBipFmdAssA}bKmgIysE}}Ae_EssBykCq|EgzF}nVu]_{A}j@a{@gaAqk@_pCgu@{`Awp@S??SK?_g@{bAwq@}j@wy@iI_~@fa@{pGaH_eDwaDmvFeoLqfE}{CmyBgu@}rAnYs}Bn}DqeIfyI{|CjoB}gD}IckE{~D_yE{oHwzAk|@wxBuH}sA~s@qkArqAqu@tl@_i@`b@{iCbe@quBcZ_pBsi@{vB{Bu{Aby@s}@`eB}hChwI_rAh|BgiBvy@i|BymAquB_pBupBec@wmBvZylBxmAqa@jh@mz@j{Agj@dc@meAvZow@R}t@mEk}@bFi{Atg@gqHroEs}AnxAkcDpzGs}AnaAwkExYywAt{Ai~@ptDu^hoDyw@|fDekCp~Cqu@zvAycBv_F_r@ncAwVjEe|A|Wq_Bcz@kdDohEox@k^wcCs^yl@q`@q`CetFshA{|D{`@yy@yy@gj@adC_^_h@i_@moBsjKaoA}}BcoLa|M{w@sgB{a@qtBoXyvCst@mxBaqAnb@g_Bf`Ag~A_^i|B}{CqaAkq@wcBks@y_E}iA}t@u{@_I}sB",
        "ch|qEopkpLr_@q|F",
        "wxonEil~oLkWcxAgw@khA}sAifA}c@q_Cot@eqHilAobBgtBa\\obBhTkeBxEu{BmdA_eDmmDyrAkf@{tCwGc}BlQoyEj{@epBi@_sLcvDwxCbZamEl{LayClaE}qD~oDi`Dd`CatB`{@_kCza@mhCkGymB_hAqa@yzAyDmN]acC",
        "ypxnEyy`jLbK}qEjiKaei@f[saJpyAmuEnZiqB|PywNn{AybOrDq}D",
        "kcylEytsjLswBznIaJ|~AePzsCcp@r}AmwBh_A}xBpk@o|Azu@iuDpsCibB|u@glFhrA{pAzv@mwCbvD{{Abe@{yAaqAy}AanBq{AsJy|AhTibBqLkvA_gB}n@ifDyi@ujI",
        "qmqnEmpuoLpk@ggDfGsrB",
        "wpfnEwlaoLceAczLgwDanB}nAcZoMk}@",
        "exfnEc`gnLlFskY",
        "}scnEkylmLgcBweY",
        "ikqiEom{jLsx@mxBolVkc`@glEqk@gaEbbB{uHlhI{l@h_@mcBdm@g`@fk@un@lmDwZ`p@i~ApuAeoB|u@iwBpUauBiIoiK{~BovC{B_h@dWs[bo@mh@jfBag@xw@c_@bZa`Bnd@gvFrs@kbAj}@",
        "sjzlE}~{jLff@biG",
        "y~riEuprjLhi@etCdHsfC",
        "ydeiEazejL}Z{jAaw@yn@clIgpE{WuhA",
        "wqeiEyd`jL|KgtD",
        "sf}hE}jgiLeO{fGioF_sMsI_}@",
        "kvbiE_izhLvnD}`L",
        "gj{hEq~ehLqV_qBiqDqdHga@{qF",
        "ow|hEiu`hLzMmz@nTst@zGew@",
        "ew{hEckzgLi_@eiE",
        "az{hEqjvgLzAq_C",
        "g~b`E}b_dLa{@ifDshCm`FuyC_dEaoB_qAkr@s~A{tAcxAcd[akT_|C}hDo~DkjHmUmMkb@uUapAlOmzM`dEunQjyB_fCeDegGwn@kgG}AgjGsj@_gCaFmbC|Um|Ix`D{kGz`AqaGk]wkF}sBqhE{|DscA_}BukA_bGulAmmBwaLmhIqyBsjAukAkR{mEt}@slBrJkn@bOgZhj@{Qrt@{]pu@_h@zk@cp@h_@gyB~IcsA{bAeeCyrEksDcxCofBy`Dw[oc@qtD_}@qdT|sBsiBe{@kiB_{@_pDkdDoqBioEg[qzF",
        "}~faEqi__Lbo@e_Dp_A{hCxmBg~CrqAs_A|`AolAlP}gC",
        "}~``E{qo}KsJe|Fk^ybAgtAmeAigAsgB_{CegI}j@ob@ccCuSew@u]maDkmEin@g]g{@oe@cjGwcCiqAcoAwFq_C",
        "qlfaEwggaLvdA}pE~oD}kJ|u@a_J`e@cmApkAkh@p{FwQvzAcn@x_Dy_D|bJc_HbcB_eD",
        "myz`E}jz`LwQrgC_h@nkBu|@rTmpAmxBuyBsmGsj@srC}@{jC",
        "mc{`Eia~_LvOcvFfgEsnSr_@qfF",
        "myz`E}iv_L_IkvF",
        "yis`EsoaaLk\\gjBcdAifCemAapAew@nx@eMxwB",
        "{`{`E}`faLlF~tJ",
        "ykc`Ee`xcLpLwaF",
        "ak{_E_g}bLqWawFwlDskKmy@osE",
        "wya`E}si}KxY}|D",
        "i{j_Ec|~{KyOy_EeaA}|DcpA{eCszBqlEyqJs_K_hAwmD{AgtA",
        "ohm_Ecfr{KdlA_uK",
        "q{r~Dub|{Ka]jzB{aAt{B_|AlyAosFxc@ekBjpAs}AvzAk|Apl@mmBmoA{B_dE",
        "awe~D_io|Kyd@q~A{sBs_A}dGl\\_~@l`F",
        "uvt~Dijl|Kbz@rfO",
        "c_f~Dklg|K`Gs{F",
        "ogn}Dwp`zKmQ_rBq}CcpL}i@mrJstAqeFst@_mIyc@srBszEqmKq_AkpA}t@quAoXkdB",
        "ekc~Daj}wK~h@a{ApuAgk@djC}K`r@zNle@pa@vd@dX`q@wG|_@on@tTolAfUknC|@s}B",
        "_qhsDil}kK}eFsi[a{A_jJo{AajJk{AsjJg{AwhJk{AajJk{AkiJu{A_jJk{AuiJo{AujJg{AuiJu{AajJe{A_jJq{AwhJ_{AujJu{A_jJk{AajJufCgsOivHkpN{}D_eD{_Ee`CuQod@oNis@m[gVmz@`r@e`Cl_EkbFb`GadC|zE_sAbd@cbBeNwkFkzAogUkrKyvBoZeyJfMqxXqtB{~BdN}~Bdb@aoAxn@}gDbvCawFfiBgoGaRgx}@geRquA{w@kp@}hBgsC{kY}t@{kC_gOcjQmnCovBk_U{rEmyAyvCc[_nFgiBe`DknCspCgjCuyDgqDodLox@ohFcFqnJ",
        "ywt}DwswxKh_@u{BxkB_cF`f@q_CjIifB",
        "i_s}DmglxKur@}nFyCk{B",
        "yfo}Ds`tyKh^coK",
        "gyn}Di|iyKqLicI",
        "stfuDktjrJbnAudE~{Bi}L~pC_gOlqCihOdqC_gOxpC}fObqCugOtpC_gOrqCsgO~pC_gOrpC_gOhqCsgOnqCsgOrpCsgOhqCkfOhqC}gOtpCugOlqCsfOjeD_qQpiB_cS",
        "ymnsDshphK`@cgCrGq_c@xDssYpcDkn_@vG_vH",
        "iqjrDaycfKq{@qiDocKkbFo`DwmC_aBszE}vLgvs@",
        "gf`sDyv~bKreFuyi@x`Em}b@nkGchU",
        "{unrDmsi|Ja_AulWwMyrDeXoqHeXeqHeXoqHoXoqH{WeqHkXyqH_XeqHeX{qHqXeqHeXcqH{W{qHeXeqHoXeqHeXyqHeXoqHeXcrHemAcy\\"
      ]
    },
    {
      "left": "IRN",
      "right": "PAK",
      "kind": "International boundary (verify)",
      "lines": [
        "mnhkDwx||JqeAf}BkxJtiK_fC`zAukBvg@i~@fj@uc@f`Au\\~fBuq@jdB}jA~~@yrApt@ajAtgAynAllDgrCpxXclE~fOae@pfE_^j~Kks@f|DwvCbiHg{A~tJkv@rrBahEtdEwbIpkKegHtbGyaOtcSwbEntD_wI|qDyoDdsDo|Ah_@}gBzMixBdc@wsOdgGq_Azu@so@xdAi_@toAw_@no@oc@dMie@mPkg@gl@wt@mx@{w@iT}t@`Qsi@t{@_g@fjBsyAxn@miB|_@ywA|~@i^xbAmEnx@cQzw@u`AnaAgfAh_@_{CxOaeAjRqjB`oAu~D~eEm~Blz@kyB?_zEiiAayBsJg}Cnx@ycAxlBkl@vbCkvAbyBivObaOs}N~gNiiN|uMeiLfwKwrItiI_gOnwN",
        "gldeD_wh~J{l@~|AmuEhmGoDebBuh@u|@wdAwd@mxAa\\mdBsJybA~]mcCtyB{pSmgI_cGce@qdIr`@k_Q`{@wxHh^_xN~r@qrJbe@wwQ`bDeoLtrB{eUccBeaSwzAoyEj]iiAziC",
        "qenkDsw|}JbvDz}^",
        "ejodDubnaK{cLzsEgtBlxA{_ApaAi_@xw@aq@jyCaf@`fAwcCx`D{WxlAs@h~@",
        "{}jeDshp`Kz_BvtIhAjoA",
        "uzgeDobc`KwHjgB",
        "mdheDcz_`KlF~dDbyAnfIrUbaDf_A~jJvGzhD",
        "gcbeDstz~Jme@hdEugAtqC{Mjq@",
        "gafeDgjn~JbF|j@pk@ztAh@lp@",
        "_ppdDcwjaKxd@qjB",
        "wgoaDkhk`KazBekCuxF{`Aqj[wp@oaBql@co@_fBoc@{|FgkAu|AiqB_SwcBhs@wdBdmA}sBdw@u`Ur^shAaHu}@mY}sAqaA_~@gVmcBmcAmn@wyB_@sgC",
        "_}raDwp_~JtHuhLrIuhNrKetPp`@orFbEwuF",
        "uziaD_mo}Jkf@c`EaQ}t@sUom@w[_i@}iBq_Ayw@yn@wPybA",
        "{xqaDwyb`KzCwz@hU}t@t[el@rUyo@rA}}@",
        "ktpaDqc}_Koc@euD",
        "eikaDwni}JhKebAt]wdAnBit@",
        "{|}`Duyw{JeNs_Aw\\ec@kpA_r@ga@cp@oNkz@mbByt_@ag@}~Boc@_s@om@kp@w\\st@",
        "kb~`D}us{JnDwbC",
        "ory_Dk|{zJs_AsfCywAnD}qB`|@mnCda@olAqk@clDkcEykBq_Aye@xDeb@zV_h@vQ}u@sJcn@mf@u]gu@sj@ayBcYar@_t@uoAsSur@oDyy@",
        "od~_D_qdzJb[cjFnwAwtGj\\oiF",
        "}~m|CeavwJqUokBkgB}}AcmB}a@isL{`A_gOymA{cKmz@goIup@c{Jox@w`E_t@igDazAgiBcvCo_E{pV_eCm_Fur@isBqb@e_Caf@uaGg_A{w@wxCsUyvC}hB",
        "oan|CkhrwJpAywB",
        "ahyxCm}{vJGI_hOoeEwmOod@amR{j@evOod@}kJyXyxAiTa{@{c@kqAuzAwo@mf@wvEaQkvFbdA_eF~]kcDwbCw[mcC"
      ]
    },
    {
      "left": "RUS",
      "right": "KAZ",
      "kind": "International boundary (verify)",
      "lines": [
        "}`jqIwmxcLhdFk`b@vyBs|Cn_EsgBhfC_fC",
        "y~ipIg}xcLur@_{CcoAi_A{iByMkmFld@ox@tzCu]h|Bi~@lyActEleAom@xX}j@?cp@gu@uf@cdBeDcbB",
        "el`qI_|dfLd~Ea{Zf_Bske@feGqaXz_BaoD~tKuzN`fA}qDt]_qN~r@spFrmI}_ZhH_gB",
        "aytpIk|geLyo@syFkjHelO}UyvC",
        "cr{pIuaibLbo@}gCxEihA~q@igPhi@iqCldAy`CtxEkbFlyAwyBnd@wmC",
        "{~zoIcetaLsK_hAu|@{`Ai}@{MowBr`@is@eDshAmdBuqBuaHg_Bol@kcCvPqkBkHwcB_h@qjB_hA",
        "}irpIwvsnLbe@a_JjoAmjGxmAxaBlcBp`BhiBri@p~AcdAxgIqlLrsMsdRnkDqiBnkAqCdlApChJ_A|U?hJ~@xkDzVrrAnXboAnc@ftB`g@~dDelB|iA`q@~gAveAnjBxn@jpBtHbyA{l@jzCidFduAgl@ziDjR~nEgiAh|Cm_GbcB}xHld@awF",
        "wwipI_cpmLgAyjCiUuoCyl@giC}iAguBigB{zFqW{yI",
        "mimpImv`mLhKgt@jdBivL",
        "}}noIorpkLkz@mmBsfEckEa|@{_CokB_ePob@k|@co@yP_t@{Aap@qM{`BqiA{hFc`GoXeuB",
        "ww{oIw_oaLzWkdD",
        "u{xoImn}`L{vAi`LeC_oC",
        "gh{oI}yi`LfAmwChiAa{M",
        "urxoIc~{_LqBu{B_qAc~H",
        "ya{oI{ns_L`SuzAza@coAdWmbB",
        "w`jnIocb~KaqAip]ycAylB{}Cql@yc@qiCey@qu@_qAeYcmB{u@em@quBwFamDga@mlCi}BqW{rDhsNqsCviF{rDueBaqAziCkSxn@y_CqmKcQkeC",
        "glonI_gi}K`Ge`ElbDizQ",
        "ssxmIaqv{K{vAmxM_zDmrJytFwvFs|AuzBshAawDug@q|E",
        "myymIwvyyKxbAi_L",
        "emlmIi|~xKcc@auFoaBwbD{tCg_CkeBetCkh@ejD",
        "igymIumszKtRkbb@",
        "suwmIawfzKup@suK",
        "aqlmIwdpxKzBqvM",
        "kg}lImdvuK}a@mfKup@giCgsCulFql@kdCga@eee@mYy_EmyBqnJc[_dE",
        "_}_mIclmqL~Sg~Bj|@_pBreEqsEd`CgiAxkCi@puAnmAvo@piCfv@j~HzjBvcEblDtf@j|L}j@lf@pMza@nCvZiI~rAi|BhhA{XdsE~^be@cP|Som@hUokBb[m[`p@SfjBbNptA]niGr_@hh@`~I",
        "a{_mIy|dqL}@inG",
        "mz}lI_f}tK`Rm}W",
        "ejilIafuqKa~CaoValMsbcAcc@gkK",
        "}a{lI_olqKnv@evBnyK}u@vdB}gB",
        "moflIaqapK{Uy`EkfBucDe_EanDmxC}qDupAyiE}gBsiM",
        "immlIspsnKfl@o~QroD}_Z",
        "_z}kI}xinK{VkeCwcC{k@abFveA_rAu]s_@okD",
        "kv_lIws~mKj{@edJ",
        "qmnjIcgxlKs@g`AyjEqrDavStdEiqCyaCi~AlPa[tGgtCSihAwcB}pEozWcE}rD",
        "islkIccetMdDirCxx@azAphChj@j|@vnBbnAvxNpl@joBzkAfiCpuA~gApjA_qAdw@wuH~|@}qB~pCew@|}Cda@lwBhhB|hBx`ChqBbnBxuDpjAp`Alo@|t@leAfuAh{Cly@~|@~dF~aI",
        "yfgkIqsnsM{MszCsfCgvL_Uu{B",
        "ozgkIavcsMtRo|I",
        "acwjIomqrMkGq~AeaAwnBekBeZk{BqAgsBce@owAcbCqVgqD",
        "ap`kIozdkKxcBgbL`gKaoNdw@yxAlf@evAjRk{A",
        "oasjI_t_jKcxBmqK{~DyfKqtBgkK",
        "yd}jIw~ciK|j@apAjcEk}JvcAudEfMc_F",
        "}dyjIe{vhK}T_|C}hBqeG",
        "uu{jI{|uvL`|@{eTjfAamErrC}fF~xDc`EjzDuzAbbAmeAxx@o|G|hBmnAxnAxXpzGbvEx`CmnPrhC_pQtR_HxXxMb\\~_@ztAr}@lPdmA",
        "ynjiIktfwLqMacDmn@ykCccBcoAojDjR{kBpkBkg@blDaQl_Eij@vcDyx@~qBeb@jGapA}@i~@sJugAm[wdAyc@ieDe`CcdAcZox@tr@ylArqCcoAllEcy@~eAq`BzMgk@srB",
        "{ozjIafnhKxEsiAj\\wbCvEweA",
        "_eujImetgK_j@{gRuRgjA}j@w{@gk@ym@_S}_@",
        "}pwjIgnkrMzLg~D",
        "suojIyioqMah@inGumDglKi_@igCgBq~A",
        "s{vjIwllgKtHwyA|k@}|C",
        "ozojIeupfKuRwxCewAgoHeX{}Dyb@g~B}Uce@i`@ihA",
        "mvujI_ohpMx_Eyye@",
        "yidiIyfmlMcZqgFexAy|HqiByzJgfE}bUkuH}na@_xF{uZkoCfiAigBpLg_B{l@}tBghBsfBoaCs_@mxB",
        "ivnjIimdqL_@tpBoWbxB{kApfF{Xf~BmEl`F",
        "_}rjIgzjpLjq@~pCh|Bnx@~xEkf@zNi`KlZarAlcBg_@fsClDjoC`]xxAnn@|gA_oFnx@i}At{Ae`BjcF{~DhhAylBpAmbC",
        "uhqjIubhfKdm@oqG",
        "w~ljIkk|eKoEufAyW_t@emAaeB{Wwy@qByxA",
        "kipjIc{seK|jAetBrUiiA`GwoA",
        "oxwiIe~~dKirA}`Ayo@eiEgUuaFk|@cbE_eDylBi|CheEmcB`{Agl@uGyXcp@yn@mo@oYit@",
        "c|ojIckrlKpm@_{D",
        "epmjIe{ilKyD{jByN}j@qm@}iAwFel@",
        "gxbjIabzcKtI}{Enw@kwDlkFybOvZokDjSouA",
        "ysqiIsmpaK_@idFmo@}pDq~CwiIap@amDoNedL{qGe~^",
        "yfbjImb_uL~gAeee@lZe_Ddd@qtBnaAkdBt_LkkJteBykCnc@mvD",
        "sxfiIeuetLaH_|Aq`AuoE_qAunDcxAst@osGt^i|BaSsqB_}@krAccBs_@wbC",
        "mcyiIuxhrL|ScuDfv@}eElZkcE",
        "wueiIkxmqL_{Ao~EyxBclDskI{zHgjAyvC",
        "_`viI_y`sLpVc{@j|@cy@`qAyc@poH}u@",
        "y{uiIczzrLeC{}D",
        "i`uiIshn`KjGcsJn`B}|TrA}Q",
        "grbiIcf``Kkq@ckDugBg~AayAdLu{Ady@kqBld@wcB{tAcd@amE",
        "{`liIwp|rMaGxzJgrDxzWkIdnK",
        "qfriI}ikqMpWzuBxm@|hBtg@dMxsSe}RhiAce@lkFymAv`Eq}Dd}F{sOfmJa_WrgPyec@|gP{ec@rgPyec@|gP{ec@dxKyxY`{NatVzsEi|HlwIk`OzgSwkTl~LydLdlUsbTjlUubTblUicT~kUicTdo^isZno^}sZjo^stZho^isZN?",
        "ufliImlgzLdw@__Yfu@}_X",
        "kkzhIw~pyLol@jf@wnBob@wxBg`A_iAar@}qDo|Gkf@w~H",
        "obkiIsezsLrSqaAfkA{~BbYs_AzMokB",
        "mhgiI_kgsL}JqhCg_B}xH{LcvC",
        "_tiiIwne|LlYk{AtrAigAbmBi_@pqFaS|tAgdHrrAigAtoD{w@tqA}qBblBu~W`pCac`@",
        "gxhiIkmz{LwZk`J",
        "sxfiIyefyL_JlyA",
        "scgiIkkcyLh@hfB~SpWnmAzl@~RdX",
        "qzeiI{`ykMvo@}dS",
        "oalgIerwhMaHghDgdJijXwgIskVgmL_q]igM~hM}}DikLq`AszE}Iq|E",
        "yjciImd}xLSvy@uh@h|D",
        "cudiIkluxL~Sh|@`eAvH`qAmRzw@qUhfBkqBdlAipClzAssA|qCxbAh@?b_FjyCh}Br_A`dBi@|hAcwBv\\abE",
        "uldiIk~j~JdMowBjqAeqGvE{hD",
        "czxgI{}r|J_]ybB}j@eWkbE|s@en@j]ap@?cnAiiAsfDakGmoBfjBk\\ve@muExmAifD}|DylB_lH_h@a`G_Tg~O{uA_vI",
        "o_diIizl_Kfl@yjR",
        "keaiI}r|~JcyAkfO",
        "ueaiIurp`MbOwcBhUwFx`C_SvRu}@",
        "ueghIg{n_McZyvCmf@qjAmnA_UgrCjIU?iqBks@qu@gmJi~AylBqkA~TobAdw@ss@hTs^kpAql@ciI",
        "we~hIo_kuJzk@_sNht@{_B`bFqrDhr@_gB|_AynMhdEiTnx@mo@pXwnB",
        "kv_hIqvntJqBwnB_qBifBgjBaSejBr`@eiEf~Bec@|Ti{Blo@qN__Jwo@i{ColBsrBeuAupBuSmbD",
        "ce}hIanaaMxt]~nG~eDbxA~qAlcChTbjD",
        "ui{hI{qv`Mmz@e{I",
        "uehhIyaqzLqk@kdDiyEp`@{tDbwBmaCnxBafAlwCeCjwE",
        "cp|hIecbzLvcAlcP",
        "mawhIm~|{JhKy`Ch~@cnAziCfL?f@lnBnsGhqA`pAjzB_ThhBupBz_BgnHzvAobCnx@k{@~q@_gAh_@onAxCgtA",
        "ardhIwamyJ{wJ|@od@xDevBg@yx@eboA",
        "}_rhIsrcxJjSi}A~]owAxwBcn@joAsJxx@we@ts@s}Bjg@g{ElY}zT",
        "wgnhIc_zwJuIwoA_gBshCoDcxA",
        "qlphIywtwJnl@uqAhVssA",
        "{sghIguzvJeO}sBcy@{`AkzAs`@_rB}T?esQ",
        "slmhIggzyLxCs~AbaD}yR",
        "w__hIie`yLsJ}gEkq@kcCkyDmaGckDm`Dkg@woA",
        "sxlhIwo}~LvGwbEfKwy@hi@emAtfB_oC|JymA",
        "azehI}dw~L{NgtAmo@q`@_gAiK_~@wQgV}s@",
        "oiihIe{{sJ`e@qpHl\\ih@|j@gV~|@qm@|iAuqAvy@_gB",
        "mvjfIipjsJsrBszEylAqLemAxDekAeDiiAom@eb@eaB}TqrFceA{u@}qCshAapByvCo`BsgDwdBg~BokCaQuqA~yCow@`xEg`AxjDmnBjzBi_@~~@uRjzByDbyK_S`fC}_Ahh@meAfKigAyMybAwe@a{AapBen@adCuf@aaHyDmjE",
        "_`vgIkul`MykBnb\\",
        "ylygI{qo_MlFlvDhr@nuC~}AnaCphCjzBjzBibHnaCdtPxlAldBjnPvxCb\\jjGve@zuBnlAh}AxwBby@tqAm[frC{rEdsEjoDpdIyj^n{JdrGlvDqmK",
        "sdrgIyqqgMlGeaOp`@q|EbxCs_N",
        "kosfI{olfMkh@q_AofHomBguAs}@_h@_t@gL_hA}Ko{Hyd@a{@cxA_t@otDmcA{vAcp@_s@i|@si@ytE",
        "ejtfIeuleMxYuy^",
        "{yheIg~_eM{~Ay`Cg_QmiHwn@`Hus@xbA{`AjoB_i@dc@ozHqv@a{B{u@igAu|A",
        "y{nfIsmvrJjdCuaS",
        "coxeIq{_uJ}}BdlZgk@duB_g@hj@wdBvdA_i@|j@yx@tuHi_@veZyvBfhDyvCcxC",
        "_nkfImwgbMbZ}xFr_@}`Lr`@myAbbB_^bwBtHvdBmG|j@yvAxEo_E",
        "gxbfIstjaMsS{_B}qEaqL}j@kcEgAojE",
        "g_ffI{tq`MhJi~MbPugBpiAwvE",
        "mb|eIofl`MyM{u@sj@oN{v@yDq`Bij@aq@i@_g@iI{Mgj@",
        "sjcfIw_qcMbEc{KdNwy@lnA}iAdwAmf@xcAqv@fU_{BvnCdl@r|Aug@nlCkbFf@S",
        "{||eIycicMyZcdAmwCsrBoXebA",
        "otceI{qyuJebAi{CalEw~HkqAccDuqAy|Fc{KpgDyvAjgAkSztA",
        "crafIaikvJ|Av_Ubd@ntDnhFhyGlP|{E",
        "}q|eIspg`MnN{tC",
        "spbeImaa_MyNaqAacBkeD_qGufM?SS?cyAwmCap@gu@{aAur@wmByw@k}@iTea@wg@oYwnB}Acn@",
        "soqeI{`|tJrT_eD|`AmxB|gCadCxaC_|CptAunDfAy~D",
        "sfcdIoxytJci@hbH}lCfzFgtCt{B}{Czw@e{C_UgrCqtBavF_xG}sAov@gjAyZo_EqW}_AqiBsUo`D",
        "ovneIu|odMbcDmhInWcwD",
        "ovneIa|odM?S",
        "eiwcImomvJkg@taFccHtdRor@~yE",
        "eicdIalluJpAprQ",
        "kzabIildyJanBowMmhBmkFcnCieCc@?srHyxB}lCyM{tC`q@qyC~yCufAnjEucDbbi@uqBbzLusEnpJg|Eb~FwZlcC",
        "{a~cIitfwJffExuQlP`mE",
        "{vrbIur`vJtw@ayDtzBscFndFwsJ~m@ubE",
        "sckbIkgguJaNc`Emo@qiDkyCwhHkX{tC",
        "ecqbIkfntJdi@kwEztAgrExm@}qDtOmaE",
        "qke`IirvqJiDfjBsd@boA_s@za@kh@fK{a@vZa`@lpAqa@j|@st@lYm`ArAgeAmGq_GmlCccBohGsj@{oHwtAicGolAgvAkoDetCepAkoBw|Qq{`@ylHteO{CdD}@eD}@g`Nwe@aaFcyAsqE?S]i@ESmiBumEsTwvE",
        "_ijbI{dixJpq@idFzfEy{KdSidF",
        "euhbIiguwJyr@q|R",
        "clibI{}lwJ|UmhG",
        "_ndbIyi_wJshAe`EkbAmxBcPmxB",
        "kdg}Hkn~pJwGypIw|Cq{H{|FsyFa`AiqBc}C{sQ{u@u{B_zEc|Ho|@_rBm_BwiG_|BkcEwgI|aKyxA~fBsnBda@{`GxZkoBri@mz@~q@i_@dmAgxBvaQwu@veBefB~]ogHyZwyBxD_aBt^ah@|_@qEr}@",
        "_af`I_t`rJlTt`I",
        "yzh}HwthpJfGm|Idm@e{I",
        "i{n{HwwwmJkW~cEimAd`CyuKf{G}bBpv@qfBuH{rCobBO?CeeD[cx`@k|Quh[yxFigN}hCowN",
        "exi|HoamaNvkWgzSnlWsyS`~IsjH`mL_nJ`lWgzSrmVymPlmVamP|lVmnPhmVamPzcKm`H|~LilIdgI}oDxaBmeAzhCgrCvcCcbEpvAqqEnCy`E",
        "exi|He`maN?S?U",
        "cneyHcprsJaGf`AoNfu@yPbe@uRbZiTfV_Yl[wZ|h@k|A`mEyx@|iA{xBxxAemAdl@{v@vQyjExDsnAqW}@`eBeg@hhnAsJby@{l@zc@y}@~Gyw@jR{\\paA{fAdgTqv@x`CiaCyDsoA{_BswAscHow@{uB}o@{VymBlEce@ob@cx@u{Byj@u{@kq@oYqcCblD_jDvta@chHv_Set@zrE",
        "opu{H}u`nJ`|@jgAf`Bfu@zu@p~C",
        "{e_{Hujg~HrbAghDnpE{jBnxF{lAr{DupAlrN}`LhvKmmDl~@_g@tkAafAxtAq`BzeAyvB`q@eaCtHap@",
        "i`uzHsex}H_J_nDsdAwdCg|DcnAuv@e`B",
        "gg|zHylztHxi@qoIzj@}qB~~@srBxrAobB`eBqaAbrBueBnm@kyCx~@avn@",
        "}kvyHgtltHmJsqCgeActGmsBwcDgrD{VefOpeHioE~RmiBwmC",
        "wquzHegm}HlPm}I",
        "ojgzHicr|HoE{~D}_@o`DogAcwBieEojCuvAwzAix@cbD",
        "gymzHqruwHlj@moBhgDmwCpu@gkAhc@i|BdDcrGnh@mxBtzBu}@bmCdDp_Bvp@h~@xwAjg@tzBveAl`Rvo@~^p{AmeAfdBccB`jAox@v@?~aCabEl[guM",
        "gujzHcbiwH}[{~Byn@ojCgVadC",
        "kulzHwaw{HdHanDtl@mlDfaAcbDja@caDjNy~D",
        "ea`yHakfzH}Pc~G}wBw}HgxBmlFcfFeCenE|}Aq|D`R{vFqyIgrDy~DkfAiqBuh@okD",
        "s_dzHsfvsHpBkpB|rBmuFjBsaH|Zus@xgBxvBzpB`eB`u@ekAbKe_D",
        "{r{vHmvjmHwGuvm@em@ihB}_GgdHsmNcc[kqA}dGknC{{a@oiF_`V_y@shBu|@uh@}mAjHcmB|j@yvBvPkx@ex@qe@s}Ag{@wxAeXrSuc@~s@_g@j]gb@cp@uLekAsJmsJgW_qBsx@}sAcmBmp@aNesCqU{`Bs_Aqv@ilC{X{iJnx@u{A_SshAelBoSyuBso@quAyzC_KchCoX",
        "glpyH_azyH|k@g_Dnw@{`AfyAoNdpCaHdyDknC",
        "idcyHw`rxHer@yaO{kB_kIeaB}iBeaBcnAk`Ai}AcAaxC",
        "_mlyHc}ncIr@q~AhJyy@vZa\\`b@}Tr_@mf@hNox@",
        "y`gyHogmcI}mBrt@mp@a\\yJemA",
        "wdkyHopcaI~S_}@tvAadCfVu{@",
        "qy`yHmym`IgWkeA}y@emA_s@st@g`@st@eR{iAsJquCuT{j@sm@w\\wl@{l@{Pi}A",
        "}djyHserdI|y@o_C",
        "okhyHarjdIiHu|Aco@{tC",
        "gviyHm|{cIvi@stM",
        "iqhyHmkxcIsIag@{Qea@mFwe@",
        "ykhyHivvdIv{@kkF|x@iiAlsC{~Bxx@}tAzcDq|RtqB{eGtu@coAvdByn@fq@rt@~bAhyEbwAqtBdfBTzjBl[nbBga@hfC{rEdlAazA`pBui@dlBaxCl{Ee|b@",
        "_jhyHcfvdIy@eO",
        "atgyHykvaI`]q}BjpBztAjLq_Cf{@m`DnNi}A",
        "y`gyHgpkaIgRqzI",
        "yqgyH{xubI~OsmV",
        "ok`yHytcbIqQ}_Bmo@}rA{w@ymAym@kpAsz@_nF",
        "sdcyHibitJyKxkC_w@`wFwKf~B",
        "eveyHe~xsJ`G`mE",
        "ok`yHwrduJmL~rAujAluEkTbvC",
        "_zcyHeqvtJjTzmL",
        "sdcyHcq{_I`V}hP~r@k]",
        "ikayHmkw_Iix@udC",
        "ebdtHsarqJ}~@}nRutJqau@utJoau@u|BqfEo}DymC}dG_|AsqPs|AykDiu@{q_@miHabHcbCwlDinEa_BgpGex@ygI}\\vkBozAxjIsmBr{DwkDxvCobNzzF{_Cf~Ba\\nYgg@baF}lBnqGk|@niF",
        "yuayHcsnuJpFxvAd^psCpB~rA",
        "q|bxHejmkNf_GqcYxTcaD",
        "clowHesujNkg@clFg}CsqAsaBkIa|A{l@yrAmcAqeAymAccAayBsJupB",
        "kq_xHojtlNbGkpCrrA}s@nxE}KtwBwp@z_A}hAfzAuxFrtAa_HdWcmCpH}|C",
        "ofzwH{pllNkk@}iAceAwz@kw@}qB",
        "g{pwH}~djNbn@gsO",
        "cdwuHoqfiN__@uwFwyAwiGmwCcaFwvEg~B}}AgVcoBsJaoBfBg~AhT}yAvy@gsBnkDsnArsAklAhTwrBgBikEec@svBst@qpAolAwl@mmBsIouC",
        "uenwHkjanNfHi{Bpp@owBtkAih@hhBvOdeC|u@voSr_Lh|JjdDnwAxN|t@ii@`g@uyBxWkdD",
        "}oiwHg_ymNguBkoDo^wyA",
        "gcmwHeb`hId]}fDnvB{qFzpAywBluEgrClu@{iCb_@qdItx@wyBt{Ast@tqFk|@rtAis@dw@{l@n}@iTfiBfVtyCabEv{@elBh}AwuFpjAowA|sAwmA`qA}_Bvz@yvCby@wxNt]qaArhAiqBnYw{@jg@_vGj[exAhs@yl@vz@iKh~@dOv{@|h@zdH~`Jh}Bdn@vtGfKdwB|_@pzGhgC~{Bza@`yB{VvcCobBvaEwaF|iAu{Bvz@wmCxOmaC",
        "w~kwHyavgIoc@k_I",
        "ufewHqj{bJpq@u|Ar{Bs{DvpAolApuAsSdqAwHjeAqk@lj@i|B~Im|VhnAukGx`DadEjfGyn@ftBlf@tzAbdA~hAlyAz`AteBhsAbp@psBsU`pBk|@~gAufAdN{uB",
        "{urvHwz_bJw_AmnC}nBshAieCyw@upB{kAon@keC{VwmCw_B}zF",
        "k_`wHeiw_JblB{{G`NobB",
        "swsuHslb_J}iAknEmwD_|AckE{Bu|Kt{@_eFwe@mrCsrBuiCmbBmUejD",
        "_s~vHud{lHb_BwpN",
        "i~wsHaqwhH{`@esGeaPcrb@aqMuoPgsCicGqhCugZaoCyvOkeC{rFerEq~AucE~pBy`DdsEkzCdvCipDuhAcfDcvCq{Ayy@qlE_s@irBwz@{eBcmAq_A_sA}VgrC",
        "ec|vHs~m`JjVaoApb@gw@d{AccBxIg~@",
        "ec|vHqic`J?atI",
        "wm{vHo~y{Ire@{tAv}BkpAppFiu@jlBcn@dl@wcBzBirCrTovBrt@_gBldBo`BvdB{w@n}EcmAxcB}u@xaBg_BjfA_rBprC{wKv[uzC",
        "udtvHkv`{Ick@efHmbDqxKoXkfB",
        "ca{vHefnaJfGsi@j\\c\\jf@yDnd@T|TmGhcAamCht@}fDdHghD",
        "gawvHijw`Je}@koDuMuqA_r@ywM",
        "orwvHo}lyIrYmdBjuBehFdb@i{C",
        "c|avHe}~xIaGovBwdAqLufBfj@eiEr}BiwBpLwtAcxAaw@keC}^cyBsOaxC",
        "mevvHs|uwIhi@kxD~`OshPnb@i|Bnx@g_M",
        "}ppuHszpvI}T_gDgjAq}Bg`Bar@scFih@u|@myAa]y|HssAmdB}sAResDjgAa|AeDmiAmz@sdAyaByeB}eE",
        "ahuvHqhpzIjb@ylO",
        "i~qvHmh|yIgAkdDa]mbDmn@uxC_Ys|C",
        "ikmvH{eslIbZirCjl@wbCxpCcuFp_C{wKtpAcyBz}C}zDjeCamE`oDg~\\zhC{_BvuFrJd`DolCpwXsfj@j|@{tCpV}qB",
        "myjsHolskIil@__HcDm_@wcAo}Fe`Ew}IcvDqrDseExOaeMvvEobCpAcjF{kAe`CnCuf@j]ycA~}Amp@rSqu@uQ{kBycBgt@ec@wuFrsAu{B`tIebAlgJ}hA`oCew@woAwf@qtBk{@keAmkFd`C}jA_t@gj@euBolB{uOg@ytC",
        "clhvHsdq{N`|@soT~oDknDlcAs|Avp@mdCtrAiwTdl@anC`mEaiJ`{@{iCbOa{Bh@o{GpVgjCxn@i|BhhAanB~xEkcExy@aqAjeAysF|}BsqDxeKdD~cEcbDnbIw_Urd@_qAvlDwbEnwBcy@p_BwOhsAye@txC_xEjfBm{@hqBoMnpIlcCjcEi}AtzD_eDtmEebCbmCoNblCzMxbC]hqBs_Ajf@}hAza@ayD`]aoA|i@oo@tgBekAle@}j@hIyhF",
        "omevHo_uzNkHaeBeWycBa|@gyT",
        "g_gvHiyjzNpBi~@ve@{_DlF_eB",
        "}zpuHkfmyNu|@y{Gq}CmbFg|EioDsyFkeC}Jk|@gCs}@",
        "ws`vHaoaoNhU}aWv`FqAhoEa|AhzDgqCbaDkeDf~BvdCr|CfsBp_Dzl@|fC{kA|_AeuD",
        "iq{uHku_nNuHmsIwwCgdV",
        "eaxuHkkh~I~Q}zFpuBidQ",
        "cdluH_jr}IoCuxCis@ssCcyAclBq~AcdAurAwoA{u@aoC",
        "ewwuHir~hN`Re~F",
        "kxcuHyg_hNqLirCi~@shAwjEgtA{aBaqAsh@owAecAauF{`@qv@cnAmyAcZ{w@kHykA",
        "gbvuHctzuIdvCsgObY{|D",
        "wclsH}avrIsu@ouEkkHexL_tJmu_@_hN}r[koCmcCwrVehF_rCi~@sqAybAwRkfB",
        "suuuHk}cxNh|AkpNj|@svX",
        "qaptH{pkvN_wIsaXo`CgkLmcC}|CstLiKkzBidDcd@amF",
        "igmuHgi|dJh~@}~@fpFzl@trAmP`fAomBtH{}C",
        "wxluHkmrdJqM{zH",
        "g`luHq_vmJbnAwiI~dFmbB|dFyOprD}gCdkCwkEbnBy_FdkBsvI|fE}spA",
        "}tksHgcpkJwd@orHouDm_GusJ}nG_sAcoAyvCqfEssAwdA{iByZizEpb@k{BqCejB{a@k~KgeGap@gj@ag@gw@i_A_mGkRqbK",
        "ebkuHesqgNzb@mmBr{CkwEhh@ylB",
        "}owtHoxxgN_aJ~uIy~DdaBmoA{rE",
        "i|_uHodqeJnlAe`C`mE_gBfjAqv@fkAylBhcFguMnbAysFf_B}_t@lZ}gC|tAaeBt|AmeAxx@qjAlZcxAdBelB",
        "ir~tHczeeJ__@ayD_IioD",
        "u|}tH{s|qNpBwwB~eB{hFfLueC",
        "sgstHmeepNqb@ywh@ew@ioCaxDiqDg_A_rB",
        "{y{tH}bzrNj^syHvz@}wGlz@{iCjvEqyJdn@ekCtg@sbI",
        "{dztHe}krN_t@wdM",
        "sowtHmwnuNhJcoAv\\i~@hTwdA",
        "{sttHm}fuN_UynAsi@cmAcZa{A",
        "kxvtHwj~uNfl@shCphDo{G",
        "gqutHsluuNcf@c}G",
        "sdvtHiq`uNpL{kBdb@g~A",
        "atmtHwkktNaHucDyb@_|CqaAknB_}AazBcbAmxB",
        "kzetHqqkqIj\\}}CldA}pCp`BczAjdBkq@hrA{`AflAc_H~|@yaB|pDe~Dj{B_mG",
        "czctHobypIyEkqB{v@_wHq@ucD",
        "coctH}`pgHrIazC|yHmpXfj@sbH",
        "mm_oHy}qfHi`@woAcaCaoC{l@uqA{eIu|f@alFwvRasJybN{iBadBu|@{m@}`Ag@auFrhAmeBrt@adAptAywAdnLcbDrJq|Ekq@wlF~oBwrI|eGmoLlkDeb[~fD}tLoYy`E|_@qhCtzCkg@`~Hgv@bxCazB`\\upAeaB",
        "o{_tHg|wiJrgBg|FvzAs{BptAwiIle@olAvaDtQfl@~{C",
        "uy|sHkf{hJ_|AcuQyCw~H",
        "ckosHu~jjJoc@ddJ",
        "sopsHoy_jJr}AjdDt|AxDh|A{_BlkEk`J",
        "q`lsHw{ekJrJofI",
        "qiasHqphjJu{@ohEigCckEaoBwvE}`@y|H",
        "g`}rHsvoaHfiAq}ClsIgwKvdB_xGh|@owAvpAwdAh}@sh@dm@wz@h^yxBj]okA~xEm`HhsBayBblCcuFnrFgzFjoCmvFrjAqk@ptAk\\zuA{k@xbAemAnaDivH|eDigClmDa{@frDug@dtDcoAxx@ij@t{Bg~@dv@ij@~s@igA~dCmvF~qCmxBphCel@`{AgkArIaxE",
        "}bnfHeztzGaA|@wB}@iCoC}iq@ooZ}vn@ebYghCcvCymBkyEifDqtM{kAmnCaeAyuBimGorHwtHicGgmIovBw~H`fAmjGvsHymMf_\\{wAnzIgsn@_eKisn@_eKm_GwlCmmCy_FaiKovi@gyGiiLyfIuiKaoD_{B_bFxDerH`tIkmDvp@ssAydAykCkbFu|Ak{@{_Bf`@gaAfuAqiArs@mxBccAc{@qjBetBmpLycAyvAigGcoDqh@uZsqDe`Eg|CscG{`B{zGS{gG",
        "_ltqHyikbOxlBsyEnkCgsDhtAmaEz`@}pE",
        "{~mqH{g}aO{uBacFguA{|E",
        "mfiqHkrkcOxNc`F`|AkyCnuBwlCbyAe`EvFknB",
        "ozhqHamdcO}JidF",
        "ss_qHogldOza@elBfw@ybApfFwxCxc@omA",
        "ea_qHeledOmQizE",
        "sowpH{tbeOjIejCh{BoxKjr@ocAzrEsoEnmAkr@teB`Q`f@ncBt^~uG?TlDdNvGdm@pdJxXtcDqWvoAkcCnw@ibJtgA}rCjoCmyA`bFg_@zuAec@lnBueBhlH_vKzsDsgCboN_}@~yDqqDxwAyuF",
        "cltpHw`ydOeXqjBon@wnByYywA",
        "arjoH}cyeHvRcy@`xD{fHdjC_jJrK{kA",
        "c{ioHwoseH}UesD",
        "_u|nHw`soOjIohEz`BohGzAs~A",
        "ccrnHy{hoOwFgj@qkBwzBcaCg`AmzAu{A",
        "ofznHk`npObZ{`AdcAeC~gAzj@teAdx@v{@dc@pkAaQ`dAocAjgBmwCfsAr}B`{@nvB~^f~BxNrmHfaAz_C|oEv_FtqBr}AtzAdYrtAcn@d`BewBp`A{tCH_fC",
        "{eynHksdpO_]e~DsAylB",
        "qjrnH_mfoO|@kh@nDmd@",
        "{x{lHyn~lOalEgfF{oI{gE}pE{_DkeDoeJ_{AodKe}Fk~Ki_@qjBce@kf@my@mFycAtScdAfj@srBqdHwOk\\a}@mpA_S_r@",
        "sgzmHkemiOpLomBpaA}sAdtDquAnmA{uA`[{iB",
        "eesmHanuhOgMoiFqVapBme@koBapB_dEcd@keB",
        "_qymHcqchOvd@ipClcCgpGr`@kyC",
        "o{rmHk}kgOst@_wFmy@ylBsu@ufCcd@qiCuHuzB",
        "qfqmH}hfjOHkfCle@ekBnbAu{AxwA_|Ah`@k{A",
        "wwnmHca|iOoNugBi~@c~E",
        "knomHaihkOxZo}Fft@uHn_G|~@njBzAvfAu{AlPsgB",
        "ebjmHqrvjOc[kqB_fB_oEec@s{B{CovB",
        "srmmHomfpO|VaoCrpDssLjpA}gCveB~G~zB|t@jnCr@hgBs|AhjA}}CrfBc~HbzAmkDvz@dMdaAr}AvoBfaArqAwp@byA}}B|zEs`Ljs@olAtp@cZdwAs@v{@em@ve@qjAzV}tArKe_D",
        "kflmH}q}oOgk@qzG",
        "gbhmHqsilObe@m_GzhDi|CjxDo|F",
        "cx~lHwstkOyYqiB_}@qaB?]ymCidEoaAmkG",
        "qqpkHyo~rOdYuyD`q@wkDjyCgoIx`CmbBpwLg_CrqDq`B",
        "qqokHa`nrO__@wnO",
        "{c`bH}|``H{_Ppdc@miCzrEa_BrgBihAbZ_lAob@klBaqAwe@ij@uSug@oXi^is@}Jyc@tSqlFpqE}pJpwLkgAfj@ur@owAwkEqjNmxCa`G_|BquAolA~oBoXlsIwoAnbBwoBgBgiBym@cmBu]y|Bvn@kf@xe@_aBnjCex@r^_i@kf@ga@g`A}_@ih@ouBssAcCByu@x@_yAvoAi}@z_CgsBbjRkjJfyo@kjJfyo@",
        "}bnfHu~tzG?nC",
        "}epbHyqyaH_mL~zh@gHtoC",
        "e}}bHcek`Htw@loB~{Ap`@fxJ{Bv_Htg@byBfu@nNbzA",
        "wv|{GefshHkzBkz\\okBabEirHujJey_Ajj{@{ls@lo\\iuCp_AsgBdbAal@j{AqQzfF}u@z}EofBjdD{eHfxH_@hAm|i@~jc@{}EraKmcC~gL",
        "s_qbHaufdHtXfblA",
        "ezm|GwvvgHnlA}kJ|oAg`CzdBe_BzmF_gDfo@axC",
        "yytzGyzbiHqC`xCurEx|JsaCd_DqeBjmDei@twFwE|}Pq{@prE_qCsrCwp@vcBivA~]}zAxO}~@nx@q~AtcF{b@lxB{HduBslC{tCcrHseDeuDo}Hgu@i_K",
        "glwyGqtmkHk`Nh{d@e{F~hMutDzdGcp@xaCc@~oD",
        "wquzGqtgiH|VvxC"
      ]
    },
    {
      "left": "ISR",
      "right": "JOR",
      "kind": "International boundary (verify)",
      "lines": ["{dnfEoljxEhAqB|M}rC}j@ccBs{CinEevDuvIkV{jBM]"]
    },
    {
      "left": "SYR",
      "right": "JOR",
      "kind": "International boundary (verify)",
      "lines": [
        "ocfdEaxs_FmVaoAyeQok^wnOu{\\I??g@I?{tJyrTqbQul`@ikGgoNcvHm~PgbQ_n`@acQ_n`@_nLyzWI?w}Pk_a@owGmqOuaUmwh@o{W{yn@",
        "ib{fEygiyExCi_@hPoYH?RRN?t|@mx@`cCy~Sl\\mz@n{A{jBvG_^",
        "ekzfE}{fyEkOaf@wEyc@",
        "cgpfEirjzExI{Vth@uHng@jGnX~R",
        "ifpfEqahzEYwoA",
        "splfEowjzE{AfV",
        "oslfEg`jzEvz@yw@vj@{u@dRg`A",
        "yfifEskrzEnH_qC`fAa\\liBvQjtBqCtgBwy@zhJuxGxgA{a@xYg@nCsUbAgjAlAmxA",
        "yxhfEeqozE_MmyA",
        "w~oeEo{x{En^ybAblDojEfjFarKvwLadPjk@k{Ax^kzBf]a_Jvt@kdBrVccFlwAcvY~oCm`F",
        "_smeEcut{EsK_^ku@afAwGi_@",
        "uqneEugp{EpBkf@hTs_AxDmd@",
        "ewmeEk`i{EoYifF",
        "ccidEki`_FjBsfCdxAenK`B{vA",
        "{lgdEy||~Egu@qkB"
      ]
    },
    {
      "left": "ISR",
      "right": "EGY",
      "kind": "International boundary (verify)",
      "lines": [
        "q~n}Dec`pEtiDc_AnqScuFxmO_dEd_PunFvtUm}HpjZ_`K`pNggClaGqLfiBod@ftBmbBH?dlAa}@|sAh@tyDlz@xlB|I~fAqLxy@gj@taGatIlxAcdAnbOinEvx[{oJjyQgqFza@mPxc@_Jnd@{Ble@fBlrIkf@jlS{pGnjQ{sFjbSy_D~nLrJntC}j@zaGwmC~wA{t@"
      ]
    },
    {
      "left": "PSX",
      "right": "EGY",
      "kind": "International boundary (verify)",
      "lines": ["eac~DuvvoE|oFcwC`fBec@riHeoB"]
    },
    {
      "left": "IRQ",
      "right": "SAU",
      "kind": "International boundary (verify)",
      "lines": [
        "mu`cE{~~mF|rDkse@dsDwre@fsDure@zrDare@tgAgtN",
        "ka`cE{w|mF{CaQeDaQcDmP{CmP",
        "o|gbEidisFHSHi@l|I_raAboBqoI`lDc{InfIwaSvvGwbPtuGadPtvGmcPlvGwbPjvGmcP~uGmcPjvGwbPvvGadPjvGwbPjvGybPjvGkcPjvGadP~uGybPjvGwbPjvGadPjvGwbP|zGolP`tH_}KjhKapOlhKwnOjhKwnOjhKkoOvzLkoQnzLunQ`{LioQbzAwxBh_JsuMHSJSHUtpMysSzcK_fPfcKiePncKuePpcK_fPxwNwjUxwNkkUxwNikUbxNwjU|tEenHfbH{{KxwN_kU|wNwjUbxNujU`cLqrQjcL}rQ~bLosQjcLsqQ|qI}_NfL_g@zLag@|Laf@pLah@`l@szPzf@uqN`f@kpNvf@apNff@wpN~q@w_Spq@e_S~q@w_Spq@o_Spq@m_S~q@y_Svq@w_Stq@e_Svd@u{Mrd@mzMbe@k{Mrd@k{M~r@gqS",
        "o|gbE_cisF?i@",
        "skkpDce}yG{q@gpGk]kbDoS{lB_r@epGar@}pG"
      ]
    },
    {
      "left": "JOR",
      "right": "SAU",
      "kind": "International boundary (verify)",
      "lines": [
        "q{gbEo`ylF]?{lAkwEwvQgeVylAmxBmPi~@",
        "{{gbE{_ylFHS",
        "eddqDwmyzEyDejDex@e_DshNgeT_}MysSilOuuUe{I{`NooQcpKk~PodKqgLo~G}}NqxI{jCgtC}iAyjDeaB}|OccBekPwaDcb[o`Da{ZcvCqcYwcCk_V_gBkeCekQwtGkrLumEmxMy_F}bKmvD_pBkpAugBuoCaiI}eTqmJcrVq|EihMiU_i@}@yDqAqAeC|@sxHjtHavTjlTwuTtmT_vT~lTkvThlTaS`S_SjR_S~RwRjRasVhlXcgV``XiJdKcsVflXwrVflXi|@{nFsmIo{g@_kKkko@ikKiko@w|AumJemHu|c@qv@g`F_bHk{c@qyI}{j@{yIi{j@qyIq|j@knD}dU",
        "awcrDu`itEdiBitTvoBeeV|qCek]vbCycZzjCq~[foByaV`u@acJtkBgoUjaB{hS"
      ]
    },
    {
      "left": "SAU",
      "right": "KWT",
      "kind": "International boundary (verify)",
      "lines": [
        "_`~oDoio`Hog@x{I{fA`mR_gAtmRagAtmRufA`mRgkAfzTujAhxTsjArxTwjAfyT",
        "m}cmDyd}aHydD~r@qjB|sB_xAjnCikBjdCslCt}AmwDftAq}D`{@{oIzVs|C`\\}`YpyIibMblHuqBlkACTUdB",
        "_`~oDejo`H?T",
        "_iemD{orfH~Htta@~Hjva@jIjva@hI`va@zApnI"
      ]
    },
    {
      "left": "IRQ",
      "right": "JOR",
      "kind": "International boundary (verify)",
      "lines": [
        "a|tjEuctkFrzZuaH|`XubGzwSkwEnvZ{{Gft[efHbyg@{bLj_CnaNhAlGnCpAvFqAdImGna[{oHt|Aom@j]i~@",
        "k|mdEqfnnFr~@q_C~~Dk{AndLoaCxdEp~C|~OznVbo@i@",
        "agedEqfimFitG__d@"
      ]
    },
    {
      "left": "IRQ",
      "right": "SYR",
      "kind": "International boundary (verify)",
      "lines": [
        "k`oaFw{oaG|hAag@x~@cn@zdAqb@vyA}@n@jAhvBj`E|oHznKR?H??|@`iPrcS`p`@h`f@nrUhiYjpBjdDf`AbjDhkIpq{@ru@rtKvcAbwDziCh|BT?HRR?ldZtfPrfD~q@l_p@phEhgBUdkBoWpoHg_D",
        "scuzEuyzzFR?rtYebNpgEybAblEu\\lzYoYtbEfa@~{DxaB~aG|qE`iJxeH\\??T?R~zDnx@v`R|u@|bW|cGn{Jj|@fpCaDje_@sb@~ba@_t@vbDfM`yCpt@jpt@|o`@\\?jyKx_FteDbmCraBxuD`tIv}n@ljMrs[pyIdrT`yIdrT`yIbrT~xBjrFl_Fx~LdyIdrTbyInqT`yIxrTjyIpqTvxIdrTfyIbrT`yIdrTdyIdrTfyIdrTpyIbrT`yIdrTjyIdrT",
        "icuzEayzzFIS"
      ]
    },
    {
      "left": "OMN",
      "right": "YEM",
      "kind": "International boundary (verify)",
      "lines": [
        "wa}rBkag|HlbBek@hlKuoDhzQmjGtzQmjGhzQmjGrzQwiGdzQmjGlzQakGtzQmiGbzQwjGdzQwjG|zQcjG~yQmjGhzQakGjzQmjGhzQmiGrzQmjGhzQmjGh~LieEfBrJdC~_@fBtHdw@k{A|KcjFxc@gjBfuA{`AdjOgqFpmYeeKzlYweKnmYofKdkYgeK"
      ]
    },
    { "left": "OMN", "right": "SAU", "kind": "International boundary (verify)", "lines": ["_idsBay||HffFtvT"] },
    {
      "left": "OMN",
      "right": "SAU",
      "kind": "International boundary (verify)",
      "lines": [
        "khqiCwtyoI~cRilKtkWmwNrkWyxNrkWowNhkWcxNp`O_kIrgCs_AjnCgBt`UvhF~|Ab^tzBhh@x{IrrBh}OfsDb~TxhF~~XnsGp_\\vsHb`^lhIppFjoAznWtcGn`_@`tIx_^`iIp_\\bsHb_YbtGr~TzhF||OprDx{IfsBjzBjh@tzQzgElxHnk\\vcJtl`@fcJvl`@dcJjk`@rcJtl`@jcJjm`@pcJtl`@vcJ`l`@fcJtl`@pcJ`l`@jcJjm`@pcJ`l`@vcJtl`@fcJhm`@pcJvk`@pcJ`l`@pcJtl`@"
      ]
    },
    {
      "left": "ARE",
      "right": "SAU",
      "kind": "International boundary (verify)",
      "lines": [
        "ap`sCmcwyHhoFue@b`D|@toK|KlaDs`@|qCs|AhfL}bJpbKqdIvbKeeIzbKqdIfbKgeIpbKeeIfbKeeIzbKqdIrbKgeIfbKqdItbKeeI|bKqdIpbKeeIfbKgdIvbKeeItbK{dIvbKgeIllKgnI`dB_|Btm@uxCpzBok^ziBycZ|iBycZviBmdZviBycZziBycZ|iBmdZtiBycZ|iBycZ`jBceZ`jBycZpiBycZ|iBmdZfjBecZpiBycZpiBmdZfjBmdZ|gBsuY",
        "}caiCcwioIoNi}A}sNi~K"
      ]
    },
    {
      "left": "SAU",
      "right": "YEM",
      "kind": "International boundary (verify)",
      "lines": [
        "aelfB{ys~GmZojEufAwwDenLw}VqnKogU}FeEekFuvDioa@}`LsjWofHo`EshBivU{~Q{za@wc\\w~c@_{]}cTmvPkdQycNy|AokCsfK_`X{jOqp`@ahQqld@ajOio`@suLoa[mgCmuGkiEadQykBmeXueCgh^ueCgh^ueCeh^ueCsg^ueCeh^_fCgh^ieCgh^ueCeh^efCig^keCei^ueCqg^yeCqg^ueCgh^ueCgh^yeCgh^ueCeh^}cCaz]",
        "{l}iBmkbhGnXupB`GosEfXmdBn}DqkMzuCohGrsM_sLjcEkaGhi@_|B\\kpB",
        "oeudBigmfGkRqiBqsBce@{HnAcqC|c@i~Axw@{tApL{`CwxAaf@ew@gWox@}_@en@q`AoYapAlGybAhi@mo@f_A_}@zfF{w@`gAicFpjA{rFxbC}hBnWkzC_i@gpFwcByvBcZigCS{hCnb@_gBbp@ycBdXo`Cyc@kvFcbC}}Bqb@koCxDkzBce@yaBo`CobAkdD_^wmCqaAekCi|BgUaeCp_AayAvyBapBfdJw[yPiaJkkH}_Mo_PwiIwdPaq@sgCaQ{hC",
        "yskiBi_ooGbGaqf@`DqbW`@mzCbFiy_@vcAsaJbwPaw^lyAo|GxaCqkh@vwCepo@rsBc}c@ntCukn@",
        "}~eiBg_ynG_I_oDcmCyfKw[ggC",
        "abiiB{t_nGdMm|J|sA}kL",
        "krciBcazlGwF{uB{iB}~Ma|@}{Q",
        "ekfiBkzmlGnNg~BhhAofG",
        "okzhBmlalGit@ovBkoB}}AuyCmzAi~@a{A",
        "}c_iBmoqkGhJqiBnuB_oFrUmaD",
        "ogrhBqd`kG_TgrCu{Aq`BayBaoA{jB_~AycA_fC",
        "mk|hB}rzjGlOcd@ncA?j{BbO`q@yW~\\uS`Rcd@nN_iA",
        "s|zhBcsrjGyCelB_i@sqC",
        "}q{hBu{jjGhTmvF",
        "mxzhB{qcjGoXyhF",
        "cbmhBcab|Gz_C{fFjzOwrKdiRomMj_UkoOlo@cnAtBuvAba@mvX",
        "machBmkvyG}gC{g_@wvDykj@",
        "ekxdB_p`fG`[i{CrhA_zF",
        "mm|bBiiddGudB{iHcyAszE{jB{_DccBst@adBbF}}AxOwpA}VwZoaAij@{qFs^wzAuzCgpGo`B_fCgjBcmAgwKo`DeuBeXccCmG{tA_^s_@aoA"
      ]
    },
    {
      "left": "TCD",
      "right": "LBY",
      "kind": "International boundary (verify)",
      "lines": [
        "wy~uBezjqCs|J|bW}{J|bWc|JzbWs|J|bWg|J|bWy{JpcWq|JfbW}{JpcWi|J|bW}{JzbWm|J|bWi|J|bWk|JzbW_|J|bWc|J|bWa|JzbWm|JpcWy{JhbWc|JpcWw|JzbWc|J|bWc|J|bWm|JpcWw{JfbWc|JpcWm|JfbWy{J|bWm|JpcWw|JfbWy{JpcWa|J|bWm|J|bWy{JzbWm|JpcWc|JhbWc|JpcWm|JzbWm|J|bWcyHf{R}aAtfCc|JfbWc|JpcWm|J|bWy{JzbWm|J|bWm|JpcWa|JfbWc|JpcWm|J|bWy{J|bWc|J|bWm|JzbWc|J|bWm|JpcWg|JfbW}{J|bWi|JpcWa|JfbWy{JpcWg|J|bWs|J|bWg|JzbWi|JpcWc|JfbWw{JpcWyxGbxP",
        "o`bnC{aq`BtNz~Bb}BvtG`bDlgJlbDngJlbDlgJfbDvfJrbDlgJjbDngJlbD`hJlbDlgJlbDlgJpbDlgJfbDlgJbbDlgJbbDbhJlbDbfJjbDlgJlbDbhJ~q@tlB"
      ]
    },
    {
      "left": "LBY",
      "right": "NER",
      "kind": "International boundary (verify)",
      "lines": [
        "mfpnCkt`hAjzB_fPzyBsfPzyBigP|yB_fPjzB_fPtyBigP|yB_fP`zB_fPdzBggP`zB_fPzyBufP`zB_fP`zBsfPjzBsfPpyBufPfzBsfP|lC_zR~yJc|U`aHm~ItbS}lWxbSgmWfbS}kWnbSgmWniFe{Gfj@czA",
        "{f`iCkrwuAiI{_BgfEuiKuzOul`@wzOal`@uzOmk`@e{Oul`@ISy@_C"
      ]
    },
    {
      "left": "DZA",
      "right": "NER",
      "kind": "International boundary (verify)",
      "lines": [
        "_vysBy{xXcaF{yc@gaF{yc@{`F{yc@gaFozc@avBumRkeGywi@}dGwwi@kvBumRkyCodXscB_xGesDumGyeLekNcrIaiKwqIuiKerI_iKwqIaiKcrI_iKyqIaiK_rI_iKcrIuiKyqIwgKcrIuiKwqI_iKerIwhKwqIuiKyqIkhKyqI_iKcrIaiKauHmgJ}eEwjFujKocN_kJi}LsjJk}LikJk}LujJu|LyxNojReaNarXsyFuhL}yFkgLuyFuhL}yFuhL}yFkgLsyFuhLsyFuhL}yFkgLuyFuhLsyFuhLsyFahLsyFahL}yFshLiyFahL}yFuhL_zFahL}yFuhLsyF_hL}yFuhLiyFuhL}yFahLsyF_hL_zFuhLiyFahL}yFahLsyFuhLsyF_hL}yFahL_zFuhLsyF_hLsyFuhL}yFahLsyFahLsyFshLsyFahL_zFahLsyFuhLsyF_hLsyFahLgzFuhLsyFuhLsyFkgL_zFuhLiyFahLsyF_hL}yFuhLyyFuhLiyFahL}yFuhLwyFuhLuyFuhLwyFkgLczFuhLsyFuhLsyFkgL_zFuhLsyFuhLmyFkgLyyFuhLwyFuhLuyFahLsyFahLwyFuhLczF_hL"
      ]
    },
    {
      "left": "DZA",
      "right": "MRT",
      "kind": "International boundary (verify)",
      "lines": [
        "{dpeDzw~s@tvUite@~uUite@tvUkse@`vUuse@rvUite@`vUuse@rvUuse@jvU_te@tvU_te@hvUuse@jvU_te@hvU_te@fgRmv_@fgRuv_@pgRwv_@nlOm}Z`yAixC`|LmsVf|Se|`@z{S{{`@d|Sw{`@z{S{{`@"
      ]
    },
    {
      "left": "NER",
      "right": "TCD",
      "kind": "International boundary (verify)",
      "lines": [
        "sqsrAut`rAgfEpk@cfEdl@ifEpk@weEfl@ifEpk@yeEpk@qfEpk@}eEfl@cfEpk@ifEpk@seEdl@mfErk@yeEpk@gfEdl@cfEfl@gfEzj@_~Gf`Ac}HfvAaqLnvBeoJ}@muGykEilAq~CgzAm`FkSe|FyZ_sC_RidBkjD}pEopBoo@msBaFymF`g@_d@rSyy@dbAm_@tHi_@sUcsAkzByxEqfEem@k}@i[i|B_IovB}o@}}AmqCqv@g~BvFsiGzvAq~BdX}cCwFuvBq`@gaEa|AyhLckEupIo`DsuFotD_}FuyD_~F_yDo}FizDy}FayDk}FuyDs}FuyDu}F_yDk}FuyDe}FuyDs}FuyDu}FayDi}FizDq}F_yD}}FayDk}FizDy}FayDerFgqDiaJatIy{JgmJ}zFspF_kJw}IglJk~IikJw}IukJw}IskJc}I}kJc}IikJw}IukJw}IikJw}IskJc}I_lJw}IikJw}IskJw}IikJw}IilJw}I_kJc}I{{EosEirBaqA}~@qQ_iAmTg}CsLe|GyX{{GeXe|GqWe|GeX{{GeXe|GeXe|GeXo|GeX{{G{Xe|GeX{{GeXo|GeX{{GeXe|GeXe|GeXo|GqWe|GeXe|GyX{{GeXo|GeX{{GeXe|GgXe|GeX}t@wCgfFmS_|GeXa|GeXe|GyX_|GeXa|GqWe|GeXe|GeXi|GeX{{GeXk|GeX{{GgXi|GyXa|GeXe|GeX_|GeXe|GeXk|GeX{{GqWi|GeXw{GeXo|G{X{{GeXi|GeX{{GeXk|GeXe|GeX{{GeXi|GeXa|GeXe|G{X_|GoWe|GeXk|GgX{{GeXi|GeXw{GeXo|GeX{{GyXo|GeX{{GeXscGsUsiNabEmaDi}A_nL_yFanL_yFcnLsyFknLsyFm{E{~B{iB{l@afBpL}fCnwAuyC|rCo{JhkJm{JrjJy{JhkJo{JjkJetDvlDw{Jj{NovBvnB_gCnwAg}CfiAsxG`r@a`Hur@ipFkyC}fC}zFyuCjfBmxC~fBwwCfhBcxCtgBaxCrgBcxCrgBaxChhBcxC~fBaxCrgBwwChhBwxC~fBwwCfhBcxCtgBaxCrgBcxCrgBwwChhBmxC~fBkwEpsCytFbvEymAnvB_pCdfHa{AdaBmcBxXwbD|@kzB|@qdIxDqkMlGwnO~GaoO`HgkMjGqdIdDkzBrA}zFbn@mhG~q@ohG`r@yfKpjAmfK|iAmfK|iAwfKpjAmfK|iAyfKpjAcfKhiAwfKpjAwfK|iAofK|iAgfKpjAsfKhiAsfK|iA_fKljA"
      ]
    },
    {
      "left": "SDS",
      "right": "KEN",
      "kind": "International boundary (verify)",
      "lines": ["adwXwcknE}pRwvRmpRavR}pRcvRspRwvR"]
    },
    {
      "left": "EGY",
      "right": "SDN",
      "kind": "International boundary (verify)",
      "lines": ["}}feCwvz~DGgqJAchD?o~R?c_S?o~R?c_S?o~R?c_S?o~R?c_S?o~R?c|N?uaC?e_S?m_S?o~R?c_S?o~R?kxR"]
    },
    {
      "left": "KEN",
      "right": "ETH",
      "kind": "International boundary (verify)",
      "lines": [
        "_|bZmi~zEca@lnCkuA`dC{rEfqF}dAvnBiwA|h@miB{@i|BwQmwBlEcrCtqA{jBhK",
        "ynaZokl|E_JvoA{u@tpBsOj|@",
        "iadZukd|EHz`Af\\bvEnFjo[FzW",
        "cj`Zymu~EwBlN{Gzc@kv@j{A}Jfu@",
        "azbZ{fo~E~R|p]fVlhc@",
        "wamYs_caFk]zl@kdDdaBul@v{@my@b~F__Fl{L{eBtsJ",
        "ot`Zqb{_FjIvsd@",
        "atcY}amaFmFh_@s`@~R{iCh_@q{@pWuv@hh@{Mnm@",
        "ckmY}|faFjHh|B",
        "yz_WqzpzF}d@xeI{yB~mHcwEvtG_pPbpKouClbDa{@vcBwdBliH}x@tpBi~@r_Ai`ErgBanDvxCi~FpwJytDrhC",
        "y{cYktxwFxaG~hKnfE~fOj|FdsSnuHlfXb`@nb@|cBxc@r^r`@jjDzkNp{E~wR^lP",
        "ie`UadsgFwKfkAc|B`oCkx@tyDgk@`oA_qBf_Bs}F|}CyrBfsBuzBn_EuoKhnRk}J|qQu}KhdS{oJ~{PqdIjyNshMdhUyfKb`RqfKb`RgxEnqIuHxc@",
        "aucYkgnaF^ld@",
        "_orWoegtFeDvQuIvQyD`{@",
        "udsW}cdtFzWxD|e@oCtc@j[lkC|yGncH||QzaG`yOzaGnvOjyC||BxeIvyBvkMjmDr_EjfBh|CnvBb`MpjNxtJdyKx`En`Db_LhgClcDfhBnIrfE",
        "akbWqaj~Fmu@luGipCdrG}_BbhH",
        "wskWyno}FjvCxgGhSlyA",
        "ahfWqkd}FmOdxAucAhdDwEnbB",
        "}ciWqiy|FpzBrsN~GjdDzvA|xHjg@x{Thc@f}R",
        "uxgWkts~FrlDxqH",
        "o__Ue_mjFaHjpA}TfvAuc@nWkp@hKsz@jq@_aBduBkM|_@",
        "q`hUgh`jFjW`{@~r@|Ktv@eDzb@vFdjCn}Hz\\`}I",
        "}fmTevklF}|BvpMseDzgRu}@hqBcbBp`B{}EfhD",
        "elbUm~}jFhh@qAtvAjGxi@i@",
        "qo}Tc`iiFajA|zScjAlvS",
        "webUwl_hFnNtbE|o@~cE",
        "k`}T}y}jFiY~kJsT|_@s`@lEySrJ",
        "wf`U}ypjFpa@nwAtCfa@",
        "kndTq`knF{r@prFiaGvqPad@roAoM`{@",
        "cxoTqmmmFvjAbfJf@|_B",
        "ckmToe_mFua@r|AgMtgB",
        "a|nTe_ylFpq@feGpAvaD",
        "yuwSmubpFaaAnbBorAbn@ssA|_@aeAfu@w_An_EgVhkWirBox@w_Ab\\{C~pA",
        "_wiTei{nF`V`g@jjCfqFdEhmF"
      ]
    },
    {
      "left": "MAR",
      "right": "DZA",
      "kind": "Indefinite (please verify)",
      "lines": [
        "gybcE|ljN|`@mzYnNskK`Qs_MjRihN~SigOrTa{O~TkdPrTmbPhTevOhSg_OjRs}MnPaqLbNozJhK}xHjHklFbE{tCfA_t@`RevM",
        "eph`ErbtToPkgF_xGebx@m|Iaii@abC_ca@obR`eGio]~mLykDsfJsrAcgc@yhGk`b@",
        "k}xbEv`sFaq@etF",
        "edj`Ebm|T~r@oiG",
        "era}DnhgVyDbgBew@biAokB~TmyBuh@c_EmcCymC}K{vMlf@iqBeXisAinAwvE}vIkXmmMeoq@ivAi}DyhL",
        "kx_sDl`la@wmDqbRqeVenSgqW{vPqeVwsLyvPqbRchKenSekO{yTm|IekOwpHenSm|Igt[obRshZgqW{yTwpHqbRwmDqeVuj@}_]kyEiw_@ekOkzc@chKtj@chKtj@aeGypHo_Nm|IksM|pImxBjGymBxZsrB`{@cx@hhA_~Al`Fa{AbnBmjFdjDupAlxAgW~kB",
        "k{h}Dje{Uhi@z{ApsCxuDhi@lnB",
        "}~vsD~fcb@xvPmyEvmDckO",
        "sfvrD|{kh@ysLckOkvAshZkyEgt[kvAshZ?it[?gqW_bCqeVkvAeqW",
        "m{csDzzcj@tj@{yTbhKaca@",
        "o}irD`nzk@ekO{vPaeG{yTuj@m_N",
        "{bkrDpdom@hJgcHrh@esGpCyjC",
        "_sygDzw~s@_vJ?muJ?euJ?ouJ?uuJ?suJ?ouJ?suJ?euJ?ouJ?suJ?ouJ?uuJ?ouJ?cuJ?uuJ?o|G?ggDqU}tBwdAcxAgtBa}Je_X_eEexGajC{zG{eAymA}lImuEebA_}AquA}zEgu@afBe{Ik}Ky}F_iLwpGa_Ue_CioEk|MwyPqgKwtSgyHa}JogCakHuaAw~AwrIs|JuqAotE",
        "cakrDptpl@rb@oeU",
        "kiirDh`yl@}L}hCyh@y`C"
      ]
    },
    {
      "left": "SAH",
      "right": "MRT",
      "kind": "International boundary (verify)",
      "lines": [
        "e`w}BllbgB_aT|vC_yDmVmwPiqCsfEoh@wjUihGmvQewBg}OokBur@mz@?atU?waGI{xU?imb@?o~l@Sylu@Kkv{@?k}_ASo`bA?q`bAIa}_AA_`EGsuu@Ielu@Ky~l@?ymb@?wxUIqaG?mr[{r^hcAi|O|c@cwoAnoDwyo@bfBwyo@bfBusKjpAqbX|nHknKv`AscLqqAclKoiEsxTuuOI?mmCivBkoK}pRyqNgmWomLg`ToyFmgKsxBq|J_jC}{_@e}@c`Fm|Quyi@e_Ds{RccBsrAstEeXuwN?ewM?uwM?swM?kwM?uwM?owM?ewM?qwM?owM?owM?kwM?owM?ewM?uwM?owM?qwM?ewM?owM?uwM?ewM?_wM?qwM?ywM?owM?ewM?qwM?owM?ewM?owM?qwM?ewM?ywM?IotR?ytR?ysR?ytR?otR?ytR?otR?mtR?ytR?etR?ytR?mtR?otR?otR?otR?ytR?mtR?etR?ytR?mtR?ytR?etR?otR?ytR?mtR?otR?otR?otR?wtR?etR?otRIcuR?cqOk^gyB_qAyi@}yG?guAHerF?eyJN}iNRacQTqfS\\ysT\\kjUTcjURwsT^{fSRmcQ\\giN^qyJ?orFH}tAR"
      ]
    },
    {
      "left": "DZA",
      "right": "TUN",
      "kind": "International boundary (verify)",
      "lines": [
        "}ar_Foa_s@{b@avEckCmpLi_AwnB{jAeD{fGluEc_AhTkjAeDmdDtR",
        "{nr_Fuwwr@|KyhF",
        "me`iEs_bp@sFbbCg`@z~Bys@lxBucLnsTa`A~bFqVvjHmy@|dFmsCx_DccHr~Am{XvG_YHitFh}AazTr}M}bQflKk~Crt@}cI|~@ibHrrDajBfj@_wIftA_rFt^grR{`CukMkRchD{tAatBcgC{wEc{F}gDaxCqrCejDgdB{qF_t@glKis@guBomAcmAqdBgw@mbVcjFozEuyB}qCesF_dE}|OwyC_dGw_FspQ{e@ss@y|Dm`G}hAgrC_i@wp@}i@cZ{kB}j@_r@kf@}sBy_FaeAyn@spEn`Dg`BmPi|AshAknD}gEwHmGcw@_p@}sAoPouRhsBogFrJ}pFi~@slIetCgkMylBg|EuqAwjGgfHa{M{xJwyB_}@ghCbvEoaAhcGu}AlkFo}E~nCc_G`g@kcF}K_yEybAczLc_FuwD}@whOh|@k_ErUmkEriB{wKnpHuyEhiAehGbZkpNec@{eKmcCeiAeXiwI_S}jMwbCufBmeAeuByw@uoBbO_sBnm@_{Bv\\aaGw\\o}SyfHq_@kEiuA{OaaGuHyvBfK}qB|s@on@f_BoYfuBkq@vwBex@r}OssAx~F}BGmrEuKwoCgrCi{AgsDwyBwrKcqJksV_|BekC_zEwmCszEst@q~B~|Bk{AhyEobBag@{kAc`EqVspF",
        "uaowDeiby@}nT~oD}nT~oDsnT~oDsnTrpD}nTrpDsnT~oD}nT~oD}nT~oDsnTfqD}nTjoDsnTrpD}nT~oD}nT~oDinTrpD}nTjoD}nTfqDu`AxOy~LhqBguBleAcwApuAceSf{_@saXjzg@idR~d^}|Kv}Vk}C~iD}FrGamE~gAmdS`{@kmZrsAwfErsAaaYhyR}hW`nQyfAnjC",
        "c~`iEcbfp@tWnaC"
      ]
    },
    {
      "left": "MLI",
      "right": "DZA",
      "kind": "International boundary (verify)",
      "lines": [
        "a}o}BotgFaQbmCi`@dvAcnAzl@_zCxOwyBoCgrP}iCcjTwmAqhCpLepKfsBg}BboA_~Mn{UiaJ||O}`Jh|O_aJh|Ou`J||OiaJh|OgaJh|OiaJr|O_aJn|O_aJr|Os`Jx{O_aJ~|OogHddMyx@lwAiaJl|O_aJx|O}`Jr|O_aJn|O_aJl|OiaJt|OiaJf|O}`J~|O_aJr|Ou`Jh|O_aJr|OgaJh|OiaJ||O_aJh|OiaJh|Ou`Jr|Oy`J~|OmaJ|{OiaJt|Oy`Jh|O_aJ||O_aJh|Os`Jr|OoaJh|OiaJ||OcaJ~{O_aJr|Oy`Jr|O_aJ~|OiaJh|OcaJh|O_aJr|O}`Jr|Oy`Jl|OiaJr|OiaJd|OqdI~qN{dItpNwdI`qNkdIhqNqdIjqNqdIjqN{dInpNqdIfqN}dIzpN{dIhqNqdInqNqdIzpNqdIdqNqdIvpN{dIhqNqdIfqNgeMduTciH`|MwhH`|MiiHn{MciH|{M",
        "}qzzBssbJcGrfCwy@xbCueQnfVazA~|@isMeD{}Ebe@qqDr}Ba`HxnKyxBbuFeb@reFccAlmBs_@hqBmf@|zFcnA~lGkfApiBqtBf_BkxEbbCcbApuAed@~pC",
        "itq}BkuwFrAxbCtq@twF|@jcC",
        "iknzBwutJkCphCelAdn@euB|Ta_Cv{@seAn`BwEvcB",
        "o`{zBadfJpMloB",
        "gdyrBs~iSmLvzAyWr}@{vArqCwxIfoJkuBt_HegAlcCsyA`{BwgBvnB_mCrgBuoB`HcnB{w@qhCk{A}xByn@uw@s^ur@_sA_eCsfCwiByZmqF_^iqByw@c}AgsBscAmcCctAkqB}mCi|@{hCbOmcBdbAa|AlnAsqB|u@mz@i@_{Bga@gg@{Bgu@nYkWh_@kRp`@od@|_@ycFboAmpF`Fkkf@srBstAfXwnAdvAal@n`By~@baFol@hfB}oGvhJwhIhvWatItpt@mL~uI}gBjyP{CzbA_YlxBwsBl`Ful@lxBm_@bvC_`@r~AybA~gA}uLd|FwhGheEckFreFm_Ht~Jk|@nkBw[~qB",
        "uswzBegiLhUvbCxwAtoCjcFp}FhcA`cD",
        "{{jzBcpsKeJ~{AsaCjhKid@t}@ug@lo@e^|s@kHhiA",
        "g`szBk{|JvVzvAt|A|hBn^xbA",
        "_vysBy{xXveE`l`@xeE`l`@rnBjxQtuA~qM|eElk`@lxB~mS?RltBlyN`Gd_D"
      ]
    },
    {
      "left": "SDN",
      "right": "LBY",
      "kind": "International boundary (verify)",
      "lines": [
        "}}feCycnwCjiW?~iWTtiW?jiW?viW?tiWRjiWRtiW?tiW?tiWTviW?tiW?|pQRhqQRpqQ?hqQTrxT?pf@?tHxDjHxDtHxDjHxD|@dMl@pLl@pLl@pL?xtR",
        "og`yBi{wvCMbo[EnzVYjiWSzbYE~`USfuO",
        "kj`yBeijrC?~m^bkW?zjW?|jW?tkW?"
      ]
    },
    {
      "left": "TCD",
      "right": "SDN",
      "kind": "International boundary (verify)",
      "lines": [
        "itw~A{ciqC}zDuhA{C?wgJ?wjl@Tyjl@|@yjl@f@wjl@Tckl@f@mjl@h@yjl@h@wjl@f@yjl@Twjl@|@yjl@f@mjl@Tsjl@f@sjl@h@yjl@h@wjl@f@",
        "i~b_Bk}~nC\\slUlnBuvVpqF_wU`FehD",
        "gwu~AqximC}j@guMscHksXouAeyK",
        "{|{~AkwklCrdEe`]",
        "mablA}ukeCqAnhGco@v`GshBrzE_{Bd`CceMltFooEzhDafAnYkf@{MqaEccBmqM}{C{}\\q`O_tF{sDqhEmuEe{@mmBceGe~S{eAifBatQ{_Qo{G{{E_dGis@{mCziAceG|{EetCjpA_wBxZsfJzBaqFtzAujJpmKaqFbnBqjC?w_BgKqzAhTo{BxaB_fC~pC_w@wFksFmwCcwRy{NmkAq|@}sCquCqtBesDulMe_^goAywBksE{fFulAcmCy^ifDew@ipCwiBa|AgvDkG}gEri@qxBdw@ubAbnBq{@t_Jmu@~fBe{A|iAefCzw@ciA`Qap@mEqiBqv@iYcZme@ssAk^u^im@mEoc@rUc`@~]md@tS__TlwAktAno@ekCn_EgfFvmCk}EqtBizDs{Fi}BwiGyfIwff@gl@}~@evAk]qv@~IqfEh}AolBza@_vI`r@e`D?w_Bmq@iuCscFgoBa{BefBob@atByDiwC}_@y`C_hA}|PirPcbBkzBgkAwmCmoA{rE_x@mo@srNuvGejCyn@{uUmnA_pEfK{aE`}@{oDheCikCvdCo`DrgB{rDzl@abEgl@{kCeuBygH{kNkuMynKylBmbDoQyxCwb@ahH",
        "eulhAajahC_nT{_DekAyDgkApCqiAbOiqj@fjMm~HvmEqkAzKamE_oCsmUkvHwnAtqAcjFn~R}~NzmW",
        "_}wlAo{ofCrdG|qD|{DzgEnaC~mFptApeH|_@dsF",
        "ajqdAeq`jCyY~|@i{D|@kw@lPqsCx_DqgDfvNygB`vEkrEn~EugGf~DsdHh|BkjH`\\gd{@y{I{{HomBcmBuQe`B`Fu]t^",
        "u|uhAyn~hClyA|s@",
        "gbshA{y|hCwq@hrA",
        "_uthAqfzhChj@dsF||BhuK`r@ncAtRld@xN`g@",
        "ussaAs`pjCunZ{sFm}@kf@mjByaB}bAmPc}BgBwzBuSeoBwe@yzEihB}mBwZotD~J{pAlDynMf}CmzLrsA}jAxxAuBrqC",
        "ghsdAcdsjCd}@|qQ"
      ]
    },
    {
      "left": "EGY",
      "right": "LBY",
      "kind": "International boundary (verify)",
      "lines": [
        "_|e`EahoxCnkGleKltE`nD~qOhdFxgUlv^heEzkAtcF|@xlOa}@d_OyD|zSuoCr}Bgj@zbK_zEx}HkpAduNsoG|zFgtAvvElf@luEr|A~xFplA~vIz`AnmLf|Dj{BtSdrEvy@nuEbyB|~M|kJ|eDf|DjyDfhDdvAlz@nuErgBhtK`bGrzEbcBfpF|@teCew@nsGkoDvrc@ayOnkCm[~zBvFzdIrgBdcG_i@vuMk_I``GmyAbwCTxcMdw@rpFgM`wE_}@xha@aeOznImmBxfJij@pbW?jw_@?nzlA?vblA?lgN?hwcA?vpF?fw\\?z{`A?~iP?~}c@?nde@?x~w@?d_x@?d_x@?d~w@?z~w@?d_x@?~~w@?p~w@?x~w@?d_x@?~~w@?p~w@?d_x@?x~w@?z~w@?z~w@?"
      ]
    },
    {
      "left": "GNB",
      "right": "SEN",
      "kind": "International boundary (verify)",
      "lines": [
        "ugjlAvhxrAaHlfdAsEfzq@kAtkQkHdfdAaAtuN_F|ot@g@npH",
        "mmklAlxv{AlYfrDjgAdaDx~F~iJxiDb{J~mFxjI|K~PnrUvhp@fk@lvE",
        "uc|jAzwn`BsTbwBe_CxeKmRz|E",
        "}lakAtteaBloAdwMbQhi@rSbZrJl\\",
        "cj}jAvowaBuGhr@is@~eC_KzaA",
        "cs_kA|l_bBrLp`AhdFnnLxgGrsNpjAf|DrA|yHvnAdeInChrB",
        "id{jA~s{~Ai}@vt`@sB~|@",
        "gf}jAvg_`Bpa@boN",
        "}tjjAhd|cBqv@bnY",
        "olljAlsvdBhu@tdFz_BrmC"
      ]
    },
    {
      "left": "SOM",
      "right": "KEN",
      "kind": "International boundary (verify)",
      "lines": [
        "uxgWkts~FhmVfjObmVnkOlmVzjOlmVnkOdmM~aIrmMrbIzlM|aInmMrbIj{Nz_Ot{NdaOj{NdaO~zNp`OzrExtEllDvxArmIeBndXwFjhYmGnnM?hxS?hxS?dxS?hxS?llW?~kW?llW?flW?~kW?blW?vhB?nbT?hlW?|kW?hlW?rkW?rlW?|kW?rlW?|kW?rlW?f_OaFxdLeDvdLoC|eTaHrdTaHfeT_HzeTaHpwLyDnwLyDxyMyD`mEq~C`mEg}CjlEq~C`mE{}CfnKmtH~|Kw~H`|LiwIfoJo|GflKorHr_LiaIhuKezH|uKsyH`uHsnFphCqjAfuBsUhfKnOv{BfD@A"
      ]
    },
    {
      "left": "KEN",
      "right": "TZA",
      "kind": "International boundary (verify)",
      "lines": [
        "zubEgrlnEdB{_BlbDiK|u@}rA`Q}fFrdGisMhlVs|h@rkVi}h@ntPos^xvDchItkVu|h@hlVg}h@f}CuzGjmQ_a`@hlV_|h@hlVs|h@hlVs|h@hlVa|h@tkVg}h@rkVu|h@hlVs|h@tkVs|h@hlVi}h@hjGu}M~`N_~Y`_HccOvxCq~ArdTmmBhqAqLzzVk|BjGtpBrt@`}@dvA|TvnBaH`HfuBlnApsCnmBnjCvcBbzApv@r^vdAt\\~gAdOz`AuHzl@gl@|KueB`p@s^jfBdX`yBtp@|tAaQ",
        "`ybEi||mE?c{MeByX",
        "ntlTi|wdFrJwdCza@wbCxw@euBboAgvAf_Bcn@~_KokBz~Bu}@joB}tAdsFksIj_KqtOh_K}sOj_KeuOt~J}sOh_K{sOv~JguOlaJojNz\\kh@t~JeuOt~J}sOj_K}sOh_KeuOt~JqtOj_KqtOh_KqtOv~JqtOl}JgqO",
        "|emTgqndFmPajH"
      ]
    },
    {
      "left": "UGA",
      "right": "TZA",
      "kind": "International boundary (verify)",
      "lines": [
        "lp_E_dzzDpv@}{E`p@mbB",
        "pspEmb_zD{`AmnAmkFo~Ecn@myA}iAalFwyBcjF",
        "`ybEkdd{D?wrK?swb@?_wb@?idC?_r^?iwb@?}vb@?kva@?s_@?swb@?iwb@?_xb@?}lb@?_I?_bW?itJ?uvb@?swb@?i}\\?uxD?yha@?ym@?uvb@?e_O",
        "lzmEii`yD`FqlA~]om@|a@g_@bOgb@",
        "bcoE}v~xDug@kq@",
        "punEscvyDxMggCdn@quC",
        "pspE{hfyDyDgjAcZgsBa\\gzH"
      ]
    },
    {
      "left": "GNQ",
      "right": "CMR",
      "kind": "International boundary (verify)",
      "lines": [
        "_~eLwj~{@uSr}BkdEhjKoXpkBuh@joBekBf}C{~BtoCebBboA{_CpLe`CaS{sBdDmhBxfA",
        "__fL_jbdAHjly@H`my@?jly@@r|ADd|i@BrqK?~gY"
      ]
    },
    {
      "left": "GNQ",
      "right": "GAB",
      "kind": "International boundary (verify)",
      "lines": [
        "ycbEccedAmdr@tHkdr@tHe|g@vF_gI|@ydr@tH{tNpAonFxn@",
        "}~bE_{e|@rAeiTjDy~t@LcoClEumy@lCcfk@j@ggMlE}ny@",
        "issDoeu{@_UmbBufAshAaqAsUaxDSkzA_`@{NqyBqVstD",
        "u~aEi|yz@jT{xDpb@{_B~gAkfBjxDcaD`oAkfBdn@mmBxOcnB"
      ]
    },
    {
      "left": "MLI",
      "right": "NER",
      "kind": "International boundary (verify)",
      "lines": [
        "iyu|Ak~kTcoUyy@gfDs}@sbIcbPgjOkgNmxBidF{zAwoNgzBwjFkwD_|C_e@mOsuDcnA}oFwp@maRew@irBag@wmC}}Ak_JujJaQyDmQ{Bae@h@aHUwGh@kGfBwFnCmwDnlAwkDpWokDoYmmh@wmPcmCi}AkzBovBolBsqCifC}nGcnAowAiqCkq@qqTfBkyOpAecYnCuiK|@qv@cO_|BkpA}_AyZ}dRfa@apBwFylByc@iSwp@gBqaAcy@irA_oS|@kiK|@ocW|@}cWrAqcWdB{cWrA{cW|@{cWpAaqLl@yqIb@}cW|@ucWrAkcWpAgdWpAiuVpAgM@ucWpA}cWpAucWrA{cWpA",
        "_cd}AkewQ`zBmhV|aEsvc@jiBkbS~Iga@hUiqB",
        "k|dzA}zaCaF{tAeh@okD_cAgqD_bAyuDu]a{\\{a@{hDehAmwCcyM{jO}pJoxK_dMssN}|JcfL_bBqgDgp@sqEyNqkM_SizQkS}zQoRizQkSkzQ_S}zQaSizQ{Rs{QiSizQuR_{QkSizQ{R}zQ{RkzQeSq{QiSkzQqR}zQiSizQkImtHoqA{a@afFS{qBiKo}@oNg_@el@sUccBuCwuF",
        "q{ozA{ej@bjEqwXb@qrE",
        "sh_zAmti@{uHpb@kyCsAu`Akq@",
        "wlozAupcBjoIgi]",
        "ioizA_rjAoh@meE{iCqsKaHubE"
      ]
    },
    {
      "left": "SOL",
      "right": "ETH",
      "kind": "International boundary (verify)",
      "lines": [
        "mecbAgp~dGzdCplAx}Ff~@xhBxn@`vAtgBhkBfeG~aBf_Bt{B`p@dfBpWv~A`g@jeBn`BrqDn~EhcBthAvvCjz@`}Fb{@`zBxl@xfB|iA~bAlxBvd@t{Bxy@jpAlcCkG~vGu{BnbGseDtjI}wI`zBg_BziDybApyPcoAfpK}sBl|JunDh`EwaD~_KovQptC{rCjxDmoBfkEmnAllE_r@daHovBtjDylDfzAscFpp@{{GbgBohFvgEovBjc^{sDruFssAztCsgCri@}gDzWur@x|@a{@~fCmz@rbAsh@hu@a{@rqA_}Bzv@ex@bzGwlCjoBce@rpEyNftBcZt`BmnAx`EgeIb~Gg`N|IgsB",
        "}b`x@g`diGho@cxAzrL}_NzuNclP`oUyzWziKusLjmCesFlcDgtNzsD_fPnsD_fPzsD_fPvsD_fPxsDiePpsDufPzsDiePzsD_fPtsDkePpsDsfPpsDaePhtDifPjsDuePlsDifPxsDkePzsDsfP",
        "ob~w@uc|hG}x@mwCoEccB",
        "knzr@kpxtGtnD{kOvnDokOnnDclOtnD{jOvnDqkOtnDokO~nDekOpnDykOnnDqkOpnDclOtnDekOtnD{kOvnDclO~nD{jOjnDelO~nD{jObcCuiKntD{mJHojP",
        "knzr@apxtG?I",
        "gyxo@u~g~G?oyZ?yj]?mw]?qmX?kub@ImyZ"
      ]
    },
    {
      "left": "SEN",
      "right": "MRT",
      "kind": "International boundary (verify)",
      "lines": [
        "_cqdBbr_zAcPfrBcnA|_AuyAnn@aJxDgsAtpA}a@`fA",
        "e`{dBjtkzAzv@njCjh@h_Axx@jg@nvAtRjg@zLle@t]b[ve@`Qfk@dCnm@",
        "mlodBhjyzAeM|k@a{@f`AufA`p@w{@nw@eYbyA",
        "iuvdBd|b{ArVbxAt|@hu@voApKrrAcd@h~AcdBtf@sSnm@fApb@xYxXtg@xn@vbC`eBd~SpBvcB",
        "_wedBh`mvAoXly@yn@tI{uB}_@mcAsAom@dY__@fo@yuCbkK",
        "}`udBlx|vAlFryBpUzz@~}A|bDlZx|@bPf`AlFzaA",
        "sdpdBbhxxAiiAlj`@",
        "}nrdBpsyyA|j@p}D",
        "ayndBlcdxAsJxcAkoAtnD{Mzu@",
        "}crdBxnmxAr@`}@ft@drElG`gA",
        "}oodBxtmwAi@tbAar@j|F",
        "idqdBzuwwAr@taAjfAvdGfAbdA",
        "sckaBvsksA}Kxs@ga@rw@om@rp@{u@jf@wz@v\\igDvs@uq@`^}i@bh@kgApaBk\\nr@mdAbtF{v@liBybBfVaoB__@ss@fAgw@nZylAn|@ug@vK}s@sJg_Bkf@sj@jCii@ld@u]nx@em@zyB{a@pv@i}BdlBwd@hi@}rBnnE}cIfrJ_nFdsEmdB`sCuf@lk@keCbiBa\\tq@iKdfA_IztCk\\``Amo@n_@wnBfGmo@bTyZp{@",
        "ukfdBxpevAtSnnF",
        "e`_dBxsa}A__@dlAmy@ri@u~@zb@ym@xy@aGr}A",
        "eqedB|hk}Alf@vyAnaAnlA|pExvCpu@`{@pb@hiAtGh{A",
        "iobdBvfa|Agl@xfH",
        "q|cdBpnj|AxErgEhSn`B|hBffGhTxvA~@`{A",
        "sgtcB|az`ByNblCcz@r}BekB|hBokBpjAem@dm@}`@nx@yMxmA",
        "ej`dBtymaBzKfjAh_@tfAh}BvvDv[r~@fK`fA",
        "uuycB`k|aB{CbeAae@tmE",
        "s`{cBz_ebBvZlmCnmA`dCdkBhrBftBpuAftBbn@hxFr_@v``@x~FhhAxYr~@jf@~|@p`Bht@peF|jAbzAr|Bdl@`fLxZ|zFnkBbsGfuAvfAbd@ngTzMrwIj|@niFhlC",
        "orxcBtk|}Agt@lkG",
        "wgzcBbxd~AnMf~Afk@~hAlyBdiC|s@fuA`]j{AbD|~A",
        "ctwcBn`y_B_r@hyE",
        "cgycBxz_`BtHdwApiBtvFtGdm@",
        "mzqcBb~v~AeWz`BybAprCeN~s@_JxiEmxAryG{CxbB",
        "}nxcBxqr_BxY~xC?ts@",
        "ejucBzxk`BoBlf@a^voA}J~r@",
        "uxvcB`eq`BvFxm@hUfk@t]pk@hSftC",
        "{shaB|ulrAmFrj@aGvL{a@~g@aHfPeMhe@uGdNaH`GiUtHsI|EaSf[oWv_AyPp\\q`A~RmqA{Z{gBqb@aoAwKyEvz@",
        "ibyaBzuvrA|A~x@xM`v@v\\|s@zj@dn@tzC|mBfl@ri@|iAvcBbx@jeBlPfp@zCvq@",
        "ugeaBdajqA}h@l~@}_BmJ{|DygBevAlJcGjh@",
        "woraBdajqAh@tb@hIpa@r`@`tAxbAbhIlnAr|DzLhn@hA|TRltBlF~b@nwAdjDrIxg@",
        "omj~AnoxoAkzCbz@ss@`Hqv@yEuq@}UanCm}A{l@_J{l@bF_s@xYcdBdfAqj@~h@yd@`q@gu@p~Ag`@xj@si@f_@it@fG}s@{L_t@ySss@{LywBv@qiB`]g_Bnv@}~BfpBmd@rY_i@jLkr@?qhB{Vit@{B_s@vLco@nc@gsBv|C}u@zu@wz@dn@}_Adg@qqEzuAco@pGolBhEco@tN{k@rd@aoB~jDoc@x]isAfq@g`@~]gAb}A",
        "{}gaBh}bqAduAzbF",
        "{lo}AtmtnAyn@h~DyYzb@ix@~Tct@rJmu@XcjFgb@_wAvMohA~k@qz@zaAgk@dmAyd@znC}Ptl@{oArrBwPzk@{CbzA",
        "apk~A`vooA~^nzDpA||A",
        "e|d|AvwlmAiOufBuuAw`@geBng@qpArnAguFfsJinAzjAa_Bpr@}dBtVgpE^mo@xJ{m@`[goAx}@mi@tSykDdXgu@fRkm@jf@qk@bbB",
        "you}AbefnA|Kz`Bpp@zzAr_AtqArw@n}AdJrxA",
        "uqe|AfmsmAnTotE",
        "gl{{ApnjmAc@vz@aRpv@yh@lu@wiC|mC_mArd@um@s~@",
        "mvb{AlqmlA}cAbfDglD|wDkm@pp@}o@l|CyOfFuw@dRgp@fCq}Cw`@kr@f@}n@tN}i@v_@ie@zw@mP~}@",
        "gg|{A~fdmA?~`A~YpdC",
        "kvdyAxiziAagGpyIesDdhKyxA~lB_sF|qEaq@duAibApBuqNtpC{{@t\\sz@|t@yb@taA}_@hqC_e@jaAaoAdlBodEhwI_bBtoAyn@hp@{Rfy@",
        "_he{AtfblAfMb_Bry@rdEbGl_APpC"
      ]
    },
    {
      "left": "MLI",
      "right": "MRT",
      "kind": "International boundary (verify)",
      "lines": [
        "ezpwC`vl\\^bgj@Rrfj@Thgj@Rrfj@^|fj@R~fj@Rfgj@T~fj@dqNw{@dpNa{@vpNa{@~pNw{@fpNk{@tpNa{@tpNm{@zpNk{@zyNmz@pb@eC|aKel@lqYebBjqYybBlaK{k@hqVewAhqVewAhqVowAdqVcwAlqVowAdqV{vAlcDiRnlQedAhqVewAdqVmwA~pVewAbqV{vAnqVowAbqVewAdqVmwAlqVewAdqVewAlqVewAzpVowAbqVcwAnqVewAbqVewAdqVowAbqVewAdqVcwApmJui@ddXi}AddX}|A|lJsi@jaTenA|kWayAhlWoxA|kWayAflWyxAxkWcyAblWmxAhlWoxAblWcyAH?H?H?rzYg}A|kJkg@nkJwf@rkJag@nkJag@zbQs~@rbQs~@pbQ}~@pbQi~@|bQi~@pbQs~@rbQg_AzbQi~@bbQs~@`cQ}~@lbQs~@jbQs~@|rPk|@rrPi}@zrP_}@fsPk|@rrPk}@zrPu|@rrPu|@|rPi}@zrP_}@|rPu|@rrPu|@zrPk}@fsPu|@rrPu|@fsPi}@zrP_}@|zFcZxbB}u@xbBgu@~cDcuFbxC}dFvwDctG~cDmuFziDc_GhfDiyFh^_]~^a]~f@mE`g@cE`xDdb@`nQhqBjnQ~pBjnQtqBjnQtpBz}QptBp}QftB~}QptB`~QzsBn]dEnVjCnFl@p]xDt]lEl@?l@?^?f@?r@?^?\\?h@?R?^^H\\RH^HH^\\RTT?f@?r@?R?r@?h@?h@?\\?r@",
        "omq}Avmku@Qj~PA`_BGl~VAjvEIrz`@qyPcf@_jLgtA_iEjRg_AduC",
        "q~x~Axlbx@piAvxB|zLx|J~dDtzA~tD^jjKybBH?`yI}iAt|@lno@z{@joH~r@j{BzhE~`Jnx@~mF",
        "cxd{AxzraA{qHjlE{|EfgFqdIbkDk~DbkEgib@~jp@{_C|sBynXbbQmcC||Cwz@hqCufAddJ",
        "spn~AdbheA|Ddw@tDlQhYuIjRmOtNiTnNeYb^eMx^{Cd_@zC~]dMd|@pv@p`@~gA~n@heD|x@~fB~dFz}E`{AxuD",
        "gow}AvfafAiK|eDos@~eD{BdYkVf}C",
        "ikz}AbmqfArtE?hcAxMrgD|}CffE`oAt|LzaBdsL|oE~bBzXbhHxb@fmIztBxaCzNxy@oDzuAkRf_AxD|zFrgAr{DzMr^~Ibk@u|@",
        "olq}Aviur@UzbYIptO",
        "omq}Adc`t@?rrN?nnM?lfL",
        "siq}Avgxj@S~m`@I~m`@Ife`@Kxt_@Ir{^Ohz]M`p\\",
        "olq}Axjyq@?|}Z",
        "ufq}Axxfc@ExdMOd`NIdcYEzfRCxuGIjp\\I~y]Of{^Oxt_@",
        "siq}Abawi@?re`@",
        "{`q}Arys`@UfAS|@S|@U|@M|@Y|@U|@SfAInu]IleY",
        "ufq}Atfmb@?lhK?tgL",
        "{df}Azxd_AuWvxB",
        "q}f}Arrh_AxNjfB|cAtnEnDlOrPlzB",
        "kje}Afph~@o_@vkDiIp|R",
        "euf}Apza_AhOh}A",
        "ke_}Ap_j}@Ipu@knEpuOyJzuA",
        "{`f}Apc_~@nUtkH",
        "uqc}Apuv_AwA|cGgw@|wJ",
        "ule}Alsj`A`D`dBd`AxcA`vBpVzaGwFlbClp@xm@bo@`w@`dBpdBbdAxHhs@?~}@hVxbAj_BbdBzdBzk@heFj{@rhBleA~yCfgDrcB|t@`cJ|~AnhBzv@",
        "u|w|Arim|@cFd}Fci@tpC_lCjbFqz@p~BqBbo@",
        "az_}Aplf}@tS~qB",
        "kdy|An_`{@e~@vrU",
        "qc{|Afsv{@zeBjuU",
        "igzzAfbfgAxx@_hAbeAem@~wAyOxpBfL^?x`Bdm@hnBr_@f`F~^be@eDt\\cPjx@gj@dg@KhTpb@rJ|j@~HzWv[hT|_@|^di@r_@hx@fWtqAjp@nmA`|A`z@~pBxs@pzFljAnxAbeE|rCxhAnlBb`@jyB",
        "e{xzA|sigA{M_h@g\\_`@?uf@",
        "_y|xA|nthAeb@bdAycFzfGip@~}A",
        "irfyA|zaiA~TjdCt{A`lGbPneC",
        "onbyAzsriAiUphCqp@jkB",
        "cjbyAd|hhAO~{BmZfsB",
        "afcyAlmphA|_@dm@~`B|_@biAjq@"
      ]
    },
    {
      "left": "ZAF",
      "right": "MOZ",
      "kind": "International boundary (verify)",
      "lines": ["rhzbD}}dcEqb@dvD", "tc}bDkxmdEur@j_JoaA`fMoEzsD", "~fybDa|ncEr`@b}H", "fkzbDwlwgExXle]fVflZhTlfX`QfxU"]
    },
    {
      "left": "AGO",
      "right": "ZMB",
      "kind": "International boundary (verify)",
      "lines": [
        "|lebBgwkeCcDg}CoqItxEohE~dDafCfMwcB?ezJ?skK?mPxDgyGi@e}RSq|R}@q|Ri@g}RScrG?i|D?kcC?uwF?yl\\Ryl\\Ryl\\Tyl\\Ryl\\Twl\\Rom\\Ryl\\Tcl\\Rmm\\Rel\\T}vJFouPJyl\\Rmm\\Tyk\\Ryl\\R?ahW?chW?mgW?mgW?mgW?mgW?ahW?mgW?ahW?chW?mgW?ahW?ahW?mgW?chW?wfW?eiEkbFrhAieEpiBqrDziC_vIlsIanDf~BggEzw@mvFkh@sxGmxBelM{uBkrLkoBgsDqjA}uK}yG}mHgrEqiB_r@siBmPsxGj|@w|JxXs|C|~@waDf}Cy`EtfCuvG|_@qkZ_i@{cXmd@goHkeCi~@iIwxC`\\_rMlYcvCrt@{uBf`AywBxn@g}C?kzB}_@ixFcnB}eGclDshAcZmdBSouCbOymA}@cdA{M_|AybAouCubEssAa{@}iAzBizQxrGq~Cbc@cyZyXkR`yBquApb@}oFyZgyIdDwnBsUcwB_g@wzAfVawDlxB}hBjf@yqHri@",
        "xgebBedjeCbDar@",
        "vzvdBo}xfCm[rsAwfL`yOgtAtg@}hBxOmyAbZwe@xbAoNnvBel@zXebAeOitAoCwxAza@wlDfjBqlA`\\sgBeD}sB}_@ylBur@aoAcy@emAiKom@veB{l@~nEmd@hIgiCfBu{@hIyZhTi~@|iAyc@xZuzAvZonA~IymApUyvApaA",
        "n_ajBurslCa\\zjBcmAfkAexAzBo`BqLccB`QebAf`AkfBnsG{sBdtCghDvxCayDduB}fDlo@afAnd@umG|cGup@lyAemAxhHs|CfxJqiBpgDkwEtwFccBlaEebA`qAk{Aby@ibHbdAueDxvAmbDr}BscHjwG_}@dvAipCtsJUnnAcZxc@qt@lYelBSkq@|KmnAlnAmz@tdE_t@vxAmnA|u@unDnaActTxcMgu@lo@s`@dy@aQbcByOza@md@p`@}iAri@q_CdaB_qAjh@mz@j|@yZreDeMpWmo@nm@mPj]",
        "netdBgt`gCrJhTjRpUdMb{@za@h}AdDlo@",
        "bptjBivumCwoAnb@aoAdDyxAqk@upBvmCeiCptByxAz~Bsi@j{A{X`zAcOziE",
        "dk_jBus}lCdMpiBnYpiBrJzjB"
      ]
    },
    {
      "left": "NAM",
      "right": "AGO",
      "kind": "International boundary (verify)",
      "lines": [
        "bipfBudnoA_qAfsB",
        "bwmfBmpjoAjGhgCnm@bmC`pBv~S`wDxgIti@`bEby@lxBjf@ftCv{@j]jeA|Idw@zXdc@fu@|_@bnB`Svn@lo@nx@`zA`r@~s@hh@|~@nsEz~BxtGprDrzEdy@ptB|Tp|Cjq@bxCxhFtvG|iAxvCnExmA",
        "hvsfBeh|oA}@fiAiTdkCi_@dbAu{@hh@qb@zl@",
        "n~nfBkwpoAri@tqA",
        "l`jiBqqitAyZhpCmcA`zAopJx}G{`AdmAgzHdjQu`ItxQyoLvbPe{GhsO}qDc{@aeBhu@_sAjyAwuF`qA{tA~{A_t@naCmPpsC}_@vnB_qCh{Ewe@hqB",
        "bipfBebqpAh[~mBze@pwC",
        "hlrfBszhpAgBjf@mYri@",
        "rnqfBshfpApUf_BjgAp~C",
        "pmtfByh~oAom@?",
        "`_sfByh~oAfVr_A",
        "`xugBmabiAa}@luE_g@r_AgBpk@",
        "vnrgBy}whApLxc@hI|j@nd@j`HvoAx}GfsBx~FdtEpeHptBl_G|iA|qBjq@zc@hh@pLbZr^`Hj{A",
        "ffchBocviA{XrSwy@lPyy@v\\mYlz@oNz`Ayc@leA_i@h|@ga@za@cp@pWwn@jIsi@xM}a@`g@aQnx@",
        "h{sgBmhfiAlPj]l[p`@zM`fA",
        "liehB_askAmo@z{Ew\\|mJce@ptBssApsC",
        "n`_hBakxjAzBr_ApaAftAnb@lyA",
        "ljbhBwzpjAeM~sK",
        "f|ahBwedjA~h@faM",
        "tfkhBudagA}KdbAqv@nkBoLjrAIJ",
        "zbciBobxuAU`fA",
        "dbciBm{uuAt^xD~zBvy@tSfiC",
        "bdciBqviyASzbq@Sfbq@",
        "zbciBmoevA?~iL?|@",
        "`fciBidr_BShbq@ApdAQt|n@Ufbq@",
        "bdciBoz{zA?|bq@",
        "vfciBanhdBUfbq@",
        "`fciByjvbB?raq@?zbq@",
        "~gciBcy~hBEp_PMhb`@S|bq@",
        "vfciBiqzeB?fbq@",
        "|iciByfgoBSzbq@I|kYIhuVUhbq@",
        "~gciBk|pjB?fbq@",
        "n|wkBs}asBaoCznXwiGllPqv@zqFafA|tA{}Ct{BchJneJag@`{@gu@rrByw@lz@{w@p`@mmBt^{l@~RubGdeIgj@jrAcdA~RynKluEui@ftC{K`Qs_A~ImkFteBs^tg@qWtg@cy@rUce@`H{B`p@",
        "|iciBytqoB?~lI",
        "prhiBspouA}j@nsG",
        "rfgiBc|fuAzMri@pv@daBjRlcA?hiA",
        "l`jiBq`~tA_^jdBeOtfC{a@hqBwFleA",
        "rfgiBwzptAdMdw@j|@lbBfMplA",
        "bptjBivumCdaBpiO|oFvzf@rpFvzf@fqFxzf@|oFj{f@t_Hj_p@v_H``p@b_Hj_p@v_Hj_p@tqAdaMh_@|sB",
        "p}tkBsjetByc@`yD}@jeA",
        "xvskBej}sBbZjeCvoAxtExXjoO",
        "ld_lB}epuBg{Gx_^_}@xaB",
        "djtkBibntBjRtvG",
        "peelB{otwBwFxaB}j@toC{w@z`Cel@xw@koBdw@u^p_C",
        "v{{kB}hawBfMvmCxkA|bJrLho`@",
        "peelBoxl{BkcEdsFeXjgA",
        "~g~kB}{b{Bxc@roEdDpuA",
        "~q_lBwtyzB_i@dbA",
        "~g~kBqqwzBjmD~wE",
        "lhflBc}gyBkGt{@uhA~yE{~BniF",
        "nv_lB}zwxB?tz]xXjf@hsB~gA|_@~]",
        "jvclBqxpzBwy@hrCwFhfD",
        "zsalB}}fzBld@dtCfkAvzA",
        "peelB_m_zBen@nm@",
        "jvclBo~}yBnd@nwAfKjpA",
        "pvwlBiuo|Bce@vmAq_CzsDueBbvEmo@t}@e`ClxBewBxkCq_ArzC",
        "x~clB_zq{Bve@n`D",
        "bhelBstxyBqAdjD",
        "peelBmisyBza@hkJ",
        "jm}lBwbpaCuJpb@o_C~dB{vA`yDmxB|bJouCpzG{VvcB",
        "namlB{zn`CbOd~F",
        "rqmlBu{f`CcOlyA",
        "namlBgad`CjRtpBxl@piBpW~fB",
        "f{olB_}y_Cgj@`eB",
        "~onlB}vv_CxtCn`QfV`xAh~BjgNhdDpuAxe@llEz`AjxDzKz_D",
        "r{{lBqjn}ByO`eBsi@jfBis@nm@ks@nbBsS`aF",
        "zbvlBai||BrJbuF`g@r|C",
        "fw`mBwu~}BqtB~eCuzAr{DyZ|hB",
        "djylBehq}Bpv@bn@zXnm@"
      ]
    },
    {
      "left": "NAM",
      "right": "ZMB",
      "kind": "International boundary (verify)",
      "lines": [
        "`o_jBga~tCwFzu@ob@nbBye@fu@gj@ve@{a@jq@cZ|}Cew@duBs`@hzDazAdgG_S`pB",
        "zjsiBymzsCxMlmB`fArdGrUjq@",
        "jwviBkgmsCce@bdA_JviIwOfsB",
        "nutiBgc}rCjGjqBdc@twD|s@ljG~s@ljG|s@ljGhs@`kG~s@viG|s@ljGjs@ljG|s@`kG~s@`kGhs@ljG|s@ljG~s@ljGhs@viG|s@ljG~s@vkG|s@jjGxc@`yDrAptB~h@~yEvn@n}F",
        "fu|iBsfjvCqLz`Aa\\ri@a\\~]qL|_@kpAptO",
        "rnwiBsdtuC?~wGjRv{@ri@fj@ri@r`@nd@lcAtqA~}AvZz`AzBlz@",
        "rydjBesewCcnBlnAiiAteDirAplL",
        "zl|iBoopvCjGzgE",
        "jgjjBakswCgBjz@ufAnbByaBtfA{C`Fkr@~iA",
        "jacjBmriwCfw@f~B",
        "vr_kBmwixCsi@bOsi@~]q`@pk@}Knx@a\\rJcwDhs@}ItSq`BtpB{VlPU~gA_Hfl@}V|_@wn@ve@ij@?qiB_i@uSrU",
        "nyhjB}_ywCtH|~@dc@|sB",
        "dlrkBspdyCymAjf@ydAbdAap@rsA_S|tAeD|hBkRnm@kfBvoAgVp`@ob@leAoYbZec@tHmnAcFob@jRa|Aj{A",
        "bi}jB}zlxCrApk@~eA|u@"
      ]
    },
    {
      "left": "ZWE",
      "right": "MOZ",
      "kind": "International boundary (verify)",
      "lines": [
        "vft`Ba_qxDuqLvFakV|K{qQtHexN`H",
        "veqaBilq~DqCfVih@bf@cy@tRox@bZsi@~|@__AlxBouAnmAgrEftBqkBbxA_fAteBsi@fuBkpChyRuSltG",
        "rks`Bc~{|Dt|Ar{CzvA`r@",
        "xp`aBauc|DeMhgBocAj{AkfBxcBcjDzzFgw@xtG",
        "jss`B{yi{DpC``T`Frz^rAr_MbDn|T",
        "day`Bmnu|DsAbn@yc@lp@}Kft@",
        "xlw`Bsxp|Dzl@vzAr}BrrBt{@~gAxy@djC",
        "z{jcBmwkbEccBdhSom@nbB_~Apu@_nFt]mmBzu@a{@hiAmcCfeGobBxwBenKnyJ}gCxjDoaAvxCebAfr_@srB|oF}~@r|AoPt{Bg@~eCoNbyBcQrJi]mGa\\s@eOl\\",
        "nwpaBqvs~DpAdXtJ`p@",
        "~l~dBuywfE[fA_Mxb@wyB~dDwuFt}@_oCnCyxA`]i~@veAaaH~jV}_Kf}]_yF~cSkgAzjN",
        "b~icBojrcEv\\`re@",
        "likoBg_jhEyuDmbCoaCgsDcdAk\\ovBvo@cwB`pBaaF~bHmcC|}Au|AvZsr@}Iyn@yc@uqAoo@wdC{v@om@eCumEjSucS|zEykCpLkzBq`@st@yDevAnkAwy@~Hwp@s^_^wp@_i@mo@kpA{WomBrJ_nD~hAcyBtHayBmP{`Cag@sgBocA{l@ifBaeBq~CscFoX}pGjQsnF{V{fFkfBewBqWe`CzXylBztAueBniFaqAdlBsr@vZgrEz`AcdAT_i@ag@q`@gu@mo@ug@ijMotFebCwwAqi@y[eaBwe@obBdDov@pj@}iAfjCij@zu@_{B|_AigCpVm}@dAwgFbGs`KhtAmgJd_Dw|L|cG}zQ~`Jag@jGedLg_M_{BeaB{gEgjB{qSkoDqrDgj@",
        "bcydBedfhE~GzkA~h@~fBhqBhzDbZldB",
        "pc_eBqnwgEgK`cE_qAj~JsJtbE",
        "ty{dBmg_gEnNz_B|_@fvAza@rt@",
        "|dkoBomihEnCwP",
        "p|tqByvpgEqLwcDirAekBkeCebAgfDqj@wmE}KoiDlo@ibJ~zDc_F`oAq_ChTghBoNitAolAsi@gjB}_@yuBew@mnBwdAwxBk|@ihCwoAknBs}Bkh@}~@|TyxAnnAi|@~G",
        "zitqB_whgEtQy~F",
        "dccsBekvfE{B|sAgVteAwp@lp@irAdNmnAiIocAhIojCbn@{kA_Hks@w{@si@aoAwn@{aAwp@nmAwzA`g@epIfj@ew@uHwkGkxQmYg|D",
        "h`{uB_|cgEeDxvBgiAfaAq_C`F{|Fkf@mvD|Kk|@{MgzFehFgiCczAsgBup@wnB_UkyCmEoeWotDouEtf@k|@ts@{j@ly@mo@lp@{kA~]_hAdMsi@vQm[dc@oYxbAsJnkB",
        "rkasBmobgEpv@fcK",
        "zvdwBcjsgEcF~nCqW`pBybAjfA{iC~Si~@_Sgu@{c@a{@mYkpA~Gk|@pNox@z@ecMqk@}qB|@ufCri@a\\zvA",
        "vrzuBumggEpLtpB",
        "`ogyBmvmhEoo@bQ}pCld@{lMsUeoJwwBw`GuHsqCii@cwBwRcdAt}@}u@piCwoAteCccB~fBylBtr@eqFur@s}B`Hmz@`nB",
        "`w|vB}eahEld@hsBptDryDxc@zkC",
        "`dgyBygchE~IsmI",
        "|po|B}{~eEsi@mjGmbDg}CivJckEyfJkcEywMutKgcIwtGcoAmo@wxAga@g~Dqk@wp@fB}rA~h@ij@tFu{@qL}rCgtA{_B_^goHom@ew@{w@cQudBa\\ebBwxAmo@g~Dec@keAgtA",
        "tnn|BmuueEfa@oeH",
        "rod`Cm|qdE{B`[kgAfw@st@vyA{u@pa@_eQebN{zJ{zH{pG_qC_nFwe@ehS|tAc~SvxAkaGgKohG{`AioFadE}_@inG",
        "nyaaC_j`eEi\\lG{YvF}xUjfMoWwFga@gWmf@}U}h@S}KbQ",
        "hnd`C{wrdEh@lZ",
        "pg}`CkxxdE|pCspF",
        "jnugCwb~}D{eIuqNukG}uK}nI}cIwrIofIwrIcgIyrIofIksIofIyrI{eIwrIcgImsIofIwrIegIwrIofIyrIofImsIofIwrImfIwrIegIyrIofIwrIcgIwrI{eI}xH}mHcjFe}E"
      ]
    },
    {
      "left": "AGO",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "d~yb@moqtA{a@~{AitAztC}gAfqF",
        "`}sb@ijbtAxbArsYhrAdj_@",
        "~u~b@}pdcByO`eBmeAhgCymAxaBe`AzjBi_@p~C",
        "lnvb@itqbBxD|mJ`H~yPzE~sKxAvcDtHjyPtHvxPtH~yPtHvxP~GjyPtHjyP`HjyPtHjyP`HvxPtHjyPtHjyP`HjyPtHvxPtHjyPzBliFxDn|IhpCnyW",
        "d_yb@ucpqA{w@bwD_HhrN{BllE",
        "lyvb@yjtpAj[hh@tfCr}Btp@bdA",
        "do}b@w}lpA}fB~cEg`AhcGqk@vnO",
        "lyvb@udnoAFfE",
        "dtxb@ojgrAis@nlN",
        "z_wb@_}wqAfKlz@xn@hqBfBpjA",
        "t`~b@etbwAsJztPiKvjScOvyBoaCnpJcOjnC",
        "~exb@}vhuAdw@nfV",
        "p}~c@y_jdBkeAjRcgKdXcy@rJ{`A~]ymAb{@ag@RyaB_sA_t@sSiqBzfFeXzl@s~AlkFoY`nB{BjoB",
        "zz{b@{rqcBvQ`{Bxy@fgEpLr|A",
        "`g`c@y~}wAwQb`EwcBhlK",
        "po|b@kpkwAbp@d{G",
        "j_df@{a~dByXhh@{w@pb@{V|I}oFyBu}@}VkRgu@oCox@sUob@_}@mGk|@pLcy@`S_t@tH}hMzBweBoNmnAqk@uqA{Mi}Apv@kzBblB}rAl[kh@dbAyXhrAwe@~gAkpCpiBew@rjAgK~zBcxCwbC_}@zV",
        "zt}c@ivndBvFpv@`\\vy@zBdc@",
        "tucj@ivofBigCaFqiB}j@q`B{VylBpt@mo@|_@wp@dXae@xe@{MtfAcZpv@yy@Rwy@}T{X{MedJbn@axC|iA}hBdvCoN`fAqNnuCgVxbAoaAhgA_sAdZazAhIwzAzV}~MtvIaeBlo@wnBvZqeFbQomBbZgpEtzAmdB`SelBgVy`C{kAa{@gBafAdw@mz@r_Acy@jf@meArAazAwg@yDtfCk|@?quA{w@kpAcc@kpAzKmG|_@",
        "hvcf@gk_eB`Hjh@",
        "zbnk@k|f|BorHbFogHbFibHwe@atIcbCo}F}_ByzL{hDm{J_qC",
        "vwei@ytx|Bh@bhJf@~zO|@piOTxgI|IjgAtg@rr@h}Alq@xxAj[`mExZlyAU?jkH?pfG?feG?feG?feG?|eG?zeG?r`E?tcA?zeG?feG?feG?|eG?zeG?feG?feG?heG?zeG?deI`wF}qBnaA{MvcB`g@txElkDrrBjgA|gEj|@xs^xbAheEkRnuEmo@h~KaeDx`EzBxkCtpDpAbDfBdDzBnCxlBhtAxsFf`At|AvxAvZbwB",
        "``bj@anifBrt@ggE",
        "hhil@okngByy@nwA{tAxc@iuCh@acARi}AxZs}@xbAolAn`DgtCdrEkq@hfDgiAvZ}_B?eaBdOmlCjdBaqAzkAyc@v{@st@h_@qmIsJ}wKz~Bi{C}K",
        "brqz@gk_eC{qFnwAozKrkKmtF~yCicGf`AmcPtfAo}FzkA}~@~h@g~B|hBocAnYymAmGo_Ce`AuxEag@qdKe`E{eG{`Ac~F}@qsRfkAujUyxA}cIzMwoNar@ouC}~@umEyn@ij@{j@glKs_A}hMshAi|DybAggEupB{Bbn@}IdXqLjR_Jt^s_NqsCcrGqWckGvp@eqF`xC}}CjgAigAs`@uYip@_Xgm@srB~|@spDxuDmoB~q@whHdbAyiGdMghBbQ_sAbe@otDp|CmmBzbAk|Bhh@wvCpLkgA~h@mmBjcEkq@t{@cnBl[uhLbQa{@uSkzBmyA_hAuS_hAvFo`Dlf@oqG{c@weBob@ieEcdAojCap@seFcoA{rE_hAe{Bsj@}nAa[gsBsJyc@uSwzAazAwn@uSejF?_}@dOea@rSye@fMcmAqCafAsSs}B{w@aoAsJec@dMox@v{@ec@dM_^aFyw@i_@ce@cFolAnNom@xc@}j@|j@meAdc@ga@}Kqk@_^ur@oNcy@fa@ag@za@kiHxkCen@lf@k]lo@eMtg@k]rU}T}@{Bz~B",
        "flmk@a{ycCf@|pEh@beMh@veMf@jfMh@beMh@jfMf@veMh@ndMh@jfMRbeMh@veM|@veMRveMh@veM|@`eMRxeMh@veMh@raH",
        "vx~m@svohB{aBzMsqCyDkdBt\\qtBgVk{A`{BmwCzoHufC~{AujH~fB{kC~rAqt@vy@ce@~s@ug@`g@mz@xMiiAq`@ob@kgAqWshAwe@q`@el@fVc\\xw@ea@`dCcZvp@{Xnd@",
        "xdfl@icqgBrJld@zvAjq@",
        "`lgm@i{puB{a@nnL",
        "difm@ykcuBlbDhKhfDar@ffD_fAdaDoo@bvCqAlbDrUh_KjzBjzDlz@b}GtzAvbEbQd_DkRvdNkeC?niD?v|W?b|W?v|W?n{W?lsG",
        "xdao@wqjiBen@tSaoAgBmeAvQ{Mv{@SrqAqLhj@ew@cy@si@?i@xuByw@j]qlAcDwy@tH_^~|@uS`oCq`@j[gw@|VccB~oBaoAr`@ew@sUyy@ag@{u@h@ij@~fBcZcZgB?}IpLyn@pL",
        "xl}m@ssrhB|j@~{A",
        "ptqo@_xriB{l@jRmPpLcQeBom@w\\{`AjeCug@dw@kh@fVgtA}_@cy@cy@qv@gVaoAtfA",
        "ti`o@ylmiBbZ`zA",
        "`hlo@crmpBSzaM",
        "lglo@go_pB|s@dkAlxB|KzhFs`@nClzB",
        "l{yo@awqqBqsCz_B{kAxe@unDt\\ga@zu@",
        "`hlo@yzjqB?t~L?~gN",
        "vvlp@gpljB{tAn|I}u@lo@uB|@q{A`p@gqD_hA}hB~T{l@~q@meArhCcy@h~@u{@|_@_fExw@",
        "j{no@sluiBj]`\\t^be@bZlP",
        "xw|o@_fboBeDvoAcxAxhFsJppHaQjqM",
        "x{xo@og`nBdMvcBxwBd~FpWf_BxbAtpB~nCby@xlDbF|{Cag@hK`oP",
        "ddyo@i|yoByD`e@",
        "j~xo@gvxoBxD`~JzM~fB~gA|gCvZf_B",
        "ffop@kh|lB{c@reD_mGb~HyvA`wDsUtoE",
        "|dbp@{y`lBtSjdBnsEzcKtHzkA",
        "xwip@wbokBymAzrE{M|zD",
        "bzfp@}rbkBlxDjqOdBhoD",
        "p{h{@_vteCqb@~|@_}KbfJanDpjAeiErJ",
        "v`oz@uydeChTxe@jf@z_BtSve@",
        "rdtcAghvfCw~FyxA}eG}TsfP~gAeuBtg@ovDrgB{jBhTi]`S}`AtzAs^`SkmF?ssL`dC}_Bxw@ueBh@}gC{jBq_CipCaoAmoBgjBsdGgl@_zCaQ{uB}s@k|@ovBaQunF`QkRuHce@q`@o`D`eBg{EnNobC_EkyBsDegG|TcbClz@uqAnlA}rAt}@adCpL{`Csi@m`FekCi}Ak]}~@aFwyBi_@afAcFigAtSmmB`zAs{Drt@y~FrqC}dHbnB_xGvxCy{GhqB{iEgj@olAh]qfG|u@utIz~Bg{Ejq@{iCxn@{aBftAyvCrpFcxA~fBga@bdA",
        "v`g{@onweCfl@pk@pL|j@",
        "|njaAschqClx@ptBj|Bjq@zrCxZ~|B~q@fu@xy@nlA`dCvp@lz@h~@ld@njCxn@lz@~h@pjApqE",
        "rxdbA}~noCqN~nEuoCloOqiBzcKuSzqF",
        "by{aAwfdnCfMd|FfiApfGtcFf`L|vJ`mTftAz_O|hBdrR?tvG",
        "|~hbAw_npC{l@~xFuoA~aGeZjmF",
        "dedbAktvoClRltF",
        "|ivbAk_viC}VfqFoaAtlFk{AdhF}|DlzM",
        "dujbAyzphC~_@tcF|rNrdE`xCntD~nEhpRh~@`zA`aHpqGtfA|sBjGz}C",
        "lmwbA}fekCob@hoF_t@t{BuxCbjFqaAz~ByDftC",
        "zrmbAuyijCncAnjCf_B~eCziAxbClf@~bF"
      ]
    },
    {
      "left": "ZAF",
      "right": "NAM",
      "kind": "International boundary (verify)",
      "lines": [
        "`navCas}xBdmA}@b}I?v}I?v}I?`}ISv}ISb}I?b}I?v}I?v}I?b}I?`}I?x}IU`}I?v}I?v}I?toA?llG?b}I?b}I?v}I?`}ISv}ISv}I?b}I?b}I?v}I?b}IUv}I?b}I?v}I?`}I?v}I?b}ISb}ISv}I?b}I?v}I?`}I?v}IUb}I?v}I?b}I?b}I?v}I?v}ISb}ISv}I?v}I?l|I?b}I?v}I?v}I?b}IUv}I?v}I?l|I?v}I?v}I?b}I?v}I?v}ISb}ISb}I?v}I?`}I?vuF?lxDtH"
      ]
    },
    {
      "left": "BWA",
      "right": "NAM",
      "kind": "International boundary (verify)",
      "lines": [
        "dlrkBspdyCuhAdyKeBfzF",
        "h_pkBe{oxCheEvmEtqA~lExDd`E",
        "zpwkBupnwCyX~q@gu@tg@_i@|`AexAye@",
        "r}pkB{yjwC~IncAj]t\\~h@hTpk@dn@hTtg@`oCpkM~GxwBnYzjBptBrqCnYz~B~Rve@nwAxe@jR|s@`Hnx@hTfu@nYnm@dXr`@`mE|fDbbC`vEvoA`|AjiJzzH|KpUza@`SbcBxvAld@`SzMh~@l[l~GtQ`oA",
        "b~xkBg}|wCq_Clz@",
        "p}tkBya{wC~fBvlDfKxmA",
        "xqxkBgeswCshApt@",
        "dhvkBuoqwCtg@~}A",
        "blfmBcgqtC{|DdtE{_B~Iec@`\\cQhh@si@nm@ieEfjBebAzkAyXfiCuHxtE",
        "l_qlB{yusC|_@tzAz_B`eBbjHtpDri@vy@",
        "bkanB{~|mCmErt@kRdw@cQfa@g_@jGihBsJmd@fBi~@be@etEp{DkyCvfAi}AtfAq`@lPij@vFqsCwFuS~RcDzl@}Kzl@qk@~R_sAS_i@jGcZdc@ug@voAuHlkF",
        "vbzlBk~|lCpb@boLpk@vyOj|@|aVvcBz`PdaB`nOp`BvnObaBbnOp`BvnOdaB`nOdaBbnOp`B`nOdaBvnOdaBvnOn`BbnOdaBlmOp`BjoOdaBbnOdaBvnOn`BlmOp`BvnO~RpiB`SfjB~R|hBjRfjBpCduBbDduBrJ|dHrJfdHrJpeHrJfdHfMt_JpLj`JdM`_JpLt_JtF`_ErCvqBrpD?b~F?n}F?d~F?v~F?x~F?n}F?d~F?b~F?d~F?b~F?d~F?b~F?n}F?d~F?b~F?x~F?|kWqAv_HWdkNe@~kWgBrlWsA|kW}@|kWeBrlWsA|kW}@rlWqA|kWqAlqRq@pyCK|kWsArlWqA|kWqArlWsAbgWqAxC?lgJSlgJ}@xfJi@xfJSlgJi@xfJi@lgJg@lgJi@xfJSlgJ}@lgJi@lgJi@lgJg@xfJi@xfJi@lgJg@``GUhdFboA?zdJ?`vl@?bvl@?`vl@?`vl@`yOSpk\\i@xj\\g@pk\\Unk\\g@nr`@Ufq`@}@zq`@g@biSMtgLGpr`@g@zq`@i@nb[a@~mDGzq`@g@pr`@Udq`@}@zq`@g@nr`@U",
        "~v_mBukhsC_Jdw@gu@pkBaSxbAwObbC",
        "|p|lB_`}rCvOt{BhhBf{Eb}ItjH~pChpE~f@~bF|V`r@hfDdsDbc@bp@thAhqD|s@pjAh_@t\\ri@fV",
        "`p~mB{zhqC_SxZmPt\\wFr`@",
        "zb}mBw_fqClEbc@frCtxEvvEjRlyAnbBdwBbwDnaAxkAz_DloBjeA~gA`\\daBn_RxjQpv@~{A|Tx`ChfD|rCh_@jh@bOvZ~gAd}EfBnmB",
        "v_xoBcz~nCs_AjpAqdG`p@ckGzaBgtApv@cbCowAcbCby@grEbkEacB_t@mz@za@cp@f`AmcAza@iiAzXcZ|~@eMrsAs`@ftAap@r`@}hBlyAgkA~{A",
        "bm_nBw`_nC~|@z`A"
      ]
    },
    {
      "left": "SEN",
      "right": "GMB",
      "kind": "International boundary (verify)",
      "lines": [
        "{ejsArwc{AlEudCzhCasJxZcvRbiAicFr|AouBvoAceBriBcnAbrB{v@ntKmxBrn@gj@~vCy_Gx]ovA",
        "g}zrAh{d|Ay]adCaeH{uMwbDwfM",
        "_bdsAprt|Ahi@umGfu@my@b|CcxB`f@_t@",
        "k}{qAt{u}Ai_@caBewFsKssAgNsi@uFmhCap@yaCs_AmiBmdAqlEwaEq|DegGajBk`H",
        "}skrAtwgxA`Ra`GvyBkkGv}A_xBpfBmsAnvBmz@lnGorAxrAog@jbAe~@pb@{q@l|HmdM|cAeuCnNeqB",
        "qgbrAxa~xAgWelAwpEu~JkaAg|F",
        "wslpA`rnxAsYhcFmuA~oEgwCjmD_kD~|Bkg@xaA{V|~Boc@rqBi|B~oE_Z||AaRjnFau@drEckEpwKS^_@f@I^c{EjuHq`GtwGilBxjD",
        "ih}qAhqk{Adw@vmCbcCfaCjnCjlCziCnvAraKrVvkDvd@vbDp_CvsBprDbiAxkEtc@ljEHheF",
        "eu|qAvsadBn@ofKh@gcKr@{bKh@gcKp@ocKh@}bKr@ecKRs}FHidCh@ecKr@qcKh@{bKp@gcKh@ocKr@}bKh@ocKp@}bK^{pH",
        "ud{qA`cktAhUgbC`u@w}CriA_uCnrAugBlu@i_@nuB{f@ts@m_@|IcLtc@{j@zpAylC~q@c~@pfH{tCv~H`WhhG~pDlcCptHtf@dwM`aA|yF|A|zF`~AfkG",
        "idwqAz`vtA_Ig`A}^mhAehAi~BgLyrA",
        "imwqApmytA~GukB",
        "glbqAneqvAoXikBg_CanJerEmyIgq@ouBwnAsgJ{oCa`H_^w}BgAebA",
        "wzppAfwz|AcmCxhTkG`bE",
        "gqupAbdv}Avt@hqC`lAjoCn|@|zD~H`eB",
        "}fopAxhh~Aeg@ndL",
        "coppAhnu~A|@xmApvAtwG~g@trL`f@hgAdwAzWdzLrIn`BhAd|LrJd]~h@",
        "guwoAbcpvA}K`hDkl@lbDmrBzbFmk@daA_s@bz@y}@xn@{eA|dA}UbrAwFtcEuXlyAem@~qAss@zx@}aDzqD{WjfA",
        "c`opA|_axAvp@niErYrfF",
        "gcapAzx`uAg@dkB",
        "odapA`eduAdh@r|Ap|EfkH~`ArgCdExsD",
        "quvoAjlzuAk}@hrI",
        "}sxoAt_evAt]lbJ",
        "iuhoAfms_B}@biFo@reDsBxpKcFpmXgKtej@mGpt\\eH|d_@qA~nG",
        "}cjoAppwdBrn@~xEvwCj{A`{@tRh~AxaB~q@vf@|dApU|nCpH"
      ]
    },
    {
      "left": "SAH",
      "right": "DZA",
      "kind": "International boundary (verify)",
      "lines": ["{dpeDzw~s@yjQ?ojQ?cjQ?ujQ?"]
    },
    {
      "left": "LBY",
      "right": "DZA",
      "kind": "International boundary (verify)",
      "lines": [
        "uaowDeiby@ryThpl@vkEuqCz_KwrJ~pIoeI|n_@u~Wn{d@u`Vhzm@cnNjzm@cnN~y\\giCx`d@uQ|t_@ztCdqcApyHjjJwoA~|aAwo[vtFhIvu@tQd}e@lgLt{BtgBxsAtnD|bBvxCdaCaSxjCazAhaC_}@~vBvp@dgGhlGlcCdxAdoJtqAluFhfBldB`\\rfBfBfbs@upOjlSmxBjyBa{@pw@ocAxjCuvGrjAyaBvxAqWtxS~{CtxE`QvlDufAlcCgMpaX~cG~|BptB|r\\f~cAr{BvFriBfVvyAzu@ntDdtEjwFhqBlcBdvAdfHlyCfzI_qCnqa@}jZjtd@ay\\zg]k~Vtud@wy\\xnKioFhkK}rAruX{XhrZwZ`bZ}K~eDcmA~pNea\\fhDqtBtcQylBtxEemAnrBapBb{QstXxh@}sB",
        "yb{tCeth`A|V_fCfhJwfd@~aMqrm@~vQw}|@hmAuaGzdBwkEt~D{_DlfXmpLthY{aMvPoHj|g@a|TboX}tL|zZ_}M",
        "a}jtCuhp~@wU_wFavFuwUuhFcrTgMufC"
      ]
    },
    {
      "left": "NER",
      "right": "BFA",
      "kind": "International boundary (verify)",
      "lines": [
        "sh_zAmti@hmCyMxrAdw@vcApuAp`BnkA|qDjI`iJetD`}Dkh@d`c@h`Ld{Hyc@hmHkyDfkAytAx~W}b[x|IchGnb@yPzr@nEviAfz@tw@bVl`E|_@biAt\\paFptCnhA|YpfAsZlsBgnAvi@we@l\\gf@|_@ga@xs@oYng@bFrcBtr@zu@Ub_Amx@|e@mpAzu@q`AxmB{KhmBsp@fcAefBvv@slBhhAkbAlu@vAtoBdr@p`AoBjl@se@xrAiaCxt@cp@vrB}s@nbAsp@jb@}XvtA_~A~eCqqEzqA}~@lhAmeAhj@cwBry@si@ztBld@haCv{@b~AbZtzCquAtv@wcD",
        "storAqcrC|Ki~@fj@aQzq@f@be@cD`VnCzXhThh@eDrdA{iAfy@wyBxDcnB",
        "yznrAefxByXk|X",
        "wydrAadeDltAw_HheEypI`fGq{FrxGi_@z|D}sBfsCamEbsHygTzb@wnBb_@ygGdYihBt`As~AhbCovBv`AzhD",
        "ocdrA}x}CgUcjF",
        "uzfpAguaFuw@ziCoqAznIkbE~rNiUjcC",
        "q_rpAcb_ElyF`qA`qOqAfkQgBtlK_AjrBQtuBcQxbBqv@v_BqrDxc@_~Ld{As{D|dH}bJ`tH_uJx}JymMhdCe`DtcL_|Nf{GgwIpbJqlL|~AanD|s@knE|u@c_SzaAivW",
        "crkpAmnqFuw@lxBixA`eBs_@`pB",
        "wdqpA{}fFz`@|_@hdAv\\rtEr}@fLhj@",
        "oetlAab`Kvp@{~QpaAsyFrzDmbDvxBec@r`@{VbbAqaAtr@{`AldAiqBxdAew@psA_i@xmA_SrwJyn@lnAk]z_B_r@bo@qb@rtAmnAbn@eXnY?p`A~Rh^TrhCiKxaA|j@fVvzA`^jrJ",
        "senlAqyxJql@cdAiqB}hB__@mx@",
        "ucolAo|uJ~S}j@`Hcp@",
        "ew|kA}scJ_KmmBmcA}hBgjB}iAkzB{`AaxC}hBurAsi@_]yZuI_r@",
        "yxujA}reLoDt^__@dbAcEtQ",
        "mdwjAk}aLhTlf@j|@dl@hTl[rhAlgJnlAh}AdtDzM~yEovBdoJakGx_SarMf{QgvLffTmnNfoGqdI"
      ]
    },
    {
      "left": "COG",
      "right": "CAF",
      "kind": "International boundary (verify)",
      "lines": [
        "ogcUoyqjB}c@f|FobBvaF}`EffFeOj[_HfvAqWh]eqApW}ZbZ_UlnC",
        "wgsUe}piBxj@jdBvdA~}Axh@fpAx{BjqFh{Cr{Bp{BvdChOtaF",
        "u|`UewlkB_@nx@iUjf@gdAv{@aR~h@",
        "ildUqofkBfApk@bZhgAxEr`@Rp~N",
        "mafT}}tpBgBpqGkkAdkAydFnbBszKx~FcwB`eBu_Ch{C",
        "ikdUoyvoBdCjpAnrAbdAfnBhqB`Wzw@",
        "kfaUcpqhBcu@n`DkGboA",
        "{dcUo~ihB``@lyAzfApuAdaA~q@tx@dw@hn@tgBfLvxA",
        "e{qTqq~kBwPbxA_aBti@_{Bt\\oqBvy@gzAboAwv@|}AoCfu@",
        "}taU_ppkBfWxwB",
        "il}TywloBcE|hB",
        "mr}T{mioBjH`fAbYvZltAzXrUzV",
        "{byTiydoB_@|j@eb@jeAaGnd@",
        "cozToa`oBfk@~pN",
        "oczT{_{gBwFryF",
        "gkzTgesgBpV|tAj`A|fDpL|tA",
        "{byToopnBgAbdAqNdw@",
        "utyTerlnBpMzl@`uAld@x{Drk@~{@zVpjBjgAzfBblBb}@bbC",
        "wdwTmqhgBsIpgD",
        "kowT{hcgBpLdw@|o@~fBv[hj@z{@jeA|Uhs@pAbe@",
        "m|qTgttlBiU`{@yjC|{EmL|_@",
        "_lwTizjlBtYpb@fsB~mFz`@duB",
        "udfTwa~mBgQtfCezA~pAoxFnnAmjBxlBofA`vE",
        "q~vTusjmB|@jyEhx@nsEx}A`bE`GnlA",
        "ontTqudfByIlx@mi@jqB{Mvy@",
        "srvT_o}eB`HvzAdr@jG~`AmPht@fKd}@vyBlFxbC",
        "gcqTydqfB_^jq@ys@zl@we@ncAeDj|@",
        "_cuTubjfBnSblD",
        "mynToqreBk_CxaOkH||B",
        "ecsTwp~dBjH`oC`tAfdHhgDx~F~gFn_EzuGbcBriOpv@dhKh{ClxCzB~dCnb@bjHbvE`nChgAjyCpClcCwp@z~Bg`ApjCyn@l_Fjh@boMppFbsGmPztBgkAldBkyAjoB}u@puC`\\nzJhqDzqHloC`vDbuAfsPdiGtyQd{GrjLzgE~yQf{GbiT~_I",
        "w}qTq|wfB_J~rA",
        "whrTqhufBjHlo@b[hrA"
      ]
    },
    {
      "left": "COG",
      "right": "CMR",
      "kind": "International boundary (verify)",
      "lines": [
        "yxsLelzaBvZob@zv@q`@bcArr@~zDhzF",
        "ot_L{pkxA_^t{@ebB}s@oaAdtCseFvmEgk@x_D",
        "alnLkd{wA`g@r^pu@dy@dy@i@lx@eM|t@~RvRdw@fhBzkNnmAz~BrJdc@",
        "aeiLibsaBymBfsB}Tr}B",
        "yimLmokaB`|@bcBphChh@zjC|iAjfAfMfoA}Kvu@oYxx@yOnwApLbErL\\dXlGvZbZvQhd@bF`[?nO}BpBeB`v@aHvo@iT`v@i@jdCr~Ab{@xOveFcFl`@{VvQye@ln@qt@x{DwnBvaPsqEtqTytCjaB~Rt\\dbA",
        "wl_L}|awAuRbxAwnBxwB{v@daBst@~jK",
        "u}fLy|kvAziBbrGbFdy@",
        "ukcLooavAcEppSwGn`^_In|a@mGvq^eA`eGwGd`]uHzq`@",
        "mayK_bzxAcd@j{Ac~BjzB}s@fvA",
        "sz_L_spxAbEbaD",
        "okxK_j}xA}Tj|@eNwe@{dAwxA_yApgD",
        "op~KqdzxArUfl@lwCui@",
        "{gfK{lczAaR~vFmxCyXumDebAorAbyBq|@~RgyB`qAgxAjyA",
        "sg|KiwtyAje@ti@tlA?`kAfK~x@|j@|U~{Ali@j_K",
        "clrKawbyAq\\~RsjCyDck@bF",
        "mayKwabyA?r^~M|u@|Ed`A",
        "kjkKopt{AygArfE",
        "esmK{hn{AfwD~pA",
        "chvJuqr|AkMqAq`ArqCeDj]ct@`p@oX`Hkb@_J{pAkG{l@pLqo@nb@cf@bp@imAnsE{Qfa@_i@nWg~Afa@od@~]_s@xbC",
        "sjmK_fz{A`\\n`Bdb@~rA",
        "{ycK{eyzAyZf_BgkFbhHkGv{@",
        "ijlKw_kzAduCtp@v[nx@nNtfC",
        "}zgK{vk{Aka@vzA",
        "i}hKc{h{A?be@`dBf~@peBbcBt^tgB",
        "_raK}h_{AinBrhA",
        "iaeKi_}zAlf@lxB",
        "_g}I}n~_Bis@~]c}AbOck@~h@k\\t{@_aBftC_y@reD{g@dmAuoH~mFuYdl@gV~pCu]dmA_c@f`Aw[bZ_aArpQ}|CfsOgq@fpG",
        "a|`Ke_o}Ard@fpGf|D`~Hxh@~|Bvz@ptBnJrhA",
        "eyxIydp`Bii@zjBsYlxB{l@j{AuaBjR",
        "un_Jwoe`Bdc@naAr_@~rAzAhiA",
        "}cbIqsaaBy|HbuFukB|s@c_A?}y@aQk|@aH{fAbZ}m@`r@w[`dAs@|iA",
        "a|yImer`Bza@r_A",
        "oymIyipaBol@jeC",
        "_goImclaBxNzu@frK~wG"
      ]
    },
    {
      "left": "CAF",
      "right": "CMR",
      "kind": "International boundary (verify)",
      "lines": [
        "kk|l@qsn}AnwAlo@ldMpoIdaBpW`oBmxBjqApLxDbZbFptB`G~f@db@dc@tfBtr@dc@zV`aFpeHjkGr_NfmAf{A`wBplCpfHptB`nCpuAxcA`\\`z@vF`jJi]r~@vO|~@~s@daAjnCdd@zw@hfBxbAptBdl@haKdaBh|O`mEfdGlcCj{GhhBpvAvn@|~@fkAnyDhvJncAjdBp_BhtAftCbaAhoq@bkUrtE|{CffApLbrCcZ|bA}@~cAfMhrBf~@djHzhFtmAxaBnhLlzZ",
        "c}wd@o}}wA}@~aG",
        "a_xd@ozuwAbcBdw@`tBt|AtoDfsD|Zh}AtjCtoC`kAhrArTwFja@sDx_@kDp{@xZ~YjRbt@|TlYbZT|_@",
        "{`|c@s_~vAcp@f`A",
        "_r}c@k~{vAxDt\\`r@pm@bi@tQ|p@qLfiAur@zq@is@`uAufAxhAk{Al_BazAzcBij@dlBcZjaBcn@|cAueBRsiBrUkcE",
        "eadc@}d}wAzC{kAn{BuqAr|B_^brBmyArySkh@r}B}j@fyA~h@lsI|tA|yG`nBj`BxOjkBkGvtAu^frCyvAtaBkh@tlAiIl{D`Hf`ArShoDbzAjfBrS|qDmEpfAvZ`\\tqApo@|@dgB~s@v_Br}@xXj]zpAhKxmBza@vhBzu@`aAjgAdN~q@bcAeXvnByaBnqA{`CrxAilGx~@oaCxaBccBp`CcdApnC{l@|lCcZzyHh@vpFyZbfFrk@dZd@~xA|BveAqWxt@_g@pz@a\\hfDxMx}@gVj|@ec@jjAq`@rmQmyAb~@dDlxCl[|cAlY~g@bFvhBkh@dyMgj@xfHkpAveGkdDhyEy_F~hTo~]p_BgpGzk@iiAb~@ih@|}Csi@lsAug@hiGmwEjoDq~AxjDgw@txJg~@rbJuHrfD_i@ry@afA",
        "_o`c@k_uwAiIk{A{fBehD",
        "oqbX_ug{Abc@i}AfvAag@hwAuStg@yc@",
        "qebXavd{A}J}}A",
        "cuzWalp{AnNs~Ads@qjA~bAgMrs@vyBb`@rhC`sBxsFpX`yB",
        "cuzW{tm{A?evA",
        "ajoWgrb{AgLjfBar@fgE",
        "kjqWsbyzAHdjBpkZeoJ|wW_{OfyOk{Nb_Am{@l~LmdL~kPmmOfpT{hSbnSeiRvkRoiQvoNisMl\\en@xMap@|JemA",
        "mc~Qyrs_BbFmd@rj@ebA~G{V",
        "ug|Qsqo_BaFeXug@igA_Ku^",
        "ad}Qa```Bza@mdB`dBmxBz`C_gBvxB_r@pyHirA|`@yO~\\}TnYoY",
        "ug|Qisw_Bk[wkG",
        "uxeQ_eu`BzAw{@b[g`Ahs@up@x_EmcCjnEk{AvaC{kAzjC_}@tdDmPrrCtr@pgDpgDvcDfVnsE{VnvAnC|t@uShA}~@",
        "okdQonp`Bu\\_sAoNoaA",
        "}hoOgzdaBbEcoAxNafA|sAzw@`{Avn@`eAhTr~BmP~xEg_Bp~BuQxvB`\\buEn`BfjCxD`pAeX|pCmnAjqBwZdhF?tq@aHnaCwp@tyCcmAteCguBr_Agj@xw@sUnw@sJ~{BwFt]kRru@quArTsUhs@qAvnAnb@vz@tHzm@_qA`R}V",
        "u{nOifbaBgL}rA"
      ]
    },
    {
      "left": "UGA",
      "right": "SDS",
      "kind": "International boundary (verify)",
      "lines": [
        "adwXwcknEj{NlyNnaOxaOtzTryT|vQbuQflM|jMzPp]nfCtfFr`@tmG",
        "iizU{tckEar@`l^g[lxPmd@l`E_dAbbCicS`tWes@~{B",
        "q{uVwwkhEpf@lmBnxGdzJdxF|iN||CnkOrnAdu]r|Ad{b@|~@ppGlzTb}b@vsA|hA|oAxEt~EcZz_Bf@hwAdRpf@rGbu@~g@zAzjA",
        "s{lTamgcEgnAvgKmu@hhBuaBr~AiaAlh@y}BhnA}d@`fAaBpp@g]bjNkk@ftAwhBfj@s~G`RquBrVeuCvxAkpN`|L_{B|rCeP~c@my@v|B{BlR",
        "wkhVwr}`Ezb@pL|mPjpNxs@by@vo@hqBb~ApgS`v@xlB|yA~gAnDfEfz@jbA",
        "oaiUk~k_EsVhqBaqLl}WowGvcO_mAltFob@x~FKdfH",
        "qucVmlf}Dpl@bbDzsDvfFnaCbfDfUdw@lVzuBpVby@vwCn_Ebf@|sAtGr~@",
        "ybpUe|b|DaBtzB",
        "{epUo`_|DrUp`At{@bdA~bAt^dgAjRnhAl[zwQv{K`lG|gCdaBnY"
      ]
    },
    {
      "left": "COD",
      "right": "AGO",
      "kind": "International boundary (verify)",
      "lines": [
        "vih[smxnA|qDhs@voAn~Ed}Ghje@djBf|DhsBrgBvbC`fAdkCtg@hpC|KpjAby@xaD~wGzkAt|AtdCfu@zaB|KtfAxl@tr@bxC`Q|oFhi@pv@f~BvQvjFjdBftCdhFzsDnkOlEjs@",
        "ncz]if`kAmEnm@",
        "`}y]yw~jAfKjf@v{@~]|s@fBdbAsJlz@qW|_@ob@rfC_`Krt@qjA|pEkh@|~MvQ|sOtStiV`\\jiWt\\ttKnNvaQ~T",
        "bl}a@cdjkAoCfjMyD`xP",
        "xa}a@y_jjApjAfuOffDpmH"
      ]
    },
    {
      "left": "ZAF",
      "right": "MOZ",
      "kind": "International boundary (verify)",
      "lines": [
        "b}l}Cwa_bEqnUltFizDxXclDae@grRohGqjAcp@wdAaoAs`@w{@ae@si@krAyXsfCRcgKxx@maCnc@e`Cf`AcbEfVklEwFg}CeXqpHqiByli@hHca^xDaiVfC}{_@lEweZdDolLar@ebNr`@}~Mp|C{qL|yE}`UhbJygG`g@k}]~g@qeBfCobBp`@coArhAepGvrKaeBztBcbCpvAccPn|FslWfpFaaFjzB{sQbwQe}EpsBw`Gle@{qk@cbCi|Dbe@ste@plL{eVv`Gg_\\t`Io`\\haIc|WnsGkoBk|@"
      ]
    },
    {
      "left": "SWZ",
      "right": "ZAF",
      "kind": "International boundary (verify)",
      "lines": [
        "bds}C_inaEcp@|rDq_InbP{z@heB}nI||P{aK`uS}aKbuSyn@|}C",
        "~pa|Cebt~DpA`wDtr@lwElnAtnDvzNluRh}LphPnaC`pAlhIh~A~vUpoInhTjgL~bOjdMB@xsSvbQhsMhfChxSwF~}YuH|kLi}@|pCii@",
        "b}l}Cwa_bEz_DneJbe@fqD",
        "h}kbDihn{D|rAw^p|GckB`pBuqAzhD}qDj{AoaA~zByc@tzCvFntFp_ArzCoY`xEckC~fOw`SlqKmiHpuAq_Bxw@i}AzgD}bPdcAm|EhrCi}MrdEkaSfkAgbLjG{pT~Iem[vFkwQlEkoP",
        "rbsbDgb_{DyDokBaQ_gB}s@}hB_hA}~AonAufA",
        "v~rbD}`gbE|@ebLnPccBdiCwxCtg@wcB",
        "reveDsxbbEuqAfB_fA`QqaAr^ybAti@wzAza@cnMxNavB`Cm`K`Lg}PylBq`Oq`BggP}hBkzDpL"
      ]
    },
    {
      "left": "MOZ",
      "right": "ZMB",
      "kind": "International boundary (verify)",
      "lines": [
        "taptA}{siEdvCbeMntDp_PfeGbqWneJbs`@v}I~y_@fzHtp\\|yE|oSx`EhdQxxA|tNtfAhnFzrEzvMdiEfrRnhGfuXl~Gj|Zf{EplLliHjdQx`EbwOtxCniS||DzcX`xCdfSlGvnBrdEjsZziCvkRxsHnbZp}DfsOjkF`wSrxGtdQx_FxmM|~@bbPnYteBdBHvg@pBtyDqk@`vG?rmGi]~kWghFvhH_zCp_CojE|_@wxA~pAymAbnBg`ArrB}j@p_CoY|uKcOtfAuR`{Ba{A`{@_Sr}@vOlwE~qBphCtg@puAqLlvDgqDbp@}_@`wDwfAnNpMza@dwA"
      ]
    },
    {
      "left": "ZMB",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "fl_q@uguzDn`Dpg`@prFddq@d~Dhif@|zFlzr@p{Fl|r@pNveBzeEz~g@ztCjy]`cDhx`@`pB~kV|~@bbDptBsUnjPwiGxkPh^xwOnhFrz_@`}Wvu^tn_@`hLjcQviGlxP`nDljGreF~zBtcFmcB`eBwjGh~@yqHtpBkyE|{Co_CnvBsL`pBtJlyAtHn`Ba^leAgiAxlBeuCf`A{k@bdAqXjpAsJ|hB{AtqAu]j]gkA",
        "p|fy@altmDlo@th@fl@nkCfa@r^vy@eXlcCeuBrsAcZ`{@}Kx`Cqv@zbA}KraHaGt{Bce@`yBqtAti@s}@jRiu@xc@kf@`zA{MjdDmbDl[hKzl@hrB`nB`{@~lG~{@vrKd_E~eCnXfaMem@~pNbPxsFpv@n_Ep`BrpDjyCrrBvy@rrDctEj[iKpaA{K|_@mPrJoNh_@}u@dB_JbyBq`@z_BlPnbBzb@bbCjQh{CkRbnBmo@lbByw@byBgl@fiAcFxmAtHjgApWdw@xc@vy@nY~}Aur@jz@dX|tAg@tpBaqAreDyvCthAgA`dCpa@hgAhIh~@q`@nmB_qC~f@q`@~|B|_@fsB`oAz_Bz`BncApvA`Hnb@",
        "bagy@kgnmDqCucE",
        "nwj`Au}ymDyDlnA",
        "tqj`AgnwmDlPxc@f_@bZbxC~}AhgCpk@t{@nm@bnB|hB`dCjpA`oCzw@frC~]btG?xbAdMf~Bj|@r_AdMnaAhVbnBxlBnx@bd@r}@lFvdCiKf~@zCdbApVxvC`qAxwBnwAt{@zBtkIebAdmAsAvy@dOxmAft@dc@zNdbAvFpqEwFtlFfsBzbAlz@`zAvy@|gCdYpgFon@tQr`@fjBziCdXhTvpMhaI`nBdO~lIwFf_Bc\\jq@}_@bwD}hA|~@ym@j{AwzAxw@yc@`sJ{jBt}@zBxXfVnx@_i@~rAmyAf~@kRdoLk|@xmA_r@h]wcBf`AsjAfoHsr@f_B{aA",
        "h{kbAowfrColAtg@_oEkIufArJ_}B|j@mcAnNox@oCwnB{a@gu@RwdCbmC{_BjlGqv@fdHaFnsE",
        "`ylbAu~|rCmPjzBebAffFgBrgB",
        "dajbAmsnrC`g@||B`Q~|B",
        "tj~dAifjtCgKtoCmz@h|B{~DzrEuqApjCkRrrBqAhcGom@vcBkoB~s@qaAcoAemAicGkpAemAivHggEycBmo@mxB{VudC_JoaCvFylB|_@st@hj@s|A|hBkgAnb@owAoCa{@om@{u@is@kgA_Ug~BleA}gCp|CupBzsDk|@xkC{M|sB",
        "jxlbAsfdsCT|fF",
        "hzafAyexyCcF~s@qW|j@gu@~q@ihBxy@i}NpgDanB`Qcy@g@mz@eXobBitAmz@kGylBnm@{qFnlCq}Bxn@cxClEwdAis@ox@_hA_rB_t@qt@h_@st@vdAst@fa@qv@igAwp@oaCsi@mo@u{@gB}~B|Ke_DwFekCzKoaAfkA",
        "hnicAolnyCf_@~cE~bHjoQdmAhtJlnA~|Z",
        "dpxcAycnwCuStnF",
        "n{wcActfwClnArdGvaFloMtr@dqFh@pvMn`BhoFt}@dbAlwChqBj|@j|@~]z`Aj]dkCnWdw@lo@fu@tr@nd@lz@xXleA`Srr@tg@jIz`A",
        "przdAuvztCyD~gA",
        "vlzdAumxtCnCj|@f_B|cGdX`dC",
        "pqbjAcgchDsUjuG{w@`nDk`H`kGeZba@_kG~nI{~Bp`Bk}YfoH_yFnY_qNrcHk`U|lc@q_PbvCqqEgKqpHbZo|Gf`AouCpiB",
        "dureAyr{dDxDtg@dbA|qDpUljGfkAlkFpA~|@",
        "pcxeAiacdD_SphC",
        "poweAww~cDvFfu@bxAhsAzuBqBdgGolAhfD~Ir~Ap_AnuAj{ArhCr~AvuFt{@p~NdXfqFvyBtoEhyEfgC~oFdw@lhG",
        "jb{fAkrrzC_i@r}AgtAjf@i{Cgu@s`@{Aq`@zAi_@jI}}AxlBsgDxdJ_r@|u@_t@t\\ih@`g@yOtqA",
        "ryafAguzyCTlnA",
        "no`gAakn|CqAxfJuS~qBigC~mFioDrdEafCnuEuHb}G",
        "znqfA_gb{C`g@bp@|~@`Qdy@pWrSdbA~IvmAxc@|j@~h@be@j]by@nCvyB",
        "~ctgAy}s}C_JvoAup@xlBmaEztAs_AdxAkq@tdCqoG`tIw\\zViTt^sJxbA",
        "rb~fAazu|CrJzl@nx@~zBvFbdA",
        "xolgAapamDpCg`Aza@ew@bn@qv@fa@w\\lxBgiAnx@kR",
        "v{mgAa}~lD}j@_rA",
        "zhsgAaoomDj|@ssAniFomBh|@kpAjdDcrHr`@mbC",
        "p{ugAm|jmDuqAsqC",
        "~tygA}}a_Dmz@p}BmnAr}B_t@dkC",
        "busgAqtu~CzMvu`@",
        "bdjhAsg}aDcp@zjBkpAriBcdAbwBmo@bjFga@lyNufAn~EquA|qBu|Ar~AwoApiBel@rsC",
        "|ougAebf`DlE~mFbe@ngFbZr_AtqAvyB`\\vdA",
        "jg{gAqio_D{BrhAu{@d`C",
        "xfygAw~h_DdMx_F",
        "fpahAiqwbD_^~bH",
        "fq`hAimnbD|@d_DdmA|}AfjBtgAtzAr}AxZf~B",
        "vtchAotlnDvp@yw@jmDkRh}Aqb@paA{tAzsBi{ExdAymAteBssAnvBmcA|sBwZrhA{w@njEcqJheEcaDnu[_|Nt}@qN~pA}IxOw\\",
        "`udhAczenDi_@kyE",
        "`zdiAsd{tDxISbSc@rAEtwSh@~vUr@~n_@\\hf\\|@tba@h@~f\\r@|sZr@vd\\f@nqTTjcEf_BxOh}A",
        "~|piAenzsDaSqiBqsCefIcvCgqEgl@mcC}T_mG",
        "pnkiAojrsDv\\moAnkBaoBdc@ebA",
        "lr_kAy{|rDsJewBox@s|AwzAu}@{sB}TmoBt\\g_@|iAoEf_Bec@p`BcjF|zDap@|Vur@aIew@}UsqCoXesFgjAymAkf@wdAs~Ak{AoqGkgAmyB}rAwyAsUex@?}sA",
        "z{ojAi`xiD_i@njCadCjg@}{CrVapB`zAsoEfbJen@f~BoN||C",
        "noyiAiyzhDbp@`qAftAxcAh}AnuBlo@jdE|Kl~G",
        "pgnjAuzpqDt\\_~@byBkoBz`AylAzVoy@rJigAxDsyFjIcp@bkCubGb{@seDnCkh@",
        "`rsjAewtpDoaAqiB{w@eaCae@wwCaH_}N",
        "pqzjAqkujDyuBxvCew@l[w{@rK}s@fUga@nx@}j@fkM",
        "tbojAun~iDxD~|AjRjoB",
        "rxojAksrpDlxBybA",
        "x{qjAielpDis@gjB{MyaB",
        "jvpjAqkgpDr^i~@xDmyA",
        "~vpjAm|epDScn@",
        "tb|jAqcjkD_hAblBazAh}Ais@dwB",
        "hjujA}_`kDjf@h{CxxAj{A`e@tzA",
        "btumA}wjmD{Bh}Acy@z`AsbIhT}rCzaBsfCphCwcDd`Ce_Dhj@cxAk}@meAadBifBufAyaDgCqtBh_AiyEzqEykCdlAcsHxxBkeCptAoyLteOwy@zjBob@ptBmG`{B",
        "|o{jA}dskDbQr{BRvcD",
        "|y|jAgrwrDfBah@`Qq`@nY}TdXoYnNom@",
        "ta}jAcztrDwFcwA",
        "naxpAkaapD_U`eBcaB~pAyuDp}DkaGldByw[z~Du|AhgAgVdx@yDvxB{a@vz@axEbz@eMrScFfa@_Jpb@cZnW{a@lFg`AuGwZnCm[i@mcAu\\u^{BoYzVu\\~rAwZbYy_Ffv@ybAfl@u|AlmBs}ObfLq{FryF_}@|bH",
        "jujmAkaumD~s@jpAdsDlyA|iAv{@ri@z_B",
        "pk}oAsg|sDmGziA}iAdwBquApiB}~@~qBwF~pC",
        "|yuoA_ujsD~|@~nC|nIjiJbmA|~BhlI~qZ`lF`jJnx@`mCdn@~rAllCbwBxc@paA",
        "tqcqAu{ttDoCvpKebAtwFis@~eCiu@f_Bqt@fu@__A~h@adAh_@kgAzVevA?s`@mo@}Imz@kRwe@ey@sJi|BhK}s@uHom@}j@cZwnBu^em@yn@m\\_}@oWebAkIs}@dOcdAxw@i@lo@",
        "ly|oA}}}sDbQhu@",
        "hk_qA{_cqDuQ|}AuhA|u@i}Ahi@cmAzv@i~@njC",
        "dcupAi|vpD|@nuCpW~{CPbn@j@|sBhh@tpBpWtpB"
      ]
    },
    {
      "left": "TGO",
      "right": "BFA",
      "kind": "International boundary (verify)",
      "lines": [
        "wkvaAyf~AihGqjA_XvcB{W}ToXaH_YoCyZmGuRfBeMjG}GpLglC~yTemBb`Pg~Gxok@wyC|}Vs`ArcIo_A`~H",
        "s_bbAeaoDzM|jXlJjxQviAbgKxmG|kW"
      ]
    },
    {
      "left": "BEN",
      "right": "TGO",
      "kind": "International boundary (verify)",
      "lines": [
        "s_bbAeaoDx_Kd_Dd{B`QjbA{Mz}Bis@tbA_HfwDn`BzaAfKvmCvHf_AjR~qBtoA`_IxrI~oEvxA`rPup@jsFnCb{IvzAvbSdvAtnCeDd}Akq@|vHywMrfKiqQhlF_gJt}IasO|lQi~ZzqLorStsEcoA~n@UjkMaF|iTsJldNwFxbHap@`kA`Hb}@xMn|B}@x~@vFfnAve@fhDbnBfpAzXf~BaSvwCi~@n|Ak{A",
        "wt|x@sgjGhpDwfAhxRsi@dxFmyA|sDouBzo@__@`fOirNnsKecK~~Eq_CnuCwp@niDq`@bmWkIfiT_HrbQwFtcYqIryDkAthAaHzdAs^jjEo`D~{@oYlmBfVfpIllE|s@tHnkB?lwC~]~X_QDAfK{c@tx@s^bwOoaAdkU|Ivb^nNh|]{B|ue@cD|lBQ|xOmAheRyA`d\\{Bfj[{B|t[qCp`@tpB",
        "}`{x@m|fGyr@ejB",
        "ioti@w}xHgBdwM",
        "qrti@qejHb{LmxBtfBkeAlF_I`dAw{AnbAew@|uA{KjeGbn@viB{BvjBcZz~Byn@xuCyc@v_BdXr`Abp@h{B~{AbkCtr@feAag@l`AwoAb|BocAro@g@hs@|Irx@zB~~@_Shr@md@lp@cp@xh@is@`\\cp@xEwy@",
        "mybg@qr`IxNel@pfAmGlj@cOltA_gBft@mf@x}@wF`eCnNpu@qLv`@ih@~cAkeC~f@st@|`Gy_DftMmxBriMqtBvFx`Cr|D|aXhcAd`CjaCcl@",
        "ssbg@eu~HyDk|@"
      ]
    },
    {
      "left": "GHA",
      "right": "BFA",
      "kind": "International boundary (verify)",
      "lines": [
        "sx}bAdm_@wmDhnY",
        "kgccAn|y@|cBlPry@qWjw@_Mx{A|o@`kAfnA|`FhxH",
        "sdpbAz`gAmcCjoBc}ApuB",
        "egwbAxgnA?vwBduCzvB|yA`\\vlCzLfaA|`@fz@|hA~kAjcDpfAxy@^?xNnNzLvQtIhS|E|T",
        "sibbAdiwEcFdpVwFdzWm[r{C{nAnnEcWt}@_]~lAgWttW",
        "eshbA`dpHp`@xkBtlBzk@zg@~gAhHdj]fLnvi@|Lf}j@tMzfn@fKzbe@vDpiQj@|gC",
        "yl_bAfsoD_S|^msArj@s_@nn@oIrs@obAt|Y",
        "{cfbAr`pEbZhpDb~Afv@",
        "i{_bAxxeCyDxZqeAjGYzj@wKdgUs@?wk@h_@{Ldb@",
        "oqdbApt`DdNxc@lj@zb@bUtdCxvCzjC~MzkB",
        "ot`bA|fxOkaApAuHzyO",
        "q`cbAjdiPdc@uGjk@fPjvBmd@vmBocAtvBmd@`nCdb@pzAbsAljArbBl~A~rAbaCdm@z`H|cAfhDbhBvmCrUfz@fa@l`AxaAld@`Rf~@wM~ZqE",
        "}eabA|zcBgGprF",
        "enabAnnkBvLx`Cf`@xxAbgBxx@lxCpl@blCf~@taAnlB",
        "ymqaAf~zBe|G`kHqj@wQsp@ym@aq@yYwj@bd@cDby@",
        "ck`bAdmdCxNrj@",
        "}y|aAt{nDmtAuh@",
        "ko_bA~qmDpAf`A",
        "icj`A|uxP~C_ZpLw[xZaQjg@EpZ|L|VpPpeBbe@dtCxrAz|@vPhvBmYxgIkzDn|@eNjdCiI`|@yOtc@{[brAmsAl\\mQ`yBaR|mA}o@f~DmzEve@{kA|OwdBzBwwCxYgWry@bZvy@dx@tYlcAlE|oAhTp{@he@bo@by@pk@jzAri@l~Bh^bbC?zdBuq@pVqu@bF}~@|Kit@xh@mUffAeNxMqg@",
        "icj`AdbyP?gK",
        "qqv}@xy~OhUa{@fe@k}@vQug@f`@iThoAqBbrAtS`v@nm@jaBr}Bp_CtpAn{B|AfyGg`AnvO?r}Bu]zqEwlCloBwg@d_DlFvzGby@p|CcZflFqsCd|@wPr~@vf@dnF`wExoErgBxaCfVt`Csi@hw@_r@xDga@",
        "}ov}@jp`Ps@qu@",
        "aqcz@zz{ObZsu@pq@s^dx@wFhx@_Spc@sn@rNgShcAxnApzArt@deB~]rcBtHvdB_Jf_Ai_@jiEy~EbyGm`F",
        "emcz@v}|O{B{a@"
      ]
    },
    {
      "left": "MOZ",
      "right": "MWI",
      "kind": "International boundary (verify)",
      "lines": [
        "vmseA{_ltE_Upe|@",
        "vwreAiynrEtr@vvEboA`{@tpBSfnG_i@p{FfKxuFdn@feRz|FjbU`{Mre^l_TzzH`dCrxGt\\fa@yHtyO{yCnyf@qnJbqd@qxId{TmpApkZueB`kVquAhnRigAjpOtg@f_OoNbeMmlEfKwFjS{SrfBkiBp`B_hA|{Es}B`dAu\\nd@cFxXuQfa@ebAjRycB",
        "fnkqAm~jsEh_@ytEfiAgpE|A{ChrB{}DjyPe}R~gNcbPhyR{~OfmWm_TtwSazPhnRovOdqWebLrySi|O`gXioSvtGs`FtvGebFvjHgoH`zA_hAriBec@jzg@}~@pv@ih@fKwoA",
        "x{kqAw~qrEqLu~W",
        "x|cxAcumlE}_@xlBq_AfiAkrA~s@mdB~d@kkFrwAymA|s@{u@tfAgkA~fD{u@tfAwoA|s@emA~^giA~g@afAhrAsrBpfGi~@voA}rCtpBgpRd{HgtCxlBubD~uAu_@hPug@|k@iTpv@{w@lxAmx@hs@izFh{CkoBbZuuHs^upDbdAejBdkCayDfwI",
        "z~seBmkytEm[fqDykCbwDqsC|qBew@rt@a{@ftAqNti@wOp~AgVri@en@l[wwB~Rur@nYi]bj@cg@~w@el@xlB}u@r~Aq~Aj|@afCdl@{tAjq@ulFtaHkrAh~@gpEvnB}tAvoAojE|jKwOdn@m[ve@kxDzkAox@|_@qk@~h@}rCdiEiiAbmA{_BdbAyoL`nDojCnjCkf@btGwFbvEywB`yBoaPv`GosEeXwrKkzBunDvZcmChhBiqOhhOgu@`zAs~A~nE{`AnlAwlDxbA{}ErJiyEs^_|CebA_yDspDuqAcnBap@}hBye@e`Cwe@ybAmBqAuhOiaKieEgiAuwFaSgxJzw@qqEUugBcmAew@moB{~DuyB{iA_}BqlAih@g}C_^olAa\\wzAafAsr@{kA_i@kpAk|@_sAcaD_rBmbDoWszLl}@e}MjbAqiB{MmcAox@afAdOemAjf@owAfMyvAyc@{jDg~Bk{A{l@ghBsJ}}Adl@u|AncAccBdw@u{Bxc@sgBzMelM|@adEza@awDdbAqhErgBytElz@asJssAsoEvFieE`eB}xHpdImmDhpCqvKbkE}sBnrA_hAds@azA`nD",
        "d`yvAoyrpE`Hzu@t\\dn@dc@dl@j]xn@tHvp@",
        "ds|vAudkpE_JbcB",
        "dh|vAq`hpExDbn@vvEdiRfKjfMtqAfgE|~@zl@r|CjgAt^`p@",
        "|anwAipynE}tAppSSxuD",
        "jkkwA}g_nEri@djDvvE`jJh~@rpD",
        "`muwAa`imEmPhoD}zFfoI",
        "t_mwAo_ylEtg@lcCxkCr}AntDft@vvETvnB~Rri@j|@",
        "`rzyA{pczEvyOniFhjKxjDpqT|mHh{Cjh@|pC}@ndBmXzfQmqCd}TgqDv_GdQvDJdnN`b@|kWpv@rhPjf@bb[t}@rhFj~@b~Cdj@zaBqAn}D}a@daBnE~eClz@jfBh}AfoHxcMh_@z`AdDnx@",
        "|uzyAoj_zE{BkeC",
        "hdjaBqiwxEkTduB",
        "|niaBkssxEfBr_AvlDdsQzMdvCxc@~]|_BtQlx@tg@",
        "~muaB_mwwEeBdmAye@hrAmo@rt@sgBfl@ebAhfBga@p_CmEjzB",
        "`_laBkedwEpb@llCnlAptBv|JjrLrh@fc@||CphCniF|qBj`Hri@|`AeMtnD}iAh~@pWxjDfrCf^bHjsAnWtwF}@vnBfa@dvAztAjwG~rLrt@nnAvtGweBjyCccBp_AyXjs@ec@|TwdAtHox@~q@}gCjTag@t\\k[p_Ai_@r`@qWfKkRrU_t@rJmP|}CouC|_@kRj|KaQ`{BeXnrFi|BtzCu^z~Bh{CxbCzM`lFeM`\\~RvZbe@t^j]jf@sA`\\a\\rrBeiErt@md@jpAr^jqBpaAvcBvFbjF}u@r}BkG~fBbOztAfa@`fAdn@Dr@hd@pbJ",
        "zvqgBkx`vEuSluRwp@xgIcxAr~A{_DkR_lHljEabEap@qkBufC}iAg}Cg}AqhCejD_hA}gEwQuaFzBy`Enx@wcBxkCyD`mE",
        "lmseBoe_uElP`yD"
      ]
    },
    {
      "left": "UGA",
      "right": "KEN",
      "kind": "International boundary (verify)",
      "lines": [
        "{srVevdoEos@jpCikBaHaoCmnAe_DqaA}cBnN{fAjgAe|@vzAidAfiAibBbp@m~@sAmz@cZavAqWspCaQohA|@ogAjRgeAhs@y~@vdAmcA|u@ctAvFi_EkG_pCbmAsmBxkCkvAzsD",
        "un_Vk{ooEa]lnAgo@ih@snAu{Bc~AdmAyc@daBga@rJkyCmiHisA{bAmtAdOegAfiCSlxB",
        "w_vVkpooEnwA~vFjRdaB",
        "wgrUgjhpE_h@hgAc{Fh}AgrDziCo]zB",
        "s~aV{t~oEnDz`A~a@`{BbGvyBvZzjBpB|s@",
        "g|lPkkorEsUftAwy@xw@gtCt|Aq{EheE{kBt}@ip\\ntDWJabCfhA{uAbbCisApeH_rAnaCanCxbAk~V~|@kxFvoAyaAzl@c_Avy@_bAbp@yiAbOueAwQcxCs}@gz@uHscAxX{dCzkAubAdDwu@{a@{W{w@wO}~@q\\cy@ouD{uBoyFwy@ouNoNobC|h@az@vzA{b@|sBk|@ptBkwExiEal@joB",
        "clxUsmqpEfp@|hD`|@d`Azz@bZdYb\\",
        "mlxNm`tsEmEztAox@xy@ybPpfG{}O|}AaiKf~Bgv@dX}s@ri@aG|_@}sA~oDyOrJiJhKsThIsTpLiJzV",
        "_uqPqlurE~HpNvo@vZ~InNpKxXdx@xdAfLve@",
        "uwsEedyqEoVgzBk@gFi{@ib@ku@{^ykCiIiqBsi@cdA_nHwkEctEmnA{`Cus@caOcyA_fEy|FymAuwFf`Ae}FpkBotBfKwgB~I{nHmrJuwNybCmuE_oCo^u}@yYcbCm[_}@{z@}~@}eAgl@_cLieEufCmd@u}d@mEakAeZ}rC{sB_bAgVsdAr^}gCrqC}_A|u@mlBpk@e|BxXe`CvFqxBuHwuGwy@}wBRagThyGcoGzoByeQvpFmtFtg@kyC}u@evA_pBwfA_}BwmBk{AylCwOqiBlx@anDpiDevBdc@_vHnb@itAt}@",
        "kw{N_uxsEvGxw@~r@jh@dm@jq@",
        "wivEyvrqEfWifBxx@aeB",
        "`ybEi||mE{vf@nb@_sYfVs_[kfBsgg@qsCe_^}qBspFlEaaSb`E_cSlaEkzBkRocNujJ}eAet@}|SiuNmmDy_FuqAst@g~BmP_cFleA_rBlEyw@wZ}~B{jBg`A}j@}s@kR}gRouCgTeDo_EejBs}BwwDwzA{|FueBeiEo`DouCakGwcB{nCuWimAmL}u@ur@{gEcpKq`BgjBqzFyxAeiFesDooKcaD{~Byc@kwG{BadCi_@g~Bis@wnBk|@i|B}~B"
      ]
    },
    {
      "left": "UGA",
      "right": "COD",
      "kind": "International boundary (verify)",
      "lines": [
        "ynnTmmq{D|sCwoA~v@}@toD~h@nfAuHdbCs}@|gAuJvdClf@`m@z^zcApn@~dEfsD~sEtzBj]hJp`AvFh_@~RnM`\\bPfjAfMrUd|E`oB`}Vz}F`cHd`BvcCdXxvBwFt{A}iAniE_bHnbBekBf{FaoCjvFybA~wF`HpcLjyC~|@ri@fKpWpMpjAlPnYdb@nN~|@f@h_@vFhqPtoExmAhMbYvCxo@nMn}D`yB~~@zXfsBvFffF{V`oBbDlcBxn@f~BxmAdaCxw@fjBaQbZyxAdC}tLzb@_}@dkA{L|}A\\lzAyOjeBg~@vyBkfB~fBgsBvn@ihB",
        "wthTcjf{Daq@ufCgdBeuBwa@mdB",
        "}ytMeex{D\\{fFnbAihBhkKu_JdYeMdm@{Mxb@tHlQza@dXtSnw@i_@xn@azAdn@{pGzBssA",
        "knfMusl{D{uA{rDehE{uAojDweB",
        "ex`Mwjh}DtlGkHlbCiTpjByn@`dBy`CrgEu`JtjBkeAhOuIhKdAvmH~t@|bI|qDnsM`sJhxNdpKftDhoCvePruLxfJj}LtuTxyYhiTplYffTvnOf}IjoGf}QlvM|hB|{Bnv@nnAdc@dvA~]duB`H~rA",
        "_v|Lwt{|DeO_gB_qB_mH",
        "wniFkjpxDoNllC",
        "g~iF}|kxDlE~gAlpAtgB||BzjAjpApkA",
        "aw`FyraxDkq@zjBqu@xbAkInx@",
        "kjdFsizwDxOft@bZ|t@lbEp}Dtg@xOtdC|Kr_AbOpu@|TriAnnAvwB}@d}Fs`@|rBhj@|rCxkCxcB`\\pUjRrqE`pBvnAxbApa@t{@nvChzSnuBfeGhcAvwAvhBhhCzm@voAjvFzuBh~@`HhbIga@`oOzkAp_CdBbxNsrBnrFoNhbE~xA`j@xRdhCvuBn|JdiI|sBtfAjeCrj@hc_@|fExn@|Tlf@~|@",
        "q}]ayxtDyOti@kf@xl@c\\thA",
        "{r`@{vstDleAda@`~JzqGfhDpu@zjB`HpoG}hAnvBoDptBf`@~dFt|An|RxkBp~Exd@~cRtfBjlBvQdrW|eCptBoN~b@ePbhCm`Af_Bc\\`~JsSdvApLfa@jq@nCnaAxOdy@lcAdXnd@kInaAmo@nd@oMlo@`Gr^j]zXza@h_@rSdkNdmAnaCdDnrFqv@xbCgM|vJdOlyAlP|rAjeAt}@vwDxlBxdAxw@jG~|@{BptBgWj{AmFv{@|Vbt@f^v@`@|iA`QxlBcPhoFa{AxwByXjoBxDhaKfkAnuCUvcBir@r~Ai_A~eCyc@|s@bEf}Cbz@paAgBh|B_hAjeAoWnvBi@|mJvy@"
      ]
    },
    {
      "left": "SDN",
      "right": "ERI",
      "kind": "International boundary (verify)",
      "lines": [
        "ii}iBqyehFiT}rCwcBghBwzBeOkcCvFkzBs^i~A{jBkoCauH_}As}BakGmkDi|\\swJeqFclDahUgxZ",
        "iddjBwf|gF`|@kdBt{A_~Af`AmmB",
        "c`uiB}xkgF_@s|AguAkfBovBg`Aq`A}@}i@dOwf@vF{v@m[yDyc@obAi{E",
        "ckbjBymdgFRknCj}@yy@~fBmE|{B`H`fCqb@",
        "_vliBe{cfF}_@gtCmyAwyB}pFubEqoGgeL{BaEkr@sqC",
        "aotiB{queF|`@g~BblDizD~h@wmC",
        "_d}fBmjhcF_tKa_Ju{Bur@ojCu\\cjF}gC}~Bmf@scGa\\upBxDc}GvdAkfAoNmf@ebAavFmzX}`@q{Fq~Be~FguM}nGwoBiyE",
        "wnegB{sy`Fhi@obBr}@g}A|j@ynBnYy_D|Uq_AvmCspF~H_}@",
        "_z`vA{`}}E{{b@fiCieWh}AyoW|}Aa}QrhAsxI~h@gv_@f~B_pQtfAahC_H{kBmq@gqL{jMikDupBol[q{Hc`EayBadCwkEwoGztAegGcOmld@crI}hC{kAwtHwsHajG}fD}vXwjHahWiyGayP}nEmbDmdBsdGsdG{}C}~@cdCxOe|FtpBmbCf_@kdC_HcoB_UmmBeBgkBzf@_QrEuqBnwAwcBdaBomBjpAuoCri@{tAoCkxF{kAwwBwQyjErJymBiI{tB{w@uqA}}AanCamEguAebAivJwxC_uJ{VwZsJaq@gl@{XsJmc@vFgw@zc@{VjG}yFsJonAnNelAfu@k|@f`AobAhT}pEyvCwwBa\\ovBrU_eD~zBqv@fM{p@{KyAUym@kh@cOg~B",
        "{bbgBgavbFz}CehQ",
        "mw{fBqfabFsJi|D_pDchHyMgsD",
        "ud|fBqi~aFfL_|A",
        "uozfBmvsaF_t@crI"
      ]
    },
    {
      "left": "ERI",
      "right": "ETH",
      "kind": "International boundary (verify)",
      "lines": [
        "adyyAstgfFn{AqkBpjBqjA~cFovBbUcZvEw{@jT}TnXgB`aA|@jR{Bdl@{Vth@qL~\\cZnJmeAdl@k|@xo@qLtu@oCp|@qb@tg@sr@bnGgeTjSapB",
        "k~auAuuedF}dAkeAmmOm`FafYefJcs[agKek\\mqKcs\\iuKytQc~F",
        "wrsxAc`bhF~G}rCle@g_B`kA}~@h}Agf@v\\mKxjDi]d|@_^bu@mz@jf@_hAho@g`AloAag@dlFmz@xlB_r@f{A_hAliAq`BhpDgnInm@kq@~eC_i@`w@q`@~w@olAlDis@",
        "_wqxAe|vgFwz@}bJ",
        "eqlxA{abmFtTaH~Wo~Evf@gqDnWu}@nrAigC|nB}|B~_C{jBzdC}tAjeOotDlfFe`C",
        "gbgwAmjjkFkIsrBmZyuBeuCwsJcYkuGumAsrBawDamEkuBicG_mA}~BwoBowAcrBuQwsBtH_gBuHalAwoA",
        "{g|wA}wdpFl@}jBdcA_{BhlA}}AduCg~Btb@ce@fQob@d}Au`ItMifD",
        "inkwAoadoF}E{uBuiCg_OcxBc~FypCcnB_|Bap@",
        "{}owAe~uqFl{@izD`iBmkDfuGygIbk@}}AtRguB",
        "}{mwAupdqFym@_zGoKojAsE_fE",
        "mcmwAaoynFbt@mqI",
        "cjcwAczhnFs@i{CksEigCajAssAgWuzC",
        "gvhwA}l_kFzBayBbd@wpB~IupB",
        "ia_wAcd}iFit@k|Mk{@ogFgbE}aK",
        "ikhwAo|wsFfdCipPpjBumG|mCauFhpL_~Mf_KwgLnvDsjJtuHwuSpv@koDrmAqsPjzCkgL~gGo{JftUulS||UmtSlfYydNn{VyxLxuDs{D`nO}iYbeTg|`@vnO_nSx~Ju{MpvForFlpGqsErbI}eEbe_@wdNv_M{eInrHufN`oCqcJd~DozIvzFyhHrhTsvKfeTs|NvtHmiH",
        "wnewAc`hsFgAcxA_xAysHi@mmB",
        "a~fwAyp_sFxTe|BnXcqC",
        "ia`wA}crrFq`@ayB}}Co_Eg[iqB",
        "_vfwAa}rbF|}BowChbAeuBhlImkFz{Aq~Apq@}Vd|A_HlmCdBnaAmPzq@myAjmEq{Fhd@cZjtB{l@j{Cs^feAod@d\\aoAhJs_A~]}~@hn@mo@vz@wQv~CaFxfBa\\|iAg`AzeAmoB",
        "u{dwA{~kbF{l@igCmK{tA",
        "wdewAkp}aF`HomM",
        "yccvAyxcaFkHmo@_t@cmAslAebAafBen@}aCmP{tC{Bg~BiTgzBkq@_fC}}A}bC}qDsn@wvE",
        "sc_wA_psiFhAcsH",
        "}t~vA_{qiFuM_t@",
        "mfnvAmuu_FxY{gEftBsvKvYinErVyc@xuCapBtb@wp@xYap@bPiu@xD}~@",
        "ww`vAuy`~EqyByl@o~@ymA{VihBqBadCqRquAiwAc`E_Si|B?uxGgM}s@{{@mdBeMu{@?_jL",
        "kqcvAcg`aFpLupB",
        "ww`vAetz`F}Jyc@ohAazAeCar@",
        "_z`vA{`}}EfAywB"
      ]
    },
    {
      "left": "EST",
      "right": "RUS",
      "kind": "International boundary (verify)",
      "lines": [
        "m~giJmg_kD{tBa\\ij@ldAueAd`D}k@rhAyw@xy@ayDfrC}gAvdCsjAhwGitB`yB",
        "epiiJsozjDvp@yvC",
        "ov`iJo`jjDk{AldMkr@ieEsTkzNisB{qG",
        "}`~hJyujjDowAs}B",
        "my`iJmtnjD|A|rC",
        "kh~hJg{siDlFqyU",
        "ozb~I{j}eDq`Avp@yaBxy@egB|j@smAdBst@st@qMykAaBitAuS{kAe]el@yYmPe`CgLgUrJkSpMyqAbO{WdMi^xD}{@wOqp@_^ic@ii@}u@wdBu`BwcOm~@qkBinAaFkoD`dAmhBw[wu@i}@id@{tAym@clDm_A`dC{Lvp@sYmpAqH}sBmhAke[muAagKuv@_qCisAemAuzB~s@q|@teBeiC`xR{a@~q@{vAza@{fA{VycAgl@goAu\\_vCbe@uq@hrBoXdvBgsD~GwbDkg@ytDle@yiFd|Hc~G`wF}lCp~BmgDlvC{eHdmAc}HmeAexMyzJweZb}IyeW`uH{|Hp~Bc{G~pBaoK{}Eo`J_dEmqJa|Ww`GykPwFgH_{A_lB{kCcdAibGkjGwcCgjBelO_jJquMmaEueC{jBcmB|s@a{A_fCmcBy{I"
      ]
    },
    {
      "left": "IND",
      "right": "PAK",
      "kind": "International boundary (verify)",
      "lines": [
        "u|idE_vqjMv{BeqDnnDwaD~lCce@zyBf`AjbEfgEhhB`r@btEp_AdcAhT",
        "qafcEs~pjMsKvbE",
        "enfcE{zjjMrK|rAri@rqC~rAz~DduBllC`nCmE",
        "edxbEg~liM{A`r@k{B~}J",
        "mc|bEel_iMtSvpBroDen@pBt}@",
        "u}ybEmmyiMaFboAqa@jnC",
        "ig{bE}mriMhSrt@nx@xbAhTfu@",
        "qzubE}j{hMuHtxC",
        "gdvbEgqvhMdYxy@j|@xn@rs@vZfk@ve@nb@fkAzMxvC",
        "mynbEa`jhM}KxkC",
        "kfobEgsehMvQjzBpjBlbB",
        "ahkbEmt~gM}tAluG",
        "_~mbE_~ugMtfCnkB~xE|u@laDptBfWd`C",
        "sa}aEycigMmeAtrK",
        "ah_bEcp|fMb_HrpD|s@boA~^vcBrwHpvMrsA|}AvcBb{@hhChThqApAv[rJtSbZly@lo@l\\rJpiAbQxZzKdMbQjR`p@`HpLbcBpaA~S~RteAs}@xbPw}I~nQ{sD`wF_{DduBcO|sB|_@lcBfiAxlB`eBdkBrjAvxO`uFvnChj@~vGh@jwFbcBr}BvOxwB_SbxA}_@bmAgu@nwAuqAve@aeB",
        "sh||DwuhfMfBk|Blo@s|AxxAiqBly@st@zhDthJzuAjeCnmB|}Ad`Ch@dkAr~AnbBdvAfuAz_Bbd@`{BpAziCxOzsBfl@|hBnuAzjBzjBncAzvAnYlp@`p@",
        "_~z|D{c`fMsi@{pG",
        "{xp{D_obeMwG~eCih@xaDeDvdA",
        "cpr{Dm_wdMpMlnAve@z`Azv@~s@f`A~h@~oB{l@bnBvdAhsAr}B|_@jzBxX|T`{Byw@fk@yDxl@bn@`|@h}Apk@hs@teDp_CxlA`eBvp@xn@f}Btg@l{@`zAjq@tSxwAjRf`@vp@pX`oCxx@jcCxw@p`BleAftAz~Aj{ApuBr_AziBcF|tB_SlvCnWlnA~rAv{@`wFvp@hs@jqAve@|`Kd|Hpj@h|@~JxmA",
        "gzsxDczcbM_^tgB",
        "gytxDmq`bMtg@qLnwAqLhh@sJ",
        "wnoxDexabMsIrrB",
        "kyoxDqd~aMxw@r{Bj{AnbBdaBtg@zWbQ~oCcsHnaDs}B`jGcmCppGcxAnqA|KtaBnNbsV~l_@ztB|oFl_Fzob@|uLvu`@t|A`|AdzV`kGbvVviGtv[hcIdeQ~uItfOxqHnxXtfN|jMzcKfkFz_DboLljEv{AfkA|~@~fBlqJbeXdfIngUv|Jt}X|zKp_[bhBnkDbsNloMzbGpsClef@|mJ|iH||BnmGblDz`FnrFpnPj~VhaQjrNb|B`fAhrBp`@tzVjgAb~Aza@fz@rsAnnGtc^~mFbnZ`e@piO",
        "cmahDihioL_s@hsLacE``IewHppFamKx`EmxBjRqfF{Wg~Brs@emA|iAg~B~oDesEtmEolBtzCepAtnD{r@vwDyNbbC",
        "uocjDq~_mLxZxwBptAppFf`@fqFj]xlB|cA`pBxwIv}I|sGplLhx@h}@hsNf_PtpBjeA~td@flMlwD|pCdlMfuOf~OfvJhpRx|UzzFbrK~|NxtPvgKb`GzvM|fDhaW~eCbgVnaCl`Gmo@hcEwbEdfJgi]jyCc~F`iJgaMj{AsmG",
        "g{`iD_kgsLcd@xnN",
        "k`biDe{wrLth@tzOdeB|rOlnCxwMvrIj`W|xHdfUfeBz`O",
        "wdhaDkyqjLhu@cjFvnBo_FniE}pD|dFk]xaObd@vvF}TdkB~Sx`Clx@byBfa@bxBuHpzFmn@~cFj\\|eF~{AbxN|nIjfBlZx}EbErcI|t@|}AgA|yHisBhlHieEngGmtFziEkaGz_C_rBzxI{~BtpCk{Az_A}~AnnAosFldAu_J",
        "ymfaDgzbiL}u@c~m@",
        "cg|{CspzmLnm@iyFfgDueCd~FsUlcPb\\tjUve@jxEcp@lbCmbB`wFsyFr{Cmq@|qCk[t{BuhAbuEgpE`vHaiK~{BejBdtCweAvzY_pElxI}gCngIwlDrwO}vJraP}qEnmDazB~~@el@nsAf_CpvDv|KjtCvxAlbEvp@bqDmQt`BaxBjb@iVve@mEnh@vGri@~Sr|BxMho@tHnn@Tnm@yFjl@kPfjAmnCfe@_yFv_AiyEtzCmo@xy@t{@xaBvjHfdAdbAfeAdl@`m@f`A",
        "eju{CyemlLyP{zUcn@muFi|AakFu}@mkF",
        "ou{rCqlznLw{@bdYsgB~dFe|ApiBgyAnm@qwFj]wzEt{@ocAcD}e@ga@u`A{jBo~@od@iuCzkAeDfeG",
        "wnatC}rlmLpnCvlS|wDz{G`e@xlBxPttIbs@lxB|wChcFjWvzBbFn_ClmBbgJvQ~xE|d@~hAvdBzaA~cKbvC`qBxbA~mDbaFfv@nqGrOtsf@",
        "wctsCgpipLaCbyBau@fgCcGzuB",
        "_fvsC_w}oLfa@fsB|kFl}JjoBn`BrlBqUzfBmpAli@be@lUpkBti@d_C`nBxiFx_@p_C",
        "{t|rCiadcLouAnvBkjJlc@a`ClzAaLfcI",
        "{dosCuerbLfeGvdC|tNfAhnSzA~bZzB",
        "ek`sC{x_dLoJjpBqpAdvAqgElwB{q@pm@ci@zu@ySdw@",
        "sbmsCgzpcL|EzuA|c@r_@dr@hJ`q@tRhlIbbEhn@h~@",
        "i}_sC}bdeLyTrrBw|C~~I{g@dvC",
        "wyfsCcxpdL~RbwBd`Cd}Fjx@|gD",
        "_gnrCqwyhLsd@jsIy|BdrGmyM~gN{jAxuDsj@`cv@",
        "k|esCclzeLh|C`qMv`@bvF",
        "qsbqCgie`Lgp@g@sy@~Gkq@~TuW`f@",
        "ojhqCmdc`LlKfkArs@nBb~@{V`k@kGpqAnw@fiAriAv`@ftA",
        "kugqC}vmbLgBtfN{BfgRcDvuU",
        "sahqCgpt`L|h@`_HbcC|eE",
        "u_}pCq|z_Lsc@xwAmy@le@so@zMeY|U",
        "qibqCowu_L~I|}@ri@fw@jw@dMjv@qA`g@`FvKiJtScYnWeNrUhUl@nW",
        "cjypCmsq_LyIj|@",
        "}typCavo_L|@jR`X|j@~l@vnBp\\lo@vqEpsCbF~A"
      ]
    },
    {
      "left": "CAN",
      "right": "USA",
      "kind": "International boundary (verify)",
      "lines": [
        "kubhLtcs{Ybn[O`n[Obn[Mbn[Ebn[Ibn[Obn[Obn[Mxm[Obn[Obn[O`n[Cnn[Ivm[Ohn[Ofn[O~m[Mfn[Obn[Oxm[Cln[Kfn[M~m[O|m[O~m[O`n[Mbn[Obn[Ihn[Efn[Obn[Mbn[Obn[Oxm[Oln[Mbn[Kbn[Cln[Obn[Ovm[Mnm[Oln[Obn[Oln[Ibn[Cbn[Obn[Oxm[Oln[Mbn[O|m[Orn[I|m[E|m[Obn[M~m[O|m[O|m[Orn[M|m[Ohn[Oxm[Ofn[Mhn[IhgB}e@rt@c_BzjA_wLlwCinZftBwaTfhCgwW",
        "gmioJ`h_pYza@miCnuBibAziCb[jgMvzFdyK|`Fl|J`qEhfDwEpeGqsLvbEqdIh_@wt@lmBajH`vFko^bxC}nR`{AsjFt\\co@ri@y^t{N}jF`eCshB|{D_nFbfJqpTrvK{mWrtMoc[xlNqt\\f~Not]lnNuv\\t}Mku[xvAkjB|sBqjAfaM}kEpcKyoDzuN{cFpcI~pCr{ChEt{AygCxDwoE",
        "ejjnJtyquYcEekHwxBu|H}nHiuPmgI{bRcnBwnHql@u`ImO}pToNyhSiUws\\{Vsj^",
        "kg_oJvefxY`GasCd_DsjR|zFil]~wFa~\\",
        "}lpnJz~vxYg`@}|AylAijA_zF{bEcnAimAg`@u|A",
        "_f}kJfn|yXlPcmBjbFuzJfjCgmJ`lE}wOlnCklF~nDuyDzsC_uEh~@m~Hjh@qtB|oEivI|tAcyAlbBoMfyHnSbcBpVf`B~wAhpC|_GvxBdjB|eFs_Sj{AjgAp`B`{@|~A~IdqFmaFveBkiCp_Aw}CdmAadQjpAawQh^alFj]_sApkAsx@xuDkfAxlAcdArdFauHdaB{mDdc@}aDr@yhH`p@{cEriB_eDb~GejIh}AybAtoB{HfqGfuA`e@y|Inc@auAr_Aa{@|TjR|Vzk@`eA~OlmBgb@bnAk`Ax|JeoQjvEmcUtnFypWnsEgzTvnBsyFvxCaxExjQ_yQ`jIglMb~FcnN~mGykOrkJyyLreEvkFtbGi}AjvF{{FdwNe|UthK}{P~eDsqCxaPqfHr|CazBf{Kg~Nz~Jg{MzjPmrOr`Xw}VblOkuNftNy}M`gNo{QpuM}fQjwKcgJbiOqkMpjHrzGbkLhtK|zDi}a@|gCenXjc`@~vM`wK{`m@lo@qb@rnAzg@juAx~@|dAl`@bcAcKjr@i`@|~AmbB`bEi`DnlBot@||BaWv`Gpa@t}@ug@nb@odDdOszS",
        "ufziJvci_Ymz@ycHejD}wG}cGm|DmmDztAwyBn~F}fBr}HouD}|Pi~AyaUccB}cV{uA_cSudDmcQcqIs`d@_yGq}]",
        "gr|iJfy|_Yvy@oaIxO_rH",
        "q{_hJlvdaYiTclJaoB_rGi}NkpO}UwFq|DgiBi{QjBeaN|A",
        "scahJj|zaY`g@}dU",
        "uvnfJdk}eYqt@w|DmiHirO_eEg~I_yFukTs{FknT{b@k~A_kFenS{fFcyRqw@wxI",
        "avlxIxjcbXbEq~Cfv@otCr{C{vGrbJgo[~{HclXnwGanUz_CsiOfzAova@jiDgkNhgO_kU~{A}nGlzAczSbn@epC~wA_xAx_Lg{DbxAa|@vo@uwAxaCkeUrt@ueHdNmfE",
        "uwjxIxcxbXk}@_xS",
        "icmuIvldyW~XekCpkBmmCfpFkhEzdCinAvgCsn@prF_ZbtGbLhcArPD@",
        "gajuIh{vyWaaBqmQ"
      ]
    },
    {
      "left": "SDS",
      "right": "SDN",
      "kind": "International boundary (verify)",
      "lines": [
        "erux@{l}nEkCnd`@aGlRaQjQa]lP{g@tSopDnl@gsGhVu|Mye@yvPcbCw|WmpK{`AkSid@mDij@?amCld@azBnm@eyDfVg}KwdAk_CyEkdDvHygBh^oqT~vGolB~{Aqja@nhi@sja@jhi@{rQxmN{g@ht@}^zaAmsNf}i@mq@zaAshAwGc~Asi@a`HadDokAgV}sBgVskgA|tHukgAztHezA}@q{@c[ed@gVsaB_qAgeBkfAmqDmpA_bAiTyzX}sAatUnE}wd@wiJeaOwe@ec@~f|A",
        "_~piAs|wfEnYlQt^|@bc@mFxe@eC`pA|@ttCdWfnAxDvoA{Av`Hql@xxEomAngAqKnnA{BnuCtHbHl{_AbHj{_Azww@}jr@dd@kRraBa\\pgAsJh~R_^pr^bwAhiS_RheLg_Bd~Xa|LdzC`\\zbE~fBhre@l_m@hre@l_m@lsBjpA|d_@pyKhvQxcKrjDllDzgYvjTneh@v~h@neh@v~h@~oDfwLbgAlyh@@~@jR|`UxRloAfl@lwBhcArhAzq@fvA",
        "eliz@gpzzDsZfuAufA`cBucm@hur@uc\\v`m@uc\\v`m@",
        "q}t}@c|dvDvhDhyG|`Xxbs@doEhwIfrCf}D`a[tHzgM~aH~pNlmOvzHbal@lnGpmV`rKl~V|cB|{B"
      ]
    },
    {
      "left": "CHN",
      "right": "HKG",
      "kind": "International boundary (verify)",
      "lines": [
        "u_vhCsmzwTlo@k|@",
        "e~phCotuwT}tAi_@gu@kq@iTmeA",
        "gothCgt_xTvEeaC",
        "gothC_k|wT?ghB",
        "ohthCmvcxTiC_x@",
        "}eqhCsrswTvF{`A",
        "i|nhC{nowT{`AshAwFcy@",
        "}fphCqxmwTza@}a@vFkR",
        "ogohCyuhwTm^yw@?}hB"
      ]
    },
    {
      "left": "ITA",
      "right": "VAT",
      "kind": "International boundary (verify)",
      "lines": ["ojw~Fmf_kAJ}D|EK?rD", "ecw~Fcg_kAu@tAsAK_Bs@"]
    },
    {
      "left": "SDS",
      "right": "SDN",
      "kind": "Disputed (please verify)",
      "lines": ["me|w@_q`oDA`GkT~zlAmT~zlAomIdkHobh@p|R", "inoy@g_}oDziJxwMpiKbrKdoFr_CzhGrG~}EwXjyCelA"]
    },
    {
      "left": "SDS",
      "right": "SDN",
      "kind": "International boundary (verify)",
      "lines": [
        "axyx@sszaDa\\vhJweAhzC}pDdrGmyi@jzc@kyi@hzc@ksDh_N_A|@uzAbwA_|AthAe~QhtJ}o@zc@uSfUs^vf@wGlPap@zhDeh@|}A_bCb`Fuf@lo@ck@tg@sYnOqa@rJif]xd@ka@vFa\\pK_s@~^mmIrnGcPfV",
        "mgr~@yvu|CfExbAzgAjvGl~@bbC~Mfv@xDjq@",
        "adm~@{nc|CuH|yF",
        "wmm~@}s{{CxDdc@bZxaB|UlmC|@zhEjDzb@z`AtkGn_DplM|AjRfUlmAdJveA",
        "ygc~@}mozCwGfzF",
        "qpc~@urgzCxErjA`L`fAn^~{AbZbz@~R|~@vFpiAN`g@fGrhAtH~^fu@fsBxD|`@Ndc@",
        "a`}}@sliyC_@xd@iExc@cJxb@sZ~}@cJfa@qKpiA",
        "ye_~@kr`yChCti@tIpk@vUdw@hDrh@",
        "wz}}@iyzxCeH~gA",
        "}c~}@ipxxC^zb@by@bvCvJvfA",
        "iw}}@iqoyCuHxbA",
        "_a~}@ommyCzAza@hU`{@vF|`@",
        "a}{}@qmpxCwKd_D",
        "yi|}@kmkxCvLzaAzb@`zAt[daBzNve@tf@pk@riA~|@f{ShwHnaAnOzr@xC|cAqLn^uHvtBir@`_AkRjb@{Bve@|@xc@vFxvDxbApnIvbDdlBxb@~pBhu@dfArs@vtAhsAlfFnjDpyAtpA~`C`wEpoDlvEl^ht@vWfu@`KxbAjCbz@nDpUtWfWvf@hT`_CfVt~r@sIrhArJ`nCnl@xiL`~JjcDdtDdgAvp@poBri@fid@dwB``@vEp{@fWxw\\nuPr|Avd@vg@xDfyS?th@za@|`@`}@zdBnqHbz@lwPd\\lmCbkLviTtwAf|DpoGxfJjq@xd@xwApLnf@xZ",
        "}|ry@atcfDaq@x}G",
        "_oty@guzeDhd@xpq@xjX|kjAxDzaA",
        "{`qy@cmogDs~@tzN",
        "o`sy@mq_gDpBj|Z",
        "wvny@_wnhDmsBr_X",
        "ekry@kvugDpBza@za@daCzBdc@",
        "ibqy@eggiDdXf_A|PteBl_@fhR"
      ]
    },
    {
      "left": "MAR",
      "right": "DZA",
      "kind": "International boundary (verify)",
      "lines": [
        "enfcEdwzFs@`dBudBlZgf@eWsdAafBg`@we@uaAuf@kr@aHys@|@oiA_LizPmbBm`FsrAqmBi}@qoBcdBgl@wdBy^_bGgpA{fFieCknEovIkiJilCz_B{ob@~qu@e{B|kKsrC`lEijd@pmYo`DehGsi@ym@_s@yc@sy@{Xg_AoMsgCuRypC}@q`Cjg@auAfhBqnBduD}|Bx`D}xCd`CkcErsAsqDjoBoaGn{HmlEdx@}eR]q}C}_Ai|CstAo{IetB}sBu|AeiDcnAamEv[asPrxGyhAxbAubAdlB{_AtwEqv@|~AuaBxd@a_Bm[e~@k{@ct@ugAyaAi~@g{Aon@wcAoCkuDz`AirHpw@gdH_T{m^kbHc|BoNaoAhNcvAtOe_c@t|LmtG||C}jFjnFe}SsySq`@jeAax@tbFm_SzoV}hB_r@qbL{fI}xGmwCkr@apAol@qU}~AtpBuvIzoS_dDzrE{hDjjI}sA|tAquAt]itA`G}hApWkq@bnAsT~wGmoBpqEmvClaEgiCzgFwz@p}Da{BvnBsdDbz@}tF|G",
        "mozbEpkkFe}EkzBeaCj^{kAjdBq`@naC",
        "g~hcElwoFf@nvBxmAfgF"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": ["cwwjEqrt`NpeGsfHdsA{pD~nA}wDd~@_|DxjAagCnq@snC{NygD"]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "ysldEmsy`Nks@zgEoeC`yDcvCn`Dq}JlmO}gErgB{cIbnB{{AfKuoBob@mjB_t@whBsJqiBnwA_o@hrC",
        "ooefE{tl_Nbp@ptBn~DvwDppAdjBvp@xlBnq@|zF|UnxZfp@`uFtbA~pC|xB|Vj`IkoDnvHkvFn}@iTfe@dXtb@~h@|u@r^nlArJdc@aHd\\aQzzPetChfCjGtoBr^zlAiItQ_aAZ_B",
        "meleEivnbNvUnuCvo@`yDxcAfqDtpAt{BxkCt}@rqJvdApzBteBnCdw@",
        "}gqdEosqaN}c@teD}EtfA",
        "ysrdEcejaNjR~rAx|@tzCnNftAh~AvkE"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "{craEuzl_NzfGbn@nvBlf@`xE`cDteB~R|sCkyCpu@pAvz@dOt|@{Bxm@k]loAolAxlBwp@pl@{a@|_@{l@pK}s@",
        "g{g`Egmu_NblEogF`dDirCdlAj]`dBpiBdmLb`R|gCzXh~BcjFllCwwDtmEnNroF`zA|oF|j@zjB{M`{@oYle@kq@rtAubE\\kgA",
        "uwg`E{zq_NqBkqB",
        "s`_~Dm|a`NlPseD",
        "w}}}Diz|_N{a@caD"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "International boundary (verify)",
      "lines": [
        "egs|DgppcNvkEkh@tpAih@jScoA",
        "uij|Dsz{cNvOs~Afk@k{AzWcZv[_Ur_@cOzb@kG~qAyy@~|Ai}AxmA}hBle@azA~]sfCnXiiA",
        "kti|DasucNmPaeB{Bo`B",
        "isa|D_`ueNrK_fCdaBkfM|j@ihB`pAemAfrDylBllCamC|f@wfA",
        "ysy{DipudNsJ_hAejCc~FkSwnBiI}zF_iA{zH"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "Disputed (please verify)",
      "lines": [
        "w~djEob}aNwMi|CzCqmT`gBqtNGqqNxyCc`FpaQzjEp|GlyHxyHip@`yEypBbtAvrJpuBve@h_BmwGti@u}EhiKgcJ|mUgdQrsDkvH|aFgi@|iJbuGpjC`xGfzFr_BpiGtoGz~DxqDx^fdFicHziD{aBxoJ`tJrmEvoDvbIqUf~B"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "Disputed (please verify)",
      "lines": ["yfucEk~|}MdLsm@hhBucF|bD}gCl`EghBdgUe`R~yBotDpiC{pG`}@_hAz~BebAztBdOdhGfgCh{Bnd@"]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "Disputed (please verify)",
      "lines": [
        "eo~}Dacg`NqBkrAtl@c{CnyAwsEifEmwBcrCmwBkpByuD{yFafDevFavEeoFu}Bw@so@dpCylIzqCicD`cCqeC`uCsqAbrB}}AtfCy~DboBwDlnA}{Ab_Cmp@hgC|sAjeAuZv`@c~C`zAo}@|iC_|@z|Ba_@xyBpEhcC{jB~~DuhHhlBa`@haBa_Alv@ac@"
      ]
    },
    {
      "left": "CHN",
      "right": "IND",
      "kind": "Disputed (please verify)",
      "lines": [
        "{~n{DoiwfNnOq\\~t@_`B||C{xL`fB_oCnuC{aB|gC_pBf_AmxD",
        "qh}zDenchNHueBlp@gkAdgFifDpvAgqDbx@si@pqFlwC|`@pk@lE~q@",
        "usyzDg_zgNqUqiBi}AkcE",
        "_cgzDimmhNgAv{@",
        "gegzDqpkhNnDxw@t\\lf@dmA}@fjAs_AfiAirArjAcy@`yBiTt|Afa@vxAvy@nlBrt@"
      ]
    },
    {
      "left": "TZA",
      "right": "MWI",
      "kind": "International boundary (verify)",
      "lines": [
        "tggx@}jghEh~@ylBbsHswHdfH_`KrU{w@xc@ggDvfAcvDpLgV",
        "jnlx@kz|gEmdBg_Ba{@{uBeDmxB",
        "tv{x@}mcjExe@wnBjvFm~IzjBsrBzfFojB|sBijAdbAe_Bxc@ywB`QubG",
        "lr~x@}}|iEyOst@q_AyaBkIqv@",
        "pd}x@eqviEve@y`CbF}iA",
        "`s`y@{aniEkR{w@meA{tA_Skh@UevA",
        "v{ny@ix{lEfhBejDp~Cq~ChhBcaDlz@sqCrgB_pD||BouC`{BybAhs@_hA",
        "tcty@okklEuS{}Ck{AkdD{u@qgE",
        "dupy@wqykE~T{rElz@q}Dn[ecDPcB",
        "rwvy@gdjkEom@maEgtAgrCu}@yvC"
      ]
    },
    {
      "left": "CNM",
      "right": "CYN",
      "kind": "Line of control (please verify)",
      "lines": ["wk_uEy_rnEnXbTst@l~Grt@hgCaRdaBuRbmAqRlf@KN"]
    },
    {
      "left": "CNM",
      "right": "CYN",
      "kind": "Line of control (please verify)",
      "lines": [
        "_nstE_mikE{M|~@cy@pCyuCga@}tBga@mxB?koB?my@|j@knDptBweBlcAwxBzkA{vA`S}gAjRqa@`p@",
        "g{yuEua}jEhItqAly@thAh~@lo@pW`f@bo@txD?hsBt\\lcA",
        "ypruEk{ijEyCz`Bmf@zrDoMf~Dcp@jdBobA|qE",
        "e`xuEanqiE`\\vkEb\\f`Bz}BfgCtHxcA",
        "ukbuEg~ogE{CbaB}}Bdy@keBn`Bs~@byBqj@rzE{Wx`B}`@zlAs~@lcA_~@bp@giAfLmf@_D",
        "m}quE_saiEmcA~qA",
        "{atuE_`_iE`\\fjBvy@blCbf@~zCvo@fjBr~@rzCrsBbyBr~@llCxMnmAjHtgA",
        "cffuE_f}gEkHlcAyM~pC",
        "i~fuEqovgExM~gAfMjf@r~@xy@|t@be@",
        "cqytE_z_lEuHnmAap@lmAu{A`\\st@lf@kf@rt@",
        "qeauE}bwkE?ve@jf@dWh~@`IdDve@",
        "uy}tEesskEqWnmAuHxx@",
        "}{~tE{jokE?zj@`\\lf@`pBxn@fj@t\\dmAjRf~@tHbf@?",
        "u}xtEmyhlEq`BrqC",
        "g_|tEyfdlEt\\rhAlo@dbA",
        "ypytEo_qlEbRvs@",
        "u}xtEwjolEwH~{A",
        "mgytEwmllEvHpW?vzA"
      ]
    },
    {
      "left": "CNM",
      "right": "CYN",
      "kind": "Unrecognized",
      "lines": ["gnwuEicffExSzFdcA`\\lo@rt@hIvcA", "ozruE_dafEccAzlAwYbD"]
    },
    {
      "left": "CYN",
      "right": "ESB",
      "kind": "International boundary (verify)",
      "lines": [
        "udjuE_`zmEft@yMjI}j@by@u\\tRgMfa@?",
        "{~}tE_|pmEuHybAst@irAkf@c\\sVq`@}t@p`@k{A?etBa\\?uqA",
        "_uduEcw~mEr~@ap@xn@zj@nMve@`IxI",
        "_uduEuf}mE?mo@",
        "e~_uEagmmEtR{bArj@ap@",
        "ymztEs|emEkIap@ylAqWewAy_D",
        "e~_uE_|wlEzWa\\hgClp@~gAdW",
        "{pytEo_qlEsRtVwy@tHmy@u\\{Mq`Bst@ybA?yy@",
        "cd|tE_x|lEp`BkdD",
        "_txtEmovlEmRccAu{AmcC",
        "exztEcxcmEjIocA",
        "qbytEk}amEst@wy@"
      ]
    },
    {
      "left": "CNM",
      "right": "ESB",
      "kind": "International boundary (verify)",
      "lines": ["ybptEsgwlEihA{W{`@daBcf@jRaf@gu@}j@jR{j@pjBy[va@", "sqptEirulExMit@"]
    },
    { "left": "CYN", "right": "ESB", "kind": "International boundary (verify)", "lines": ["ypytEo_qlEA?"] },
    { "left": "CYP", "right": "ESB", "kind": "International boundary (verify)", "lines": ["qsmtEoiulEa}AyG"] },
    { "left": "CNM", "right": "ESB", "kind": "International boundary (verify)", "lines": ["}l`uEuj}mE~o@ls@"] },
    { "left": "CYN", "right": "ESB", "kind": "International boundary (verify)", "lines": ["_m`uEwj}mE@@"] },
    {
      "left": "CYP",
      "right": "ESB",
      "kind": "International boundary (verify)",
      "lines": [
        "}{~tEgv{mEshAloB",
        "qeauEyexmEna@fa@|j@zj@fk@dmApMdvA",
        "i||tEirpmEqa@jf@a\\no@",
        "}{~tEmzmmEfa@hrA`f@vy@xcAr`@|s@_qC|j@ap@pgCbD@?vo@mcAtH}sBfjB?hIrt@by@nlAzWmo@",
        "suktEscumEf]kjD",
        "iaktEkoqmEiSgsB"
      ]
    },
    {
      "left": "PAK",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "glx`F{bugMobCheEaGriMmxBpgDyaBdxAmPz_B",
        "oedaFioufMhhAjbFtpAxpK`q@lxB",
        "m_c_FsswkM{LdzJmwCtdCciFpk@y_GhK}nFfj@uzDjfBieCreDcpAlkFw|BrbVy~AzrEa_CrpDyg@bxAaQ~qB",
        "glx`F}~jiMd{@nvOh@bjFnl@vvEhe@nkB~r@lyA|mAv{@zsDzu@rz@ve@bZ~rA",
        "klg`Fgo~gMcz@za@q|Dxc@sjAxn@qzEprD",
        "glx`FedugM?h@",
        "_mp}EafvnMmDl@gs]f{R}|Ch{CklGbqJ}{EhaKy_EnlNmnAlnN",
        "e_l_FuzflMnvBxeKj{@be@r_AtQfj@lf@"
      ]
    },
    { "left": "CAN", "right": "USA", "kind": "International boundary (verify)", "lines": ["gz_jHpbhnV?{wI"] },
    {
      "left": "ARG",
      "right": "CHL",
      "kind": "International boundary (verify)",
      "lines": ["hdh`IryzaLvgs@|Ihis@rJths@~I|is@~Ihis@fJths@~Ihks@dJfks@bJ"]
    },
    {
      "left": "DEU",
      "right": "POL",
      "kind": "International boundary (verify)",
      "lines": ["oazgIcrtuAq`Bjq@mnAdlBiImz@_Tur@qgDiiB"]
    },
    { "left": "LTU", "right": "RUS", "kind": "International boundary (verify)", "lines": ["sklpIqyu~Brz@ktK"] },
    { "left": "GHA", "right": "CIV", "kind": "International boundary (verify)", "lines": ["{rd^nm_R`fB~Y"] },
    { "left": "PAK", "right": "KAS", "kind": "Indeterminant frontier", "lines": ["gohuEasguM_is@xoY}hs@xoY"] },
    { "left": "KAS", "right": "IND", "kind": "Indeterminant frontier", "lines": ["gohuEasguM_rd@akhAard@akhA"] },
    {
      "left": "KAS",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": ["iuswEekzyMgUhfD", "qktwE{cuyMnDtqApVvoAduBz~DnnAdhDt[ptD", "cllwEya_yM{wBfpZ"]
    },
    {
      "left": "KAS",
      "right": "CHN",
      "kind": "Indefinite (please verify)",
      "lines": [
        "s}cxEsmytMcEz|F}Tx`Ckg@hsBcdAlbBmmDhrCmnAdvAug@~qB",
        "wmqxEux{sM|K|cG",
        "y`qxEwsssMkAha@",
        "wbywEsv`vM{LtaFymAx_Fi|@jpAapClcCyw@voAu]nvB",
        "ieexEaueuMpAjeCbd@``G",
        "yrnwEytnwMeOntDyvAheEseEhbHs~@xvCyOf|D",
        "{qzwEs`ovMbn@~hM",
        "_epwEqpcxMkEhm@",
        "kkpwEgbbxMbGn~Elo@|lK"
      ]
    },
    {
      "left": "MYS",
      "right": "IDN",
      "kind": "International boundary (verify)",
      "lines": ["idlXq~kmUpe@kvE", "w}jXoainUnBosI", "w}jX}urmU?k{G?enL"]
    },
    {
      "left": "CYP",
      "right": "WSB",
      "kind": "International boundary (verify)",
      "lines": [
        "}oxrEypkgE|E{ShAk_@",
        "otrrEg~dgEq{Aim@qJirAcVySm_@a]wZa]",
        "smxrEa|pgE~oAsCnv@k_@xjAauBpf@iuD",
        "ufxrEafmgE?k_@?so@}E_d@",
        "{tsrEiw~fEnQ_iAzL}{B",
        "ueorEeq}fEgbBpB}j@uh@",
        "wqprEmm{gE{i@kU"
      ]
    },
    {
      "left": "CYP",
      "right": "WSB",
      "kind": "International boundary (verify)",
      "lines": [
        "g|srE}mchEpWclEpiDeM?`yB",
        "yaprEky_hEyy@we@s~@ylA",
        "s|qrEyc|gEb\\cmAt\\mf@",
        "cymrEeofhEga@`\\",
        "k{nrEcrehE|t@jgAxvAuHfWij@",
        "kuirEw~dhE}j@{j@{MmcC?uzC"
      ]
    },
    {
      "left": "GTM",
      "right": "BLZ",
      "kind": "Disputed (please verify)",
      "lines": [
        "gv|_Bnkr_PwpAtr@qmAaB{mHyJ{cl@a_Dsig@c_B",
        "yn|_Bfl|}O}hCvgP",
        "wx``B~tm~Oh@lgEj\\fqD",
        "az_`Btoy~OsTj}M",
        "uo``B`nh_Pzl@lqBdBtw@rVdhAv[bz@~R~L",
        "eh_`Bh_u}OjxA|kF"
      ]
    },
    {
      "left": "CHL",
      "right": "ARG",
      "kind": "International boundary (verify)",
      "lines": [
        "l}n~Hxzw`LoaFoAo`Ahf@m[rpC_hAzlNiT`eB{kAf}DcZhpB{~Bjye@a}@nmFmqIta\\c`Gh~f@ea@lit@miHn{a@szGva`@qfEjiVeDhyNgKh`k@iKb`k@gK~_k@gKr`k@iKd`k@{Kb`k@iKn`k@gKb`k@qCrsNmxBbhHwiGi^sfEihA_nDh}@aoCjpCgjBtnDorHjgKysFlqL{sB~wGewBxjQs}@jyBu{B~rAqxI|t@ihBtq@obBz_CoWdvCf@jcDgVphD}pCxaCi|DmlD_aHm{Lyn@aQcy@xCa{@hKgw@dC_}@iTcn@kh@kh@el@cn@ga@koB}`@a_Jq@}gCyPczA{j@goFmkGyxA_hAazAwFquAleBmlEzvMspCvkEwvElaCs}BjH}tAkq@{}CipDu{BykBu{@}jAcZwcBiTotD_hCkeBibHmdAyuOox@{qF~h@g_Dz~B}gCdiDunDrgDelBxx@owA|@ouA_i@}xHm`FccB}K{l@dvBoYtpCqiBhmF{uBl}VpuAtlG~aIdnLlE`uGur@h|Bg{Ex|Hcp@fjC`SllCfdHvhWptBd}Eb~H~~LtdChcGboAbtGsAfnGy`C~mFwkEfw@_nFaH}fFrj@_|Ad`AgfFzfGueBnnAweBlYyfJIooIpkAwyBrIc~FuQs}B~GkcEh~@ipE|iBabEjeCkyCfqC_hAftBu|An}Fa{MtjWehDdcAg~Dk}@{xJc|HuqAsLiqBpv@emArnA_dE~qIk{AhqB{kAcZ}iAcyAssAgjAanB}U_~ApBevAcZc_FmfIwxCqvB{hDfL"
      ]
    },
    {
      "left": "CHL",
      "right": "ARG",
      "kind": "Indefinite (please verify)",
      "lines": [
        "vvunHzsk_M{gE|jDoNxUywBfqDirA`{AobB|i@{jBib@i}A_nAobBy|@ayBdQu|A~hA{iCxuDcmAnrA}sB~lA{`AaH}gCq~DsiBmrA}rA|IyxAzf@cwBrAmdB{aAcdAopBccBooF_qAwiBymAe\\wkErs@k{C`Ckz@{qAeXib|@apBgVsi@oaAod@oiEwe@{B"
      ]
    },
    {
      "left": "SAH",
      "right": "MAR",
      "kind": "Line of control (please verify)",
      "lines": ["_sygDnnlt@EznK?`B", "_sygDzw~s@?ruL"]
    },
    {
      "left": "OMN",
      "right": "ARE",
      "kind": "International boundary (verify)",
      "lines": ["awhyCi~mvIny@wyAxeBl`@bf@t{B", "snbyC}zkvIgfDpTo_@ka@Uqu@"]
    },
    {
      "left": "BTN",
      "right": "CHN",
      "kind": "International boundary (verify)",
      "lines": [
        "etjkDihacPjfA|}A|bBfl@npDbnBr~AtlFlwB|lVh_@~qBn}@`oBphIjaH|uA`zBrh@~{BrsAhfBzfBbxAxbF~pC?h@~d@rUpnNdfHvzFbtEdzCjcFjgBx}FjzBfrE"
      ]
    },
    {
      "left": "BTN",
      "right": "CHN",
      "kind": "Disputed (please verify)",
      "lines": [
        "wumkDknifPua@tlFekFlxDiaF?aoChaF",
        "_walD}duePv|@rcD~nC~nCpS`oC",
        "utzkDg`gePgqAbxDw|@fhI",
        "ud_lD{}vdPxxCnuNbO|tBd|@dvB",
        "q}wkDgz_dP}l@lbF",
        "okykDyvxcP|oBrxE",
        "qzukDe}qcPeR`o@",
        "wmvkDcmpcP`]zaAft@pv@~wBf_Btu@pv@puBpqE",
        "w}rkDknzfP{eBdxD",
        "sdvkDeutfP?xlEzmG~wC",
        "c{ijDe}egP_fIg`AexDexDqSwlEwlEmzBw|@exDwlEt|@iqA|uFqSnjGwlErsH",
        "w}rkDgebgP?zuF"
      ]
    },
    {
      "left": "IND",
      "right": "PAK",
      "kind": "Line of control (please verify)",
      "lines": [
        "sdmgEmiwfMly@ssA~jC}VjeCti@leGf}CtiCdl@~gCqA~|Fqk@n{BvFpiBjq@pkBbdAnpBzl@n{BwQdsLizD|gDifDz`A{}E",
        "aqzfE_{yeMkl@aiIg`@wyBimAe`C{|Awp@ujBoYmxBa{@}~AmmBuRupB",
        "}dggEs~odMttBk|@rzAkpApz@ihB~SkeC",
        "kobgEyxieMbm@_gBt{CeuD~m@ueBnCi|B",
        "ac~fEa}{dMoY{sBihBojEoGkzB",
        "}veeEmywgMpxDemL",
        "a_ceEcvagMsJ}oFo}@c_FwLgqF",
        "cadeE}`|hM~aAabEvbDehF~lBgrEfyAquLziBqsEpiHmiL",
        "k}_eEsgehMmUabGgzAegGaQamE"
      ]
    },
    {
      "left": "CHN",
      "right": "BTN",
      "kind": "Disputed (please verify)",
      "lines": ["kuyfDi|a~Okv@f]sbA`M{mAy`@cl@cyAakAckAsbAbMy~AqsAwRajBy~Amf@ivAmeA}n@wpA_}@{jDbMsbAbC_U"]
    },
    {
      "left": "RUS",
      "right": "UKR",
      "kind": "Disputed (please verify)",
      "lines": [
        "{woxGgaglEgpCqfEyyCycAsgFn|@sp@cu@xjCa{GxMwuFky@ubHvj@ctGtsBubHzpC{_IxpCubHpvAwyEzgAqeGjy@ihFd\\a}Iky@}vFpMwyEpvAkhFnvA_nD?ekEnvAanDl_DaeBfbCovAfbCusBbeB{pC`eBq|Dd\\_wFusBaeB}gAiy@d\\_wFqMq|DsMqeGvj@ubHhbCubHfbC_nDdkEgbCr|D?|vF?l_De\\rsBgbC|gAgzJl_DubHl_DwyEd\\{pC_hA{bD"
      ]
    },
    { "left": "SDS", "right": "KEN", "kind": "Disputed (please verify)", "lines": ["oie[uokyE~@uuMt@ypK"] },
    {
      "left": "SDS",
      "right": "KEN",
      "kind": "Disputed (please verify)",
      "lines": [
        "_ke[mazpEy{FoiNy~EiqLsvEgnL{sEwhLe|Ee_Ry}DgzNyqDozMo_Ey~NivEk{Po_Ey~NobDsqLhnEqmBaqFkuLklGwfNzdDgiCxbN~iF?_mRfiC_uM`eWboHfiMu{FpzOmhH"
      ]
    },
    {
      "left": "ISR",
      "right": "LBN",
      "kind": "Indefinite (please verify)",
      "lines": ["acljEgy~xE??jXnmBxoEtlFvmAds@`LpbC"]
    },
    {
      "left": "ISR",
      "right": "LBN",
      "kind": "Indefinite (please verify)",
      "lines": ["a}ajEienxEl^|cAzrAnKphAfsAH?H?pWhCl@F"]
    },
    { "left": "SDS", "right": "KEN", "kind": "Disputed (please verify)", "lines": ["aoe[wbjxE~CwAdBkH||DmfPm{D_a@"] },
    { "left": "SDS", "right": "KEN", "kind": "Disputed (please verify)", "lines": ["kee[ix|xEe@GeBQicG{a@_yBgmD"] },
    { "left": "IND", "right": "NPL", "kind": "International boundary (verify)", "lines": ["gmkwD_rtlNYg@"] },
    {
      "left": "IND",
      "right": "NPL",
      "kind": "International boundary (verify)",
      "lines": [
        "qq`iD{qyxOh_@_zCxZurA|c@ir@nhAiKhrB|iAl_Gs^l}Cp_A~~ClyA|iOztClkQdcKfzH|}CtaAvFzz@wFbyBu\\lZyOhs@ew@xYsJrt@nMnb@b[t^r_@rh@pVxmCrt@vdAnNpuAoExbAcZvxBolAveAcO`xCbe@vpHfwCh_Ev~ArtLfWduDjzArs@jIjq@uHnn@w\\ftAyaBb_FupBh_AwnB~f@q_BdcAaqA`cDyaCxiEs{B~yEu|Ap_B}t@f}D{jCn`Bqt@pjBqW`lGgVtvF}u@fuBwFnuBtHj{BzXnqGrgBnnN~wGvjGzyAreCvl@r~@dCzlAkRH?x~Fjq@rlHtyDz~EljFrSvaEolAbxAelBphE}hAxwAwz@`f@elBvg@_r@j\\dBxNanBnuCqWnDzWxmBtoCn}D^fjB}t@rrBga@|hBl[boAjcC|h@h~Afl@~h@vzA_K~fBeaAhrAwp@jeB~h@teC~m@`cAviBxyC~{AffFgu@hyEidFh_Ms_@x~DhIjnE~r@nhEj|AxlDvxAtfAb`FzsBvz@fkA{LrsA}hBzeGql@`qAupAdw@q_B|i@oy@r_Aht@n~Dr`@~lI}`AprDyiDvnCspErfByuDt}@?h@I?msHtfAshBpB{uBjRrAjfAnbAlyA|oD|{Dhu@vnA~gAbhFzu@bnDtfBvaEnkCh_AtzBvwBvyAbxCjh@z}CwHnx@ylA|{EhJptA~|@xm@~hAjh@bm@p`A{U~qBamFrsLclDndLybAt{B?f@ywA~rAcdAptAco@daByXlxBmdAp~DayDj}Ja|@jzD?dv@zNhfCoD|k@}j@pj@owArA}i@dl@wQ|hBjQjdC~gA`lFboAfjC|Jzj@_Jr`AcY`e@k\\`]uSth@eXr}AmChf@a@vHvFbmCeMve@eYh_@}pFdnLew@p|D~}@z}EpMfrCbx@dlB`jI|iLjfA~eCzMldB{a@hj@yo@rJ{u@f@ss@|Jmf@lp@pMj{@|U~}@qLdw@_oFdpIq`BnwAg{EpaAomMem@otEvo@g~AzvAysF|hN_TnbAtmDnmNlcCppGnlBl`Fr^~oB_^tqBcDdkB|rA~fBj}AxuAnMhLnbAbdB`z@twEhAh}A_hCd`QcjDvuDwvE^}{D|TwzAxsFpLnlCtzBj~I{K|}C_sArI}}AmFyo@pjBuHbnAkRplAebA~nC_pB~s@oaCnb@evBvyA_gAnkCk|AjvHmnArqCS^{`BnaAuRf`B|_@teBby@rsA\\jeAmvDzoVuq@`pAkeCdc@wmCqv@anCowAifCu|@kwF{`@knFpLehF`z@_bFvdB_pEp}C}rBlwDgeHtdw@ylAtfCgtCptB{sBt|@yx@fsAbZh|DeOvy@cwCdbAmx@ly@st@duCkb@dbAmt@xy@oqBlZmUbmBxl@t{Bx{Ix{HvoAvcCxE|eEwf@jxFeWvoAp@bEnc@piCbQt`Hfj@lxBxbB}t@|qD}pDly@oNr~@{W`r@r@~St|@dWdc@bz@pk@cFzFk]l`@_|Al~Gu}KfaZcwC`gMaqA`kToCdjQtr@vaDt{@r^fkA|KtgAgKhrBs}AfjAtGlmAri@frD~eCh~A~gB~{@vxBdEdkC}k@jnCi}@~}@{vAjf@cvB`gAomAdlA{hF`uHkpAfeFdDn{VavAtjKaoCv}G{k@j{Cim@vfWapCdkCelFxbAorM`{@ooFfkAi{CnkByKfc@ao@|fCzsDjrWzu@fuOebAdqFepHppImvElcNwcP`iVq~AroGwu@piBsmB|sBs}Ah|BsAvGsi@tnCk[t_IngAlwD~fG|zFzvA`nCyJdkD{zAvlDirBblD{~CrwHqkFjwF_aB~dCon@~qCg`AzyHisA`zBI?Sr@_rBvoAmnAp}Bq{F|gP_cAh~Aiy@bYg`AxEwxAj\\yqB`pAwjBboBatA`dCal@vmCrJp~Ahx@jg@jlAdYbhAbx@pg@byAdN~fBc[xbAywA_SiU`eBco@jf@er@yWga@_~AyuC|sA}pJviJcmD|sAwrJf~B_pCd`CicA~pCghBlkRmp@rbHubAfl@ulArJ_bA|Tcd@rhA`\\z_BqAxwB_U`{Ba\\lcBsiAfsByvA`]_}AhHu|Avq@{a@bxASb_GuRfsBqw@tgBa{EhmFw{@veB}o@tbEal@fjBsgAf`AyoE~zBwq@lnA}c@|fFi_@djBqq@bnB{p@~h@iy@gBgu@iI_d@~RyBvdC}AfhBx|@h|BltA`}@jjBvOvlK}s@pqA~]yy@vyB_xGdgGqz@tpBuDh|Bv[bwBdNxwBkl@h|B}mA`fAwtHniDqb@xn@oWtpBuT`r@sm@vn@icBf`Akg@pb@sx@fhBm`@h{Eod@nvBs}@lyAmtFroEygBdiE{H`v@kSdqBgoA|qB_}Fbe@y|BeDkpBmPmhBih@{dBolAubA}_Bcn@sgBg|@cxAekB_t@c@?glE`SwuGis@olFcyBgqAc`ExKqiB\\oaCu]cwBuqAqlAk_BdOodGrgBwyAs^mK{jBhu@ymA`Kmz@eyKq_CcpCeXwtBxOwa@zl@lAlx@"
      ]
    },
    {
      "left": "IND",
      "right": "NPL",
      "kind": "International boundary (verify)",
      "lines": ["ankwDgstlN|kAa|@lmBk{@pVolBk{BycLqAgp@"]
    },
    {
      "left": "URY",
      "right": "ARG",
      "kind": "International boundary (verify)",
      "lines": [
        "vahwDfhy~I@@phCc[vkGywAnrFzl@fgEhfC`o]pme@vwDxjDx_FbnAbsF{WfqFokCxwBk{A|cGojCpjC_s@r{Eux@jaDmi@lpBmNtyCaT|cGoEf`AbFnuCzb@h}Ap`@dXnlA"
      ]
    },
    {
      "left": "URY",
      "right": "ARG",
      "kind": "International boundary (verify)",
      "lines": [
        "nlt{Dv{{_J{MtoC`{@xhGzbArsBlmBlo@tfAaf@~lIqfG|bHkq@dtErrBroE||CxrGlnAvtG_i@daDTtfAt{@jkFz`Cvg@dm@vdA~eBhh@|i@p_Cnx@pzG~]ptBv{@~gAdaBvyBbjFftAxuBb`EdnAd_DywC|o@yhAbiBi_DfqDudD`vGgl@drGpw@lc]pwJvxA|_Atr@bvCjq@dgH`r@phCr}@naB~dDdjDp_Cjh@~|B{kAd~D_dEtbEa|@xiGgVhxGvQppFp`Ad`EzhCz~Bpb@lcCweAvdN_jLbuD{_A||Dr^hgN~jKxtGh{CxbA~{@rMlA"
      ]
    },
    { "left": "BRI", "right": "BRA", "kind": "Indeterminant frontier", "lines": ["vqgwDlpq~Ign@tv@"] },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "Disputed (please verify)",
      "lines": ["hvu|D~uztI}o@jb@uk@f_@_fCh@q|Gyd@oxKcDufC_Y{hDklBkxDu]m@H"]
    },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "fni{DfjvtI{xDlf@okDhcBy}GjxKkdB||Ay{IdnEks@nh@qk@|t@ybAxwB_r@vdAw{@hZ{`ArOocApb@ckEhdEifB~{BcxAllEmjG`mJekC|~Gi~@rrAihBlyA{{EdvCk{A~fBcwD~kIirArgBgu@xlA_eFlfFcmAfv@{a@v`@yc@nbAcFd|@"
      ]
    },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": ["lsz{Drk`sIhKtvBtqAfpAluEjaAz_Bnq@|iA|yAfiCznF"]
    },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "Disputed (please verify)",
      "lines": ["|~m|DfttsInx@vbB~f@~c@dc@jVr`@xZ|_@`q@pLj{@f@ptCfa@vaE"]
    },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "ha|wDpylxIh@|z@gMv~@gu@rbBug@xEg`AuRs}BrSqsAnx@ymA~|Au}@vhBwoA~`EgfFxcKg`Ab{@ghD|rBggCv`FxD`lFza@fgF_hA~kHzBh|Bld@hdFfM|j@pv@jyBUpaAmo@zsBoCv|@h}Af|CdsDpiDdiE`dCp~Cxm@jcEfa@hoDh{B`{BpsDld@xiEaQj^shAnlA_Ulp@dOlc@jpAplAbO`p@s^vyA_t@dbAqk@nmAoC`yB|_@xnAlmBlmCnYt|@iTd`Bs}Bt|Amd@hrApAnuCri@ppG"
      ]
    },
    { "left": "URY", "right": "BRA", "kind": "Disputed (please verify)", "lines": ["fxu|D|vhtIsUhzKnRlyCd@hH"] },
    {
      "left": "URY",
      "right": "BRA",
      "kind": "International boundary (verify)",
      "lines": [
        "f~|lEhrxdI~HdhEmeAdlAylB|k@aeB`{@a{@vdBS~eB`QvnB?z~Bm_GvnDwmPyP}e_@kmCej\\diCglMpCs}GgdBu~Ckw@UISKsfEioDs|CytEsjLgxVmcAycAiqB_i@qgFcOapBar@g}C_nDkaGsaL{kCibCkcCozBetCkaFexAcoAupB_Ss|Azv@ezJt}Kmz@|~AymAnhE{jBjnEg@dhEyZ|hBekC`lGwcBh`Jm|IzoJwlFthKe`C|rCqsCd`Co`D|hBqjA|_AovBd~CaqAzw@}hB~\\qyHvRosE|h@mmDfjAynKx|H_lJrqDg{ElG}tAbd@up@vyAqaAfmJg~AxkDw{@jpA}~@p_AebAnc@i~@nN}~@nZybA~gAugBfqD{a@byAwZpjBmPvlE_Sh|@ij@fw@k{Azv@_i@ld@mcAziBgl@dvB}IvyBbc@ztBbzAtpBf`Avz@xDbeAgvArpCmtFnrH_oEpyIypIplL}|Dz}DyvCr{Dg~B`lEekCdiDsn@zTkiCl~@{|F~HylBbYiqBhiAkrAjzAkbFlhI}rAvfAkcElmBmeAjpAyXr}ARhvE{~Bhj_@}~@f{Dom@bsAmeA|nAaqAzgAwdA~lAueBd|FazCfsDotDt_D{tCzcByuBvnBzVbpAphEdtBdaBfqAve@dpAoN~}AebAtzB{fFbgHa}@rsBkpAltFqv@~gBmbBt`BapBvu@ubGhsAg_BtfA{sBtnEey@ldAejBfj@o~EtTweBz`@euB`{A}_MnmMc_FtaHirCziCigA`dBapBjbFunD`nD_^nbClY`cCjrAt`B`nBt]v`G}TzuBnIp_AtpAuHnkCcZvwC"
      ]
    },
    { "left": "BRI", "right": "URY", "kind": "Indeterminant frontier", "lines": ["xahwDlhy~IaO_wF"] },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": ["cbm`A`yy~N{LgVqrC}~BkzC{}KqFc_@w_BoyKsnBmzEuhDcQk}Ejx@ihCjBa`@j}@arAsQqc@dK"]
    },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": ["}`saAnov}NaErLelBpo@uKbp@"]
    },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": ["_kz`Apnx`O|@k`BjEkk@zFmu@"]
    },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["wxx`Antz`Ogq@}dA"] },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": ["aiz`At`w_Odm@}cAriBq[jdH}wJvRci@zGcy@"]
    },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["_rw`A~~{_OchAciA}LesA"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["ggz`Af_p`O`oBasB|Y{fA"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["yzy`Ajjr`OmKcjA"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["ekx`Ati_`OdXuiB"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["yhu`Avdd`OkaBazC"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["_rw`Anpf`OdhAwjA"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["g|u`Ahcj`Owt@{fA?}i@"] },
    { "left": "NIC", "right": "CRI", "kind": "International boundary (verify)", "lines": ["ucn`Azc__Op`@yiD"] },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": ["gnk`A~ae_OyJg|@wz@_vA{L{h@"]
    },
    {
      "left": "NIC",
      "right": "CRI",
      "kind": "International boundary (verify)",
      "lines": ["iiwaA|ax}NxN{^eBoT~Ok`@bK?vJ`OlT?gBwYo\\y^sXgD"]
    },
    {
      "left": "EGY",
      "right": "SDN",
      "kind": "International boundary (verify)",
      "lines": ["g~feCaikiE?mE?KAgdCGcgh@?kml@?aml@?cti@"]
    },
    {
      "left": "EGY",
      "right": "SDN",
      "kind": "Disputed (please verify)",
      "lines": ["q~feCyn~nE?iq@?gf@?_ml@Kaml@Iuml@?aml@?aml@?_ml@Iuml@?aml@?uml@Iaml@Iaml@?}sl@"]
    },
    {
      "left": "EGY",
      "right": "SDN",
      "kind": "International boundary (verify)",
      "lines": [
        "}}feCycnwCHy~Q?o_R?o_R?c`R?y~QHe_R?o_R?y~Q?{~QHo_RJc`R?y~Q?o_RH{~Q?y~Q?o_R?o_RHo_RHy~Q?o_R?{~Q?m_R?o_RH{~Q?o_R?o_R?m_R?o_R?{~QHo_RJm_R?o_R?q~QHy_R?m_R?q~Q?y_R?o_R?m_RHo_RH{~Q?o_R?m_R?{~Q?o~QHy_R?o_R?o_R?o_RHy~QJ{~Q?o_R?o~Q?m`R?o_RH{~Q?y~Q?o_R?o_R?y~Q?y_R",
        "mxfeCkuu{DHy_RHo_R?q~Q?inFem@uqAejQcsH_h@qTmwO_yGwcDo`Dcy@}sBaScwBnPcwBfu@_rBh|BshCziCov@h{CvFnoKtoCziPpfE"
      ]
    },
    { "left": "HRV", "right": "SVN", "kind": "Disputed (please verify)", "lines": ["qxmtGsrgrAsS|sBabDbwE"] },
    {
      "left": "HRV",
      "right": "SVN",
      "kind": "International boundary (verify)",
      "lines": [
        "ujyzGssxcB_sAbvCeWj|@wFz`A|JtfCeCfu@eYhs@elAhhBqWpv@{B~eApCnnAmFlnAag@hgAxm@xe@uAvAck@jk@tRdWhs@h_A|ZxwBzg@p~Aht@jcErMzQn}BraDxs@nCle@hBltA}VbkDiiApq@oCrcBrJbs@wOx^ce@vo@siBv\\a\\hu@qFhNcA~Q`\\q@vmC|d@z}Er@~s@yOfhBic@dxA_bBxtCoSv{@hIzkApe@hs@nn@xn@va@lz@dH|gAeDrb@wZv~DvnBfBrxAeMdpARvtAfl@rJjNzr@pcA`{@jzBpl@z`CxDv\\dM|gAzX~nE`fAjyD|rA|zEJpPDzHzD|xGxPnbBh^|}AzJhUra@|_AfsCp}Brt@nvBaVt_MkDfgBxn@jeCzlAtqA|TfVjyCrrB~oDxxAf|CRxkCevA`zAszBpc@op@r^gkAtq@anDbf@ekAjz@}v@|`@}^f`AbZpkA~gAf}Bxn@^Rd`CgFx~DyI~fBtHdmAh_@|hA|j@|iAnWxnAmYr|BuhAbxA{Bt}@t}@bn@z~BpWbyBbEdqF}ZtiFqRzbDhT`{@dbAhsBnN~|@uGtfAoO`fAyDleA|UlcAly@v\\f`AqWlz@uHng@peAlAjCpmCtcRrf@diDnaB|zFhj@|s@x{@|^xJdEdYgKxN{l@th@a{@|rA_}@t]_`@l[ov@hTmpAqKyXgXkGwOm[gMqjAuGgV|JmRjpA}cBtHaKzuBaeBfv@ga@Ud`ChTdvA`\\plA`h@lvDnm@dc@lp@fVbYri@b[bmAhr@mEdbAqk@`eAca@nDuAxaDod@~eCkq@piBwxAftCsyHxc@`{@bmBvnBpb@hu@nMvdA{AxiEvyAh{IxbAdcG",
        "_egtGktt{AyZ~wGgqG`hMkd@f}@yD|oHwf@~|@}UvdAkD~v@yG|zAafAzjBg`AbmCfBtpB`dCpU~pCdwBnbAjjGye@jcGumDdaBIR_@R?TgrD`cQsiA~zBg_@|@omB}Tmo@rJga@bc@]hAeOtf@{K|j@ewBluEkz@voAymAnx@isAxDuqBcF{~ApLyZncAfU`iAvHn_@ld@lo@r}BdmAdbAz`A~zBr|Cl{@by@vnAlf@pYxC`lCnXnwA~_@hhBrqAf}BzsFfkArrBz~AfoFlQl~Gwe@`aHqkAtwF{V|gC|_@d_Dz`BdhH~Sl`DSxMCpBwD|sCuf@`cDmoA~{CI?cz@tqAg`@vxAsWndDoMl`BjSfj@fk@~TdbA?lnBmcCdlAboAnvApcH~}@bzAj{@zu@za@paAea@|lI_UdaBmz@hrAmbCffH|RvkRlBpiB"
      ]
    },
    {
      "left": "SRB",
      "right": "HRV",
      "kind": "International boundary (verify)",
      "lines": ["wowsG{ghsBhKcxAhYoaBb~@}qAxx@cObcCk`@~kCqrIheA{pF"]
    },
    {
      "left": "SRB",
      "right": "HRV",
      "kind": "International boundary (verify)",
      "lines": [
        "qocsGmuptBrh@oyD~h@_gPjf@ewB~|B{`ArqCnNhq@lfAfMhSlP~zOeNj]qu@jq@iJ`\\fMfl@lZfV`[tQzN~]dWrdGyDvdCi_@bwBmo@dbAyvBptBm[fiAfVrhC`{Aij@fuBwoAvcBfXtR~eC{W`}I`{@~}Apv@mGlo@wp@|j@_}@tg@om@zlAyn@j{@kRduCgVlwDur@p`AaFvy@pLfjAt\\fkAtSr~@}Kfk@ybAqa@{~Bpk@{w@f~AeXfl@pk@|TtfAdYlz@duBdaB~s@nx@h_@|iAcG`zAy`B~|BaRpsAdbArgDr|BaQluDkeC"
      ]
    },
    { "left": "SRB", "right": "HRV", "kind": "Disputed (please verify)", "lines": ["ahzsG_l_sBde@oh@vr@ocBs@{lC"] },
    { "left": "SRB", "right": "HRV", "kind": "Disputed (please verify)", "lines": ["wxgsGkmdtBdhCagK"] },
    {
      "left": "ARG",
      "right": "CHL",
      "kind": "Indefinite (please verify)",
      "lines": ["vvunHzsk_MscNels@y~JejKw{KalMamNqMelIdgDs{DnuE}~Nw{@akFwaA"]
    },
    {
      "left": "PSX",
      "right": "ISR",
      "kind": "Disputed (please verify)",
      "lines": [
        "sscaEqhwuEs`@nAgc@bUo_@oGsHsf@j@}h@~n@}fBmGqNwUiAg_B?_xAxRq}@tUco@h[me@{AoYmi@lMi}@piAi[p}@rDhj@iJbo@yc@yNkfAxCq_@dQqV|PwTtl@jb@`KwKrBah@rNw\\|m@|Yzg@v\\fgAmQpq@aF`QmQhd@v\\zvA~`@pk@yAza@ah@|r@iRxe@h\\hZhb@nyAhShYr]dt@zJnHxZoS`h@c]fTyI`WfXv\\mq@hwAhRn`DuiAhnAsGhlAgWn`@GH"
      ]
    },
    {
      "left": "PSX",
      "right": "ISR",
      "kind": "Disputed (please verify)",
      "lines": [
        "erbbEyiptE`mByyAj\\ug@tb@tW~`@gIzk@icAnLusAtaB}w@`hHh\\rXhY|DbrCzLdq@rr@zu@pr@zcAvWdGxK_QrPwcCgDefAeT}yAc`BipBq^_`A{Fss@rAgiAtd@qhAjhBkz@tl@_|A"
      ]
    },
    {
      "left": "PSX",
      "right": "ISR",
      "kind": "Disputed (please verify)",
      "lines": [
        "muu`E}_puEpY`pCh_B|fAl~AfaCb_DntEdaHbvOrrBjqBdUhLncD`bBfhDvZtmDrAnjEnb@jrKrxG~oEbzA|pE_hAvxAgiChUkdDgVyjDen@{}C{j@auJxDsjWgtB_lJaeNmhTuoDchJk]ahL"
      ]
    },
    {
      "left": "PSX",
      "right": "ISR",
      "kind": "Disputed (please verify)",
      "lines": ["wrfaE}{huE??qDwv@~`Ai`Bbi@_fFmFqkA"]
    },
    {
      "left": "IND",
      "right": "PAK",
      "kind": "Line of control (please verify)",
      "lines": ["sm|qEql{jM_hB``GwvCvuFk{AvcBqtBlyA_i@`lAAB"]
    },
    {
      "left": "IND",
      "right": "PAK",
      "kind": "Line of control (please verify)",
      "lines": [
        "kjlrEkhcjMuf@tgAqAtcFhhAfwKpWreQgmJh|cAa{M~jp@{v@hjKj[`iKbcCnoKx}GhsMvcAbaDxlCp~]|`@ftAf}BxuDjpCrJx`Dwp@rpDgB~{Bt|AjmD`jHbmCvcB\\?rjF`HljAh_@`q@zu@feA`zChh@z`AnkCteB~{C~]xuCap@xwBkeCzjAuzCpp@cvCpR{_DuNspDdOg|DjiB_gBfuHojC~uBquAtfCmo@f~B`Q~{A|sBjcD~tJf_CfrCz}Dpv@xyDcy@vcDykCnpBwwDn_@c`Eu{A_jLvEs}BxaB_kIyHc_Fmo@mkFoEwaFrrBubEphEymAdhEj|@zsDjnCdlCrgDlaC|yEdrAf{Et`Bb`TjpBhpCdaIlwEbiAld@hmAl[`pAjR|uDdM``BeMvzA}_@ptAis@jtEehH~sDenKn_F}lIpwImdBl{MjeC`fMn_EngBlz@nwAxbAfjA~pA`_A~fBjmAniFfy@vcB~lB`}@tqGrSh`EquAbrCehDteCkbFplDckE`sKgyI`pBgfF~qA_eQvyAqiD~iCebAp{HoNj_IekAnaC`Q`tBxbArm@dd@fGpE~hA~y@"
      ]
    },
    {
      "left": "IND",
      "right": "PAK",
      "kind": "Line of control (please verify)",
      "lines": [
        "gohuEasguMlTzg@d`CrwBnvCqWnkDar@laEjh@fiBz_B~wF|vJlmBnvB`r@nnAeN|}AevAtcDcf@rgDdOd}Et|@~yEnaBlwC`oCjq@znIgVdvBxy@xbMjyPnc@jpAr~A~zOgApkBu]lbBueDhnG}^rnFzjA`nFb|Kt|YtnCd|SzCjnEykCrkK`f@hyEfjAnbBxtDx`CrtAhrAhSpk@|j@rgDd}FfwKtuH`hJ|tAf~BtX|sBa]dgGRlcCdgA~iJuGpqG{nJdnr@??"
      ]
    },
    {
      "left": "PRT",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": ["agv_Grz~p@sm@nnAmdB~S{kGaRc~Atw@a{@~v@"]
    },
    {
      "left": "PRT",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": [
        "}l~kFjtjj@se@cdBu|@{jAgp@qkAeXir@ixAjFe`Bs^qyBpuAuvAueCovC{jCc}HgpEy}@k|@i~@qa@uw@~Hak@jfA}iBgj@kyBjf@coBpvAujAlcBalA`oCeb@`bD",
        "irvmFtzbj@nMvcD|eAntCpUrjAwKf~A}c@vzAgq@f_Ais@vGcyBocAg~@gLovBpkAit@|qCob@llDqbA`zCy`BdvAi|Bbo@cbCaHkqBisAofH`uHugAptBshAdm@adCv\\giCdBewAq_@ayAcp@ymCs_@kdCSi}@dm@gu@peGmp@vcCk{@f~A}gClz@}t@|t@itAfrEolArgBo_E`yDmnAjoBaqLniEovAtn@eOzGvp@cdi@mQ}sAqa@ueBwQssBdEixFeY}iBr_AsfCvEwaEowAov[u\\mzAaeC_gA{l@vEsi@lQcy@}@wy@w[meBsiAkz@qVks@tHmx@xYebAvGssAgl@u^wo@em@cnCcZkz@otDi|Ck{@iTugB{Cev@sIi^i@_~@hUqb@Ra[kQqb@w{@eWaRkyCoc@{v@qW{bArJoaAk\\}hCqjBc{IhzFaeCziCufB|sAem@zaAkRdbAaQtdDcPpjA}sAfiAetE|k@kzArr@_hAgt@uoCk|@cy@ew@ye@moBifCilGcIumAkDyh@vGkyBoEcxB_|@_rBod@mQup@uBut@aCmo@{U{`@cf@mwCulGsj@ev@ouColBevCfqEysD~oCyjEnc@izEirBg}C}pCqjAoP{jBpa@itAp`Aow@beAs~@|t@elB|Ke`Bod@oiEuoCgiB}j@}jAImnBrKqpEjq@yjEbnAywApLcxB?u|@sJga@cP{a@mEq`ArSkh@vFg}CuG{WaeBwmA{XuqA~]oc@dcAwQr|A_s@jr@ybChs@y|FteCmnBzvAg}C`cEweAh|@ymA|KaqA{aAqtBoW_@sA_q@{_CdYs_K}LqiDg_AgtAwtGkvFupBur@kyCnNgk@qVymAcpAanCq{Ewq@ob@i|A{m@}{Fe}E_|@kgAqMwmByC{wKu]qw@ywBgmJyvBmkEuzC{gEgoFkcE{DoXrJ{kAwDeXqa@eNyo@mFwd@zB}AvQap@woAqX{uA}IcbEst@Sy~GamFsh@{Auh@xOkp@nCi~@wf@g_Cy`DwhIaiHk|@r~@o{AdvAioEpfG_hChwGcsAfpH}mA`zN}@ztA`[hj@he@hh@pk@rtAtb@r|ApL|_A{p@tnD_cB|tAgyBr_@csBbOwy@v[yt@th@gu@`Rgz@yc@yr@sk@sy@mYs}NmwCwtBagAkg@n`DmKlnB}j@jp@ylG_r@kfBdXgjAhsA}n@bwCndChrAfp@dsE|L`|L_i@~yDkfG`cFkXz}DjyDjf@vcAfsC`WpcKsY`nDsxAlwCc`@bvAcTrv@lnAhqCxgAz|EibAtcEwyBf}Dc}AdhE~IxxA~l@xlBvu@p~Axc@zl@jvApLjiEkg@bbBfMblAdfAd~@hy@|~A`lEhqBxzLvLtoBeD`bFlKh}Axi@hsAj`CxuClt@jqAibBnYukB`{@erA`oA}UzuAiCv{@gq@r}AIbo@d]nm@ld@hKni@vE`l@r_@tq@r}Aba@p~BxM`dCgGnmBmi@vcByy@zBocEq_ByIfoIgg@llBc|AblDwQz`B|bAtnDfeApbKwFfhDhOp`Ala@j\\ng@tTxc@fj@IreEosDhi@}gDbPnb@`zBzfAj\\ngBj]fpAxy@`AfsBmKlcBz]xwAt{@pkAljAj|@j~CjlEnAvJzx@|kG{W`yO{J}@}tCeWyqAhIgp@dn@m`Ax~EqnBteAmsBiHuoBmz@}iGcpFwdCiuD_wAotDo}@ibBsmAuaA_lBgMa|Avq@cdAf~Awd@xvBnHz`Che@`nBxRr}Asm@nnAmdB~S{kGaRc~Atw@a{@~v@hcBhzDza@tqBnBfjBlGbn@rYpv@tkBn_Dbi@~gBhsBjd]p`@ptBhmB`vEjb@zqBtCxcFlOblBrz@hiBx}@fu@teCnaA|}@nn@x~@z~Bnc@z_Dbu@blChe@`eA"
      ]
    },
    {
      "left": "PRT",
      "right": "ESP",
      "kind": "International boundary (verify)",
      "lines": [
        "cf_bFbcgl@qqGp|AclCh]}}Ash@clEt|@koNbn@maEzjBmeA{LmhC`QwwCdd@wsBfk@ge@pa@seAdjBig@bo@y~@vr@iEbDoc@fLii@lDwtAx_@^pWmFnHm`ApBeX_S{{@qaAy]mFc[gLu]yCge@bOe^az@okCadDeq@}i@e}A_`@ukH{u@}zDssA}~BmmBe~Js}PwqFckDctEcdAubH}gCsmB}_@w~@|Amz@~Qkq@pBcd@}i@__@seE_c@ebA~CapAjRmnAvFelAc_@qlAqQ_qAaWym@icAs_A_aC_}@un@qu@lGgkBhrBs`JuMs}CuvCir@cmAyy@g|Dqu@s|DssBsoEgsAu{Acp@_qDi~@}IfRoo@btAtJjmD`f@xaDi@`QuGp`@xrAzkAfu@bwC~X||Ci@|}Aw}@vsAml@f|@kzN|zFyZr_@o}@piBeb@~i@}e@bZcrAjg@oc@lYa|SdtSkeBhpDw`@ptAyiAyxAmdAk{@igAyEaqA`gAihAk|@{yHapBihHqdGwuA}`@"
      ]
    }
  ]
}
